/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

// constructor
function PointerEventsPolyfill(options){
	// set defaults
	this.options = {
		selector: '*',
		mouseEvents: ['click','dblclick','mousedown','mouseup'],
		usePolyfillIf: function(){
			if(navigator.appName == 'Microsoft Internet Explorer')
			{
				var agent = navigator.userAgent;
				if (agent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) != null){
					var version = parseFloat( RegExp.$1 );
					if(version < 11)
						return true;
				}
			}
			return false;
		}
	};
	if(options){
		var obj = this;
		$.each(options, function(k,v){
			obj.options[k] = v;
		});
	}

	if(this.options.usePolyfillIf())
		this.register_mouse_events();
}

// singleton initializer
PointerEventsPolyfill.initialize = function(options){
	if(PointerEventsPolyfill.singleton == null)
		PointerEventsPolyfill.singleton = new PointerEventsPolyfill(options);
	return PointerEventsPolyfill.singleton;
};

// handle mouse events w/ support for pointer-events: none
PointerEventsPolyfill.prototype.register_mouse_events = function(){
	// register on all elements (and all future elements) matching the selector
	$(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(e){
		if($(this).css('pointer-events') == 'none'){
			// peak at the element below
			var origDisplayAttribute = $(this).css('display');
			$(this).css('display','none');

			var underneathElem = document.elementFromPoint(e.clientX, e.clientY);

			if(origDisplayAttribute)
				$(this)
					.css('display', origDisplayAttribute);
			else
				$(this).css('display','');

			// fire the mouse event on the element below
			e.target = underneathElem;
			$(underneathElem).trigger(e);

			return false;
		}
		return true;
	});
};
(function (root) {

	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;

	function noop() {
	}

	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
		return function () {
			fn.apply(thisArg, arguments);
		};
	}

	function Promise(fn) {
		if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
		if (typeof fn !== 'function') throw new TypeError('not a function');
		this._state = 0;
		this._handled = false;
		this._value = undefined;
		this._deferreds = [];

		doResolve(fn, this);
	}

	function handle(self, deferred) {
		while (self._state === 3) {
			self = self._value;
		}
		if (self._state === 0) {
			self._deferreds.push(deferred);
			return;
		}
		self._handled = true;
		Promise._immediateFn(function () {
			var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
			if (cb === null) {
				(self._state === 1 ? resolve : reject)(deferred.promise, self._value);
				return;
			}
			var ret;
			try {
				ret = cb(self._value);
			} catch (e) {
				reject(deferred.promise, e);
				return;
			}
			resolve(deferred.promise, ret);
		});
	}

	function resolve(self, newValue) {
		try {
			// Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
			if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
			if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
				var then = newValue.then;
				if (newValue instanceof Promise) {
					self._state = 3;
					self._value = newValue;
					finale(self);
					return;
				} else if (typeof then === 'function') {
					doResolve(bind(then, newValue), self);
					return;
				}
			}
			self._state = 1;
			self._value = newValue;
			finale(self);
		} catch (e) {
			reject(self, e);
		}
	}

	function reject(self, newValue) {
		self._state = 2;
		self._value = newValue;
		finale(self);
	}

	function finale(self) {
		if (self._state === 2 && self._deferreds.length === 0) {
			Promise._immediateFn(function () {
				if (!self._handled) {
					Promise._unhandledRejectionFn(self._value);
				}
			});
		}

		for (var i = 0, len = self._deferreds.length; i < len; i++) {
			handle(self, self._deferreds[i]);
		}
		self._deferreds = null;
	}

	function Handler(onFulfilled, onRejected, promise) {
		this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
		this.onRejected = typeof onRejected === 'function' ? onRejected : null;
		this.promise = promise;
	}

	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
		var done = false;
		try {
			fn(function (value) {
				if (done) return;
				done = true;
				resolve(self, value);
			}, function (reason) {
				if (done) return;
				done = true;
				reject(self, reason);
			});
		} catch (ex) {
			if (done) return;
			done = true;
			reject(self, ex);
		}
	}

	Promise.prototype['catch'] = function (onRejected) {
		return this.then(null, onRejected);
	};

	Promise.prototype.then = function (onFulfilled, onRejected) {
		var prom = new (this.constructor)(noop);

		handle(this, new Handler(onFulfilled, onRejected, prom));
		return prom;
	};

	Promise.all = function (arr) {
		var args = Array.prototype.slice.call(arr);

		return new Promise(function (resolve, reject) {
			if (args.length === 0) return resolve([]);
			var remaining = args.length;

			function res(i, val) {
				try {
					if (val && (typeof val === 'object' || typeof val === 'function')) {
						var then = val.then;
						if (typeof then === 'function') {
							then.call(val, function (val) {
								res(i, val);
							}, reject);
							return;
						}
					}
					args[i] = val;
					if (--remaining === 0) {
						resolve(args);
					}
				} catch (ex) {
					reject(ex);
				}
			}

			for (var i = 0; i < args.length; i++) {
				res(i, args[i]);
			}
		});
	};

	Promise.resolve = function (value) {
		if (value && typeof value === 'object' && value.constructor === Promise) {
			return value;
		}

		return new Promise(function (resolve) {
			resolve(value);
		});
	};

	Promise.reject = function (value) {
		return new Promise(function (resolve, reject) {
			reject(value);
		});
	};

	Promise.race = function (values) {
		return new Promise(function (resolve, reject) {
			for (var i = 0, len = values.length; i < len; i++) {
				values[i].then(resolve, reject);
			}
		});
	};

	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) {
			setImmediate(fn);
		}) ||
		function (fn) {
			setTimeoutFunc(fn, 0);
		};

	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
		if (typeof console !== 'undefined' && console) {
			console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
		}
	};

	/**
	 * Set the immediate function to execute callbacks
	 * @param fn {function} Function to execute
	 * @deprecated
	 */
	Promise._setImmediateFn = function _setImmediateFn(fn) {
		Promise._immediateFn = fn;
	};

	/**
	 * Change the function to execute on unhandled rejection
	 * @param {function} fn Function to execute on unhandled rejection
	 * @deprecated
	 */
	Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
		Promise._unhandledRejectionFn = fn;
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Promise;
	} else if (!root.Promise) {
		root.Promise = Promise;
	}

})(this);
window.USER_SETTINGS = window.USER_SETTINGS || {};
window.NOOP = () => {};

var APP = APP || function () {};
window.APP = APP;


function Arti() {
    var exports = {},
        partials = {},
        helpers = {
            'each': function (object, contentBlock) {
                var content = '';

                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        content += contentBlock(object[key], {key: key, index: key});
                    }

                }

                return content;

            },
            'with': function (object, contentBlock) {
                return contentBlock(object || {});
            }

        },

        fnBegin = 'function(meta,root,parent,helpers,partials,nth){meta=meta||{};' +
            'meta.context=this;meta.parent=parent;var out="',

        regexp = [
            // handle multi matches :
            [/}}/g, '}}\r\n'],
            // remove comments {{!-- xy --}} or {{! xy}} :
            [/({{!--.+?--}}|{{!.+?}})/g, ''],
            // handle double quotes :
            [/(")(?![^{]*}})/g, '\\"'],
            // if :
            [/{{#if (.+?)}}/g, '";if($1){out+="'],
            // else if :
            [/{{#elseif (.+?)}}/g, '"}else if($1){out+="'],
            // else :
            [/{{#else}}/g, '"}else{out+="'],
            // end if :
            [/{{\/if}}/g, '"}out+="'],
            // singe helper :
            [/{{#(.+?) (.+?)\/}}/g, '"+helpers.$1.call(this,($2))+"'],
            // singe helper without arguments :
            [/{{#(.+?)\/}}/g, '"+helpers.$1.call(this)+"'],
            // open block helper :
            [/{{#(.+?) (.+?)}}/g, '"+helpers.$1.call(this,($2),function(c,m){return(' + fnBegin],
            // open block helper without arguments :
            [/{{#(.+?)}}/g, '"+helpers.$1(function(c,m){return(' + fnBegin],
            // end block helper :
            [/{{\/(.+?)}}/g, '";return out}).call(c,m,root,meta,helpers,partials)})+"'],
            // partial :
            [/{{>(.+?) (.+?)}}/g, '"+partials.$1($2)+"'],
            // partial without arguments :
            [/{{>(.+?)}}/g, '"+partials.$1()+"'],
            // default :
            [/{{(.+?)}}/g, '"+($1)+"'],
            [/\r\n/g, '']
        ];

    function getTemplateFunction(_templateString) {
        return eval('(' + fnBegin + (function () {
                for (var i = 0; i < regexp.length; i++) {
                    _templateString = _templateString && _templateString.replace(regexp[i][0], regexp[i][1]);
                }

                return _templateString;
            })() + '";return out})');
    }

    exports.template = function (_templateString) {
        var fn = getTemplateFunction(_templateString);
        return function (_context) {
            _context = _context || {};
            return fn.call(_context, {}, _context, false, helpers, partials, function (object, index) {
                return object[index];
            });
        }

    };

    exports.addHelper = function (_helperName, _function) {
        helpers[_helperName] = _function;
    };

    exports.addPartial = function (_partialName, _templateString) {
        partials[_partialName] = exports.template(_templateString);
    };

    return exports;
}


APP.Pro = (function () {
    var exports = {},
        initialized = false,
        $payButton,
        groupMinimum = 10,
        schoolMinimum = 100;

    function init() {
        $payButton = $body.find('[data-pay-whit-cart]');
        initProBindings();
        initialized = true;
        initPaymentUi();
    }

    function initPaymentUi() {
        $body.find('[data-payment-method-select]').trigger('change');
        checkRememberContainerVisibility();
    }

    function getPrice(quantity, period, currency) {
        var price = window.PRICE[currency || 'actual'][period].default;

        if (quantity >= schoolMinimum) {
            price = window.PRICE[currency || 'actual'][period].school;
        } else if (quantity >= groupMinimum) {
            price = window.PRICE[currency || 'actual'][period].group;
        }

        return price;
    }

    function initProBindings() {
        if (initialized) {
            $body.find('[data-pro-quantity-input]').trigger('input');
            return;
        }

        $body.on('change', '[data-pro-quantity-input]', function () {
            var $this = $(this),
                quantity = parseInt($this.val() || 1) || 1,
                period = $body.find('[data-pro-period]').val();

            if (quantity <= 1) {
                $this.val(quantity);
                if ($body.find('[data-pro-group-plan]').length) {
                    $this.val(2);
                    $this.trigger('input');
                    APP.Layout.openOverlay('go-pro-with-one');
                }
            }
        });

        $body.on('input', '[data-pro-quantity-input]', function () {
            var $this = $(this),
                quantity = parseInt($this.val()) || 1,
                period = $body.find('[data-pro-period]').val(),
                finalPrice = getPrice(quantity, period, $body.find('[data-pro-actual-currency]').val());

            $body.find('[data-pro-quantitiy]').html(quantity);
            $body.find('[data-pro-price]').html((function () {
                var price = quantity * finalPrice;

                if (price !== Math.round(price)) {
                    price = (price).toFixed(2);
                }

                return price;
            })().toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            $body.find('[data-pro-price-gbp]').html((function () {
                var price = quantity * finalPrice * parseFloat($body.find('[name="gbpToEur"]').val());

                if (price !== Math.round(price)) {
                    price = (price).toFixed(2);
                }
                return price;
            })().toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            $body.find('[data-pro-one-price]').html((finalPrice).toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            // $body.find('[data-pro-discount]').html((window.PRICE.original * quantity - quantity * finalPrice).toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));

            $body.find('[data-pro-discount-alert]').hide();
            if (quantity >= 5 && quantity < 10) {
                $body.find('[data-pro-optimum-quantity]').text(10);
                $body.find('[data-pro-discount-alert]').css('display', 'block');
            } else if (quantity >= 67 && quantity < 100) {
                $body.find('[data-pro-optimum-quantity]').text(100);
                $body.find('[data-pro-discount-alert]').css('display', 'block');
            }
        });

        $body.find('[data-pro-quantity-input]').trigger('input');

        $body.on('change', '[data-pro-period]', function () {
            $body.find('[data-pro-quantity-input]').trigger('input');
        });

        $body.on('click', '[data-buy-packages]', function () {
            var name = $body.find('[data-pro-name]').val();

            if (name) {
                buyPackages({
                    billName: name,
                    quantity: parseInt($body.find('[data-pro-quantity-input]').val(), 10),
                    activateUserPro: $body.find('[data-activate-user-account]').prop('checked'),
                    groupNeed: $body.find('[data-pro-need-group]').prop('checked'),
                    groupName: name,
                    period: $body.find('[data-pro-period]').val(),
                    renew: $body.find('[name="renew"]').prop('checked'),
                    code: $body.find('[data-code-input]').val(),
                    codeMode: $body.find('[data-activation-code-mode]').val(),
                    ownerId: $body.find('[data-subscription-owner]').val(),
                    schoolData: {
                        name: $body.find('[data-pro-school-name]').val(),
                        year: $body.find('[data-pro-school-year]').val()
                    }
                });
            } else {
                $body.find('[data-pro-name]').addClass('form--error-show');
            }
        });

        $body.on('click', '[data-show-code-payment]', function () {
            $body.find('[data-payment-wrapper]').hide();
            $body.find('[data-code-payment-wrapper]').show();
            $body.find('[data-code-input]').focus();
            $body.find('[data-activation-code-mode]').val('1');
        });

        $body.on('click', '[data-hide-code-payment]', function () {
            $body.find('[data-payment-wrapper]').show();
            $body.find('[data-code-payment-wrapper]').hide();
            $body.find('[data-activation-code-mode]').val('0');
        });

        $body.on('click', '[data-activate-packages]', function () {
            var name = $body.find('[data-pro-name]').val();

            if (name) {
                activatePackage({
                    'code': $body.find('[data-pro-activation-code]').val(),
                    'school-name': $body.find('[data-pro-school-name]').val(),
                    'school-year': $body.find('[data-pro-school-year]').val()
                });
            } else {
                $body.find('[data-pro-name]').addClass('form--error-show');
            }
        });

        $body.on('change', '[data-activation-code]', function () {
            $body.find('[data-hidden-activation-code]').val($(this).val());
        });

        $body.on('click', '[data-delete-subscription]', function () {
            deleteSubscription($(this).attr('data-delete-subscription'));
        });

        $body.on('click', '[data-remove-pro]', function () {
            removePro($(this).attr('data-remove-pro'), $(this).attr('data-remove-pro-code'));
        });

        $body.on('click', '[data-set-renew]', function () {
            setRenew($(this).attr('data-set-renew') === 'true', $body.find('[data-bill-id]').attr('data-bill-id'));
        });

        $body.on('click', '[data-add-pro]', function () {
            addPro($(this).attr('data-add-pro'));
        });

        $body.on('click', '[data-go-pro]', function (event) {
            event.preventDefault();
            event.stopPropagation();
            APP.Page.applyPageByUrl('/en-US/pro');
        });

        $body.on('click', '[data-wire-promise]', function (event) {
            var $this = $(this),
                url = $this.attr('data-wire-promise');

            APP.Ajax.post(url).then(function () {
                if ($body.find('.application').hasClass('user--logedin')) {
                    APP.Page.applyPageByUrl('/en-US/pro/success-wire-transfer');
                } else {
                    APP.Page.applyPageByUrl('/en-US/pro/success-wire-transfer?signup=true');
                }
            }, window.NOOP);
        });

        $body.on('input', '[data-pro-activation-code]', function () {
            var $this = $(this);

            if ($this.val().length > 0) {
                $body.find('[data-activate-packages]').show();
                $body.find('[data-buy-packages]').hide();
            } else {
                $body.find('[data-activate-packages]').hide();
                $body.find('[data-buy-packages]').show();
            }
        });

        $body.on('click', '[data-generate-new-activation-code]', function () {
            var $this = $(this),
                id = $this.attr('data-generate-new-activation-code');

            APP.Ajax.post('/en-US/service/pro/new-activation-code/' + $this.attr('data-generate-new-activation-code'))
                .then(function (result) {
                    if (result.success) {
                        APP.Page.applyPageByUrl('/en-US/pro/subscription/' + id);
                    } else {
                        APP.Layout.openOverlay('generate-new-activation-error');
                    }
                }, function () {
                    APP.Layout.openOverlay('generate-new-activation-error');
                });
        });

        $body.on('click', '[data-revert-subscription]', function () {
            var $this = $(this),
                id = $this.attr('data-revert-subscription');

            $body.find('[data-revert-sub]').attr('data-revert-sub', id);
            APP.Layout.openOverlay('revert-subscription');
        });

        $body.on('click', '[data-revert-sub]', function () {
            var $this = $(this),
                id = $this.attr('data-revert-sub');

            APP.Ajax.post('/en-US/service/pro/revert-subscription/' + id)
                .then(function (result) {
                    if (result.success) {
                        APP.Page.reloadPage();
                    } else {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('revert-subscription-error');
                    }
                }, function () {
                    APP.Layout.closeOverlay();
                    APP.Layout.openOverlay('revert-subscription-error');
                });
        });

        $body.on('change', '[data-payment-method-select]', function () {
            var $this = $(this),
                value = $this.val(),
                $container = $body.find('[data-card-container]');

            if (value === 'card') {
                $container.show();
            } else {
                $container.hide();
            }
        });

        $body.on('change', '[data-card-container] [name="card"]', checkRememberContainerVisibility);
        $body.on('change', '[data-card-container] [name="remember"]', function () {
            var $this = $(this),
                checked = $this.is(':checked');

            if (!checked) {
                $body.find('input[type="checkbox"][name="renew"]').prop('checked', false);
            }
        });
        $body.on('change', '[data-card-container] [name="renew"]', function () {
            var $this = $(this),
                checked = $this.is(':checked');

            if (checked) {
                $body.find('input[type="checkbox"][name="remember"]').prop('checked', true);
            }
        });

    }

    function checkRememberContainerVisibility() {
        var value = $body.find('[data-card-container] [name="card"]:checked').val(),
            $rememberContainer = $body.find('[data-card-remember-container]');

        if (value === 'new') {
            $rememberContainer.show();
        } else {
            $rememberContainer.hide();
        }
    }

    function deleteSubscription(id) {
        APP.Ajax.post('/en-US/service/pro/delete/' + id).then(function (result) {
            //todo: prompt window!
            if (result.success) {
                $body.find('[data-delete-subscription="' + id + '"]').parents('tbody').remove();
            } else {
                APP.Layout.openOverlay('fail-action');
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function removePro(id, code) {
        APP.Ajax.post('/en-US/service/pro/remove-user/', {
            userId: id,
            code: code,
            billId: $body.find('[data-bill-id]').attr('data-bill-id')
        }).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl(document.location.href);
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function setRenew(value, billId) {
        APP.Ajax.post('/en-US/service/pro/set-renew/', {
            billId: billId,
            value: value
        }).then(function (result) {
            APP.Page.applyPageByUrl(document.location.href);
        }, window.NOOP);
    }

    function addPro(id) {
        APP.Ajax.post('/en-US/service/pro/add-user/', {
            userId: id,
            billId: $body.find('[data-bill-id]').attr('data-bill-id')
        }).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl(document.location.href);
            } else {
                APP.Layout.openOverlay('fail-action');
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function buyPackages(data) {
        APP.Ajax.post('/en-US/service/pro/create-bill', data).then(function (result) {
            if (result.success) {
                if (result.result) {
                    APP.Page.applyPageByUrl('/en-US/pro/billing/' + result.result);
                } else if (result.billId) {
                    APP.Page.applyPageByUrl('/en-US/pro/subscription/' + result.billId);
                } else {
                    APP.Page.applyPageByUrl('/en-US/');
                }
            } else {
                $body.find('[data-buy-error-text]').text((result.error || {}).global ||
                    $body.find('[data-buy-error-text]').attr('data-buy-error-text'));
                APP.Layout.openOverlay('buy-error');
            }
        }, function () {
            $body.find('[data-buy-error-text]').text($body.find('[data-buy-error-text]').attr('data-buy-error-text'));
            APP.Layout.openOverlay('buy-error');
        });
    }

    function activatePackage(data) {
        APP.Ajax.post('/en-US/service/pro/activate', data).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl('/en-US/');
            } else {
                APP.Layout.alert(result.error.global);
            }
        }, () => {
            APP.Layout.alert(result.error.global);
        });
    }

    function successBillingSettings(data) {
        if (data.redirect) {
            document.location.href = data.redirect;
        } else {
            APP.Page.applyPageByUrl('/en-US/pro/pay-review/' + $body.find('[data-bill-id]').attr('data-bill-id'));
        }
    }

    function successSelectPayment(data) {
        if (data.redirect) {
            document.location.href = data.redirect;
        } else {
            APP.Page.applyPageByUrl('/en-US/pro/pay-wire-transfer/' + $body.find('[name="billId"]').val());
        }
    }

    function successActivationCode() {
        APP.Page.applyPageByUrl('/en-US/');
    }

    function successActivationCodeModification() {
        APP.Page.applyPageByUrl(document.location.href);
    }

    exports.init = init;
    exports.successBillingSettings = successBillingSettings;
    exports.successSelectPayment = successSelectPayment;
    exports.successActivationCode = successActivationCode;
    exports.successActivationCodeModification = successActivationCodeModification;
    exports.getPrice = getPrice;
    return exports;

})();

APP.Tpl = (function () {
    var exports = {},
        initialized = false,
        templates = {},
        engine;

    function init() {
        engine = new Arti();
        engine.addPartial('icon', APP.$store.templates.icon);
        engine.addPartial('newsFeedCard', APP.$store.templates['newsfeed-card']);
        engine.addPartial('newsFeedCardActions', APP.$store.templates['newsfeed-card-actions']);
        engine.addHelper('safe', function (str) {
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        });
        engine.addHelper('postReplacer', function (str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(
                    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,
                    '<a href="$1" target="_blank">$1</a>'
                );
        });
        engine.addHelper('base64', base64Encode);
        engine.addHelper('lowercase', function (str) {
            return String(str).toLowerCase();
        });
    }

    function run(tpl, ctx) {
        if (templates.hasOwnProperty(tpl)) {
            return templates[tpl](ctx || {});
        } else if (APP.$store.templates.hasOwnProperty(tpl)) {
            templates[tpl] = engine.template(APP.$store.templates[tpl]);
            return run(tpl, ctx);
        } else if ($body.find('[data-tpl="' + tpl + '"]').length > 0) {
            var tplString = $body.find('[data-tpl="' + tpl + '"]').html();

            tplString = tplString.replace(/\n/g, '\\n');
            tplString = tplString.replace(/\(\(/g, '{{');
            tplString = tplString.replace(/\)\)/g, '}}');
            templates[tpl] = engine.template(tplString);
            return run(tpl, ctx);
        }
        throw new Error('no tmplate like: ' + tpl);
    }

    exports = {
        init: init,
        run: run
    };

    return exports;

})();
(function () {

    window.setCookie = function (cname, cvalue, exdays) {
        var d = new Date(),
            expires;
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';path=/; ' + expires;
    };


    window.getCookie = function (cname) {
        var name = cname + '=',
            ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    window.queryEncode = function (object) {
        var str = [];
        for (var p in object) {
            if (object.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]));
            }
        }
        return str.join("&");
    };

    window.queryDecode = function () {
        var args = document.location.search.substring(1).split('&'),
            arg,
            object = {},
            i;

        for (i = 0; i < args.length; i++) {
            arg = decodeURIComponent(args[i]);
            if (arg.indexOf('=') === -1) {
                object[arg.trim()] = true;
            } else {
                var kvp = arg.split('=');
                object[kvp[0].trim()] = kvp[1].trim();
            }

        }

        return object;

    };

    window.async = function (fn, timeout) {
        requestAnimationFrame(function () {
            setTimeout(fn, timeout || 8);
        });
    };

    window.showLog = function () {
        window.log = true;
        window.setCookie('show-log', 'true', 3);

    };

    window.hideLog = function () {
        window.log = false;
        window.setCookie('show-log', 'false', 100);
    };

    window.log = window.getCookie('show-log') === 'true';

    window.base64Encode = function (str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    };

    window.base64Decode = function (str) {
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };

    window.toB64 = function (string) {
        return replaceCharacters(btoa(string));
    };

    window.fromB64 = function (string) {
        return atob(replaceCharacters(string, true));
    };

    function replaceCharacters(string, backward) {
        var b64ReplaceTable = [
            ['/', '-'] // url pattern friendly
        ];

        b64ReplaceTable.forEach(function (item) {
            if (backward) {
                string = string.replace(new RegExp(item[1], 'g'), item[0]);
            } else {
                string = string.replace(new RegExp(item[0], 'g'), item[1]);

            }
        });

        return string;
    }
}());


APP.Ajax = (function () {
    var exports = {},
        waitForResponse = 0,
        wait = 0,
        chain = [];

    function post(serviceUrl, data, silence) {
        return load({
            url: serviceUrl,
            data: data,
            type: 'POST',
            dataType: 'json'
        }, silence);
    }

    function get(url, silence) {
        return load({
            url: url,
            type: 'GET',
            dataType: 'html',
            contentType: 'application/json; charset=utf-8'
        }, silence);
    }

    function runChain() {
        if (chain.length > 0) {
            var task = chain.shift();
            if (task) {
                task();
            }
        }
    }

    function load(ajaxSettings, silence, asap) {
        return new Promise(function (resolve, reject) {
            var detailedError,
                task = function () {
                    wait++;
                    ajaxSettings.timeout = ajaxSettings.timeout || 30000;

                    var jqXHR = $.ajax(ajaxSettings);

                    if (!silence) {
                        subscribePromise(jqXHR);
                    }

                    jqXHR.done(function (res) {
                        wait--;
                        runChain();
                        resolve(res);
                    }).fail(function (err, textStatus) {
                        detailedError = new Error('Ajax Error: ' + textStatus + ' (' + err.status + ') on ' + ajaxSettings.url);
                        wait--;

                        // Csak akkor logolunk, ha nem a felhasználó szakította meg a kérést (status 0)
                        if (err.status !== 0 && textStatus !== 'abort') {
                            var errorData = {
                                url: ajaxSettings.url,
                                method: ajaxSettings.type,
                                status: err.status,
                                statusText: err.statusText,
                                responseText: err.responseText ? err.responseText.substring(0, 500) : '',
                                page: document.location.pathname
                            };
                            if (window.posthog) {
                                window.posthog.captureException(detailedError, errorData);
                            }
                            APP.Analytics.capture('ajax-server-error', {
                                error_details: errorData,
                                exception: detailedError
                            });
                        }

                        runChain();
                        reject(detailedError);
                    });
                };

            if (wait === 0 || asap) {
                task();
            } else {
                chain.push(task);
            }
        });
    }

    function subscribePromise(jqXHR) {
        waitForResponse++;
        updateLoadingState();
        jqXHR.always(function () {
            waitForResponse--;
            updateLoadingState();
        });
    }

    function updateLoadingState() {
        if (waitForResponse <= 0) {
            $body.removeClass('application--loading');
            waitForResponse = 0;
        } else {
            $body.addClass('application--loading');
        }
    }

    exports.post = post;
    exports.get = get;
    exports.load = load;
    return exports;

})();

APP.Akri = (function () {
    var exports = {};

    function Akri($element) {
        var _self = this,
            settings = {
                blinkSpeed: 3,
                eyeSpeed: 3,
                lightSpeed: 30,
                wingSpeed: 3
            },
            data = {
                akri: {
                    top: 0,
                    topt: 0
                },
                top: {
                    cpl: -38.7, // curve point left
                    cplt: -38.7, // curve point left target
                    cpr: 101.3, // curve point right
                    cprt: 101.3, // curve point right target
                    mp: -70, // middle point
                    mpt: -70 // middle point target
                },
                bottom: {
                    cpl: -38.7, // curve point left
                    cplt: -38.7, // curve point left target
                    cpr: 101.3, // curve point right
                    cprt: 101.3, // curve point right target
                    mp: -70, // middle point
                    mpt: -70 // middle point target
                },
                pupil: {
                    scale: 0.5,
                    scalet: 0.5,
                    x: 50,
                    xt: 50,
                    y: 50,
                    yt: 50
                },
                iris: {
                    scale: 1,
                    scalet: 1,
                    x: 0,
                    xt: 0,
                    y: 0,
                    yt: 0
                },
                lights: {
                    scale1: 0,
                    scale1t: 0,
                    scale2: 0,
                    scale2t: 0,
                    scale3: 0,
                    scale3t: 0,
                    scale4: 0,
                    scale4t: 0
                },
                wing: {
                    left: {
                        rotate: 0,
                        rotatet: 0
                    },
                    right: {
                        rotate: 0,
                        rotatet: 0
                    }
                }
            },
            $e = {
                $body: $element.querySelector('[data-akri="body"]'),
                $hat: $element.querySelector('[data-akri="hat"]'),
                $blinkPathTop: $element.querySelector('[data-akri-path="top"]'),
                $blinkPathBottom: $element.querySelector('[data-akri-path="bottom"]'),
                $pupil: $element.querySelector('[data-akri="pupil"]'),
                $iris: $element.querySelector('[data-akri="iris"]'),
                $lights: $element.querySelector('[data-akri="lights"]'),
                $eyeball: $element.querySelector('[data-akri="eyeball"]'),
                $leftWing: $element.querySelector('[data-akri="left-wing"]'),
                $rightWing: $element.querySelector('[data-akri="right-wing"]'),
                $light1: $element.querySelector('[data-akri="light-1"]'),
                $light2: $element.querySelector('[data-akri="light-2"]'),
                $light3: $element.querySelector('[data-akri="light-3"]'),
                $light4: $element.querySelector('[data-akri="light-4"]'),
                $shadow: $element.querySelector('[data-akri="shadow"]')
            };

        _self.ouch = function () {

        };

        _self.haha = function () {

        };

        _self.hihi = function () {

        };

        _self.aww = function () {

        };

        _self.hmm = function () {

        };

        _self.pls = function () {

        };

        _self.zzz = function () {

        };

        _self.peace = function () {

        };

        _self.blink = function (time) {

        };

        _self.pokeIn = function () {

        };

        _self.pokeOut = function () {

        };

        _self.lookAtMe = function () {
            _self.eyeMove(0, 0);
        };

        _self.lookAtMyEyes = function () {
            data.iris.x = data.pupil.x = -0.1;
            data.iris.y = data.pupil.y = 0;
        };

        _self.lookAtMouse = function () {

        };

        _self.lookAtElement = function ($element) {

        };

        _self.eyeMove = function (x, y, preventOthers) {
            var radius = 2.5,
                deg = (Math.atan2(x, y) * (180 / Math.PI)) || 0,
                xPos = radius * Math.sin(Math.PI * 2 * deg / 360),
                yPos = radius * Math.cos(Math.PI * 2 * deg / 360);

            setLights(x, y);

            if (x >= 0) {
                xPos = Math.min(x * radius, xPos);
            } else {
                xPos = Math.max(x * radius, xPos);
            }

            if (y >= 0) {
                yPos = Math.min(y * radius, yPos);
            } else {
                yPos = Math.max(y * radius, yPos);
            }

            data.iris.xt = xPos;
            data.iris.yt = yPos;

            var maxPercent = 66;
            data.pupil.xt = ((100 - maxPercent) / 2 + ((1 + x) / 2) * maxPercent);
            data.pupil.yt = ((100 - maxPercent) / 2 + ((1 + y) / 2) * maxPercent);

            if (!preventOthers) {
                setBlinkPosByIrisY(y);
            }

        };

        _self.pupilScale = function (weight) {
            data.pupil.scalet = 0.3 * weight + 0.3; // between 0.3 and 0.6
        };

        _self.irisScale = function (weight) {
            data.iris.scalet = 0.7 * weight + 0.3; // between 0.3 and 1
        };

        _self.blinkTop = function (weight) {
            data.top.cplt = -38.7 + 38.7 * weight; // -38.7;
            data.top.cprt = 101.3 + 38.7 * weight; // 101.3;
            data.top.mpt = -70 * (1 - weight);//-70;
        };

        _self.blinkBottom = function (weight) {
            data.bottom.cplt = -38.7 + 38.7 * weight; // -38.7;
            data.bottom.cprt = 101.3 + 38.7 * weight; // 101.3;
            data.bottom.mpt = -70 * (1 - weight);//-70;
        };

        _self.blinkTo = function (weight) {
            _self.blinkTop(weight);
            _self.blinkBottom(weight);
        };

        _self.blink = function (weight) {

        };

        _self.think = function (html) {

        };

        _self.whiskLeftWing = function (weight) {
            data.wing.left.rotatet = weight * 75;
        };

        _self.whiskRightWing = function (weight) {
            data.wing.right.rotatet = weight * 75;
        };

        _self.whiskWings = function (weight) {
            _self.whiskLeftWing(weight);
            _self.whiskRightWing(weight);
        };

        _self.show = function () {

        };

        _self.hide = function () {

        };

        _self.start = function () {

        };

        _self.pause = function () {

        };

        // private functions:

        function setBlinkPosByIrisY(y) {
            var defInterval = 1.11,
                scale = 0.5 * (defInterval - y);
            _self.blinkTop(y + scale);
            _self.blinkBottom(defInterval - y - scale);
            /*
             if (y >= 0) {
             _self.blinkTop(y);
             _self.blinkBottom(0.2);
             } else {
             _self.blinkTop(0.2);
             _self.blinkBottom(-y);
             }
             */
        }

        function setLights(x, y) {
            data.lights.scale1t = 0;
            data.lights.scale2t = 0;
            data.lights.scale3t = 0;
            data.lights.scale4t = 0;

            if (x < 0 && y < 0) {
                data.lights.scale3t = 1 + x * y;
            } else if (x <= 0 && y >= 0) {
                data.lights.scale2t = 1 + x * -y;
            } else if (x > 0 && y > 0) {
                data.lights.scale1t = 1 + x * y;
            } else {
                data.lights.scale4t = 1 + x * -y;
            }
        }

        function initBindings() {
            var preventMouseMove = false,
                hatMouseDown = false,
                leftWingMouseDown = false,
                rightWingMouseDown = false,
                eyeBallMouseDown = false;

            $e.$eyeball.addEventListener('mouseenter', function () {
                preventMouseMove = true;
                _self.lookAtMe();
                _self.pupilScale(0.9);
            });

            $e.$eyeball.addEventListener('mousedown', function () {
                eyeBallMouseDown = true;
                _self.pupilScale(0.5);
                _self.blinkTo(1);
            });
            $e.$eyeball.addEventListener('touchstart', function () {
                eyeBallMouseDown = true;
                _self.pupilScale(0.5);
                _self.blinkTo(1);
            });

            $e.$eyeball.addEventListener('mouseleave', function () {
                _self.irisScale(1);
                _self.pupilScale(1);
                _self.blinkTop(0.4);
                _self.blinkBottom(0.15);
                preventMouseMove = false;
            });

            $e.$leftWing.addEventListener('mouseenter', function () {
                _self.pupilScale(0.7);
                _self.eyeMove(-1, 0);
                _self.blinkTo(0.2);
            });

            $e.$rightWing.addEventListener('mouseenter', function () {
                _self.pupilScale(0.8);
                _self.eyeMove(1, 0);
                _self.blinkTo(0.2);
            });

            $e.$leftWing.addEventListener('mousedown', function () {
                leftWingMouseDown = true;
                _self.whiskLeftWing(1);
            });

            $e.$rightWing.addEventListener('mousedown', function () {
                rightWingMouseDown = true;
                _self.whiskRightWing(1);
            });

            $e.$hat.addEventListener('mousedown', function () {
                hatMouseDown = true;
                _self.whiskWings(1);
            });

            $e.$leftWing.addEventListener('touchstart', function () {
                leftWingMouseDown = true;
                _self.whiskLeftWing(1);
            });

            $e.$rightWing.addEventListener('touchstart', function () {
                rightWingMouseDown = true;
                _self.whiskRightWing(1);
            });

            $e.$hat.addEventListener('touchstart', function () {
                hatMouseDown = true;
                _self.whiskWings(1);
            });

            window.addEventListener('mousemove', function (event) {
                var offset = getCoords($e.$eyeball),
                    x = event.pageX - (offset.left + $e.$eyeball.offsetWidth / 2),
                    y = event.pageY - (offset.top + $e.$eyeball.offsetHeight / 2),
                    xorX = x < 0 ? -1 : 1,
                    xorY = y < 0 ? -1 : 1;

                if (preventMouseMove) {
                    x = x / ($e.$eyeball.offsetWidth / 2);
                    y = y / ($e.$eyeball.offsetHeight / 2);
                    _self.eyeMove(x, y, eyeBallMouseDown);
                } else {
                    _self.pupilScale(Math.min(1 / ((Math.abs(x) + Math.abs(y)) / 200), 1));
                    if (Math.abs(x) > Math.abs(y)) {
                        y = (Math.abs(y / x) || 0) * xorY;
                        x = xorX;
                    } else {
                        x = (Math.abs(x / y) || 0) * xorX;
                        y = xorY;
                    }
                    _self.eyeMove(x, y);
                }

            });

            var fnMouseup = function (event) {
                if (eyeBallMouseDown) {
                    eyeBallMouseDown = false;
                    _self.irisScale(1);
                    _self.pupilScale(0.7);
                    _self.blinkTo(0.3);
                }

                if (leftWingMouseDown) {
                    leftWingMouseDown = false;
                    _self.whiskLeftWing(0);
                }

                if (rightWingMouseDown) {
                    rightWingMouseDown = false;
                    _self.whiskRightWing(0);
                }

                if (hatMouseDown) {
                    hatMouseDown = false;
                    _self.whiskWings(0);
                }
            };
            window.addEventListener('mouseup', fnMouseup);
            window.addEventListener('touchend', fnMouseup);

        }

        function getCoords(elem) { // crossbrowser version
            var box = elem.getBoundingClientRect(),
                body = document.body || {},
                docEl = document.documentElement || {},
                scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
                scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
                clientTop = docEl.clientTop || body.clientTop || 0,
                clientLeft = docEl.clientLeft || body.clientLeft || 0,
                top = box.top + scrollTop - clientTop,
                left = box.left + scrollLeft - clientLeft;
            return {
                top: Math.round(top),
                left: Math.round(left)
            };
        }

        function onFrame() {
            animate();
            requestAnimationFrame(onFrame);
        }

        function animate() {
            data.top.cpl = (data.top.cpl + (data.top.cplt - data.top.cpl) / settings.blinkSpeed);
            data.top.cpr = (data.top.cpr + (data.top.cprt - data.top.cpr) / settings.blinkSpeed);
            data.top.mp = (data.top.mp + (data.top.mpt - data.top.mp) / settings.blinkSpeed);

            data.bottom.cpl = (data.bottom.cpl + (data.bottom.cplt - data.bottom.cpl) / settings.blinkSpeed);
            data.bottom.cpr = (data.bottom.cpr + (data.bottom.cprt - data.bottom.cpr) / settings.blinkSpeed);
            data.bottom.mp = (data.bottom.mp + (data.bottom.mpt - data.bottom.mp) / settings.blinkSpeed);

            data.pupil.scale = (data.pupil.scale + (data.pupil.scalet - data.pupil.scale) / settings.eyeSpeed);
            data.pupil.x = (data.pupil.x + (data.pupil.xt - data.pupil.x) / settings.eyeSpeed);
            data.pupil.y = (data.pupil.y + (data.pupil.yt - data.pupil.y) / settings.eyeSpeed);

            data.iris.scale = (data.iris.scale + (data.iris.scalet - data.iris.scale) / settings.eyeSpeed);
            data.iris.x = (data.iris.x + (data.iris.xt - data.iris.x) / settings.eyeSpeed);
            data.iris.y = (data.iris.y + (data.iris.yt - data.iris.y) / settings.eyeSpeed);

            data.lights.scale1 = (data.lights.scale1 + (data.lights.scale1t - data.lights.scale1) / settings.eyeSpeed);
            data.lights.scale2 = (data.lights.scale2 + (data.lights.scale2t - data.lights.scale2) / settings.eyeSpeed);
            data.lights.scale3 = (data.lights.scale3 + (data.lights.scale3t - data.lights.scale3) / settings.eyeSpeed);
            data.lights.scale4 = (data.lights.scale4 + (data.lights.scale4t - data.lights.scale4) / settings.eyeSpeed);

            data.wing.right.rotate = (data.wing.right.rotate + (data.wing.right.rotatet - data.wing.right.rotate) / settings.wingSpeed);
            data.wing.left.rotate = (data.wing.left.rotate + (data.wing.left.rotatet - data.wing.left.rotate) / settings.wingSpeed);

            $e.$blinkPathTop.setAttribute('d',
                'M140,140c0 ' + (data.top.cpl.toFixed(1)) +
                '-31.3 ' + (data.top.mp.toFixed(1)) +
                '-70 ' + (data.top.mp.toFixed(1)) +
                'S0,' + (data.top.cpr.toFixed(1)) +
                ',0,140V0h140V140z'
            );

            $e.$blinkPathBottom.setAttribute('d',
                'M140,140c0 ' + (data.bottom.cpl.toFixed(1)) +
                '-31.3 ' + (data.bottom.mp.toFixed(1)) +
                '-70 ' + (data.bottom.mp.toFixed(1)) +
                'S0,' + (data.bottom.cpr.toFixed(1)) +
                ',0,140V0h140V140z'
            );

            $e.$pupil.style.transform = 'scale(' + data.pupil.scale + ')';
            $e.$pupil.style.transformOrigin = (data.pupil.x) + '% ' + (data.pupil.y) + '%';
            $e.$iris.style.transform = 'scale(' + data.iris.scale + ') translate3d(' + data.iris.x + 'em,' + data.iris.y + 'em,0)';
            $e.$light1.style.transform = 'scale(' + data.lights.scale1.toFixed(1) + ')';
            $e.$light2.style.transform = 'scale(' + data.lights.scale2.toFixed(1) + ')';
            $e.$light3.style.transform = 'scale(' + data.lights.scale3.toFixed(1) + ')';
            $e.$light4.style.transform = 'scale(' + data.lights.scale4.toFixed(1) + ')';

            $e.$rightWing.style.transform = 'rotate(' + data.wing.right.rotate.toFixed(1) + 'deg)';
            $e.$leftWing.style.transform = 'rotate(' + -data.wing.left.rotate.toFixed(1) + 'deg)';

            $e.$body.style.transform = 'rotate(' + ((data.wing.left.rotate - data.wing.right.rotate) / 5).toFixed(1) + 'deg) translate3d(0, ' + (-(data.wing.left.rotate + data.wing.right.rotate) / 5).toFixed(1) + 'px, 0)';
            $e.$lights.style.transform = 'rotate(' + (-(data.wing.left.rotate - data.wing.right.rotate)).toFixed(1) + 'deg)';
            $e.$shadow.style.transform = 'scale(' + (1 - (data.wing.left.rotate + data.wing.right.rotate) / 300).toFixed(1) + ')';

        }

        _self.eyeMove(0, 0);
        setLights(0, 0);
        requestAnimationFrame(onFrame);
        initBindings();

        return _self;

    }

    exports.init = function () {
        initializeAll();
    };

    function initializeAll() {
        $body.find('.akri:not(.akri--ready)').each(function () {
            $(this).addClass('akri--ready');
            var A = new Akri(this);
        });
    }

    return exports;

})();

APP.Exam = (function () {
    var initialized = false,
        inputType = 'solution',
        reloadTimer,
        exports = {};

    function init() {
        if (!initialized) {
            initialized = true;
            initBindings();
            timerTick(true);
            groupExamsLiveTableInit();
        }
        timerTick();
        initializeLiveTables();
        pageReLoaderInit();
    }

    function initBindings() {
        $body.on('click', '[data-start-exam]', function () {
            generateExam($(this).attr('data-start-exam')).then(function (id) {
                APP.Page.applyPageByUrl('/en-US/exam/' + id);
            }, function () {
                // para van!
            });
        });

        $body.on('click', '[data-exam-send]', function () {
            var $button = $(this),
                answer = $body.find('[data-learn-input]').attr('data-value');

            if (answer !== '[]') {
                $button.addClass('disabled');
                APP.Ajax.post('/en-US/service/exam/check', {
                    examId: $body.find('[name="exam-id"]').val(),
                    examNth: $body.find('[name="exam-nth"]').val(),
                    answer: answer
                }).then(function (result) {
                    APP.Live.saveClientMeta('ping', 1);
                    $button.removeClass('disabled');
                    if (result.success) {
                        if (result.display) {
                            addFormulaToHistory(result.display, 'solution');
                        }
                    } else if (result.reason === 'redundant') {
                        APP.Layout.openOverlay('exam-redundant');
                    } else if (result.reason === 'done') {
                        APP.Layout.openOverlay('exam-finished');
                    } else {
                        APP.ProblemWorker.run('learn-error', result).then(function (content) {
                            $body.find('[data-learn-error-content]').html(content);
                            APP.Layout.openOverlay('learn-error');
                            $body.find('[data-close-learn-error]').focus();
                        });
                    }
                }, function () {
                    $button.removeClass('disabled');
                });
            } else {
                APP.Layout.openOverlay('empty-exam-input');
                $body.find('[data-close-learn-empty]').focus();
            }
        });


        $body.on('click', '[data-exam-save-step]', function () {
            var $button = $(this),
                answer = $body.find('[data-learn-input]').attr('data-value');

            if (answer !== '[]') {
                $button.addClass('disabled');
                APP.Ajax.post('/en-US/service/exam/check', {
                    examId: $body.find('[name="exam-id"]').val(),
                    examNth: $body.find('[name="exam-nth"]').val(),
                    answer: answer
                }).then(function (result) {
                    APP.Live.saveClientMeta('ping', 1);
                    $button.removeClass('disabled');
                    if (result.success || (!result.success && result.reason === 'redundant')) {
                        APP.Page.applyPageByUrl($button.attr('data-href'));
                    } else if (result.reason === 'done') {
                        APP.Layout.openOverlay('exam-finished');
                    } else {
                        APP.ProblemWorker.run('learn-error', result).then(function (content) {
                            $body.find('[data-learn-error-content]').html(content);
                            APP.Layout.openOverlay('learn-error');
                            $body.find('[data-close-learn-error]').focus();
                        });
                    }
                }, function () {
                    $button.removeClass('disabled');
                });
            } else {
                APP.Page.applyPageByUrl($button.attr('data-href'));
            }
        });

        $body.on('click', '[data-exam-cta-resolve]', function () {
            var $this = $(this);

            APP.Ajax.post('/en-US/service/exam/check', {
                examId: $body.find('[name="exam-id"]').val(),
                examNth: $body.find('[name="exam-nth"]').val(),
                answer: $this.attr('data-exam-cta-resolve'),
                display: $this.attr('data-exam-cta-display'),
                type: 'cta'
            }).then(function (result) {
                APP.Live.saveClientMeta('ping', 1);
                if (result.success) {
                    if (result.display) {
                        addFormulaToHistory(result.display, 'cta');
                    }
                } else if (result.reason === 'redundant') {
                    APP.Layout.openOverlay('exam-redundant');
                } else if (result.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                } else {
                    APP.ProblemWorker.run('learn-error', result).then(function (content) {
                        $body.find('[data-learn-error-content]').html(content);
                        APP.Layout.openOverlay('learn-error');
                        $body.find('[data-close-learn-error]').focus();
                    });
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-switch-type]', function () {
            inputType = $(this).attr('data-switch-type');
        });

        $body.on('click', '[data-submit-exam-comment]', function () {
            var type = $(this).attr('data-submit-exam-comment'),
                comment = $body.find('[data-comment]').val();

            if (type === 'comment-formula') {
                comment = $body.find('[data-learn-input]').attr('data-value');
            }

            APP.Ajax.post('/en-US/service/exam/' + $body.find('[name="exam-id"]').val() + '/comment', {
                examId: $body.find('[name="exam-id"]').val(),
                examNth: $body.find('[name="exam-nth"]').val(),
                type: type,
                comment: comment
            }).then(function (result) {
                APP.Live.saveClientMeta('ping', 1);
                if (result.success) {
                    addFormulaToHistory(result.display, type);
                    showFormulaInput();
                } else if (result.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-answer-edit]', function () {
            var nth = parseInt($(this).attr('data-exam-answer-edit'), 10),
                length = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length - 1,
                i;

            APP.Calculator.Keyboard.clean();
            APP.Calculator.Keyboard.paste(
                $(this).parents('[data-exam-answer-formula]').attr('data-exam-answer-formula')
            );

            showFormulaInput();
            switchToCtas('edit');
            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answer="' + nth + '"]').addClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            $body.find('[name="edit-item"]').val(nth);

            if (nth !== length) {
                $body.find('[data-exam-answers="2"]').removeClass('invisible');
            }

            for (i = 0; i <= length; i++) {
                if (nth < i) {
                    $body.find('[data-exam-answers="1"] [data-exam-answer="' + i + '"]').addClass('invisible');
                } else if (nth > i) {
                    $body.find('[data-exam-answers="2"] [data-exam-answer="' + i + '"]').addClass('invisible');
                }
            }

        });

        $body.on('click', '[data-exam-text-edit]', function () {
            var nth = parseInt($(this).attr('data-exam-text-edit'), 10),
                length = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length - 1,
                i;

            inputType = 'comment-text';
            $body.find('[data-dashboard-input]').hide();
            $body.find('[data-prime-box]').hide();
            $body.find('[data-comment-box]').show();
            $body.find('[data-comment]').val($(this).parents('[data-exam-answer]').find('p').text()).focus();
            switchToCtas('edit');

            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answer="' + nth + '"]').addClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            $body.find('[name="edit-item"]').val(nth);

            if (nth !== length) {
                $body.find('[data-exam-answers="2"]').removeClass('invisible');
            }

            for (i = 0; i <= length; i++) {
                if (nth < i) {
                    $body.find('[data-exam-answers="1"] [data-exam-answer="' + i + '"]').addClass('invisible');
                } else if (nth > i) {
                    $body.find('[data-exam-answers="2"] [data-exam-answer="' + i + '"]').addClass('invisible');
                }
            }

        });

        $body.on('click', '[data-exam-answer-delete]', function () {
            var examId = $body.find('[name="exam-id"]').val(),
                itemIndex = $body.find('[name="item-index"]').val(),
                nth = $(this).attr('data-exam-answer-delete');

            APP.Ajax.post('/en-US/service/exam/' + examId + '/delete', {
                itemIndex: itemIndex,
                answerIndex: nth
            }).then(function (response) {
                APP.Live.saveClientMeta('ping', 1);
                if (response.success) {
                    $body.find('[data-exam-answer="' + nth + '"]').remove();
                    updateIndexes($body.find('[data-exam-answers="1"]'));
                    updateIndexes($body.find('[data-exam-answers="2"]'));
                } else if (response.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-edit-save]', function () {
            var examId = $body.find('[name="exam-id"]').val(),
                itemIndex = $body.find('[name="item-index"]').val(),
                nth = $body.find('[name="edit-item"]').val(),
                type = inputType,
                answer;

            if (type === 'comment-text') {
                answer = $body.find('[data-comment]').val();
            } else {
                answer = $body.find('[data-learn-input]').attr('data-value');
            }

            APP.Ajax.post('/en-US/service/exam/' + examId + '/update', {
                itemIndex: itemIndex,
                answerIndex: nth,
                answer: answer,
                type: type
            }).then(function (response) {
                APP.Live.saveClientMeta('ping', 1);
                if (response.success) {
                    var $actual = $body.find('[data-exam-answer="' + nth + '"]'),
                        $formula = $(APP.Tpl.run('exam-solution', {
                            index: nth,
                            type: type,
                            displayJson: $body.find('[data-calculator]').attr('data-value'),
                            display: response.display
                        }));
                    $formula.insertBefore($actual);
                    $actual.remove();
                    APP.Formula.fillFormulas();
                    switchToCtas('default');
                    $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
                    $body.find('[data-exam-answers="2"]').addClass('invisible');
                    // APP.Calculator.Keyboard.clean();
                    $body.find('[data-comment]').val('');
                    inputType = 'solution';
                    showFormulaInput();
                } else if (response.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                } else {
                    APP.ProblemWorker.run('learn-error', response).then(function (content) {
                        $body.find('[data-learn-error-content]').html(content);
                        APP.Layout.openOverlay('learn-error');
                        $body.find('[data-close-learn-error]').focus();
                    });
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-edit-cancel]', function () {
            inputType = 'solution';
            showFormulaInput();
            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            APP.Calculator.Keyboard.clean();
        });

        $body.on('click', '[data-group-exam]', function () {
            var groupId = $(this).attr('data-group-exam'),
                examTemplateId = $body.find('[name="templateId"]').val(),
                members = [];

            $body.find('[name="member"]:checked').each(function () {
                members.push($(this).val());
            });
            APP.Ajax.post('/en-US/service/group-exam/create', {
                groupId: groupId,
                examTemplateId: examTemplateId,
                members: members
            }).then(function (response) {
                if (response.success) {
                    APP.Page.applyPageByUrl('/en-US/group/exam/' + response.examId + '/live');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-start-group-exam]', function () {
            var groupExamId = $(this).attr('data-start-group-exam');

            APP.Ajax.post('/en-US/service/group-exam/start', {
                groupExamId: groupExamId,
            }).then(function (response) {
                if (response.success) {
                    APP.Page.applyPageByUrl('/en-US/exam/' + response.examId);
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-finish-exams]', function () {
            var $this = $(this),
                groupExamId = $this.attr('data-finish-exams');

            APP.Ajax.post('/en-US/service/group-exam/finish', {
                groupExamId: groupExamId,
            }).then(function (response) {
                if (response.success) {
                    APP.Page.reloadPage();
                }
            }, window.NOOP);
        });

    }

    function initializeLiveTables() {
        $body.find('[data-group-exam-live]').each(function () {
            var $this = $(this);
            $this.html(APP.Tpl.run('exam-live', JSON.parse($this.attr('data-group-exam-live'))));
            APP.Layout.setMoments();
        });
    }

    function showTextInput() {
        inputType = 'comment-text';
        $body.find('[data-dashboard-input]').hide();
        $body.find('[data-comment-box]').show();
        $body.find('[data-prime-box]').hide();
        switchToCtas('default');
    }

    function showFormulaInput() {
        $body.find('[data-dashboard-input]').show();
        $body.find('[data-comment-box]').hide();
        $body.find('[data-prime-box]').hide();
        switchToCtas('default');
    }

    function addFormulaToHistory(formula, type) {
        var index = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length,
            $formula = $(APP.Tpl.run('exam-solution', {
                index: index,
                type: type,
                displayJson: type === 'cta' ? '[]' : $body.find('[data-calculator]').attr('data-value'),
                display: formula
            }));

        $body.find('[data-exam-answers="1"]').removeClass('invisible');
        $body.find('[data-previous-good-answers]').append($formula);
        APP.Formula.fillFormulas();
    }

    function generateExam(id) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/en-US/service/exam/generate/' + id).then(function (response) {
                if (response.success) {
                    resolve(response.id);
                } else {
                    reject();
                }
            }, window.NOOP);
        });
    }

    function timerTick(repeat) {
        if (repeat) {
            setTimeout(function () {
                timerTick(true);
            }, 5000);
        }
        $body.find('[data-timer]').each(function () {
            var $this = $(this),
                start = new Date($this.attr('data-timer')),
                delta = Date.now() - start;
            $this.text(Math.max(0, Math.floor(delta / 1000 / 60)));
        });
    }

    function groupExamsLiveTableInit() {
        $body.find('[data-group-exam-live]:not(.done)').each(function () {
            loadExamLiveTable($(this).attr('data-group-exam-live-id'));
        });
        setTimeout(groupExamsLiveTableInit, 10000);
    }

    function loadExamLiveTable(groupExamId) {
        var allDone = true,
            $table;

        APP.Ajax.post('/en-US/service/group-exam/live', {
            groupExamId: groupExamId
        }, true).then(function (response) {
            if (response.success) {
                $table = $body.find('[data-group-exam-live-id="' + groupExamId + '"]');
                $table.attr('data-group-exam-live', JSON.stringify(response.result));
                response.result.forEach(function (exam) {
                    if (!exam.done) {
                        allDone = false;
                    }
                });

                if (allDone) {
                    $table.addClass('done');
                }
                initializeLiveTables();
            }
        }, window.NOOP);
    }

    function switchToCtas(name) {
        $body.find('[data-formula-default-ctas]').hide();
        $body.find('[data-formula-comment-ctas]').hide();
        $body.find('[data-formula-edit-ctas]').hide();
        $body.find('[data-formula-' + name + '-ctas]').show();
    }

    function updateIndexes($wrapper) {
        $wrapper.find('[data-exam-answer]').each(function (index) {
            var $this = $(this);

            $this.attr('data-exam-answer', index);
            $this.find('[data-exam-answer-edit]').attr('data-exam-answer-edit', index);
            $this.find('[data-exam-answer-delete]').attr('data-exam-answer-delete', index);
        });
    }

    function pageReLoaderInit() {
        var $indicator = $body.find('[data-page-reload]'),
            interval = parseInt($indicator.attr('data-page-reload'), 10);

        clearTimeout(reloadTimer);
        if ($indicator.length) {
            reloadTimer = setTimeout(function () {
                APP.Page.reloadPageSilence();
                pageReLoaderInit()
            }, interval);
        }
    }

    exports.init = init;
    exports.addFormulaToHistory = addFormulaToHistory;
    exports.showFormulaInput = showFormulaInput;
    return exports;

})();

APP.Form = (function () {
    var exports = {};

    function init() {
        initBindings();
    }

    function initBindings() {
        $body.on('submit', 'form:not([data-native])', submitForm);
        $body.on('keydown', 'input[type="number"]', function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });

        $body.on('focus', 'form input, form textarea, form select', function () {
            var $this = $(this);
            APP.Analytics.trackEvent('form', 'focus', $this.parents('form').attr('action'), $this.attr('name'));
        });

        $body.on('change', '[data-toggle-list]', function () {
            var $this = $(this);

            $body.find('[data-toggle-item="' + $this.attr('data-toggle-list') + '"]').prop('checked', $this.prop('checked'));
        });

        $body.on('change', '[data-show-on-select]', function () {
            var $this = $(this);
            var res = $this.attr('data-show-on-select');

            $body.find('[data-id="' + res + '"]').css('display', 'block');
        });
    }

    function submitForm(event) {
        var $form = $(this),
            action = $form.attr('action'),
            data = $form.serialize(),
            key,
            formErrorOffset,
            callback = $form.attr('data-callback');

        event.preventDefault();
        event.stopPropagation();

        if (!action) {
            return;
        }

        if ($form.attr('data-submitting') !== 'true') {
            $form.attr('data-submitting', 'true');
        } else {
            return;
        }

        $form.find('.form--error-show').removeClass('form--error-show');

        APP.Analytics.trackFormSubmit(action, $form);
        APP.Ajax.load({
            type: $form.attr('method') || 'get',
            url: action,
            data: data,
            dataType: 'json'
        }).then(function (result) {
            if (result.success) {
                callback = getCallbackByName(callback);
                APP.Analytics.trackEvent('form', 'success', action);
                if (callback) {
                    callback(result);
                }
            } else {
                $body.find('.button--loading').removeClass('button--loading');
                APP.Analytics.trackEvent('form', 'fail', action, result);
                for (key in result.error) {
                    if (result.error.hasOwnProperty(key)) {
                        if (typeof result.error[key] === 'number') {
                            $form.find('[data-form-error="' + key + '"][data-form-error-id="' + result.error[key] + '"]')
                                .addClass('form--error-show');
                        } else {
                            $form.find('[data-form-error="' + key + '"]:not([data-form-error-id])').text(result.error[key]).addClass('form--error-show');
                            $form.find('[name="' + key + '"], [data-input-group="' + key + '"]').addClass('form--error-show');
                        }
                    }
                }
                formErrorOffset = $body.find('.form--error-show').offset();
                if (formErrorOffset) {
                    APP.Layout.scrollTo(formErrorOffset.top - 60);
                }
                if (result.error && result.error.hasOwnProperty('robot') && window.hasOwnProperty('grecaptcha')) {
                    window.grecaptcha.reset();
                }
            }
            setTimeout(function () {
                $form.attr('data-submitting', 'false');
            }, 1000);
        }, function () {
            $body.find('.button--loading').removeClass('button--loading');
            setTimeout(function () {
                $form.attr('data-submitting', 'false');
            }, 1000);
        });
    }

    function getCallbackByName(callbackName) {
        if (!callbackName) {
            return false;
        }

        // because of minify.
        switch (callbackName) {
            case 'APP.Page.reloadPage':
                return APP.Page.reloadPage;
            case 'APP.Premium.successWallOfLoveApply':
                return APP.Premium.successWallOfLoveApply;
            case 'APP.Premium.successPremiumSent':
                return APP.Premium.successPremiumSent;
            case 'APP.User.successComment':
                return APP.User.successComment;
            case 'APP.User.successAlert':
                return APP.User.successAlert;
            case 'APP.User.successPassReset':
                return APP.User.successPassReset;
            case 'APP.User.successInvitationRequest':
                return APP.User.successInvitationRequest;
            case 'APP.User.successInvitationUse':
                return APP.User.successInvitationUse;
            case 'APP.User.successLoggedIn':
                return APP.User.successLoggedIn;
            case 'APP.User.successUserSettings':
                return APP.User.successUserSettings;
            case 'APP.User.successPhoneSettings':
                return APP.User.successPhoneSettings;
            case 'APP.User.successSignUp':
                return APP.User.successSignUp;
            case 'APP.User.successAndReload':
                return APP.User.successAndReload;
            case 'APP.User.mailSent':
                return APP.User.mailSent;
            case 'APP.Pro.successBillingSettings':
                return APP.Pro.successBillingSettings;
            case 'APP.Pro.successSelectPayment':
                return APP.Pro.successSelectPayment;
            case 'APP.Pro.successActivationCode':
                return APP.Pro.successActivationCode;
            case 'APP.Pro.successActivationCodeModification':
                return APP.Pro.successActivationCodeModification;
            case 'APP.NewsFeed.reloadNewsFeedContent':
                return APP.NewsFeed.reloadNewsFeedContent;
            case 'APP.NewsFeed.redirectToGroup':
                return APP.NewsFeed.redirectToGroup;
            case 'APP.NewsFeed.groupSettingsSaved':
                return APP.NewsFeed.groupSettingsSaved;
            case 'APP.User.successPreRegistration':
                return APP.User.successPreRegistration;
            case 'APP.User.successEmailModification':
                return APP.User.successEmailModification;
            case 'APP.User.successDelete':
                return APP.User.successDelete;
            case 'APP.NewsFeed.successCodeConnect':
                return APP.NewsFeed.successCodeConnect;
            case 'APP.User.successForgottenEmailAdded':
                return APP.User.successForgottenEmailAdded;
            case 'APP.User.demoBooked':
                return APP.User.demoBooked;
            case 'APP.User.trialBooked':
                return APP.User.trialBooked;
            case 'APP.Locale.successUISettings':
                return APP.Locale.successUISettings;
            case 'APP.User.successGroupSubscription':
                return APP.User.successGroupSubscription;
            case 'APP.Group.successAction':
                return function () {
                    APP.Layout.closeOverlay();
                    APP.Layout.openOverlay('success-action');
                };
            case 'APP.Group.successGroupRegistration':
                return function (result) {
                    APP.Layout.closeOverlay();
                    APP.Layout.alert(result.message);
                };
            case 'APP.Forms.redirect':
                return function (result) {
                    APP.Page.applyPageByUrl(result.url);
                };
            default:
                return false;
        }
    }

    function customSelect(element) {
        new Choices(element, {
            shouldSort: false,
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: ''
        });
        if (element.classList.contains('math-font')) {
            element.parentElement.parentElement.classList.add('math-font');
        }
    }

    function searchSelect(element) {
        const FLAT_DOM_MASTER_LIST = [];
        const DOM_MASTER_LIST = [];
        const choices = new Choices(element, {
            shouldSort: false,
            searchEnabled: true,
            searchFloor: 0,
            searchResultLimit: 10000,
            noResultsText: window.TXT['learn.no_result'],
            noChoicesText: window.TXT['learn.no_result'],
            itemSelectText: '',
            searchPlaceholderValue: '🔍︎',
            searchChoices: false,
        });
        const myCustomFilter = function (item, searchTerm) {
            const lowerSearch = searchTerm.toLowerCase().trim();
            const label = item.label.toLowerCase();

            return label.includes(lowerSearch);
        };
        const eventHandler = function (event) {
            const searchTerm = event.target.value;

            choices.removeActiveItems();
            if (!searchTerm || searchTerm.trim() === '') {
                choices.setChoices(
                    DOM_MASTER_LIST,
                    'value', 'label', true
                );
            } else {
                choices.setChoices(
                    FLAT_DOM_MASTER_LIST.filter(item => myCustomFilter(item, searchTerm)),
                    'value', 'label', true
                );
            }
        };

        Array.from(element.children).forEach(child => {
            const tagName = child.tagName.toLowerCase();

            if (tagName === 'option') {
                if (child.value && child.value !== '') {
                    DOM_MASTER_LIST.push({
                        value: child.value,
                        label: child.label
                    });
                }
            } else if (tagName === 'optgroup') {
                const group = {
                    label: child.label,
                    choices: []
                };

                Array.from(child.children).forEach(option => {
                    if (option.value && option.value !== '') {
                        group.choices.push({
                            value: option.value,
                            label: option.label
                        });
                        FLAT_DOM_MASTER_LIST.push({
                            value: option.value,
                            label: option.label
                        });
                    }
                });
                if (group.choices.length > 0) {
                    DOM_MASTER_LIST.push(group);
                }
            }
        });

        if (choices.input) {
            choices.input.element.addEventListener('input', eventHandler, false);
            if (element.hasAttribute('data-goto-topic')) {
                choices.input.element.addEventListener('focus', eventHandler, false);
            }
            choices.setValue([
                {value: '-', label: element.getAttribute('data-placeholder'), disabled: true, selected: true}
            ]);
        }

    }

    exports.init = init;
    exports.searchSelect = searchSelect;
    exports.customSelect = customSelect;

    return exports;

})();

APP.Live = (function () {
    var exports = {},
        initialized = false,
        binded = false,
        observerBinded = false,
        socket,
        observer,
        observing = false,
        winId,
        ignoreScrollEvents,
        liveAllowed,
        s = (function (options) {
            var _self = this;

            _self.default_options = {
                selectors: ['id', 'tag', 'nthchild'],
                prefix_tag: true,
                attribute_blacklist: [],
                attribute_whitelist: [],
                quote_attribute_when_needed: false,
                id_blacklist: [],
                class_blacklist: []
            };

            _self.setOptions = function (options) {
                var key, results, val;
                if (options === null) {
                    options = {};
                }
                results = [];
                for (key in options) {
                    val = options[key];
                    if (_self.default_options.hasOwnProperty(key)) {
                        results.push(_self.options[key] = val);
                    } else {
                        results.push(void 0);
                    }
                }
                return results;
            };

            _self.isElement = function (element) {
                return !!((element !== null ? element.nodeType : void 0) === 1);
            };

            _self.getParents = function (element) {
                var current_element, result;
                result = [];
                if (_self.isElement(element)) {
                    current_element = element;
                    while (_self.isElement(current_element)) {
                        result.push(current_element);
                        current_element = current_element.parentNode;
                    }
                }
                return result;
            };

            _self.getTagSelector = function (element) {
                return _self.sanitizeItem(element.tagName.toLowerCase());
            };

            _self.sanitizeItem = function (item) {
                var characters;
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        return "\\" + (':'.charCodeAt(0).toString(16).toUpperCase()) + " ";
                    } else if (/[ !"#$%&'()*+,.\/;<=>?@\[\\\]^`{|}~]/.test(character)) {
                        return "\\" + character;
                    } else {
                        return escape(character).replace(/\%/g, '\\');
                    }
                });
                return characters.join('');
            };

            _self.sanitizeAttribute = function (item) {
                var characters;
                if (_self.options.quote_attribute_when_needed) {
                    return _self.quoteAttribute(item);
                }
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        return "\\" + (':'.charCodeAt(0).toString(16).toUpperCase()) + " ";
                    } else if (/[ !"#$%&'()*+,.\/;<=>?@\[\\\]^`{|}~]/.test(character)) {
                        return "\\" + character;
                    } else {
                        return escape(character).replace(/\%/g, '\\');
                    }
                });
                return characters.join('');
            };

            _self.quoteAttribute = function (item) {
                var characters, quotesNeeded;
                quotesNeeded = false;
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        quotesNeeded = true;
                        return character;
                    } else if (character === "'") {
                        quotesNeeded = true;
                        return "\\" + character;
                    } else {
                        quotesNeeded = quotesNeeded || (escape(character === !character));
                        return character;
                    }
                });
                if (quotesNeeded) {
                    return "'" + (characters.join('')) + "'";
                }
                return characters.join('');
            };

            _self.getIdSelector = function (element) {
                var id, id_blacklist, prefix, sanitized_id;
                prefix = _self.options.prefix_tag ? _self.getTagSelector(element) : '';
                id = element.getAttribute('id');
                id_blacklist = _self.options.id_blacklist.concat(['', /\s/, /^\d/]);
                if (!!id && _self.notInList(id, id_blacklist)) {
                    sanitized_id = prefix + ("#" + (_self.sanitizeItem(id)));
                    if (element.ownerDocument.querySelectorAll(sanitized_id).length === 1) {
                        return sanitized_id;
                    }
                }
                return null;
            };

            _self.notInList = function (item, list) {
                return !list.find(function (x) {
                    if (typeof x === 'string') {
                        return x === item;
                    }
                    return x.exec(item);
                });
            };

            _self.getClassSelectors = function (element) {
                var class_string, item, k, len, ref, result;
                result = [];
                class_string = element.getAttribute('class');
                if (class_string !== null) {
                    class_string = class_string.replace(/\s+/g, ' ');
                    class_string = class_string.replace(/^\s|\s$/g, '');
                    if (class_string !== '') {
                        ref = class_string.split(/\s+/);
                        for (k = 0, len = ref.length; k < len; k++) {
                            item = ref[k];
                            if (_self.notInList(item, _self.options.class_blacklist)) {
                                result.push("." + (_self.sanitizeItem(item)));
                            }
                        }
                    }
                }
                return result;
            };

            _self.getAttributeSelectors = function (element) {
                var a, attr, blacklist, k, l, len, len1, ref, ref1, ref2, result, whitelist;
                result = [];
                whitelist = _self.options.attribute_whitelist;
                for (k = 0, len = whitelist.length; k < len; k++) {
                    attr = whitelist[k];
                    if (element.hasAttribute(attr)) {
                        result.push("[" + attr + "=" + (_self.sanitizeAttribute(element.getAttribute(attr))) + "]");
                    }
                }
                blacklist = _self.options.attribute_blacklist.concat(['id', 'class']);
                ref = element.attributes;
                for (l = 0, len1 = ref.length; l < len1; l++) {
                    a = ref[l];
                    if (!((ref1 = a.nodeName, indexOf.call(blacklist, ref1) >= 0) || (ref2 = a.nodeName, indexOf.call(whitelist, ref2) >= 0))) {
                        result.push("[" + a.nodeName + "=" + (_self.sanitizeAttribute(a.nodeValue)) + "]");
                    }
                }
                return result;
            };

            _self.getNthChildSelector = function (element) {
                var counter, k, len, parent_element, prefix, sibling, siblings;
                parent_element = element.parentNode;
                prefix = _self.options.prefix_tag ? _self.getTagSelector(element) : '';
                if (parent_element !== null) {
                    counter = 0;
                    siblings = parent_element.childNodes;
                    for (k = 0, len = siblings.length; k < len; k++) {
                        sibling = siblings[k];
                        if (_self.isElement(sibling)) {
                            counter++;
                            if (sibling === element) {
                                return prefix + (":nth-child(" + counter + ")");
                            }
                        }
                    }
                }
                return null;
            };

            _self.testSelector = function (element, selector) {
                var is_unique, result;
                is_unique = false;
                if ((selector !== null) && selector !== '') {
                    result = element.ownerDocument.querySelectorAll(selector);
                    if (result.length === 1 && result[0] === element) {
                        is_unique = true;
                    }
                }
                return is_unique;
            };

            _self.testUniqueness = function (element, selector) {
                var found_elements, parent;
                parent = element.parentNode;
                found_elements = parent ? parent.querySelectorAll(selector) : [];
                return found_elements.length === 1 && found_elements[0] === element;
            };

            _self.testCombinations = function (element, items, tag) {
                var item, k, l, len, len1, len2, len3, m, n, ref, ref1, ref2, ref3;
                if (tag === null) {
                    tag = _self.getTagSelector(element);
                }
                if (!_self.options.prefix_tag) {
                    ref = _self.getCombinations(items);
                    for (k = 0, len = ref.length; k < len; k++) {
                        item = ref[k];
                        if (_self.testSelector(element, item)) {
                            return item;
                        }
                    }
                    ref1 = _self.getCombinations(items);
                    for (l = 0, len1 = ref1.length; l < len1; l++) {
                        item = ref1[l];
                        if (_self.testUniqueness(element, item)) {
                            return item;
                        }
                    }
                }
                ref2 = _self.getCombinations(items).map(function (item) {
                    return tag + item;
                });
                for (m = 0, len2 = ref2.length; m < len2; m++) {
                    item = ref2[m];
                    if (_self.testSelector(element, item)) {
                        return item;
                    }
                }
                ref3 = _self.getCombinations(items).map(function (item) {
                    return tag + item;
                });
                for (n = 0, len3 = ref3.length; n < len3; n++) {
                    item = ref3[n];
                    if (_self.testUniqueness(element, item)) {
                        return item;
                    }
                }
                return null;
            };

            _self.getUniqueSelector = function (element) {
                var k, len, ref, selector, selector_type, selectors, tag_selector;
                tag_selector = _self.getTagSelector(element);
                ref = _self.options.selectors;
                for (k = 0, len = ref.length; k < len; k++) {
                    selector_type = ref[k];
                    switch (selector_type) {
                        case 'id':
                            selector = _self.getIdSelector(element);
                            break;
                        case 'tag':
                            if (tag_selector && _self.testUniqueness(element, tag_selector)) {
                                selector = tag_selector;
                            }
                            break;
                        case 'class':
                            selectors = _self.getClassSelectors(element);
                            if ((selectors !== null) && selectors.length !== 0) {
                                selector = _self.testCombinations(element, selectors, tag_selector);
                            }
                            break;
                        case 'attribute':
                            selectors = _self.getAttributeSelectors(element);
                            if ((selectors !== null) && selectors.length !== 0) {
                                selector = _self.testCombinations(element, selectors, tag_selector);
                            }
                            break;
                        case 'nthchild':
                            selector = _self.getNthChildSelector(element);
                    }
                    if (selector) {
                        return selector;
                    }
                }
                return '*';
            };

            _self.getSelector = function (element) {
                var item, k, len, parents, result, selector, selectors;
                selectors = [];
                parents = _self.getParents(element);

                for (k = 0, len = parents.length; k < len; k++) {
                    item = parents[k];
                    selector = _self.getUniqueSelector(item);
                    if (selector !== null) {
                        selectors.unshift(selector);
                        result = selectors.join(' > ');
                        if (_self.testSelector(element, result)) {
                            return result;
                        }
                    }
                }
                return null;
            };

            _self.getCombinations = function (items) {
                var i, j, k, l, ref, ref1, result;
                if (items === null) {
                    items = [];
                }
                result = [[]];
                for (i = k = 0, ref = items.length - 1; 0 <= ref ? k <= ref : k >= ref; i = 0 <= ref ? ++k : --k) {
                    for (j = l = 0, ref1 = result.length - 1; 0 <= ref1 ? l <= ref1 : l >= ref1; j = 0 <= ref1 ? ++l : --l) {
                        result.push(result[j].concat(items[i]));
                    }
                }
                result.shift();
                result = result.sort(function (a, b) {
                    return a.length - b.length;
                });
                result = result.map(function (item) {
                    return item.join('');
                });
                return result;
            };

            // constructor:
            if (options === null) {
                options = {};
            }

            _self.options = {};
            _self.setOptions(_self.default_options);
            _self.setOptions(options);

            return _self;

        })(),
        $cursor,
        observerStopper,
        observerCounter = 0,
        pingTimer;

    function init() {
        if (!initialized) {
            initialized = true;
            $cursor = $body.find('[data-cursor]');
            if (window.WINID) {
                winId = window.WINID;
                setUpObserve();
                loadIo().then(setupIo);
            }
            $body.on('click', '[data-allow-live]', function () {
                liveAllowed = true;
                socket.emit('add-access', true);
            });
        } else {
            watchMetas();
        }
    }

    function watchMetas() {
        unsubscribeAllMetaChanges();
        $body.find('[data-live-template]').each(function () {
            var $this = $(this),
                $html,
                clientId = $this.attr('data-live-client'),
                singleBlock = $this.attr('data-live-client-type') === 'single',
                newMeta,
                onScreen,
                changed = false;

            subscribeMetaChanges(clientId, function (meta) {
                changed = true;
                newMeta = meta;
                onScreen = singleBlock || isOnScreen($this);
                if (onScreen) {
                    runCtx();
                } else {
                    $this.css('opacity', .33);
                }
            });

            $this.on('drawContext', function () {
                if (changed) {
                    runCtx();
                }
            });

            function runCtx() {
                var meta = JSON.parse(newMeta.value || '{}');

                APP.ProblemWorker.run($this.attr('data-live-template'), meta).then(function (html) {
                    if (meta.closed || $this.find('[data-live-client-block]').length === 0) {
                        $this.html(html);
                        if(singleBlock) {
                            $this.find('[data-live-client-block-type="list"]').remove();
                        } else {
                            $this.find('[data-live-client-block-type="single"]').remove();
                        }
                    } else {
                        $html = $(html);
                        $html.find('[data-live-client-block]').each(function () {
                            var $block = $(this),
                                stamp = $block.attr('data-live-client-stamp'),
                                index = $block.attr('data-live-client-block'),
                                $oldBlock = $this.find('[data-live-client-block="' + index + '"]'),
                                oldStamp = $oldBlock.attr('data-live-client-stamp');

                            if (stamp !== oldStamp) {
                                $oldBlock.replaceWith($block);
                            }
                        });
                    }
                    APP.Formula.fillFormulas($this);
                    APP.Formula.cosmeticFormulaByWrapper($this);
                    APP.Layout.setMoments();
                    $this.css('opacity', 1);
                });
            }
        });

        window.addEventListener('scroll', function () {
            $body.find('[data-live-template]:not([data-live-client-type="single"])').each(function () {
                var $this = $(this);

                if (isOnScreen($this)) {
                    $this.trigger('drawContext');
                }
            });
        }, true);
    }

    function loadIo() {
        var script;

        return new Promise(function (resolve, reject) {
            script = document.createElement('script');
            script.onload = resolve;
            script.onerror = reject;
            script.src = '/socket.io/socket.io.js';
            document.body.appendChild(script);
        });
    }

    function setupIo() {
        socket = window.io(document.location.origin, {
            transports: ['websocket']
        });
        socket.on('hello', function () {
            clearTimeout(observerStopper);
            socket.emit('hello', winId);
            if (!binded) {
                socket.on('start-live', observe);
                socket.on('finish-live', ignore);
                socket.on('client-event', onClientEvent);
                binded = true;
            } else {
                sendClientContents();
            }
            saveClientMeta('focus', true);
            sendMetas();
            watchMetas();
        });
    }

    function sendMetas() {
        var metaArray = [];

        if ($body.find('[data-live-meta="problem.instruction"]').length) {
            metaArray.push('problemInstruction');
            metaArray.push($body.find('[data-live-meta="problem.instruction"]').val());
            metaArray.push('problemClone');
            metaArray.push($body.find('[data-live-meta="problem.clone"]').val());
            metaArray.push('problemSolutionLink');
            metaArray.push('');
        } else {
            metaArray.push('problemInstruction');
            metaArray.push('');
            metaArray.push('problemClone');
            metaArray.push('');
            metaArray.push('problemSolutionLink');
            metaArray.push('');
        }
        metaArray.push('url');
        metaArray.push(document.location.href);
        metaArray.push('title');
        metaArray.push(document.title);
        metaArray.push('historyId');
        metaArray.push($body.find('[name="lesson-history-id"]').val() || '');
        metaArray.push('examId');
        metaArray.push($body.find('[name="exam-id"]').val() || '');
        metaArray.push('examNth');
        metaArray.push($body.find('[name="exam-nth"]').val() || '');
        saveClientMeta(metaArray);
    }

    function setUpObserve() {
        var changes;

        observer = new MutationObserver(function (mutationList) {
            mutationList.forEach(function (mutation) {
                changes = processMutation(mutation);
                if (changes.length > 0) {
                    socket.emit('change', changes);
                }
            });
        });
    }

    function processMutation(mutation) {
        var changes = [],
            val,
            selector;

        switch (mutation.type) {
            case 'childList':
                selector = s.getSelector(mutation.target);
                if (selector) {
                    changes.push([selector, 'html', mutation.target.innerHTML]);
                }
                break;
            case 'attributes':
                val = mutation.target.getAttribute(mutation.attributeName);
                if (mutation.attributeName && mutation.oldValue !== val && (mutation.attributeName !== 'id' && val !== null)) {
                    selector = s.getSelector(mutation.target);
                    if (selector) {
                        changes.push([selector, 'attr', mutation.attributeName, val]);
                    }
                }
                break;
            case 'characterData':
                selector = s.getSelector(mutation.target);
                if (selector) {
                    changes.push([selector, 'text', mutation.target.textContent]);
                }
                break;
        }

        return changes;
    }

    function observe() {
        observerCounter++;
        clearTimeout(observerStopper);
        sendClientContents();

        if (!observing) {
            observing = true;
            observer.observe(window.document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
                attributeOldValue: true
            });

            if (!observerBinded) {
                observerBinded = true;
                window.addEventListener('scroll', function (event) {
                    if (observing) {
                        if (ignoreScrollEvents) {
                            ignoreScrollEvents = false;
                            return;
                        }
                        if (!event.target.parentElement) {
                            socket.emit('scroll', [window.scrollX, window.scrollY]);
                        } else {
                            socket.emit('scroll', [event.target.scrollLeft, event.target.scrollTop, s.getSelector(event.target)]);
                        }
                    }
                }, true);

                window.addEventListener('resize', function () {
                    if (observing) {
                        socket.emit('resize', [window.innerWidth, window.innerHeight]);
                    }
                });

                window.addEventListener('mousemove', function (event) {
                    if (observing) {
                        socket.emit('mousemove', [event.pageX - window.scrollX, event.pageY - window.scrollY]);
                    }
                });

                window.addEventListener('input', function (event) {
                    if (observing) {
                        socket.emit('input', [
                            s.getSelector(event.target),
                            event.target.getAttribute('type') !== 'password' ? event.target.value : ('*').repeat(event.target.value.length)
                        ]);
                    }
                }, true);
            }
        }
    }

    function sendClientContents() {
        if (socket) {
            socket.emit('resize', [window.innerWidth, window.innerHeight]);
            socket.emit('body', window.document.body.outerHTML);
            socket.emit('scroll', [window.scrollX, window.scrollY]);
            socket.emit('change', [['html', 'attr', 'class', $('html').attr('class')]]);
        } else {
            setTimeout(sendClientContents, 1000);
        }
    }

    function ignore() {
        observerCounter--;
        $cursor.css({display: 'none'});
        observerStopper = setTimeout(function () {
            if (observing && !observerCounter) {
                observing = false;
                observer.disconnect();
            }
        }, 15000);
    }

    function onClientEvent(e) {
        var event = e.event,
            message = e.message;

        clearTimeout(observerStopper);
        if (!liveAllowed) {
            if (event === 'live-access') {
                $body.find('[data-access-name]').text(message);
                APP.Layout.openOverlay('live-access');
            }
            return;
        }

        switch (event) {
            case 'mousemove':
                $cursor.css({
                    display: 'block',
                    left: message[0] + 'px',
                    top: message[1] + 'px',
                });
                break;
            case 'click':
                var element = document.elementFromPoint(message[0], message[1]);
                if (element) {
                    element.click();
                }
                break;
            case 'scroll':
                if (message.length > 2) {
                    scrollTo(document.querySelector(message[2]), message[0], message[1]);
                } else if (message.length === 2) {
                    scrollTo(window, message[0], message[1]);
                }
                break;
            case 'input':
                document.querySelector(message[0]).value = message[1];
                break;
        }
    }

    function scrollTo(element, x, y) {
        ignoreScrollEvents = true;
        element.scrollTo(x, y);
    }

    function saveClientMeta(key, value) {
        clearTimeout(pingTimer);
        if (socket) {
            if (arguments.length === 1) {
                socket.emit('client-metas', key);
            } else {
                socket.emit('client-meta', {
                    key: key,
                    value: typeof value === 'object' ? JSON.stringify(value) : value
                });
            }
            pingTimer = setTimeout(ping, 1000 * 60 * 2);
        } else {
            setTimeout(function () {
                if (arguments.length === 1) {
                    saveClientMeta(key);
                } else {
                    saveClientMeta(key, value);
                }
            }, 1000);
        }
    }

    function subscribeMetaChanges(clientId, callback) {
        if (socket) {
            clientId = clientId.replace(/winId-/g, '');
            socket.emit('subscribeMetaChanges', {clientId: clientId});
            socket.on('clientMetaChange-' + clientId, callback);
        } else {
            setTimeout(function () {
                subscribeMetaChanges(clientId, callback);
            }, 1000);
        }
    }

    function subscribeUserEvent(userId, callback) {
        if (socket) {
            socket.on('user-event', callback);
        } else {
            setTimeout(function () {
                subscribeUserEvent(userId, callback);
            }, 1000);
        }

    }

    function unsubscribeAllMetaChanges() {
        if (socket) {
            socket.emit('unsubscribeAllMetaChanges');
        } else {
            setTimeout(unsubscribeAllMetaChanges, 1000);
        }
    }

    function isOnScreen($element) {
        return $element.offset().top >= window.scrollY + 52;
    }

    function ping() {
        saveClientMeta('ping', 1);
    }

    function sendMessageToAllClient() {
        // TODO: make it!
    }

    exports.init = init;
    exports.saveClientMeta = saveClientMeta;
    exports.subscribeMetaChanges = subscribeMetaChanges;
    exports.unsubscribeAllMetaChanges = unsubscribeAllMetaChanges;
    exports.sendMetas = sendMetas;
    exports.watchMetas = watchMetas;
    exports.subscribeUserEvent = subscribeUserEvent;

    return exports;

})();

APP.Page = (function () {
    var exports = {},
        $pageBody,
        interPageUrl;

    function init() {
        $pageBody = $body.find('#body');
        initBindings();
        setUpNotAjaxState();
        if (typeof onPageReady !== 'undefined') {
            requestAnimationFrame(onPageReady);
        }
    }

    function setUpNotAjaxState() {
        var data = {
            title: $('title').text(),
            url: document.location.pathname + document.location.search + document.location.hash,
            body: $('#body').html(),
            pageType: $('meta[name="akriel-page-type"]').attr('content')
        };

        try {
            window.history.replaceState(data, data.title, data.url);
            if (document.location.hash) {
                pageLoaded($(document.location.hash));
            }

        } catch (e) {
            console.warn(e);
        }
    }

    function initBindings() {
        var ignoreSelection = '[href="#void"], [href*="://"],[target="_blank"],[href^="#"],[href^="mailto:"],[data-enable-href]';
        $body.on('click', 'a[href]:not(' + ignoreSelection + ')', function (event) {
            var $this = $(this);
            if ($this.attr('data-prevent-default') !== 'false') {
                event.preventDefault();
            }
            clickOnElement($this);
        });

        $body.on('click', 'a[href="#void"]', function (event) {
            event.preventDefault();
        });

        virtualKeyboardDetector.init();

        window.onpopstate = function (event) {
            if (event.state) {
                applyPageByUrl(event.state.url, true).then(APP.KeepScroll.init);
            }
        };
    }

    function clickOnElement($element) {
        applyPageByUrl($element.attr('href'));
    }

    function applyPageByUrl(pageUrl, noPushState) {
        return new Promise(function (resolve) {
            if (interPageUrl) {
                var url = interPageUrl.replace('{0}', pageUrl);
                interPageUrl = false;
                applyPageByUrl(url, noPushState).then(resolve);
            } else {
                APP.Ajax.get(pageUrl).then(function (html) {
                    applyPageByHtml(html, pageUrl, noPushState);
                    if (pageUrl.indexOf('#') > -1) {
                        pageLoaded($(document.getElementById(pageUrl.split('#')[1])));
                    }
                    resolve();
                }, function (err) {
                    console.log('applyPageByUrl error', err);
                });
            }
        });
    }

    function applyPageByHtml(pageContent, url, noPushState) {
        var page = document.createElement('html'),
            data;

        APP.Live.saveClientMeta('input', '');
        page.innerHTML = pageContent;
        data = {
            title: $('title', page).text(),
            url: url,
            body: $('#body', page).html(),
            pageType: $('meta[name="akriel-page-type"]', page).attr('content')
        };
        applyPageByData(data, noPushState);
        APP.Live.sendMetas();
    }

    function applyPageByData(data, noPushState) {
        if (!noPushState) {
            try {
                window.history.pushState(data, data.title, data.url);
            } catch (e) {
                console.warn(e);
            }
        }

        document.title = data.title;

        if (!data.target) {
            async(APP.Calculator.Keyboard.hide);
            APP.Layout.closeOverlay();
            $pageBody.html(data.body);
            setPageClass(data.pageType);
            pageLoaded($pageBody, noPushState);
        } else {
            $body.find(data.target).html(data.body);
        }

        APP.Initializer.init();
    }

    function setPageClass(pageClass) {
        var prefix = 'page--',
            app = $body.find('.application')[0],
            classes = app.className.split(' ').filter(function (c) {
                return c.lastIndexOf(prefix, 0) !== 0;
            });

        app.className = $.trim(classes.join(' '));
        if (pageClass) {
            $(app).addClass('page--' + pageClass);
        }
    }

    function pageLoaded($target, preventScroll) {
        requestAnimationFrame(function () {
            APP.Calculator.Keyboard.hide(true);
            if ($target.selector === '#body') {
                if (
                    $body.find('[data-auto-input-scroll-top]').length === 0 &&
                    document.location.pathname.indexOf('/en-US/learn') !== 0 &&
                    !preventScroll
                ) {
                    APP.Layout.scrollTo(0, 100);
                }
            } else if ($target.length) {
                APP.Layout.scrollTo($target.offset().top - 60);
            }
            if (typeof onPageReady !== 'undefined') {
                requestAnimationFrame(onPageReady);
            }
        });
    }

    function getContentOfUrl(url, selector, callback, innerHtml) {
        APP.Ajax.get(url).then(function (html) {
            var page = document.createElement('html'),
                found;

            page.innerHTML = html;
            found = $(selector, page)[0];

            if (found) {
                if (innerHtml) {
                    callback(found.innerHTML);
                } else {
                    callback(found.outerHTML);
                }
            }
        }, window.NOOP);
    }

    function reloadPage() {
        applyPageByUrl(document.location.href);
    }

    function refreshPage() {
        document.location.reload();
    }

    function reloadPageSilence() {
        var pageUrl = document.location.href;

        APP.Ajax.get(pageUrl, true).then(function (html) {
            applyPageByHtml(html, pageUrl, true);
        }, window.NOOP);
    }

    function isDevice() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

        var mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    function hasVirtualKeyboard() {
        return isDevice() && (localStorage.hasKeyboardVirtual || !localStorage.hasKeyboardHardwer);
    }

    function addInterPage(url) {
        if (url.indexOf('{0}') > -1) {
            interPageUrl = url;
        }
    }

    exports.init = init;
    exports.getContentOfUrl = getContentOfUrl;
    exports.applyPageByUrl = applyPageByUrl;
    exports.reloadPage = reloadPage;
    exports.refreshPage = refreshPage;
    exports.reloadPageSilence = reloadPageSilence;
    exports.isDevice = isDevice;
    exports.hasVirtualKeyboard = hasVirtualKeyboard;
    exports.addInterPage = addInterPage;
    return exports;

})();

APP.User = (function () {
    var exports = {},
        initialized = false,
        ref,
        amIPro,
        amLoggedIn,
        $application,
        previousUserId,
        previousAmIPro,

        userId;

    function init() {
        userId = $body.find('[data-akriel-user-id]').attr('data-akriel-user-id');

        $application = $body.find('.application');
        initInvitationPageBindings();
        initSubscriptionEmailChecker();

        if (!initialized) {
            previousUserId = userId;
            amIPro = $application.hasClass('user--pro');
            amLoggedIn = $application.hasClass('user--logedin');
            initialized = true;
            initBindings();
            setSettingsCheckbox();
            userId && sendDataToServiceWorker(userId);
        }

        handleUserAccountSwitch();
        if (ref = window.queryDecode()['ref']) {
            setReferral(ref);
        }

        setUTM();
        initReferral();
    }

    function sendDataToServiceWorker(userId) {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.register(document.location.origin + '/en-US/sw.js')
                .then(() => sendUserIdToServiceWorker(userId));
        }
    }

    function sendUserIdToServiceWorker(userId) {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage(userId);
            return;
        }
        navigator.serviceWorker.ready.then(registration => {
            if (registration.active) {
                registration.active.postMessage(userId);
            }
        });
    }

    function initBindings() {
        $body.on('click', '[data-send-verification-email]', function () {
            $.ajax({
                'type': 'POST',
                'url': '/en-US/service/user-verification',
                'data': {id: $(this).attr('data-send-verification-email')},
                'dataType': 'json'
            }).then(function (result) {
                APP.Layout.openOverlay(result.success ? 'success-resend' : 'failed-resend');
            });

        });

        $body.on('click', '[data-submit-loading]', function () {
            $(this).addClass('button--loading');
        });

        $body.on('change', '[data-user-setting-checkbox]', function () {
            var $this = $(this),
                checked = $this.prop('checked');

            setSetting($this.attr('data-user-setting-checkbox'), $this.attr('data-negate') ? !checked : checked);
        });
        $body.on('click', '[data-user-setting-true]', function () {
            var $this = $(this);

            setSetting($this.attr('data-user-setting-true'), true);
        });

        $body.on('click', '[data-activation-submit]', function () {
            APP.Page.applyPageByUrl('/en-US/pro/activate/' + $body.find('[data-activation-code]').val())
        });

        $body.on('click', '[data-activate-free]', function () {
            var $this = $(this);

            activateFree($this.attr('data-activate-free'), $this.attr('data-activation-code'));
        });

        $body.on('click', '[data-generate-new-group-code]', function () {
            var $this = $(this),
                id = $this.attr('data-generate-new-group-code');

            APP.Ajax.post('/en-US/service/group/new-group-code/' + $this.attr('data-generate-new-group-code'))
                .then(function (result) {
                    if (result.success) {
                        APP.Page.applyPageByUrl('/en-US/group/' + id);
                    } else {
                        APP.Layout.openOverlay('generate-new-group-code-error');
                    }
                }, function () {
                    APP.Layout.openOverlay('generate-new-group-code-error');
                });
        });
    }

    function setSettingsCheckbox() {
        if (window.USER_SETTINGS) {
            $body.find('[data-user-setting-checkbox]').each(function () {
                var $this = $(this),
                    checked = window.USER_SETTINGS[$this.attr('data-user-setting-checkbox')];

                $this.prop('checked', $this.attr('data-negate') ? !checked : checked);
            });
        }
    }

    function initInvitationPageBindings() {
        if ($body.find('[data-invitation-page]').length > 0) {
            var formOpen = false,
                $accordionForm = $body.find('[data-invitation-accordion="form"]'),
                $accordionMoreItem = $body.find('[data-invitation-accordion="more-item"]'),
                $selectRequestCont = $body.find('[data-invitation-request-count]'),
                $sendRequest = $body.find('[data-invitation-request]'),
                $overlay = $body.find('[data-overlay="use-invitation"]');

            $selectRequestCont.on('change', function () {
                if ($selectRequestCont.val() === '0') {
                    $accordionMoreItem.addClass('open');
                } else {
                    $accordionMoreItem.removeClass('open');
                }
            });

            $sendRequest.on('click', function () {
                if (!formOpen) {
                    formOpen = true;
                    $accordionForm.addClass('open');
                } else {
                    $accordionForm.submit();
                }
            });

            $body.find('[data-use-invitation]').on('click', function () {
                $overlay.addClass('overlay--show');
                $overlay.find('[name="code"]').val($(this).attr('data-use-invitation'));
            });
        }
    }

    function initSubscriptionEmailChecker() {
        var $mailChecker = $body.find('[data-mail-check]'),
            $error = $body.find('[data-form-error="mail-checker"]'),
            oldMail,
            name,
            newMail;

        if ($mailChecker.length > 0) {
            $mailChecker.on('click', function () {
                newMail = $body.find('[data-checking-mail]').val();
                oldMail = decodeURIComponent(window.getCookie('email'));
                name = decodeURIComponent(window.getCookie('name'));
                $error.removeClass('form--error-show');

                APP.Ajax.post('/en-US/service/subscribe', {
                    url: window.document.location.pathname,
                    name: name,
                    email: newMail
                }).then(function (result) {
                    if (result.success) {
                        APP.Layout.closeOverlay();
                        if (oldMail === newMail) {
                            APP.Layout.openOverlay('email-not-arrived-3');
                        } else {
                            APP.Layout.openOverlay('email-not-arrived-4');
                        }
                    } else {
                        $error.text(result.error.email);
                        $error.addClass('form--error-show');
                    }
                }, window.NOOP);
            });
        }
    }

    function activateFree(id, code) {
        APP.Ajax.post('/en-US/service/pro/activate-free/', {
            id: id,
            code: code
        }).then(function (result) {
            if (result.success) {
                APP.Layout.openOverlay('success-activation');
            } else {
                APP.Layout.openOverlay('failed-activation');
            }
            APP.Layout.onOverlayClose(function () {
                APP.Page.applyPageByUrl('/en-US/dashboard');
            });
        }, () => {
            APP.Layout.openOverlay('failed-activation');
        });

    }

    function successInvitationRequest() {
        $body.find('[data-invitation-accordion]').removeClass('open');
        $body.find('[data-invitation-accordion="success"]').addClass('open');
    }

    function successLoggedIn(data) {
        if (data.verified) {
            var pathParts = window.location.pathname.split('/').filter(function (part) {
                return part.length > 0;
            });

            pathParts[0] = data.language;
            window.location.href = '/' + (pathParts.join('/') + '/?login=true');
        } else {
            window.location.href = '/' + data.language + '/user/verify';
        }
    }

    function successEmailModification() {
        window.location.href = '/en-US/user/verify';
    }

    function successForgottenEmailAdded() {
        APP.Page.applyPageByUrl('/en-US/user/forgotten-password/sent/' + $body.find('[data-forgotten-email]').val());
    }

    function successSignUp() {
        APP.Page.applyPageByUrl($body.find('[data-success-url]').attr('data-success-url'));
    }

    function successSignUpConfirm() {
        window.location.href = '/en-US/?signup=true';
    }

    function successInvitationUse() {
        window.location.href = '?invited=true';

    }

    function successDelete() {
        APP.Layout.openOverlay('success-delete-user');
        APP.Layout.onOverlayClose(function () {
            window.location.href = '/en-US/?deleted=true';
        });
    }

    function successGroupSubscription() {
        APP.Layout.openOverlay('activate-group-success');
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl('/en-US/group/' + $body.find('[name="group-id"]').val());
        });
    }

    function mailSent() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            var redirectUrl = $body.find('[data-redirect-url]').val() || '/en-US/dashboard';
            APP.Page.applyPageByUrl(redirectUrl);
        });
    }

    function demoBooked() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            window.location.reload();
        });
    }

    function trialBooked() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl('/en-US/dashboard');
        });
    }

    function successAndReload() {
        window.location.reload();
    }

    function successComment() {
        APP.Layout.closeOverlay();
        APP.Layout.alert($body.find('[data-comment-succes-message]').attr('data-comment-succes-message'));
        $body.find('[data-overlay="problem-comment"] textarea[name="comment"]').val('');
    }

    function successAlert() {
        APP.Layout.alert($body.find('[data-succes-message]').attr('data-succes-message'));
    }

    function successPassReset() {
        APP.Layout.openOverlay('success-pass-reset');
        APP.Layout.onOverlayClose(function () {
            document.location.href = '/en-US/';
        });
    }

    function successUserSettings() {
        APP.Layout.openOverlay('success-user-settings');
        APP.Layout.onOverlayClose(() => APP.Page.refreshPage());
    }

    function successPhoneSettings() {
        document.location.href = '/?signup=true';
    }

    function setSetting(property, value) {
        window.USER_SETTINGS[property] = value;
        setSettingsCheckbox();
        APP.Analytics.trackEvent('userSettins', 'set', property, value);
        if (property === 'proHeader') {
            if (value === true) {
                $body.find('[data-header]').addClass('header--pro');
            } else {
                $body.find('[data-header]').removeClass('header--pro');
            }
        }
        return $.ajax({
            'type': 'POST',
            'url': '/en-US/service/user-set-settings',
            'data': {
                key: property,
                value: value
            },
            'dataType': 'json'
        });
    }

    function setReferral(referral) {
        window.setCookie('referral', encodeURIComponent(referral));
    }

    function setUTM() {
        var utm = {},
            hasUTM = false,
            query = window.queryDecode();

        Object.keys(query).forEach(function (key) {
            if (key.indexOf('utm') === 0) {
                utm[key] = query[key];
                hasUTM = true;
            }
        });

        if (hasUTM) {
            window.setCookie('UTM', encodeURIComponent(JSON.stringify(utm)));
        }
    }

    function initReferral() {
        $body.find('[data-referral-id]').val(window.getCookie('referral'));
        $body.find('[data-utm]').val(decodeURIComponent(window.getCookie('UTM')));
    }

    function successPreRegistration(data) {
        APP.Page.applyPageByUrl(
            '/en-US/user/sign-up/select-plan/' +
            window.base64Encode(JSON.stringify(data))
        );
    }

    function setUserPro(isPro, hasNotified) {
        previousAmIPro = amIPro;
        amIPro = isPro;

        if (!hasNotified && isPro) {
            APP.Layout.openOverlay('pro-activated');
            APP.Layout.onOverlayClose(function () {
                $.ajax({
                    'type': 'POST',
                    'url': '/en-US/service/user/state-change',
                    'data': {
                        method: 'notified-pro'
                    },
                    'dataType': 'json'
                });
            });
        }
    }

    window.setUserPro = setUserPro;

    function handleUserProChange() {
        if (amIPro) {
            $application.addClass('user--pro');
        } else {
            $application.removeClass('user--pro');
            APP.Layout.openOverlay('pro-deactivated');
        }
    }

    function handleUserAccountSwitch() {
        var actualUserId = $body.find('[data-akriel-user-id]').attr('data-akriel-user-id');

        if (actualUserId !== previousUserId) {
            previousUserId = actualUserId;
            if (actualUserId.length > 0) {
                if (amLoggedIn) {
                    APP.Layout.openOverlay('user-account-logged-in-other-user');
                    APP.Layout.onOverlayClose(function () {
                        document.location.reload();
                    });
                }
            } else {
                APP.Layout.openOverlay('user-account-logged-out');
                APP.Layout.onOverlayClose(function () {
                    document.location.reload();
                });
            }
        } else if (actualUserId === previousUserId && previousAmIPro !== amIPro && previousAmIPro !== undefined) {
            handleUserProChange();
        }
    }

    function getUserId() {
        return userId;
    }

    window.setUserSetting = setSetting;

    exports = {
        init: init,
        setSetting: setSetting,
        successLoggedIn: successLoggedIn,
        successSignUp: successSignUp,
        successSignUpConfirm: successSignUpConfirm,
        successInvitationRequest: successInvitationRequest,
        successInvitationUse: successInvitationUse,
        successAndReload: successAndReload,
        successComment: successComment,
        successAlert: successAlert,
        successPassReset: successPassReset,
        successUserSettings: successUserSettings,
        successPhoneSettings: successPhoneSettings,
        successPreRegistration: successPreRegistration,
        successEmailModification: successEmailModification,
        successForgottenEmailAdded: successForgottenEmailAdded,
        setUserPro: setUserPro,
        successDelete: successDelete,
        successGroupSubscription: successGroupSubscription,
        mailSent: mailSent,
        demoBooked: demoBooked,
        trialBooked: trialBooked,
        getUserId: getUserId
    };

    return exports;

})();

APP.Decor = (function () {
    var exports = {},
        initialized = false,
        targetX = 0,
        targetY = 0,
        map = {
            s1: {
                x: 0,
                y: 0
            },
            s2: {
                x: 0,
                y: 0
            },
            s3: {
                x: 0,
                y: 0
            },
            s4: {
                x: 0,
                y: 0
            }
        },
        w = window.innerWidth,
        h = window.innerHeight,
        scrollTimer,
        $gifImages;

    function init() {
        w = window.innerWidth;
        h = window.innerHeight;
        map.s1.e = $body.find('.decoration--active .decoration__bg--1');
        map.s2.e = $body.find('.decoration--active .decoration__bg--2');
        map.s3.e = $body.find('.decoration--active .decoration__bg--3');
        map.s4.e = $body.find('.decoration--active .decoration__bg--4');

        if (!initialized) {
            initialized = true;
            animate();
            initBindings();
        } else {
            $gifImages = $body.find('img[data-bg]');
            setVisibility();
        }
    }

    function initBindings() {
        document.addEventListener('mousemove', function (event) {
            var x = event.clientX - (w / 2),
                y = event.clientY - (h / 2);
            targetX = x * 0.21;
            targetY = y * 0.21;
        });

        $body.on('click', '[data-splash] [data-more-testimonial]', function () {
            $(this).hide();
            $body.find('[data-hidden-testiomonials]').show();
        });

        bindVisibility();
    }

    function bindVisibility() {
        $gifImages = $body.find('img[data-bg]');
        $window.on('scroll.decor', setVisibility);
        setVisibility();
    }

    function setVisibility() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
            $gifImages.each(function () {
                var $this = $(this);
                if ($this.visible(true)) {
                    $this.removeClass('passive');
                } else {
                    $this.addClass('passive');
                }
            });
        }, 80);
    }

    function animate() {
        var originalS4 = map.s4.y;

        map.s4.x += (targetX - map.s4.x) / 9;
        map.s4.y += (targetY - map.s4.y) / 9;
        if (originalS4.toFixed(3) !== map.s4.y.toFixed(3)) {
            map.s1.x += (targetX - map.s1.x) / 6;
            map.s1.y += (targetY - map.s1.y) / 6;
            map.s2.x += (targetX - map.s2.x) / 7;
            map.s2.y += (targetY - map.s2.y) / 7;
            map.s3.x += (targetX - map.s3.x) / 8;
            map.s3.y += (targetY - map.s3.y) / 8;
            updateStyle();
        }
        window.requestAnimationFrame(animate);
    }

    function updateStyle() {
        if (map.s1.e.length > 0) {
            map.s1.e.css('transform', 'translate3d(' + (0 - map.s1.x) + 'px, ' + (0 - map.s1.y) + 'px, 0)');
            map.s2.e.css('transform', 'translate3d(' + (0 - map.s2.x) + 'px, ' + (0 - map.s2.y) + 'px, 0)');
            map.s3.e.css('transform', 'translate3d(' + (0 - map.s3.x) + 'px, ' + (0 - map.s3.y) + 'px, 0)');
            map.s4.e.css('transform', 'translate3d(' + (0 - map.s4.x) + 'px, ' + (0 - map.s4.y) + 'px, 0)');
        }
    }

    exports.init = init;
    return exports;

})();
APP.Error = (function () {

    var initialized = false,
        exports = {},
        errors = [],
        $notification,
        $offlineNotification;

    function init() {
        if (!initialized) {
            initialized = true;
            putToDom();
            initBindings();
            window.addEventListener('error', function (e) {
                showError(e);
                // logError(e.error);
                return false;
            });
            checkOnLineStatus();
        }
    }

    function checkOnLineStatus() {
        if (!window.navigator.onLine) {
            $offlineNotification.addClass('offline-notification--show');
        } else {
            $offlineNotification.removeClass('offline-notification--show');
        }
        setTimeout(checkOnLineStatus, 1000);
    }

    function putToDom() {
        var $container = $body.find('#notification-container');
        $container.html(APP.Tpl.run('error-notification', null));
        $notification = $container.find('[data-error-notification]');
        $offlineNotification = $container.find('[data-offline-notification]');
    }

    function initBindings() {
        $notification.find('[data-close-error-notification]').on('click', hideErrorNotification);
    }

    function hideErrorNotification() {
        $notification.removeClass('error-notification--show');
    }

    function showError(error) {
        logError(error);
        if (false && window.navigator.onLine && (error || {}).readyState !== 0) {
            $notification.addClass('error-notification--show');
        }
    }

    function errorToString(error) {
        var object = {};

        if(typeof error === 'string') {
            return error;
        }

        try {
            Object.getOwnPropertyNames(error).forEach(function (key) {
                object[key] = error[key];
            });
            return JSON.stringify(object);
        } catch (e) {
            return error && error.toString();
        }
    }

    function logError(error) {
        console.log('> error', error);
        APP.Ajax.post('/en-US/service/log-client-error', {
            error: errorToString(error),
            url: document.location.href
        }, true).then(window.NOOP, window.NOOP);
        if (window.posthog) {
            window.posthog.captureException(error, {
                url: document.location.href
            });
        }
    }

    exports.init = init;
    exports.showError = showError;
    return exports;

})();
APP.Learn = (function () {
    var exports = {},
        initialized = false,
        $answerOverlay,
        $answersWrapper,
        isChecking,
        soundFiles = [
            'show-star',
            'show-medal',
            'show-cup',
            'hide-star',
            'hide-medal',
            'hide-cup',
            'okay',
            'fail'
        ],
        sounds = {},
        preCheckResult,
        lastSolution;

    var hasFailed = false;

    function init() {
        $answerOverlay = $body.find('[data-overlay="learn-answer"]');
        $answersWrapper = $body.find('[data-previous-good-answers]');
        if ($answerOverlay.length > 0) {
            initSounds();
        }
        initBindings();
        initialized = true;
        lastSolution = false;
        $body.find('[data-doodle-formula-preview]').html(
            '<div data-f="' +
            $body.find('[data-learn-sample]').attr('data-f') +
            '"><div data-f-content></div></div>'
        );
        // APP.Formula.fillFormulas();
        if (document.location.hash) {
            var hash = document.location.hash,
                $anchorElement = $body.find('[data-learn-anchor="' + hash.replace('#', '') + '"]');

            if (hash.indexOf('#topic-') === 0) {
                $anchorElement = $body.find('[data-topic-card="' + hash.replace('#topic-', '') + '"]');
            }

            if ($anchorElement && $anchorElement.offset()) {
                requestAnimationFrame(function () {
                    APP.Layout.scrollTo($anchorElement.offset().top - 60, 0);
                });
            }
        }

        if ($body.find('[name="question-id"]').length > 0) {
            preCheckProblem($body.find('[name="question-id"]').val());
        }


        setTimeout(function () {
            if ($body.find('[data-auto-input-scroll-top]').length > 0) {
                APP.Layout.scrollTo($body.find('[data-auto-input-scroll-top]').offset().top - 60, 0);
            }
            if ($body.find('[data-auto-open-input]').length > 0 && !APP.Page.isDevice()) {
                APP.Calculator.Keyboard.focus();
            }
        }, 120);

    }

    function initBindings() {
        $body.find('[data-learn]').on('click', function (event) {
            var $this = $(this),
                solutions = $this.attr('data-learn-solutions');

            event.stopPropagation();
            event.preventDefault();

            if (solutions === '_' || solutions === '_0') {
                $body.find('[data-no-solution-link]').attr('href', '/en-US/learn/question/' + $this.attr('data-learn'));
                APP.Layout.openOverlay('no-solution');
            } else if (solutions) {
                loadSolutions($this);
            } else {
                APP.Page.applyPageByUrl('/en-US/learn/question/' + $this.attr('data-learn'));
            }
        });

        $body.find('[data-learn-send]').on('click', function () {
            var input = $body.find('[data-learn-input]').attr('data-value');

            if (input !== '[]') {
                checkProblem(
                    $body.find('[name="question-id"]').val(),
                    input
                );
            } else {
                APP.Layout.openOverlay('empty-learn-input');
                $body.find('[data-close-learn-empty]').focus();
            }
        });

        $body.find('[data-learn-cta-resolve]').on('click', function () {
            checkProblem($body.find('[name="question-id"]').val(), $(this).attr('data-learn-cta-resolve'));
        });

        $body.find('[data-learn-cta]').on('click', function () {
            APP.Layout.onOverlayClose(function () {
            });
        });

        $body.find('[data-learn-fail]').on('click', giveUp);
        $body.find('[data-reset-learn-tree]').on('click', cutLearnTree);
        $body.find('[data-learn-year]').on('click', function () {
            var $this = $(this),
                $anchorElement = $body.find('[data-learn-year-anchor="' + $this.attr('data-learn-year') + '"]');

            if ($anchorElement.offset()) {
                APP.Layout.scrollTo($anchorElement.offset().top - 60, 0);
            } else {
                APP.Page.applyPageByUrl('/en-US/learn#year-' + $this.attr('data-learn-year'));
            }
        });

        if ($body.find('[data-search-select]').length) {
            APP.Form.searchSelect($body.find('[data-search-select]')[0]);
            if ($body.find('[data-goto-topic][data-search-select]').length) {
                $body.find('[data-goto-topic][data-search-select]')[0].addEventListener(
                    'choice', function () {
                        var $this = $(this),
                            $anchorElement = $body.find('[data-topic-card="' + $this.val() + '"]');

                        if ($anchorElement.offset()) {
                            requestAnimationFrame(function () {
                                APP.Layout.scrollTo($anchorElement.offset().top - 60, 0);
                            });
                        } else {
                            APP.Page.applyPageByUrl('/en-US/learn#topic-' + $this.val());
                        }
                    }, false
                );
            }
        }

        $body.find('[data-custom-select]').each(function(){
            APP.Form.customSelect(this);
        });

        $body.find('[data-goto-anchor]').on('click', function () {
            var $this = $(this),
                $anchorElement = $body.find('[data-learn-anchor="' + $this.attr('data-goto-anchor') + '"]');

            if ($anchorElement.offset()) {
                APP.Layout.scrollTo($anchorElement.offset().top - 60, 0);
            } else {
                APP.Page.applyPageByUrl('/en-US/learn#' + $this.attr('data-goto-anchor'));
            }
        });

        $body.find('[data-goto-topic]').on('change', function () {
            var $this = $(this),
                $anchorElement = $body.find('[data-topic-card="' + $this.val() + '"]');

            if ($anchorElement.offset()) {
                APP.Layout.scrollTo($anchorElement.offset().top - 60, 0);
            } else {
                APP.Page.applyPageByUrl('/en-US/learn#topic-' + $this.val());
            }
        });

        $body.find('[data-show-topic-after]').on('click', function () {
            $(this).hide();
            $body.find('[data-topic-after]').removeClass('newsfeed__item--hide');
        });

        $body.find('[data-hide-topic-after]').on('click', function () {
            $body.find('[data-show-topic-after]').show();
            $body.find('[data-topic-after]').addClass('newsfeed__item--hide');
        });

        $body.find('[data-show-topic-before]').on('click', function () {
            $(this).hide();
            $body.find('[data-topic-before]').removeClass('newsfeed__item--hide');
        });

        $body.find('[data-hide-topic-before]').on('click', function () {
            $body.find('[data-show-topic-before]').show();
            $body.find('[data-topic-before]').addClass('newsfeed__item--hide');
        });

        if (!initialized) {
            $body.on('click', '[data-focus-input]', function () {
                $body.find('[data-calculator-focus-hunter]').focus();
            });

            $body.on('click', '.newsfeed-button--short', function () {
                $body.find('.newsfeed').attr('class', 'newsfeed newsfeed--short');
                APP.Layout.scrollTo(0, 200);
            });

            $body.on('click', '.newsfeed-button--long', function () {
                $body.find('.newsfeed').attr('class', 'newsfeed newsfeed--long');
                APP.Layout.scrollTo(0, 200);
            });

            $body.on('click', '[data-solutions]', function (e) {
                e.stopPropagation();
                e.preventDefault();
                APP.Page.applyPageByUrl($(this).parents('a').attr('href') + '?solutions=true');
            });

            $body.on('click', '[data-question-copy]', function (e) {
                APP.Calculator.Keyboard.paste($(this).attr('data-question-copy'));
            });

            $body.on('click', '[data-open-comment]', function () {
                $body.find('[data-dashboard-input]').hide();
                $body.find('[data-prime-box]').hide();
                $body.find('[data-comment-box]').show();
                $body.find('[data-comment]').val('').focus();
            });

            $body.on('click', '[data-open-formula-comment]', function () {
                formulaCommentPhase(true);
            });

            $body.on('click', '[data-close-formula-comment]', function () {
                formulaCommentPhase(false);
            });

            $body.on('click', '[data-open-doodle-comment]', function () {
                APP.Doodle.newDoodle();
                APP.Doodle.openDoodleInput();
                APP.Doodle.onDoodled(function (doodleId) {
                    $body.find('[data-previous-good-answers-wrapper]').show();
                    $answersWrapper.append($(APP.Tpl.run('exam-solution', {
                        index: $answersWrapper.first().find('> [data-exam-answer]').length,
                        type: 'comment-doodle',
                        display: doodleId
                    })));
                });
            });

            $body.on('click', '[data-close-comment]', function () {
                $body.find('[data-dashboard-input]').show();
                $body.find('[data-comment-box]').hide();
                $body.find('[data-prime-box]').hide();
            });

            $body.on('click', '[data-submit-comment]', function () {
                var type = $(this).attr('data-submit-comment'),
                    comment = type === 'comment-formula' ?
                        $body.find('[data-learn-input]').attr('data-value') :
                        $body.find('[data-comment]').val();

                saveComments(type, comment, function (result) {
                    var $formula = $('<div class="formula-flack" />');

                    if (result.success) {
                        $body.find('[data-previous-good-answers-wrapper]').show();
                        if (type === 'comment-formula') {
                            $formula.html('<div data-f="' + result.comment + '"><div data-f-content></div></div>');
                            formulaCommentPhase(false);
                        } else {
                            $formula.text(comment);
                        }
                        $answersWrapper.append($formula);
                        APP.Formula.fillFormulas();
                        $body.find('[data-dashboard-input]').show();
                        $body.find('[data-comment-box]').hide();
                        $body.find('[data-prime-box]').hide();
                    }
                });
            });
        }
    }

    function saveComments(type, comment, callback) {
        APP.Ajax.post('/en-US/learn/post-comment', {
            questionId: $body.find('[name="question-id"]').val(),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            data: {
                type: type || 'text',
                content: comment
            }
        }).then(function (result) {
            callback && callback(result);
        }, window.NOOP);
    }

    function initSounds() {
        var i;

        if (window.Audio) {
            for (i = 0; i < soundFiles.length; i++) {
                sounds[soundFiles[i]] = new Audio(CDN.sound + soundFiles[i] + '.mp3');
            }
        }
    }

    function loadSolutions($element) {
        if ($element.hasClass('opened-solutions')) {
            $element.removeClass('opened-solutions');
            $element.next().remove();
        } else {
            $element.addClass('opened-solutions');
            APP.Ajax.post('/en-US/service/solutions', {
                questionId: $element.attr('data-learn')
            }).then(function (result) {
                APP.ProblemWorker.run('learn-solutions', result.result).then(function (result) {
                    var $solutions = $('<li data-opened-solutions />');
                    $solutions.html(result);
                    $solutions.insertAfter($element);
                    APP.Layout.setMoments();
                    APP.Formula.fillFormulas();
                });
            }, window.NOOP);
        }
    }

    function playSound(name) {
        name = name === 'show-cup-default' ? 'show-cup' : name;
        if (window.USER_SETTINGS && window.USER_SETTINGS.audio && sounds.hasOwnProperty(name)) {
            try {
                sounds[name].play().catch(console.log);
            } catch (e) {
                console.log(e);
            }
        }
    }

    function preCheckProblem(questionId) {
        preCheckResult = false;
        hasFailed = false;
        APP.Ajax.post('/en-US/learn/pre-check', {
            questionId: questionId,
            questionCheck: $body.find('[data-learn-question]').attr('data-learn-check'),
            questionSample: $body.find('[data-learn-question]').attr('data-learn-sample'),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            language: window.LANGUAGE,
        }).then(function (result) {
            if (result.success) {
                preCheckResult = result.result;
            } else {
                APP.Calculator.Keyboard.hide(true);
                APP.Layout.alert(window.TXT['learn_error.error'], false, function () {
                    APP.Page.reloadPage();
                });
            }
        }, function () {
            APP.Calculator.Keyboard.hide(true);
            APP.Layout.alert(window.TXT['learn_error.error'], false, function () {
                APP.Page.reloadPage();
            });
        });
    }

    function checkProblem(questionId, answer) {
        fastCheckProblem(questionId, answer);
    }

    function getCompetition(questionId) {
        const $wrapper = $body.find('[data-learn-element="competition"]');

        $wrapper.addClass('loading');
        APP.Ajax.post('/en-US/learn/get-competition', {
            questionId: questionId
        }).then(function (result) {
            $wrapper.removeClass('loading');
            if (result.success) {
                APP.ProblemWorker.run('learn-competition', result.result).then(function (response) {
                    $wrapper.html(response);
                });
            }
        }, window.NOOP);
    }

    function fastCheckProblem(questionId, answer) {
        if (!isChecking) {
            isChecking = true;
            $body.find('[data-learn-send]').addClass('disabled');

            APP.Ajax.post('/en-US/learn/fast-check', {
                questionId: questionId,
                answer: prefixWithMultipleAnswer(answer),
                questionCheck: $body.find('[data-learn-question]').attr('data-learn-check'),
                questionSample: $body.find('[data-learn-question]').attr('data-learn-sample'),
                historyId: $body.find('[name="lesson-history-id"]').val(),
            }).then(function (result) {
                isChecking = false;
                $body.find('[data-learn-send]').removeClass('disabled');

                if (result.success && result.result && preCheckResult) {
                    var display = result.result.display;
                    var actionId = result.result.result;
                    var r = {success: true};

                    if (actionId === 0) {
                        hasFailed = true;
                    } else if (actionId === 1 && display === lastSolution) {
                        actionId = 5;
                    } else if (actionId === 2 && hasFailed) {
                        actionId = 6;
                    }
                    lastSolution = display;
                    r.result = preCheckResult[actionId];
                    if (actionId !== 0 && actionId !== 5) {
                        r.result.display = display;
                    }
                    if (result.result.getback) {
                        r.result.getback = result.result.getback;
                    }
                    if (window.USER_SETTINGS.competitionNotification > 0) {
                        if (window.USER_SETTINGS.competitionNotification === 1) {
                            if (preCheckResult && preCheckResult[actionId] && preCheckResult[actionId].action.emocard === 'show-medal') {
                                getCompetition(questionId);
                            }
                        } else if (window.USER_SETTINGS.competitionNotification === 2) {
                            if (actionId === 2) {
                                getCompetition(questionId);
                            }
                        }
                    }
                    handleChecking(r);
                } else {
                    APP.Layout.alert(window.TXT['learn_error.error'], false);
                }
            }, function () {
                isChecking = false;
                $body.find('[data-learn-send]').removeClass('disabled');
                APP.Layout.alert(window.TXT['learn_error.error'], false);
            });
        }
    }

    function handleChecking(result) {
        var i,
            action;

        if (result.success && result.result) {
            action = result.result.action;
            $answerOverlay.find('[data-learn-element="text"]').text(action.text);
            playSound(action.emocard);
            $answerOverlay.find('[data-learn-element="emocard"]').html(
                APP.Tpl.run('learn/emocard', {type: action.emocard})
            );
            $answerOverlay.find('[data-learn-cta]').hide();
            for (i = 0; i < action.actionButtons.length; i++) {
                $answerOverlay.find('[data-learn-cta="' + action.actionButtons[i] + '"]').show();
            }
            $answerOverlay.find('[data-learn-cta="' + action.actionButtons[0] + '"]').focus();
            APP.Layout.openOverlay('learn-answer');
            if (action.actionButtons[0] > 0) {
                APP.Layout.onOverlayClose(function () {
                    APP.Page.applyPageByUrl(document.location.href);
                });
            }
            if (action.emocard === 'show-star' || action.emocard === 'show-medal' || action.emocard === 'show-cup') {
                $body.find('.learn__star:not(.learn__star--active)').first().addClass('learn__star--active');
            }
            if (result.result.display && action.emocard !== 'redundant') {
                APP.Live.saveClientMeta('ping', 1);
                $body.find('[data-previous-good-answers-wrapper]').show();
                APP.ProblemWorker.run('formula', result.result.display).then(function (formula) {
                    var $formula = $(formula),
                        $copy = $('<a style="position: absolute; right: 15px" data-question-copy=\'' + result.result.display + '\'><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-symbol-copy"></use></svg></i></a>');
                    $body.find('[data-doodle-formula-preview]').html(formula);
                    $formula.prepend($copy);
                    if (result.result.result === 3 || result.result.result === 2) {
                        $formula.addClass('formula-flack--result');
                    }
                    $answersWrapper.append($formula);
                    APP.Formula.fillFormulas();
                });
            }
            if (action.interPage) {
                APP.Page.addInterPage(action.interPage);
            }
            if (result.result.getback && action.emocard !== 'redundant') {
                pushToMultipleAnswer(result.result.getback);
            }
        } else {
            APP.ProblemWorker.run('learn-error', result).then(function (content) {
                $body.find('[data-learn-error-content]').html(content);
                APP.Layout.openOverlay('learn-error');
                $body.find('[data-close-learn-error]').focus();
            });
        }
    }

    function pushToMultipleAnswer(answer) {
        var $ma = $body.find('[data-multiple-answer]'),
            splitChar = '@@',
            value = $ma.attr('data-multiple-answer'),
            splited = value ? value.split(splitChar) : [];

        splited.push(answer);
        $ma.attr('data-multiple-answer', splited.join(splitChar));
    }

    function prefixWithMultipleAnswer(answer) {
        var $ma = $body.find('[data-multiple-answer]'),
            splitChar = '@@',
            value = $ma.attr('data-multiple-answer'),
            splited = value ? value.split(splitChar) : [];

        splited.push(answer);
        if (splited.length > 2 && false) {
            splited = [
                splited[splited.length - 2],
                splited[splited.length - 1]
            ];
        }

        return splited.join(';');
    }

    function giveUp() {
        var questionId = $body.find('[name="question-id"]').val(),
            answerData = $body.find('[name="answer-data"]').val(),
            historyId = $body.find('[name="lesson-history-id"]').val();

        APP.Ajax.post('/en-US/learn/give-up', {
            questionId: questionId,
            answerData: answerData,
            historyId: historyId
        }).then(function () {
            APP.Page.applyPageByUrl('/en-US/learn/answer/' + answerData + '/' + questionId);
        }, window.NOOP);
    }

    function cutLearnTree() {
        APP.Ajax.post('/en-US/learn/cut-tree').then(function () {
            APP.Page.applyPageByUrl('/en-US/learn/');
        }, window.NOOP);
    }

    function formulaCommentPhase(show) {
        var $ctas = $('[data-formula-comment-ctas]'),
            $defaultCtas = $('[data-formula-default-ctas]');

        if (show) {
            $body.addClass('show-extended-keyboard');
            $ctas.show();
            $defaultCtas.hide();
            $('#new-input').focus();
        } else {
            $body.removeClass('show-extended-keyboard');
            $ctas.hide();
            $defaultCtas.show();
        }

    }

    exports.init = init;
    exports.saveComments = saveComments;

    return exports;

})();

APP.Video = (function () {
    var exports = {},
        initialized = false;

    function init() {
        var $videoIndicator;
        initBindings();

        if (document.location.hash === '#video') {
            $videoIndicator = $body.find('[data-play-youtube]');

            if ($videoIndicator.length > 0) {
                playYoutube($videoIndicator.first().attr('data-play-youtube'));
            }
        }
    }

    function initBindings() {
        if (!initialized) {
            initialized = true;

            $body.on('click', '[data-play-youtube]', function () {
                var $this = $(this),
                    customEvent = $this.attr('data-custom-event'),
                    id = $this.attr('data-play-youtube');

                if (customEvent) {
                    console.log('customEvent', customEvent);
                    APP.Analytics.logCustomUserEvent(customEvent, id);
                }
                playYoutube(id);
                APP.Analytics.trackEvent('landing-click', 'play-youtube', id);
            });
        }
    }

    function playYoutube(id) {
        $body.find('[data-youtube-video-wrapper]').html(APP.Tpl.run('youtube-video', {
            id: id,
            language: window.LANGUAGE
        }));
        setTimeout(function () {
            APP.Layout.openOverlay('youtube-video-overlay');
            APP.Layout.onOverlayClose(function () {
                $body.find('[data-youtube-video-wrapper]').html('');
            });
        }, 300);
    }

    exports.init = init;
    return exports;

})();

APP.Assets = (function () {
    var exports = {},
        loaded = 0,
        loadedCallback = null,
        timeoutDuration = 6000;

    function init(callback) {
        loadedCallback = callback;
        loadSprite();
        loadCss();
        loadFont();
    }

    function loadCss() {
        function loadStylesheet(href) {
            return new Promise((resolve, reject) => {
                const existing = [...document.styleSheets].find(s => s.href === href);
                if (existing) return resolve(href);
                const link = document.createElement('link');
                const cleanup = () => {
                    link.onload = null;
                    link.onerror = null;
                };

                link.rel = 'stylesheet';
                link.href = href;
                link.onload = () => { cleanup(); resolve(href); };
                link.onerror = () => { cleanup(); reject(new Error(`CSS load error: ${href}`)); };
                document.body.appendChild(link);
            });
        }
        const readyOnce = (() => {
            let called = false;
            return () => {
                if (called) return;
                called = true;
                ready();
            };
        })();
        const timeout = setTimeout(readyOnce, timeoutDuration);
        const fontStylesheets = [];

        window.STYLESHEETS.forEach((stilesheet) => {
            fontStylesheets.push(loadStylesheet(stilesheet));
        });
        Promise.all(fontStylesheets).then(() => {
            clearTimeout(timeout);
            readyOnce();
        }).catch(() => {
            clearTimeout(timeout);
            readyOnce();
        });
    }

    function loadFont() {
        const readyOnce = (() => {
            let called = false;
            return () => {
                if (called) return;
                called = true;
                ready();
            };
        })();
        const timeout = setTimeout(readyOnce, timeoutDuration);
        const fontLoadings = [];

        window.FONTS.forEach((font) => {
            fontLoadings.push(document.fonts.load(`24px "${font}"`));
        });
        Promise.all(fontLoadings).then(() => {
            clearTimeout(timeout);
            readyOnce();
        }).catch(() => {
            clearTimeout(timeout);
            readyOnce();
        });
    }

    function loadSprite() {
        document.getElementById('sprite').innerHTML = APP.$store.svg;
        requestAnimationFrame(ready);
    }

    function ready() {
        if (++loaded > 2) {
            requestAnimationFrame(loadedCallback);
        }
    }

    exports.init = init;
    return exports;

})();


APP.Avatar = (function () {
    var exports = {},
        props = {},
        initialized = false;

    function init() {
        if (!initialized) {
            initialized = true;
            initBindings();
        }
    }

    function initBindings() {
        $body.on('click', '[data-avatar-prev]', function () {
            var $this = $(this),
                propName = $this.attr('data-avatar-prev'),
                val = (getLength(propName) + getProp(propName) - 1) % getLength(propName);

            if(val === 0) {
                val = getLength(propName);
            }

            setProp(propName, val);
        });

        $body.on('click', '[data-avatar-next]', function () {
            var $this = $(this),
                propName = $this.attr('data-avatar-next'),
                val = (getLength(propName) + getProp(propName) + 1) % getLength(propName);

            if(val === 0) {
                val = getLength(propName);
            }

            setProp(propName, val);
        });
    }

    function getHash() {
        return parseInt([
            getProp('body'),
            getProp('hair'),
            getProp('dress'),
            getProp('glass'),
            getProp('beard'),
            getProp('bgColor'),
            getProp('skinColor'),
            getProp('hairColor'),
            getProp('dressColor'),
            getProp('glassColor')
        ].join(''), 10).toString(32);
    }

    function getProp(propName) {
        if (!props.hasOwnProperty(propName)) {
            props[propName] = parseInt($body.find('[data-avatar-actual="' + propName + '"]').text(), 10);
        }
        return props[propName];
    }

    function getLength(propName) {
        return window.AVATAR_PROP_LENGTHS[propName];
    }

    function setProp(propName, value) {
        props[propName] = value;
        $body.find('[data-avatar-actual="' + propName + '"]').text(value);
        $body.find('[data-avatar-window]').attr('src', '/static/avatar/' + getHash() + '.svg?layout=0');
    }

    exports.init = init;


    return exports;

})();

APP.Doodle = (function () {
    var adtualDoodleId,
        Doodle,
        doodlers = [],
        doodlerIndex = 0;

    function init() {
        var $input = $body.find('[data-doodle-input]:not([data-doodle-input-initialized])');

        if ($input.length) {
            Doodle = new DoodleInput($input);
        }
    }

    function newDoodle() {
        Doodle.readAndWrite('doodle');
        Doodle.setMode('doodle');
        Doodle.setDoodleId(undefined);
        Doodle.loadPath([]);
    }

    function editDoodle(id) {
        return new Promise(function (resolve, reject) {
            getDoodlePath(id).then(function (path) {
                Doodle.setDoodleId(id);
                Doodle.loadPath(path);
                openDoodleInput();
                resolve();
                onDoodled(function (doodleId) {
                    $body.find('img[data-doodle-id="' + doodleId + '"]')
                        .attr('src', '/doodle/' + doodleId + '.svg?' + new Date());
                });
            });
        });
    }

    function getDoodlePath(id) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/en-US/service/doodle/get', {
                id: id
            }).then(function (result) {
                console.log('AJAX result');
                if (result.success) {
                    resolve(result.path);
                } else {
                    reject();
                }
            }, reject);
        });

    }

    function openDoodleInput() {
        Doodle.setMode('doodle');
        Doodle.fullScreen();
    }

    function closeDoodleInput() {

    }

    function showLastStep() {

    }

    function hideLastStep() {

    }

    function DoodleInput($element) {
        var _self = this,
            doodleId,
            offsetX,
            offsetY,
            idSeeker = 0,
            editable = false,
            isMouseDown = false,
            fullscreen = false,
            MODES = {
                DOODLE: 1,
                PAN: 2,
                RUBBER: 3
            },
            MODE = MODES.DOODLE,
            panStartCoordinates = [0, 0],
            panOffset = [0, 0],
            simplifyTolerance = 3,
            $path,
            $points = $element.find('[data-points]'),
            paths = [],
            pathHistory = [],
            tpmDoodleId;

        _self.init = function () {
            $element.attr('data-doodle-input-initialized', 'true');
            initBindings();
        };

        _self.setMode = function (mode) {
            MODE = MODES[mode.toUpperCase()];
            $element.attr('data-doodle-input-mode', mode.toLowerCase());
        };

        function initBindings() {
            $element.find('[data-doodle-control="fullscreen-close"]').on('click', function () {
                toggleFullscreen();
            });

            $element.find('[data-doodle-control="save"]').on('click', function () {
                _self.save();
                toggleFullscreen();
            });

            $element.find('[data-doodle-control="doodle"]').on('click', function () {
                _self.setMode('doodle');
            });

            $element.find('[data-doodle-control="pan"]').on('click', function () {
                _self.setMode('pan');
            });

            $element.find('[data-doodle-control="rubber"]').on('click', function () {
                _self.setMode('rubber');
            });

            $element.find('[data-doodle-control="undo"]').on('click', undo);

            $element.on('touchmove', function (event) {
                if (isMouseDown) {
                    event.preventDefault();
                }
            });

            $element.find('svg').on('mousedown touchstart', function (event) {
                var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                    clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                setMouseDown(true);
                updateOffset();

                if (MODE === MODES.DOODLE) {
                    addToHistory();
                    createPath(getCoordinate('x', clientX - 1), getCoordinate('y', clientY - 1));
                    updatePath(getCoordinate('x', clientX), getCoordinate('y', clientY));
                } else if (MODE === MODES.PAN) {
                    panStart(getCoordinate('x', clientX), getCoordinate('y', clientY));
                } else if (MODE === MODES.RUBBER) {
                    addToHistory();
                }
            });

            $window.off('.doodle');
            $body.off('.doodle');

            $window.on('touchmove.doodle', '[data-address]', function (event) {
                event.preventDefault();
            });

            $window.on('mousemove.doodle touchmove.doodle', function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                    if (typeof clientX !== 'number' || typeof  clientY !== 'number') {
                        return;
                    }

                    if (MODE === MODES.DOODLE) {
                        updatePath(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    } else if (MODE === MODES.PAN) {
                        pan(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    } else if (MODE === MODES.RUBBER) {
                        var elemet = document.elementFromPoint(clientX, clientY),
                            address = elemet ? elemet.getAttribute('data-address') : false;

                        if (address) {
                            clearPoint(address);
                        }
                    }
                }
            });

            $window.on('scroll.doodle', updateOffset);

            $window.on('mouseup.doodle touchend.doodle', function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.changedTouches && event.originalEvent.changedTouches[0].clientX,
                        clientY = event.clientY || event.originalEvent.changedTouches && event.originalEvent.changedTouches[0].clientY;

                    setMouseDown(false);
                    if (MODE === MODES.DOODLE) {
                        closePath();
                        saveDoodle(paths, tpmDoodleId, true).then(function (id) {
                            tpmDoodleId = id;
                            APP.Live.saveClientMeta('input', {
                                type: 'doodle',
                                value: id
                            });
                        });
                    } else if (MODE === MODES.PAN) {
                        panEnd(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    }
                }
            });

            $body.on('click.doodle', '[data-doodle-id]', function () {
                var $this = $(this),
                    doodleId = $this.attr('data-doodle-id');

                editable = !!$this.attr('data-editable');
                editDoodle(doodleId).then(function () {
                    _self.setMode('pan');
                    if (!editable) {
                        _self.readOnly();
                    } else {
                        _self.readAndWrite();
                    }
                });
            });

        }

        function addToHistory() {
            pathHistory.push(JSON.parse(JSON.stringify(paths)));
            $element.addClass('doodle-table__show-undo');
        }

        _self.clearHistory = function () {
            $element.removeClass('doodle-table__show-undo');
            pathHistory = [];
        };

        function undo() {
            var recovery = pathHistory.splice(-1, 1)[0];

            Doodle.loadPath(recovery, true);
            if (!pathHistory.length) {
                $element.removeClass('doodle-table__show-undo');
            }
        }

        function setMouseDown(value) {
            isMouseDown = value;
            if (value) {
                $points.show();
            } else {
                $points.hide();
            }
        }

        function getId() {
            return ++idSeeker;
        }

        function newPath() {
            var id = getId();

            $element.find('svg [data-paths]')[0].innerHTML += '<path data-path-id="' + id + '" />';
            $path = $element.find('path:last-child');
            return id;
        }

        function getCoordinate(coordinate, value) {
            if (coordinate === 'x') {
                return value - offsetX;
            }
            return value - offsetY;
        }

        function createPath(x, y) {
            var id = newPath(),
                points = x ? [{x: x - panOffset[0], y: y - panOffset[1]}] : [];

            paths.push({
                id: id,
                points: points
            });

            return id;
        }

        function updatePath(x, y) {
            paths[paths.length - 1].points.push({x: x - panOffset[0], y: y - panOffset[1]});
            drawPaths();
        }

        function updateOffset() {
            offsetX = $element.offset().left - window.scrollX;
            offsetY = $element.offset().top - window.scrollY;
        }

        function getPathById(id) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    return paths[i];
                }
            }
        }

        function deletePathById(id) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    paths.splice(i, 1);
                }
            }
        }

        function updatePathById(id, points) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    paths[i].points = points;
                    return true;
                }
            }
        }

        function closePath() {
            var path = paths[paths.length - 1] = simplifyPath(paths[paths.length - 1]);

            drawPaths();
            drawCircles(path.id);
        }

        function drawCircles(id) {
            var path = getPathById(id),
                i,
                endpoint,
                points = '',
                pathPoints = path.points;

            for (i = 0; i < pathPoints.length; i++) {
                endpoint = (i === 0 || i === pathPoints.length - 1);
                points += '<circle cx="' + pathPoints[i].x + '" cy="' + pathPoints[i].y + '" fill="' + (endpoint ? 'blue' : 'green') + '" r="20" data-address="' + path.id + ';' + i + '" />';
            }
            $element.find('svg [data-points]')[0].innerHTML += points;
        }

        function clearCircles(id) {
            $element.find('svg circle[data-address^="' + id + ';"]').remove();
        }

        function drawPaths() {
            var path = getCurvedPath(decodeXY(paths[paths.length - 1].points));
            $path.attr('d', path);
        }

        function drawPath(id) {
            var points = getPathById(id).points;

            if (points.length > 0) {
                $element.find('[data-path-id="' + id + '"]').attr('d', getCurvedPath(decodeXY(points)));
                drawCircles(id);
            } else {
                deletePathById(id);
                $element.find('[data-path-id="' + id + '"]').remove();
            }
        }

        function simplifyPath(data) {
            data.points = simplify(data.points, simplifyTolerance, true);
            return data;
        }

        function panStart(x, y) {
            panStartCoordinates = [x, y];
        }

        function pan(x, y) {
            var X = x - panStartCoordinates[0] + panOffset[0],
                Y = y - panStartCoordinates[1] + panOffset[1];

            $element.find('svg [data-canvas]').css('transform', 'translate3d(' + X + 'px,' + Y + 'px, 0)');
            $element.css('background-position', X + 'px ' + Y + 'px')
        }

        function panEnd(x, y) {
            panOffset = [x - panStartCoordinates[0] + panOffset[0], y - panStartCoordinates[1] + panOffset[1]];
        }

        function drawNewPath(points) {
            var id = createPath(),
                path = getPathById(id);

            path.points = points;
            drawPath(id);
        }

        function clearPoint(address) {
            var addressParts = address.split(';'),
                pathId = parseInt(addressParts[0], 10),
                nth = parseInt(addressParts[1], 10),
                path = getPathById(pathId),
                pathPoints = path.points,
                newPathPoints = pathPoints.splice(0, nth);

            clearCircles(pathId);
            updatePathById(pathId, newPathPoints);
            drawPath(pathId);
            drawNewPath(pathPoints.splice(1, pathPoints.length));
            $element.find('[data-address="' + address + '"]').remove();
        }

        function continuePoint() {

        }

        function toggleFullscreen() {
            fullscreen = !fullscreen;
            if (fullscreen) {
                _self.fullScreen();
            } else {
                $element.removeClass('doodle-table__fullscreen');
            }
        }

        _self.readOnly = function () {
            $element.addClass('doodle-table__readonly');
        };

        _self.readAndWrite = function () {
            $element.removeClass('doodle-table__readonly');
        };

        _self.loadPath = function (_paths, original) {
            paths = [];
            $element.find('[data-paths]').html('');
            $element.find('[data-points]').html('');
            _paths.forEach(function (path) {
                // paths
                if (original) {
                    drawNewPath(path.points);
                } else {
                    drawNewPath(encodeXY(path));
                }
            });
        };

        _self.fullScreen = function () {
            APP.Calculator.Keyboard.hide(true);
            fullscreen = true;
            $element.addClass('doodle-table__fullscreen');
            _self.clearHistory();
            APP.Formula.fillFormulas($element);
        };

        _self.save = function () {
            var examId = $body.find('[name="exam-id"]').val(),
                examNth = $body.find('[name="exam-nth"]').val(),
                commentType = 'comment-doodle';

            if (doodleId) {
                updateDoodle(doodleId, paths);
            } else {
                saveDoodle(paths).then(function (id) {
                    doodleId = id;
                    if (examId) {
                        APP.Ajax.post('/en-US/service/exam/' + examId + '/comment', {
                            examId: examId,
                            examNth: examNth,
                            type: commentType,
                            comment: id
                        }).then(function (result) {
                            if (result.success) {
                                APP.Exam.showFormulaInput();
                                $body.find('[data-exam-answers="1"]').removeClass('invisible');
                            } else if (result.reason === 'done') {
                                APP.Layout.openOverlay('exam-finished');
                            }
                        }, window.NOOP);
                    } else {
                        APP.Learn.saveComments(commentType, id);
                    }
                });
            }
        };

        _self.setDoodleId = function (value) {
            doodleId = value;
        };

        _self.init();
        return _self;
    }

    function getCurvedPath(data) {
        var k = 1,
            size = data.length,
            last = size - 4,
            path = 'M' + [data[0], data[1]],
            i,
            x0, y0, x1, y1, x2, y2, x3, y3, cp1x, cp1y, cp2x, cp2y;

        for (i = 0; i < size - 2; i += 2) {
            x0 = i ? data[i - 2] : data[0];
            y0 = i ? data[i - 1] : data[1];
            x1 = data[i];
            y1 = data[i + 1];
            x2 = data[i + 2];
            y2 = data[i + 3];
            x3 = i !== last ? data[i + 4] : x2;
            y3 = i !== last ? data[i + 5] : y2;
            cp1x = x1 + (x2 - x0) / 6 * k;
            cp1y = y1 + (y2 - y0) / 6 * k;
            cp2x = x2 - (x3 - x1) / 6 * k;
            cp2y = y2 - (y3 - y1) / 6 * k;
            path += 'C' + [cp1x, cp1y, cp2x, cp2y, x2, y2];
        }
        return path;
    }

    function encodeXY(data) {
        var result = [];

        for (var i = 0; i < data.length; i += 2) {
            result.push({x: data[i], y: data[i + 1]});
        }

        return result;

    }

    function decodeXY(data) {
        var result = [];

        (data || []).forEach(function (d) {
            result.push(d.x);
            result.push(d.y);
        });

        return result;

    }

    function saveDoodle(path, id, preventCallback) {
        if (id) {
            return updateDoodle(id, path, preventCallback);
        }
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/en-US/service/doodle/save', {
                path: JSON.stringify(path.map(function (p) {
                    return decodeXY(p.points)
                }))
            }).then(function (result) {
                if (result.success) {
                    !preventCallback && onDoodledCallback(result.id);
                    resolve(result.id);
                } else {
                    reject();
                }
            }, reject);
        });
    }

    function updateDoodle(id, path, preventCallback) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/en-US/service/doodle/save', {
                id: id,
                path: JSON.stringify(path.map(function (p) {
                    return decodeXY(p.points)
                }))
            }).then(function (result) {
                if (result.success) {
                    !preventCallback && onDoodledCallback(result.id);
                    resolve(result.id);
                } else {
                    reject();
                }
            }, reject);
        });

    }

    var onDoodledCallback = function (id) {
        console.log('doodled', id);
    };

    function onDoodled(callback) {
        onDoodledCallback = callback;
    }

    function openDoodle(id, editable) {

    }

    return {
        newDoodle: newDoodle,
        editDoodle: editDoodle,
        openDoodleInput: openDoodleInput,
        openDoodle: openDoodle,
        saveDoodle: saveDoodle,
        onDoodled: onDoodled,
        init: init
    };

})();

APP.Cd = (function () {

    var initialized = false,
        exports = {};

    function init() {
        $body.find('[data-hcflcm]:not([data-hcflcm-initialized])').each(function () {
            var $this = $(this);
            initCd($this);
        });
    }

    function initCd($element) {
        $element.attr('data-hcflcm-initialized', 'true');

        APP.Ajax.post('/en-US/service/hcflcm', {
            cmd: $element.attr('data-hcflcm-cmd'),
            formula: $element.attr('data-hcflcm-formula')
        }).then(function (result) {
            APP.ProblemWorker.run('hcflcm', result).then(function (compiled) {
                $element.html(compiled);
                APP.Formula.fillFormulas();
                APP.Formula.cosmeticFormulaByWrapper($element);
            });
        }, window.NOOP);
    }

    exports.init = init;

    return exports;

})();


APP.Layout = (function () {
    var exports = {},
        inited = false,
        overlayCloseCallback = false,
        momentInitialized = false,
        $html,
        $body$html,

        lastOverlay,

        inputCloseTimer;

    function init() {
        loadOverlays();
        initBindings();
        initMoment();
        preloadBackgrounds();
        addMails();

        $body.find('[data-header-tooltip]').removeClass('show');
        $body.addClass(APP.Page.isDevice() ? 'device' : 'desktop');
        $html = $('html');
        $body$html = $('html, body');
    }

    function initBindings() {
        $body.find('[data-prevent]').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
        });
        initCarousels();
        if (!inited) {
            setCookieNotification();
            $body.on('click', '[data-open-overlay]', function () {
                var overlay  = $(this).attr('data-open-overlay');
                openOverlay(overlay);

                if(overlay === 'group-registration') {
                    $body.find('[data-overlay=' + overlay + '] [name="groupId"]').val(
                        $body.find('[data-actual-group-id]').attr('data-actual-group-id')
                    )
                }
            });

            $body.on('click', '[data-close-overlay]', () => closeOverlay());
            $body.on('click', '[data-close-last-overlay]', () => closeOverlay(true));
            $body.find('[data-language-selector]').on('change', function () {
                var pathPeaces = document.location.pathname.split('/');

                pathPeaces[1] = $(this).val();
                document.location.href = pathPeaces.join('/')
                    + document.location.search
                    + document.location.hash;
            });

            $body.on('click', '[data-scroll-to-top]', function () {
                scrollTo(0, 200);
            });

            $body.find('[data-header-tooltip-show]').on('click', function (event) {
                var $tooltip = $body.find('[data-header-tooltip="' + $(this).attr('data-header-tooltip-show') + '"]');

                event.originalEvent.attribute = 'click-from-tooltip';
                $body.find('[data-header-tooltip]').removeClass('show');
                $tooltip.addClass('show');
                $tooltip.on('click.header-tooltip', function (event) {
                    event.originalEvent.attribute = 'click-from-tooltip';
                });

                setTimeout(function () {
                    $body.on('click.header-tooltip', function (event) {
                        if (event.originalEvent && event.originalEvent.attribute !== 'click-from-tooltip') {
                            $tooltip.off('click.header-tooltip');
                            $body.find('[data-header-tooltip]').off('click.header-tooltip');
                            $body.off('click.header-tooltip');
                            $body.find('[data-header-tooltip]').removeClass('show');
                        }
                    });
                }, 8);

            });

            $body.on('click', '[data-load-more]', function (e) {
                e.preventDefault();
                var $this = $(this),
                    fromSelector = $this.attr('data-load-more').split(':')[0],
                    toSelector = $this.attr('data-load-more').split(':')[1],
                    promise = $.ajax({
                        'type': 'get',
                        'url': $this.attr('href'),
                        'dataType': 'html'
                    });

                APP.Analytics.trackEvent('loadMore', $this.attr('href'), '', {
                    from: fromSelector,
                    to: toSelector
                });
                promise.then(function (result) {
                    $body.find(toSelector).replaceWith($(fromSelector, result).html());
                    setMoments();
                    APP.Formula.fillFormulas();
                });
            });

            $body.on('change', '[data-query]', function () {
                var queryStrings = [],
                    $this;

                $body.find('[data-query]').each(function () {
                    $this = $(this);
                    queryStrings.push($this.attr('data-query') + '=' + $this.val());
                });

                document.location.href = '?' + queryStrings.join('&');
            });

            $body.on('change', '[name="change-currency-onchange"]', function () {
                APP.Page.applyPageByUrl(document.location.href.split('?')[0] + '?currency=' + $(this).val());
            });

            $body.find('.made-in__heart').on('click', function () {
                var $this = $(this);

                $this.removeClass('made-in__heart__pulse');
                async(function () {
                    $this.addClass('made-in__heart__pulse');
                });
            });

            $body.find('[data-copy-text]').on('click', function () {
                document.execCommand('copy');
            });

            $body.find('[data-copy-text]').on('copy', function (event) {
                var $this = $(this),
                    clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;

                clipboardData.setData('text/plain', $this.attr('data-copy-text'));
                event.preventDefault();
            });

            $body.on('click', '[data-show-password]', function () {
                var $pw = $(this).parents('[data-password-wrapper]');

                $pw.addClass('password-show');
                $pw.find('input').attr('type', 'text');
            });

            $body.on('click', '[data-hide-password]', function () {
                var $pw = $(this).parents('[data-password-wrapper]');

                $pw.removeClass('password-show');
                $pw.find('input').attr('type', 'password');
            });

            $body.on('click', '[data-show-block]', function () {
                var id = $(this).attr('data-show-block');

                $body.find('[data-block-indicator="' + id + '"]').hide();
                $body.find('[data-block-id="' + id + '"]').show();
                initCarousels();
                APP.Analytics.trackEvent('landing-click', 'show-block', id);
            });

        }
        inited = true;
    }

    function initCarousels() {
        $body.find('[data-carousel]:visible:not([data-initialized-carousel])').each(function () {
            var $this = $(this),
                fade = $this.hasClass('fade');

            $this.attr('data-initialized-carousel', true);
            $this.slick({
                infinite: true,
                autoplay: true,
                cssEase: fade ? 'ease' : 'cubic-bezier(0.76, 0, 0.24, 1)',
                speed: fade ? 120 : 300,
                fade: fade,
                autoplaySpeed: fade ? 3000 : 5000,
                prevArrow: $this.parent().find('[data-carousel-prev]'),
                nextArrow: $this.parent().find('[data-carousel-next]')
            });
        });
    }

    function loadOverlays() {
        document.getElementById('overlays').innerHTML = APP.Tpl.run('overlays');
    }

    function addMails() {
        $body.find('[data-mail-to-placeholder]').each(function () {
            var $this = $(this);

            $this.removeAttr('data-mail-to-placeholder');
            $this.html(APP.Tpl.run('mail-to', {support: !!$this.attr('data-support')}));
        });
    }

    function preloadBackgrounds() {
        $body.find('[data-bg]').each(function () {
            var $this = $(this),
                src = $this.attr('data-bg'),
                img = new Image();

            $this.css('background-image', 'url(' + src + ')');
            img.src = src;
        });
    }

    function closeOverlay(justTheLast) {
        let overlaySelector = '[data-overlay]';

        if(justTheLast) {
            overlaySelector = '[data-overlay="' + lastOverlay + '"]';
        }
        if ($body.find(overlaySelector + '.overlay--show').length > 0) {
            $body.find(overlaySelector).removeClass('overlay--show');
            APP.Analytics.trackEvent('overlay', 'close');
        }
        if (overlayCloseCallback) {
            overlayCloseCallback();
            overlayCloseCallback = false;
        }
    }

    function openOverlay(name) {
        var $overlay = $body.find('[data-overlay="' + name + '"]');

        $overlay.addClass('overlay--show');
        $overlay.find('.overlay--content').scrollTop(0);
        lastOverlay = name;
        $overlay.find('[data-src]').each(function () {
            var $this = $(this);
            $this.attr('src', $this.attr('data-src'));
        });
        APP.Analytics.trackEvent('overlay', 'open', name);
    }

    function initMoment() {
        if (!momentInitialized) {
            momentInitialized = true;
            moment.lang($('html').attr('lang'));
            moment().add('milliseconds', window.SERVER_TIME_OFFSET);
            setInterval(setMoments, 21000);
        }
        setMoments();
    }

    function setMoments() {
        $('[data-ago-moment]').each(function () {
            var $this = $(this),
                ago = new Date($this.attr('data-ago-moment')),
                m = moment(ago);
            $this.text(m.fromNow());
            $this.attr('title', m.format('LLLL'));
        });

        $('[data-date-moment]').each(function () {
            var $this = $(this),
                date = new Date($this.attr('data-date-moment')),
                m = moment(date).format('LL');
            $this.text(m);
            $this.attr('title', m);
        });

        $('[data-datetime-moment]').each(function () {
            var $this = $(this),
                date = new Date($this.attr('data-datetime-moment')),
                m = moment(date).format('LL - HH:mm');

            $this.text(m);
            $this.attr('title', m);
        });
    }

    function alert(message, keepOtherOverlays, callback) {
        if (!keepOtherOverlays) {
            closeOverlay();
        }
        overlayCloseCallback = callback;
        $body.find('[data-alert-content]').html(message);
        APP.Analytics.trackEvent('overlay', 'alert', '', {
            message: message
        });
        openOverlay('alert');
    }

    function scrollTo(top, duration) {
        if (duration === 0) {
            window.scrollTo(0, top);
        } else {
            $body$html.stop(1, 1, 1).animate({scrollTop: top}, duration || 300);
        }
    }

    function setCookieNotification() {
        if (!navigator.cookieEnabled) {
            $body.find('#notification-container').append(APP.Tpl.run('cookie-notification'));
            $body.find('[data-cookie-notification]').removeClass('cookie-notification--show');
            $body.find('[data-no-cookie-notification]').addClass('no-cookie-notification--show');
        } else if (!window.getCookie('cookie-notified')) {
            var $cookieNotification;
            $body.find('#notification-container').append(APP.Tpl.run('cookie-notification'));
            $cookieNotification = $body.find('[data-cookie-notification]');
            $document.on('click.cookie', function () {
                window.setCookie('cookie-notified', 'true', 999999);
                $document.off('click.cookie');
                $cookieNotification.removeClass('cookie-notification--show');
            });
        }
    }

    function inputFullScreen() {
        if (inputCloseTimer) {
            window.clearTimeout(inputCloseTimer);
        }
        $body.find('[data-close-banner]').addClass('keyboard__close-banner--show');
    }

    function onOverlayClose(callback) {
        overlayCloseCallback = callback;
    }

    exports.init = init;
    exports.openOverlay = openOverlay;
    exports.closeOverlay = closeOverlay;
    exports.alert = alert;
    exports.scrollTo = scrollTo;
    exports.onOverlayClose = onOverlayClose;
    exports.inputFullScreen = inputFullScreen;
    exports.setMoments = setMoments;
    exports.initCarousels = initCarousels;
    return exports;

})();

APP.Locale = (function () {
    var exports = {},
        initialized = false,
        replaceTable;

    function init() {
        if (!initialized) {
            setTable();

            $body.find('[data-keyboard-character]').each(function () {
                var $this = $(this);

                $this.html(replace($this.html()))
            });
            initialized = true;
        }

        $body.find('[data-ui-settings]').each(function () {
            var $this = $(this);
            var replaceTableStringify = replaceTable.map(function (element) {
                return element.join('-');
            });

            if (window.USER_SETTINGS.audio) {
                $this.find('[name="audio"]').val('true');
            }

            $this.find('[name="competitionNotification"]')
                .val(window.USER_SETTINGS.competitionNotification);
            $this.find('[name="charTable[]"] option').each(function () {
                var $this = $(this);

                if (replaceTableStringify.indexOf((JSON.parse($this.attr('value')) || []).join('-')) > -1) {
                    $this.attr('selected', 'selected');
                }
            });
        });
    }

    function setTable() {
        replaceTable = window.MATH_CHAR_REPLACE_TABLE;
        if (window.USER_SETTINGS && window.USER_SETTINGS.hasOwnProperty('charTable')) {
            replaceTable = window.USER_SETTINGS.charTable;
        }
    }

    function replace(input) {
        if (replaceTable.length && input && input.replace) {
            replaceTable.forEach(function (item) {
                if (item && item.length === 2) {
                    input = input.replace(new RegExp('\\' + item[0], 'g'), item[1]);
                }
            });
        }
        return input;
    }

    function successUISettings(response) {
        if (response.success) {
            APP.Layout.openOverlay('success-ui-settings');
            replaceTable = response.result.charTable;
            window.USER_SETTINGS.audio =  response.result.audio;
            window.USER_SETTINGS.competitionNotification =  response.result.competitionNotification;
            APP.ProblemWorker.sendRequest({method: 'addReplaceTable', data: replaceTable});
        }
    }

    exports.init = init;
    exports.replaceMathCharacters = replace;
    exports.successUISettings = successUISettings;
    exports.getReplaceTable = function () {
        setTable();
        return replaceTable;
    };

    return exports;

})();

var FormulaMagicNumber = 5;

APP.Formula = (function () {
    var exports = {},
        initialized = false;

    function init() {
        fillFormulas();
        fillVisibleFormulas();
        initBindings();
        initialized = true;
    }

    function fillFormulas($wrapper, force) {
        $wrapper = $wrapper || $body;

        $wrapper.find('[data-f]:not(.filled)').each(function () {
            var $this = $(this);

            if (force || $this.parents('[data-onscroll-cosmetic]').length === 0) {
                $this.addClass('filled');
                APP.ProblemWorker.getDom($this.attr('data-f'), $this.attr('data-f-mode')).then(function (dom) {
                    $this.find('[data-f-content]').html(dom);
                    cosmeticFormulaByWrapper($this);
                    // APP.Formula.cosmeticFormulaByWrapper($body.find('[data-cosmetic-formulas]'));
                    async(function () {
                        $this.addClass('loaded');
                    });
                });
            }
        });

        $wrapper.find('[data-fromto]:not(.filled)').each(function () {
            var $this = $(this);

            if (force || $this.parents('[data-onscroll-cosmetic]').length === 0) {
                $this.addClass('filled');
                APP.ProblemWorker.getDom({
                    from: $this.attr('data-from'),
                    to: $this.attr('data-to'),
                    action: $this.attr('data-action'),
                    vertical: $this.attr('data-vertical') === 'true'
                }, 'fromto').then(function (dom) {
                    $this.html(dom);
                    cosmeticFormulaByWrapper($this);
                    async(function () {
                        $this.addClass('loaded');
                    });
                });
            }
        });
    }

    function fillVisibleFormulas() {
        $body.find('[data-onscroll-cosmetic]').each(function () {
            var $this = $(this);
            if ($this.visible()) {
                fillFormulas($this, true)
            }
        });
    }

    function initBindings() {
        if (!initialized) {
            document.onscroll = fillVisibleFormulas;
        }
    }

    function cosmeticFormulaByWrapper($wrapper) {
        if ($wrapper.length > 0) {
            if ($wrapper.find('[data-f]:not(.filled)').length === 0) {
                setAllParenthesis($wrapper);
                setAllSupSubAlignment($wrapper);
                APP.Formula.Setup.setUpElement($wrapper);
            } else {
                async(function () {
                    cosmeticFormulaByWrapper($wrapper);
                });
            }

        }
    }

    function setAllParenthesis($wrapper) {
        var selector = '[data-parenthesis]:not([data-formula-ghost-p="inactive"])',
            $elements = $wrapper.find(selector);

        $($elements.get().reverse()).each(function () {
            var $this = $(this);

            $this.parents(selector).first().attr('data-parenthesis-type', getParentParenthesisType($this));
        });

        function getParentParenthesisType($this) {
            var type = $this.attr('data-parenthesis-type');

            switch (type) {
                case '3':
                    return 1;
                case '2':
                    return 3;
                case '1':
                default:
                    return 2;
            }
        }
    }

    function setAllSupSubAlignment($wrapper) {
        $wrapper.find('[data-sup-sub="setted"]').attr('data-sup-sub', 'not-set');
        iterateExpSubs($wrapper);

        function iterateExpSubs($element) {
            var $elements = $element.find('[data-sup-sub="not-set"].exp-sup');

            $($elements.get().reverse()).each(function () {
                handleSubSupIfReady($(this));
            });

            function handleSubSupIfReady($this) {
                handleSubSup($this);
            }

            function handleSubSup($this) {
                var height = $this.parent().find('>.inline-block').height();

                $this.css('margin-bottom', Math.max(height * 0.6, height - 15));
                $this.attr('data-sup-sub', 'setted');
            }
        }
    }

    exports.init = init;
    exports.cosmeticFormulaByWrapper = cosmeticFormulaByWrapper;
    exports.fillFormulas = fillFormulas;
    exports.fillVisibleFormulas = fillVisibleFormulas;
    return exports;

})();

APP.Formula.Setup = (function () {
    // TODO REVIEW!

    var exports = {},

        elementSelector,
        fitBoxSelector,
        calculatorActually,

        wGroupSeeker = 0;

    function setUpElement($wrapper) {
        elementSelector = '[data-formula]';
        fitBoxSelector = '[data-fit-box]';
        calculatorActually = false;

        if ($wrapper.find('[data-calculator-element]').length > 0) {
            elementSelector = '[data-calculator-element]:not([data-calculator-element-type="wrapper"])';
            calculatorActually = true;
        }
        $wrapper.find('.skipme').removeClass('skipme');
        $wrapper.find(elementSelector).each(function () {
            var $element = $(this),
                dimension = getDimensionOfElement($element);

            if ($element.parent().find('> ' + elementSelector).length < 2) {
                $element.addClass('skipme');
            }

            if ($element.attr('data-calculator-element-type') === 'log') {
                $element.find('> [data-formula="log"] > div > [data-formula-part="fnsub"]')
                    .css('padding-top', (dimension.top - 5) + 'px');
            } else if ($element.attr('data-formula') === 'log') {
                $element.find('> div > [data-formula-part="fnsub"]')
                    .css('padding-top', (dimension.top) + 'px');
            }
        });

        $wrapper.find('[data-wgroup]').removeAttr('data-wgroup');

        setUpElements(getFormula($wrapper));
        APP.Operations.init();
    }

    function getFormula($element) {
        return $element.find(elementSelector)
            .not($element.find(elementSelector + ' ' + elementSelector))
            .not($element.find(fitBoxSelector + ' ' + elementSelector))
    }

    function getFitBox($element) {
        return $element.find(fitBoxSelector)
            .not($element.find(elementSelector + ' ' + fitBoxSelector));
    }


    function getDimensionOfElement($element) {

        var returnDimension = {top: 0},
            fitBoxDimension,

            $fitBox = getFitBox($element),
            $child = getFormula($element);

        if ($fitBox.length > 0) {
            setUpElements($child);
            fitBoxDimension = getDimensionOfFitBox($fitBox);
            returnDimension.top = ($fitBox.offset().top - $element.offset().top - (calculatorActually ? 5 : 0)) + fitBoxDimension.top;
            if ($fitBox.find('> [data-calculator-element-type="wrapper"] > .calculator--placeholder').length > 0) {
                returnDimension.top += (calculatorActually ? 5 : 0);
            }
        } else if ($child.length > 0) {
            returnDimension = setUpOneLevelElements($child);
        } else {
            returnDimension.top = $element.outerHeight() / 2;
        }

        return returnDimension;

    }

    function getDimensionOfFitBox($fitBox) {
        var $child = getFormula($fitBox);
        if ($child.length > 0) {
            return setUpOneLevelElements(getFormula($fitBox));
        }
        return {top: $fitBox.outerHeight() / 2};
    }

    function getDimensionOfElements($elements) {
        var $this,
            dimension,
            returnDimension = {top: 0};

        $elements.each(function () {
            $this = $(this);
            dimension = getDimensionOfElement($this);
            if (dimension.top > returnDimension.top) {
                returnDimension.top = dimension.top;
            }

        });

        return returnDimension;

    }

    function setUpElements($child) {
        var $this,
            $parent;

        $child.each(function () {
            $this = $(this);
            $parent = $this.parent();
            if (!$parent.attr('data-wgroup')) {
                $parent.attr('data-wgroup', ++wGroupSeeker);
                setUpOneLevelElements($parent.find('> ' + elementSelector));
            }
        });
    }

    function setUpOneLevelElements($elements) {
        var $this,
            dimension,
            groupDimension = getDimensionOfElements($elements),
            negativeMargin = 0;

        if ($elements.length > 1) {
            $elements.each(function () {
                $this = $(this);
                dimension = getDimensionOfElement($this);
                negativeMargin = Math.min(calculatorActually ? -5 : 0, parseInt($this.css('margin-top'), 10));
                $this.css('margin-top', negativeMargin + groupDimension.top - dimension.top);
            });
        }
        return groupDimension;
    }

    exports.setUpElement = setUpElement;
    return exports;

})();
APP.Premium = (function () {

	var exports = {};

	function init() {

	}

	function successWallOfLoveApply() {

	}

	function successPremiumSent() {

	}


	exports.init = init;
	exports.successWallOfLoveApply = successWallOfLoveApply;
	exports.successPremiumSent = successPremiumSent;
	return exports;

})();
APP.Problem = (function () {
    var exports = {},
        $problemWrapper,
        animationDuration = 150,
        resizeTimer = null,
        inited = false,
        $header,
        $htmlBody,

        problemId,
        problemSource,

        actualRowIndex;

    function init() {
        $problemWrapper = $body.find('[data-problem]');
        $header = $body.find('[data-header-gutter]');
        $htmlBody = $('html, body');
        problemId = $problemWrapper.attr('data-id');
        problemSource = $problemWrapper.attr('data-source');
        initBindings();

        if ($problemWrapper.length > 0) {
            $problemWrapper.attr('data-problem', 'initialized');
            APP.ProblemWorker.buildResult(problemId).then(function () {
                clearTimeout(resizeTimer);
                $problemWrapper.attr('data-problem', 'initialized');
                onResize();
                APP.Formula.cosmeticFormulaByWrapper($problemWrapper);
                /*
                    var $mainRows = $body.find('[data-formulas-root] > [data-row-aceholder]');

                    if ($mainRows.length <= 2) {
                        async(function () {
                            $mainRows.first().find('> [data-problem-main-row]').trigger('click');
                        });
                    }
                */
            });
        }
    }

    function initBindings() {
        $body.find('[data-pillar-scroller]').on('scroll', function () {
            $body.find('[data-problem-scroll-wrapper]').parent()
                .css('overflow', 'hidden')
                .scrollLeft($(this).scrollLeft());
        });

        if (!inited) {
            $body.on('click', '[data-problem-row]', clickOnRow);
            $body.on('click', '[data-open-all-main-row]', toggleAllMainRow);
            $body.on('click', '.button[data-academy-trigger]', function () {
                loadAcademyItem($(this));
            });
            $body.on('click', '[data-academy-overlay-trigger]', loadAcademyOverlay);

            $body.on('click', '[data-blank-href]', function () {
                window.open($(this).attr('data-blank-href'));
            });

            $body.on('click', '[data-main-row-close]', function (e) {
                var $row = $(this).parents('[data-problem-main-row]');
                if ($row.attr('data-problem-main-row') === '1') {
                    $row.attr('data-problem-main-row', '0');
                    e.stopPropagation();
                }
            });

            $body.on('click', '[data-problem-main-row] > .problem--border > .problem--row__close', function (e) {
                var $row = $(this).parents('[data-problem-main-row]');

                if (!$row.hasClass('problem--multiple-main-row') && $row.attr('data-row-fullymarked') !== 'true') {
                    async(function () {
                        $row.attr('data-problem-main-row', '1');
                    });
                }

            });

            $body.on('click', '[data-open-secondary-child]', function () {
                var $row = $(this).parents('[data-problem-row]').first();

                $row.removeClass('problem--open-primary-child').addClass('problem--open-secondary-child');
            });

            $body.on('click', '[data-open-primary-child]', function () {
                var $row = $(this).parents('[data-problem-row]').first();

                $row.removeClass('problem--open-secondary-child').addClass('problem--open-primary-child');
            });
            $window.on('resize', onResize);
            $window.on('scroll', APP.ProblemWorker.checkMainRows);
            inited = true;
        }

    }

    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initVerticalScroll, 150);
    }

    function logRowClick($row, event) {
        var open = $row.hasClass('problem--row-hide'),
            deep = $row.parents('[data-problem-row]').length,
            mainRow = $row.attr('data-problem-main-row') === '0';

        if (open && event.originalEvent !== undefined) {
            if (mainRow) {
                APP.Analytics.logCustomUserEvent('view-main-row');
            } else if ($row.attr('data-academy-trigger')){
                APP.Analytics.logCustomUserEvent('view-pictogram');
            } else {
                APP.Analytics.logCustomUserEvent('view-multilevel');
            }
        }

        APP.Analytics.trackEvent('problem', open ? 'open' : 'close', mainRow ? 'mainRow' : 'row', {
            problemId: problemId,
            deep: deep,
            source: problemSource
        });

    }

    function clickOnRow(event) {
        var $row = $(this),
            open = $row.hasClass('problem--row-hide'),
            mainRowPhase;

        event.stopPropagation();
        event.preventDefault();
        logRowClick($row, event);

        if (!$row.hasClass('problem--row-no-child')) {
            mainRowPhase = $row.attr('data-problem-main-row');
            if (mainRowPhase) {
                if (open) {
                    animateToAutoHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                    closeAllNotParent($row);
                    closeMainRows();
                    $row.attr('data-problem-main-row', 2);
                    openRow($row);
                } else {
                    if ($row.parents('[data-problem-main-row]').length === 0) {
                        closeMainRows();
                        animateToNullHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                        $row.attr('data-problem-main-row', 0);
                        closeRow($row);
                    } else {
                        closeMainRows();
                        animateToAutoHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                        $row.attr('data-problem-main-row', 1);
                        closeRow($row);
                    }
                }
            } else {
                if (open) {
                    openRow($row);
                } else {
                    closeRow($row);
                    activateRowIndexes($row.parents('[data-problem-row]').first());
                }
            }
        }
    }

    function activateRowIndexes($row) {
        if (window.USER_SETTINGS.autoCollapseProblem) {
            $problemWrapper.find('.problem--index--active').removeClass('problem--index--active');
            $row.find('.problem--child .problem--index').addClass('problem--index--active');
        } else {
            $row.find('.problem--index:not(.problem--index--active)').addClass('problem--index--active');
        }
    }

    function closeMainRows() {
        var $this;
        if (window.USER_SETTINGS.autoCollapseProblem && false) {
            $problemWrapper.find('[data-problem-main-row]:not([data-problem-main-row="0"])').each(function () {
                $this = $(this);
                $this.attr('data-problem-main-row', 0);
                closeRow($this, true);
            });
        }
    }

    function loadAcademyItem($this) {
        var $wrapper = $body.find($this.attr('data-academy-trigger')).not('[data-academy-loaded]'),
            index = parseInt($this.attr('data-academy-index'), 10),
            open = $this.hasClass('problem--row-hide');

        if (index === 0) {
            index = 'first';
        } else {
            index--;
        }

        APP.Analytics.trackEvent('problem', $this.hasClass('problem--row-hide') ? 'open' : 'close', 'academy', {
            traceid: $this.attr('data-traceid'),
            problemid: problemId,
            source: problemSource
        });

        if ($wrapper.length === 0) {
            return;
        }

        APP.Page.getContentOfUrl($this.attr('data-href'), '[data-ajax-content-' + index + ']', function (source) {
            $wrapper.attr('data-academy-loaded', true).html(source);
            APP.Formula.fillFormulas();
        }, true);
    }

    function loadAcademyOverlay(event) {
        var $this = $(this);

        event.stopPropagation();
        event.preventDefault();

        APP.Analytics.trackEvent('problem', 'open', 'academy-overlay', {
            traceid: $this.attr('data-traceid'),
            url: $this.attr('data-href'),
            problemid: problemId,
            source: problemSource
        });

        if ($this.attr('data-href')) {
            APP.Page.getContentOfUrl($this.attr('data-href'), '[data-ajax-content]', function (result) {
                $body.find('[data-academy-overlay]').html(result);
                APP.Formula.fillFormulas();
                APP.Layout.openOverlay('academy-item');
            });

        }

    }

    function toggleAllMainRow() {
        if (!putAllMaiRowInSecondPhase()) {
            animateToNullHeight($body.find('[data-problem-mainrow-accordion]'));
            $body.find('[data-problem-main-row]').attr('data-problem-main-row', 0);
            $body.find('[data-problem-main-row]').each(function () {
                var $row = $(this);
                closeRow($row);
            });
        } else {
            animateToAutoHeight($body.find('[data-problem-mainrow-accordion]'));
            $body.find('[data-problem-main-row="2"]').each(function () {
                var $this = $(this);
                if (!$this.find('[data-problem-main-row]').length) {
                    closeRow($(this));
                }
            });
            $body.find('[data-problem-main-row]').attr('data-problem-main-row', 1);
            $body.find('[data-problem-main-row].problem--multiple-main-row').each(function () {
                $(this).attr('data-problem-main-row', 2);
                openRow($(this), true);
            });
        }

    }

    function putAllMaiRowInSecondPhase() {
        return $body.find('[data-problem-main-row="0"]').length > 1;
    }


    function findInRow($row, selector) {
        return $row.find(selector).not($row.find('[data-problem-gate] ' + selector));
    }

    function openRow($row, preventScrollTo) {
        var hasMultipleOpener = $row.find('> div .problem--wrapper > .problem--toggler-button--wrapper > [data-open-secondary-child]').length > 0
            && !$row.hasClass('problem--multiple-main-row');

        styleRow($row);
        $row.find('[data-operation].show').removeClass('show');
        setTimeout(function() {
            $row.find('[data-operation]').addClass('show');
        }, 120);

        APP.ProblemWorker.openRow($row.parents('[data-row-placeholder]').attr('data-row-placeholder'));
        if ($row.attr('data-academy-trigger')) {
            loadAcademyItem($row);
        }

        if (hasMultipleOpener && !$row.hasClass('problem--open-primary-child') && !$row.hasClass('problem--open-secondary-child')) {
            // prevent open because of multiple opener.
        } else if ($row.hasClass('problem--row-hide')) {
            var $childWrapper = findInRow($row, '[data-problem-child]');
            closeAllNotParent($row);
            actualRowIndex = parseInt($row.attr('data-row-index'), 10);


            animateToAutoHeight(findInRow($row, '[data-problem-accordion]'), function () {
                $row.removeClass('problem--row-hide');
                fadeIn($childWrapper, function () {
                    $childWrapper
                        .removeClass('problem--child-no-gutter')
                        .removeClass('problem--child-hide');
                    findInRow($childWrapper, '[data-problem-row]:not(.problem--row-never-borderize)')
                        .addClass('problem--row-borderize');
                    if (!preventScrollTo) {
                        setTimeout(function () {
                            scrollToRow($row);
                        }, 300);
                    }
                });
            });
        }
        activateRowIndexes($row);
    }

    function closeAllNotParent($row) {
        var $this;

        if (window.USER_SETTINGS.autoCollapseProblem && false) {
            $problemWrapper.find('.problem--row-open-it').removeClass('problem--row-open-it');
            $row.addClass('problem--row-open-it');
            $problemWrapper.find('.problem--row:not(.problem--row-hide)').each(function () {
                $this = $(this);
                if (
                    $this.find('.problem--row-open-it').length === 0 &&
                    (
                        $this.parents('.problem--row:not(.problem--row-hide)').find('.problem--row-open-it').length > 0 ||
                        $this.parents('.problem--row:not(.problem--row-hide)').length === 0
                    )
                ) {
                    closeRow($this, actualRowIndex < parseInt($row.attr('data-row-index'), 10));
                    $this.addClass('problem--row-hide');

                }
            });
        }

    }

    function styleRow($row) {
        styleFormulas(getSubRowFormulas($row));
    }

    function styleFormulas($formula) {
        var $this;
        $formula.each(function () {
            $this = $(this);
            if ($this.attr('data-formula-styled') !== 'true') {
                $this.attr('data-formula-styled', 'true');
                APP.Formula.cosmeticFormulaByWrapper($this);
                styleMessage($this);
            }
        });
    }

    function styleMessage($this) {
        $this.find('[data-message-insert]').each(function () {
            var $insert = $(this),
                $formulaTest = $insert.find('[data-formula-test]'),
                topDistance = parseInt($formulaTest.css('margin-top'), 10),
                bottomDistance = $insert.height() - $formulaTest.height() - topDistance;
            $insert.css({
                'margin-bottom': Math.max(0, topDistance - bottomDistance),
                'margin-top': Math.max(0, bottomDistance - topDistance)
            });
        });
    }

    function getSubRowFormulas($row) {
        var $rowArea = $row.find('[data-problem-row]').not($row.find('[data-problem-row] [data-problem-row]'));
        return findInRow($rowArea, '.problem--formula-wrapper');
    }

    function closeRow($row, preventScroll) {
        APP.ProblemWorker.closeRow($row.parents('[data-row-placeholder]').attr('data-row-placeholder'));
        $body.find('.problem--open-secondary-child, .problem--open-primary-child')
            .removeClass('problem--open-secondary-child')
            .removeClass('problem--open-primary-child');


        if (preventScroll || true) {
            var originalHeight = $row.outerHeight(),
                scrollTop = document.body.scrollTop;

            $row.find('[data-operation]').removeClass('show');
            $row.addClass('notransition');
            $row.css('height', '');
            closeRowViaClass($row);
            $row.removeClass('notransition');
            if ($row.attr('data-problem-main-row')) {
                $row.attr('data-problem-main-row', '0');
            }
            if ($row.offset().top + originalHeight < scrollTop + window.innerHeight / 2)
                async(function () {
                    bodyScroll(scrollTop + $row.outerHeight() - originalHeight);
                });
        } else {
            animateToNullHeight(findInRow($row, '[data-problem-accordion]'), function () {
                closeRowViaClass($row);
            });
        }


        if ($row.attr('data-problem-main-row')) {
            $row.attr('data-problem-main-row', '0');
        }

        function closeRowViaClass($actualRow) {
            $actualRow.addClass('problem--row-hide');
            $actualRow.find('[data-problem-row]')
                .addClass('problem--row-hide')
                .removeClass('problem--row-borderize');
            $actualRow.find('[data-problem-child]')
                .addClass('problem--child-no-gutter')
                .addClass('problem--child-hide');

        }

    }

    function bodyScroll(distance) {
        document.body.scrollTop = distance;
        if (distance < 0) {
            $header.addClass('no-transition');
            $header.css('padding-top', -distance);
            async(function () {
                $header.removeClass('no-transition');
                $header.css('padding-top', 0);
            });
        }
    }

    function initVerticalScroll() {
        var $pillarBox = $body.find('[data-problem-pillar-wrapper]'),
            $scrollWrapper = $body.find('[data-problem-scroll-wrapper]'),
            gutter = 30,
            contentWidth,
            wrapperWidth;

        $pillarBox.removeClass('pillar-box--scroller');
        $pillarBox.removeClass('pillar-box--growing');
        $scrollWrapper.css('width', 'auto');
        contentWidth = $scrollWrapper.outerWidth();
        wrapperWidth = $pillarBox.outerWidth();
        $scrollWrapper.css('width', '100%');

        $body.find('[data-pillar-scroller] div').css('width', 0);

        if (contentWidth > wrapperWidth) {
            $pillarBox.addClass('pillar-box--growing');
            if (contentWidth > $window.width() - gutter) {
                $pillarBox.addClass('pillar-box--scroller');
                $body.find('[data-pillar-scroller] div').css('width', $scrollWrapper.outerWidth() + gutter);
            } else {
                $pillarBox.removeClass('pillar-box--scroller');
            }

        }

    }

    function animateToAutoHeight($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);

            if ($element.height() !== 0) {
                return;
            }

            $element.css('height', 'auto');
            if (!index && callback) {
                callback();
            }
            $element.css('height', 0);
            async(function () {
                $element.css('height', '');
            });
        });
    }

    function animateToNullHeight($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);

            if ($element.height() === 0) {
                return;
            }
            $element.css('height', '');
            if (!index && callback) {
                callback();
            }
        });
    }

    function fadeIn($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);
            $element.animate({
                opacity: 1
            }, {
                duration: animationDuration,
                queue: false,
                complete: function () {
                    callback();
                    $element.css('opacity', '');
                }
            });
        });
    }

    function scrollToRow($row) {
        var winHeight = $window.height() - 60,
            rowHeight = $row.height(),
            rowTop = $row.offset().top,
            scrollTop = rowTop - Math.min(Math.max(0, winHeight - rowHeight), winHeight),
            winScrollTop = $window.scrollTop();

        if (winScrollTop < scrollTop) {
            $htmlBody.animate({scrollTop: scrollTop - 60}, 300);
        } else if (rowTop < winScrollTop || (rowTop + rowHeight) > (scrollTop + winHeight)) {
            $htmlBody.animate({scrollTop: rowTop - 60}, 300);
        }

    }

    exports.init = init;
    exports.scrollToRow = scrollToRow;
    exports.initVerticalScroll = initVerticalScroll;
    exports.onResize = onResize;
    exports.openRow = openRow;
    return exports;

})();

APP.NewsFeed = (function () {

    var exports = {},
        initialized = false,
        windowFocused = true,
        windowFocusedCallback = false,
        latestRefresh = new Date(0),

        refreshCallback,

        storyTimer = {},

        actualFeedFilterId = 'all';

    function init() {
        initBindings();
        loadNewsFeed();
        refreshUnapprovedUsers();
        // refreshLearnPeriod();
        $body.find('[data-newsfeed-story-initialize]').each(function () {
            refreshStory($(this).attr('data-newsfeed-story'));
        });
        $body.find('[data-period-src]').each(function () {
            var $this = $(this);
            renderLearnPeriod($this, JSON.parse($this.attr('data-period-src')));
        });
    }

    function loadNewsFeed(reset) {
        $body.find('[data-newsfeed]').each(function () {
            var $this = $(this);

            if (reset) {
                $this.html('<div class="newsfeed__item newsfeed__item--loading" data-hide-when-loaded></div>'.repeat(4));
            }
            initNewsFeed($this, $this.attr('data-newsfeed'));
        });
    }

    function renderLearnPeriod($container, ctx) {
        APP.ProblemWorker.run('learn-period', ctx).then(function (response) {
            $container.html(response);
            APP.Formula.fillFormulas();
            APP.Layout.setMoments();
            // APP.Live.watchMetas();
        });
    }

    function initBindings() {
        if (!initialized) {
            initialized = true;
            setTimeout(function () {
                autoRefreshGroup(15000);
            }, 15000);

            window.addEventListener('focus', function (event) {
                windowFocused = true;
                if (windowFocusedCallback) {
                    windowFocusedCallback();
                }
            }, false);

            window.addEventListener('blur', function (event) {
                windowFocused = false;
            }, false);

            $body.on('click', '[data-newsfeed-refresh]', function () {
                APP.Page.reloadPage();
            });

            $body.on('click', '[data-newsfeed-load-more]', function () {
                var $this = $(this);
                $this.hide();
                initNewsFeed(
                    $this.parent(),
                    $body.find('[data-newsfeed]').attr('data-newsfeed'),
                    {before: $this.attr('data-newsfeed-load-more')},
                    true
                );
            });

            $body.on('click', '[data-like-story]', function (event) {
                var $this = $(this),
                    $counter = $this.find('[data-count]'),
                    index = parseInt($counter.text()) || 0;

                event.stopPropagation();
                likeUnLikeStory(true, $this.attr('data-like-story'));
                $this.addClass('button--red').removeClass('button--gray');
                $counter.text(++index);
            });

            $body.on('click', '[data-unlike-story]', function (event) {
                var $this = $(this),
                    $counter = $this.find('[data-count]'),
                    index = parseInt($counter.text()) || 0;
                event.stopPropagation();
                likeUnLikeStory(false, $this.attr('data-unlike-story'));
                $this.removeClass('button--secondary').addClass('button--gray');
                $counter.text(--index || '');
            });

            $body.on('click', '[data-newsfeed-story]', function () {
                var id = $(this).attr('data-newsfeed-story');
                refreshStory(id);
            });

            $body.on('click', '[data-show-group-users]', function () {
                var targetId = $(this).attr('data-show-group-users');
                loadUsersList('group-users', targetId);
            });

            $body.on('click', '[data-show-unapproved-users]', function () {
                var targetId = $(this).attr('data-show-unapproved-users');
                loadUsersList('group-unapproved-users', targetId);
            });

            $body.on('click', '[data-show-story-likes]', function () {
                var targetId = $(this).attr('data-show-story-likes');
                loadUsersList('story-likes', targetId);
            });

            $body.on('click', '[data-group-show-details]', function () {
                var $this = $(this),
                    $item,
                    details = JSON.parse(base64Decode($this.attr('data-group-show-details'))),
                    rule = '<style>[data-newsfeed-story="' + $this.parents('[data-newsfeed-story]').attr('data-newsfeed-story') + '"] [data-group-show-details] { display:none; }</style>';

                if (((details.details || {}).problem || {}).solutionLink) {
                    var solutionDataParts = details.details.problem.solutionLink.split('/'),
                        solutionData;

                    if (solutionDataParts.length > 2) {
                        solutionData = solutionDataParts[3];
                        try {
                            solutionData = JSON.parse(base64Decode(solutionData));
                            if ((solutionData.clone || {}).message) {
                                details.details.problem.instruction = solutionData.clone.message;
                            }
                        } catch (e) {
                            console.log('error', e);
                        }
                    }
                }

                APP.ProblemWorker.run('newsfeed-input-details', details).then(function (result) {
                    $item = $this.parents('.newsfeed__item').first().find('[data-nf-input-details]');
                    $item.html(result);
                    $(rule).insertAfter($item);
                    APP.Formula.cosmeticFormulaByWrapper($item);
                });
            });

            $body.on('click', '[data-open-overlay="new-group-challenge"]', function () {
                APP.Ajax.post('/en-US/service/get-user-list', {
                    listType: 'group-users',
                    targetId: $body.find('[data-actual-group-id]').attr('data-actual-group-id')
                }).then(function (result) {
                    if (result.success) {
                        APP.Form.searchSelect($body.find('[data-search-select-challenge]')[0]);
                        $body.find('[data-challenge-users-list]').html(
                            APP.Tpl.run('challenge-users-list', result.result)
                        );
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-refresh-user-list]', function () {
                if (refreshCallback) {
                    refreshCallback();
                }
            });

            $body.on('click', '[data-user-action]', function () {
                var $this = $(this),
                    action = $this.attr('data-user-action').split(':'),
                    actionName = action[0],
                    targetId = action[1],
                    groupId = $body.find('[data-actual-group-id]').attr('data-actual-group-id');

                APP.Ajax.post('/en-US/service/group/action', {
                    actionName: actionName,
                    targetId: targetId,
                    groupId: groupId
                }).then(function (response) {
                    if (response.success) {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('success-action');
                        APP.Layout.onOverlayClose(function () {
                            APP.Page.reloadPage();
                        });
                    } else {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('fail-action');
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-user-edit]', function () {
                var $this = $(this),
                    attr = $this.attr('data-user-edit').split('::'),
                    id = attr[0],
                    email = attr[1],
                    name = attr[2],
                    $overlay,
                    groupId = $body.find('[data-actual-group-id]').attr('data-actual-group-id');

                if (email.indexOf('/') > -1) {
                    $overlay = $body.find('[data-overlay="edit-user-name"]');
                    $overlay.find('[name="name"]').val(name);
                    $overlay.find('[name="userId"]').val(id);
                    $overlay.find('[name="groupId"]').val(groupId);
                    APP.Layout.openOverlay('edit-user-name');
                } else {
                    $overlay = $body.find('[data-overlay="edit-user-email"]');
                    $overlay.find('[name="email"]').val(email);
                    $overlay.find('[name="userId"]').val(id);
                    $overlay.find('[name="groupId"]').val(groupId);
                    APP.Layout.openOverlay('edit-user-email');
                }
            });

            $body.on('change', '[data-group-hide-user-actions]', function () {
                var $this = $(this),
                    checked = $this.prop('checked');

                APP.User.setSetting('hide-user-activity-in-group', checked).then(function () {
                    loadNewsFeed(true);
                });
            });

            $body.on('click', '[data-delete-group]', function () {
                var $this = $(this),
                    groupId = $this.attr('data-delete-group'),
                    password = $body.find('[data-delete-password]').val();

                APP.Ajax.post('/en-US/service/group/delete', {
                    groupId: groupId,
                    password: password
                }).then(function (result) {
                    if (result.success) {
                        APP.Layout.openOverlay('success-delete-group');
                        APP.Layout.onOverlayClose(function () {
                            APP.Page.applyPageByUrl('/en-US/');
                        });
                    } else {
                        APP.Layout.openOverlay('failed-delete-group');
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-feed-filter]', function (e) {
                var $this = $(this),
                    feedFilterId = $this.attr('data-feed-filter');

                actualFeedFilterId = feedFilterId;
                loadNewsFeed(true);
                $body.find('[data-feed-filter]')
                    .removeClass('button--gray')
                    .addClass('button--white');
                $body.find(`[data-feed-filter="${feedFilterId}"]`)
                    .addClass('button--gray')
                    .removeClass('button--white');
                e.preventDefault();
                e.stopPropagation();
            });

        }
    }

    function initNewsFeed($wrapper, serviceUrl, data, ignoreCount) {
        serviceUrl += document.location.search;
        data = data || {};
        if (!window.USER_SETTINGS['hide-user-activity-in-group']) {
            data.feedFilterId = actualFeedFilterId;
        }
        return APP.Ajax.post(serviceUrl, data).then(function (result) {
            var firstDate = result.result.firstDate;
            var count = result.result.count;

            if (new Date(firstDate) > new Date(latestRefresh)) {
                latestRefresh = firstDate;
                $body.find('[data-newsfeed-first-date]').attr('data-newsfeed-first-date', latestRefresh);
            }
            $wrapper.find('[data-hide-when-loaded]').hide();
            APP.ProblemWorker.run('newsfeed', result.result).then(function (result) {
                $wrapper.prepend(result);
                APP.Layout.setMoments();
                APP.Formula.fillFormulas();
            });
            if (count && !ignoreCount) {
                Object.keys(count).forEach(function (key) {
                    $body.find(`[data-feed-filter="${key}"] span`).text(`(${count[key]})`);
                });
            }
        }, window.NOOP);
    }

    function loadNewNewsFeedContent($wrapper, serviceUrl, data) {
        serviceUrl += document.location.search;

        return APP.Ajax.post(serviceUrl, data, true).then(function (result) {
            var firstDate = result.result.firstDate;
            var count = result.result.count;
            var $item, value;

            if (new Date(firstDate) > new Date(latestRefresh)) {
                latestRefresh = firstDate;
                $body.find('[data-newsfeed-first-date]').attr('data-newsfeed-first-date', latestRefresh);
            }
            $wrapper.find('[data-hide-when-loaded]').hide();
            if (result.result.items) {
                APP.ProblemWorker.run('newsfeed', result.result).then(function (result) {
                    $wrapper.prepend(result);
                    APP.Layout.setMoments();
                    APP.Formula.fillFormulas();
                });
            }
            if (count) {
                Object.keys(count).forEach(function (key) {
                    if (count[key] > 0) {
                        $item = $body.find(`[data-feed-filter="${key}"] span`);
                        value = $item.text();
                        value = parseInt(value.substr(1, value.length - 2), 10);
                        $item.text(`(${(value + count[key])})`);
                    }
                });
            }
        }, window.NOOP);
    }

    function refreshLearnPeriod() {
        var $wrapper = $body.find('[data-period-wrapper]'),
            url = $wrapper.attr('data-period-wrapper') + document.location.search;

        if ($wrapper.length) {
            APP.Ajax.post(url, {}, true).then(function (result) {
                if (result.success) {
                    renderLearnPeriod($wrapper, result.period);
                }
            }, window.NOOP);
        }
    }

    function refreshUnapprovedUsers() {
        var $wrapper = $body.find('[data-group-unapproveds]'),
            $target = $body.find('[data-actual-group-id]');

        if ($wrapper.length + $target.length > 1) {
            APP.Ajax.post('/en-US/service/get-user-list', {
                listType: 'group-unapproved-users',
                targetId: $target.attr('data-actual-group-id')
            }, true).then(function (result) {
                if (result.success && result.result) {
                    if (result.userCount) {
                        $body.find('[data-group-users-count]').text(result.userCount[1]);
                    }
                    $wrapper.html(
                        APP.Tpl.run('group-unapproveds', {users: result.result['unapproved-group-member']})
                    );
                }
            }, window.NOOP);
        }
    }

    function refreshStory(storyId) {
        window.clearTimeout(storyTimer[storyId]);
        storyTimer[storyId] = window.setTimeout(function () {
            APP.Ajax.post('/en-US/service/story/refresh', {
                id: storyId
            }, true).then(function (result) {
                if (result.success) {
                    var $storyCard = $body.find('[data-newsfeed-story="' + storyId + '"]'),
                        $storyCardActions = $storyCard.find('[data-nf-card-actions]');
                    if ($storyCardActions.length) {
                        $storyCardActions.html(
                            APP.Tpl.run('newsfeed-card-actions', result.result)
                        );
                    } else {
                        $storyCard.html(APP.Tpl.run('newsfeed-card', result.result));
                        APP.Layout.setMoments();
                        APP.Formula.fillFormulas();
                    }
                }
            }, window.NOOP);
        }, 500);
    }

    function autoRefreshGroup(intervall) {
        windowFocusedCallback = false;
        if ($body.find('[data-actual-group-id]').length) {
            if (windowFocused) {
                refreshGroupPage();
                refreshLearnPeriod();
                refreshUnapprovedUsers();
                setTimeout(function () {
                    autoRefreshGroup(intervall);
                }, intervall);
            } else {
                windowFocusedCallback = function () {
                    autoRefreshGroup(intervall);
                };
            }
        } else {
            setTimeout(function () {
                autoRefreshGroup(intervall);
            }, intervall);
        }
    }

    function refreshGroupPage() {
        var $wrapper = $('<div />'),
            $nf = $body.find('[data-newsfeed]'),
            data = {after: latestRefresh};

        if (!window.USER_SETTINGS['hide-user-activity-in-group']) {
            data.feedFilterId = actualFeedFilterId;
        }
        $wrapper.prependTo($nf);
        loadNewNewsFeedContent($wrapper, $nf.attr('data-newsfeed'), data).then(function () {
            window.requestAnimationFrame(function () {
                $wrapper.find('[data-newsfeed-content]').remove();
            });
        });
    }

    function likeUnLikeStory(like, storyId) {
        APP.Ajax.post('/en-US/service/story/' + (like ? 'like' : 'unlike'), {
            id: storyId
        }).then(function () {
            refreshStory(storyId);
        }, window.NOOP);
    }

    function loadUsersList(listType, targetId) {
        APP.Ajax.post('/en-US/service/get-user-list', {
            listType: listType,
            targetId: targetId
        }).then(function (result) {
            if (result.success) {
                showUsersList(result.result, listType, targetId);
            }
        }, window.NOOP);
    }

    function showUsersList(users, listType, targetId) {
        $body.find('[data-users-list]').html(
            APP.Tpl.run('users-list', users)
        );
        refreshCallback = function () {
            loadUsersList(listType, targetId);
        };
        APP.Layout.openOverlay('users-list');
    }

    function reloadNewsFeedContent() {
        // todo be smarter here!
        APP.Page.reloadPage();
    }

    function redirectToGroup(result) {
        APP.Page.applyPageByUrl('/en-US/group/' + result.result);
    }

    function groupSettingsSaved() {
        APP.Layout.openOverlay('group-settings-saved');
    }

    function successCodeConnect(result) {
        var topic = result.message.topic,
            url = '/en-US/learn/' + (topic ? 'topic/' + topic : '');

        $body.find('[data-go-to-learn]').attr('href', url);
        APP.Layout.openOverlay('group-success-code-' + result.message.mode);
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl(url);
        });
    }

    exports.init = init;
    exports.reloadNewsFeedContent = reloadNewsFeedContent;
    exports.redirectToGroup = redirectToGroup;
    exports.groupSettingsSaved = groupSettingsSaved;
    exports.successCodeConnect = successCodeConnect;
    return exports;

})();

var Row = function () {
    var _self = this,
        _element,
        $element,

        id,
        callbacks = {open: [], close: [], check: []},

        filled = false,
        rendering = false,
        opened = false,
        visible,
        inGame = false;

    _self.Parent = null;
    _self.Children = [];

    _self.init = function (_$element, _Parent) {
        _element = _$element[0];
        $element = _$element;
        id = _$element.attr('data-row-placeholder');
        $element.addClass('problem-row-placeholder--inited');
        _self.Parent = _Parent;

        if (_self.Parent) {
            inGame = _self.Parent.isOpened();
            _self.Parent.onOpen(function () {
                inGame = true;
                checkOnScreen();
            });
            _self.Parent.onClose(function () {
                inGame = false;
            });
            _self.Parent.onCheck(checkOnScreen);
            _self.Parent.addChild(_self);
        } else {
            inGame = true;
            checkOnScreen();
        }
    };

    _self.getId = function () {
        return id;
    };

    _self.onOpen = function (callback) {
        callbacks.open.push(callback);
    };

    _self.onClose = function (callback) {
        callbacks.close.push(callback);
    };

    _self.onCheck = function (callback) {
        callbacks.check.push(callback);
    };

    _self.isOpened = function () {
        return opened;
    };

    _self.addChild = function (child) {
        _self.Children.push(child);
    };

    _self.getElement = function () {
        return $element;
    };

    _self.open = function () {
        opened = true;
        APP.ProblemWorker.fillPlaceholderStackByWrapper($element);
        callAll(callbacks.open);
        setTimeout(function () {
            _self.Children.forEach(function (child) {
                child.parentOpened();
            });
        }, 120);
    };

    _self.parentOpened = function () {
        if (amIOnlyChild()) {
            APP.Problem.openRow($element.find('> [data-problem-row]'), true);
        }
    };

    _self.close = function () {
        opened = false;
        callAll(callbacks.close);
        setTimeout(APP.ProblemWorker.checkMainRows, 300);
    };
    _self.check = function () {
        async(checkOnScreen);
    };

    function callAll(cb) {
        var i;
        for (i = 0; i < cb.length; i++) {
            cb[i]();
        }
    }

    function onScreen() {
        show();
    }

    function offScreen() {
        hide();
    }

    function show() {
        if (visible !== true) {
            $element.removeClass('problem-row-placeholder--hide');
            _element.style.height = 'auto';
            visible = true;
            APP.Problem.onResize();
            if (!filled) {
                render();
            }
        }
    }

    function hide() {
        if (visible !== false) {
            _element.style.height = _element.offsetHeight + 'px';
            $element.addClass('problem-row-placeholder--hide');
            visible = false;
            APP.Problem.onResize();
        }
    }

    function render() {
        rendering = true;
        filled = true;
        APP.ProblemWorker.getContent(id, function (content) {
            $element.html(content);
            prepare();
            window.requestAnimationFrame(function () {
                $element.addClass('problem-row-placeholder--loaded');
                rendering = false;
                window.requestAnimationFrame(function () {
                    APP.ProblemWorker.fillPlaceholderStackByWrapper($element);
                });
            });
        });
    }

    function prepare() {
        APP.Formula.cosmeticFormulaByWrapper($element);
    }

    function checkOnScreen() {
        if (inGame && !rendering) {
            var rect = _element.getBoundingClientRect(),
                clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                viewHeight = Math.max(clientHeight, window.innerHeight);

            if (rect.bottom < 0 || rect.top - viewHeight >= 0) {
                offScreen();
            } else {
                onScreen();
                if (opened || true) {
                    callAll(callbacks.check);
                }
            }
        }
    }

    function amIOnlyChild() {
        return _self.Parent && _self.Parent.Children.length <= 1;
    }

    return _self;

};

APP.Analytics = (function () {
    var exports = {},
        logedIn,
        initialized = false;

    function init() {
        logedIn = $body.find('.application').hasClass('user--logedin');
        userInitialization();
        initBindings();
    }

    function userInitialization() {
        if (!initialized) {
            if (window.TRACK && window.posthog) {
                if (logedIn) {
                    window.posthog.identify(String($body.find('[data-akriel-user-id]').attr('data-akriel-user-id')), {});
                } else if (new URLSearchParams(window.location.search).get('logout') === 'true') {
                    window.posthog.reset();
                }
            }
        }
        initialized = true;
    }

    function checkStuffs() {
        $body.find('[data-track-purchase]').each(function () {
            var $this = $(this),
                val = $this.attr('data-track-purchase').split(';');

            APP.Analytics.successPayment(val[0], val[1], val[2], val[3]);
        });
        $body.find('[data-track-custom]').each(function () {
            var $this = $(this),
                val = $this.attr('data-track-custom').split(';');

            APP.Analytics.logCustomUserEvent(val[0], val[1]);
        });
    }

    function phCapture(eventName, props) {
        if (!window.posthog) {
            console.log('send to posthog', eventName, props);
            return;
        }

        window.posthog.capture(eventName, props || {});
    }

    function pageView() {
        if (window.TRACK) {
            phCapture('$pageview', {
                url: document.location.pathname,
                title: document.title
            });
            logCustomUserEvent('page-view', {url: document.location.pathname, title: document.title});
            checkStuffs();
        }
    }

    function initBindings() {
        $body.on('click', '[data-ga-event]', logEvent);
        $window.focus(function () {
            trackEvent('window', 'focus');
            APP.Live.saveClientMeta('focus', true);
        }).blur(function () {
            trackEvent('window', 'blur');
            APP.Live.saveClientMeta('focus', '');
        }).on("beforeunload", function () {
            APP.Live.saveClientMeta('closed', true);
        });
    }

    function logEvent() {
        var $this = $(this),
            label = $this.attr('data-ga-event').split(':');

        trackEvent(label[0], 'click', label[1]);
    }

    function trackEvent(category, action, label, value) {
        sendLocalEvent(category, action, label, value);

        if (window.TRACK) {
            phCapture('ui event', {
                category: category,
                action: action,
                label: label,
                value: value
            });
        }
    }

    function trackFormSubmit(action, $form) {
        var data = serializeForm($form);

        logCustomUserEvent('form-submit', {data: data, action: $form.attr('action')});
        phCapture('form submitted', {data: data, action: $form.attr('action')});
    }

    function serializeForm($form) {
        var o = {},
            a = $form.serializeArray();

        $.each(a, function () {
            if (this.name.indexOf('password') > -1) {
                this.value = '***';
            }
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });

        return o;
    }

    function sendLocalEvent(category, action, label, value) {
        if (window.log) {
            console.log(window.TRACK ? 'track:' : 'not tracked:', [category || null, action || null, label || null, value || null]);
        }
    }

    function logError(error) {
        $.ajax({
            type: 'POST',
            url: '/en-US/service/analytics-error',
            dataType: 'json',
            data: {
                url: document.location.href,
                error: error
            }
        });
        if (window.posthog) {
            window.posthog.captureException(error, {
                url: document.location.href
            });
        }
    }

    function successPayment(billId, quantity, summary, currency) {
        var price = Math.round(summary / quantity);

        if (window.TRACK) {
            phCapture('purchase_completed', {
                bill_id: billId,
                quantity: quantity,
                revenue: summary,          // figyelj: PostHog jellemzően "minor unit" (pl. cent) szemléletet ír
                currency: currency,
                product: 'subscription',
                plan: quantity >= 10 ? 'group' : 'basic',
                unit_price: price
            });
        }

        logCustomUserEvent('purchase', {currency: currency, value: summary});
    }

    function logCustomUserEvent(type, data) {
        if (window.USER_LOGGED_IN && window.TRACK) {
            APP.Ajax.post('/en-US/service/log-custom-event', {
                type: type,
                data: data
            }, true).then(window.NOOP, window.NOOP);
        }
    }

    exports.init = init;
    exports.trackEvent = trackEvent;
    exports.trackFormSubmit = trackFormSubmit;
    exports.logError = logError;
    exports.successPayment = successPayment;
    exports.pageView = pageView;
    exports.logCustomUserEvent = logCustomUserEvent;
    exports.capture = phCapture;
    return exports;

})();


/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){var b;if("object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype||{},"isPrototypeOf"))return!1;for(b in a);return void 0===b||k.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c;
}catch(e){}O.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ca(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Fa(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ba.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Oa(a,b,c||(g?"border":"content"),d,f)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),
    void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g,hb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(hb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var ib=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!ib.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,ib.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b)}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var jb=a.location,kb=n.now(),lb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var mb=/#.*$/,nb=/([?&])_=[^&]*/,ob=/^(.*?):[ \t]*([^\r\n]*)$/gm,pb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,qb=/^(?:GET|HEAD)$/,rb=/^\/\//,sb={},tb={},ub="*/".concat("*"),vb=d.createElement("a");vb.href=jb.href;function wb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function xb(a,b,c,d){var e={},f=a===tb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function yb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function zb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Ab(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:jb.href,type:"GET",isLocal:pb.test(jb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":ub,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?yb(yb(a,n.ajaxSettings),b):yb(n.ajaxSettings,a)},ajaxPrefilter:wb(sb),ajaxTransport:wb(tb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=ob.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||jb.href)+"").replace(mb,"").replace(rb,jb.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=vb.protocol+"//"+vb.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),xb(sb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!qb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(lb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=nb.test(f)?f.replace(nb,"$1_="+kb++):f+(lb.test(f)?"&":"?")+"_="+kb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+ub+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=xb(tb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=zb(m,x,d)),u=Ab(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Bb=/%20/g,Cb=/\[\]$/,Db=/\r?\n/g,Eb=/^(?:submit|button|image|reset|file)$/i,Fb=/^(?:input|select|textarea|keygen)/i;function Gb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Cb.test(a)?d(a,e):Gb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Gb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Gb(c,a[c],b,e);return d.join("&").replace(Bb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Fb.test(this.nodeName)&&!Eb.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Db,"\r\n")}}):{name:b.name,value:c.replace(Db,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Hb={0:200,1223:204},Ib=n.ajaxSettings.xhr();l.cors=!!Ib&&"withCredentials"in Ib,l.ajax=Ib=!!Ib,n.ajaxTransport(function(b){var c,d;return l.cors||Ib&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Hb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Jb=[],Kb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Jb.pop()||n.expando+"_"+kb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Kb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Kb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Kb,"$1"+e):b.jsonp!==!1&&(b.url+=(lb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Jb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Lb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Lb)return Lb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Mb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Mb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Mb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Nb=a.jQuery,Ob=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Ob),b&&a.jQuery===n&&(a.jQuery=Nb),n},b||(a.jQuery=a.$=n),n});
APP.Calculator = (function () {
    var exports = {},
        calculatorList = [],
        idSeeker = 0,
        wrapperTemplateString,
        expSupMoveTimer,
        isSymbolMode,

        // for tuch devices:
        readonly = true,
        keyTable = {
            '8': 'backspace',
            '9': 'tab',
            '13': 'enter',
            '18': 'altgr',
            '35': 'end',
            '36': 'home',
            '37': 'left',
            '38': 'up',
            '39': 'right',
            '40': 'down',
            '46': 'delete',
            '56': '8',
            '54': '6',
            '65': 'a',
            '67': 'c',
            '88': 'x',
            '89': 'y',
            '90': 'z',
            '111': '/',
            '191': '/',
            '32': 'space'
        },

        formulaChildLengths = {
            'root': 2,
            'per': 2,
            'log': 2,
            'exp': 2,
            'abs': 1,
            'p': 1
        },

        formulaDefaultChildIndexes = {
            'root': 1,
            'root:inverse': 0,
            'per': 0,
            'per:inverse': 1,
            'log': 1,
            'log:inverse': 0,
            'exp': 0,
            'exp:inverse': 1,
            'abs': 0,
            'p': 0
        },

        virtualSelection,
        inited = false;

    function init() {
        if (!inited) {
            inited = true;
            wrapperTemplateString = getTemplate('wrapper');
        }

        isSymbolMode = $body.find('[data-symbol-mode="true"]').length > 0;

        $body.find('[data-calculator]:not([data-calculator-inited])').each(function () {
            calculatorList.push(new Calculator($(this), getUniqueId()));
            APP.Calculator.Keyboard.init();
        });
    }

    function parseFormula(type, child, id) {
        var templateString,
            wrapperString = wrapperTemplateString.replace('{id}', id),
            contentString,
            index = 0;

        switch (type) {
            case 'wrapper':
                if (child.length > 0) {
                    templateString = '';
                    child.forEach(function (children) {
                        templateString += children.toHtml();
                    });
                } else {
                    templateString = getTemplate('placeholder');
                }
                break;

            case 'char':
                templateString = [APP.Locale.replaceMathCharacters(child[0])];

                if (isSymbolMode) {
                    if ('ABCDEF'.indexOf(child[0]) > -1) {
                        templateString = getTemplate('shape').replace(/\{0\}/g, child[0].toLowerCase());
                    }
                }
                break;

            default:
                templateString = getTemplate(type);
                if (type === 'exp' || type === 'log') {
                    templateString = templateString.replace('{ghost-phase}', child[0].parent.ghostPhase);
                }

                while (templateString.indexOf('{' + index + '}') > -1) {
                    contentString = child[index].toHtml();
                    templateString = templateString.replace('{' + index + '}', contentString);
                    index++;
                }
                break;

        }

        wrapperString = wrapperString.replace('{type}', type);
        wrapperString = wrapperString.replace('{content}', templateString);
        return wrapperString;

    }

    function getTemplate(name) {
        return APP.$store.templates['calculator/' + name] || '';
    }

    function getSelection() {
        var html = '',
            parent = null,
            range;

        if (typeof window.getSelection !== 'undefined') {
            var sel = window.getSelection();
            if (sel.rangeCount) {
                var container = document.createElement('div');
                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;

                parent = sel.getRangeAt(0).commonAncestorContainer;
                if (parent.nodeType !== 1) {
                    parent = parent.parentNode;
                }
            }

        } else if (typeof document.selection !== 'undefined') {
            if (document.selection.type === 'Text') {
                range = document.selection.createRange();
                html = range.htmlText;
                parent = range.parentElement();
            }
        }

        return {
            html: html,
            parent: parent
        };

    }

    function getTextSelectionLengthOfElement(element) {
        var selectedText;
        if (typeof document.selection !== 'undefined') {
            element.focus();
            var sel = document.selection.createRange();
            selectedText = sel.text;
        } else if (typeof element.selectionStart !== 'undefined') {
            var startPos = element.selectionStart;
            var endPos = element.selectionEnd;
            selectedText = element.value.substring(startPos, endPos);
        }

        return selectedText.length;
    }

    function getUniqueId() {
        return ++idSeeker;
    }

    // TODO: put it to modules!

    // CALCULATOR OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function Calculator($element, id) {
        var _self = this,
            $wrapper,
            $hunter,
            $display,
            $valueHolder,
            hunterFocused = false,
            allFormula = {},
            pointer = null,
            initialized = false,

            history = [],
            historyMoment = 0,
            mouseX = null,
            pasted = false,

            selectionStartX,
            selectionStartY,

            isMouseDown = false,
            isMouseMoved = false,

            wrapperStarter = false;

        function init($el) {
            $wrapper = $el;
            $wrapper.attr('data-calculator-inited', true);
            $hunter = $wrapper.find('[data-calculator-focus-hunter]');
            $display = $wrapper.find('[data-calculator-display]');
            $valueHolder = $wrapper.find('input[type="hidden"]');
            _self.valueObject = newFormula('wrapper');
            _self.valueObject.addChild(getFormulasFromString($el.attr('data-calculator')));
            initAllFormula();
            pointer = _self.valueObject;
            initBinding();
            echoValue();
            initialized = true;
            if ($wrapper.attr('data-calculator-auto-focus') === 'true' && document.location.hash === '#input') {
                setTimeout(addFocus, 8);
            }
            APP.Calculator.Keyboard.add(_self);
        }

        function initAllFormula() {
            var id;

            for (id in allFormula) {
                if (allFormula.hasOwnProperty(id)) {
                    allFormula[id].setExpAndLogGhostP();
                }
            }
        }

        function exitCalculator() {
            hunterFocused = false;
            isMouseDown = false;
            hideCursor();
        }

        function initBinding() {
            window.onCalculatorFocus = window.onCalculatorFocus || [];
            window.onCalculatorFocus[id] = function (calculator) {
                hunterFocused = true;
                APP.Calculator.Keyboard.show(calculator);
                drawPointerOrSelection();
            };

            $hunter.on({
                'focus': function () {
                    window.onCalculatorFocus[id](_self);
                },
                'blur': exitCalculator,
                'keyup': keyUp,
                'keydown': keyDown,
                'paste': function () {
                    keyUp();
                    pasted = true;
                    $hunter.val('');
                }
            });

            $wrapper.on('click', '.calculator--placeholder', function (e) {
                var wrapperId = parseInt($(this).parent().attr('data-calculator-element-id'), 10),
                    pointer = getFormulaById(wrapperId);

                pointer.pointerPosition = 0;
                pointer.length = 0;
                pointFormula(pointer);
            });

            $wrapper.on('dblclick dbltap', '[data-calculator-element-type="wrapper"]', function (event) {
                var formula = getFormulaById($(this).attr('data-calculator-element-id'));

                event.stopPropagation();
                event.preventDefault();
                setTimeout(function () {
                    formula && formula.selectAll();
                }, 1);
            });

            $body.off('.calculatorSelection' + id);

            $body.on('touchstart.calculatorSelection' + id + ' mousedown.calculatorSelection' + id, function (event) {
                var $target = $(event.target),
                    isKeyboardShown = APP.Calculator.Keyboard.isShown(id),
                    notKeyboardAction = $target.parents('[data-keyboard]').length === 0;

                if (isKeyboardShown && notKeyboardAction) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                    selectionStartX = clientX + window.scrollX;
                    selectionStartY = clientY + window.scrollY;
                    isMouseDown = true;
                }
            });

            $body.on('touchmove.calculatorSelection' + id + ' mousemove.calculatorSelection' + id, function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY,
                        selection = rectangleSelect(
                            selectionStartX,
                            selectionStartY,
                            clientX + window.scrollX,
                            clientY + window.scrollY
                        );

                    event.stopPropagation();
                    if (selection) {
                        isMouseMoved = true;
                        pointFormula(selection);
                    } else {
                        pointer.pointerLength = 0;
                        pointFormula(pointer);
                    }
                }
            });

            $body.on('touchend.calculatorSelection' + id + ' mouseup.calculatorSelection' + id, function (event) {
                var $target = $(event.target),
                    isKeyboardShown = APP.Calculator.Keyboard.isShown(id),
                    notKeyboardAction = $target.parents('[data-keyboard]').length === 0,
                    isPlaceholder = $target.attr('class') === 'calculator--placeholder',
                    selection;

                if (!isPlaceholder && (isKeyboardShown || wrapperStarter) && !isMouseMoved && notKeyboardAction && ($target.parents('[data-calculator]').length === 1 || isKeyboardShown)) {
                    selection = pointSelect(selectionStartX, selectionStartY);
                    if (selection) {
                        selection.pointerLength = 0;
                        pointFormula(selection);
                    } else {
                        exitCalculator();
                    }
                }

                isMouseDown = false;
                isMouseMoved = false;
                wrapperStarter = false;

            });

        }

        function rectangleSelect(x1, y1, x2, y2) {
            var left = Math.min(x1, x2),
                top = Math.min(y1, y2),
                right = Math.max(x1, x2),
                bottom = Math.max(y1, y2),
                elements = [],
                $wrappers = $body.find('nope');

            $wrapper.find('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').each(function () {
                var $this = $(this),
                    type = $this.attr('data-calculator-element-type'),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height(),
                    $myWrapper;

                if (type === 'char') {
                    if (x + w >= left
                        && y + h >= top
                        && x <= right
                        && y <= bottom) {
                        elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                        $myWrapper = $this.parents('[data-calculator-element-type="wrapper"]').first();
                    }
                } else {
                    if (x >= left
                        && y >= top
                        && x + w <= right
                        && y + h <= bottom) {
                        elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                        $myWrapper = $this.parents('[data-calculator-element-type="wrapper"]').first();
                    }
                }

                if ($myWrapper) {
                    $wrappers = $wrappers.add($myWrapper);
                }

            });

            $wrappers.find('> [data-calculator-element-before], > [data-calculator-element-after]').each(function () {
                var $this = $(this),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height();

                if (x + w >= left
                    && y + h >= top
                    && x <= right
                    && y <= bottom) {
                    var $p = $this.parents('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').first();

                    elements.push(parseInt($p.attr('data-calculator-element-id'), 10));
                }
            });

            return createPointerFromRectangle(elements);
        }

        function pointSelect(x1, y1) {
            var left = x1,
                top = y1,
                right = x1,
                bottom = y1,
                elements = [],
                pointer,
                element;

            $wrapper.find('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').each(function () {
                var $this = $(this),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height();

                if (x + w >= left
                    && y + h >= top
                    && x <= right
                    && y <= bottom) {
                    elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                }

            });

            element = getInnerElement(elements);
            if (element && element.parent) {
                pointer = element.parent;
                pointer.pointerPosition = pointer.child.indexOf(element);
                if (isCoordinateAfterTheElement(element.id, x1)) {
                    pointer.pointerPosition++;
                }
            } else {
                pointer = getRootElement();
                pointer.pointerPosition = 0;
                if (isCoordinateAfterTheElement(pointer.id, x1)) {
                    pointer.pointerPosition = pointer.child.length;
                }
            }

            return pointer;
        }

        function isCoordinateAfterTheElement(element, x) {
            var $element = $wrapper.find('[data-calculator-element-id="' + element + '"]'),
                midpoint = $element.offset().left + ($element.width() / 2);

            return x > midpoint;
        }

        function getInnerElement(elements) {
            var innerElement = elements[0],
                depth = getParentDepth(innerElement);

            elements.forEach(function (element) {
                var d = getParentDepth(element);

                if (d > depth) {
                    innerElement = element;
                    depth = d;
                }
            });

            return getFormulaById(innerElement);

            function getParentDepth(element, plus) {
                var e = getFormulaById(element);
                plus = plus || 0;

                if (e && e.parent) {
                    return getParentDepth(e.parent.id, ++plus);
                }

                return plus;
            }
        }

        function createPointerFromRectangle(array) {
            var commonParentId,
                pointerFormula,
                pointerPosition = -1,
                pointerLength = 0,
                parents,
                extendedArray;

            if (!array || !array.length) {
                return false;
            }

            parents = getParents(array);
            commonParentId = parents.common;
            pointerFormula = getFormulaById(commonParentId);

            if (pointerFormula) {
                extendedArray = array.concat(parents.extend);
                pointerFormula.child.forEach(function (child, index) {
                    if (extendedArray.indexOf(child.id) > -1) {
                        if (pointerPosition === -1) {
                            pointerPosition = index;
                        }
                        pointerLength = index - pointerPosition + 1;
                    }
                });

                pointerFormula.pointerPosition = pointerPosition;
                pointerFormula.pointerLength = pointerLength;
            }
            return pointerFormula;

            function getParents(idArray) {
                var parentMatrix = [],
                    commonParent,
                    commonParentElement,
                    allParent = [],
                    breakLoop = false,
                    row,
                    actualParent,
                    parentLength = Infinity,
                    i,
                    p;

                idArray.forEach(function (item) {
                    row = getParentRow(item);
                    if (row.length < parentLength) {
                        parentLength = row.length;
                    }
                    parentMatrix.push(row);
                });

                commonParent = parentMatrix[0][0];
                for (p = 0; p < parentLength && !breakLoop; p++) {
                    actualParent = parentMatrix[0][p];
                    for (i = 1; i < idArray.length && !breakLoop; i++) {
                        if (actualParent !== parentMatrix[i][p]) {
                            breakLoop = true;
                        }
                    }
                    if (!breakLoop) {
                        commonParent = actualParent;
                    }
                }

                commonParentElement = getFormulaById(commonParent);
                if (commonParentElement && commonParentElement.type !== 'wrapper' && commonParentElement.parent) {
                    commonParent = commonParentElement.parent.id;
                }

                return {common: commonParent, extend: allParent};

                function getParentRow(id, prefix) {
                    var formula = getFormulaById(id),
                        row = prefix || [],
                        parentId;

                    if (formula && formula.parent) {
                        parentId = formula.parent.id;
                        row.push(parentId);
                        if (allParent.indexOf(parentId) === -1) {
                            allParent.push(parentId);
                        }
                        return getParentRow(formula.parent.id, row);
                    }

                    return row.reverse();
                }
            }

        }

        function getRootElement() {
            return getFormulaById(parseInt($wrapper.find('[data-calculator-element-id]').attr('data-calculator-element-id'), 10));
        }

        function setScrollbar() {
            if ($display.outerWidth() > $element.outerWidth()) {
                $element.addClass('add-scroll');
            } else {
                $element.removeClass('add-scroll');
            }
        }

        function hideCursor() {
            resetSelection();
            resetPointers();
        }

        function mouseDown(event) {
            mouseX = event.clientX;
        }

        function keyUp() {
            var hunterSelected = getTextSelectionLengthOfElement($hunter[0]) === 0;
            if ($hunter.val().length > 0 && hunterSelected && !pasted) {
                addString($hunter.val());
            } else if (pasted) {
                pasted = false;
                onPaste($hunter.val());
                $hunter.val('');
            }
        }

        function onPaste(pastedString) {
            if (pastedString) {
                pointer.addChild(getFormulasFromString(pastedString));
                initAllFormula();
                echoValue();
                drawPointerOrSelection();
                APP.Analytics.trackEvent('calculator', 'paste');
            }
        }

        function keyDown(event) {
            var actions = [],
                preventDefault = false,
                allowed = true;

            if (typeof event.originalEvent.repeat !== 'undefined') {
                allowed = !event.originalEvent.repeat;
            }
            if (!allowed) {
                return false;
            }

            if (event.hasOwnProperty('keyCode')) {
                // catch tab
                preventDefault = event.keyCode === 9 || preventDefault;
                // catch navigation
                preventDefault = (event.keyCode < 41 && event.keyCode > 34) || preventDefault;
                // catch ctrl + y; ctrl + z
                preventDefault = ((event.keyCode === 89 || event.keyCode === 90) && event.ctrlKey) || preventDefault;
                // catch shift + 8; (
                preventDefault = (event.keyCode === 56 && event.shiftKey) || preventDefault;

                if (preventDefault) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                if (keyTable[event.keyCode]) {
                    if (event.ctrlKey) {
                        actions.push('ctrl');
                    }
                    if (event.altKey) {
                        actions.push('alt');
                    }
                    if (event.shiftKey) {
                        actions.push('shift');
                    }
                    actions.push(keyTable[event.keyCode]);
                    addHotKey(actions.join('+'));
                }

            }

        }

        function getFormulasFromString(string) {
            var formulas = [],
                json;

            try {
                json = JSON.parse(string);
            } catch (error) {
                json = false;
            }

            if (json && validateJson(json)) {
                formulas = getFormulaFromJson(json);
            }

            return formulas;
        }

        function validateJson(json) {
            // TODO VALIDATE JSON STRUCTURE!!
            return !!json; //true;
        }

        function getFormulaFromJson(json, parent) {
            var formula,
                result,
                i,
                j;

            if (json) {
                if ($.isArray(json)) {
                    formula = [];
                    for (i = 0; i < json.length; i++) {
                        result = getFormulaFromJson(json[i], parent);
                        if ($.isArray(result)) {
                            for (j = 0; j < result.length; j++) {
                                formula.push(result[j]);
                            }
                        } else {
                            formula.push(result);
                        }
                    }
                } else {
                    if (typeof json === 'string') {
                        formula = createCharFormulasByString(json, parent);
                    } else {
                        formula = newFormula(json.type);
                        if (json.id) {
                            formula.id = json.id;
                            allFormula[json.id] = formula;
                        }
                        formula.child = getFormulaFromJson(json.child, formula);
                    }
                    formula.parent = parent;
                }
                return formula;
            } else {
                return [];
            }

        }

        function newFormula(type, child, parent) {
            var id = getUniqueId(),
                formula = new Formula({
                    id: id,
                    type: type,
                    child: child || []
                }, _self, parent);

            fillFormulaWithWrappers(formula);
            allFormula[id] = formula;

            return formula;

        }

        function fillFormulaWithWrappers(formula) {
            var childLength = formulaChildLengths[formula.type] || 0;
            while (childLength-- > 0) {
                formula.child.push(newFormula('wrapper', [], formula));
            }
        }

        function getFormulaById(id) {
            return allFormula[id];
        }

        function echoValue(disableFromHistory) {
            var val = _self.getContent();

            $wrapper.find('[data-calculator-display]').html(_self.valueObject.toHtml());
            APP.Formula.cosmeticFormulaByWrapper($wrapper);
            $element.attr('data-value', _self.getContent());
            APP.Live.saveClientMeta('input', {
                type: 'formula',
                value: val
            });
            if (!disableFromHistory) {
                addToHistory();
            }
            setScrollbar();
        }

        function addToHistory() {
            var content = $.extend(true, {}, _self.valueObject.toJson(true));

            history = history.slice(0, ++historyMoment);
            history.push({
                pointer: {
                    id: pointer && pointer.id,
                    pointerPosition: pointer && pointer.pointerPosition,
                    pointerLength: pointer && pointer.pointerLength
                },
                content: content
            });

            if ($valueHolder) {
                $valueHolder.val(getContent());
            }

        }

        function applyHistoryItem(index) {
            var moment = history[index];

            if (!moment) {
                return;
            }

            allFormula = {};
            historyMoment = index;
            _self.valueObject = getFormulaFromJson(moment.content);
            pointer = getFormulaById(moment.pointer.id);
            pointer.pointerPosition = moment.pointer.pointerPosition;
            pointer.pointerLength = moment.pointer.pointerLength;

            initAllFormula();
            echoValue(true);
            drawPointerOrSelection();
        }

        function undo() {
            if (historyMoment > 0) {
                APP.Analytics.trackEvent('calculator', 'undo');
                applyHistoryItem(Math.min(historyMoment - 1, history.length - 2));
            }
        }

        function redro() {
            if (historyMoment < history.length - 1) {
                APP.Analytics.trackEvent('calculator', 'redro');
                applyHistoryItem(historyMoment + 1);
            }
        }

        function getContent() {
            return stringifyJson(_self.valueObject.toJson().child);
        }

        function cleanInput() {
            pointer = _self.valueObject = getFormulaFromJson({type: "wrapper", child: Array(0), id: 0});
            pointer.pointerPosition = 0;
            pointer.pointerLength = 0;
            echoValue(true);
            drawPointerOrSelection();
        }

        function addFocus() {
            if (!hunterFocused) {
                $hunter[0].select();
            }
            // $wrapper.find('[data-calculator-focus-hunter]').focus();
        }

        function addString(string) {
            $hunter.val('');
            string = string.replace(/[^a-zA-Z0-9\u16A1\u00B1\-\+\*:=≠>≥<≤]*/g, '');
            pointer.addChild(createCharFormulasByString(string));
            echoValue();
            drawPointerOrSelection();
            addFocus();
        }

        function createCharFormulasByString(string, parent) {
            var i, formulas = [];
            for (i = 0; i < string.length; i++) {
                formulas.push(newFormula('char', [string[i]], parent));
            }
            return formulas;
        }

        function addFormula(action) {
            var formula = newFormula(action.split(':')[0]),
                targetChild = pointer.addChild(formula, action);

            if (!targetChild && formulaDefaultChildIndexes.hasOwnProperty(action)) {
                targetChild = formula.child[formulaDefaultChildIndexes[action]];
            }
            echoValue();
            addFocus();
            targetChild.addFocus();
        }

        function addHotKey(method) {
            pointer.hotKey(method);
            addFocus();
        }

        function pointFormula(formula) {
            pointer = formula;
            drawPointerOrSelection();
            clearTimeout(expSupMoveTimer);
        }

        function drawPointerOrSelection() {
            resetSelection();
            resetPointers();
            APP.Calculator.Keyboard.addStatus(pointer.pointerLength);
            if (pointer.pointerLength === 0) {
                putPointer();
            } else {
                putSelection();
            }
        }

        function putPointer() {
            if (pointer.child.length === 0) {
                pointer.pointerPosition = 0;
                pointElementById(pointer.id, 'inner');
            } else if (pointer.pointerPosition < pointer.child.length) {
                if (pointer.pointerPosition === -1) {
                    pointer.pointerPosition = 0;
                }
                pointElementById(pointer.child[pointer.pointerPosition].id, 'before');
            } else {
                pointElementById(pointer.child[pointer.child.length - 1].id, 'after');
            }
            $hunter.val('');
        }

        function pointElementById(id, type) {
            $wrapper.find('[data-calculator-element-id="' + id + '"]').addClass('calculator--element-pointer-' + type);
            addFocusToElement(id);
        }

        function resetPointers() {
            $wrapper.find('.calculator--element')
                .removeClass('calculator--element-pointer-before')
                .removeClass('calculator--element-pointer-after')
                .removeClass('calculator--element-pointer-inner')
                .removeClass('calculator--element-focus-inner-ghost');
        }

        function putSelection() {
            getSelection(true);
        }

        function getSelection(put) {
            var length = pointer.pointerLength,
                position = pointer.pointerPosition,
                from = length < 0 ? position + length : position,
                to = length < 0 ? position : position + length,
                selection = [],
                value;

            while (from++ < to) {
                selection.push(pointer.child[from - 1].toJson());
                selectElementById(pointer.child[from - 1].id);
            }
            if (pointer.child[0]) {
                addFocusToElement(pointer.child[0].id);
            }
            value = stringifyJson(selection);

            if (put) {
                $hunter.val(value);

                if (hunterFocused && !APP.Page.hasVirtualKeyboard()) {
                    $hunter[0].setSelectionRange(0, value.length);
                }
            } else {
                return value;
            }
        }

        function addFocusToElement(childId) {
            if (!childId) {
                return;
            }

            var childFormula = getFormulaById(childId),
                parentFormula = childFormula.parent,
                addInnerGhostClass = false;

            if (!!parentFormula && !!parentFormula.parent) {
                if (parentFormula.type === 'wrapper') {
                    parentFormula = parentFormula.parent;
                }
                $wrapper.find('[data-calculator-element-id="' + parentFormula.id + '"]')
                    .addClass('calculator--element-focus');

                if (parentFormula.type === 'exp') {
                    if (childFormula.type === 'wrapper' && childFormula.id === parentFormula.child[0].id) {
                        addInnerGhostClass = true;
                    } else if (childFormula.type !== 'wrapper' && childFormula.parent.id === parentFormula.child[0].id) {
                        addInnerGhostClass = true;
                    }
                } else if (parentFormula.type === 'log') {
                    if (childFormula.type === 'wrapper' && childFormula.id === parentFormula.child[1].id) {
                        addInnerGhostClass = true;
                    } else if (childFormula.type !== 'wrapper' && childFormula.parent.id === parentFormula.child[1].id) {
                        addInnerGhostClass = true;
                    }
                }

                if (addInnerGhostClass) {
                    $wrapper.find('[data-calculator-element-id="' + parentFormula.id + '"]')
                        .addClass('calculator--element-focus-inner-ghost');
                }

            }

        }

        function stringifyJson(json) {
            var string = JSON.stringify(json);
            string = string.replace(/"type"/g, '{!!!type!!!}');
            string = string.replace(/"child"/g, '{!!!child!!!}');
            string = string.replace(/","/g, '');
            string = string.replace(/{!!!type!!!}/g, '"type"');
            string = string.replace(/{!!!child!!!}/g, '"child"');
            return string;
        }

        function selectElementById(id) {
            $wrapper.find('[data-calculator-element-id="' + id + '"]').addClass('calculator--element-select-all');
        }

        function resetSelection() {
            $wrapper.find('.calculator--element-select-all')
                .removeClass('calculator--element-select-all');
        }

        function isSendable() {
            return $element.attr('data-prevent-send') !== 'true';
        }

        _self.valueObject = null;

        _self.addFocus = addFocus;
        _self.addString = addString;
        _self.addFormula = addFormula;
        _self.addHotKey = addHotKey;
        _self.getFormulaById = getFormulaById;
        _self.pointFormula = pointFormula;
        _self.newFormula = newFormula;
        _self.echoValue = echoValue;
        _self.mouseDown = mouseDown;
        _self.onPaste = onPaste;

        _self.undo = undo;
        _self.redro = redro;
        _self.cleanInput = cleanInput;

        _self.getContent = getContent;
        _self.isSendable = isSendable;
        _self.hideCursor = hideCursor;
        _self.getSelection = getSelection;
        _self.exitCalculator = exitCalculator;

        _self.id = id;

        // constructor:
        init($element);

        return _self;
    }

    // FORMULA OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function Formula(attributes, calculator, parentFormula) {
        var _self = new FormulaMethodHandler(this, calculator);
        attributes = attributes || {
            type: 'wrapper',
            id: null,
            child: []
        };

        function toHtml() {
            return parseFormula(_self.type, _self.child, _self.id);
        }

        function toJson(saveId) {
            var i,
                json = {
                    type: _self.type,
                    child: []
                };

            if (saveId) {
                json.id = _self.id;
            }

            if (_self.type !== 'char') {
                for (i = 0; i < _self.child.length; i++) {
                    json.child.push(_self.child[i].toJson(saveId));
                }
            } else {
                return _self.child.toString();
            }

            return json;

        }

        function onClick(event) {

            switch (_self.type) {
                case 'wrapper' :
                    _self.pointerPosition = getChildIndexById(event.originalEvent.attribute);
                    _self.pointerLength = 0;
                    calculator.pointFormula(_self);
                    break;

                default:
                    event.originalEvent.attribute = _self.id;
                    break;

            }
        }

        function getWrapperParent() {
            var actualParent = _self.parent;
            while (actualParent && actualParent.type !== 'wrapper') {
                actualParent = actualParent.parent;
            }
            return actualParent || false;
        }

        function getMyIndex() {
            var index = 0;
            if (_self.parent) {
                index = _self.parent.child.indexOf(_self);
            }
            return index;
        }

        function getMySiblingsLength() {
            return _self.parent.child.length;
        }

        function getPointedChild() {
            return _self.child[_self.pointerPosition];
        }

        function getChildIndexById(id) {
            return _self.child.indexOf(calculator.getFormulaById(id));
        }

        function removeSelection(echoValue, preventRemoveOne) {
            var selection = [];
            var formula;
            var vector = 'fromRight';

            if (_self.pointerLength > 0) {
                vector = 'fromLeft';
                if (_self.pointerLength === 1) {
                    formula = _self.child[_self.pointerPosition];
                }
                selection = removeChild(_self.pointerPosition, _self.pointerLength);
            } else if (_self.pointerLength < 0) {
                _self.pointerPosition = _self.pointerPosition + _self.pointerLength;
                if (Math.abs(_self.pointerLength) === 1) {
                    formula = _self.child[_self.pointerPosition];
                }
                selection = removeChild(_self.pointerPosition, Math.abs(_self.pointerLength));
            }

            _self.pointerLength = 0;

            if (formula && !preventRemoveOne) {
                removeOneFormula(formula, vector);
            }

            if (echoValue) {
                calculator.echoValue();
                calculator.pointFormula(_self);
            }
            return selection;
        }

        function removeOneFormula(formula, vector) {
            if (formula.type === 'p') {
                insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                if (vector === 'fromRight') {
                    _self.pointerPosition += formula.child[0].child.length;
                }
            } else if (formula.type === 'exp' && vector === 'fromRight') {
                if (formula.ghostPhase === 'active') {
                    insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                    _self.pointerLength = formula.child[0].child.length;
                    calculator.addFormula('p');
                } else {
                    insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                    _self.pointerPosition += formula.child[0].child.length;
                }
            }
        }

        function removeChild(index, length) {
            var ret = _self.child.splice(index, length || 1);

            setExpAndLogGhostP();
            return ret;
        }

        function insertChild(position, length, child) {
            clearTimeout(expSupMoveTimer);

            child.parent = _self;
            _self.child.splice(position, length, child);

            setExpAndLogGhostP();

            // kitevőről leugrasztás 1 karakter esetén:
            if (_self.parent
                && _self.parent.type === 'exp'
                && _self.child.length > 0
                && _self.parent.child.indexOf(_self) === 1) {
                expSupMoveTimer = setTimeout(_self.moveFocusNext, 5000);
            }

        }

        function insertChildArray(position, length, childArray) {
            var args,
                i;

            for (i = 0; i < childArray.length; i++) {
                childArray[i].parent = _self;
            }

            args = [position, length].concat(childArray);
            _self.child.splice.apply(_self.child, args);
            setExpAndLogGhostP();
        }

        function addChild(formula, formulaName, noStrip) {
            var selection,
                pointFormula = false;

            if ($.isArray(formula)) {
                for (var i = 0; i < formula.length; i++) {
                    addChild(formula[i], formulaName, noStrip);
                }
            } else {
                formula.parent = _self;
                if (_self.pointerLength !== 0) {
                    selection = removeSelection(false, true);
                    insertChild(_self.pointerPosition, 0, formula);
                } else if ((formula.type === 'exp' || formula.type === 'per') && formula.child[0].child.length === 0 && _self.pointerPosition > 0) {
                    var pointerLength = _self.pointerPosition;
                    _self.setPointerPosition(0);
                    _self.setPointerLength(pointerLength);
                    selection = removeSelection(false, true);
                    formula.child[0].addChild(selection, false, true);
                    insertChild(0, 0, formula);
                    if (formula.type === 'exp') {
                        pointFormula = formula.child[0].setExpBaseByInsert() || formula.child[1];
                    } else {
                        pointFormula = formula.child[0].setPerBaseByInsert() || formula.child[1];
                    }
                    _self.setPointerLength(0);
                    selection = false;
                } else {
                    insertChild(_self.pointerPosition, 0, formula);
                }

                if (_self.pointerPosition < 0) {
                    _self.pointerPosition = 0;
                }

                _self.pointerPosition++;

                if (selection) {
                    formula.addInheritedContent(selection, formulaName);
                    switch (formulaName) {
                        case 'exp':
                            pointFormula = formula.child[1];
                            break;
                        case 'exp:inverse':
                            pointFormula = formula.child[0];
                            break;
                        case 'log':
                            pointFormula = formula.child[0];
                            break;
                        case 'log:inverse':
                            pointFormula = formula.child[1];
                            break;
                        case 'per':
                            pointFormula = formula.child[1];
                            break;
                        case 'per:inverse':
                            pointFormula = formula.child[0];
                            break;
                    }

                }

            }

            return pointFormula;

        }

        function setExpBaseByInsert() {
            var pointFormula = false,
                parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'exp' && myIndex === 0) {
                    setBase(isNumberCharChild);
                    if (_self.child.length === 0) {
                        pointFormula = parent.child[0];
                    } else {
                        pointFormula = parent.child[1];
                    }

                }

            }

            return pointFormula;

        }

        function setPerBaseByInsert() {
            var pointFormula = false,
                parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'per' && myIndex === 0) {
                    setBase(function (c) {
                        return !isOperation(c);
                    });
                    if (_self.child.length === 0) {
                        pointFormula = parent.child[0];
                    } else {
                        pointFormula = parent.child[1];
                    }

                }

            }

            return pointFormula;

        }

        function setBase(filterFunction) {
            var index,
                foundOneUnit = 0,
                foundNonOneUnit = false;

            index = _self.child.length;

            if (!isOperation(_self.child[index - 1])) {
                while (index-- > 0) {
                    if (filterFunction(_self.child[index])) {
                        foundOneUnit++;
                    } else {
                        foundNonOneUnit = true;
                        if (foundOneUnit === 0) {
                            foundOneUnit++;
                        }
                        break;
                    }
                }

                if (foundNonOneUnit) {
                    _self.setPointerPosition(0);
                    _self.setPointerLength(_self.child.length - foundOneUnit);
                    _self.parent.insertBefore(_self.removeSelection());
                }
            } else {
                _self.setPointerPosition(0);
                _self.setPointerLength(_self.child.length);
                _self.parent.insertBefore(_self.removeSelection());
            }

        }

        function isOperation(formula) {
            if (formula.type === 'char') {
                return !!formula.child[0].match(/(,|-|\+|:|\*|\/|\.|=)/g);
            }
            return false;
        }

        function setExpAndLogGhostP() {
            var parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'exp' && myIndex === 0) {
                    if (isGhostPNeeded('exp')) {
                        parent.ghostPhase = 'active';
                    } else {
                        parent.ghostPhase = 'inactive';
                    }
                } else if (parent.type === 'log' && myIndex === 1) {
                    if (isGhostPNeeded('log')) {
                        parent.ghostPhase = 'active';
                    } else {
                        parent.ghostPhase = 'inactive';
                    }

                }

            }

        }

        function isGhostPNeeded(formula) {
            var putP = false,
                index,
                foundOneUnit = 0,
                foundNonOneUnit = false;

            index = _self.child.length;

            while (index-- > 0) {
                if (isNumberCharChild(_self.child[index])) {
                    foundOneUnit++;
                } else if (_self.child[index].type !== 'char' && formula === 'exp') {
                    putP = true;
                } else {
                    foundNonOneUnit = true;
                    foundOneUnit++;
                }
            }

            if (foundNonOneUnit && foundOneUnit > 1) {
                putP = true;
            } else if (_self.child.length === 1 && _self.child[0].type === 'p') {
                putP = false;
            }

            return putP;

        }

        function isNumberCharChild(formula) {
            if (formula.type === 'char') {
                return !isNaN(formula.child[0]);
            }
            return false;
        }

        function addInheritedContent(formula, formulaName) {
            var targetChild;

            if (formulaDefaultChildIndexes.hasOwnProperty(formulaName || _self.type)) {
                targetChild = _self.child[formulaDefaultChildIndexes[formulaName || _self.type]];
                if (targetChild.child.length === 0) {
                    targetChild.addChild(formula, formulaName);
                }

            }

        }

        _self.id = attributes.id;
        _self.type = attributes.type;
        _self.child = attributes.child;
        _self.pointerPosition = 0;
        _self.pointerLength = 0;
        _self.parent = parentFormula;
        _self.ghostPhase = 'inactive';

        _self.toHtml = toHtml;
        _self.toJson = toJson;

        _self.onClick = onClick;

        _self.getMyIndex = getMyIndex;
        _self.getMySiblingsLength = getMySiblingsLength;
        _self.getPointedChild = getPointedChild;
        _self.getWrapperParent = getWrapperParent;

        _self.removeSelection = removeSelection;
        _self.addChild = addChild;
        _self.setExpBaseByInsert = setExpBaseByInsert;
        _self.setPerBaseByInsert = setPerBaseByInsert;
        _self.setExpAndLogGhostP = setExpAndLogGhostP;
        _self.addInheritedContent = addInheritedContent;
        _self.insertChildArray = insertChildArray;

        return _self;

    }

    // METHOD MANAGER OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function FormulaMethodHandler(_self, calculator) {
        var methodHotKeyTable = {
            'left': movePointerLeft,
            'right': movePointerRight,
            'up': moveFocusUp,
            'down': moveFocusDown,
            'home': movePointerFirst,
            'end': movePointerLast,

            'enter': submitFormula,

            'ctrl+left': movePointerFirst,
            'ctrl+right': movePointerLast,
            'shift+left': movePointerLengthLeft,
            'shift+right': movePointerLengthRight,
            'shift+home': movePointerLengthFirst,
            'shift+end': movePointerLengthLast,

            'ctrl+shift+left': movePointerLengthFirst,
            'ctrl+shift+right': movePointerLengthLast,
            'ctrl+a': selectAll,

            'backspace': removePrevious,
            'delete': removeNext,
            'shift+backspace': removePrevious,
            'shift+delete': removeNext,
            'ctrl+backspace': removePreviousAll,
            'ctrl+delete': removeNextAll,

            'ctrl+x': cut,
            'ctrl+c': copy,
            'ctrl+v': paste,
            'ctrl+z': calculator.undo,
            'ctrl+y': calculator.redro,

            'tab': moveFocusNext,
            'shift+tab': moveFocusPrev,

            'shift+8': function () {
                calculator.addFormula('p');
            },
            'shift+6': function () {
                calculator.addFormula('per');
            },
            '/': function () {
                calculator.addFormula('per');
            },
            'shift+/': function () {
                calculator.addFormula('per');
            },
            'altgr': function () {
                calculator.addFormula('exp');
            },
            'alt+altgr': function () {
                calculator.addFormula('exp');
            },
            'ctrl+alt+altgr': function () {
                calculator.addFormula('exp');
            },
            'alt+alt+altgr': function () {
                calculator.addFormula('exp');
            },
            'space': function () {
                calculator.addFormula('root');
            },
            'ctrl+space': function () {
                calculator.addFormula('log');
            }
        };

        function hotKey(methodHotKey) {
            if (methodHotKeyTable[methodHotKey]) {
                methodHotKeyTable[methodHotKey]();
            }
        }

        function setPointerPosition(position) {
            _self.pointerPosition = Math.max(0, position);
            _self.pointerPosition = Math.min(_self.child.length, _self.pointerPosition);
            return _self.pointerPosition;
        }

        function setPointerLength(length) {
            _self.pointerLength = Math.max(-1 * _self.pointerPosition, length);
            _self.pointerLength = Math.min(_self.child.length - _self.pointerPosition, _self.pointerLength);
            return _self.pointerLength;
        }

        function echoPointer() {
            calculator.pointFormula(_self);
        }

        function setPointer(position, length) {
            setPointerPosition(position);
            setPointerLength(length);
            echoPointer();
        }

        function movePointerLeft(keepPointerLength) {
            var pointedChild;

            if (_self.pointerLength === 0) {
                if (_self.pointerPosition === 0) {
                    moveFocusPrev();
                } else {
                    setPointerPosition(_self.pointerPosition - 1);
                    if (!keepPointerLength) {
                        setPointerLength(0);
                    }
                    pointedChild = _self.getPointedChild();
                    if (!pointedChild || pointedChild.type === 'char') {
                        echoPointer();
                    } else {
                        pointedChild.addFocus('right');
                    }
                }
            } else {
                setPointerPosition(Math.min(_self.pointerPosition, _self.pointerPosition + _self.pointerLength));
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerRight(keepPointerLength) {
            var pointedChild = _self.getPointedChild();
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition === _self.child.length && _self.pointerLength === 0) {
                    moveFocusNext();
                } else {
                    setPointerPosition(_self.pointerPosition + 1);
                    if (!keepPointerLength) {
                        setPointerLength(0);
                    }

                    if (!pointedChild || pointedChild.type === 'char') {
                        echoPointer();
                    } else {
                        pointedChild.addFocus('left');
                    }

                }

            } else {
                setPointerPosition(Math.max(_self.pointerPosition, _self.pointerPosition + _self.pointerLength));
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();

            }

        }

        function movePointerFirst(keepPointerLength) {
            if (_self.pointerPosition === 0) {
                moveFocusPrev();
            } else {
                setPointerPosition(0);
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerLast(keepPointerLength) {
            if (_self.pointerPosition === _self.child.length) {
                moveFocusNext();
            } else {
                setPointerPosition(_self.child.length);
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerLengthLeft() {
            if (_self.pointerLength !== setPointerLength(_self.pointerLength - 1)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('right');
            }
        }

        function movePointerLengthRight() {
            if (_self.pointerLength !== setPointerLength(_self.pointerLength + 1)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('left');
            }
        }

        function movePointerLengthFirst() {
            if (_self.pointerLength !== setPointerLength(-1 * _self.pointerPosition)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('right');
            }
        }

        function movePointerLengthLast() {
            if (_self.pointerLength !== setPointerLength(_self.child.length - _self.pointerPosition)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('left');
            }
        }

        function moveFocusNext() {
            if (_self.parent) {
                var wrapperParent = _self.getWrapperParent(),
                    myIndex = _self.getMyIndex(),
                    mySiblingsLength = _self.getMySiblingsLength();

                switch (_self.parent.type) {
                    case 'wrapper' :
                        _self.parent.setPointer(myIndex + 1, 0);
                        break;
                    case 'per' :
                        if (wrapperParent) {
                            _self.parent.moveFocusNext();
                        }
                        break;
                    default:
                        if (myIndex < mySiblingsLength - 1) {
                            _self.parent.child[myIndex + 1].addFocus('left');
                        } else if (wrapperParent) {
                            _self.parent.moveFocusNext();
                        }
                        break;
                }
            } else {
                setPointer(_self.child.length, 0);
            }

        }

        function moveFocusPrev() {
            if (_self.parent) {
                var wrapperParent = _self.getWrapperParent(),
                    myIndex = _self.getMyIndex();

                switch (_self.parent.type) {
                    case 'wrapper' :
                        _self.parent.setPointer(myIndex, 0);
                        break;
                    case 'per' :
                        if (wrapperParent) {
                            _self.parent.moveFocusPrev();
                        }
                        break;
                    default:
                        if (myIndex > 0) {
                            _self.parent.child[myIndex - 1].addFocus('right');
                        } else if (wrapperParent) {
                            _self.parent.moveFocusPrev();
                        }
                        break;
                }

            } else {
                setPointer(0, 0);
            }

        }

        function moveFocusUp() {
            if (_self.parent && _self.parent.type === 'per' && _self.getMyIndex() === 1) {
                _self.parent.child[0].addFocus('right');
            } else {
                movePointerFirst();
            }
        }

        function moveFocusDown() {
            if (_self.parent && _self.parent.type === 'per' && _self.getMyIndex() === 0) {
                _self.parent.child[1].addFocus('left');
            } else {
                movePointerLast();
            }
        }

        function selectAll() {
            var wrapperParent = _self.getWrapperParent();
            if (_self.pointerPosition !== 0 || _self.pointerLength !== _self.child.length) {
                setPointerPosition(0);
                setPointerLength(_self.child.length);
                echoPointer();
            } else {
                if (wrapperParent) {
                    wrapperParent.selectAll();
                }
            }
        }

        function selectChild(childFormula, pointerSide) {
            var childIndex = _self.child.indexOf(childFormula);
            if (childIndex >= 0) {
                if (pointerSide === 'left') {
                    setPointerPosition(childIndex);
                    setPointerLength(1);
                } else {
                    setPointerPosition(childIndex + 1);
                    setPointerLength(-1);
                }
                echoPointer();
            } else {
                console.warn('unexpected child passed');
            }
        }

        function selectMeAtParent(pointerSide) {
            var parentFormula = _self.parent,
                parentWrapperFormula = false;

            if (parentFormula) {
                parentWrapperFormula = parentFormula.getWrapperParent();
                parentWrapperFormula.selectChild(parentFormula, pointerSide);
            }

            return parentWrapperFormula;
        }

        function addFocus(pointerSide) {
            if (_self.type === 'wrapper') {
                addFocusToWrapper(pointerSide);
            } else if (_self.type !== 'char') {
                addFocusToFormula(pointerSide);
            }

            function addFocusToFormula(pointerSide) {
                if (_self.child.length > 0) {
                    if (pointerSide === 'left') {
                        _self.child[0].addFocus('left');
                    } else {
                        _self.child[_self.child.length - 1].addFocus('right');
                    }
                } else {
                    console.warn('unexpected formula structure');
                }
            }

            function addFocusToWrapper(pointerSide) {
                setPointerLength(0);
                if (pointerSide === 'left') {
                    setPointerPosition(0);
                } else {
                    setPointerPosition(_self.child.length);
                }
                echoPointer();
            }

        }

        function cut() {
            if (_self.pointerLength !== 0) {
                // asincron because of clipboard
                setTimeout(function () {
                    copy();
                    _self.removeSelection(true);
                }, 8);
            }
        }

        function copy() {
            virtualSelection = calculator.getSelection();
            $body.find('[data-keyboard-method="ctrl+v"]').show();
        }

        function paste() {
            calculator.onPaste(virtualSelection);
        }

        function replaceChild(formula, newFormula) {
            formula.insertBefore(newFormula);
            formula.parent.selectChild(formula);
            formula.parent.removeSelection(true, true);
        }

        function removePrevious() {
            var wrapperParent;
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition !== 0) {
                    setPointerLength(_self.pointerLength - 1);
                    _self.removeSelection(true);
                } else {
                    if (_self.parent && _self.parent.type === 'per') {
                        removePerFromInside();
                    } else if (_self.parent && _self.parent.type === 'exp') {
                        removeExpFromInside();
                    } else {
                        wrapperParent = _self.selectMeAtParent('right');
                        if (wrapperParent) {
                            wrapperParent.removeSelection(true);
                        }
                    }
                }
            } else {
                _self.removeSelection(true);
            }
        }

        function removePerFromInside() {
            var otherChild = _self.parent.child[_self.parent.child.indexOf(_self) === 0 ? 1 : 0];

            replaceChild(_self.parent, otherChild.child);
        }

        function removeExpFromInside() {
            var childIndex = _self.parent.child.indexOf(_self) === 0 ? 1 : 0,
                otherChild = _self.parent.child[childIndex];

            if (_self.parent.ghostPhase === 'active') {
                otherChild.selectAll();
                calculator.addFormula('p');
            }
            replaceChild(_self.parent, otherChild.child);
            _self.parent.setExpAndLogGhostP();
        }

        function removeNext() {
            var wrapperParent;
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition !== _self.child.length) {
                    setPointerLength(_self.pointerLength + 1);
                    _self.removeSelection(true);
                } else if (_self.parent) {
                    if (_self.parent.type === 'per') {
                        removePerFromInside();
                    } else if (_self.parent.type === 'exp') {
                        removeExpFromInside();
                    } else {
                        wrapperParent = _self.selectMeAtParent('left');
                        if (wrapperParent) {
                            wrapperParent.removeSelection(true);
                        }
                    }
                }
            } else {
                _self.removeSelection(true);
            }
        }

        function removePreviousAll() {
            var wrapperParent;
            if (_self.pointerPosition === 0) {
                wrapperParent = _self.selectMeAtParent('right');
                if (wrapperParent) {
                    wrapperParent.removeSelection(true);
                }
            } else {
                setPointerLength(-1 * _self.pointerPosition);
                _self.removeSelection(true);
            }
        }

        function removeNextAll() {
            var wrapperParent;
            if (_self.pointerPosition === _self.child.length) {
                wrapperParent = _self.selectMeAtParent('left');
                if (wrapperParent) {
                    wrapperParent.removeSelection(true);
                }
            } else {
                setPointerLength(_self.child.length - _self.pointerPosition);
                _self.removeSelection(true);
            }
        }

        function insertBefore(formulas) {
            var parent = _self.parent;
            parent.setPointerPosition(_self.getMyIndex());
            parent.setPointerLength(0);
            parent.addChild(formulas, false, false);
        }

        function insertAfter(formulas) {
            var parent = _self.parent;
            parent.setPointerPosition(_self.getMyIndex() + 1);
            parent.setPointerLength(0);
            parent.addChild(formulas, false, false);
        }

        function submitFormula() {
            APP.Calculator.Keyboard.submit();
        }

        _self.hotKey = hotKey;
        _self.setPointer = setPointer;
        _self.setPointerPosition = setPointerPosition;
        _self.setPointerLength = setPointerLength;

        _self.selectAll = selectAll;
        _self.selectChild = selectChild;
        _self.selectMeAtParent = selectMeAtParent;

        _self.insertBefore = insertBefore;
        _self.insertAfter = insertAfter;

        _self.addFocus = addFocus;
        _self.moveFocusPrev = moveFocusPrev;
        _self.moveFocusNext = moveFocusNext;
        _self.movePointerLast = movePointerLast;
        _self.movePointerFirst = movePointerFirst;

        return _self;

    }

    //-------------------------------------------------------------------

    exports.init = init;
    return exports;

})();
APP.Collection = (function () {

	var exports = {},
		liveBinded = false;

	function init() {
		initBindings();
	}

	function initBindings() {
		if (!liveBinded) {
			liveBinded = true;

			$body.on('click', '[data-add-folder]', function () {
				addFolder($body.find('[data-add-folder-name]').val(), $body.find('[data-add-folder-parent-id]').val());
			});

			$body.on('click', '[data-add-collection]', function () {
				addCollection($body.find('[data-add-collection-name]').val());
			});

			$body.on('click', '[data-add-problem]', function () {
				addProblem(
					$body.find('[data-add-problem-name]').val(),
					$body.find('[data-add-problem-id]').val(),
					$(this).attr('data-add-problem')
				);
			});
		}

	}

	function collectionService(service, body) {
		return APP.Ajax.post('/en-US/service/collection/' + service, body).then(window.NOOP, window.NOOP);
	}

	function addCollection(name) {
		return collectionService('add-collection', {
			name: name
		});
	}

	function addFolder(name, parentFolderId) {
		return collectionService('add-folder', {
			name          : name,
			parentFolderId: parentFolderId
		});
	}

	function addProblem(name, problemId, folderId) {
		return collectionService('add-problem', {
			name     : name,
			problemId: problemId,
			folderId : folderId
		});
	}

	exports.init = init;
	exports.addCollection = addCollection;
	return exports;

})();
function OpTbl(width, height, isMultiDigit) {
    var _this = {};
    var pause = 9;

    _this.width = Math.max(1, width | 0);
    _this.height = Math.max(1, height | 0);
    _this._idx = 0;

    _this._cells = [];
    for (var y = 0; y < _this.height; y++) {
        var row = [];

        for (var x = 0; x < _this.width; x++) {
            row.push({num: '', color: '', i: 0, filled: false});
        }
        _this._cells.push(row);
    }

    _this.underline = function (x, y, w) {
        if (_this._cells[y] && _this._cells[y][x]) {
            _this._cells[y][x].underline = {
                index: _this._idx++,
                width: w
            };
            _this._idx += pause;
        }
    };

    _this.markerline = function (x, y) {
        if (_this._cells[y] && _this._cells[y][x]) {
            _this._cells[y][x].markerline = {
                index: _this._idx++
            };
            _this._idx += pause;
        }
    };

    _this.add = function (x1, y1, x2, y2, color, direction, value) {
        color = color || 'black';
        direction = (direction || 'forward').toLowerCase();
        x1 |= 0;
        y1 |= 0;
        x2 |= 0;
        y2 |= 0;

        var left = Math.max(0, Math.min(x1, x2, _this.width - 1));
        var right = Math.min(_this.width - 1, Math.max(x1, x2));
        var top = Math.max(0, Math.min(y1, y2, _this.height - 1));
        var bottom = Math.min(_this.height - 1, Math.max(y1, y2));
        var coords = [];
        for (var y = top; y <= bottom; y++) {
            for (var x = left; x <= right; x++) {
                coords.push([x, y]);
            }
        }

        var n = coords.length;
        var forward = direction !== 'backward';
        var k, xy, cell, a = 0;

        if (forward) {
            for (k = 0; k < n; k++) {
                xy = coords[k];
                cell = this._cells[xy[1]][xy[0]];
                if (value) {
                    if (value[k]) {
                        cell.num = value[k];
                        a++;
                    }
                } else {
                    cell.num = String(k + 1);
                    a++;
                }
                cell.color = color;
                cell.i = _this._idx + k;
                cell.filled = true;
            }
        } else {
            for (k = 0; k < n; k++) {
                xy = coords[k];
                cell = _this._cells[xy[1]][xy[0]];
                if (value) {
                    if (value[k]) {
                        cell.num = value[k];
                        a++;
                    }
                } else {
                    cell.num = String(n - k);
                    a++;
                }

                cell.color = color;
                cell.i = _this._idx + (n - 1 - k);
                cell.filled = true;
            }
        }

        _this._idx += a;
        _this._idx += pause;

        return _this;
    };

    _this.build = function () {
        var html = '<div class="tbl' + (isMultiDigit ? ' tbl--multi' : '') + '">';
        var l;

        for (var y = 0; y < _this.height; y++) {
            html += '<div class="tbl__row">';
            for (var x = 0; x < _this.width; x++) {
                var c = this._cells[y][x];
                l = c.underline ? '<span class="tbl__cell__underline" style="--w:' + c.underline.width + ';--i:' + c.underline.index + ';"></span>' : '';
                if (c.markerline) {
                    l = '<span class="tbl__cell__markerline" style="--i:' + c.markerline.index + ';"></span>';
                }
                if (c.filled) {
                    html += '<div class="tbl__cell"><span class="tbl__num tbl__num--' + c.color +
                        '" style="--i:' + c.i + ';"><span>' + c.num + '</span></span>' + l + '</div>';
                } else {
                    html += '<div class="tbl__cell">' + l + '</div>';
                }
            }
            html += '</div>';
        }
        html += '</div>';

        return html;
    };

    return _this;

}


APP.Operations = (function () {
    var exports = {};

    function init() {
        $body.find('[data-operation]:not(.initialized)').each(function () {
            var $this = $(this);
            var data = $this.data('operation');

            if (data.multidigit) {
                opMultiple(data.operation, data.arguments, $this);
            } else {
                opSingle(data.operation, data.arguments[0], data.arguments[1], $this, data.colors);
            }
            $this.addClass('initialized');
            setTimeout(function () {
                $this.addClass('show');
            }, 120);
        });
    }

    function opSingle(operation, a, b, $target, color) {
        var t;

        if (operation === 'addition') {
            t = OpTbl(a + b, 2);
            t.add(0, 0, a - 1, 0, color[0]);
            t.add(a, 0, a + b, 0, color[1]);
            t.add(0, 1, a + b - 1, 1, color[2]);
        } else if (operation === 'subtraction') {
            t = OpTbl(a, 2);
            t.add(0, 0, a - 1, 0, color[0]);
            t.add(a - 1, 1, a - b, 1, color[1], 'backward');
            t.add(0, 1, a - b - 1, 1, color[2]);
        } else if (operation === 'multiplication') {
            t = OpTbl(b + 1, a + 1);
            t.add(0, 1, 0, a + 1, color[0]);
            t.add(1, 0, b + 1, 0, color[1]);
            t.add(1, 1, b + 1, a + 1, color[2]);
        } else if (operation === 'division') {
            t = OpTbl(b + 1, (a / b) + 1);
            t.add(0, 0, b - 1, 0, color[1]);
            t.add(0, 1, b - 1, a / b, color[0]);
            t.add(b, 1, b, a / b, color[2]);
        } else if (operation === 'reverseAddition') {
            t = OpTbl(a + b, 2);
            t.add(0, 0, a + b - 1, 0, color[2]);
            t.add(0, 1, a - 1, 1, color[0]);
            t.add(a, 1, a + b, 1, color[1]);
        }
        $target.html(t.build());
    }

    function opMultiple(operation, tags, $target) {
        var w, h, t, r;

        if (operation === 'addition') {
            w = Math.max.apply(null, tags.slice(0, tags.length - 1)).toString().length + 1;
            t = OpTbl(w, tags.length, true);
            tags.forEach(function (tag, index) {
                r = tag.toString();
                if (index === tags.length - 1) {
                    t.underline(0, tags.length - 2, w);
                    t.add(w - r.length, index, w, index, 'normal', 'backward', r);
                } else {
                    t.add(w - r.length, index, w, index, 'normal', 'forward', r);
                    if (index === tags.length - 2) {
                        t.add(0, index, 0, index, 'normal', 'forward', '+');
                    }
                }
            });
            $target.html(t.build());
        } else if (operation === 'subtraction') {
            w = Math.max.apply(null, tags).toString().length + 1;
            t = OpTbl(w, tags.length, true);
            tags.forEach(function (tag, index) {
                r = tag.toString();
                if (index === tags.length - 1) {
                    t.underline(0, tags.length - 2, w);
                    t.add(w - r.length, index, w, index, 'normal', 'backward', r);
                } else {
                    t.add(w - r.length, index, w, index, 'normal', 'forward', r);
                    if (index === tags.length - 2) {
                        t.add(0, index, 0, index, 'normal', 'forward', '-');
                    }
                }
            });
            $target.html(t.build());
        } else if (operation === 'multiplication') {
            var a = tags[0],
                b = tags[1],
                list = [], m,
                result;

            b.toString().split('').forEach(function (digit) {
                var res = parseInt(digit, 10) * parseInt(a, 10);

                list.push(res.toString());
            });

            if (list.length > 1) {
                var leftIndent = b.toString().length + 2;
                w = Math.max(list[0].toString().length, a.toString().length) + b.toString().length + 2; // a.toString().length + b.toString().length + 3;
                m = a.toString() + '*' + b.toString();
                t = OpTbl(w, list.length + 2, true);
                t.add(w - m.length, 0, w, 0, 'normal', 'forward', m);
                t.underline(w - m.length, 0, a.toString().length);
                list.forEach(function (item, index) {
                    leftIndent--;
                    t.add(w - leftIndent - item.length, index + 1, w - leftIndent, index + 1, 'normal', 'backward', item);
                });
                result = (a * b).toString();
                t.add(0, list.length, 0, list.length, 'normal', 'forward', '+');
                t.underline(0, list.length, result.length + 1);
                t.add(w - leftIndent, list.length + 2, w - leftIndent - result.length, list.length + 2, 'normal', 'backward', result);
            } else {
                result = (a * b).toString();
                w = (a * b).toString().length + b.toString().length + 1;
                m = a.toString() + '*' + b.toString();
                t = OpTbl(w, 2, true);
                t.add(w - m.length, 0, w, 0, 'normal', 'forward', m);
                t.underline(w - m.length, 0, a.toString().length);
                t.add(w - b.toString().length - 1 - result.length, 1, result.toString().length, 1, 'normal', 'backward', result);
            }
            $target.html(t.build());
        } else if (operation === 'division') {
            var a = parseInt(tags[0], 10),
                b = parseInt(tags[1], 10),
                c = parseInt(a.toString().substr(0, 1), 10),
                d, rows = [], i = 1, l = 1, tmp, re, of = 0, xof = 0, zof, s = false;

            while (true) {
                re = Math.floor(c / b) * b;
                rows.push(re);
                c = parseInt((c - re).toString() + a.toString()[i], 10);
                rows.push(c);
                if (re === 0 && !s) {
                    of += 2;
                    xof += 1;
                } else {
                    s = true;
                }
                i++;
                if (i > a.toString().length) {
                    break;
                }
            }
            w = a.toString().length + b.toString().length + 3 + Math.floor(a / b).toString().length;
            h = rows.length + 2 - of;
            t = OpTbl(w, h, true);
            d = (a + ':' + b + '=' + (a / b)).toString();
            t.add(
                w - d.length,
                1,
                w - d.length + d.length - Math.floor(a / b).toString().length,
                1,
                'normal', 'forward',
                d.substr(0, d.length - Math.floor(a / b).toString().length)
            );

            for (i = of; i < rows.length; i += 2) {
                t.markerline(w - d.length + l - 1 + xof, 0);
                t.add(
                    w - Math.floor(a / b).toString().length - 1 + l,
                    1,
                    w - Math.floor(a / b).toString().length - 1 + l,
                    1,
                    'normal', 'backward', Math.floor(a / b).toString()[l - 1]);
                tmp = w - d.length + l - rows[i].toString().length + xof;

                t.add(
                    tmp,
                    i + 2 - of,
                    tmp + rows[i].toString().length,
                    i + 2 - of,
                    'normal', 'backward',
                    rows[i].toString()
                );
                t.add(
                    w - d.length + l - rows[i].toString().length - 1 + xof,
                    i + 2 - of,
                    w - d.length + l - rows[i].toString().length - 1 + xof,
                    i + 2 - of,
                    'normal', 'forward',
                    '-'
                );

                t.underline(w - d.length + l - rows[i].toString().length - 1 + xof, i + 2 - of, rows[i].toString().length + 1);

                l++;
                zof = 0;
                if (rows[i + 1] === 0) {
                    zof = -1;
                }
                if (rows[i + 1].toString().length === 1) {
                    if (rows[i + 1].toString() !== '0') {
                        t.add(
                            w - d.length + l - 2 + xof + zof,
                            i + 3 - of,
                            w - d.length + l - 2 + xof + zof,
                            i + 3 - of,
                            'normal', 'forward',
                            '0'
                        );
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                    } else if (i + 1 !== rows.length - 1) {
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                        t.add(
                            w - d.length + l + xof + zof,
                            i + 3 - of,
                            w - d.length + l + xof + zof,
                            i + 3 - of,
                            'normal', 'forward',
                            '0'
                        );
                    } else {
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                    }
                } else {
                    t.add(
                        w - d.length + l - rows[i + 1].toString().length + xof + zof,
                        i + 3 - of,
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length - 1,
                        i + 3 - of,
                        'normal', 'backward',
                        rows[i + 1].toString().substr(
                            0, rows[i + 1].toString().length - 1
                        )
                    );
                    t.add(
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length - 1,
                        i + 3 - of,
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length,
                        i + 3 - of,
                        'normal', 'backward',
                        rows[i + 1].toString().substr(
                            rows[i + 1].toString().length - 1, 1
                        )
                    );
                }
            }
            $target.html(t.build());
        }
    }

    exports.init = init;

    return exports;

})();

APP.PrimeTable = (function () {

    var exports = {},
        row,
        initialized;

    function init() {
        $body.find('[data-primetable]:not(.inited)').each(function () {
            initPrimeTable($(this));
        });
        initBindings();
    }

    function initBindings() {
        if (!initialized) {
            $body.on('click', '[data-open-prime-table]', showPrimeTable);
            $body.on('click', '[data-submit-prime-table]', submitPrimeTable);
        }
        initialized = true;
    }

    function showPrimeTable() {
        $body.find('[data-prime-box]').show();
        $body.find('[data-dashboard-input]').hide();
        $body.find('[data-comment-box]').hide();
        $body.find('[data-primetable] input').first().focus();
    }

    function submitPrimeTable() {
        var data = collectPrimeTableData();
        APP.Ajax.post('/en-US/learn/post-comment', {
            questionId: $body.find('[name="question-id"]').val(),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            data: {
                type: 'prime-table',
                content: data
            }
        }).then(function (result) {
            var $formula = $('<div class="formula-flack" />'),
                $answersWrapper = $body.find('[data-previous-good-answers]');

            if (result.success) {
                $body.find('[data-previous-good-answers-wrapper]').show();
                $formula.html(APP.Tpl.run('prime-table',data));
                $answersWrapper.append($formula);
                $body.find('[data-dashboard-input]').show();
                $body.find('[data-comment-box]').hide();
                $body.find('[data-prime-box]').hide();
                resetPrimeTable();
            }
        }, window.NOOP);
    }

    function collectPrimeTableData() {
        var $rows = $body.find('[data-primetable] [data-prime-row]'),
            data = [];

        $rows.each(function () {
            var $this = $(this);

            data.push([
                parseInt($this.find('[data-inp1]').val(), 10),
                parseInt($this.find('[data-inp2]').val(), 10)
            ]);
        });

        return data;
    }

    function resetPrimeTable() {
        $body.find('[data-primetable]').html(row);
    }

    function initPrimeTable($table) {
        row = $table.find('[data-prime-row]')[0].outerHTML;
        $table.addClass('inited');
        $table.on('input', 'input', cleanTable);

        function cleanTable() {
            var $rows = $table.find('[data-prime-row]'),
                ready = true;

            $('.pin').hide();
            $rows.each(function (index) {
                var $this = $(this),
                    isLast = (index + 1) === $rows.length,
                    val1 = parseInt($this.find('[data-inp1]').val(), 10),
                    val2 = parseInt($this.find('[data-inp2]').val(), 10);

                $this.find('[data-inp1]').val(val1 > 0 ? val1 : '');
                $this.find('[data-inp2]').val(val2 > 0 ? val2 : '');

                if (val1 > 1) {
                    $this.find('[data-inp2]').parent().removeClass('prime-input__hide');
                } else {
                    $this.find('[data-inp2]').parent().addClass('prime-input__hide');
                }

                if(val1 > 0) {
                    $this.find('[data-inp1]').parent().removeClass('empty');
                } else {
                    $this.find('[data-inp1]').parent().addClass('empty');
                }

                if(val2 > 0) {
                    $this.find('[data-inp2]').parent().removeClass('empty');
                } else {
                    $this.find('[data-inp2]').parent().addClass('empty');
                }

                if (isLast) {
                    if ((val1 || val2) && val1 > 1) {
                        $table.append(row);
                    } else if (val1 === 1 && ready) {
                        $('.pin').show();
                        // checkPrimeTableReady();
                    }
                } else {
                    if (!val1) {
                        $this.remove();
                    }
                    if (!val1 || !val2) {
                        ready = false;
                    }
                }

            });

        }
    }

    exports.init = init;

    return exports;

})();

APP.KeepScroll = (function () {
    var exports = {};

    function init() {
        window.scrollTo(0, 0);
    }

    exports.init = init;

    return exports;

})();


APP.Notification = (function () {

    var exports = {},
        initialized = false,
        $notificationOverlay,
        $notificationContent,
        $notificationNumber,
        $notificationFavicon,
        $noNotification,

        notificationNumber = 0,
        notificationSound,

        notificationPing,

        afterDate = new Date('1987/12/10'),
        beforeDate = new Date(),

        clientId,
        isSubscribed,
        applicationServerPublicKey = 'BDymD2jYRhZIuab6nHvq8BjgGroN-jQWGIDQFQafKO6iSL8Dhey-umxpaJB4iD43Kc_vQFFUzpl0h6oLuHytJzw';

    function init() {
        if (!initialized) {
            initialized = true;
            initDomElements();
            initBindings();
            updateNotificationNumber();
            // notificationPing = setInterval(updateNotificationNumber, 30000);

            if (window.Audio) {
                notificationSound = new Audio(CDN.sound + 'notification.mp3');
            }
        }
    }

    function initDomElements() {
        $notificationContent = $body.find('[data-notification-content]');
        $notificationNumber = $body.find('[data-notification-number]');
        $noNotification = $body.find('[data-no-notification]');
        $notificationFavicon = $(document.getElementById('notification-icon'));
    }

    function initBindings() {
        $body.on('click', '[data-header-tooltip-show="notification"]', renderNewNotifications);

        $body.on('click', '[data-notification-href]', function () {
            var $this = $(this),
                href = $this.attr('data-notification-href');

            $this.addClass('notification__item--seen');
            updateNotificationSeen($this);
            setTimeout(closeNotificationOverlay, 1000);
            if (href) {
                APP.Page.applyPageByUrl(href);
            }
        });

        $body.on('click', '[data-notification-seen-toggle]', function (event) {
            var $this = $(this),
                $notification = $this.parents('[data-notification-href]');

            event.preventDefault();
            event.stopPropagation();
            $notification.toggleClass('notification__item--seen');
            updateNotificationSeen($notification);
        });

        $body.on('click', '[data-load-older-notifications]', function () {
            $(this).hide();
            loadOlderNotifications();
        });

        var userId = APP.User.getUserId();
        if (userId) {
            APP.Live.subscribeUserEvent(userId, function (data) {
                console.log(data);
                if (data.key === 'notificationCount') {
                    updateNotificationNumber(data.value);
                } else if (data.key === 'notificationOverlay') {
                    $body.find('[data-notification-alert-content]').html(APP.Tpl.run('notification-overlay', data.value));
                    APP.Layout.openOverlay('show-notification');
                }
            });
        }

        onWorkerMessage(function (data) {
            updateNotificationNumber(data.result);
        });
    }

    function getClientId() {
        if (window.localStorage) {
            clientId = window.localStorage.getItem('clientId');

            if (!clientId) {
                clientId = Math.round(Math.random() * Math.pow(9, 9)).toString(36) + new Date().getTime().toString(36);
                window.localStorage.setItem('clientId', clientId);
            }
        }
        return clientId;
    }

    function onWorkerMessage(callback) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', function (event) {
                callback && callback(JSON.parse(event.data));
            });
            if ('PushManager' in window && window.USER_LOGGED_IN) {
                navigator.serviceWorker.register(document.location.origin + '/en-US/sw.js').then(subscribeUser, console.log);
            }
        }
    }

    function subscribeUser(swRegistration) {
        navigator.serviceWorker.ready.then(function () {
            if (window.Notification && window.Notification.permission) {
                var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

                swRegistration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: applicationServerKey
                }).then(function (subscription) {
                    updateSubscriptionOnServer(subscription);
                    isSubscribed = true;
                }, function () {
                    console.log('no push...');
                });
            }
        });

        function urlB64ToUint8Array(base64String) {
            var padding = '='.repeat((4 - base64String.length % 4) % 4),
                base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/'),
                rawData = window.atob(base64),
                outputArray = new Uint8Array(rawData.length),
                i;

            for (i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }

            return outputArray;
        }

        function updateSubscriptionOnServer(subscription) {
            APP.Ajax.post('/en-US/service/save-web-push-subscription', {
                subscription: JSON.stringify(subscription),
                clientId: getClientId()
            }, true).then(window.NOOP, window.NOOP);
        }

    }

    function updateNotificationSeen($element) {
        APP.Ajax.post('/en-US/service/update-notification-seen', {
            id: $element.attr('data-notification-id'),
            seen: $element.hasClass('notification__item--seen')
        }, true).then(function (result) {
            updateNotificationNumber(result.result);
        }, window.NOOP);
    }

    function closeNotificationOverlay() {
        $body.find('[data-header-tooltip]').removeClass('show');
    }

    function renderNewNotifications() {
        $body.find('[data-notification-loading]').removeClass('hide');
        return APP.Ajax.post('/en-US/service/get-notifications', {
            after: afterDate
        }, true).then(function (response) {
            var notifications = response.result;

            if (notifications.length > 0) {
                afterDate = notifications[0].date;
                $notificationContent[0].insertAdjacentHTML('afterbegin', APP.Tpl.run('notification', notifications));
                APP.Layout.setMoments();
                updateNotificationNumber(0);
                $noNotification.hide();
            }
            $body.find('[data-notification-loading]').addClass('hide');
        }, window.NOOP);
    }

    function loadOlderNotifications() {
        return APP.Ajax.post('/en-US/service/get-notifications', {
            before: beforeDate
        }).then(function (response) {
            var notifications = response.result;

            if (notifications.length > 0) {
                beforeDate = notifications[notifications.length - 1].date;
                $notificationContent[0].insertAdjacentHTML('beforeend', APP.Tpl.run('notification', notifications));
                APP.Layout.setMoments();
                $noNotification.hide();
            }
        }, window.NOOP);
    }


    function updateNotificationNumber(number) {
        if (!window.USER_LOGGED_IN) {
            return false;
        } else if (typeof number !== 'undefined') {
            if (notificationNumber < number) {
                playNotificationSound();
                showNotificationFavicon();
            }
            notificationNumber = number;
            $body.find('[data-notification-number]').attr('data-notification-number', notificationNumber);
            if (notificationNumber === 0) {
                hideNotificationFavicon();
            }
        } else {
            APP.Ajax.post('/en-US/service/get-notifications-count', {}, true).then(function (result) {
                updateNotificationNumber(result.result);
            }, window.NOOP);
        }
    }

    function playNotificationSound() {
        if (window.USER_SETTINGS && window.USER_SETTINGS.audio && notificationSound) {
            try {
                notificationSound && notificationSound.play().catch(console.log);
            } catch (e) {
                console.log(e);
            }
        }
    }

    function showNotificationFavicon() {
        $notificationFavicon.attr('href', $notificationFavicon.attr('data-notification-icon'));
    }

    function hideNotificationFavicon() {
        $notificationFavicon.attr('href', $notificationFavicon.attr('data-default-icon'));
    }

    exports.init = init;
    return exports;

})();

APP.ProblemWorker = (function () {
    var exports,
        actualProblemId,
        $worker,
        initialized = false,
        callbacks = {},
        mainRows = [],
        rows = {},

        placeholderCallbacks = {},
        getDomCallbacks = {},
        runCallbacks = {},
        currentCallback,
        domIdSeeker = 0,
        runIdSeeker = 0;

    // it have to be called asap
    (function init() {
        if (!initialized) {
            initialized = true;

            if (typeof window.Worker !== 'function') {
                workerFallback()
            } else {
                $worker = new Worker(document.location.origin + '/static/js/worker.' + window.LANGUAGE + '.js');
                sendRequest({method: 'addReplaceTable', data: APP.Locale.getReplaceTable()}, true);
                $worker.onmessage = function (e) {
                    var data = JSON.parse(e.data);
                    messageHandler(data.method, data.data);
                };
                async(function () {
                    sendRequest({method: 'addTemplates', data: APP.$store.templates});
                });
            }
        }
    })();

    function workerFallback() {
        var script = document.createElement('script');
        script.src = document.location.origin + '/static/js/worker.' + window.LANGUAGE + '.js';
        document.body.appendChild(script);

        window.workerReady = (function () {
            $worker = window.$worker;
            sendRequest({method: 'addReplaceTable', data: APP.Locale.getReplaceTable()}, true);
            $worker.onmessage(messageHandler);
            async(function () {
                sendRequest({method: 'addTemplates', data: APP.$store.templates});
            });
        });
    }

    function messageHandler(method, data) {
        switch (method) {
            case 'addToDom':
                addToDom(data.content, data.placeholder);
                break;
            case 'placeholderContentArrived':
                placeholderCallbacks[data.id](data.content);
                break;
            case 'addDom':
                getDomCallbacks[data.id](data.content);
                break;
            case 'run':
                runCallbacks[data.id](data.content);
                break;
            case 'setCurrents':
                currentCallback(data);
                break;
            case 'done':
                showDone();
                break;
            case 'error':
                console.log('showError', data);
                showError(data);
                break;
            case 'elementary':
                var $mainRows = $body.find('[data-formulas-root] > [data-row-placeholder]');
                if ($mainRows.length <= 2) {
                    async(function () {
                        $mainRows.first().find('> [data-problem-main-row]').trigger('click');
                    });
                }
                break;
        }

    }

    function sendRequest(message, asap) {
        if(asap) {
            $worker.postMessage(message);
        } else {
            setTimeout(function () {
                $worker.postMessage(message);
            }, 8);
        }
    }

    function buildResult(id) {
        return new Promise(function (resolve) {
            actualProblemId = id;
            sendRequest({method: 'buildResult', data: {id: id, source: queryDecode().source}});
            callbacks.onDom = resolve;
        });
    }

    function addToDom(content, id) {
        var $loader = $body.find('[data-placeholder-loader="' + id + '"]:not(.loaded)');
        $loader.html(content);
        $loader.addClass('loaded');
        fillPlaceholderStackByWrapper($loader);
        async(callbacks.onDom);
    }

    function showDone() {
        var $waitbox = $body.find('.waitbox');
        $waitbox.addClass('waitbox--loaded');
    }

    function showError(msg) {
        var $waitbox = $body.find('.waitbox');
        if (typeof msg === 'string') {
            $waitbox.find('[data-problem-error-text]').show().text(msg);
        } else {
            $waitbox.find('[data-problem-error-text]').hide();
        }
        $waitbox.addClass('waitbox--broke');
    }

    function fillPlaceholderStackByWrapper($wrapper) {
        $wrapper.find('[data-row-placeholder]:not(.problem-row-placeholder--inited)').each(function () {
            var $this = $(this),
                $parent = $this.parents('[data-row-placeholder]').first(),
                parent = rows[$parent.attr('data-row-placeholder')],
                row = new Row(),
                id;

            row.init($this, parent);
            id = row.getId();

            rows[row.getId()] = row;

            if (!parent) {
                mainRows.push(id);
            }
        });
    }

    function getContent(id, callback) {
        sendRequest({method: 'getPlaceholder', data: id});
        placeholderCallbacks[id] = callback;
    }

    function checkMainRows() {
        var i;
        async(function () {
            for (i = 0; i < mainRows.length; i++) {
                rows[mainRows[i]].check();
            }
        });
    }

    function openRow(placeholderId) {
        if (rows.hasOwnProperty(placeholderId)) {
            rows[placeholderId].open();
        }
    }

    function closeRow(placeholderId) {
        if (rows.hasOwnProperty(placeholderId)) {
            rows[placeholderId].close();
        }
    }

    function getDom(formula, mode) {
        return new Promise(function (resolve) {
            sendRequest({
                method: 'getDom', data: {
                    formula: formula,
                    mode: mode,
                    id: ++domIdSeeker
                }
            });
            getDomCallbacks[domIdSeeker] = function (data) {
                resolve(data);
            }
        });
    }

    function run(tpl, context) {
        return new Promise(function (resolve) {
            sendRequest({
                method: 'run', data: {
                    id: ++runIdSeeker,
                    tpl: tpl,
                    context: context
                }
            });
            runCallbacks[runIdSeeker] = resolve;
        });
    }

    exports = {
        sendRequest: sendRequest,
        buildResult: buildResult,
        fillPlaceholderStackByWrapper: fillPlaceholderStackByWrapper,
        getContent: getContent,
        checkMainRows: checkMainRows,
        openRow: openRow,
        closeRow: closeRow,
        getDom: getDom,
        run: run
    };

    return exports;

})();

//! moment.js
//! version : 2.6.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (undefined) {

    /************************************
     Constants
     ************************************/

    var moment,
        VERSION = "2.6.0",
        // the global-scope this is NOT the global object in Node.js
        globalScope = typeof global !== 'undefined' ? global : this,
        oldGlobalMoment,
        round = Math.round,
        i,

        YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,

        // internal storage for language config files
        languages = {},

        // moment internal properties
        momentProperties = {
            _isAMomentObject: null,
            _i : null,
            _f : null,
            _l : null,
            _strict : null,
            _isUTC : null,
            _offset : null,  // optional. Combine with _isUTC
            _pf : null,
            _lang : null  // optional
        },

        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),

        // ASP.NET json date format regex
        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,

        // format tokens
        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,

        // parsing token regexes
        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
        parseTokenDigits = /\d+/, // nonzero number of digits
        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        parseTokenT = /T/i, // T (ISO separator)
        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        parseTokenOrdinal = /\d{1,2}/,

        //strict parsing regexes
        parseTokenOneDigit = /\d/, // 0 - 9
        parseTokenTwoDigits = /\d\d/, // 00 - 99
        parseTokenThreeDigits = /\d{3}/, // 000 - 999
        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf

        // iso 8601 regex
        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,

        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',

        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
            ['YYYY-DDD', /\d{4}-\d{3}/]
        ],

        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
            ['HH:mm', /(T| )\d\d:\d\d/],
            ['HH', /(T| )\d\d/]
        ],

        // timezone chunker "+10:00" > ["10", "00"] or "-1530" > ["-15", "30"]
        parseTimezoneChunker = /([\+\-]|\d\d)/gi,

        // getter and setter names
        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
        unitMillisecondFactors = {
            'Milliseconds' : 1,
            'Seconds' : 1e3,
            'Minutes' : 6e4,
            'Hours' : 36e5,
            'Days' : 864e5,
            'Months' : 2592e6,
            'Years' : 31536e6
        },

        unitAliases = {
            ms : 'millisecond',
            s : 'second',
            m : 'minute',
            h : 'hour',
            d : 'day',
            D : 'date',
            w : 'week',
            W : 'isoWeek',
            M : 'month',
            Q : 'quarter',
            y : 'year',
            DDD : 'dayOfYear',
            e : 'weekday',
            E : 'isoWeekday',
            gg: 'weekYear',
            GG: 'isoWeekYear'
        },

        camelFunctions = {
            dayofyear : 'dayOfYear',
            isoweekday : 'isoWeekday',
            isoweek : 'isoWeek',
            weekyear : 'weekYear',
            isoweekyear : 'isoWeekYear'
        },

        // format function strings
        formatFunctions = {},

        // tokens to ordinalize and pad
        ordinalizeTokens = 'DDD w W M D d'.split(' '),
        paddedTokens = 'M D H h m s w W'.split(' '),

        formatTokenFunctions = {
            M    : function () {
                return this.month() + 1;
            },
            MMM  : function (format) {
                return this.lang().monthsShort(this, format);
            },
            MMMM : function (format) {
                return this.lang().months(this, format);
            },
            D    : function () {
                return this.date();
            },
            DDD  : function () {
                return this.dayOfYear();
            },
            d    : function () {
                return this.day();
            },
            dd   : function (format) {
                return this.lang().weekdaysMin(this, format);
            },
            ddd  : function (format) {
                return this.lang().weekdaysShort(this, format);
            },
            dddd : function (format) {
                return this.lang().weekdays(this, format);
            },
            w    : function () {
                return this.week();
            },
            W    : function () {
                return this.isoWeek();
            },
            YY   : function () {
                return leftZeroFill(this.year() % 100, 2);
            },
            YYYY : function () {
                return leftZeroFill(this.year(), 4);
            },
            YYYYY : function () {
                return leftZeroFill(this.year(), 5);
            },
            YYYYYY : function () {
                var y = this.year(), sign = y >= 0 ? '+' : '-';
                return sign + leftZeroFill(Math.abs(y), 6);
            },
            gg   : function () {
                return leftZeroFill(this.weekYear() % 100, 2);
            },
            gggg : function () {
                return leftZeroFill(this.weekYear(), 4);
            },
            ggggg : function () {
                return leftZeroFill(this.weekYear(), 5);
            },
            GG   : function () {
                return leftZeroFill(this.isoWeekYear() % 100, 2);
            },
            GGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 4);
            },
            GGGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 5);
            },
            e : function () {
                return this.weekday();
            },
            E : function () {
                return this.isoWeekday();
            },
            a    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), true);
            },
            A    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), false);
            },
            H    : function () {
                return this.hours();
            },
            h    : function () {
                return this.hours() % 12 || 12;
            },
            m    : function () {
                return this.minutes();
            },
            s    : function () {
                return this.seconds();
            },
            S    : function () {
                return toInt(this.milliseconds() / 100);
            },
            SS   : function () {
                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
            },
            SSS  : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            SSSS : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            Z    : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + ":" + leftZeroFill(toInt(a) % 60, 2);
            },
            ZZ   : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
            },
            z : function () {
                return this.zoneAbbr();
            },
            zz : function () {
                return this.zoneName();
            },
            X    : function () {
                return this.unix();
            },
            Q : function () {
                return this.quarter();
            }
        },

        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'];

    function defaultParsingFlags() {
        // We need to deep clone this object, and es5 standard is not very
        // helpful.
        return {
            empty : false,
            unusedTokens : [],
            unusedInput : [],
            overflow : -2,
            charsLeftOver : 0,
            nullInput : false,
            invalidMonth : null,
            invalidFormat : false,
            userInvalidated : false,
            iso: false
        };
    }

    function deprecate(msg, fn) {
        var firstTime = true;
        function printMsg() {
            if (moment.suppressDeprecationWarnings === false &&
                typeof console !== 'undefined' && console.warn) {
                console.warn("Deprecation warning: " + msg);
            }
        }
        return extend(function () {
            if (firstTime) {
                printMsg();
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    function padToken(func, count) {
        return function (a) {
            return leftZeroFill(func.call(this, a), count);
        };
    }
    function ordinalizeToken(func, period) {
        return function (a) {
            return this.lang().ordinal(func.call(this, a), period);
        };
    }

    while (ordinalizeTokens.length) {
        i = ordinalizeTokens.pop();
        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
    }
    while (paddedTokens.length) {
        i = paddedTokens.pop();
        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
    }
    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);


    /************************************
     Constructors
     ************************************/

    function Language() {

    }

    // Moment prototype object
    function Moment(config) {
        checkOverflow(config);
        extend(this, config);
    }

    // Duration Constructor
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._bubble();
    }

    /************************************
     Helpers
     ************************************/


    function extend(a, b) {
        for (var i in b) {
            if (b.hasOwnProperty(i)) {
                a[i] = b[i];
            }
        }

        if (b.hasOwnProperty("toString")) {
            a.toString = b.toString;
        }

        if (b.hasOwnProperty("valueOf")) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function cloneMoment(m) {
        var result = {}, i;
        for (i in m) {
            if (m.hasOwnProperty(i) && momentProperties.hasOwnProperty(i)) {
                result[i] = m[i];
            }
        }

        return result;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    // left zero fill a number
    // see http://jsperf.com/left-zero-filling for performance comparison
    function leftZeroFill(number, targetLength, forceSign) {
        var output = '' + Math.abs(number),
            sign = number >= 0;

        while (output.length < targetLength) {
            output = '0' + output;
        }
        return (sign ? (forceSign ? '+' : '') : '-') + output;
    }

    // helper function for _.addTime and _.subtractTime
    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
        }
        if (months) {
            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            moment.updateOffset(mom, days || months);
        }
    }

    // check if is an array
    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return  Object.prototype.toString.call(input) === '[object Date]' ||
            input instanceof Date;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function normalizeUnits(units) {
        if (units) {
            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
            units = unitAliases[units] || camelFunctions[lowered] || lowered;
        }
        return units;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (inputObject.hasOwnProperty(prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeList(field) {
        var count, setter;

        if (field.indexOf('week') === 0) {
            count = 7;
            setter = 'day';
        }
        else if (field.indexOf('month') === 0) {
            count = 12;
            setter = 'month';
        }
        else {
            return;
        }

        moment[field] = function (format, index) {
            var i, getter,
                method = moment.fn._lang[field],
                results = [];

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            getter = function (i) {
                var m = moment().utc().set(setter, i);
                return method.call(moment.fn._lang, m, format || '');
            };

            if (index != null) {
                return getter(index);
            }
            else {
                for (i = 0; i < count; i++) {
                    results.push(getter(i));
                }
                return results;
            }
        };
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            if (coercedNumber >= 0) {
                value = Math.floor(coercedNumber);
            } else {
                value = Math.ceil(coercedNumber);
            }
        }

        return value;
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    function weeksInYear(year, dow, doy) {
        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function checkOverflow(m) {
        var overflow;
        if (m._a && m._pf.overflow === -2) {
            overflow =
                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
                    m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
                        m._a[HOUR] < 0 || m._a[HOUR] > 23 ? HOUR :
                            m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
                                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
                                    m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
                                        -1;

            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            m._pf.overflow = overflow;
        }
    }

    function isValid(m) {
        if (m._isValid == null) {
            m._isValid = !isNaN(m._d.getTime()) &&
                m._pf.overflow < 0 &&
                !m._pf.empty &&
                !m._pf.invalidMonth &&
                !m._pf.nullInput &&
                !m._pf.invalidFormat &&
                !m._pf.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    m._pf.charsLeftOver === 0 &&
                    m._pf.unusedTokens.length === 0;
            }
        }
        return m._isValid;
    }

    function normalizeLanguage(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function makeAs(input, model) {
        return model._isUTC ? moment(input).zone(model._offset || 0) :
            moment(input).local();
    }

    /************************************
     Languages
     ************************************/


    extend(Language.prototype, {

        set : function (config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        },

        _months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        months : function (m) {
            return this._months[m.month()];
        },

        _monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        monthsShort : function (m) {
            return this._monthsShort[m.month()];
        },

        monthsParse : function (monthName) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                if (!this._monthsParse[i]) {
                    mom = moment.utc([2000, i]);
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        },

        _weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdays : function (m) {
            return this._weekdays[m.day()];
        },

        _weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysShort : function (m) {
            return this._weekdaysShort[m.day()];
        },

        _weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        weekdaysMin : function (m) {
            return this._weekdaysMin[m.day()];
        },

        weekdaysParse : function (weekdayName) {
            var i, mom, regex;

            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = moment([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        },

        _longDateFormat : {
            LT : "h:mm A",
            L : "MM/DD/YYYY",
            LL : "MMMM D YYYY",
            LLL : "MMMM D YYYY LT",
            LLLL : "dddd, MMMM D YYYY LT"
        },
        longDateFormat : function (key) {
            var output = this._longDateFormat[key];
            if (!output && this._longDateFormat[key.toUpperCase()]) {
                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function (val) {
                    return val.slice(1);
                });
                this._longDateFormat[key] = output;
            }
            return output;
        },

        isPM : function (input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return ((input + '').toLowerCase().charAt(0) === 'p');
        },

        _meridiemParse : /[ap]\.?m?\.?/i,
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        },

        _calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.apply(mom) : output;
        },

        _relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        relativeTime : function (number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return (typeof output === 'function') ?
                output(number, withoutSuffix, string, isFuture) :
                output.replace(/%d/i, number);
        },
        pastFuture : function (diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        },

        ordinal : function (number) {
            return this._ordinal.replace("%d", number);
        },
        _ordinal : "%d",

        preparse : function (string) {
            return string;
        },

        postformat : function (string) {
            return string;
        },

        week : function (mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        },

        _week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        },

        _invalidDate: 'Invalid date',
        invalidDate: function () {
            return this._invalidDate;
        }
    });

    // Loads a language definition into the `languages` cache.  The function
    // takes a key and optionally values.  If not in the browser and no values
    // are provided, it will load the language file module.  As a convenience,
    // this function also returns the language values.
    function loadLang(key, values) {
        values.abbr = key;
        if (!languages[key]) {
            languages[key] = new Language();
        }
        languages[key].set(values);
        return languages[key];
    }

    // Remove a language from the `languages` cache. Mostly useful in tests.
    function unloadLang(key) {
        delete languages[key];
    }

    // Determines which language definition to use and returns it.
    //
    // With no parameters, it will return the global language.  If you
    // pass in a language key, such as 'en', it will return the
    // definition for 'en', so long as 'en' has already been loaded using
    // moment.lang.
    function getLangDefinition(key) {
        var i = 0, j, lang, next, split,
            get = function (k) {
                if (!languages[k] && hasModule) {
                    try {
                        require('./lang/' + k);
                    } catch (e) { }
                }
                return languages[k];
            };

        if (!key) {
            return moment.fn._lang;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            lang = get(key);
            if (lang) {
                return lang;
            }
            key = [key];
        }

        //pick the language from the array
        //try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
        //substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
        while (i < key.length) {
            split = normalizeLanguage(key[i]).split('-');
            j = split.length;
            next = normalizeLanguage(key[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                lang = get(split.slice(0, j).join('-'));
                if (lang) {
                    return lang;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return moment.fn._lang;
    }

    /************************************
     Formatting
     ************************************/


    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, "");
        }
        return input.replace(/\\/g, "");
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = "";
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {

        if (!m.isValid()) {
            return m.lang().invalidDate();
        }

        format = expandFormat(format, m.lang());

        if (!formatFunctions[format]) {
            formatFunctions[format] = makeFormatFunction(format);
        }

        return formatFunctions[format](m);
    }

    function expandFormat(format, lang) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return lang.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }


    /************************************
     Parsing
     ************************************/


    // get the regex to find the next token
    function getParseRegexForToken(token, config) {
        var a, strict = config._strict;
        switch (token) {
            case 'Q':
                return parseTokenOneDigit;
            case 'DDDD':
                return parseTokenThreeDigits;
            case 'YYYY':
            case 'GGGG':
            case 'gggg':
                return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
            case 'Y':
            case 'G':
            case 'g':
                return parseTokenSignedNumber;
            case 'YYYYYY':
            case 'YYYYY':
            case 'GGGGG':
            case 'ggggg':
                return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
            case 'S':
                if (strict) { return parseTokenOneDigit; }
            /* falls through */
            case 'SS':
                if (strict) { return parseTokenTwoDigits; }
            /* falls through */
            case 'SSS':
                if (strict) { return parseTokenThreeDigits; }
            /* falls through */
            case 'DDD':
                return parseTokenOneToThreeDigits;
            case 'MMM':
            case 'MMMM':
            case 'dd':
            case 'ddd':
            case 'dddd':
                return parseTokenWord;
            case 'a':
            case 'A':
                return getLangDefinition(config._l)._meridiemParse;
            case 'X':
                return parseTokenTimestampMs;
            case 'Z':
            case 'ZZ':
                return parseTokenTimezone;
            case 'T':
                return parseTokenT;
            case 'SSSS':
                return parseTokenDigits;
            case 'MM':
            case 'DD':
            case 'YY':
            case 'GG':
            case 'gg':
            case 'HH':
            case 'hh':
            case 'mm':
            case 'ss':
            case 'ww':
            case 'WW':
                return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
            case 'M':
            case 'D':
            case 'd':
            case 'H':
            case 'h':
            case 'm':
            case 's':
            case 'w':
            case 'W':
            case 'e':
            case 'E':
                return parseTokenOneOrTwoDigits;
            case 'Do':
                return parseTokenOrdinal;
            default :
                a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), "i"));
                return a;
        }
    }

    function timezoneMinutesFromString(string) {
        string = string || "";
        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
            minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? -minutes : minutes;
    }

    // function to convert string input to date
    function addTimeToArrayFromToken(token, input, config) {
        var a, datePartArray = config._a;

        switch (token) {
            // QUARTER
            case 'Q':
                if (input != null) {
                    datePartArray[MONTH] = (toInt(input) - 1) * 3;
                }
                break;
            // MONTH
            case 'M' : // fall through to MM
            case 'MM' :
                if (input != null) {
                    datePartArray[MONTH] = toInt(input) - 1;
                }
                break;
            case 'MMM' : // fall through to MMMM
            case 'MMMM' :
                a = getLangDefinition(config._l).monthsParse(input);
                // if we didn't find a month name, mark the date as invalid.
                if (a != null) {
                    datePartArray[MONTH] = a;
                } else {
                    config._pf.invalidMonth = input;
                }
                break;
            // DAY OF MONTH
            case 'D' : // fall through to DD
            case 'DD' :
                if (input != null) {
                    datePartArray[DATE] = toInt(input);
                }
                break;
            case 'Do' :
                if (input != null) {
                    datePartArray[DATE] = toInt(parseInt(input, 10));
                }
                break;
            // DAY OF YEAR
            case 'DDD' : // fall through to DDDD
            case 'DDDD' :
                if (input != null) {
                    config._dayOfYear = toInt(input);
                }

                break;
            // YEAR
            case 'YY' :
                datePartArray[YEAR] = moment.parseTwoDigitYear(input);
                break;
            case 'YYYY' :
            case 'YYYYY' :
            case 'YYYYYY' :
                datePartArray[YEAR] = toInt(input);
                break;
            // AM / PM
            case 'a' : // fall through to A
            case 'A' :
                config._isPm = getLangDefinition(config._l).isPM(input);
                break;
            // 24 HOUR
            case 'H' : // fall through to hh
            case 'HH' : // fall through to hh
            case 'h' : // fall through to hh
            case 'hh' :
                datePartArray[HOUR] = toInt(input);
                break;
            // MINUTE
            case 'm' : // fall through to mm
            case 'mm' :
                datePartArray[MINUTE] = toInt(input);
                break;
            // SECOND
            case 's' : // fall through to ss
            case 'ss' :
                datePartArray[SECOND] = toInt(input);
                break;
            // MILLISECOND
            case 'S' :
            case 'SS' :
            case 'SSS' :
            case 'SSSS' :
                datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
                break;
            // UNIX TIMESTAMP WITH MS
            case 'X':
                config._d = new Date(parseFloat(input) * 1000);
                break;
            // TIMEZONE
            case 'Z' : // fall through to ZZ
            case 'ZZ' :
                config._useUTC = true;
                config._tzm = timezoneMinutesFromString(input);
                break;
            case 'w':
            case 'ww':
            case 'W':
            case 'WW':
            case 'd':
            case 'dd':
            case 'ddd':
            case 'dddd':
            case 'e':
            case 'E':
                token = token.substr(0, 1);
            /* falls through */
            case 'gg':
            case 'gggg':
            case 'GG':
            case 'GGGG':
            case 'GGGGG':
                token = token.substr(0, 2);
                if (input) {
                    config._w = config._w || {};
                    config._w[token] = input;
                }
                break;
        }
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function dateFromConfig(config) {
        var i, date, input = [], currentDate,
            yearToUse, fixYear, w, temp, lang, weekday, week;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            fixYear = function (val) {
                var intVal = parseInt(val, 10);
                return val ?
                    (val.length < 3 ? (intVal > 68 ? 1900 + intVal : 2000 + intVal) : intVal) :
                    (config._a[YEAR] == null ? moment().weekYear() : config._a[YEAR]);
            };

            w = config._w;
            if (w.GG != null || w.W != null || w.E != null) {
                temp = dayOfYearFromWeeks(fixYear(w.GG), w.W || 1, w.E, 4, 1);
            }
            else {
                lang = getLangDefinition(config._l);
                weekday = w.d != null ?  parseWeekday(w.d, lang) :
                    (w.e != null ?  parseInt(w.e, 10) + lang._week.dow : 0);

                week = parseInt(w.w, 10) || 1;

                //if we're parsing 'd', then the low day numbers may be next week
                if (w.d != null && weekday < lang._week.dow) {
                    week++;
                }

                temp = dayOfYearFromWeeks(fixYear(w.gg), week, weekday, lang._week.doy, lang._week.dow);
            }

            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = config._a[YEAR] == null ? currentDate[YEAR] : config._a[YEAR];

            if (config._dayOfYear > daysInYear(yearToUse)) {
                config._pf._overflowDayOfYear = true;
            }

            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // add the offsets to the time to be parsed so that we can have a clean array for checking isValid
        input[HOUR] += toInt((config._tzm || 0) / 60);
        input[MINUTE] += toInt((config._tzm || 0) % 60);

        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
    }

    function dateFromObject(config) {
        var normalizedInput;

        if (config._d) {
            return;
        }

        normalizedInput = normalizeObjectUnits(config._i);
        config._a = [
            normalizedInput.year,
            normalizedInput.month,
            normalizedInput.day,
            normalizedInput.hour,
            normalizedInput.minute,
            normalizedInput.second,
            normalizedInput.millisecond
        ];

        dateFromConfig(config);
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate()
            ];
        } else {
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }
    }

    // date from string and format string
    function makeDateFromStringAndFormat(config) {

        config._a = [];
        config._pf.empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var lang = getLangDefinition(config._l),
            string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, lang).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    config._pf.unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    config._pf.empty = false;
                }
                else {
                    config._pf.unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                config._pf.unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            config._pf.unusedInput.push(string);
        }

        // handle am pm
        if (config._isPm && config._a[HOUR] < 12) {
            config._a[HOUR] += 12;
        }
        // if is 12 am, change hours to 0
        if (config._isPm === false && config._a[HOUR] === 12) {
            config._a[HOUR] = 0;
        }

        dateFromConfig(config);
        checkOverflow(config);
    }

    function unescapeFormat(s) {
        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        });
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function regexpEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    // date from string and array of format strings
    function makeDateFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            config._pf.invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = extend({}, config);
            tempConfig._pf = defaultParsingFlags();
            tempConfig._f = config._f[i];
            makeDateFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += tempConfig._pf.charsLeftOver;

            //or tokens
            currentScore += tempConfig._pf.unusedTokens.length * 10;

            tempConfig._pf.score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    // date from iso format
    function makeDateFromString(config) {
        var i, l,
            string = config._i,
            match = isoRegex.exec(string);

        if (match) {
            config._pf.iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    // match[5] should be "T" or undefined
                    config._f = isoDates[i][0] + (match[6] || " ");
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    config._f += isoTimes[i][0];
                    break;
                }
            }
            if (string.match(parseTokenTimezone)) {
                config._f += "Z";
            }
            makeDateFromStringAndFormat(config);
        }
        else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDateFromInput(config) {
        var input = config._i,
            matched = aspNetJsonRegex.exec(input);

        if (input === undefined) {
            config._d = new Date();
        } else if (matched) {
            config._d = new Date(+matched[1]);
        } else if (typeof input === 'string') {
            makeDateFromString(config);
        } else if (isArray(input)) {
            config._a = input.slice(0);
            dateFromConfig(config);
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof(input) === 'object') {
            dateFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function makeUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function parseWeekday(input, language) {
        if (typeof input === 'string') {
            if (!isNaN(input)) {
                input = parseInt(input, 10);
            }
            else {
                input = language.weekdaysParse(input);
                if (typeof input !== 'number') {
                    return null;
                }
            }
        }
        return input;
    }

    /************************************
     Relative Time
     ************************************/


    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, lang) {
        return lang.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime(milliseconds, withoutSuffix, lang) {
        var seconds = round(Math.abs(milliseconds) / 1000),
            minutes = round(seconds / 60),
            hours = round(minutes / 60),
            days = round(hours / 24),
            years = round(days / 365),
            args = seconds < 45 && ['s', seconds] ||
                minutes === 1 && ['m'] ||
                minutes < 45 && ['mm', minutes] ||
                hours === 1 && ['h'] ||
                hours < 22 && ['hh', hours] ||
                days === 1 && ['d'] ||
                days <= 25 && ['dd', days] ||
                days <= 45 && ['M'] ||
                days < 345 && ['MM', round(days / 30)] ||
                years === 1 && ['y'] || ['yy', years];
        args[2] = withoutSuffix;
        args[3] = milliseconds > 0;
        args[4] = lang;
        return substituteTimeAgo.apply({}, args);
    }


    /************************************
     Week of Year
     ************************************/


    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = moment(mom).add('d', daysToDayOfWeek);
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;

        weekday = weekday != null ? weekday : firstDayOfWeek;
        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    /************************************
     Top Level Functions
     ************************************/

    function makeMoment(config) {
        var input = config._i,
            format = config._f;

        if (input === null || (format === undefined && input === '')) {
            return moment.invalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = getLangDefinition().preparse(input);
        }

        if (moment.isMoment(input)) {
            config = cloneMoment(input);

            config._d = new Date(+input._d);
        } else if (format) {
            if (isArray(format)) {
                makeDateFromStringAndArray(config);
            } else {
                makeDateFromStringAndFormat(config);
            }
        } else {
            makeDateFromInput(config);
        }

        return new Moment(config);
    }

    moment = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._i = input;
        c._f = format;
        c._l = lang;
        c._strict = strict;
        c._isUTC = false;
        c._pf = defaultParsingFlags();

        return makeMoment(c);
    };

    moment.suppressDeprecationWarnings = false;

    moment.createFromInputFallback = deprecate(
        "moment construction falls back to js Date. This is " +
        "discouraged and will be removed in upcoming major " +
        "release. Please refer to " +
        "https://github.com/moment/moment/issues/1407 for more info.",
        function (config) {
            config._d = new Date(config._i);
        });

    // creating with utc
    moment.utc = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._useUTC = true;
        c._isUTC = true;
        c._l = lang;
        c._i = input;
        c._f = format;
        c._strict = strict;
        c._pf = defaultParsingFlags();

        return makeMoment(c).utc();
    };

    // creating with unix timestamp (in seconds)
    moment.unix = function (input) {
        return moment(input * 1000);
    };

    // duration
    moment.duration = function (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            parseIso;

        if (moment.isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoDurationRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            parseIso = function (inp) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            };
            duration = {
                y: parseIso(match[2]),
                M: parseIso(match[3]),
                d: parseIso(match[4]),
                h: parseIso(match[5]),
                m: parseIso(match[6]),
                s: parseIso(match[7]),
                w: parseIso(match[8])
            };
        }

        ret = new Duration(duration);

        if (moment.isDuration(input) && input.hasOwnProperty('_lang')) {
            ret._lang = input._lang;
        }

        return ret;
    };

    // version number
    moment.version = VERSION;

    // default format
    moment.defaultFormat = isoFormat;

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    moment.momentProperties = momentProperties;

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    moment.updateOffset = function () {};

    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    moment.lang = function (key, values) {
        var r;
        if (!key) {
            return moment.fn._lang._abbr;
        }
        if (values) {
            loadLang(normalizeLanguage(key), values);
        } else if (values === null) {
            unloadLang(key);
            key = 'en';
        } else if (!languages[key]) {
            getLangDefinition(key);
        }
        r = moment.duration.fn._lang = moment.fn._lang = getLangDefinition(key);
        return r._abbr;
    };

    // returns language data
    moment.langData = function (key) {
        if (key && key._lang && key._lang._abbr) {
            key = key._lang._abbr;
        }
        return getLangDefinition(key);
    };

    // compare moment object
    moment.isMoment = function (obj) {
        return obj instanceof Moment ||
            (obj != null &&  obj.hasOwnProperty('_isAMomentObject'));
    };

    // for typechecking Duration objects
    moment.isDuration = function (obj) {
        return obj instanceof Duration;
    };

    for (i = lists.length - 1; i >= 0; --i) {
        makeList(lists[i]);
    }

    moment.normalizeUnits = function (units) {
        return normalizeUnits(units);
    };

    moment.invalid = function (flags) {
        var m = moment.utc(NaN);
        if (flags != null) {
            extend(m._pf, flags);
        }
        else {
            m._pf.userInvalidated = true;
        }

        return m;
    };

    moment.parseZone = function () {
        return moment.apply(null, arguments).parseZone();
    };

    moment.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    /************************************
     Moment Prototype
     ************************************/


    extend(moment.fn = Moment.prototype, {

        clone : function () {
            return moment(this);
        },

        valueOf : function () {
            return +this._d + ((this._offset || 0) * 60000);
        },

        unix : function () {
            return Math.floor(+this / 1000);
        },

        toString : function () {
            return this.clone().lang('en').format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        },

        toDate : function () {
            return this._offset ? new Date(+this) : this._d;
        },

        toISOString : function () {
            var m = moment(this).utc();
            if (0 < m.year() && m.year() <= 9999) {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        },

        toArray : function () {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hours(),
                m.minutes(),
                m.seconds(),
                m.milliseconds()
            ];
        },

        isValid : function () {
            return isValid(this);
        },

        isDSTShifted : function () {

            if (this._a) {
                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
            }

            return false;
        },

        parsingFlags : function () {
            return extend({}, this._pf);
        },

        invalidAt: function () {
            return this._pf.overflow;
        },

        utc : function () {
            return this.zone(0);
        },

        local : function () {
            this.zone(0);
            this._isUTC = false;
            return this;
        },

        format : function (inputString) {
            var output = formatMoment(this, inputString || moment.defaultFormat);
            return this.lang().postformat(output);
        },

        add : function (input, val) {
            var dur;
            // switch args to support add('s', 1) and add(1, 's')
            if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, 1);
            return this;
        },

        subtract : function (input, val) {
            var dur;
            // switch args to support subtract('s', 1) and subtract(1, 's')
            if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, -1);
            return this;
        },

        diff : function (input, units, asFloat) {
            var that = makeAs(input, this),
                zoneDiff = (this.zone() - that.zone()) * 6e4,
                diff, output;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month') {
                // average number of days in the months in the given dates
                diff = (this.daysInMonth() + that.daysInMonth()) * 432e5; // 24 * 60 * 60 * 1000 / 2
                // difference in months
                output = ((this.year() - that.year()) * 12) + (this.month() - that.month());
                // adjust by taking difference in days, average number of days
                // and dst in the given months.
                output += ((this - moment(this).startOf('month')) -
                    (that - moment(that).startOf('month'))) / diff;
                // same as above but with zones, to negate all dst
                output -= ((this.zone() - moment(this).startOf('month').zone()) -
                    (that.zone() - moment(that).startOf('month').zone())) * 6e4 / diff;
                if (units === 'year') {
                    output = output / 12;
                }
            } else {
                diff = (this - that);
                output = units === 'second' ? diff / 1e3 : // 1000
                    units === 'minute' ? diff / 6e4 : // 1000 * 60
                        units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
                            units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                                units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                                    diff;
            }
            return asFloat ? output : absRound(output);
        },

        from : function (time, withoutSuffix) {
            return moment.duration(this.diff(time)).lang(this.lang()._abbr).humanize(!withoutSuffix);
        },

        fromNow : function (withoutSuffix) {
            return this.from(moment(), withoutSuffix);
        },

        calendar : function () {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're zone'd or not.
            var sod = makeAs(moment(), this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' :
                    diff < -1 ? 'lastWeek' :
                        diff < 0 ? 'lastDay' :
                            diff < 1 ? 'sameDay' :
                                diff < 2 ? 'nextDay' :
                                    diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(this.lang().calendar(format, this));
        },

        isLeapYear : function () {
            return isLeapYear(this.year());
        },

        isDST : function () {
            return (this.zone() < this.clone().month(0).zone() ||
            this.zone() < this.clone().month(5).zone());
        },

        day : function (input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.lang());
                return this.add({ d : input - day });
            } else {
                return day;
            }
        },

        month : makeAccessor('Month', true),

        startOf: function (units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
                case 'year':
                    this.month(0);
                /* falls through */
                case 'quarter':
                case 'month':
                    this.date(1);
                /* falls through */
                case 'week':
                case 'isoWeek':
                case 'day':
                    this.hours(0);
                /* falls through */
                case 'hour':
                    this.minutes(0);
                /* falls through */
                case 'minute':
                    this.seconds(0);
                /* falls through */
                case 'second':
                    this.milliseconds(0);
                /* falls through */
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            } else if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        },

        endOf: function (units) {
            units = normalizeUnits(units);
            return this.startOf(units).add((units === 'isoWeek' ? 'week' : units), 1).subtract('ms', 1);
        },

        isAfter: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) > +moment(input).startOf(units);
        },

        isBefore: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) < +moment(input).startOf(units);
        },

        isSame: function (input, units) {
            units = units || 'ms';
            return +this.clone().startOf(units) === +makeAs(input, this).startOf(units);
        },

        min: function (other) {
            other = moment.apply(null, arguments);
            return other < this ? this : other;
        },

        max: function (other) {
            other = moment.apply(null, arguments);
            return other > this ? this : other;
        },

        // keepTime = true means only change the timezone, without affecting
        // the local hour. So 5:31:26 +0300 --[zone(2, true)]--> 5:31:26 +0200
        // It is possible that 5:31:26 doesn't exist int zone +0200, so we
        // adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        zone : function (input, keepTime) {
            var offset = this._offset || 0;
            if (input != null) {
                if (typeof input === "string") {
                    input = timezoneMinutesFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                this._offset = input;
                this._isUTC = true;
                if (offset !== input) {
                    if (!keepTime || this._changeInProgress) {
                        addOrSubtractDurationFromMoment(this,
                            moment.duration(offset - input, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        moment.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
            } else {
                return this._isUTC ? offset : this._d.getTimezoneOffset();
            }
            return this;
        },

        zoneAbbr : function () {
            return this._isUTC ? "UTC" : "";
        },

        zoneName : function () {
            return this._isUTC ? "Coordinated Universal Time" : "";
        },

        parseZone : function () {
            if (this._tzm) {
                this.zone(this._tzm);
            } else if (typeof this._i === 'string') {
                this.zone(this._i);
            }
            return this;
        },

        hasAlignedHourOffset : function (input) {
            if (!input) {
                input = 0;
            }
            else {
                input = moment(input).zone();
            }

            return (this.zone() - input) % 60 === 0;
        },

        daysInMonth : function () {
            return daysInMonth(this.year(), this.month());
        },

        dayOfYear : function (input) {
            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add("d", (input - dayOfYear));
        },

        quarter : function (input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        },

        weekYear : function (input) {
            var year = weekOfYear(this, this.lang()._week.dow, this.lang()._week.doy).year;
            return input == null ? year : this.add("y", (input - year));
        },

        isoWeekYear : function (input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add("y", (input - year));
        },

        week : function (input) {
            var week = this.lang().week(this);
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        isoWeek : function (input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        weekday : function (input) {
            var weekday = (this.day() + 7 - this.lang()._week.dow) % 7;
            return input == null ? weekday : this.add("d", input - weekday);
        },

        isoWeekday : function (input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        },

        isoWeeksInYear : function () {
            return weeksInYear(this.year(), 1, 4);
        },

        weeksInYear : function () {
            var weekInfo = this._lang._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units]();
        },

        set : function (units, value) {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                this[units](value);
            }
            return this;
        },

        // If passed a language key, it will set the language for this
        // instance.  Otherwise, it will return the language configuration
        // variables for this instance.
        lang : function (key) {
            if (key === undefined) {
                return this._lang;
            } else {
                this._lang = getLangDefinition(key);
                return this;
            }
        }
    });

    function rawMonthSetter(mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.lang().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(),
            daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function rawGetter(mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function rawSetter(mom, unit, value) {
        if (unit === 'Month') {
            return rawMonthSetter(mom, value);
        } else {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function makeAccessor(unit, keepTime) {
        return function (value) {
            if (value != null) {
                rawSetter(this, unit, value);
                moment.updateOffset(this, keepTime);
                return this;
            } else {
                return rawGetter(this, unit);
            }
        };
    }

    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
    // moment.fn.month is defined separately
    moment.fn.date = makeAccessor('Date', true);
    moment.fn.dates = deprecate("dates accessor is deprecated. Use date instead.", makeAccessor('Date', true));
    moment.fn.year = makeAccessor('FullYear', true);
    moment.fn.years = deprecate("years accessor is deprecated. Use year instead.", makeAccessor('FullYear', true));

    // add plural methods
    moment.fn.days = moment.fn.day;
    moment.fn.months = moment.fn.month;
    moment.fn.weeks = moment.fn.week;
    moment.fn.isoWeeks = moment.fn.isoWeek;
    moment.fn.quarters = moment.fn.quarter;

    // add aliased format methods
    moment.fn.toJSON = moment.fn.toISOString;

    /************************************
     Duration Prototype
     ************************************/


    extend(moment.duration.fn = Duration.prototype, {

        _bubble : function () {
            var milliseconds = this._milliseconds,
                days = this._days,
                months = this._months,
                data = this._data,
                seconds, minutes, hours, years;

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absRound(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absRound(seconds / 60);
            data.minutes = minutes % 60;

            hours = absRound(minutes / 60);
            data.hours = hours % 24;

            days += absRound(hours / 24);
            data.days = days % 30;

            months += absRound(days / 30);
            data.months = months % 12;

            years = absRound(months / 12);
            data.years = years;
        },

        weeks : function () {
            return absRound(this.days() / 7);
        },

        valueOf : function () {
            return this._milliseconds +
                this._days * 864e5 +
                (this._months % 12) * 2592e6 +
                toInt(this._months / 12) * 31536e6;
        },

        humanize : function (withSuffix) {
            var difference = +this,
                output = relativeTime(difference, !withSuffix, this.lang());

            if (withSuffix) {
                output = this.lang().pastFuture(difference, output);
            }

            return this.lang().postformat(output);
        },

        add : function (input, val) {
            // supports only 2.0-style add(1, 's') or add(moment)
            var dur = moment.duration(input, val);

            this._milliseconds += dur._milliseconds;
            this._days += dur._days;
            this._months += dur._months;

            this._bubble();

            return this;
        },

        subtract : function (input, val) {
            var dur = moment.duration(input, val);

            this._milliseconds -= dur._milliseconds;
            this._days -= dur._days;
            this._months -= dur._months;

            this._bubble();

            return this;
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units.toLowerCase() + 's']();
        },

        as : function (units) {
            units = normalizeUnits(units);
            return this['as' + units.charAt(0).toUpperCase() + units.slice(1) + 's']();
        },

        lang : moment.fn.lang,

        toIsoString : function () {
            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var years = Math.abs(this.years()),
                months = Math.abs(this.months()),
                days = Math.abs(this.days()),
                hours = Math.abs(this.hours()),
                minutes = Math.abs(this.minutes()),
                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);

            if (!this.asSeconds()) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (this.asSeconds() < 0 ? '-' : '') +
                'P' +
                (years ? years + 'Y' : '') +
                (months ? months + 'M' : '') +
                (days ? days + 'D' : '') +
                ((hours || minutes || seconds) ? 'T' : '') +
                (hours ? hours + 'H' : '') +
                (minutes ? minutes + 'M' : '') +
                (seconds ? seconds + 'S' : '');
        }
    });

    function makeDurationGetter(name) {
        moment.duration.fn[name] = function () {
            return this._data[name];
        };
    }

    function makeDurationAsGetter(name, factor) {
        moment.duration.fn['as' + name] = function () {
            return +this / factor;
        };
    }

    for (i in unitMillisecondFactors) {
        if (unitMillisecondFactors.hasOwnProperty(i)) {
            makeDurationAsGetter(i, unitMillisecondFactors[i]);
            makeDurationGetter(i.toLowerCase());
        }
    }

    makeDurationAsGetter('Weeks', 6048e5);
    moment.duration.fn.asMonths = function () {
        return (+this - this.years() * 31536e6) / 2592e6 + this.years() * 12;
    };


    /************************************
     Default Lang
     ************************************/


    // Set default language, other languages will inherit from English.
    moment.lang('en', {
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // http://cdnjs.cloudflare.com/ajax/libs/moment.js/2.6.0/moment-with-langs.js

// moment.js language configuration
// language : hungarian (hu)
// author : Adam Brunner : https://github.com/adambrunner

    (function (factory) {
        factory(moment);
    }(function (moment) {
        var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

        function translate(number, withoutSuffix, key, isFuture) {
            var num = number,
                suffix;

            switch (key) {
                case 's':
                    return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
                case 'm':
                    return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
                case 'mm':
                    return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
                case 'h':
                    return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
                case 'hh':
                    return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
                case 'd':
                    return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
                case 'dd':
                    return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
                case 'M':
                    return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
                case 'MM':
                    return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
                case 'y':
                    return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
                case 'yy':
                    return num + (isFuture || withoutSuffix ? ' év' : ' éve');
            }

            return '';
        }

        function week(isFuture) {
            return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
        }

        return moment.lang('hu', {
            months : "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
            monthsShort : "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),
            weekdays : "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
            weekdaysShort : "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
            weekdaysMin : "v_h_k_sze_cs_p_szo".split("_"),
            longDateFormat : {
                LT : "H:mm",
                L : "YYYY.MM.DD.",
                LL : "YYYY. MMMM D.",
                LLL : "YYYY. MMMM D., LT",
                LLLL : "YYYY. MMMM D., dddd LT"
            },
            meridiem : function (hours, minutes, isLower) {
                if (hours < 12) {
                    return isLower === true ? 'de' : 'DE';
                } else {
                    return isLower === true ? 'du' : 'DU';
                }
            },
            calendar : {
                sameDay : '[ma] LT[-kor]',
                nextDay : '[holnap] LT[-kor]',
                nextWeek : function () {
                    return week.call(this, true);
                },
                lastDay : '[tegnap] LT[-kor]',
                lastWeek : function () {
                    return week.call(this, false);
                },
                sameElse : 'L'
            },
            relativeTime : {
                future : "%s múlva",
                past : "%s",
                s : translate,
                m : translate,
                mm : translate,
                h : translate,
                hh : translate,
                d : translate,
                dd : translate,
                M : translate,
                MM : translate,
                y : translate,
                yy : translate
            },
            ordinal : '%d.',
            week : {
                dow : 1, // Monday is the first day of the week.
                doy : 7  // The week that contains Jan 1st is the first week of the year.
            }
        });
    }));


    moment.lang('en');


    /************************************
     Exposing Moment
     ************************************/

    function makeGlobal(shouldDeprecate) {
        /*global ender:false */
        if (typeof ender !== 'undefined') {
            return;
        }
        oldGlobalMoment = globalScope.moment;
        if (shouldDeprecate) {
            globalScope.moment = deprecate(
                "Accessing Moment through the global scope is " +
                "deprecated, and will be removed in an upcoming " +
                "release.",
                moment);
        } else {
            globalScope.moment = moment;
        }
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = moment;
    } else if (typeof define === "function" && define.amd) {
        define("moment", function (require, exports, module) {
            if (module.config && module.config() && module.config().noGlobal === true) {
                // release the global variable
                globalScope.moment = oldGlobalMoment;
            }

            return moment;
        });
        makeGlobal(true);
    } else {
        makeGlobal();
    }
}).call(this);
APP.BasicCalculator = (function () {
    var initialized = false,
        output = '',
        $screen;

    function init() {
        $body.find('[data-basic-calculator]:not([data-initialized])').each(function () {
            $(this).attr('data-initialized', true).html(APP.Tpl.run('basic-calculator'));
        });
        initDomElements();
        if (!initialized) {
            initBindings();
            initialized = true;
        }
    }

    function initDomElements() {
        $screen = $body.find('[data-basic-calculator-result]');
        output = $screen.html();
    }

    function initBindings() {
        bindClick('[data-basic-calculator-eq]', function () {
            removeErr();
            try {
                $screen.html(eval(output));
                output = $screen.html();
                if (output.length === 0) {
                    write('0');
                }
            } catch (e) {
                $screen.addClass('basic-calculator__result--error');
                $screen.html('¯\\_(ツ)_/¯');
                output = '0';
            }
        });
        bindClick('[data-basic-calculator-delete]', function () {
            removeErr();
            $screen.html(output = '0');
        });
        bindClick('[data-basic-calculator-input]', function () {
            var char = $(this).attr('data-basic-calculator-input'),
                screenHtml = $screen.html();

            removeErr();
            if (isOperator(char)) {
                if (isOperator(output.substr(output.length - 1, 1))) {
                    output = output.substr(0, output.length - 1);
                }
                write(char);
            } else if (char === '0') {
                if (output !== '0') {
                    write(char);
                }
            } else {
                if (output === '0') {
                    output = '';
                }
                write(char);
            }


        });

        function bindClick(selector, callback) {
            $body.on('click', selector, callback);
        }
    }

    function removeErr() {
        $screen.removeClass('basic-calculator__result--error');
    }

    function isOperator(char) {
        return ('.-+*%/').indexOf(char) > -1;
    }

    function write(char) {
        $screen.html(output = output.concat(char));
    }

    return {
        init: init
    };

})();

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
// Ipad fix polyfil
(function () {
    function polyfillReplaceChildren(proto) {
        if (!proto || proto.replaceChildren) return;

        proto.replaceChildren = function () {
            // remove existing children
            while (this.firstChild) this.removeChild(this.firstChild);

            // add new children (strings become text nodes)
            for (var i = 0; i < arguments.length; i++) {
                var node = arguments[i];
                if (typeof node === 'string') {
                    var doc = this.ownerDocument || (this.nodeType === 9 ? this : document);
                    node = doc.createTextNode(node);
                }
                this.appendChild(node);
            }
        };
    }

    polyfillReplaceChildren(Element.prototype);
    polyfillReplaceChildren(Document.prototype);
    polyfillReplaceChildren(DocumentFragment.prototype);
})();
/*! choices.js v11.2.0 | © 2026 Josh Johnson | https://github.com/jshjohnson/Choices#readme */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Choices = factory());
})(this, (function () { 'use strict';

    /******************************************************************************
     Copyright (c) Microsoft Corporation.

     Permission to use, copy, modify, and/or distribute this software for any
     purpose with or without fee is hereby granted.

     THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
     REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
     AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
     INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
     LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
     OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
     PERFORMANCE OF THIS SOFTWARE.
     ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol */

    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function (d, b) {
            d.__proto__ = b;
        } || function (d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function () {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }
    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    var ActionType = {
        ADD_CHOICE: 'ADD_CHOICE',
        REMOVE_CHOICE: 'REMOVE_CHOICE',
        FILTER_CHOICES: 'FILTER_CHOICES',
        ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
        CLEAR_CHOICES: 'CLEAR_CHOICES',
        ADD_GROUP: 'ADD_GROUP',
        ADD_ITEM: 'ADD_ITEM',
        REMOVE_ITEM: 'REMOVE_ITEM',
        HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
    };

    var EventType = {
        showDropdown: 'showDropdown',
        hideDropdown: 'hideDropdown',
        change: 'change',
        choice: 'choice',
        search: 'search',
        addItem: 'addItem',
        removeItem: 'removeItem',
        highlightItem: 'highlightItem',
        highlightChoice: 'highlightChoice',
        unhighlightItem: 'unhighlightItem',
    };

    var KeyCodeMap = {
        TAB_KEY: 9,
        SHIFT_KEY: 16,
        BACK_KEY: 46,
        DELETE_KEY: 8,
        ENTER_KEY: 13,
        A_KEY: 65,
        ESC_KEY: 27,
        UP_KEY: 38,
        DOWN_KEY: 40,
        PAGE_UP_KEY: 33,
        PAGE_DOWN_KEY: 34,
    };

    var ObjectsInConfig = ['fuseOptions', 'classNames'];

    var PassedElementTypes = {
        Text: 'text',
        SelectOne: 'select-one',
        SelectMultiple: 'select-multiple',
    };

    var addChoice = function (choice) { return ({
        type: ActionType.ADD_CHOICE,
        choice: choice,
    }); };
    var removeChoice = function (choice) { return ({
        type: ActionType.REMOVE_CHOICE,
        choice: choice,
    }); };
    var filterChoices = function (results) { return ({
        type: ActionType.FILTER_CHOICES,
        results: results,
    }); };
    var activateChoices = function (active) {
        return ({
            type: ActionType.ACTIVATE_CHOICES,
            active: active,
        });
    };

    var addGroup = function (group) { return ({
        type: ActionType.ADD_GROUP,
        group: group,
    }); };

    var addItem = function (item) { return ({
        type: ActionType.ADD_ITEM,
        item: item,
    }); };
    var removeItem$1 = function (item) { return ({
        type: ActionType.REMOVE_ITEM,
        item: item,
    }); };
    var highlightItem = function (item, highlighted) { return ({
        type: ActionType.HIGHLIGHT_ITEM,
        item: item,
        highlighted: highlighted,
    }); };

    var getRandomNumber = function (min, max) { return Math.floor(Math.random() * (max - min) + min); };
    var generateChars = function (length) {
        return Array.from({ length: length }, function () { return getRandomNumber(0, 36).toString(36); }).join('');
    };
    var generateId = function (element, prefix) {
        var id = element.id || (element.name && "".concat(element.name, "-").concat(generateChars(2))) || generateChars(4);
        id = id.replace(/(:|\.|\[|\]|,)/g, '');
        id = "".concat(prefix, "-").concat(id);
        return id;
    };
    var getAdjacentEl = function (startEl, selector, direction) {
        if (direction === void 0) { direction = 1; }
        var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
        var sibling = startEl[prop];
        while (sibling) {
            if (sibling.matches(selector)) {
                return sibling;
            }
            sibling = sibling[prop];
        }
        return null;
    };
    var isScrolledIntoView = function (element, parent, direction) {
        if (direction === void 0) { direction = 1; }
        var isVisible;
        if (direction > 0) {
            // In view from bottom
            isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
        }
        else {
            // In view from top
            isVisible = element.offsetTop >= parent.scrollTop;
        }
        return isVisible;
    };
    var sanitise = function (value) {
        if (typeof value !== 'string') {
            if (value === null || value === undefined) {
                return '';
            }
            if (typeof value === 'object') {
                if ('raw' in value) {
                    return sanitise(value.raw);
                }
                if ('trusted' in value) {
                    return value.trusted;
                }
            }
            return value;
        }
        return value
            .replace(/&/g, '&amp;')
            .replace(/>/g, '&gt;')
            .replace(/</g, '&lt;')
            .replace(/'/g, '&#039;')
            .replace(/"/g, '&quot;');
    };
    var strToEl = (function () {
        var tmpEl = document.createElement('div');
        return function (str) {
            tmpEl.innerHTML = str.trim();
            var firstChild = tmpEl.children[0];
            while (tmpEl.firstChild) {
                tmpEl.removeChild(tmpEl.firstChild);
            }
            return firstChild;
        };
    })();
    var resolveStringFunction = function (fn) {
        return typeof fn === 'function' ? fn() : fn;
    };
    var unwrapStringForRaw = function (s) {
        if (typeof s === 'string') {
            return s;
        }
        if (typeof s === 'object') {
            if ('trusted' in s) {
                return s.trusted;
            }
            if ('raw' in s) {
                return s.raw;
            }
        }
        return '';
    };
    var unwrapStringForEscaped = function (s) {
        if (typeof s === 'string') {
            return s;
        }
        if (typeof s === 'object') {
            if ('escaped' in s) {
                return s.escaped;
            }
            if ('trusted' in s) {
                return s.trusted;
            }
        }
        return '';
    };
    var getChoiceForOutput = function (choice, keyCode) {
        return {
            id: choice.id,
            highlighted: choice.highlighted,
            labelClass: choice.labelClass,
            labelDescription: unwrapStringForRaw(choice.labelDescription),
            customProperties: choice.customProperties,
            disabled: choice.disabled,
            active: choice.active,
            label: choice.label,
            placeholder: choice.placeholder,
            value: choice.value,
            groupValue: choice.group ? choice.group.label : undefined,
            element: choice.element,
            keyCode: keyCode,
        };
    };
    var resolveNoticeFunction = function (fn, value, item) {
        return typeof fn === 'function' ? fn(sanitise(value), unwrapStringForRaw(value), item) : fn;
    };
    var escapeForTemplate = function (allowHTML, s) {
        return allowHTML ? unwrapStringForEscaped(s) : sanitise(s);
    };
    var setElementHtml = function (el, allowHtml, html) {
        el.innerHTML = escapeForTemplate(allowHtml, html);
    };
    var sortByAlpha = function (_a, _b) {
        var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
        var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
        return unwrapStringForRaw(label).localeCompare(unwrapStringForRaw(label2), [], {
            sensitivity: 'base',
            ignorePunctuation: true,
            numeric: true,
        });
    };
    var sortByRank = function (a, b) {
        return a.rank - b.rank;
    };
    var dispatchEvent = function (element, type, customArgs) {
        if (customArgs === void 0) { customArgs = null; }
        var event = new CustomEvent(type, {
            detail: customArgs,
            bubbles: true,
            cancelable: true,
        });
        return element.dispatchEvent(event);
    };
    /**
     * Returns an array of keys present on the first but missing on the second object
     */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var diff = function (a, b) {
            var aKeys = Object.keys(a).sort();
            var bKeys = Object.keys(b).sort();
            return aKeys.filter(function (i) { return bKeys.indexOf(i) < 0; });
        };
    var getClassNames = function (ClassNames) {
        return Array.isArray(ClassNames) ? ClassNames : [ClassNames];
    };
    var getClassNamesSelector = function (option) {
        if (option && Array.isArray(option)) {
            return option
                .map(function (item) {
                    return ".".concat(item);
                })
                .join('');
        }
        return ".".concat(option);
    };
    var addClassesToElement = function (element, className) {
        var _a;
        (_a = element.classList).add.apply(_a, getClassNames(className));
    };
    var removeClassesFromElement = function (element, className) {
        var _a;
        (_a = element.classList).remove.apply(_a, getClassNames(className));
    };
    var parseCustomProperties = function (customProperties) {
        if (typeof customProperties !== 'undefined') {
            try {
                return JSON.parse(customProperties);
            }
            catch (e) {
                return customProperties;
            }
        }
        return {};
    };
    var updateClassList = function (item, add, remove) {
        var itemEl = item.itemEl;
        if (itemEl) {
            removeClassesFromElement(itemEl, remove);
            addClassesToElement(itemEl, add);
        }
    };

    var Dropdown = /** @class */ (function () {
        function Dropdown(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames;
            this.element = element;
            this.classNames = classNames;
            this.type = type;
            this.isActive = false;
        }
        /**
         * Show dropdown to user by adding active state class
         */
        Dropdown.prototype.show = function () {
            addClassesToElement(this.element, this.classNames.activeState);
            this.element.setAttribute('aria-expanded', 'true');
            this.isActive = true;
            return this;
        };
        /**
         * Hide dropdown from user
         */
        Dropdown.prototype.hide = function () {
            removeClassesFromElement(this.element, this.classNames.activeState);
            this.element.setAttribute('aria-expanded', 'false');
            this.isActive = false;
            return this;
        };
        return Dropdown;
    }());

    var Container = /** @class */ (function () {
        function Container(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
            this.element = element;
            this.classNames = classNames;
            this.type = type;
            this.position = position;
            this.isOpen = false;
            this.isFlipped = false;
            this.isDisabled = false;
            this.isLoading = false;
        }
        /**
         * Determine whether container should be flipped based on passed
         * dropdown position
         */
        Container.prototype.shouldFlip = function (dropdownPos, dropdownHeight) {
            // If flip is enabled and the dropdown bottom position is
            // greater than the window height flip the dropdown.
            var shouldFlip = false;
            if (this.position === 'auto') {
                shouldFlip =
                    this.element.getBoundingClientRect().top - dropdownHeight >= 0 &&
                    !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
            }
            else if (this.position === 'top') {
                shouldFlip = true;
            }
            return shouldFlip;
        };
        Container.prototype.setActiveDescendant = function (activeDescendantID) {
            this.element.setAttribute('aria-activedescendant', activeDescendantID);
        };
        Container.prototype.removeActiveDescendant = function () {
            this.element.removeAttribute('aria-activedescendant');
        };
        Container.prototype.open = function (dropdownPos, dropdownHeight) {
            addClassesToElement(this.element, this.classNames.openState);
            this.element.setAttribute('aria-expanded', 'true');
            this.isOpen = true;
            if (this.shouldFlip(dropdownPos, dropdownHeight)) {
                addClassesToElement(this.element, this.classNames.flippedState);
                this.isFlipped = true;
            }
        };
        Container.prototype.close = function () {
            removeClassesFromElement(this.element, this.classNames.openState);
            this.element.setAttribute('aria-expanded', 'false');
            this.removeActiveDescendant();
            this.isOpen = false;
            // A dropdown flips if it does not have space within the page
            if (this.isFlipped) {
                removeClassesFromElement(this.element, this.classNames.flippedState);
                this.isFlipped = false;
            }
        };
        Container.prototype.addFocusState = function () {
            addClassesToElement(this.element, this.classNames.focusState);
        };
        Container.prototype.removeFocusState = function () {
            removeClassesFromElement(this.element, this.classNames.focusState);
        };
        Container.prototype.addInvalidState = function () {
            addClassesToElement(this.element, this.classNames.invalidState);
        };
        Container.prototype.removeInvalidState = function () {
            removeClassesFromElement(this.element, this.classNames.invalidState);
        };
        Container.prototype.enable = function () {
            removeClassesFromElement(this.element, this.classNames.disabledState);
            this.element.removeAttribute('aria-disabled');
            if (this.type === PassedElementTypes.SelectOne) {
                this.element.setAttribute('tabindex', '0');
            }
            this.isDisabled = false;
        };
        Container.prototype.disable = function () {
            addClassesToElement(this.element, this.classNames.disabledState);
            this.element.setAttribute('aria-disabled', 'true');
            if (this.type === PassedElementTypes.SelectOne) {
                this.element.setAttribute('tabindex', '-1');
            }
            this.isDisabled = true;
        };
        Container.prototype.wrap = function (element) {
            var el = this.element;
            var parentNode = element.parentNode;
            if (parentNode) {
                if (element.nextSibling) {
                    parentNode.insertBefore(el, element.nextSibling);
                }
                else {
                    parentNode.appendChild(el);
                }
            }
            el.appendChild(element);
        };
        Container.prototype.unwrap = function (element) {
            var el = this.element;
            var parentNode = el.parentNode;
            if (parentNode) {
                // Move passed element outside this element
                parentNode.insertBefore(element, el);
                // Remove this element
                parentNode.removeChild(el);
            }
        };
        Container.prototype.addLoadingState = function () {
            addClassesToElement(this.element, this.classNames.loadingState);
            this.element.setAttribute('aria-busy', 'true');
            this.isLoading = true;
        };
        Container.prototype.removeLoadingState = function () {
            removeClassesFromElement(this.element, this.classNames.loadingState);
            this.element.removeAttribute('aria-busy');
            this.isLoading = false;
        };
        return Container;
    }());

    var Input = /** @class */ (function () {
        function Input(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
            this.element = element;
            this.type = type;
            this.classNames = classNames;
            this.preventPaste = preventPaste;
            this.isFocussed = this.element.isEqualNode(document.activeElement);
            this.isDisabled = element.disabled;
            this._onPaste = this._onPaste.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onBlur = this._onBlur.bind(this);
        }
        Object.defineProperty(Input.prototype, "placeholder", {
            set: function (placeholder) {
                this.element.placeholder = placeholder;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "value", {
            get: function () {
                return this.element.value;
            },
            set: function (value) {
                this.element.value = value;
            },
            enumerable: false,
            configurable: true
        });
        Input.prototype.addEventListeners = function () {
            var el = this.element;
            el.addEventListener('paste', this._onPaste);
            el.addEventListener('input', this._onInput, {
                passive: true,
            });
            el.addEventListener('focus', this._onFocus, {
                passive: true,
            });
            el.addEventListener('blur', this._onBlur, {
                passive: true,
            });
        };
        Input.prototype.removeEventListeners = function () {
            var el = this.element;
            el.removeEventListener('input', this._onInput);
            el.removeEventListener('paste', this._onPaste);
            el.removeEventListener('focus', this._onFocus);
            el.removeEventListener('blur', this._onBlur);
        };
        Input.prototype.enable = function () {
            var el = this.element;
            el.removeAttribute('disabled');
            this.isDisabled = false;
        };
        Input.prototype.disable = function () {
            var el = this.element;
            el.setAttribute('disabled', '');
            this.isDisabled = true;
        };
        Input.prototype.focus = function () {
            if (!this.isFocussed) {
                this.element.focus();
            }
        };
        Input.prototype.blur = function () {
            if (this.isFocussed) {
                this.element.blur();
            }
        };
        Input.prototype.clear = function (setWidth) {
            if (setWidth === void 0) { setWidth = true; }
            this.element.value = '';
            if (setWidth) {
                this.setWidth();
            }
            return this;
        };
        /**
         * Set the correct input width based on placeholder
         * value or input value
         */
        Input.prototype.setWidth = function () {
            // Resize input to contents or placeholder
            var element = this.element;
            element.style.minWidth = "".concat(element.placeholder.length + 1, "ch");
            element.style.width = "".concat(element.value.length + 1, "ch");
        };
        Input.prototype.setActiveDescendant = function (activeDescendantID) {
            this.element.setAttribute('aria-activedescendant', activeDescendantID);
        };
        Input.prototype.removeActiveDescendant = function () {
            this.element.removeAttribute('aria-activedescendant');
        };
        Input.prototype._onInput = function () {
            if (this.type !== PassedElementTypes.SelectOne) {
                this.setWidth();
            }
        };
        Input.prototype._onPaste = function (event) {
            if (this.preventPaste) {
                event.preventDefault();
            }
        };
        Input.prototype._onFocus = function () {
            this.isFocussed = true;
        };
        Input.prototype._onBlur = function () {
            this.isFocussed = false;
        };
        return Input;
    }());

    var SCROLLING_SPEED = 4;

    var List = /** @class */ (function () {
        function List(_a) {
            var element = _a.element;
            this.element = element;
            this.scrollPos = this.element.scrollTop;
            this.height = this.element.offsetHeight;
        }
        List.prototype.prepend = function (node) {
            var child = this.element.firstElementChild;
            if (child) {
                this.element.insertBefore(node, child);
            }
            else {
                this.element.append(node);
            }
        };
        List.prototype.scrollToTop = function () {
            this.element.scrollTop = 0;
        };
        List.prototype.scrollToChildElement = function (element, direction) {
            var _this = this;
            if (!element) {
                return;
            }
            var listHeight = this.element.offsetHeight;
            // Scroll position of dropdown
            var listScrollPosition = this.element.scrollTop + listHeight;
            var elementHeight = element.offsetHeight;
            // Distance from bottom of element to top of parent
            var elementPos = element.offsetTop + elementHeight;
            // Difference between the element and scroll position
            var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
            requestAnimationFrame(function () {
                _this._animateScroll(destination, direction);
            });
        };
        List.prototype._scrollDown = function (scrollPos, strength, destination) {
            var easing = (destination - scrollPos) / strength;
            var distance = easing > 1 ? easing : 1;
            this.element.scrollTop = scrollPos + distance;
        };
        List.prototype._scrollUp = function (scrollPos, strength, destination) {
            var easing = (scrollPos - destination) / strength;
            var distance = easing > 1 ? easing : 1;
            this.element.scrollTop = scrollPos - distance;
        };
        List.prototype._animateScroll = function (destination, direction) {
            var _this = this;
            var strength = SCROLLING_SPEED;
            var choiceListScrollTop = this.element.scrollTop;
            var continueAnimation = false;
            if (direction > 0) {
                this._scrollDown(choiceListScrollTop, strength, destination);
                if (choiceListScrollTop < destination) {
                    continueAnimation = true;
                }
            }
            else {
                this._scrollUp(choiceListScrollTop, strength, destination);
                if (choiceListScrollTop > destination) {
                    continueAnimation = true;
                }
            }
            if (continueAnimation) {
                requestAnimationFrame(function () {
                    _this._animateScroll(destination, direction);
                });
            }
        };
        return List;
    }());

    var WrappedElement = /** @class */ (function () {
        function WrappedElement(_a) {
            var element = _a.element, classNames = _a.classNames;
            this.element = element;
            this.classNames = classNames;
            this.isDisabled = false;
        }
        Object.defineProperty(WrappedElement.prototype, "isActive", {
            get: function () {
                return this.element.dataset.choice === 'active';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WrappedElement.prototype, "dir", {
            get: function () {
                return this.element.dir;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WrappedElement.prototype, "value", {
            get: function () {
                return this.element.value;
            },
            set: function (value) {
                this.element.setAttribute('value', value);
                this.element.value = value;
            },
            enumerable: false,
            configurable: true
        });
        WrappedElement.prototype.conceal = function () {
            var el = this.element;
            // Hide passed input
            addClassesToElement(el, this.classNames.input);
            el.hidden = true;
            // Remove element from tab index
            el.tabIndex = -1;
            // Backup original styles if any
            var origStyle = el.getAttribute('style');
            if (origStyle) {
                el.setAttribute('data-choice-orig-style', origStyle);
            }
            el.setAttribute('data-choice', 'active');
        };
        WrappedElement.prototype.reveal = function () {
            var el = this.element;
            // Reinstate passed element
            removeClassesFromElement(el, this.classNames.input);
            el.hidden = false;
            el.removeAttribute('tabindex');
            // Recover original styles if any
            var origStyle = el.getAttribute('data-choice-orig-style');
            if (origStyle) {
                el.removeAttribute('data-choice-orig-style');
                el.setAttribute('style', origStyle);
            }
            else {
                el.removeAttribute('style');
            }
            el.removeAttribute('data-choice');
        };
        WrappedElement.prototype.enable = function () {
            this.element.removeAttribute('disabled');
            this.element.disabled = false;
            this.isDisabled = false;
        };
        WrappedElement.prototype.disable = function () {
            this.element.setAttribute('disabled', '');
            this.element.disabled = true;
            this.isDisabled = true;
        };
        WrappedElement.prototype.triggerEvent = function (eventType, data) {
            dispatchEvent(this.element, eventType, data || {});
        };
        return WrappedElement;
    }());

    var WrappedInput = /** @class */ (function (_super) {
        __extends(WrappedInput, _super);
        function WrappedInput() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return WrappedInput;
    }(WrappedElement));

    var coerceBool = function (arg, defaultValue) {
        if (defaultValue === void 0) { defaultValue = true; }
        return typeof arg === 'undefined' ? defaultValue : !!arg;
    };
    var stringToHtmlClass = function (input) {
        if (typeof input === 'string') {
            // eslint-disable-next-line no-param-reassign
            input = input.split(' ').filter(function (s) { return s.length; });
        }
        if (Array.isArray(input) && input.length) {
            return input;
        }
        return undefined;
    };
    var mapInputToChoice = function (value, allowGroup, allowRawString) {
        if (allowRawString === void 0) { allowRawString = true; }
        if (typeof value === 'string') {
            var sanitisedValue = sanitise(value);
            var userValue = allowRawString || sanitisedValue === value ? value : { escaped: sanitisedValue, raw: value };
            var result_1 = mapInputToChoice({
                value: value,
                label: userValue,
                selected: true,
            }, false);
            return result_1;
        }
        var groupOrChoice = value;
        if ('choices' in groupOrChoice) {
            if (!allowGroup) {
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup
                throw new TypeError("optGroup is not allowed");
            }
            var group = groupOrChoice;
            var choices = group.choices.map(function (e) { return mapInputToChoice(e, false); });
            var result_2 = {
                id: 0, // actual ID will be assigned during _addGroup
                label: unwrapStringForRaw(group.label) || group.value,
                active: !!choices.length,
                disabled: !!group.disabled,
                choices: choices,
            };
            return result_2;
        }
        var choice = groupOrChoice;
        var result = {
            id: 0, // actual ID will be assigned during _addChoice
            group: null, // actual group will be assigned during _addGroup but before _addChoice
            score: 0, // used in search
            rank: 0, // used in search, stable sort order
            value: choice.value,
            label: choice.label || choice.value,
            active: coerceBool(choice.active),
            selected: coerceBool(choice.selected, false),
            disabled: coerceBool(choice.disabled, false),
            placeholder: coerceBool(choice.placeholder, false),
            highlighted: false,
            labelClass: stringToHtmlClass(choice.labelClass),
            labelDescription: choice.labelDescription,
            customProperties: choice.customProperties,
        };
        return result;
    };

    var isHtmlInputElement = function (e) { return e.tagName === 'INPUT'; };
    var isHtmlSelectElement = function (e) { return e.tagName === 'SELECT'; };
    var isHtmlOption = function (e) { return e.tagName === 'OPTION'; };
    var isHtmlOptgroup = function (e) { return e.tagName === 'OPTGROUP'; };

    var WrappedSelect = /** @class */ (function (_super) {
        __extends(WrappedSelect, _super);
        function WrappedSelect(_a) {
            var element = _a.element, classNames = _a.classNames, template = _a.template, extractPlaceholder = _a.extractPlaceholder;
            var _this = _super.call(this, { element: element, classNames: classNames }) || this;
            _this.template = template;
            _this.extractPlaceholder = extractPlaceholder;
            return _this;
        }
        Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
            get: function () {
                return (this.element.querySelector('option[value=""]') ||
                    // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                    this.element.querySelector('option[placeholder]'));
            },
            enumerable: false,
            configurable: true
        });
        WrappedSelect.prototype.addOptions = function (choices) {
            var _this = this;
            var fragment = document.createDocumentFragment();
            choices.forEach(function (obj) {
                var choice = obj;
                if (choice.element) {
                    return;
                }
                var option = _this.template(choice);
                fragment.appendChild(option);
                choice.element = option;
            });
            this.element.appendChild(fragment);
        };
        WrappedSelect.prototype.optionsAsChoices = function () {
            var _this = this;
            var choices = [];
            this.element.querySelectorAll(':scope > option, :scope > optgroup').forEach(function (e) {
                if (isHtmlOption(e)) {
                    choices.push(_this._optionToChoice(e));
                }
                else if (isHtmlOptgroup(e)) {
                    choices.push(_this._optgroupToChoice(e));
                }
                // todo: hr as empty optgroup, requires displaying empty opt-groups to be useful
            });
            return choices;
        };
        // eslint-disable-next-line class-methods-use-this
        WrappedSelect.prototype._optionToChoice = function (option) {
            // option.value returns the label if there is no value attribute, which can break legacy placeholder attribute support
            if (!option.hasAttribute('value') && option.hasAttribute('placeholder')) {
                option.setAttribute('value', '');
                option.value = '';
            }
            return {
                id: 0,
                group: null,
                score: 0,
                rank: 0,
                value: option.value,
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option
                // This attribute is text for the label indicating the meaning of the option. If the `label` attribute isn't defined, its value is that of the element text content (ie `innerText`).
                label: option.label,
                element: option,
                active: true,
                // this returns true if nothing is selected on initial load, which will break placeholder support
                selected: this.extractPlaceholder ? option.selected : option.hasAttribute('selected'),
                disabled: option.disabled,
                highlighted: false,
                placeholder: this.extractPlaceholder && (!option.value || option.hasAttribute('placeholder')),
                labelClass: typeof option.dataset.labelClass !== 'undefined' ? stringToHtmlClass(option.dataset.labelClass) : undefined,
                labelDescription: typeof option.dataset.labelDescription !== 'undefined'
                    ? { trusted: option.dataset.labelDescription }
                    : undefined,
                customProperties: parseCustomProperties(option.dataset.customProperties),
            };
        };
        WrappedSelect.prototype._optgroupToChoice = function (optgroup) {
            var _this = this;
            var options = optgroup.querySelectorAll('option');
            var choices = Array.from(options).map(function (option) { return _this._optionToChoice(option); });
            return {
                id: 0,
                label: optgroup.label || '',
                element: optgroup,
                active: !!choices.length,
                disabled: optgroup.disabled,
                choices: choices,
            };
        };
        return WrappedSelect;
    }(WrappedElement));

    var DEFAULT_CLASSNAMES = {
        containerOuter: ['choices'],
        containerInner: ['choices__inner'],
        input: ['choices__input'],
        inputCloned: ['choices__input--cloned'],
        list: ['choices__list'],
        listItems: ['choices__list--multiple'],
        listSingle: ['choices__list--single'],
        listDropdown: ['choices__list--dropdown'],
        item: ['choices__item'],
        itemSelectable: ['choices__item--selectable'],
        itemDisabled: ['choices__item--disabled'],
        itemChoice: ['choices__item--choice'],
        description: ['choices__description'],
        placeholder: ['choices__placeholder'],
        group: ['choices__group'],
        groupHeading: ['choices__heading'],
        button: ['choices__button'],
        activeState: ['is-active'],
        focusState: ['is-focused'],
        openState: ['is-open'],
        disabledState: ['is-disabled'],
        highlightedState: ['is-highlighted'],
        selectedState: ['is-selected'],
        flippedState: ['is-flipped'],
        loadingState: ['is-loading'],
        invalidState: ['is-invalid'],
        notice: ['choices__notice'],
        addChoice: ['choices__item--selectable', 'add-choice'],
        noResults: ['has-no-results'],
        noChoices: ['has-no-choices'],
    };
    var DEFAULT_CONFIG = {
        items: [],
        choices: [],
        silent: false,
        renderChoiceLimit: -1,
        maxItemCount: -1,
        closeDropdownOnSelect: 'auto',
        singleModeForMultiSelect: false,
        addChoices: false,
        addItems: true,
        addItemFilter: function (value) { return !!value && value !== ''; },
        removeItems: true,
        removeItemButton: false,
        removeItemButtonAlignLeft: false,
        editItems: false,
        allowHTML: false,
        allowHtmlUserInput: false,
        duplicateItemsAllowed: true,
        delimiter: ',',
        paste: true,
        searchEnabled: true,
        searchChoices: true,
        searchDisabledChoices: false,
        searchFloor: 1,
        searchResultLimit: 4,
        searchFields: ['label', 'value'],
        position: 'auto',
        resetScrollPosition: true,
        shouldSort: true,
        shouldSortItems: false,
        sorter: sortByAlpha,
        shadowRoot: null,
        placeholder: true,
        placeholderValue: null,
        searchPlaceholderValue: null,
        prependValue: null,
        appendValue: null,
        renderSelectedChoices: 'auto',
        searchRenderSelectedChoices: true,
        loadingText: 'Loading...',
        noResultsText: 'No results found',
        noChoicesText: 'No choices to choose from',
        itemSelectText: 'Press to select',
        uniqueItemText: 'Only unique values can be added',
        customAddItemText: 'Only values matching specific conditions can be added',
        addItemText: function (value) { return "Press Enter to add <b>\"".concat(value, "\"</b>"); },
        removeItemIconText: function () { return "Remove item"; },
        removeItemLabelText: function (value, _valueRaw, i) {
            return "Remove item: ".concat(i ? sanitise(i.label) : value);
        },
        maxItemText: function (maxItemCount) { return "Only ".concat(maxItemCount, " values can be added"); },
        valueComparer: function (value1, value2) { return value1 === value2; },
        fuseOptions: {
            includeScore: true,
        },
        labelId: '',
        callbackOnInit: null,
        callbackOnCreateTemplates: null,
        classNames: DEFAULT_CLASSNAMES,
        appendGroupInSearch: false,
    };

    var removeItem = function (item) {
        var itemEl = item.itemEl;
        if (itemEl) {
            itemEl.remove();
            item.itemEl = undefined;
        }
    };
    function items(s, action, context) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_ITEM: {
                action.item.selected = true;
                var el = action.item.element;
                if (el) {
                    el.selected = true;
                    el.setAttribute('selected', '');
                }
                state.push(action.item);
                break;
            }
            case ActionType.REMOVE_ITEM: {
                action.item.selected = false;
                var el = action.item.element;
                if (el) {
                    el.selected = false;
                    el.removeAttribute('selected');
                    // For a select-one, if all options are deselected, the first item is selected. To set a black value, select.value needs to be set
                    var select = el.parentElement;
                    if (select && isHtmlSelectElement(select) && select.type === PassedElementTypes.SelectOne) {
                        select.value = '';
                    }
                }
                // this is mixing concerns, but this is *so much faster*
                removeItem(action.item);
                state = state.filter(function (choice) { return choice.id !== action.item.id; });
                break;
            }
            case ActionType.REMOVE_CHOICE: {
                removeItem(action.choice);
                state = state.filter(function (item) { return item.id !== action.choice.id; });
                break;
            }
            case ActionType.HIGHLIGHT_ITEM: {
                var highlighted = action.highlighted;
                var item = state.find(function (obj) { return obj.id === action.item.id; });
                if (item && item.highlighted !== highlighted) {
                    item.highlighted = highlighted;
                    if (context) {
                        updateClassList(item, highlighted ? context.classNames.highlightedState : context.classNames.selectedState, highlighted ? context.classNames.selectedState : context.classNames.highlightedState);
                    }
                }
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    function groups(s, action) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_GROUP: {
                state.push(action.group);
                break;
            }
            case ActionType.CLEAR_CHOICES: {
                state = [];
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    /* eslint-disable */
    function choices(s, action, context) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_CHOICE: {
                state.push(action.choice);
                break;
            }
            case ActionType.REMOVE_CHOICE: {
                action.choice.choiceEl = undefined;
                if (action.choice.group) {
                    action.choice.group.choices = action.choice.group.choices.filter(function (obj) { return obj.id !== action.choice.id; });
                }
                state = state.filter(function (obj) { return obj.id !== action.choice.id; });
                break;
            }
            case ActionType.ADD_ITEM:
            case ActionType.REMOVE_ITEM: {
                action.item.choiceEl = undefined;
                break;
            }
            case ActionType.FILTER_CHOICES: {
                // avoid O(n^2) algorithm complexity when searching/filtering choices
                var scoreLookup_1 = [];
                action.results.forEach(function (result) {
                    scoreLookup_1[result.item.id] = result;
                });
                state.forEach(function (choice) {
                    var result = scoreLookup_1[choice.id];
                    if (result !== undefined) {
                        choice.score = result.score;
                        choice.rank = result.rank;
                        choice.active = true;
                    }
                    else {
                        choice.score = 0;
                        choice.rank = 0;
                        choice.active = false;
                    }
                    if (context && context.appendGroupInSearch) {
                        choice.choiceEl = undefined;
                    }
                });
                break;
            }
            case ActionType.ACTIVATE_CHOICES: {
                state.forEach(function (choice) {
                    choice.active = action.active;
                    if (context && context.appendGroupInSearch) {
                        choice.choiceEl = undefined;
                    }
                });
                break;
            }
            case ActionType.CLEAR_CHOICES: {
                state = [];
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    var reducers = {
        groups: groups,
        items: items,
        choices: choices,
    };
    var Store = /** @class */ (function () {
        function Store(context) {
            this._state = this.defaultState;
            this._listeners = [];
            this._txn = 0;
            this._context = context;
        }
        Object.defineProperty(Store.prototype, "defaultState", {
            // eslint-disable-next-line class-methods-use-this
            get: function () {
                return {
                    groups: [],
                    items: [],
                    choices: [],
                };
            },
            enumerable: false,
            configurable: true
        });
        // eslint-disable-next-line class-methods-use-this
        Store.prototype.changeSet = function (init) {
            return {
                groups: init,
                items: init,
                choices: init,
            };
        };
        Store.prototype.reset = function () {
            this._state = this.defaultState;
            var changes = this.changeSet(true);
            if (this._txn) {
                this._changeSet = changes;
            }
            else {
                this._listeners.forEach(function (l) { return l(changes); });
            }
        };
        Store.prototype.subscribe = function (onChange) {
            this._listeners.push(onChange);
            return this;
        };
        Store.prototype.dispatch = function (action) {
            var _this = this;
            var state = this._state;
            var hasChanges = false;
            var changes = this._changeSet || this.changeSet(false);
            Object.keys(reducers).forEach(function (key) {
                var stateUpdate = reducers[key](state[key], action, _this._context);
                if (stateUpdate.update) {
                    hasChanges = true;
                    changes[key] = true;
                    state[key] = stateUpdate.state;
                }
            });
            if (hasChanges) {
                if (this._txn) {
                    this._changeSet = changes;
                }
                else {
                    this._listeners.forEach(function (l) { return l(changes); });
                }
            }
        };
        Store.prototype.withTxn = function (func) {
            this._txn++;
            try {
                func();
            }
            finally {
                this._txn = Math.max(0, this._txn - 1);
                if (!this._txn) {
                    var changeSet_1 = this._changeSet;
                    if (changeSet_1) {
                        this._changeSet = undefined;
                        this._listeners.forEach(function (l) { return l(changeSet_1); });
                    }
                }
            }
        };
        Object.defineProperty(Store.prototype, "state", {
            /**
             * Get store object
             */
            get: function () {
                return this._state;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "items", {
            /**
             * Get items from store
             */
            get: function () {
                return this.state.items;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "highlightedActiveItems", {
            /**
             * Get highlighted items from store
             */
            get: function () {
                return this.items.filter(function (item) { return item.active && item.highlighted; });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "choices", {
            /**
             * Get choices from store
             */
            get: function () {
                return this.state.choices;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "activeChoices", {
            /**
             * Get active choices from store
             */
            get: function () {
                return this.choices.filter(function (choice) { return choice.active; });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "searchableChoices", {
            /**
             * Get choices that can be searched (excluding placeholders or disabled choices)
             */
            get: function () {
                var context = this._context;
                return this.choices.filter(function (choice) { return !choice.placeholder && (context.searchDisabledChoices || !choice.disabled); });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "groups", {
            /**
             * Get groups from store
             */
            get: function () {
                return this.state.groups;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "activeGroups", {
            /**
             * Get active groups from store
             */
            get: function () {
                var _this = this;
                return this.state.groups.filter(function (group) {
                    var isActive = group.active && !group.disabled;
                    var hasActiveOptions = _this.state.choices.some(function (choice) { return choice.active && !choice.disabled; });
                    return isActive && hasActiveOptions;
                }, []);
            },
            enumerable: false,
            configurable: true
        });
        Store.prototype.inTxn = function () {
            return this._txn > 0;
        };
        /**
         * Get single choice by it's ID
         */
        Store.prototype.getChoiceById = function (id) {
            return this.activeChoices.find(function (choice) { return choice.id === id; });
        };
        /**
         * Get group by group id
         */
        Store.prototype.getGroupById = function (id) {
            return this.groups.find(function (group) { return group.id === id; });
        };
        return Store;
    }());

    var NoticeTypes = {
        noChoices: 'no-choices',
        noResults: 'no-results',
        addChoice: 'add-choice',
        generic: '',
    };

    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[r] = t, e;
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }

    /**
     * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
     *
     * Copyright (c) 2023 Kiro Risk (http://kiro.me)
     * All Rights Reserved. Apache Software License 2.0
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     */

    function isArray(value) {
        return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
    }
    function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
            return value;
        }
        let result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    function toString(value) {
        return value == null ? '' : baseToString(value);
    }
    function isString(value) {
        return typeof value === 'string';
    }
    function isNumber(value) {
        return typeof value === 'number';
    }

    // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
    function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
    }
    function isObject(value) {
        return typeof value === 'object';
    }

    // Checks if `value` is object-like.
    function isObjectLike(value) {
        return isObject(value) && value !== null;
    }
    function isDefined(value) {
        return value !== undefined && value !== null;
    }
    function isBlank(value) {
        return !value.trim().length;
    }

    // Gets the `toStringTag` of `value`.
    // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
    function getTag(value) {
        return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
    }
    const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
    const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = key => `Invalid value for key ${key}`;
    const PATTERN_LENGTH_TOO_LARGE = max => `Pattern length exceeds max of ${max}.`;
    const MISSING_KEY_PROPERTY = name => `Missing ${name} property in key`;
    const INVALID_KEY_WEIGHT_VALUE = key => `Property 'weight' in key '${key}' must be a positive integer`;
    const hasOwn = Object.prototype.hasOwnProperty;
    class KeyStore {
        constructor(keys) {
            this._keys = [];
            this._keyMap = {};
            let totalWeight = 0;
            keys.forEach(key => {
                let obj = createKey(key);
                this._keys.push(obj);
                this._keyMap[obj.id] = obj;
                totalWeight += obj.weight;
            });

            // Normalize weights so that their sum is equal to 1
            this._keys.forEach(key => {
                key.weight /= totalWeight;
            });
        }
        get(keyId) {
            return this._keyMap[keyId];
        }
        keys() {
            return this._keys;
        }
        toJSON() {
            return JSON.stringify(this._keys);
        }
    }
    function createKey(key) {
        let path = null;
        let id = null;
        let src = null;
        let weight = 1;
        let getFn = null;
        if (isString(key) || isArray(key)) {
            src = key;
            path = createKeyPath(key);
            id = createKeyId(key);
        } else {
            if (!hasOwn.call(key, 'name')) {
                throw new Error(MISSING_KEY_PROPERTY('name'));
            }
            const name = key.name;
            src = name;
            if (hasOwn.call(key, 'weight')) {
                weight = key.weight;
                if (weight <= 0) {
                    throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                }
            }
            path = createKeyPath(name);
            id = createKeyId(name);
            getFn = key.getFn;
        }
        return {
            path,
            id,
            weight,
            src,
            getFn
        };
    }
    function createKeyPath(key) {
        return isArray(key) ? key : key.split('.');
    }
    function createKeyId(key) {
        return isArray(key) ? key.join('.') : key;
    }
    function get(obj, path) {
        let list = [];
        let arr = false;
        const deepGet = (obj, path, index) => {
            if (!isDefined(obj)) {
                return;
            }
            if (!path[index]) {
                // If there's no path left, we've arrived at the object we care about.
                list.push(obj);
            } else {
                let key = path[index];
                const value = obj[key];
                if (!isDefined(value)) {
                    return;
                }

                // If we're at the last value in the path, and if it's a string/number/bool,
                // add it to the list
                if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
                    list.push(toString(value));
                } else if (isArray(value)) {
                    arr = true;
                    // Search each item in the array.
                    for (let i = 0, len = value.length; i < len; i += 1) {
                        deepGet(value[i], path, index + 1);
                    }
                } else if (path.length) {
                    // An object. Recurse further.
                    deepGet(value, path, index + 1);
                }
            }
        };

        // Backwards compatibility (since path used to be a string)
        deepGet(obj, isString(path) ? path.split('.') : path, 0);
        return arr ? list : list[0];
    }
    const MatchOptions = {
        // Whether the matches should be included in the result set. When `true`, each record in the result
        // set will include the indices of the matched characters.
        // These can consequently be used for highlighting purposes.
        includeMatches: false,
        // When `true`, the matching function will continue to the end of a search pattern even if
        // a perfect match has already been located in the string.
        findAllMatches: false,
        // Minimum number of characters that must be matched before a result is considered a match
        minMatchCharLength: 1
    };
    const BasicOptions = {
        // When `true`, the algorithm continues searching to the end of the input even if a perfect
        // match is found before the end of the same input.
        isCaseSensitive: false,
        // When true, the matching function will continue to the end of a search pattern even if
        includeScore: false,
        // List of properties that will be searched. This also supports nested properties.
        keys: [],
        // Whether to sort the result list, by score
        shouldSort: true,
        // Default sort function: sort by ascending score, ascending index
        sortFn: (a, b) => a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
    };
    const FuzzyOptions = {
        // Approximately where in the text is the pattern expected to be found?
        location: 0,
        // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
        // (of both letters and location), a threshold of '1.0' would match anything.
        threshold: 0.6,
        // Determines how close the match must be to the fuzzy location (specified above).
        // An exact letter match which is 'distance' characters away from the fuzzy location
        // would score as a complete mismatch. A distance of '0' requires the match be at
        // the exact location specified, a threshold of '1000' would require a perfect match
        // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
        distance: 100
    };
    const AdvancedOptions = {
        // When `true`, it enables the use of unix-like search commands
        useExtendedSearch: false,
        // The get function to use when fetching an object's properties.
        // The default will search nested paths *ie foo.bar.baz*
        getFn: get,
        // When `true`, search will ignore `location` and `distance`, so it won't matter
        // where in the string the pattern appears.
        // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
        ignoreLocation: false,
        // When `true`, the calculation for the relevance score (used for sorting) will
        // ignore the field-length norm.
        // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
        ignoreFieldNorm: false,
        // The weight to determine how much field length norm effects scoring.
        fieldNormWeight: 1
    };
    var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);
    const SPACE = /[^ ]+/g;

    // Field-length norm: the shorter the field, the higher the weight.
    // Set to 3 decimals to reduce index size.
    function norm(weight = 1, mantissa = 3) {
        const cache = new Map();
        const m = Math.pow(10, mantissa);
        return {
            get(value) {
                const numTokens = value.match(SPACE).length;
                if (cache.has(numTokens)) {
                    return cache.get(numTokens);
                }

                // Default function is 1/sqrt(x), weight makes that variable
                const norm = 1 / Math.pow(numTokens, 0.5 * weight);

                // In place of `toFixed(mantissa)`, for faster computation
                const n = parseFloat(Math.round(norm * m) / m);
                cache.set(numTokens, n);
                return n;
            },
            clear() {
                cache.clear();
            }
        };
    }
    class FuseIndex {
        constructor({
                        getFn = Config.getFn,
                        fieldNormWeight = Config.fieldNormWeight
                    } = {}) {
            this.norm = norm(fieldNormWeight, 3);
            this.getFn = getFn;
            this.isCreated = false;
            this.setIndexRecords();
        }
        setSources(docs = []) {
            this.docs = docs;
        }
        setIndexRecords(records = []) {
            this.records = records;
        }
        setKeys(keys = []) {
            this.keys = keys;
            this._keysMap = {};
            keys.forEach((key, idx) => {
                this._keysMap[key.id] = idx;
            });
        }
        create() {
            if (this.isCreated || !this.docs.length) {
                return;
            }
            this.isCreated = true;

            // List is Array<String>
            if (isString(this.docs[0])) {
                this.docs.forEach((doc, docIndex) => {
                    this._addString(doc, docIndex);
                });
            } else {
                // List is Array<Object>
                this.docs.forEach((doc, docIndex) => {
                    this._addObject(doc, docIndex);
                });
            }
            this.norm.clear();
        }
        // Adds a doc to the end of the index
        add(doc) {
            const idx = this.size();
            if (isString(doc)) {
                this._addString(doc, idx);
            } else {
                this._addObject(doc, idx);
            }
        }
        // Removes the doc at the specified index of the index
        removeAt(idx) {
            this.records.splice(idx, 1);

            // Change ref index of every subsquent doc
            for (let i = idx, len = this.size(); i < len; i += 1) {
                this.records[i].i -= 1;
            }
        }
        getValueForItemAtKeyId(item, keyId) {
            return item[this._keysMap[keyId]];
        }
        size() {
            return this.records.length;
        }
        _addString(doc, docIndex) {
            if (!isDefined(doc) || isBlank(doc)) {
                return;
            }
            let record = {
                v: doc,
                i: docIndex,
                n: this.norm.get(doc)
            };
            this.records.push(record);
        }
        _addObject(doc, docIndex) {
            let record = {
                i: docIndex,
                $: {}
            };

            // Iterate over every key (i.e, path), and fetch the value at that key
            this.keys.forEach((key, keyIndex) => {
                let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                if (!isDefined(value)) {
                    return;
                }
                if (isArray(value)) {
                    let subRecords = [];
                    const stack = [{
                        nestedArrIndex: -1,
                        value
                    }];
                    while (stack.length) {
                        const {
                            nestedArrIndex,
                            value
                        } = stack.pop();
                        if (!isDefined(value)) {
                            continue;
                        }
                        if (isString(value) && !isBlank(value)) {
                            let subRecord = {
                                v: value,
                                i: nestedArrIndex,
                                n: this.norm.get(value)
                            };
                            subRecords.push(subRecord);
                        } else if (isArray(value)) {
                            value.forEach((item, k) => {
                                stack.push({
                                    nestedArrIndex: k,
                                    value: item
                                });
                            });
                        } else ;
                    }
                    record.$[keyIndex] = subRecords;
                } else if (isString(value) && !isBlank(value)) {
                    let subRecord = {
                        v: value,
                        n: this.norm.get(value)
                    };
                    record.$[keyIndex] = subRecord;
                }
            });
            this.records.push(record);
        }
        toJSON() {
            return {
                keys: this.keys,
                records: this.records
            };
        }
    }
    function createIndex(keys, docs, {
        getFn = Config.getFn,
        fieldNormWeight = Config.fieldNormWeight
    } = {}) {
        const myIndex = new FuseIndex({
            getFn,
            fieldNormWeight
        });
        myIndex.setKeys(keys.map(createKey));
        myIndex.setSources(docs);
        myIndex.create();
        return myIndex;
    }
    function parseIndex(data, {
        getFn = Config.getFn,
        fieldNormWeight = Config.fieldNormWeight
    } = {}) {
        const {
            keys,
            records
        } = data;
        const myIndex = new FuseIndex({
            getFn,
            fieldNormWeight
        });
        myIndex.setKeys(keys);
        myIndex.setIndexRecords(records);
        return myIndex;
    }
    function computeScore$1(pattern, {
        errors = 0,
        currentLocation = 0,
        expectedLocation = 0,
        distance = Config.distance,
        ignoreLocation = Config.ignoreLocation
    } = {}) {
        const accuracy = errors / pattern.length;
        if (ignoreLocation) {
            return accuracy;
        }
        const proximity = Math.abs(expectedLocation - currentLocation);
        if (!distance) {
            // Dodge divide by zero error.
            return proximity ? 1.0 : accuracy;
        }
        return accuracy + proximity / distance;
    }
    function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
        let indices = [];
        let start = -1;
        let end = -1;
        let i = 0;
        for (let len = matchmask.length; i < len; i += 1) {
            let match = matchmask[i];
            if (match && start === -1) {
                start = i;
            } else if (!match && start !== -1) {
                end = i - 1;
                if (end - start + 1 >= minMatchCharLength) {
                    indices.push([start, end]);
                }
                start = -1;
            }
        }

        // (i-1 - start) + 1 => i - start
        if (matchmask[i - 1] && i - start >= minMatchCharLength) {
            indices.push([start, i - 1]);
        }
        return indices;
    }

    // Machine word size
    const MAX_BITS = 32;
    function search(text, pattern, patternAlphabet, {
        location = Config.location,
        distance = Config.distance,
        threshold = Config.threshold,
        findAllMatches = Config.findAllMatches,
        minMatchCharLength = Config.minMatchCharLength,
        includeMatches = Config.includeMatches,
        ignoreLocation = Config.ignoreLocation
    } = {}) {
        if (pattern.length > MAX_BITS) {
            throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
        }
        const patternLen = pattern.length;
        // Set starting location at beginning text and initialize the alphabet.
        const textLen = text.length;
        // Handle the case when location > text.length
        const expectedLocation = Math.max(0, Math.min(location, textLen));
        // Highest score beyond which we give up.
        let currentThreshold = threshold;
        // Is there a nearby exact match? (speedup)
        let bestLocation = expectedLocation;

        // Performance: only computer matches when the minMatchCharLength > 1
        // OR if `includeMatches` is true.
        const computeMatches = minMatchCharLength > 1 || includeMatches;
        // A mask of the matches, used for building the indices
        const matchMask = computeMatches ? Array(textLen) : [];
        let index;

        // Get all exact matches, here for speed up
        while ((index = text.indexOf(pattern, bestLocation)) > -1) {
            let score = computeScore$1(pattern, {
                currentLocation: index,
                expectedLocation,
                distance,
                ignoreLocation
            });
            currentThreshold = Math.min(score, currentThreshold);
            bestLocation = index + patternLen;
            if (computeMatches) {
                let i = 0;
                while (i < patternLen) {
                    matchMask[index + i] = 1;
                    i += 1;
                }
            }
        }

        // Reset the best location
        bestLocation = -1;
        let lastBitArr = [];
        let finalScore = 1;
        let binMax = patternLen + textLen;
        const mask = 1 << patternLen - 1;
        for (let i = 0; i < patternLen; i += 1) {
            // Scan for the best match; each iteration allows for one more error.
            // Run a binary search to determine how far from the match location we can stray
            // at this error level.
            let binMin = 0;
            let binMid = binMax;
            while (binMin < binMid) {
                const score = computeScore$1(pattern, {
                    errors: i,
                    currentLocation: expectedLocation + binMid,
                    expectedLocation,
                    distance,
                    ignoreLocation
                });
                if (score <= currentThreshold) {
                    binMin = binMid;
                } else {
                    binMax = binMid;
                }
                binMid = Math.floor((binMax - binMin) / 2 + binMin);
            }

            // Use the result from this iteration as the maximum for the next.
            binMax = binMid;
            let start = Math.max(1, expectedLocation - binMid + 1);
            let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

            // Initialize the bit array
            let bitArr = Array(finish + 2);
            bitArr[finish + 1] = (1 << i) - 1;
            for (let j = finish; j >= start; j -= 1) {
                let currentLocation = j - 1;
                let charMatch = patternAlphabet[text.charAt(currentLocation)];
                if (computeMatches) {
                    // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                    matchMask[currentLocation] = +!!charMatch;
                }

                // First pass: exact match
                bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

                // Subsequent passes: fuzzy match
                if (i) {
                    bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                }
                if (bitArr[j] & mask) {
                    finalScore = computeScore$1(pattern, {
                        errors: i,
                        currentLocation,
                        expectedLocation,
                        distance,
                        ignoreLocation
                    });

                    // This match will almost certainly be better than any existing match.
                    // But check anyway.
                    if (finalScore <= currentThreshold) {
                        // Indeed it is
                        currentThreshold = finalScore;
                        bestLocation = currentLocation;

                        // Already passed `loc`, downhill from here on in.
                        if (bestLocation <= expectedLocation) {
                            break;
                        }

                        // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                        start = Math.max(1, 2 * expectedLocation - bestLocation);
                    }
                }
            }

            // No hope for a (better) match at greater error levels.
            const score = computeScore$1(pattern, {
                errors: i + 1,
                currentLocation: expectedLocation,
                expectedLocation,
                distance,
                ignoreLocation
            });
            if (score > currentThreshold) {
                break;
            }
            lastBitArr = bitArr;
        }
        const result = {
            isMatch: bestLocation >= 0,
            // Count exact matches (those with a score of 0) to be "almost" exact
            score: Math.max(0.001, finalScore)
        };
        if (computeMatches) {
            const indices = convertMaskToIndices(matchMask, minMatchCharLength);
            if (!indices.length) {
                result.isMatch = false;
            } else if (includeMatches) {
                result.indices = indices;
            }
        }
        return result;
    }
    function createPatternAlphabet(pattern) {
        let mask = {};
        for (let i = 0, len = pattern.length; i < len; i += 1) {
            const char = pattern.charAt(i);
            mask[char] = (mask[char] || 0) | 1 << len - i - 1;
        }
        return mask;
    }
    class BitapSearch {
        constructor(pattern, {
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance,
            includeMatches = Config.includeMatches,
            findAllMatches = Config.findAllMatches,
            minMatchCharLength = Config.minMatchCharLength,
            isCaseSensitive = Config.isCaseSensitive,
            ignoreLocation = Config.ignoreLocation
        } = {}) {
            this.options = {
                location,
                threshold,
                distance,
                includeMatches,
                findAllMatches,
                minMatchCharLength,
                isCaseSensitive,
                ignoreLocation
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.chunks = [];
            if (!this.pattern.length) {
                return;
            }
            const addChunk = (pattern, startIndex) => {
                this.chunks.push({
                    pattern,
                    alphabet: createPatternAlphabet(pattern),
                    startIndex
                });
            };
            const len = this.pattern.length;
            if (len > MAX_BITS) {
                let i = 0;
                const remainder = len % MAX_BITS;
                const end = len - remainder;
                while (i < end) {
                    addChunk(this.pattern.substr(i, MAX_BITS), i);
                    i += MAX_BITS;
                }
                if (remainder) {
                    const startIndex = len - MAX_BITS;
                    addChunk(this.pattern.substr(startIndex), startIndex);
                }
            } else {
                addChunk(this.pattern, 0);
            }
        }
        searchIn(text) {
            const {
                isCaseSensitive,
                includeMatches
            } = this.options;
            if (!isCaseSensitive) {
                text = text.toLowerCase();
            }

            // Exact match
            if (this.pattern === text) {
                let result = {
                    isMatch: true,
                    score: 0
                };
                if (includeMatches) {
                    result.indices = [[0, text.length - 1]];
                }
                return result;
            }

            // Otherwise, use Bitap algorithm
            const {
                location,
                distance,
                threshold,
                findAllMatches,
                minMatchCharLength,
                ignoreLocation
            } = this.options;
            let allIndices = [];
            let totalScore = 0;
            let hasMatches = false;
            this.chunks.forEach(({
                                     pattern,
                                     alphabet,
                                     startIndex
                                 }) => {
                const {
                    isMatch,
                    score,
                    indices
                } = search(text, pattern, alphabet, {
                    location: location + startIndex,
                    distance,
                    threshold,
                    findAllMatches,
                    minMatchCharLength,
                    includeMatches,
                    ignoreLocation
                });
                if (isMatch) {
                    hasMatches = true;
                }
                totalScore += score;
                if (isMatch && indices) {
                    allIndices = [...allIndices, ...indices];
                }
            });
            let result = {
                isMatch: hasMatches,
                score: hasMatches ? totalScore / this.chunks.length : 1
            };
            if (hasMatches && includeMatches) {
                result.indices = allIndices;
            }
            return result;
        }
    }
    class BaseMatch {
        constructor(pattern) {
            this.pattern = pattern;
        }
        static isMultiMatch(pattern) {
            return getMatch(pattern, this.multiRegex);
        }
        static isSingleMatch(pattern) {
            return getMatch(pattern, this.singleRegex);
        }
        search( /*text*/) {}
    }
    function getMatch(pattern, exp) {
        const matches = pattern.match(exp);
        return matches ? matches[1] : null;
    }

    // Token: 'file

    class ExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'exact';
        }
        static get multiRegex() {
            return /^="(.*)"$/;
        }
        static get singleRegex() {
            return /^=(.*)$/;
        }
        search(text) {
            const isMatch = text === this.pattern;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, this.pattern.length - 1]
            };
        }
    }

    // Token: !fire

    class InverseExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"$/;
        }
        static get singleRegex() {
            return /^!(.*)$/;
        }
        search(text) {
            const index = text.indexOf(this.pattern);
            const isMatch = index === -1;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }

    // Token: ^file

    class PrefixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'prefix-exact';
        }
        static get multiRegex() {
            return /^\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^\^(.*)$/;
        }
        search(text) {
            const isMatch = text.startsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, this.pattern.length - 1]
            };
        }
    }

    // Token: !^fire

    class InversePrefixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-prefix-exact';
        }
        static get multiRegex() {
            return /^!\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^!\^(.*)$/;
        }
        search(text) {
            const isMatch = !text.startsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }

    // Token: .file$

    class SuffixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'suffix-exact';
        }
        static get multiRegex() {
            return /^"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^(.*)\$$/;
        }
        search(text) {
            const isMatch = text.endsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [text.length - this.pattern.length, text.length - 1]
            };
        }
    }

    // Token: !.file$

    class InverseSuffixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-suffix-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^!(.*)\$$/;
        }
        search(text) {
            const isMatch = !text.endsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }
    class FuzzyMatch extends BaseMatch {
        constructor(pattern, {
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance,
            includeMatches = Config.includeMatches,
            findAllMatches = Config.findAllMatches,
            minMatchCharLength = Config.minMatchCharLength,
            isCaseSensitive = Config.isCaseSensitive,
            ignoreLocation = Config.ignoreLocation
        } = {}) {
            super(pattern);
            this._bitapSearch = new BitapSearch(pattern, {
                location,
                threshold,
                distance,
                includeMatches,
                findAllMatches,
                minMatchCharLength,
                isCaseSensitive,
                ignoreLocation
            });
        }
        static get type() {
            return 'fuzzy';
        }
        static get multiRegex() {
            return /^"(.*)"$/;
        }
        static get singleRegex() {
            return /^(.*)$/;
        }
        search(text) {
            return this._bitapSearch.searchIn(text);
        }
    }

    // Token: 'file

    class IncludeMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'include';
        }
        static get multiRegex() {
            return /^'"(.*)"$/;
        }
        static get singleRegex() {
            return /^'(.*)$/;
        }
        search(text) {
            let location = 0;
            let index;
            const indices = [];
            const patternLen = this.pattern.length;

            // Get all exact matches
            while ((index = text.indexOf(this.pattern, location)) > -1) {
                location = index + patternLen;
                indices.push([index, location - 1]);
            }
            const isMatch = !!indices.length;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices
            };
        }
    }

    // ❗Order is important. DO NOT CHANGE.
    const searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
    const searchersLen = searchers.length;

    // Regex to split by spaces, but keep anything in quotes together
    const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
    const OR_TOKEN = '|';

    // Return a 2D array representation of the query, for simpler parsing.
    // Example:
    // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
    function parseQuery(pattern, options = {}) {
        return pattern.split(OR_TOKEN).map(item => {
            let query = item.trim().split(SPACE_RE).filter(item => item && !!item.trim());
            let results = [];
            for (let i = 0, len = query.length; i < len; i += 1) {
                const queryItem = query[i];

                // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                let found = false;
                let idx = -1;
                while (!found && ++idx < searchersLen) {
                    const searcher = searchers[idx];
                    let token = searcher.isMultiMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        found = true;
                    }
                }
                if (found) {
                    continue;
                }

                // 2. Handle single query matches (i.e, once that are *not* quoted)
                idx = -1;
                while (++idx < searchersLen) {
                    const searcher = searchers[idx];
                    let token = searcher.isSingleMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        break;
                    }
                }
            }
            return results;
        });
    }

    // These extended matchers can return an array of matches, as opposed
    // to a singl match
    const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

    /**
     * Command-like searching
     * ======================
     *
     * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
     * search in a given text.
     *
     * Search syntax:
     *
     * | Token       | Match type                 | Description                            |
     * | ----------- | -------------------------- | -------------------------------------- |
     * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
     * | `=scheme`   | exact-match                | Items that are `scheme`                |
     * | `'python`   | include-match              | Items that include `python`            |
     * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
     * | `^java`     | prefix-exact-match         | Items that start with `java`           |
     * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
     * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
     * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
     *
     * A single pipe character acts as an OR operator. For example, the following
     * query matches entries that start with `core` and end with either`go`, `rb`,
     * or`py`.
     *
     * ```
     * ^core go$ | rb$ | py$
     * ```
     */
    class ExtendedSearch {
        constructor(pattern, {
            isCaseSensitive = Config.isCaseSensitive,
            includeMatches = Config.includeMatches,
            minMatchCharLength = Config.minMatchCharLength,
            ignoreLocation = Config.ignoreLocation,
            findAllMatches = Config.findAllMatches,
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance
        } = {}) {
            this.query = null;
            this.options = {
                isCaseSensitive,
                includeMatches,
                minMatchCharLength,
                findAllMatches,
                ignoreLocation,
                location,
                threshold,
                distance
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.query = parseQuery(this.pattern, this.options);
        }
        static condition(_, options) {
            return options.useExtendedSearch;
        }
        searchIn(text) {
            const query = this.query;
            if (!query) {
                return {
                    isMatch: false,
                    score: 1
                };
            }
            const {
                includeMatches,
                isCaseSensitive
            } = this.options;
            text = isCaseSensitive ? text : text.toLowerCase();
            let numMatches = 0;
            let allIndices = [];
            let totalScore = 0;

            // ORs
            for (let i = 0, qLen = query.length; i < qLen; i += 1) {
                const searchers = query[i];

                // Reset indices
                allIndices.length = 0;
                numMatches = 0;

                // ANDs
                for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
                    const searcher = searchers[j];
                    const {
                        isMatch,
                        indices,
                        score
                    } = searcher.search(text);
                    if (isMatch) {
                        numMatches += 1;
                        totalScore += score;
                        if (includeMatches) {
                            const type = searcher.constructor.type;
                            if (MultiMatchSet.has(type)) {
                                allIndices = [...allIndices, ...indices];
                            } else {
                                allIndices.push(indices);
                            }
                        }
                    } else {
                        totalScore = 0;
                        numMatches = 0;
                        allIndices.length = 0;
                        break;
                    }
                }

                // OR condition, so if TRUE, return
                if (numMatches) {
                    let result = {
                        isMatch: true,
                        score: totalScore / numMatches
                    };
                    if (includeMatches) {
                        result.indices = allIndices;
                    }
                    return result;
                }
            }

            // Nothing was matched
            return {
                isMatch: false,
                score: 1
            };
        }
    }
    const registeredSearchers = [];
    function register(...args) {
        registeredSearchers.push(...args);
    }
    function createSearcher(pattern, options) {
        for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
            let searcherClass = registeredSearchers[i];
            if (searcherClass.condition(pattern, options)) {
                return new searcherClass(pattern, options);
            }
        }
        return new BitapSearch(pattern, options);
    }
    const LogicalOperator = {
        AND: '$and',
        OR: '$or'
    };
    const KeyType = {
        PATH: '$path',
        PATTERN: '$val'
    };
    const isExpression = query => !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
    const isPath = query => !!query[KeyType.PATH];
    const isLeaf = query => !isArray(query) && isObject(query) && !isExpression(query);
    const convertToExplicit = query => ({
        [LogicalOperator.AND]: Object.keys(query).map(key => ({
            [key]: query[key]
        }))
    });

    // When `auto` is `true`, the parse function will infer and initialize and add
    // the appropriate `Searcher` instance
    function parse(query, options, {
        auto = true
    } = {}) {
        const next = query => {
            let keys = Object.keys(query);
            const isQueryPath = isPath(query);
            if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
                return next(convertToExplicit(query));
            }
            if (isLeaf(query)) {
                const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                if (!isString(pattern)) {
                    throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                }
                const obj = {
                    keyId: createKeyId(key),
                    pattern
                };
                if (auto) {
                    obj.searcher = createSearcher(pattern, options);
                }
                return obj;
            }
            let node = {
                children: [],
                operator: keys[0]
            };
            keys.forEach(key => {
                const value = query[key];
                if (isArray(value)) {
                    value.forEach(item => {
                        node.children.push(next(item));
                    });
                }
            });
            return node;
        };
        if (!isExpression(query)) {
            query = convertToExplicit(query);
        }
        return next(query);
    }

    // Practical scoring function
    function computeScore(results, {
        ignoreFieldNorm = Config.ignoreFieldNorm
    }) {
        results.forEach(result => {
            let totalScore = 1;
            result.matches.forEach(({
                                        key,
                                        norm,
                                        score
                                    }) => {
                const weight = key ? key.weight : null;
                totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
            });
            result.score = totalScore;
        });
    }
    function transformMatches(result, data) {
        const matches = result.matches;
        data.matches = [];
        if (!isDefined(matches)) {
            return;
        }
        matches.forEach(match => {
            if (!isDefined(match.indices) || !match.indices.length) {
                return;
            }
            const {
                indices,
                value
            } = match;
            let obj = {
                indices,
                value
            };
            if (match.key) {
                obj.key = match.key.src;
            }
            if (match.idx > -1) {
                obj.refIndex = match.idx;
            }
            data.matches.push(obj);
        });
    }
    function transformScore(result, data) {
        data.score = result.score;
    }
    function format(results, docs, {
        includeMatches = Config.includeMatches,
        includeScore = Config.includeScore
    } = {}) {
        const transformers = [];
        if (includeMatches) transformers.push(transformMatches);
        if (includeScore) transformers.push(transformScore);
        return results.map(result => {
            const {
                idx
            } = result;
            const data = {
                item: docs[idx],
                refIndex: idx
            };
            if (transformers.length) {
                transformers.forEach(transformer => {
                    transformer(result, data);
                });
            }
            return data;
        });
    }
    class Fuse {
        constructor(docs, options = {}, index) {
            this.options = _objectSpread2(_objectSpread2({}, Config), options);
            if (this.options.useExtendedSearch && false) ;
            this._keyStore = new KeyStore(this.options.keys);
            this.setCollection(docs, index);
        }
        setCollection(docs, index) {
            this._docs = docs;
            if (index && !(index instanceof FuseIndex)) {
                throw new Error(INCORRECT_INDEX_TYPE);
            }
            this._myIndex = index || createIndex(this.options.keys, this._docs, {
                getFn: this.options.getFn,
                fieldNormWeight: this.options.fieldNormWeight
            });
        }
        add(doc) {
            if (!isDefined(doc)) {
                return;
            }
            this._docs.push(doc);
            this._myIndex.add(doc);
        }
        remove(predicate = ( /* doc, idx */) => false) {
            const results = [];
            for (let i = 0, len = this._docs.length; i < len; i += 1) {
                const doc = this._docs[i];
                if (predicate(doc, i)) {
                    this.removeAt(i);
                    i -= 1;
                    len -= 1;
                    results.push(doc);
                }
            }
            return results;
        }
        removeAt(idx) {
            this._docs.splice(idx, 1);
            this._myIndex.removeAt(idx);
        }
        getIndex() {
            return this._myIndex;
        }
        search(query, {
            limit = -1
        } = {}) {
            const {
                includeMatches,
                includeScore,
                shouldSort,
                sortFn,
                ignoreFieldNorm
            } = this.options;
            let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
            computeScore(results, {
                ignoreFieldNorm
            });
            if (shouldSort) {
                results.sort(sortFn);
            }
            if (isNumber(limit) && limit > -1) {
                results = results.slice(0, limit);
            }
            return format(results, this._docs, {
                includeMatches,
                includeScore
            });
        }
        _searchStringList(query) {
            const searcher = createSearcher(query, this.options);
            const {
                records
            } = this._myIndex;
            const results = [];

            // Iterate over every string in the index
            records.forEach(({
                                 v: text,
                                 i: idx,
                                 n: norm
                             }) => {
                if (!isDefined(text)) {
                    return;
                }
                const {
                    isMatch,
                    score,
                    indices
                } = searcher.searchIn(text);
                if (isMatch) {
                    results.push({
                        item: text,
                        idx,
                        matches: [{
                            score,
                            value: text,
                            norm,
                            indices
                        }]
                    });
                }
            });
            return results;
        }
        _searchLogical(query) {
            const expression = parse(query, this.options);
            const evaluate = (node, item, idx) => {
                if (!node.children) {
                    const {
                        keyId,
                        searcher
                    } = node;
                    const matches = this._findMatches({
                        key: this._keyStore.get(keyId),
                        value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                        searcher
                    });
                    if (matches && matches.length) {
                        return [{
                            idx,
                            item,
                            matches
                        }];
                    }
                    return [];
                }
                const res = [];
                for (let i = 0, len = node.children.length; i < len; i += 1) {
                    const child = node.children[i];
                    const result = evaluate(child, item, idx);
                    if (result.length) {
                        res.push(...result);
                    } else if (node.operator === LogicalOperator.AND) {
                        return [];
                    }
                }
                return res;
            };
            const records = this._myIndex.records;
            const resultMap = {};
            const results = [];
            records.forEach(({
                                 $: item,
                                 i: idx
                             }) => {
                if (isDefined(item)) {
                    let expResults = evaluate(expression, item, idx);
                    if (expResults.length) {
                        // Dedupe when adding
                        if (!resultMap[idx]) {
                            resultMap[idx] = {
                                idx,
                                item,
                                matches: []
                            };
                            results.push(resultMap[idx]);
                        }
                        expResults.forEach(({
                                                matches
                                            }) => {
                            resultMap[idx].matches.push(...matches);
                        });
                    }
                }
            });
            return results;
        }
        _searchObjectList(query) {
            const searcher = createSearcher(query, this.options);
            const {
                keys,
                records
            } = this._myIndex;
            const results = [];

            // List is Array<Object>
            records.forEach(({
                                 $: item,
                                 i: idx
                             }) => {
                if (!isDefined(item)) {
                    return;
                }
                let matches = [];

                // Iterate over every key (i.e, path), and fetch the value at that key
                keys.forEach((key, keyIndex) => {
                    matches.push(...this._findMatches({
                        key,
                        value: item[keyIndex],
                        searcher
                    }));
                });
                if (matches.length) {
                    results.push({
                        idx,
                        item,
                        matches
                    });
                }
            });
            return results;
        }
        _findMatches({
                         key,
                         value,
                         searcher
                     }) {
            if (!isDefined(value)) {
                return [];
            }
            let matches = [];
            if (isArray(value)) {
                value.forEach(({
                                   v: text,
                                   i: idx,
                                   n: norm
                               }) => {
                    if (!isDefined(text)) {
                        return;
                    }
                    const {
                        isMatch,
                        score,
                        indices
                    } = searcher.searchIn(text);
                    if (isMatch) {
                        matches.push({
                            score,
                            key,
                            value: text,
                            idx,
                            norm,
                            indices
                        });
                    }
                });
            } else {
                const {
                    v: text,
                    n: norm
                } = value;
                const {
                    isMatch,
                    score,
                    indices
                } = searcher.searchIn(text);
                if (isMatch) {
                    matches.push({
                        score,
                        key,
                        value: text,
                        norm,
                        indices
                    });
                }
            }
            return matches;
        }
    }
    Fuse.version = '7.0.0';
    Fuse.createIndex = createIndex;
    Fuse.parseIndex = parseIndex;
    Fuse.config = Config;
    {
        Fuse.parseQuery = parse;
    }
    {
        register(ExtendedSearch);
    }

    var SearchByFuse = /** @class */ (function () {
        function SearchByFuse(config) {
            this._haystack = [];
            this._fuseOptions = __assign(__assign({}, config.fuseOptions), { keys: __spreadArray([], config.searchFields, true), includeMatches: true });
        }
        SearchByFuse.prototype.index = function (data) {
            this._haystack = data;
            if (this._fuse) {
                this._fuse.setCollection(data);
            }
        };
        SearchByFuse.prototype.reset = function () {
            this._haystack = [];
            this._fuse = undefined;
        };
        SearchByFuse.prototype.isEmptyIndex = function () {
            return !this._haystack.length;
        };
        SearchByFuse.prototype.search = function (needle) {
            if (!this._fuse) {
                {
                    this._fuse = new Fuse(this._haystack, this._fuseOptions);
                }
            }
            var results = this._fuse.search(needle);
            return results.map(function (value, i) {
                return {
                    item: value.item,
                    score: value.score || 0,
                    rank: i + 1, // If value.score is used for sorting, this can create non-stable sorts!
                };
            });
        };
        return SearchByFuse;
    }());

    function getSearcher(config) {
        {
            return new SearchByFuse(config);
        }
    }

    /**
     * Helpers to create HTML elements used by Choices
     * Can be overridden by providing `callbackOnCreateTemplates` option.
     * `Choices.defaults.templates` allows access to the default template methods from `callbackOnCreateTemplates`
     */
    var isEmptyObject = function (obj) {
        // eslint-disable-next-line no-restricted-syntax
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return false;
            }
        }
        return true;
    };
    var assignCustomProperties = function (el, choice, withCustomProperties) {
        var dataset = el.dataset;
        var customProperties = choice.customProperties, labelClass = choice.labelClass, labelDescription = choice.labelDescription;
        if (labelClass) {
            dataset.labelClass = getClassNames(labelClass).join(' ');
        }
        if (labelDescription) {
            dataset.labelDescription = unwrapStringForRaw(labelDescription);
        }
        if (withCustomProperties && customProperties) {
            if (typeof customProperties === 'string') {
                dataset.customProperties = customProperties;
            }
            else if (typeof customProperties === 'object' && !isEmptyObject(customProperties)) {
                dataset.customProperties = JSON.stringify(customProperties);
            }
        }
    };
    var addAriaLabel = function (docRoot, id, element) {
        var label = id && docRoot.querySelector("label[for='".concat(id, "']"));
        var text = label && label.innerText;
        if (text) {
            element.setAttribute('aria-label', text);
        }
    };
    var templates = {
        containerOuter: function (_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
            var containerOuter = _a.classNames.containerOuter;
            var div = document.createElement('div');
            addClassesToElement(div, containerOuter);
            div.dataset.type = passedElementType;
            if (dir) {
                div.dir = dir;
            }
            if (isSelectOneElement) {
                div.tabIndex = 0;
            }
            if (isSelectElement) {
                div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                if (searchEnabled) {
                    div.setAttribute('aria-autocomplete', 'list');
                }
                else if (!labelId) {
                    addAriaLabel(this._docRoot, this.passedElement.element.id, div);
                }
                div.setAttribute('aria-haspopup', 'true');
                div.setAttribute('aria-expanded', 'false');
            }
            if (labelId) {
                div.setAttribute('aria-labelledby', labelId);
            }
            return div;
        },
        containerInner: function (_a) {
            var containerInner = _a.classNames.containerInner;
            var div = document.createElement('div');
            addClassesToElement(div, containerInner);
            return div;
        },
        itemList: function (_a, isSelectOneElement) {
            var searchEnabled = _a.searchEnabled, _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            addClassesToElement(div, isSelectOneElement ? listSingle : listItems);
            if (this._isSelectElement && searchEnabled) {
                div.setAttribute('role', 'listbox');
            }
            return div;
        },
        placeholder: function (_a, value) {
            var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
            var div = document.createElement('div');
            addClassesToElement(div, placeholder);
            setElementHtml(div, allowHTML, value);
            return div;
        },
        item: function (_a, choice, removeItemButton) {
            var allowHTML = _a.allowHTML, removeItemButtonAlignLeft = _a.removeItemButtonAlignLeft, removeItemIconText = _a.removeItemIconText, removeItemLabelText = _a.removeItemLabelText, _b = _a.classNames, item = _b.item, button = _b.button, highlightedState = _b.highlightedState, itemSelectable = _b.itemSelectable, placeholder = _b.placeholder;
            var rawValue = unwrapStringForRaw(choice.value);
            var div = document.createElement('div');
            addClassesToElement(div, item);
            if (choice.labelClass) {
                var spanLabel = document.createElement('span');
                setElementHtml(spanLabel, allowHTML, choice.label);
                addClassesToElement(spanLabel, choice.labelClass);
                div.appendChild(spanLabel);
            }
            else {
                setElementHtml(div, allowHTML, choice.label);
            }
            div.dataset.item = '';
            div.dataset.id = choice.id;
            div.dataset.value = rawValue;
            assignCustomProperties(div, choice, true);
            if (choice.disabled || this.containerOuter.isDisabled) {
                div.setAttribute('aria-disabled', 'true');
            }
            if (this._isSelectElement) {
                div.setAttribute('aria-selected', 'true');
                div.setAttribute('role', 'option');
            }
            if (choice.placeholder) {
                addClassesToElement(div, placeholder);
                div.dataset.placeholder = '';
            }
            addClassesToElement(div, choice.highlighted ? highlightedState : itemSelectable);
            if (removeItemButton) {
                if (choice.disabled) {
                    removeClassesFromElement(div, itemSelectable);
                }
                div.dataset.deletable = '';
                var removeButton = document.createElement('button');
                removeButton.type = 'button';
                addClassesToElement(removeButton, button);
                var eventChoice = getChoiceForOutput(choice);
                setElementHtml(removeButton, true, resolveNoticeFunction(removeItemIconText, choice.value, eventChoice));
                var REMOVE_ITEM_LABEL = resolveNoticeFunction(removeItemLabelText, choice.value, eventChoice);
                if (REMOVE_ITEM_LABEL) {
                    removeButton.setAttribute('aria-label', REMOVE_ITEM_LABEL);
                }
                removeButton.dataset.button = '';
                if (removeItemButtonAlignLeft) {
                    div.insertAdjacentElement('afterbegin', removeButton);
                }
                else {
                    div.appendChild(removeButton);
                }
            }
            return div;
        },
        choiceList: function (_a, isSelectOneElement) {
            var list = _a.classNames.list;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            if (!isSelectOneElement) {
                div.setAttribute('aria-multiselectable', 'true');
            }
            div.setAttribute('role', 'listbox');
            return div;
        },
        choiceGroup: function (_a, _b) {
            var allowHTML = _a.allowHTML, _c = _a.classNames, group = _c.group, groupHeading = _c.groupHeading, itemDisabled = _c.itemDisabled;
            var id = _b.id, label = _b.label, disabled = _b.disabled;
            var rawLabel = unwrapStringForRaw(label);
            var div = document.createElement('div');
            addClassesToElement(div, group);
            if (disabled) {
                addClassesToElement(div, itemDisabled);
            }
            div.setAttribute('role', 'group');
            div.dataset.group = '';
            div.dataset.id = id;
            div.dataset.value = rawLabel;
            if (disabled) {
                div.setAttribute('aria-disabled', 'true');
            }
            var heading = document.createElement('div');
            addClassesToElement(heading, groupHeading);
            setElementHtml(heading, allowHTML, label || '');
            div.appendChild(heading);
            return div;
        },
        choice: function (_a, choice, selectText, groupName) {
            var allowHTML = _a.allowHTML, _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, itemSelectable = _b.itemSelectable, selectedState = _b.selectedState, itemDisabled = _b.itemDisabled, description = _b.description, placeholder = _b.placeholder;
            // eslint-disable-next-line prefer-destructuring
            var label = choice.label;
            var rawValue = unwrapStringForRaw(choice.value);
            var div = document.createElement('div');
            div.id = choice.elementId;
            addClassesToElement(div, item);
            addClassesToElement(div, itemChoice);
            if (groupName && typeof label === 'string') {
                label = escapeForTemplate(allowHTML, label);
                label += " (".concat(groupName, ")");
                label = { trusted: label };
            }
            var describedBy = div;
            if (choice.labelClass) {
                var spanLabel = document.createElement('span');
                setElementHtml(spanLabel, allowHTML, label);
                addClassesToElement(spanLabel, choice.labelClass);
                describedBy = spanLabel;
                div.appendChild(spanLabel);
            }
            else {
                setElementHtml(div, allowHTML, label);
            }
            if (choice.labelDescription) {
                var descId = "".concat(choice.elementId, "-description");
                describedBy.setAttribute('aria-describedby', descId);
                var spanDesc = document.createElement('span');
                setElementHtml(spanDesc, allowHTML, choice.labelDescription);
                spanDesc.id = descId;
                addClassesToElement(spanDesc, description);
                div.appendChild(spanDesc);
            }
            if (choice.selected) {
                addClassesToElement(div, selectedState);
            }
            if (choice.placeholder) {
                addClassesToElement(div, placeholder);
            }
            div.setAttribute('role', choice.group ? 'treeitem' : 'option');
            div.dataset.choice = '';
            div.dataset.id = choice.id;
            div.dataset.value = rawValue;
            if (selectText) {
                div.dataset.selectText = selectText;
            }
            if (choice.group) {
                div.dataset.groupId = "".concat(choice.group.id);
            }
            assignCustomProperties(div, choice, false);
            if (choice.disabled) {
                addClassesToElement(div, itemDisabled);
                div.dataset.choiceDisabled = '';
                div.setAttribute('aria-disabled', 'true');
            }
            else {
                addClassesToElement(div, itemSelectable);
                div.dataset.choiceSelectable = '';
                div.setAttribute('aria-selected', choice.selected ? 'true' : 'false');
            }
            return div;
        },
        input: function (_a, placeholderValue) {
            var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned, labelId = _a.labelId;
            var inp = document.createElement('input');
            inp.type = 'search';
            addClassesToElement(inp, input);
            addClassesToElement(inp, inputCloned);
            inp.autocomplete = 'off';
            inp.autocapitalize = 'off';
            inp.spellcheck = false;
            inp.setAttribute('aria-autocomplete', 'list');
            if (placeholderValue) {
                inp.setAttribute('aria-label', placeholderValue);
            }
            else if (!labelId) {
                addAriaLabel(this._docRoot, this.passedElement.element.id, inp);
            }
            return inp;
        },
        dropdown: function (_a) {
            var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            addClassesToElement(div, listDropdown);
            div.setAttribute('aria-expanded', 'false');
            return div;
        },
        notice: function (_a, innerHTML, type) {
            var _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, addChoice = _b.addChoice, noResults = _b.noResults, noChoices = _b.noChoices, noticeItem = _b.notice;
            if (type === void 0) { type = NoticeTypes.generic; }
            var notice = document.createElement('div');
            setElementHtml(notice, true, innerHTML);
            addClassesToElement(notice, item);
            addClassesToElement(notice, itemChoice);
            addClassesToElement(notice, noticeItem);
            // eslint-disable-next-line default-case
            switch (type) {
                case NoticeTypes.addChoice:
                    addClassesToElement(notice, addChoice);
                    break;
                case NoticeTypes.noResults:
                    addClassesToElement(notice, noResults);
                    break;
                case NoticeTypes.noChoices:
                    addClassesToElement(notice, noChoices);
                    break;
            }
            if (type === NoticeTypes.addChoice) {
                notice.dataset.choiceSelectable = '';
                notice.dataset.choice = '';
            }
            return notice;
        },
        option: function (choice) {
            // HtmlOptionElement's label value does not support HTML, so the avoid double escaping unwrap the untrusted string.
            var labelValue = unwrapStringForRaw(choice.label);
            var opt = new Option(labelValue, choice.value, false, choice.selected);
            assignCustomProperties(opt, choice, true);
            opt.disabled = choice.disabled;
            if (choice.selected) {
                opt.setAttribute('selected', '');
            }
            return opt;
        },
    };

    /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */
    var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style &&
        '-ms-ime-align' in document.documentElement.style;
    var USER_DEFAULTS = {};
    var parseDataSetId = function (element) {
        if (!element) {
            return undefined;
        }
        return element.dataset.id ? parseInt(element.dataset.id, 10) : undefined;
    };
    var selectableChoiceIdentifier = '[data-choice-selectable]';
    /**
     * Choices
     * @author Josh Johnson<josh@joshuajohnson.co.uk>
     */
    var Choices = /** @class */ (function () {
        function Choices(element, userConfig) {
            if (element === void 0) { element = '[data-choice]'; }
            if (userConfig === void 0) { userConfig = {}; }
            var _this = this;
            this.initialisedOK = undefined;
            this._hasNonChoicePlaceholder = false;
            this._lastAddedChoiceId = 0;
            this._lastAddedGroupId = 0;
            var defaults = Choices.defaults;
            this.config = __assign(__assign(__assign({}, defaults.allOptions), defaults.options), userConfig);
            ObjectsInConfig.forEach(function (key) {
                _this.config[key] = __assign(__assign(__assign({}, defaults.allOptions[key]), defaults.options[key]), userConfig[key]);
            });
            var config = this.config;
            if (!config.silent) {
                this._validateConfig();
            }
            var docRoot = config.shadowRoot || document.documentElement;
            this._docRoot = docRoot;
            var passedElement = typeof element === 'string' ? docRoot.querySelector(element) : element;
            if (!passedElement ||
                typeof passedElement !== 'object' ||
                !(isHtmlInputElement(passedElement) || isHtmlSelectElement(passedElement))) {
                if (!passedElement && typeof element === 'string') {
                    throw TypeError("Selector ".concat(element, " failed to find an element"));
                }
                throw TypeError("Expected one of the following types text|select-one|select-multiple");
            }
            var elementType = passedElement.type;
            var isText = elementType === PassedElementTypes.Text;
            if (isText || config.maxItemCount !== 1) {
                config.singleModeForMultiSelect = false;
            }
            if (config.singleModeForMultiSelect) {
                elementType = PassedElementTypes.SelectMultiple;
            }
            var isSelectOne = elementType === PassedElementTypes.SelectOne;
            var isSelectMultiple = elementType === PassedElementTypes.SelectMultiple;
            var isSelect = isSelectOne || isSelectMultiple;
            this._elementType = elementType;
            this._isTextElement = isText;
            this._isSelectOneElement = isSelectOne;
            this._isSelectMultipleElement = isSelectMultiple;
            this._isSelectElement = isSelectOne || isSelectMultiple;
            this._canAddUserChoices = (isText && config.addItems) || (isSelect && config.addChoices);
            if (typeof config.renderSelectedChoices !== 'boolean') {
                config.renderSelectedChoices = config.renderSelectedChoices === 'always' || isSelectOne;
            }
            if (config.closeDropdownOnSelect === 'auto') {
                config.closeDropdownOnSelect = isText || isSelectOne || config.singleModeForMultiSelect;
            }
            else {
                config.closeDropdownOnSelect = coerceBool(config.closeDropdownOnSelect);
            }
            if (config.placeholder) {
                if (config.placeholderValue) {
                    this._hasNonChoicePlaceholder = true;
                }
                else if (passedElement.dataset.placeholder) {
                    this._hasNonChoicePlaceholder = true;
                    config.placeholderValue = passedElement.dataset.placeholder;
                }
            }
            if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                config.addItemFilter = re.test.bind(re);
            }
            if (this._isTextElement) {
                this.passedElement = new WrappedInput({
                    element: passedElement,
                    classNames: config.classNames,
                });
            }
            else {
                var selectEl = passedElement;
                this.passedElement = new WrappedSelect({
                    element: selectEl,
                    classNames: config.classNames,
                    template: function (data) { return _this._templates.option(data); },
                    extractPlaceholder: config.placeholder && !this._hasNonChoicePlaceholder,
                });
            }
            this.initialised = false;
            this._store = new Store(config);
            this._currentValue = '';
            config.searchEnabled = !isText && config.searchEnabled;
            this._canSearch = config.searchEnabled;
            this._isScrollingOnIe = false;
            this._highlightPosition = 0;
            this._wasTap = true;
            this._placeholderValue = this._generatePlaceholderValue();
            this._baseId = generateId(passedElement, 'choices-');
            /**
             * setting direction in cases where it's explicitly set on passedElement
             * or when calculated direction is different from the document
             */
            this._direction = passedElement.dir;
            if (!this._direction) {
                var elementDirection = window.getComputedStyle(passedElement).direction;
                var documentDirection = window.getComputedStyle(document.documentElement).direction;
                if (elementDirection !== documentDirection) {
                    this._direction = elementDirection;
                }
            }
            this._idNames = {
                itemChoice: 'item-choice',
            };
            this._templates = defaults.templates;
            this._render = this._render.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onBlur = this._onBlur.bind(this);
            this._onKeyUp = this._onKeyUp.bind(this);
            this._onKeyDown = this._onKeyDown.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onClick = this._onClick.bind(this);
            this._onTouchMove = this._onTouchMove.bind(this);
            this._onTouchEnd = this._onTouchEnd.bind(this);
            this._onMouseDown = this._onMouseDown.bind(this);
            this._onMouseOver = this._onMouseOver.bind(this);
            this._onFormReset = this._onFormReset.bind(this);
            this._onSelectKey = this._onSelectKey.bind(this);
            this._onEnterKey = this._onEnterKey.bind(this);
            this._onEscapeKey = this._onEscapeKey.bind(this);
            this._onDirectionKey = this._onDirectionKey.bind(this);
            this._onDeleteKey = this._onDeleteKey.bind(this);
            this._onChange = this._onChange.bind(this);
            this._onInvalid = this._onInvalid.bind(this);
            // If element has already been initialised with Choices, fail silently
            if (this.passedElement.isActive) {
                if (!config.silent) {
                    console.warn('Trying to initialise Choices on element already initialised', { element: element });
                }
                this.initialised = true;
                this.initialisedOK = false;
                return;
            }
            // Let's go
            this.init();
            // preserve the selected item list after setup for form reset
            this._initialItems = this._store.items.map(function (choice) { return choice.value; });
        }
        Object.defineProperty(Choices, "defaults", {
            get: function () {
                return Object.preventExtensions({
                    get options() {
                        return USER_DEFAULTS;
                    },
                    get allOptions() {
                        return DEFAULT_CONFIG;
                    },
                    get templates() {
                        return templates;
                    },
                });
            },
            enumerable: false,
            configurable: true
        });
        Choices.prototype.init = function () {
            if (this.initialised || this.initialisedOK !== undefined) {
                return;
            }
            this._searcher = getSearcher(this.config);
            this._loadChoices();
            this._createTemplates();
            this._createElements();
            this._createStructure();
            if ((this._isTextElement && !this.config.addItems) ||
                this.passedElement.element.hasAttribute('disabled') ||
                !!this.passedElement.element.closest('fieldset:disabled')) {
                this.disable();
            }
            else {
                this.enable();
                this._addEventListeners();
            }
            // should be triggered **after** disabled state to avoid additional re-draws
            this._initStore();
            this.initialised = true;
            this.initialisedOK = true;
            var callbackOnInit = this.config.callbackOnInit;
            // Run callback if it is a function
            if (typeof callbackOnInit === 'function') {
                callbackOnInit.call(this);
            }
        };
        Choices.prototype.destroy = function () {
            if (!this.initialised) {
                return;
            }
            this._removeEventListeners();
            this.passedElement.reveal();
            this.containerOuter.unwrap(this.passedElement.element);
            this._store._listeners = []; // prevents select/input value being wiped
            this.clearStore(false);
            this._stopSearch();
            this._templates = Choices.defaults.templates;
            this.initialised = false;
            this.initialisedOK = undefined;
        };
        Choices.prototype.enable = function () {
            if (this.passedElement.isDisabled) {
                this.passedElement.enable();
            }
            if (this.containerOuter.isDisabled) {
                this._addEventListeners();
                this.input.enable();
                this.containerOuter.enable();
            }
            return this;
        };
        Choices.prototype.disable = function () {
            if (!this.passedElement.isDisabled) {
                this.passedElement.disable();
            }
            if (!this.containerOuter.isDisabled) {
                this._removeEventListeners();
                this.input.disable();
                this.containerOuter.disable();
            }
            return this;
        };
        Choices.prototype.highlightItem = function (item, runEvent) {
            if (runEvent === void 0) { runEvent = true; }
            if (!item || !item.id) {
                return this;
            }
            var choice = this._store.items.find(function (c) { return c.id === item.id; });
            if (!choice || choice.highlighted) {
                return this;
            }
            this._store.dispatch(highlightItem(choice, true));
            if (runEvent) {
                this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.unhighlightItem = function (item, runEvent) {
            if (runEvent === void 0) { runEvent = true; }
            if (!item || !item.id) {
                return this;
            }
            var choice = this._store.items.find(function (c) { return c.id === item.id; });
            if (!choice || !choice.highlighted) {
                return this;
            }
            this._store.dispatch(highlightItem(choice, false));
            if (runEvent) {
                this.passedElement.triggerEvent(EventType.unhighlightItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.highlightAll = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.forEach(function (item) {
                    if (!item.highlighted) {
                        _this._store.dispatch(highlightItem(item, true));
                        _this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(item));
                    }
                });
            });
            return this;
        };
        Choices.prototype.unhighlightAll = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.forEach(function (item) {
                    if (item.highlighted) {
                        _this._store.dispatch(highlightItem(item, false));
                        _this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(item));
                    }
                });
            });
            return this;
        };
        Choices.prototype.removeActiveItemsByValue = function (value) {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.filter(function (item) { return item.value === value; }).forEach(function (item) { return _this._removeItem(item); });
            });
            return this;
        };
        Choices.prototype.removeActiveItems = function (excludedId) {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.filter(function (_a) {
                    var id = _a.id;
                    return id !== excludedId;
                }).forEach(function (item) { return _this._removeItem(item); });
            });
            return this;
        };
        Choices.prototype.removeHighlightedItems = function (runEvent) {
            var _this = this;
            if (runEvent === void 0) { runEvent = false; }
            this._store.withTxn(function () {
                _this._store.highlightedActiveItems.forEach(function (item) {
                    _this._removeItem(item);
                    // If this action was performed by the user
                    // trigger the event
                    if (runEvent) {
                        _this._triggerChange(item.value);
                    }
                });
            });
            return this;
        };
        Choices.prototype.showDropdown = function (preventInputFocus) {
            var _this = this;
            if (this.dropdown.isActive) {
                return this;
            }
            if (preventInputFocus === undefined) {
                // eslint-disable-next-line no-param-reassign
                preventInputFocus = !this._canSearch;
            }
            requestAnimationFrame(function () {
                _this.dropdown.show();
                var rect = _this.dropdown.element.getBoundingClientRect();
                _this.containerOuter.open(rect.bottom, rect.height);
                if (!preventInputFocus) {
                    _this.input.focus();
                }
                _this.passedElement.triggerEvent(EventType.showDropdown);
                var activeElement = _this.choiceList.element.querySelector(getClassNamesSelector(_this.config.classNames.selectedState));
                if (activeElement !== null && !isScrolledIntoView(activeElement, _this.choiceList.element)) {
                    // We use the native scrollIntoView function instead of choiceList.scrollToChildElement to avoid animated scroll.
                    activeElement.scrollIntoView();
                }
            });
            return this;
        };
        Choices.prototype.hideDropdown = function (preventInputBlur) {
            var _this = this;
            if (!this.dropdown.isActive) {
                return this;
            }
            this._removeHighlightedChoices();
            requestAnimationFrame(function () {
                _this.dropdown.hide();
                _this.containerOuter.close();
                if (!preventInputBlur && _this._canSearch) {
                    _this.input.removeActiveDescendant();
                    _this.input.blur();
                }
                _this.passedElement.triggerEvent(EventType.hideDropdown);
            });
            return this;
        };
        Choices.prototype.getValue = function (valueOnly) {
            var values = this._store.items.map(function (item) {
                return (valueOnly ? item.value : getChoiceForOutput(item));
            });
            return this._isSelectOneElement || this.config.singleModeForMultiSelect ? values[0] : values;
        };
        Choices.prototype.setValue = function (items) {
            var _this = this;
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setValue');
                return this;
            }
            this._store.withTxn(function () {
                items.forEach(function (value) {
                    if (value) {
                        _this._addChoice(mapInputToChoice(value, false));
                    }
                });
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.setChoiceByValue = function (value) {
            var _this = this;
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setChoiceByValue');
                return this;
            }
            if (this._isTextElement) {
                return this;
            }
            this._store.withTxn(function () {
                // If only one value has been passed, convert to array
                var choiceValue = Array.isArray(value) ? value : [value];
                // Loop through each value and
                choiceValue.forEach(function (val) { return _this._findAndSelectChoiceByValue(val); });
                _this.unhighlightAll();
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        /**
         * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
         * a value field name and a label field name.
         * This behaves the same as passing items via the choices option but can be called after initialising Choices.
         * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
         * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
         *
         * **Input types affected:** select-one, select-multiple
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices([
         *   {value: 'One', label: 'Label One', disabled: true},
         *   {value: 'Two', label: 'Label Two', selected: true},
         *   {value: 'Three', label: 'Label Three'},
         * ], 'value', 'label', false);
         * ```
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices(async () => {
         *   try {
         *      const items = await fetch('/items');
         *      return items.json()
         *   } catch(err) {
         *      console.error(err)
         *   }
         * });
         * ```
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices([{
         *   label: 'Group one',
         *   id: 1,
         *   disabled: false,
         *   choices: [
         *     {value: 'Child One', label: 'Child One', selected: true},
         *     {value: 'Child Two', label: 'Child Two',  disabled: true},
         *     {value: 'Child Three', label: 'Child Three'},
         *   ]
         * },
         * {
         *   label: 'Group two',
         *   id: 2,
         *   disabled: false,
         *   choices: [
         *     {value: 'Child Four', label: 'Child Four', disabled: true},
         *     {value: 'Child Five', label: 'Child Five'},
         *     {value: 'Child Six', label: 'Child Six', customProperties: {
         *       description: 'Custom description about child six',
         *       random: 'Another random custom property'
         *     }},
         *   ]
         * }], 'value', 'label', false);
         * ```
         */
        Choices.prototype.setChoices = function (choicesArrayOrFetcher, value, label, replaceChoices, clearSearchFlag, replaceItems) {
            var _this = this;
            if (choicesArrayOrFetcher === void 0) { choicesArrayOrFetcher = []; }
            if (value === void 0) { value = 'value'; }
            if (label === void 0) { label = 'label'; }
            if (replaceChoices === void 0) { replaceChoices = false; }
            if (clearSearchFlag === void 0) { clearSearchFlag = true; }
            if (replaceItems === void 0) { replaceItems = false; }
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setChoices');
                return this;
            }
            if (!this._isSelectElement) {
                throw new TypeError("setChoices can't be used with INPUT based Choices");
            }
            if (typeof value !== 'string' || !value) {
                throw new TypeError("value parameter must be a name of 'value' field in passed objects");
            }
            if (typeof choicesArrayOrFetcher === 'function') {
                // it's a choices fetcher function
                var fetcher_1 = choicesArrayOrFetcher(this);
                if (typeof Promise === 'function' && fetcher_1 instanceof Promise) {
                    // that's a promise
                    // eslint-disable-next-line no-promise-executor-return
                    return new Promise(function (resolve) { return requestAnimationFrame(resolve); })
                        .then(function () { return _this._handleLoadingState(true); })
                        .then(function () { return fetcher_1; })
                        .then(function (data) {
                            return _this.setChoices(data, value, label, replaceChoices, clearSearchFlag, replaceItems);
                        })
                        .catch(function (err) {
                            if (!_this.config.silent) {
                                console.error(err);
                            }
                        })
                        .then(function () { return _this._handleLoadingState(false); })
                        .then(function () { return _this; });
                }
                // function returned something else than promise, let's check if it's an array of choices
                if (!Array.isArray(fetcher_1)) {
                    throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                }
                // recursion with results, it's sync and choices were cleared already
                return this.setChoices(fetcher_1, value, label, false);
            }
            if (!Array.isArray(choicesArrayOrFetcher)) {
                throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
            }
            this.containerOuter.removeLoadingState();
            this._store.withTxn(function () {
                if (clearSearchFlag) {
                    _this._isSearching = false;
                }
                // Clear choices if needed
                if (replaceChoices) {
                    _this.clearChoices(true, replaceItems);
                }
                var isDefaultValue = value === 'value';
                var isDefaultLabel = label === 'label';
                choicesArrayOrFetcher.forEach(function (groupOrChoice) {
                    if ('choices' in groupOrChoice) {
                        var group = groupOrChoice;
                        if (!isDefaultLabel) {
                            group = __assign(__assign({}, group), { label: group[label] });
                        }
                        _this._addGroup(mapInputToChoice(group, true));
                    }
                    else {
                        var choice = groupOrChoice;
                        if (!isDefaultLabel || !isDefaultValue) {
                            choice = __assign(__assign({}, choice), { value: choice[value], label: choice[label] });
                        }
                        var choiceFull = mapInputToChoice(choice, false);
                        _this._addChoice(choiceFull);
                        if (choiceFull.placeholder && !_this._hasNonChoicePlaceholder) {
                            _this._placeholderValue = unwrapStringForEscaped(choiceFull.label);
                        }
                    }
                });
                _this.unhighlightAll();
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.refresh = function (withEvents, selectFirstOption, deselectAll) {
            var _this = this;
            if (withEvents === void 0) { withEvents = false; }
            if (selectFirstOption === void 0) { selectFirstOption = false; }
            if (deselectAll === void 0) { deselectAll = false; }
            if (!this._isSelectElement) {
                if (!this.config.silent) {
                    console.warn('refresh method can only be used on choices backed by a <select> element');
                }
                return this;
            }
            this._store.withTxn(function () {
                var choicesFromOptions = _this.passedElement.optionsAsChoices();
                // Build the list of items which require preserving
                var existingItems = {};
                if (!deselectAll) {
                    _this._store.items.forEach(function (choice) {
                        if (choice.id && choice.active && choice.selected) {
                            existingItems[choice.value] = true;
                        }
                    });
                }
                _this.clearStore(false);
                var updateChoice = function (choice) {
                    if (deselectAll) {
                        _this._store.dispatch(removeItem$1(choice));
                    }
                    else if (existingItems[choice.value]) {
                        choice.selected = true;
                    }
                };
                choicesFromOptions.forEach(function (groupOrChoice) {
                    if ('choices' in groupOrChoice) {
                        groupOrChoice.choices.forEach(updateChoice);
                        return;
                    }
                    updateChoice(groupOrChoice);
                });
                /* @todo only generate add events for the added options instead of all
                if (withEvents) {
                  items.forEach((choice) => {
                    if (existingItems[choice.value]) {
                      this.passedElement.triggerEvent(
                        EventType.removeItem,
                        this._getChoiceForEvent(choice),
                      );
                    }
                  });
                }
                */
                // load new choices & items
                _this._addPredefinedChoices(choicesFromOptions, selectFirstOption, withEvents);
                // re-do search if required
                if (_this._isSearching) {
                    _this._searchChoices(_this.input.value);
                }
            });
            return this;
        };
        Choices.prototype.removeChoice = function (value) {
            var choice = this._store.choices.find(function (c) { return c.value === value; });
            if (!choice) {
                return this;
            }
            this._clearNotice();
            this._store.dispatch(removeChoice(choice));
            // @todo integrate with Store
            this._searcher.reset();
            if (choice.selected) {
                this.passedElement.triggerEvent(EventType.removeItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.clearChoices = function (clearOptions, clearItems) {
            var _this = this;
            if (clearOptions === void 0) { clearOptions = true; }
            if (clearItems === void 0) { clearItems = false; }
            if (clearOptions) {
                if (clearItems) {
                    this.passedElement.element.replaceChildren('');
                }
                else {
                    this.passedElement.element.querySelectorAll(':not([selected])').forEach(function (el) {
                        el.remove();
                    });
                }
            }
            this.itemList.element.replaceChildren('');
            this.choiceList.element.replaceChildren('');
            this._clearNotice();
            this._store.withTxn(function () {
                var items = clearItems ? [] : _this._store.items;
                _this._store.reset();
                items.forEach(function (item) {
                    _this._store.dispatch(addChoice(item));
                    _this._store.dispatch(addItem(item));
                });
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.clearStore = function (clearOptions) {
            if (clearOptions === void 0) { clearOptions = true; }
            this.clearChoices(clearOptions, true);
            this._stopSearch();
            this._lastAddedChoiceId = 0;
            this._lastAddedGroupId = 0;
            return this;
        };
        Choices.prototype.clearInput = function () {
            var shouldSetInputWidth = !this._isSelectOneElement;
            this.input.clear(shouldSetInputWidth);
            this._stopSearch();
            return this;
        };
        Choices.prototype._validateConfig = function () {
            var config = this.config;
            var invalidConfigOptions = diff(config, DEFAULT_CONFIG);
            if (invalidConfigOptions.length) {
                console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
            }
            if (config.allowHTML && config.allowHtmlUserInput) {
                if (config.addItems) {
                    console.warn('Warning: allowHTML/allowHtmlUserInput/addItems all being true is strongly not recommended and may lead to XSS attacks');
                }
                if (config.addChoices) {
                    console.warn('Warning: allowHTML/allowHtmlUserInput/addChoices all being true is strongly not recommended and may lead to XSS attacks');
                }
            }
        };
        Choices.prototype._render = function (changes) {
            if (changes === void 0) { changes = { choices: true, groups: true, items: true }; }
            if (this._store.inTxn()) {
                return;
            }
            if (this._isSelectElement) {
                if (changes.choices || changes.groups) {
                    this._renderChoices();
                }
            }
            if (changes.items) {
                this._renderItems();
            }
        };
        Choices.prototype._renderChoices = function () {
            var _this = this;
            if (!this._canAddItems()) {
                return; // block rendering choices if the input limit is reached.
            }
            var _a = this, config = _a.config, isSearching = _a._isSearching;
            var _b = this._store, activeGroups = _b.activeGroups, activeChoices = _b.activeChoices;
            var renderLimit = isSearching ? config.searchResultLimit : config.renderChoiceLimit;
            if (this._isSelectElement) {
                var backingOptions = activeChoices.filter(function (choice) { return !choice.element; });
                if (backingOptions.length) {
                    this.passedElement.addOptions(backingOptions);
                }
            }
            var fragment = document.createDocumentFragment();
            var renderableChoices = function (choices) {
                return choices.filter(function (choice) {
                    return !choice.placeholder &&
                        (isSearching
                            ? (config.searchRenderSelectedChoices || !choice.selected) && !!choice.rank
                            : config.renderSelectedChoices || !choice.selected);
                });
            };
            var showLabel = config.appendGroupInSearch && isSearching;
            var selectableChoices = false;
            var highlightedEl = null;
            var renderChoices = function (choices, withinGroup) {
                if (isSearching) {
                    // sortByRank is used to ensure stable sorting, as scores are non-unique
                    // this additionally ensures fuseOptions.sortFn is not ignored
                    choices.sort(sortByRank);
                }
                else if (config.shouldSort) {
                    choices.sort(config.sorter);
                }
                var choiceLimit = choices.length;
                choiceLimit = !withinGroup && renderLimit > 0 && choiceLimit > renderLimit ? renderLimit : choiceLimit;
                choiceLimit--;
                choices.every(function (choice, index) {
                    // choiceEl being empty signals the contents has probably significantly changed
                    var dropdownItem = choice.choiceEl ||
                        _this._templates.choice(config, choice, config.itemSelectText, showLabel && choice.group ? choice.group.label : undefined);
                    choice.choiceEl = dropdownItem;
                    fragment.appendChild(dropdownItem);
                    if (isSearching || !choice.selected) {
                        selectableChoices = true;
                    }
                    else if (!highlightedEl) {
                        highlightedEl = dropdownItem;
                    }
                    return index < choiceLimit;
                });
            };
            if (activeChoices.length) {
                if (config.resetScrollPosition) {
                    requestAnimationFrame(function () { return _this.choiceList.scrollToTop(); });
                }
                if (!this._hasNonChoicePlaceholder && !isSearching && this._isSelectOneElement) {
                    // If we have a placeholder choice along with groups
                    renderChoices(activeChoices.filter(function (choice) { return choice.placeholder && !choice.group; }), false);
                }
                // If we have grouped options
                if (activeGroups.length && !isSearching) {
                    if (config.shouldSort) {
                        activeGroups.sort(config.sorter);
                    }
                    // render Choices without group first, regardless of sort, otherwise they won't be distinguishable
                    // from the last group
                    renderChoices(activeChoices.filter(function (choice) { return !choice.placeholder && !choice.group; }), false);
                    activeGroups.forEach(function (group) {
                        var groupChoices = renderableChoices(group.choices);
                        if (groupChoices.length) {
                            if (group.label) {
                                var dropdownGroup = group.groupEl || _this._templates.choiceGroup(_this.config, group);
                                group.groupEl = dropdownGroup;
                                dropdownGroup.remove();
                                fragment.appendChild(dropdownGroup);
                            }
                            renderChoices(groupChoices, true);
                        }
                    });
                }
                else {
                    renderChoices(renderableChoices(activeChoices), false);
                }
            }
            if (!selectableChoices && (isSearching || !fragment.children.length || !config.renderSelectedChoices)) {
                if (!this._notice) {
                    this._notice = {
                        text: resolveStringFunction(isSearching ? config.noResultsText : config.noChoicesText),
                        type: isSearching ? NoticeTypes.noResults : NoticeTypes.noChoices,
                    };
                }
                fragment.replaceChildren('');
            }
            this._renderNotice(fragment);
            this.choiceList.element.replaceChildren(fragment);
            this._highlightChoice(highlightedEl);
        };
        Choices.prototype._renderItems = function () {
            var _this = this;
            var items = this._store.items || [];
            var itemList = this.itemList.element;
            var config = this.config;
            var fragment = document.createDocumentFragment();
            var itemFromList = function (item) {
                return itemList.querySelector("[data-item][data-id=\"".concat(item.id, "\"]"));
            };
            var addItemToFragment = function (item) {
                var el = item.itemEl;
                if (el && el.parentElement) {
                    return;
                }
                el = itemFromList(item) || _this._templates.item(config, item, config.removeItemButton);
                item.itemEl = el;
                fragment.appendChild(el);
            };
            // new items
            items.forEach(addItemToFragment);
            var addedItems = !!fragment.childNodes.length;
            if (this._isSelectOneElement) {
                var existingItems = itemList.children.length;
                if (addedItems || existingItems > 1) {
                    var placeholder = itemList.querySelector(getClassNamesSelector(config.classNames.placeholder));
                    if (placeholder) {
                        placeholder.remove();
                    }
                }
                else if (!addedItems && !existingItems && this._placeholderValue) {
                    addedItems = true;
                    addItemToFragment(mapInputToChoice({
                        selected: true,
                        value: '',
                        label: this._placeholderValue,
                        placeholder: true,
                    }, false));
                }
            }
            if (addedItems) {
                itemList.append(fragment);
                if (config.shouldSortItems && !this._isSelectOneElement) {
                    items.sort(config.sorter);
                    // push sorting into the DOM
                    items.forEach(function (item) {
                        var el = itemFromList(item);
                        if (el) {
                            el.remove();
                            fragment.append(el);
                        }
                    });
                    itemList.append(fragment);
                }
            }
            if (this._isTextElement) {
                // Update the value of the hidden input
                this.passedElement.value = items.map(function (_a) {
                    var value = _a.value;
                    return value;
                }).join(config.delimiter);
            }
        };
        Choices.prototype._displayNotice = function (text, type, openDropdown) {
            if (openDropdown === void 0) { openDropdown = true; }
            var oldNotice = this._notice;
            if (oldNotice &&
                ((oldNotice.type === type && oldNotice.text === text) ||
                    (oldNotice.type === NoticeTypes.addChoice &&
                        (type === NoticeTypes.noResults || type === NoticeTypes.noChoices)))) {
                if (openDropdown) {
                    this.showDropdown(true);
                }
                return;
            }
            this._clearNotice();
            this._notice = text
                ? {
                    text: text,
                    type: type,
                }
                : undefined;
            this._renderNotice();
            if (openDropdown && text) {
                this.showDropdown(true);
            }
        };
        Choices.prototype._clearNotice = function () {
            if (!this._notice) {
                return;
            }
            var noticeElement = this.choiceList.element.querySelector(getClassNamesSelector(this.config.classNames.notice));
            if (noticeElement) {
                noticeElement.remove();
            }
            this._notice = undefined;
        };
        Choices.prototype._renderNotice = function (fragment) {
            var noticeConf = this._notice;
            if (noticeConf) {
                var notice = this._templates.notice(this.config, noticeConf.text, noticeConf.type);
                if (fragment) {
                    fragment.append(notice);
                }
                else {
                    this.choiceList.prepend(notice);
                }
            }
        };
        /**
         * @deprecated Use utils.getChoiceForOutput
         */
        // eslint-disable-next-line class-methods-use-this
        Choices.prototype._getChoiceForOutput = function (choice, keyCode) {
            return getChoiceForOutput(choice, keyCode);
        };
        Choices.prototype._triggerChange = function (value) {
            if (value === undefined || value === null) {
                return;
            }
            this.passedElement.triggerEvent(EventType.change, {
                value: value,
            });
        };
        Choices.prototype._handleButtonAction = function (element) {
            var _this = this;
            var items = this._store.items;
            if (!items.length || !this.config.removeItems || !this.config.removeItemButton) {
                return;
            }
            var id = element && parseDataSetId(element.closest('[data-id]'));
            var itemToRemove = id && items.find(function (item) { return item.id === id; });
            if (!itemToRemove) {
                return;
            }
            this._store.withTxn(function () {
                // Remove item associated with button
                _this._removeItem(itemToRemove);
                _this._triggerChange(itemToRemove.value);
                if (_this._isSelectOneElement && !_this._hasNonChoicePlaceholder) {
                    var placeholderChoice = (_this.config.shouldSort ? _this._store.choices.reverse() : _this._store.choices).find(function (choice) { return choice.placeholder; });
                    if (placeholderChoice) {
                        _this._addItem(placeholderChoice);
                        _this.unhighlightAll();
                        if (placeholderChoice.value) {
                            _this._triggerChange(placeholderChoice.value);
                        }
                    }
                }
            });
        };
        Choices.prototype._handleItemAction = function (element, hasShiftKey) {
            var _this = this;
            if (hasShiftKey === void 0) { hasShiftKey = false; }
            var items = this._store.items;
            if (!items.length || !this.config.removeItems || this._isSelectOneElement) {
                return;
            }
            var id = parseDataSetId(element);
            if (!id) {
                return;
            }
            // We only want to select one item with a click
            // so we deselect any items that aren't the target
            // unless shift is being pressed
            items.forEach(function (item) {
                if (item.id === id && !item.highlighted) {
                    _this.highlightItem(item);
                }
                else if (!hasShiftKey && item.highlighted) {
                    _this.unhighlightItem(item);
                }
            });
            // Focus input as without focus, a user cannot do anything with a
            // highlighted item
            this.input.focus();
        };
        Choices.prototype._handleChoiceAction = function (element) {
            var _this = this;
            // If we are clicking on an option
            var id = parseDataSetId(element);
            var choice = id && this._store.getChoiceById(id);
            if (!choice || choice.disabled) {
                return false;
            }
            var hasActiveDropdown = this.dropdown.isActive;
            if (!choice.selected) {
                if (!this._canAddItems()) {
                    return true; // causes _onEnterKey to early out
                }
                this._store.withTxn(function () {
                    _this._addItem(choice, true, true);
                    _this.clearInput();
                    _this.unhighlightAll();
                });
                this._triggerChange(choice.value);
            }
            // We want to close the dropdown if we are dealing with a single select box
            if (hasActiveDropdown && this.config.closeDropdownOnSelect) {
                this.hideDropdown(true);
                this.containerOuter.element.focus();
            }
            return true;
        };
        Choices.prototype._handleBackspace = function (items) {
            var config = this.config;
            if (!config.removeItems || !items.length) {
                return;
            }
            var lastItem = items[items.length - 1];
            var hasHighlightedItems = items.some(function (item) { return item.highlighted; });
            // If editing the last item is allowed and there are not other selected items,
            // we can edit the item value. Otherwise if we can remove items, remove all selected items
            if (config.editItems && !hasHighlightedItems && lastItem) {
                this.input.value = lastItem.value;
                this.input.setWidth();
                this._removeItem(lastItem);
                this._triggerChange(lastItem.value);
            }
            else {
                if (!hasHighlightedItems) {
                    // Highlight last item if none already highlighted
                    this.highlightItem(lastItem, false);
                }
                this.removeHighlightedItems(true);
            }
        };
        Choices.prototype._loadChoices = function () {
            var _a;
            var _this = this;
            var config = this.config;
            if (this._isTextElement) {
                // Assign preset items from passed object first
                this._presetChoices = config.items.map(function (e) { return mapInputToChoice(e, false); });
                // Add any values passed from attribute
                if (this.passedElement.value) {
                    var elementItems = this.passedElement.value
                        .split(config.delimiter)
                        .map(function (e) { return mapInputToChoice(e, false, _this.config.allowHtmlUserInput); });
                    this._presetChoices = this._presetChoices.concat(elementItems);
                }
                this._presetChoices.forEach(function (choice) {
                    choice.selected = true;
                });
            }
            else if (this._isSelectElement) {
                // Assign preset choices from passed object
                this._presetChoices = config.choices.map(function (e) { return mapInputToChoice(e, true); });
                // Create array of choices from option elements
                var choicesFromOptions = this.passedElement.optionsAsChoices();
                if (choicesFromOptions) {
                    (_a = this._presetChoices).push.apply(_a, choicesFromOptions);
                }
            }
        };
        Choices.prototype._handleLoadingState = function (setLoading) {
            if (setLoading === void 0) { setLoading = true; }
            var el = this.itemList.element;
            if (setLoading) {
                this.disable();
                this.containerOuter.addLoadingState();
                if (this._isSelectOneElement) {
                    el.replaceChildren(this._templates.placeholder(this.config, this.config.loadingText));
                }
                else {
                    this.input.placeholder = this.config.loadingText;
                }
            }
            else {
                this.enable();
                this.containerOuter.removeLoadingState();
                if (this._isSelectOneElement) {
                    el.replaceChildren('');
                    this._render();
                }
                else {
                    this.input.placeholder = this._placeholderValue || '';
                }
            }
        };
        Choices.prototype._handleSearch = function (value) {
            if (!this.input.isFocussed) {
                return;
            }
            // Check that we have a value to search and the input was an alphanumeric character
            if (value !== null && typeof value !== 'undefined' && value.length >= this.config.searchFloor) {
                var resultCount = this.config.searchChoices ? this._searchChoices(value) : 0;
                if (resultCount !== null) {
                    // Trigger search event
                    this.passedElement.triggerEvent(EventType.search, {
                        value: value,
                        resultCount: resultCount,
                    });
                }
            }
            else if (this._store.choices.some(function (option) { return !option.active; })) {
                this._stopSearch();
            }
        };
        Choices.prototype._canAddItems = function () {
            var config = this.config;
            var maxItemCount = config.maxItemCount, maxItemText = config.maxItemText;
            if (!config.singleModeForMultiSelect && maxItemCount > 0 && maxItemCount <= this._store.items.length) {
                this.choiceList.element.replaceChildren('');
                this._notice = undefined;
                this._displayNotice(typeof maxItemText === 'function' ? maxItemText(maxItemCount) : maxItemText, NoticeTypes.addChoice);
                return false;
            }
            if (this._notice && this._notice.type === NoticeTypes.addChoice) {
                this._clearNotice();
            }
            return true;
        };
        Choices.prototype._canCreateItem = function (value) {
            var config = this.config;
            var canAddItem = true;
            var notice = '';
            if (canAddItem && typeof config.addItemFilter === 'function' && !config.addItemFilter(value)) {
                canAddItem = false;
                notice = resolveNoticeFunction(config.customAddItemText, value, undefined);
            }
            if (canAddItem) {
                var foundChoice = this._store.choices.find(function (choice) { return config.valueComparer(choice.value, value); });
                if (foundChoice) {
                    if (this._isSelectElement) {
                        // for exact matches, do not prompt to add it as a custom choice
                        this._displayNotice('', NoticeTypes.addChoice);
                        return false;
                    }
                    if (!config.duplicateItemsAllowed) {
                        canAddItem = false;
                        notice = resolveNoticeFunction(config.uniqueItemText, value, undefined);
                    }
                }
            }
            if (canAddItem) {
                notice = resolveNoticeFunction(config.addItemText, value, undefined);
            }
            if (notice) {
                this._displayNotice(notice, NoticeTypes.addChoice);
            }
            return canAddItem;
        };
        Choices.prototype._searchChoices = function (value) {
            var newValue = value.trim().replace(/\s{2,}/, ' ');
            // signal input didn't change search
            if (!newValue.length || newValue === this._currentValue) {
                return null;
            }
            var searcher = this._searcher;
            if (searcher.isEmptyIndex()) {
                searcher.index(this._store.searchableChoices);
            }
            // If new value matches the desired length and is not the same as the current value with a space
            var results = searcher.search(newValue);
            this._currentValue = newValue;
            this._highlightPosition = 0;
            this._isSearching = true;
            var notice = this._notice;
            var noticeType = notice && notice.type;
            if (noticeType !== NoticeTypes.addChoice) {
                if (!results.length) {
                    this._displayNotice(resolveStringFunction(this.config.noResultsText), NoticeTypes.noResults);
                }
                else {
                    this._clearNotice();
                }
            }
            this._store.dispatch(filterChoices(results));
            return results.length;
        };
        Choices.prototype._stopSearch = function () {
            if (this._isSearching) {
                this._currentValue = '';
                this._isSearching = false;
                this._clearNotice();
                this._store.dispatch(activateChoices(true));
                this.passedElement.triggerEvent(EventType.search, {
                    value: '',
                    resultCount: 0,
                });
            }
        };
        Choices.prototype._addEventListeners = function () {
            var documentElement = this._docRoot;
            var outerElement = this.containerOuter.element;
            var inputElement = this.input.element;
            var passedElement = this.passedElement.element;
            // capture events - can cancel event processing or propagation
            documentElement.addEventListener('touchend', this._onTouchEnd, true);
            outerElement.addEventListener('keydown', this._onKeyDown, true);
            outerElement.addEventListener('mousedown', this._onMouseDown, true);
            // passive events - doesn't call `preventDefault` or `stopPropagation`
            documentElement.addEventListener('click', this._onClick, { passive: true });
            documentElement.addEventListener('touchmove', this._onTouchMove, {
                passive: true,
            });
            this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                passive: true,
            });
            if (this._isSelectOneElement) {
                outerElement.addEventListener('focus', this._onFocus, {
                    passive: true,
                });
                outerElement.addEventListener('blur', this._onBlur, {
                    passive: true,
                });
            }
            inputElement.addEventListener('keyup', this._onKeyUp, {
                passive: true,
            });
            inputElement.addEventListener('input', this._onInput, {
                passive: true,
            });
            inputElement.addEventListener('focus', this._onFocus, {
                passive: true,
            });
            inputElement.addEventListener('blur', this._onBlur, {
                passive: true,
            });
            if (inputElement.form) {
                inputElement.form.addEventListener('reset', this._onFormReset, {
                    passive: true,
                });
            }
            if (passedElement.hasAttribute('required')) {
                passedElement.addEventListener('change', this._onChange, {
                    passive: true,
                });
                passedElement.addEventListener('invalid', this._onInvalid, {
                    passive: true,
                });
            }
            this.input.addEventListeners();
        };
        Choices.prototype._removeEventListeners = function () {
            var documentElement = this._docRoot;
            var outerElement = this.containerOuter.element;
            var inputElement = this.input.element;
            var passedElement = this.passedElement.element;
            documentElement.removeEventListener('touchend', this._onTouchEnd, true);
            outerElement.removeEventListener('keydown', this._onKeyDown, true);
            outerElement.removeEventListener('mousedown', this._onMouseDown, true);
            documentElement.removeEventListener('click', this._onClick);
            documentElement.removeEventListener('touchmove', this._onTouchMove);
            this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
            if (this._isSelectOneElement) {
                outerElement.removeEventListener('focus', this._onFocus);
                outerElement.removeEventListener('blur', this._onBlur);
            }
            inputElement.removeEventListener('keyup', this._onKeyUp);
            inputElement.removeEventListener('input', this._onInput);
            inputElement.removeEventListener('focus', this._onFocus);
            inputElement.removeEventListener('blur', this._onBlur);
            if (inputElement.form) {
                inputElement.form.removeEventListener('reset', this._onFormReset);
            }
            if (passedElement.hasAttribute('required')) {
                passedElement.removeEventListener('change', this._onChange);
                passedElement.removeEventListener('invalid', this._onInvalid);
            }
            this.input.removeEventListeners();
        };
        Choices.prototype._onKeyDown = function (event) {
            var keyCode = event.keyCode;
            var hasActiveDropdown = this.dropdown.isActive;
            /*
            See:
            https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
            https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
            https://en.wikipedia.org/wiki/UTF-16#Code_points_from_U+010000_to_U+10FFFF - UTF-16 surrogate pairs
            https://stackoverflow.com/a/70866532 - "Unidentified" for mobile
            http://www.unicode.org/versions/Unicode5.2.0/ch16.pdf#G19635 - U+FFFF is reserved (Section 16.7)

            Logic: when a key event is sent, `event.key` represents its printable value _or_ one
            of a large list of special values indicating meta keys/functionality. In addition,
            key events for compose functionality contain a value of `Dead` when mid-composition.

            I can't quite verify it, but non-English IMEs may also be able to generate key codes
            for code points in the surrogate-pair range, which could potentially be seen as having
            key.length > 1. Since `Fn` is one of the special keys, we can't distinguish by that
            alone.

            Here, key.length === 1 means we know for sure the input was printable and not a special
            `key` value. When the length is greater than 1, it could be either a printable surrogate
            pair or a special `key` value. We can tell the difference by checking if the _character
            code_ value (not code point!) is in the "surrogate pair" range or not.

            We don't use .codePointAt because an invalid code point would return 65535, which wouldn't
            pass the >= 0x10000 check we would otherwise use.

            > ...The Unicode Standard sets aside 66 noncharacter code points. The last two code points
            > of each plane are noncharacters: U+FFFE and U+FFFF on the BMP...
            */
            var wasPrintableChar = event.key.length === 1 ||
                (event.key.length === 2 && event.key.charCodeAt(0) >= 0xd800) ||
                event.key === 'Unidentified';
            /*
              We do not show the dropdown if focusing out with esc or navigating through input fields.
              An activated search can still be opened with any other key.
             */
            if (!this._isTextElement &&
                !hasActiveDropdown &&
                keyCode !== KeyCodeMap.ESC_KEY &&
                keyCode !== KeyCodeMap.TAB_KEY &&
                keyCode !== KeyCodeMap.SHIFT_KEY) {
                this.showDropdown();
                if (!this.input.isFocussed && wasPrintableChar) {
                    /*
                      We update the input value with the pressed key as
                      the input was not focussed at the time of key press
                      therefore does not have the value of the key.
                    */
                    this.input.value += event.key;
                    // browsers interpret a space as pagedown
                    if (event.key === ' ') {
                        event.preventDefault();
                    }
                }
            }
            switch (keyCode) {
                case KeyCodeMap.A_KEY:
                    return this._onSelectKey(event, this.itemList.element.hasChildNodes());
                case KeyCodeMap.ENTER_KEY:
                    return this._onEnterKey(event, hasActiveDropdown);
                case KeyCodeMap.ESC_KEY:
                    return this._onEscapeKey(event, hasActiveDropdown);
                case KeyCodeMap.UP_KEY:
                case KeyCodeMap.PAGE_UP_KEY:
                case KeyCodeMap.DOWN_KEY:
                case KeyCodeMap.PAGE_DOWN_KEY:
                    return this._onDirectionKey(event, hasActiveDropdown);
                case KeyCodeMap.DELETE_KEY:
                case KeyCodeMap.BACK_KEY:
                    return this._onDeleteKey(event, this._store.items, this.input.isFocussed);
            }
        };
        Choices.prototype._onKeyUp = function ( /* event: KeyboardEvent */) {
            this._canSearch = this.config.searchEnabled;
        };
        Choices.prototype._onInput = function ( /* event: InputEvent */) {
            var value = this.input.value;
            if (!value) {
                if (this._isTextElement) {
                    this.hideDropdown(true);
                }
                else {
                    this._stopSearch();
                }
                return;
            }
            if (!this._canAddItems()) {
                return;
            }
            if (this._canSearch) {
                // do the search even if the entered text can not be added
                this._handleSearch(value);
            }
            if (!this._canAddUserChoices) {
                return;
            }
            // determine if a notice needs to be displayed for why a search result can't be added
            this._canCreateItem(value);
            if (this._isSelectElement) {
                this._highlightPosition = 0; // reset to select the notice and/or exact match
                this._highlightChoice();
            }
        };
        Choices.prototype._onSelectKey = function (event, hasItems) {
            // If CTRL + A or CMD + A have been pressed and there are items to select
            if ((event.ctrlKey || event.metaKey) && hasItems) {
                this._canSearch = false;
                var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                if (shouldHightlightAll) {
                    this.highlightAll();
                }
            }
        };
        Choices.prototype._onEnterKey = function (event, hasActiveDropdown) {
            var _this = this;
            var value = this.input.value;
            var target = event.target;
            event.preventDefault();
            if (target && target.hasAttribute('data-button')) {
                this._handleButtonAction(target);
                return;
            }
            if (!hasActiveDropdown) {
                if (this._isSelectElement || this._notice) {
                    this.showDropdown();
                }
                return;
            }
            var highlightedChoice = this.dropdown.element.querySelector(getClassNamesSelector(this.config.classNames.highlightedState));
            if (highlightedChoice && this._handleChoiceAction(highlightedChoice)) {
                return;
            }
            if (!target || !value) {
                this.hideDropdown(true);
                return;
            }
            if (!this._canAddItems()) {
                return;
            }
            var addedItem = false;
            this._store.withTxn(function () {
                addedItem = _this._findAndSelectChoiceByValue(value, true);
                if (!addedItem) {
                    if (!_this._canAddUserChoices) {
                        return;
                    }
                    if (!_this._canCreateItem(value)) {
                        return;
                    }
                    _this._addChoice(mapInputToChoice(value, false, _this.config.allowHtmlUserInput), true, true);
                    addedItem = true;
                }
                _this.clearInput();
                _this.unhighlightAll();
            });
            if (!addedItem) {
                return;
            }
            this._triggerChange(value);
            if (this.config.closeDropdownOnSelect) {
                this.hideDropdown(true);
            }
        };
        Choices.prototype._onEscapeKey = function (event, hasActiveDropdown) {
            if (hasActiveDropdown) {
                event.stopPropagation();
                this.hideDropdown(true);
                this._stopSearch();
                this.containerOuter.element.focus();
            }
        };
        Choices.prototype._onDirectionKey = function (event, hasActiveDropdown) {
            var keyCode = event.keyCode;
            // If up or down key is pressed, traverse through options
            if (hasActiveDropdown || this._isSelectOneElement) {
                this.showDropdown();
                this._canSearch = false;
                var directionInt = keyCode === KeyCodeMap.DOWN_KEY || keyCode === KeyCodeMap.PAGE_DOWN_KEY ? 1 : -1;
                var skipKey = event.metaKey || keyCode === KeyCodeMap.PAGE_DOWN_KEY || keyCode === KeyCodeMap.PAGE_UP_KEY;
                var nextEl = void 0;
                if (skipKey) {
                    if (directionInt > 0) {
                        nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                    }
                    else {
                        nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                    }
                }
                else {
                    var currentEl = this.dropdown.element.querySelector(getClassNamesSelector(this.config.classNames.highlightedState));
                    if (currentEl) {
                        nextEl = getAdjacentEl(currentEl, selectableChoiceIdentifier, directionInt);
                    }
                    else {
                        nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                    }
                }
                if (nextEl) {
                    // We prevent default to stop the cursor moving
                    // when pressing the arrow
                    if (!isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) {
                        this.choiceList.scrollToChildElement(nextEl, directionInt);
                    }
                    this._highlightChoice(nextEl);
                }
                // Prevent default to maintain cursor position whilst
                // traversing dropdown options
                event.preventDefault();
            }
        };
        Choices.prototype._onDeleteKey = function (event, items, hasFocusedInput) {
            // If backspace or delete key is pressed and the input has no value
            if (!this._isSelectOneElement && !event.target.value && hasFocusedInput) {
                this._handleBackspace(items);
                event.preventDefault();
            }
        };
        Choices.prototype._onTouchMove = function () {
            if (this._wasTap) {
                this._wasTap = false;
            }
        };
        Choices.prototype._onTouchEnd = function (event) {
            var target = (event || event.touches[0]).target;
            var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
            if (touchWasWithinContainer) {
                var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                if (containerWasExactTarget) {
                    if (this._isTextElement) {
                        this.input.focus();
                    }
                    else if (this._isSelectMultipleElement) {
                        this.showDropdown();
                    }
                }
                // Prevents focus event firing
                event.stopPropagation();
            }
            this._wasTap = true;
        };
        /**
         * Handles mousedown event in capture mode for containetOuter.element
         */
        Choices.prototype._onMouseDown = function (event) {
            var target = event.target;
            if (!(target instanceof Element)) {
                return;
            }
            // If we have our mouse down on the scrollbar and are on IE11...
            if (IS_IE11 && this.choiceList.element.contains(target)) {
                // check if click was on a scrollbar area
                var firstChoice = this.choiceList.element.firstElementChild;
                this._isScrollingOnIe =
                    this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
            }
            if (target === this.input.element) {
                return;
            }
            var item = target.closest('[data-button],[data-item],[data-choice]');
            if (item instanceof HTMLElement) {
                if ('button' in item.dataset) {
                    this._handleButtonAction(item);
                }
                else if ('item' in item.dataset) {
                    this._handleItemAction(item, event.shiftKey);
                }
                else if ('choice' in item.dataset) {
                    this._handleChoiceAction(item);
                }
            }
            event.preventDefault();
        };
        /**
         * Handles mouseover event over this.dropdown
         * @param {MouseEvent} event
         */
        Choices.prototype._onMouseOver = function (_a) {
            var target = _a.target;
            if (target instanceof HTMLElement && 'choice' in target.dataset) {
                this._highlightChoice(target);
            }
        };
        Choices.prototype._onClick = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var clickWasWithinContainer = containerOuter.element.contains(target);
            if (clickWasWithinContainer) {
                if (!this.dropdown.isActive && !containerOuter.isDisabled) {
                    if (this._isTextElement) {
                        if (document.activeElement !== this.input.element) {
                            this.input.focus();
                        }
                    }
                    else {
                        this.showDropdown();
                        containerOuter.element.focus();
                    }
                }
                else if (this._isSelectOneElement &&
                    target !== this.input.element &&
                    !this.dropdown.element.contains(target)) {
                    this.hideDropdown();
                }
            }
            else {
                containerOuter.removeFocusState();
                this.hideDropdown(true);
                this.unhighlightAll();
            }
        };
        Choices.prototype._onFocus = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var focusWasWithinContainer = target && containerOuter.element.contains(target);
            if (!focusWasWithinContainer) {
                return;
            }
            var targetIsInput = target === this.input.element;
            if (this._isTextElement) {
                if (targetIsInput) {
                    containerOuter.addFocusState();
                }
            }
            else if (this._isSelectMultipleElement) {
                if (targetIsInput) {
                    this.showDropdown(true);
                    // If element is a select box, the focused element is the container and the dropdown
                    // isn't already open, focus and show dropdown
                    containerOuter.addFocusState();
                }
            }
            else {
                containerOuter.addFocusState();
                if (targetIsInput) {
                    this.showDropdown(true);
                }
            }
        };
        Choices.prototype._onBlur = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var blurWasWithinContainer = target && containerOuter.element.contains(target);
            if (blurWasWithinContainer && !this._isScrollingOnIe) {
                if (target === this.input.element) {
                    containerOuter.removeFocusState();
                    this.hideDropdown(true);
                    if (this._isTextElement || this._isSelectMultipleElement) {
                        this.unhighlightAll();
                    }
                }
                else if (target === this.containerOuter.element) {
                    // Remove the focus state when the past outerContainer was the target
                    containerOuter.removeFocusState();
                    // Also close the dropdown if search is disabled
                    if (!this.config.searchEnabled) {
                        this.hideDropdown(true);
                    }
                }
            }
            else {
                // On IE11, clicking the scollbar blurs our input and thus
                // closes the dropdown. To stop this, we refocus our input
                // if we know we are on IE *and* are scrolling.
                this._isScrollingOnIe = false;
                this.input.element.focus();
            }
        };
        Choices.prototype._onFormReset = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this.clearInput();
                _this.hideDropdown();
                _this.refresh(false, false, true);
                if (_this._initialItems.length) {
                    _this.setChoiceByValue(_this._initialItems);
                }
            });
        };
        Choices.prototype._onChange = function (event) {
            if (!event.target.checkValidity()) {
                return;
            }
            this.containerOuter.removeInvalidState();
        };
        Choices.prototype._onInvalid = function () {
            this.containerOuter.addInvalidState();
        };
        /**
         * Removes any highlighted choice options
         */
        Choices.prototype._removeHighlightedChoices = function () {
            var highlightedState = this.config.classNames.highlightedState;
            var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(getClassNamesSelector(highlightedState)));
            // Remove any highlighted choices
            highlightedChoices.forEach(function (choice) {
                removeClassesFromElement(choice, highlightedState);
                choice.setAttribute('aria-selected', 'false');
            });
        };
        Choices.prototype._highlightChoice = function (el) {
            if (el === void 0) { el = null; }
            var choices = Array.from(this.dropdown.element.querySelectorAll(selectableChoiceIdentifier));
            if (!choices.length) {
                return;
            }
            var passedEl = el;
            var highlightedState = this.config.classNames.highlightedState;
            this._removeHighlightedChoices();
            if (passedEl) {
                this._highlightPosition = choices.indexOf(passedEl);
            }
            else {
                // Highlight choice based on last known highlight location
                if (choices.length > this._highlightPosition) {
                    // If we have an option to highlight
                    passedEl = choices[this._highlightPosition];
                }
                else {
                    // Otherwise highlight the option before
                    passedEl = choices[choices.length - 1];
                }
                if (!passedEl) {
                    passedEl = choices[0];
                }
            }
            addClassesToElement(passedEl, highlightedState);
            passedEl.setAttribute('aria-selected', 'true');
            this.passedElement.triggerEvent(EventType.highlightChoice, {
                el: passedEl,
            });
            if (this.dropdown.isActive) {
                // IE11 ignores aria-label and blocks virtual keyboard
                // if aria-activedescendant is set without a dropdown
                this.input.setActiveDescendant(passedEl.id);
                this.containerOuter.setActiveDescendant(passedEl.id);
            }
        };
        Choices.prototype._addItem = function (item, withEvents, userTriggered) {
            if (withEvents === void 0) { withEvents = true; }
            if (userTriggered === void 0) { userTriggered = false; }
            if (!item.id) {
                throw new TypeError('item.id must be set before _addItem is called for a choice/item');
            }
            if (this.config.singleModeForMultiSelect || this._isSelectOneElement) {
                this.removeActiveItems(item.id);
            }
            this._store.dispatch(addItem(item));
            if (withEvents) {
                var eventChoice = getChoiceForOutput(item);
                this.passedElement.triggerEvent(EventType.addItem, eventChoice);
                if (userTriggered) {
                    this.passedElement.triggerEvent(EventType.choice, eventChoice);
                }
            }
        };
        Choices.prototype._removeItem = function (item) {
            if (!item.id) {
                return;
            }
            this._store.dispatch(removeItem$1(item));
            var notice = this._notice;
            if (notice && notice.type === NoticeTypes.noChoices) {
                this._clearNotice();
            }
            this.passedElement.triggerEvent(EventType.removeItem, getChoiceForOutput(item));
        };
        Choices.prototype._addChoice = function (choice, withEvents, userTriggered) {
            if (withEvents === void 0) { withEvents = true; }
            if (userTriggered === void 0) { userTriggered = false; }
            if (choice.id) {
                throw new TypeError('Can not re-add a choice which has already been added');
            }
            var config = this.config;
            if (!config.duplicateItemsAllowed && this._store.choices.find(function (c) { return config.valueComparer(c.value, choice.value); })) {
                return;
            }
            // Generate unique id, in-place update is required so chaining _addItem works as expected
            this._lastAddedChoiceId++;
            choice.id = this._lastAddedChoiceId;
            choice.elementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choice.id);
            var prependValue = config.prependValue, appendValue = config.appendValue;
            if (prependValue) {
                choice.value = prependValue + choice.value;
            }
            if (appendValue) {
                choice.value += appendValue.toString();
            }
            if ((prependValue || appendValue) && choice.element) {
                choice.element.value = choice.value;
            }
            this._clearNotice();
            this._store.dispatch(addChoice(choice));
            if (choice.selected) {
                this._addItem(choice, withEvents, userTriggered);
            }
        };
        Choices.prototype._addGroup = function (group, withEvents) {
            var _this = this;
            if (withEvents === void 0) { withEvents = true; }
            if (group.id) {
                throw new TypeError('Can not re-add a group which has already been added');
            }
            this._store.dispatch(addGroup(group));
            if (!group.choices) {
                return;
            }
            // add unique id for the group(s), and do not store the full list of choices in this group
            this._lastAddedGroupId++;
            group.id = this._lastAddedGroupId;
            group.choices.forEach(function (item) {
                item.group = group;
                if (group.disabled) {
                    item.disabled = true;
                }
                _this._addChoice(item, withEvents);
            });
        };
        Choices.prototype._createTemplates = function () {
            var _this = this;
            var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
            var userTemplates = {};
            if (typeof callbackOnCreateTemplates === 'function') {
                userTemplates = callbackOnCreateTemplates.call(this, strToEl, escapeForTemplate, getClassNames);
            }
            var templating = {};
            Object.keys(this._templates).forEach(function (name) {
                if (name in userTemplates) {
                    templating[name] = userTemplates[name].bind(_this);
                }
                else {
                    templating[name] = _this._templates[name].bind(_this);
                }
            });
            this._templates = templating;
        };
        Choices.prototype._createElements = function () {
            var templating = this._templates;
            var _a = this, config = _a.config, isSelectOneElement = _a._isSelectOneElement;
            var position = config.position, classNames = config.classNames;
            var elementType = this._elementType;
            this.containerOuter = new Container({
                element: templating.containerOuter(config, this._direction, this._isSelectElement, isSelectOneElement, config.searchEnabled, elementType, config.labelId),
                classNames: classNames,
                type: elementType,
                position: position,
            });
            this.containerInner = new Container({
                element: templating.containerInner(config),
                classNames: classNames,
                type: elementType,
                position: position,
            });
            this.input = new Input({
                element: templating.input(config, this._placeholderValue),
                classNames: classNames,
                type: elementType,
                preventPaste: !config.paste,
            });
            this.choiceList = new List({
                element: templating.choiceList(config, isSelectOneElement),
            });
            this.itemList = new List({
                element: templating.itemList(config, isSelectOneElement),
            });
            this.dropdown = new Dropdown({
                element: templating.dropdown(config),
                classNames: classNames,
                type: elementType,
            });
        };
        Choices.prototype._createStructure = function () {
            var _a = this, containerInner = _a.containerInner, containerOuter = _a.containerOuter, passedElement = _a.passedElement;
            var dropdownElement = this.dropdown.element;
            // Hide original element
            passedElement.conceal();
            // Wrap input in container preserving DOM ordering
            containerInner.wrap(passedElement.element);
            // Wrapper inner container with outer container
            containerOuter.wrap(containerInner.element);
            containerOuter.element.appendChild(containerInner.element);
            containerOuter.element.appendChild(dropdownElement);
            containerInner.element.appendChild(this.itemList.element);
            dropdownElement.appendChild(this.choiceList.element);
            if (this._isSelectOneElement) {
                this.input.placeholder = this.config.searchPlaceholderValue || '';
                if (this.config.searchEnabled) {
                    dropdownElement.insertBefore(this.input.element, dropdownElement.firstChild);
                }
            }
            else {
                if (!this._isSelectMultipleElement || this.config.searchEnabled) {
                    containerInner.element.appendChild(this.input.element);
                }
                if (this._placeholderValue) {
                    this.input.placeholder = this._placeholderValue;
                }
                this.input.setWidth();
            }
            this._highlightPosition = 0;
            this._isSearching = false;
        };
        Choices.prototype._initStore = function () {
            var _this = this;
            this._store.subscribe(this._render).withTxn(function () {
                _this._addPredefinedChoices(_this._presetChoices, _this._isSelectOneElement && !_this._hasNonChoicePlaceholder, false);
            });
            if (!this._store.choices.length || (this._isSelectOneElement && this._hasNonChoicePlaceholder)) {
                this._render();
            }
        };
        Choices.prototype._addPredefinedChoices = function (choices, selectFirstOption, withEvents) {
            var _this = this;
            if (selectFirstOption === void 0) { selectFirstOption = false; }
            if (withEvents === void 0) { withEvents = true; }
            if (selectFirstOption) {
                /**
                 * If there is a selected choice already or the choice is not the first in
                 * the array, add each choice normally.
                 *
                 * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
                 */
                var noSelectedChoices = choices.findIndex(function (choice) { return choice.selected; }) === -1;
                if (noSelectedChoices) {
                    choices.some(function (choice) {
                        if (choice.disabled || 'choices' in choice) {
                            return false;
                        }
                        choice.selected = true;
                        return true;
                    });
                }
            }
            choices.forEach(function (item) {
                if ('choices' in item) {
                    if (_this._isSelectElement) {
                        _this._addGroup(item, withEvents);
                    }
                }
                else {
                    _this._addChoice(item, withEvents);
                }
            });
        };
        Choices.prototype._findAndSelectChoiceByValue = function (value, userTriggered) {
            var _this = this;
            if (userTriggered === void 0) { userTriggered = false; }
            // Check 'value' property exists and the choice isn't already selected
            var foundChoice = this._store.choices.find(function (choice) { return _this.config.valueComparer(choice.value, value); });
            if (foundChoice && !foundChoice.disabled && !foundChoice.selected) {
                this._addItem(foundChoice, true, userTriggered);
                return true;
            }
            return false;
        };
        Choices.prototype._generatePlaceholderValue = function () {
            var config = this.config;
            if (!config.placeholder) {
                return null;
            }
            if (this._hasNonChoicePlaceholder) {
                return config.placeholderValue;
            }
            if (this._isSelectElement) {
                var placeholderOption = this.passedElement.placeholderOption;
                return placeholderOption ? placeholderOption.text : null;
            }
            return null;
        };
        Choices.prototype._warnChoicesInitFailed = function (caller) {
            if (this.config.silent) {
                return;
            }
            if (!this.initialised) {
                throw new TypeError("".concat(caller, " called on a non-initialised instance of Choices"));
            }
            else if (!this.initialisedOK) {
                throw new TypeError("".concat(caller, " called for an element which has multiple instances of Choices initialised on it"));
            }
        };
        Choices.version = '11.2.0';
        return Choices;
    }());

    return Choices;

}));

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright ÂŠ 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
	{
		easeOutExpo: function (x, t, b, c, d) {
			return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		}
	});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright ÂŠ 2001 Robert Penner
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
 */

(function () { 'use strict';

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
    function getSqDist(p1, p2) {

        var dx = p1.x - p2.x,
            dy = p1.y - p2.y;

        return dx * dx + dy * dy;
    }

// square distance from a point to a segment
    function getSqSegDist(p, p1, p2) {

        var x = p1.x,
            y = p1.y,
            dx = p2.x - x,
            dy = p2.y - y;

        if (dx !== 0 || dy !== 0) {

            var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

            if (t > 1) {
                x = p2.x;
                y = p2.y;

            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }

        dx = p.x - x;
        dy = p.y - y;

        return dx * dx + dy * dy;
    }
// rest of the code doesn't care about point format

// basic distance-based simplification
    function simplifyRadialDist(points, sqTolerance) {

        var prevPoint = points[0],
            newPoints = [prevPoint],
            point;

        for (var i = 1, len = points.length; i < len; i++) {
            point = points[i];

            if (getSqDist(point, prevPoint) > sqTolerance) {
                newPoints.push(point);
                prevPoint = point;
            }
        }

        if (prevPoint !== point) newPoints.push(point);

        return newPoints;
    }

    function simplifyDPStep(points, first, last, sqTolerance, simplified) {
        var maxSqDist = sqTolerance,
            index;

        for (var i = first + 1; i < last; i++) {
            var sqDist = getSqSegDist(points[i], points[first], points[last]);

            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }

        if (maxSqDist > sqTolerance) {
            if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
            simplified.push(points[index]);
            if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
        }
    }

// simplification using Ramer-Douglas-Peucker algorithm
    function simplifyDouglasPeucker(points, sqTolerance) {
        var last = points.length - 1;

        var simplified = [points[0]];
        simplifyDPStep(points, 0, last, sqTolerance, simplified);
        simplified.push(points[last]);

        return simplified;
    }

// both algorithms combined for awesome performance
    function simplify(points, tolerance, highestQuality) {

        if (points.length <= 2) return points;

        var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

        points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
        points = simplifyDouglasPeucker(points, sqTolerance);

        return points;
    }

    window.simplify = simplify;

})();
(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *		 the user visible viewport of a web browser.
     *		 only accounts for vertical position, not horizontal.
     */
    $.fn.visible = function(partial){

        var $t				= $(this),
            $w				= $(window),
            viewTop			= $w.scrollTop(),
            viewBottom		= viewTop + $w.height(),
            _top			= $t.offset().top,
            _bottom			= _top + $t.height(),
            compareTop		= partial === true ? _bottom : _top,
            compareBottom	= partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

})(jQuery);
;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	 *
	 * @type boolean
	 */
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}

				break;
			case 'input':

				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}

				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
					case 'button':
					case 'checkbox':
					case 'file':
					case 'image':
					case 'radio':
					case 'submit':
						return false;
				}

				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

				// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

		// AMD. Register as an anonymous module.
		define(function() {
			return FastClick;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());
APP.Calculator.Keyboard = (function () {
    var exports = {},

        CALCULATE_SERVICE = '/en-US/service/calculate',

        previousCalculator = false,
        $keyBoard = null,
        $editCta,
        initialized = false,
        activeCalculator,
        keyboardHideTimer = null,
        keyboardHideDuration = 70,

        preventHideKeyboard = false,
        lastUsedCalc,

        isMouseDown = false;

    function init() {
        preventHideKeyboard = false;
        $editCta = $body.find('[data-input-edit-cta]');
        if (!initialized) {
            initialized = true;
            $keyBoard = $body.find('[data-keyboard]');
            $body.find('[data-keyboard="desktop"]').html(
                APP.Tpl.run('keyboard/desktop') +
                APP.Tpl.run('keyboard/5th') +
                APP.Tpl.run('keyboard/symbol')
            );
            $body.find('[data-keyboard="device"]').html(
                APP.Tpl.run('keyboard/device') +
                APP.Tpl.run('keyboard/5th-device') +
                APP.Tpl.run('keyboard/symbol-device')
            );
            $body.find('[data-keyboard="qwerty"]').html(APP.Tpl.run('keyboard/qwerty'));
            $body.find('[data-keyboard="qwerty-uppercase"]').html(APP.Tpl.run('keyboard/qwerty-uppercase'));
            initBindings();
        }
        setUpKeyboardDisables();
        setUpExtraButtons();
    }

    function setUpKeyboardDisables() {
        var soons = $body.find('[data-keyboard-soons]').first().attr('data-keyboard-soons'),
            panels = soons ? soons.split(';') : [],
            title = $body.find('[data-keyboard-soon-title]').attr('data-keyboard-soon-title'),
            mode = $body.find('[data-keyboard-mode]').val();

        $body.find('[data-keyboard-var]').hide();
        $body.find('[data-keyboard-alert][data-keyboard-action]').removeAttr('data-keyboard-alert');

        if (mode) {
            $body.find('[data-keyboard-var="' + mode + '"]').show();
        } else {
            $body.find('[data-keyboard-var="default"]').show();
        }

        panels.forEach(function (formula) {
            $body.find('[data-keyboard-action="' + formula + '"], [data-keyboard-action="' + formula + ':inverse"]')
                .attr('data-keyboard-alert', title);
        });

        if ([
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            || navigator.userAgent.includes('Android')
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
            $body.find('[data-calculator-focus-hunter]').attr('readonly', 'readonly');
        }
    }

    function setUpExtraButtons() {
        var extraButtons = [];

        try {
            extraButtons = JSON.parse($body.find('[data-extra-buttons]').attr('data-extra-buttons')) || [];
        } catch (e) {
        }

        $body.find('[data-keyboard="extra-buttons"]').html(APP.Tpl.run('keyboard/extra-buttons', extraButtons));

    }

    function initBindings() {
        $document.on('mouseup', function () {
            isMouseDown = false;
            setTimeout(function () {
                if (!activeCalculator) {
                    hideKeyboard();
                } else {
                    activeCalculator.addFocus();
                }
            }, 20);
        });

        $document.on('mousedown', function () {
            isMouseDown = true;
            previousCalculator = activeCalculator;
            activeCalculator = false;
        });

        $keyBoard.on('mouseup', function () {
            isMouseDown = false;
            activeCalculator = previousCalculator;
        });

        $body.on('mouseup mousedown click select', '[data-calculator]', function (e) {
            activeCalculator = activeCalculator || previousCalculator;
            e.preventDefault();
        });

        $body.on('click', '[data-calculator]', function (e) {
            var $this = $(this);

            $this.find('[data-calculator-focus-hunter]').focus();
        });

        $body.on('click', '[data-keyboard-character]', function (e) {
            e.stopPropagation();
            if (lastUsedCalc) {
                var character = $(this).attr('data-keyboard-character');

                lastUsedCalc.addString(character);
                APP.Analytics.trackEvent('keyboard', 'press', 'character', {character: character});
            }
        });

        $keyBoard.find('[data-keyboard-action]').on('click', function (e) {
            var $this = $(this);

            e.stopPropagation();
            if (lastUsedCalc && !$this.attr('data-keyboard-alert')) {
                var action = $this.attr('data-keyboard-action');
                lastUsedCalc.addFormula(action);
                APP.Analytics.trackEvent('keyboard', 'press', 'action', {action: action});
            }
        });

        $body.on('click', '[data-keyboard-alert]', function (e) {
            APP.Layout.alert($(this).attr('data-keyboard-alert'), false, function () {
                if (lastUsedCalc) {
                    lastUsedCalc.addFocus();
                }
            });
            if (activeCalculator) {
                activeCalculator.addFocus();
            }
        });

        $keyBoard.find('[data-keyboard-method]').on('click', function () {
            if (lastUsedCalc) {
                var method = $(this).attr('data-keyboard-method');
                lastUsedCalc.addHotKey(method);
                APP.Analytics.trackEvent('keyboard', 'press', 'method', {method: method});
            }
        });

        $keyBoard.find('[data-keyboard-calculate]').on('click', submit);

        $body.find('[data-scroll-to-input]').on('click', scrollToDashboardInput);

        $body.on('click', '[data-input-edit-cta]', function () {
            $body.find('[data-calculator-focus-hunter]').focus();
        });

        $body.on('click', '[data-keyboard-qwerty]', function () {
            if (lastUsedCalc) {
                $body.addClass('qwerty');
                $body.removeClass('qwerty-uppercase');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-keyboard-qwerty-uppercase]', function () {
            if (lastUsedCalc) {
                $body.addClass('qwerty-uppercase');
                $body.removeClass('qwerty');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-keyboard-normal]', function () {
            if (lastUsedCalc) {
                $body.removeClass('qwerty-uppercase');
                $body.removeClass('qwerty');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-close-input]', function () {
            hideKeyboard(true);
        });

        virtualKeyboardDetector.on('virtualKeyboardVisible', function () {
            var $hunter = $body.find('[data-calculator-focus-hunter]');
            $hunter.attr('readonly', 'readonly');
            $hunter.blur();
            scrollToDashboardInput(1);
        });

        $body.on('focus', '[data-calculator-focus-hunter]', function () {
            $body.find('[data-calculator-focus-hunter]').attr('autocomplete', 'off');
        });
    }

    function sendCalculatorContent(content) {
        APP.Ajax.post(CALCULATE_SERVICE, {input: content}).then(outputArrived, function () {
            APP.Error.showError();
            APP.Analytics.trackEvent('keyboard', 'submit', 'fail general');
        });
    }

    function outputArrived(result) {
        if (result.success) {
            APP.Analytics.trackEvent('keyboard', 'submit', 'success', JSON.stringify(activeCalculator && activeCalculator.getContent && activeCalculator.getContent()));
            APP.Page.applyPageByUrl('/en-US/problem/' + result.id);
        } else {
            APP.Analytics.trackEvent('keyboard', 'submit', 'fail', {error: result.error});
            APP.Error.showError();
        }
    }

    function displayError(error) {
        APP.Analytics.trackEvent('keyboard', 'displayError', error);
        APP.Layout.alert(error);
        APP.Layout.onOverlayClose(function () {
            $body.find('[data-calculator]').trigger('click');
        });
    }

    function showKeyboard(calculator) {
        init();
        clearTimeout(keyboardHideTimer);
        if (activeCalculator) {
            activeCalculator.exitCalculator();
        }
        if (lastUsedCalc) {
            lastUsedCalc.exitCalculator();
        }
        activeCalculator = lastUsedCalc = calculator;
        // console.log('SHOW KEYBOARD', activeCalculator, lastUsedCalc, calculator);
        if (!$keyBoard.hasClass('keyboard--show')) {
            APP.Analytics.trackEvent('keyboard', 'show');
            $keyBoard.addClass('keyboard--show');
            $body.addClass('application--show-keyboard');
            $body.find('[data-dashboard-input]').addClass('dashboard__card--active');
            $body.find('[data-dashboard-learn]').hide();
            $body.find('[data-keyboard-calculate] .text').text($body.find('[data-calculator-cta]').attr('data-calculator-cta'));
        }
    }

    function autoFocus() {
        if (lastUsedCalc) {
            showKeyboard(lastUsedCalc);
            lastUsedCalc.addFocus();
        }
    }

    function setActiveCalculator(calculator) {
        lastUsedCalc.exitCalculator();
        activeCalculator.exitCalculator();
        lastUsedCalc = activeCalculator = calculator;
    }

    function scrollToDashboardInput(time) {
        var $inputBox = $body.find('[data-dashboard-input]'),
            offset,
            top;

        if (!$keyBoard.hasClass('keyboard--show')) {
            setTimeout(function () {
                offset = $inputBox.offset();
                top = ((offset && offset.top) ? offset.top - 60 : 0) - 90;
                APP.Layout.scrollTo(top);
            }, parseInt(time, 10) || 300);
        }
    }

    function hideKeyboard(force) {
        if (force) {
            previousCalculator = activeCalculator;
            activeCalculator = false;
            previousCalculator && previousCalculator.hideCursor();
        }
        if (!force && (isMouseDown || preventHideKeyboard)) {
            return;
        }
        init();
        keyboardHideTimer = setTimeout(function () {
            if (!activeCalculator) {
                if ($keyBoard.hasClass('keyboard--show')) {
                    $keyBoard.removeClass('keyboard--show');
                    $body.removeClass('application--show-keyboard');
                    if (!$body.find('[data-calculator]').attr('data-sent') || $body.find('[name="question-id"]')) {
                        $body.find('[data-dashboard-input]').removeClass('dashboard__card--active');
                        $body.find('[data-dashboard-learn]').show();
                    }
                    APP.Analytics.trackEvent('keyboard', 'hide');
                    if (APP.Page.isDevice()) {
                        $body.find('[data-calculator-focus-hunter]').trigger('blur');
                    }
                    previousCalculator && previousCalculator.hideCursor();
                }
            }
        }, keyboardHideDuration);
    }

    function addStatus(selectionLength) {
        init();
        if (selectionLength === 0) {
            $keyBoard.addClass('keyboard--pointer-phase');
            $keyBoard.removeClass('keyboard--selection-phase');
            $body.find('[data-keyboard-method="ctrl+c"], [data-keyboard-method="ctrl+x"]').hide();
        } else {
            $keyBoard.addClass('keyboard--selection-phase');
            $keyBoard.removeClass('keyboard--pointer-phase');
            $body.find('[data-keyboard-method="ctrl+c"], [data-keyboard-method="ctrl+x"]').show();
        }

    }

    function submit() {
        activeCalculator = activeCalculator || previousCalculator;

        if (activeCalculator) {
            var content = activeCalculator.getContent();

            preventHideKeyboard = true;
            if (activeCalculator && activeCalculator.isSendable()) {
                if (content.length > 2) {
                    sendCalculatorContent(content);
                } else {
                    APP.Layout.openOverlay('keyboard-empty');
                    APP.Layout.onOverlayClose(function () {
                        $body.find('[data-calculator]').trigger('click');
                    });
                }
            } else {
                getVisibleSubmit().trigger('click');
            }
            $body.find('[data-calculator]').attr('data-sent', true);
        }
    }

    function getVisibleSubmit() {
        return $body.find('.newsfeed__item__actions:visible button:first()');
    }

    exports.init = init;
    exports.show = showKeyboard;
    exports.hide = hideKeyboard;
    exports.focus = autoFocus;
    exports.setActiveCalculator = setActiveCalculator;
    exports.addStatus = addStatus;
    exports.submit = submit;
    exports.isShown = function (id) {
        if (typeof id === 'undefined') {
            return !!activeCalculator;
        } else {
            if (activeCalculator && activeCalculator.id === id) {
                return true;
            }
        }
        return false;
    };
    exports.paste = function (pastedString) {
        lastUsedCalc.onPaste(pastedString);
        APP.Calculator.Keyboard.show(lastUsedCalc);
    };
    exports.clean = function () {
        if (lastUsedCalc) {
            lastUsedCalc.cleanInput();
            APP.Calculator.Keyboard.show(lastUsedCalc);
            lastUsedCalc.addFocus();
        }
    };
    exports.add = function (calc) {
        lastUsedCalc = calc;
    };
    return exports;

})();

var DictionaryHelper = function (text, html) {
    var regexp = /\$(\S*)\{([^}]+)\}/g,
        htmlMarks = {};

    html.replace(regexp, function (match, key, value) {
        htmlMarks[key] = value;
        return match;
    });

    return text.replace(regexp, function (match, key, value) {
        return htmlMarks[key].replace(/@@@/g, value);
    });

};

var MarkupParser = function(html){
    var regexp = /\{\{\#\$markup(.+)\}\}(((?!\{\{\/\$markup\}\})[\s|\S])+)\{\{\/\$markup\}\}/g;

    html.replace(regexp, function (match, argument, value) {
        return match;
    });
};

/*


 // declaration:
 dictionary.key = 'You can\'t connect the dots $0{looking forward}; you can only connect them $1{looking backwards}.'

 // usage:
 {{#$markup 'dictionary.key'}}
 $0{<b>@@@</b>}
 $1{<strong>@@@</strong>}
 {{/$markup}}

 // result:
 You can't connect the dots <b>looking forward<b>; you can only connect them <strong>looking backwards</strong>

 */
jQuery.event.special.dbltap = {
    setup: function(data, namespaces) {
        var elem = this,
            $elem = jQuery(elem);
        $elem.bind('touchend.dbltap', jQuery.event.special.dbltap.handler);
    },

    teardown: function(namespaces) {
        var elem = this,
            $elem = jQuery(elem);
        $elem.unbind('touchend.dbltap');
    },

    handler: function(event) {
        var elem = event.target,
            $elem = jQuery(elem),
            lastTouch = $elem.data('lastTouch') || 0,
            now = new Date().getTime();

        var delta = now - lastTouch;
        if(delta > 20 && delta<500){
            $elem.data('lastTouch', 0);
            $elem.trigger('dbltap');
        }else
            $elem.data('lastTouch', now);
    }
};
/**
 *  The Virtual Keyboard Detector
 */

var virtualKeyboardDetector = ( function( window ) {

    var recentlyFocusedTimeoutDuration = 3000;

    var currentViewportWidth = previousViewportWidth = viewportWidthWithoutVirtualKeyboard = window.innerWidth;
    var currentViewportHeight = previousViewportHeight = viewportHeightWithoutVirtualKeyboard = window.innerHeight;

    var virtualKeyboardVisible = false;
    var recentlyFocused = false;
    var recentlyFocusedTimeout = null;
    var validFocusableElements = [ 'INPUT', 'TEXTAREA' ];

    var subscriptions = {};


    /**
     * Public functions
     */

    function init ( options ) {
        if ( typeof options !== 'undefined' ) {
            if ( typeof options.recentlyFocusedTimeoutDuration !== 'undefined' ) recentlyFocusedTimeoutDuration = options.recentlyFocusedTimeoutDuration;
        }

        resetViewportSizes();
        initFocusListener();
        initResizeListener();
    }

    function isVirtualKeyboardVisible () {
        return virtualKeyboardVisible;
    }

    function getVirtualKeyboardSize () {
        if ( !virtualKeyboardVisible ) return false;

        return {
            width: currentViewportWidth,
            height: viewportHeightWithoutVirtualKeyboard - currentViewportHeight
        };
    }

    // Subscribe
    function on ( eventName, fn ) {
        if ( typeof subscriptions[eventName] === 'undefined' ) subscriptions[eventName] = [];

        subscriptions[eventName].push(fn);
    }

    // Unsubscribe
    function off ( eventName, fn ) {
        if (typeof subscriptions[eventName] === 'undefined' ) return;

        if (typeof fn === 'undefined') {
            subscriptions[eventName] = [];
        } else {
            var i = subscriptions[eventName].length;
            while ( i-- ) {
                if ( subscriptions[eventName][i] === fn ) subscriptions[eventName].splice(i, 1);
            }
        }
    }

    // Publish
    function trigger ( eventName, args ) {
        for ( i in subscriptions[eventName] ) {
            if ( typeof subscriptions[eventName][i] === 'function' ) subscriptions[eventName][i]( args );
        }
    }


    /**
     * Private functions
     */

    // Reset all sizes. We presume the virtual keyboard is not visible at this stage.
    // We call this function on initialisation, so make sure you initialise the virtualKeyBoardListener at a moment when the virtual keyboard is likely to be invisible.
    function resetViewportSizes () {
        currentViewportWidth = previousViewportWidth = viewportWidthWithoutVirtualKeyboard = window.innerWidth;
        currentViewportHeight = previousViewportHeight = viewportHeightWithoutVirtualKeyboard = window.innerHeight;
    }

    // Initialise the listener that checks for focus events in the whole document. This way we can also handle dynamically added focusable elements.
    function initFocusListener () {
        document.addEventListener( 'focus', documentFocusHandler, true );
    }

    // Handle the document focus event. We check if the target was a valid focusable element.
    function documentFocusHandler (e) {
        if (typeof e.target !== 'undefined' && typeof e.target.nodeName !== 'undefined') {
            if (validFocusableElements.indexOf(e.target.nodeName) !== -1) elementFocusHandler(e);
        }
    }

    // Handle the case when a valid focusable element is focused. We flag that a valid element was recently focused. This flag expires after recentlyFocusedTimeoutDuration.
    function elementFocusHandler (e) {
        if ( recentlyFocusedTimeout != null ) {
            window.clearTimeout( recentlyFocusedTimeout );
            recentlyFocusedTimeout = null;
        }

        recentlyFocused = true;

        recentlyFocusedTimeout = window.setTimeout( expireRecentlyFocused, recentlyFocusedTimeoutDuration );
    }

    function expireRecentlyFocused () {
        recentlyFocused = false;
    }

    function initResizeListener () {
        window.addEventListener( 'resize', resizeHandler );
    }

    function resizeHandler () {
        currentViewportWidth = window.innerWidth;
        currentViewportHeight = window.innerHeight;

        // If the virtual keyboard is tought to be visible, but the viewport height returns to the value before keyboard was visible, we presume the keyboard was hidden.
        if ( virtualKeyboardVisible && currentViewportWidth === previousViewportWidth && currentViewportHeight >= viewportHeightWithoutVirtualKeyboard ) {
            virtualKeyboardHiddenHandler();
        }

        // If the width of the viewport is changed, it's hard to tell wether virtual keyboard is still visible, so we make sure it's not.
        if ( currentViewportWidth !== previousViewportWidth ) {
            document.activeElement && document.activeElement.blur();
            virtualKeyboardHiddenHandler();
        }

        // If recently focused and viewport height is smaller then previous height, we presume that the virtual keyboard has appeared.
        if ( !virtualKeyboardVisible && recentlyFocused && currentViewportWidth === previousViewportWidth && currentViewportHeight < previousViewportHeight ) {
            virtualKeyboardVisibleHandler();
        }

        // If the keyboard is presumed not visible, we save the current measurements as values before keyboard was shown.
        if ( virtualKeyboardVisible === false ) {
            viewportWidthWithoutVirtualKeyboard = currentViewportWidth;
            viewportHeightWithoutVirtualKeyboard = currentViewportHeight;
        }

        previousViewportWidth = currentViewportWidth;
        previousViewportHeight = currentViewportHeight;
    }

    function virtualKeyboardVisibleHandler () {
        virtualKeyboardVisible = true;

        var eventData = {
            virtualKeyboardVisible: virtualKeyboardVisible,
            sizes: getSizesData()
        };

        trigger( 'virtualKeyboardVisible', eventData );
    }

    function virtualKeyboardHiddenHandler () {
        virtualKeyboardVisible = false;

        var eventData = {
            virtualKeyboardVisible: virtualKeyboardVisible,
            sizes: getSizesData()
        };

        trigger( 'virtualKeyboardHidden', eventData );
    }

    function getSizesData () {
        return {
            viewportWithoutVirtualKeyboard: {
                width: viewportWidthWithoutVirtualKeyboard,
                height: viewportHeightWithoutVirtualKeyboard
            },
            currentViewport: {
                width: currentViewportWidth,
                height: currentViewportHeight
            },
            virtualKeyboard: {
                width: currentViewportWidth,
                height: viewportHeightWithoutVirtualKeyboard - currentViewportHeight
            }
        };
    }

    // Make public functions available
    return {
        init: init,
        isVirtualKeyboardVisible: isVirtualKeyboardVisible,
        getVirtualKeyboardSize: getVirtualKeyboardSize,
        on: on,
        addEventListener: on,
        subscribe: on,
        off: off,
        removeEventListener: off,
        unsubscribe: off,
        trigger: trigger,
        publish: trigger,
        dispatchEvent: trigger
    };

} )( window );
APP.Initializer = (function (win, doq) {
    var exports = {},
        initialized;

    function _construct() {
        setGlobalDomVariables();
        setTimeout(init, 8);
    }

    function init() {
        setUpGlobals();
        APP.Live.init();
        APP.Analytics.init();
        showAddToHomeScreen();
        APP.Assets.init(ready);
        PointerEventsPolyfill.initialize({});
        $.ajaxSetup({cache: false});
        mobileStuffs();
        if (window.ADMIN) {
            ADMIN.Initializer.init();
        }
    }

    function setUpGlobals() {
        // for inline scripts:
        window.AKRIEL_ajaxPost = APP.Ajax.post;
        window.AKRIEL_applyUrl = APP.Page.applyPageByUrl;
    }

    function showAddToHomeScreen() {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.register(document.location.origin + '/en-US/sw.js').catch(console.log);
            window.addEventListener('beforeinstallprompt', function (e) {
                e.userChoice.then(function (outcome) {
                    APP.Analytics.trackEvent('install', outcome, e.platforms.join(','));
                });
            });
        }
    }

    function mobileStuffs() {
        window.FastClick.attach(document.body);
    }

    function ready() {
        initialized = true;
        APP.Tpl.init();
        APP.Error.init();
        APP.Form.init();
        APP.Locale.init();
        APP.Page.init();
        APP.User.init();
        APP.Notification.init();
        APP.Avatar.init();
        pageLoadedInit();
        $body.addClass('application--ready')
            .removeClass('application--starts')
            .removeClass('application--loading');
        win.domReady();
    }

    function pageLoadedInit() {
        APP.Tpl.init();
        APP.Calculator.Keyboard.hide(true);
        APP.Calculator.init();
        APP.Locale.init();
        APP.Layout.init();
        APP.User.init();
        APP.Problem.init();
        APP.Collection.init();
        APP.Decor.init();
        APP.Formula.cosmeticFormulaByWrapper($body.find('[data-cosmetic-formulas]'));
        APP.Pro.init();
        APP.Formula.init();
        APP.Learn.init();
        APP.NewsFeed.init();
        APP.BasicCalculator.init();
        APP.Cd.init();
        APP.Analytics.pageView();
        APP.KeepScroll.init();
        APP.PrimeTable.init();
        APP.Exam.init();
        APP.Akri.init();
        APP.Doodle.init();
        APP.Live.init();
        APP.Video.init();
        // APP.Operations.init();
        if (window.ADMIN) {
            ADMIN.Initializer.pageLoaded();
        }
    }

    function setGlobalDomVariables() {
        win.$document = $(doq);
        win.$window = $(win);
        win.$body = $(doq.body);
    }

    // constructor:
    _construct();

    exports.init = pageLoadedInit;
    return exports;

}(window, document));
;APP.$store={};APP.$store.svg = '<svg xmlns="http://www.w3.org/2000/svg"><symbol id="icon-akriel-symbol-p1" viewBox="0 0 256 256"><path d="M139.29 237.94h-20.902c-2.867 0-3.554 1.66-1.53 3.695l8.28 8.285c2.04 2.032 5.367 2.032 7.39 0l8.29-8.285c2.04-2.035 1.345-3.696-1.53-3.696zM149.282 192.147h-43.036c-2.875 0-5.23 2.347-5.23 5.226v2.04c0 2.872 2.355 5.227 5.23 5.227h43.036c2.87 0 5.225-2.354 5.225-5.228v-2.04c0-2.878-2.355-5.225-5.225-5.225zM147.98 214.926h-40.446c-2.872 0-5.23 2.353-5.23 5.228v2.04c0 2.873 2.358 5.228 5.23 5.228h40.446c2.878 0 5.232-2.354 5.232-5.23v-2.038c0-2.876-2.354-5.228-5.232-5.228zM191.564 102.9l-58.36-39.605c-2.488-1.688-6.56-1.688-9.044 0l-58.38 39.61c-2.484 1.696-3.646 5.367-2.557 8.175l24.568 63.836c1.08 2.812 4.423 5.106 7.44 5.106h66.898c3.013 0 6.354-2.295 7.437-5.106l19.402-50.473c1.084-2.812-.493-5.11-3.507-5.11h-18.755c-3.01 0-6.977 1.953-8.802 4.337l-17.636 22.935c-1.838 2.388-4.83 6.29-6.67 8.676l-1.56 2.046c-1.826 2.386-5.002 2.535-7.05.336l-19.847-21.347c-2.048-2.207-2.026-5.785.058-7.96l1.653-1.73c2.083-2.172 5.462-2.155 7.51.054l9.738 10.46c2.042 2.2 5.22 2.053 7.053-.332l20.362-26.496c1.832-2.38 5.793-4.34 8.808-4.34h30.296c3.022 0 3.44-1.384.948-3.073z"/></symbol><symbol id="icon-akriel-symbol-p2" viewBox="0 0 256 256"><path d="M47.176 190.01L26.16 205.362c-1.74 1.27-1.925 3.993-1.445 4.62.492.627 3.818 2.178 5.518.853l20.788-15.56c2.702-2.256.312-6.254-.04-6.724-.35-.472-2.06.184-3.804 1.46zM44.23 35.24c-1.415-1.63-5.586-.27-6.7.79-1.115 1.066-.783 3.196.736 4.728L56.59 59.246c1.504 1.54 3.404 2.16 4.217 1.384.81-.767 1.837-4.052.43-5.684L44.23 35.24zM213.858 33.813c-1.146-1.008-3.223-.48-4.616 1.165L192.414 54.85c-1.39 1.643-.3 4.935.525 5.706.83.78 2.738.138 4.227-1.408l18.052-18.76c1.49-1.558-.214-5.57-1.362-6.575zM33.057 145.994c-.155-1.118-2.05-1.79-4.187-1.508l-25.804 3.428c-2.14.287-3.3 4.495-3.027 6.003.278 1.507 2.232 2.387 4.35 1.97l25.535-5.096c2.102-.424 3.302-3.678 3.132-4.796zM252.882 146.638l-25.842-3.182c-2.136-.262-4.303 2.457-4.487 3.57-.193 1.12 1.382 2.353 3.504 2.757l25.588 4.816c2.11.398 4.06-.507 4.32-2.013.26-1.504-.94-5.694-3.083-5.95zM223.106 100.776l24.807-7.912c2.046-.657 2.458-4.986 1.927-6.41-.535-1.433-2.608-1.958-4.62-1.176l-24.248 9.476c-2.01.788-2.613 4.206-2.248 5.268.357 1.074 2.33 1.413 4.382.754zM151.538 38.084c1.084.282 2.453-1.19 3.03-3.267L161.48 9.73c.574-2.084-2.834-4.792-4.33-5.125-1.487-.34-3.073 1.116-3.513 3.222l-5.284 25.493c-.45 2.108 2.086 4.485 3.185 4.764zM98.957 34.995c.574 2.082 1.94 3.553 3.036 3.27 1.084-.288 3.65-2.666 3.204-4.777L99.864 8.002c-.447-2.114-4.71-2.958-6.185-2.583-1.466.384-2.2 2.397-1.63 4.478l6.907 25.097zM6.978 94.336l25.06 7.04c2.074.586 4.046.17 4.37-.922.316-1.08-.41-4.472-2.444-5.186L9.396 86.664C7.36 85.952 4.433 89.144 4 90.61c-.44 1.464.896 3.138 2.978 3.726zM230.243 204.527L209.1 189.34c-1.752-1.258-4.1-1.045-4.448-.574-.355.462-.847 3.794.865 5.113l21.234 15.87c1.7 1.32 4.49.02 4.968-.617.478-.634.283-3.348-1.475-4.606z"/></symbol><symbol id="icon-akriel-symbol" viewBox="0 0 256 256"><path d="M139.29,237.939h-20.902c-2.867,0-3.554,1.66-1.53,3.694l8.28,8.285c2.04,2.03,5.367,2.03,7.389,0l8.291-8.286 c2.039-2.033,1.345-3.695-1.53-3.695L139.29,237.939z M149.281,192.146h-43.035c-2.875,0-5.23,2.348-5.23,5.227v2.04 c0,2.872,2.355,5.228,5.23,5.228h43.035c2.871,0,5.226-2.353,5.226-5.228v-2.04C154.507,194.495,152.152,192.146,149.281,192.146 L149.281,192.146z M147.98,214.926h-40.446c-2.872,0-5.23,2.354-5.23,5.23v2.037c0,2.873,2.358,5.23,5.23,5.23h40.446 c2.877,0,5.229-2.355,5.229-5.23v-2.039C153.213,217.277,150.857,214.926,147.98,214.926z M47.176,190.01L26.16,205.361 c-1.74,1.271-1.925,3.994-1.445,4.621c0.492,0.627,3.818,2.18,5.518,0.853l20.788-15.56c2.702-2.256,0.312-6.254-0.04-6.726 c-0.35-0.472-2.06,0.185-3.804,1.46H47.176z M44.23,35.24c-1.415-1.63-5.586-0.271-6.7,0.79c-1.115,1.066-0.783,3.196,0.736,4.728 L56.59,59.246c1.504,1.54,3.404,2.16,4.217,1.384c0.81-0.767,1.837-4.052,0.43-5.684L44.23,35.24z M213.857,33.813 c-1.146-1.008-3.224-0.48-4.615,1.165L192.414,54.85c-1.391,1.643-0.301,4.935,0.525,5.706c0.83,0.78,2.736,0.138,4.227-1.408 l18.053-18.76c1.489-1.558-0.215-5.57-1.363-6.575H213.857z M33.057,145.994c-0.155-1.118-2.05-1.79-4.187-1.508l-25.804,3.428 c-2.14,0.287-3.3,4.495-3.027,6.003c0.278,1.507,2.232,2.388,4.35,1.97l25.535-5.096C32.026,150.367,33.226,147.111,33.057,145.994 L33.057,145.994z M252.882,146.641l-25.842-3.185c-2.136-0.263-4.304,2.457-4.487,3.569c-0.193,1.121,1.383,2.354,3.504,2.758 l25.588,4.816c2.11,0.396,4.063-0.509,4.32-2.015c0.26-1.503-0.939-5.692-3.083-5.946V146.641z M223.105,100.776l24.808-7.912 c2.046-0.657,2.458-4.986,1.927-6.41c-0.535-1.433-2.607-1.958-4.619-1.176l-24.248,9.476c-2.01,0.788-2.613,4.206-2.248,5.268 C219.081,101.096,221.055,101.435,223.105,100.776L223.105,100.776z M151.538,38.084c1.084,0.282,2.453-1.19,3.03-3.267L161.48,9.73 c0.574-2.084-2.834-4.792-4.33-5.125c-1.487-0.34-3.073,1.116-3.514,3.222l-5.283,25.493 C147.902,35.428,150.439,37.805,151.538,38.084L151.538,38.084z M98.957,34.995c0.574,2.082,1.94,3.553,3.036,3.27 c1.084-0.288,3.65-2.666,3.204-4.777L99.864,8.002c-0.447-2.114-4.71-2.958-6.185-2.583c-1.466,0.384-2.2,2.397-1.63,4.478 L98.957,34.995L98.957,34.995z M6.978,94.336l25.06,7.04c2.074,0.586,4.046,0.17,4.37-0.922c0.316-1.08-0.41-4.472-2.444-5.186 L9.396,86.664C7.36,85.952,4.433,89.144,4,90.61C3.56,92.074,4.896,93.748,6.978,94.336z M230.243,204.527L209.1,189.34 c-1.752-1.258-4.1-1.045-4.447-0.574c-0.354,0.463-0.848,3.795,0.865,5.113l21.233,15.87c1.7,1.319,4.49,0.021,4.968-0.617 c0.477-0.634,0.283-3.348-1.475-4.606L230.243,204.527z M191.564,102.9l-58.36-39.605c-2.488-1.688-6.56-1.688-9.044,0l-58.38,39.61 c-2.484,1.696-3.646,5.367-2.557,8.175l24.568,63.836c1.08,2.813,4.423,5.105,7.44,5.105h66.898c3.014,0,6.354-2.295,7.438-5.104 l19.401-50.473c1.085-2.812-0.491-5.11-3.507-5.11h-18.755c-3.013,0-6.978,1.953-8.804,4.337l-17.635,22.937 c-1.838,2.388-4.832,6.289-6.67,8.676l-1.562,2.045c-1.825,2.386-5,2.535-7.048,0.336l-19.848-21.348 c-2.05-2.207-2.027-5.785,0.057-7.96l1.653-1.728c2.082-2.173,5.46-2.156,7.508,0.053l9.74,10.461c2.04,2.2,5.22,2.053,7.05-0.332 l20.361-26.497c1.832-2.38,5.793-4.34,8.811-4.34h30.295C193.639,105.974,194.057,104.589,191.564,102.9L191.564,102.9z"/></symbol><symbol id="icon-arrow-doodle-right-down" viewBox="0 0 256 256"><path d="M255.15 247.518c.036-.008.063-.03.1-.042.06-.018.112-.036.167-.063.03-.016.063-.025.09-.044.04-.025.068-.06.105-.088.044-.036.084-.072.12-.115.023-.024.05-.046.067-.073.025-.038.042-.08.063-.12.027-.053.05-.105.07-.16.008-.027.027-.048.034-.075.002-.007 0-.013.002-.02.008-.044.004-.09.008-.136.005-.035.02-.066.02-.103 0-.025-.013-.05-.015-.074-.003-.038.002-.076-.006-.114 0-.006 0-.012 0-.018-.007-.036-.03-.063-.04-.1-.02-.058-.035-.11-.063-.164-.017-.033-.028-.066-.05-.1-.02-.035-.054-.062-.08-.094-.037-.046-.073-.087-.117-.125-.026-.022-.05-.05-.08-.07-.033-.022-.072-.036-.11-.057-.054-.03-.108-.055-.166-.074-.024-.01-.045-.027-.07-.035l-33.852-8.463c-.567-.143-1.143.202-1.283.77-.023.087-.032.173-.032.258 0 .474.32.904.802 1.025l24.738 6.185C112.66 240.27 2.116 130.486 2.116 1.06 2.116.474 1.643 0 1.058 0S0 .476 0 1.06c0 62.126 26.717 124.476 73.302 171.06 46.333 46.334 107.078 72.816 171.95 75.22l-32.83 6.565c-.504.1-.852.543-.852 1.036 0 .068.008.14.02.21.114.57.673.943 1.245.828l42.314-8.46z"/></symbol><symbol id="icon-arrow-doodle-right-up" viewBox="0 0 256 256"><path d="M247.518.85c-.008-.036-.03-.063-.042-.098-.018-.06-.036-.114-.063-.168-.016-.03-.025-.063-.044-.09-.025-.04-.06-.07-.088-.105-.036-.044-.072-.084-.115-.122-.024-.022-.046-.047-.073-.066-.038-.027-.08-.043-.122-.064-.05-.028-.104-.05-.16-.07-.025-.01-.046-.03-.073-.035-.007 0-.013 0-.02 0-.044-.01-.09-.006-.136-.01-.037-.006-.067-.023-.104-.023-.026 0-.05.014-.075.016-.038.002-.076-.002-.114.005-.005.002-.01 0-.017 0-.036.008-.063.032-.1.043-.058.018-.11.035-.164.06-.034.018-.067.03-.1.05-.036.023-.063.054-.095.082-.046.037-.087.073-.125.117-.023.027-.05.05-.07.08-.023.035-.037.074-.058.11-.03.055-.055.11-.074.168-.01.025-.026.045-.034.072l-8.463 33.85c-.142.568.203 1.143.772 1.284.086.022.172.032.257.032.473 0 .903-.32 1.024-.8l6.185-24.74C240.27 143.34 130.486 253.887 1.06 253.887c-.585 0-1.06.473-1.06 1.058S.476 256 1.06 256c62.126 0 124.476-26.717 171.06-73.302 46.333-46.333 72.816-107.078 75.22-171.952l6.565 32.833c.1.5.543.85 1.036.85.068 0 .14-.006.21-.02.57-.115.943-.673.828-1.246L247.518.85z"/></symbol><symbol id="icon-arrow-down" viewBox="0 0 256 256"><path d="M23.64 159.216l91.43 91.43c7.14 7.14 18.72 7.14 25.86 0l91.43-91.43c7.14-7.142 7.14-18.72 0-25.86-7.142-7.14-18.72-7.14-25.86 0l-60.214 60.214V18.286C146.286 8.186 138.1 0 128 0c-10.1 0-18.286 8.187-18.286 18.286V193.57L49.5 133.356c-3.57-3.57-8.25-5.355-12.93-5.355s-9.358 1.786-12.93 5.356c-7.14 7.14-7.14 18.718 0 25.86z"/></symbol><symbol id="icon-arrow-key-down" viewBox="0 0 256 256"><path d="M98.732 29.267V160.97h-65.85L128 256l95.118-95.03h-65.85V28.58C157.267 12.774 144.184 0 128 0S98.732 13.463 98.732 29.267z"/></symbol><symbol id="icon-arrow-key-left" viewBox="0 0 256 256"><path d="M226.732 98.732H95.03v-65.85L0 127.998l95.03 95.117v-65.85h132.39c15.804 0 28.58-13.084 28.58-29.268 0-16.185-13.464-29.268-29.268-29.268z"/></symbol><symbol id="icon-arrow-key-right" viewBox="0 0 256 256"><path d="M29.266 157.266H160.97l-.002 65.852L255.998 128l-95.03-95.118v65.85H28.58c-15.804 0-28.58 13.084-28.58 29.268s13.464 29.266 29.268 29.266z"/></symbol><symbol id="icon-arrow-key-up" viewBox="0 0 256 256"><path d="M157.268 226.733V95.03h65.85L128 0 32.882 95.03h65.85v132.39c0 15.805 13.083 28.58 29.268 28.58s29.268-13.463 29.268-29.267z"/></symbol><symbol id="icon-arrow-left" viewBox="0 0 256 256"><path d="M96.8,23.6L5.4,115.1c-7.1,7.1-7.1,18.7,0,25.9l91.4,91.4c7.1,7.1,18.7,7.1,25.9,0c7.1-7.1,7.1-18.7,0-25.9l-60.2-60.2 h175.3c10.1,0,18.3-8.2,18.3-18.3s-8.2-18.3-18.3-18.3H62.4l60.2-60.2c3.6-3.6,5.4-8.3,5.4-12.9s-1.8-9.4-5.4-12.9 C115.5,16.5,103.9,16.5,96.8,23.6L96.8,23.6z"/></symbol><symbol id="icon-arrow-right" viewBox="0 0 256 256"><path d="M159.216 232.36l91.43-91.43c7.14-7.142 7.14-18.72 0-25.86l-91.43-91.43c-7.142-7.14-18.72-7.14-25.86 0-7.14 7.142-7.14 18.72 0 25.86l60.214 60.214H18.286C8.186 109.714 0 117.9 0 128c0 10.1 8.187 18.286 18.286 18.286H193.57L133.356 206.5c-3.57 3.57-5.355 8.25-5.355 12.93s1.786 9.358 5.356 12.93c7.14 7.14 18.718 7.14 25.86 0z"/></symbol><symbol id="icon-arrow-small-down" viewBox="0 0 256 256"><path d="M249.005 96.294c-8.982 9.225-103.616 99.377-103.616 99.377-4.812 4.923-11.102 7.373-17.39 7.373-6.313 0-12.603-2.45-17.392-7.372 0 0-94.633-90.15-103.637-99.376-8.982-9.225-9.6-25.8 0-35.664 9.623-9.843 23.02-10.615 34.782 0L128 143.346l86.224-82.694c11.785-10.615 25.203-9.843 34.78 0 9.623 9.843 9.027 26.44 0 35.642z"/></symbol><symbol id="icon-arrow-up" viewBox="0 0 256 256"><path d="M232.36,96.785l-91.43-91.431c-7.142-7.14-18.72-7.14-25.86,0l-91.43,91.431c-7.14,7.142-7.14,18.72,0,25.86 c7.142,7.14,18.72,7.14,25.86,0l60.214-60.215l0,175.285c0,10.1,8.186,18.286,18.286,18.286c10.1,0,18.286-8.188,18.286-18.286 V62.43l60.214,60.215c3.57,3.569,8.25,5.354,12.93,5.354s9.358-1.786,12.93-5.356C239.501,115.503,239.501,103.925,232.36,96.785 L232.36,96.785z"/></symbol><symbol id="icon-doodle-fullscreen" viewBox="0 0 256 256"><g id="Layer_2"><polygon points="12,57.2 0,57.2 0,0 57.2,0 57.2,12 12,12 "/><polygon points="256,57.2 244,57.2 244,12 198.8,12 198.8,0 256,0 "/><polygon points="256,256 198.8,256 198.8,244 244,244 244,198.8 256,198.8 "/><polygon points="57.2,256 0,256 0,198.8 12,198.8 12,244 57.2,244 "/></g></symbol><symbol id="icon-doodle-pan" viewBox="0 0 256 256"><polygon points="160,48.9 128,17 96,48.9 87.6,40.4 128,0 168.4,40.4 "/><polygon points="215.6,168.4 207.1,160 239,128 207.1,96 215.6,87.6 256,128 "/><polygon points="128,256 87.6,215.6 96,207.1 128,239 160,207.1 168.4,215.6 "/><polygon points="40.4,168.4 0,128 40.4,87.6 48.9,96 17,128 48.9,160 "/></symbol><symbol id="icon-doodle-pen" viewBox="0 0 256 256"><path d="M235.2,20.6C222,7.5,204.7,0,187.6,0c-14.4,0-27.7,5.3-37.4,15l-38.9,39.2c-0.1,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.1,0.2-0.2,0.2l0,0L28.1,138c-3.8,3.8-6.6,8.5-8.1,13.6L1.2,219.8c0,0.2-1.2,5.5-1.2,8.2c0,15.5,12.6,28,28,28 c3.1,0,9-1.5,9.3-1.5l67.8-17.8c5.2-1.5,9.8-4.3,13.6-8.1l122.1-123.1C263.1,83.2,260.6,46,235.2,20.6z M128.1,190.4 c-0.7-7.2-2.7-14.3-5.8-21L198,93.7c4.6,14.6,2.2,29.9-7.9,40c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1l-61.8,62.3 C128.2,194.3,128.3,192.4,128.1,190.4L128.1,190.4z M118.3,162c-3-4.9-6.4-9.6-10.6-13.8c-4.9-4.9-10.5-8.7-16.4-11.9L167.7,60 c6,2.7,11.7,6.4,16.8,11.5c4.3,4.3,7.7,9.1,10.2,14.2C194.7,85.7,118.3,162,118.3,162z M83.9,132.5c-7.4-3-15.2-4.7-22.9-4.8 l61.6-62.1c9.4-9.2,23.2-11.8,36.7-8.5C159.3,57.1,83.9,132.5,83.9,132.5z M33.3,239c-0.9,0.2-3.6,0.9-5.4,1 c-6.6-0.1-11.9-5.4-11.9-12c0.1-1.3,0.6-3.7,0.8-4.5l8.4-30.5c9.1-0.2,19,3.3,26.7,11.1c7.9,7.8,11.6,17.9,11.2,27.1L33.3,239 L33.3,239z M71,229.1c-0.2-10.7-4.6-21.9-13.4-30.7c-8.3-8.3-19.2-13.2-30.1-13.6l8-28.9c0.6-1.9,1.7-3.8,3.1-5.5 c16-11.5,40.7-8.1,57.9,9.1c18.1,18.1,20.9,44.7,7,60.5c-0.9,0.5-1.9,1-2.9,1.2C100.6,221.3,71,229.1,71,229.1z M229.5,94.2 l-13.5,13.6c0-1.8,0.2-3.5,0-5.4c-1.4-15.5-8.6-30.4-20.3-42.2c-13-13-30.3-20.5-47.4-20.6l13.2-13.4c6.6-6.6,15.9-10.3,26-10.3 c12.9,0,26.1,5.8,36.3,16c9.5,9.5,15.2,21.4,16,33.3C240.7,76.5,237,86.7,229.5,94.2z"/></symbol><symbol id="icon-doodle-rubber" viewBox="0 0 256 256"><path d="M100,234.5L232.6,102h0c7.3-7.3,7.3-19.3,0-26.6l-60.9-60.9c-3.6-3.6-8.3-5.5-13.3-5.5c-5,0-9.7,2-13.3,5.5L5.5,154 c-7.3,7.3-7.3,19.3,0,26.6l60.9,60.9c3.5,3.5,8.2,5.4,12.8,5.5v0.1H256v-12.5H100z M153.9,23.3c1.2-1.2,2.8-1.8,4.4-1.8 c1.7,0,3.2,0.7,4.4,1.8l60.9,60.9c2.4,2.4,2.4,6.4,0,8.9l-65.4,65.4L88.6,88.7L153.9,23.3z M14.4,171.7c-2.4-2.4-2.4-6.4,0-8.9 l65.4-65.3l69.8,69.8l-65.4,65.4c-2.4,2.4-6.4,2.4-8.9,0L14.4,171.7z"/></symbol><symbol id="icon-formula-abs-placeholder" viewBox="0 0 256 256"><path d="M149.113 96.33h-47.505c-5.103 0-9.237 4.136-9.237 9.237v47.505c0 5.108 4.135 9.237 9.238 9.237h47.505c5.108 0 9.237-4.13 9.237-9.238v-47.505c0-5.1-4.133-9.237-9.237-9.237z"/></symbol><symbol id="icon-formula-abs" viewBox="0 0 256 256"><path d="M9.237 232.247c-5.1 0-9.237-4.13-9.237-9.236V32.99c0-5.103 4.137-9.237 9.237-9.237 5.105 0 9.237 4.135 9.237 9.237v190.02c0 5.103-4.137 9.237-9.237 9.237zM246.763 232.247c-5.1 0-9.237-4.13-9.237-9.236V32.99c0-5.103 4.137-9.237 9.237-9.237 5.105 0 9.237 4.135 9.237 9.237v190.02c0 5.103-4.137 9.237-9.237 9.237z"/></symbol><symbol id="icon-formula-exp-placeholder-1" viewBox="0 0 256 256"><g><rect x="4.5" y="114.5" width="137" height="137"/></g></symbol><symbol id="icon-formula-exp-placeholder-2" viewBox="0 0 256 256"><g><polygon points="159.9,85.5 204,9 248.2,85.5 "/></g></symbol><symbol id="icon-formula-log-placeholder-1" viewBox="0 0 256 256"><g><polygon points="116.6,229 152.1,167.5 187.6,229 "/></g></symbol><symbol id="icon-formula-log-placeholder-2" viewBox="0 0 256 256"><g><rect x="175.5" y="90" width="76" height="76"/></g></symbol><symbol id="icon-formula-log" viewBox="0 0 256 256"><path d="M29.73 150.7c-1.503 0-2.64-.046-3.577-.148-.276-.028-.344-.09-.35-.104 0 0 .203-.243.048-1.067-.146-.728.095-2.147.095-4.796v-68.75c0-1.986-2.378-4.75-4.362-4.75h-2.54c-.463 0-.93.67-1.357.847L2.23 78.557c-.905.37-1.623 1.246-1.98 2.152-.354.908-.336 2 .074 2.89l.932 2.06c.82 1.783 2.916 2.597 4.713 1.81 1.07-.463 1.75-.582 2.124-.61.103.527.508 1.373.604 2.7.138 1.88.482 4.57.482 7.984v47.043c0 1.802-.354 3.28-.5 4.376-.132.95-.493 1.303-.537 1.354 0 0-.143.057-.365.112-.494.127-.95.276-2.685.276-1.987 0-3.1 1.605-3.1 3.595v2.027c0 1.984.55 3.43 2.54 3.43h25.42c1.98 0 3.194-1.445 3.194-3.43v-2.027c-.025-1.985-1.434-3.596-3.418-3.596zM121.954 145.82c-1.203-.113-3.08-.26-5.633-.437-2.534-.164-5.8-.313-9.758-.426-2.748-.052-4.938-.16-6.504-.323-1.04-.107-1.746-.22-2.237-.318.05-.103.11-.225.18-.35.11-.202.416-.68 1.21-1.49.827.184 1.648.333 2.472.436 5.067.65 9.952.174 14.066-1.334 2.95-1.08 5.525-2.598 7.637-4.507 2.132-1.928 3.796-4.198 4.955-6.76 1.165-2.562 1.754-5.835 1.754-8.706 0-2.467-.335-4.992-.984-7.39h.94c2.602 0 3.872.322 4.85-.205.918-.49 2.454-1.487 2.454-4.397 0-.705-.02-1.187-.052-1.72-.057-.914-.28-1.67-.648-2.382-.506-1.31-1.69-2.185-3.19-2.398-.252-.036-.664-.434-1.25-.47-.502-.032-1.224-.407-2.16-.407h-9.935c-3.99-2.397-8.65-3.252-13.884-3.252-3.417 0-6.64.76-9.582 1.907-2.95 1.148-5.542 2.847-7.705 4.877-2.164 2.03-3.884 4.47-5.12 7.163-.596 1.306-1.05 2.69-1.354 4.09-1.395-3.287-3.248-6.22-5.577-8.723-2.54-2.724-5.566-4.91-9.023-6.51-3.506-1.622-7.363-2.443-11.473-2.443-4.093 0-7.955.896-11.49 2.66-3.448 1.726-6.488 4.086-9.042 7.022-2.514 2.89-4.52 6.245-5.957 9.975-1.45 3.747-2.186 7.75-2.186 11.897 0 4.025.685 7.915 2.045 11.552 1.35 3.66 3.283 6.936 5.736 9.735 2.478 2.83 5.473 5.11 8.906 6.772 3.497 1.7 7.337 2.556 11.417 2.556 3.86 0 7.63-.8 11.175-2.378 3.527-1.567 6.663-3.805 9.338-6.642 2.66-2.827 4.803-6.24 6.343-10.144 1.19-3.02 1.916-6.315 2.187-9.812.052.094.094.196.152.29 1.174 1.905 2.658 3.586 4.44 5.022-.498.468-.952.918-1.373 1.344-1.378 1.418-2.42 2.65-3.157 3.768-.845 1.255-1.402 2.415-1.713 3.558-.276 1.034-.42 2.055-.42 3.047 0 2.027.706 3.928 2.04 5.49.386.454.85.923 1.404 1.39-1.04 1.1-1.94 2.06-2.693 2.88-1.51 1.63-2.64 2.986-3.44 4.143-.948 1.366-1.563 2.593-1.868 3.73-.28 1.025-.427 2.14-.427 3.31 0 1.745.55 4.344 3.178 6.86 1.686 1.61 3.846 2.997 6.416 4.12 2.41 1.05 5.118 1.892 8.048 2.504 2.937.613 5.846.923 8.667.923 4.05 0 8.043-.595 11.867-1.76 3.815-1.17 7.26-2.79 10.246-4.813 3.083-2.088 5.593-4.587 7.45-7.428 1.985-3.038 2.996-6.353 2.996-9.867 0-4.05-1.382-7.528-4.108-10.322-2.618-2.695-6.158-4.342-10.628-4.91zm-60.227 3.73c-1.084.49-2.247.73-3.543.73-1.692 0-3.2-.51-4.6-1.56-1.61-1.207-3.013-2.868-4.162-4.947-1.238-2.223-2.207-4.872-2.888-7.873-.697-3.084-1.048-6.35-1.048-9.724 0-3.18.32-5.878.948-8.02.602-2.043 1.364-3.68 2.282-4.876.83-1.086 1.715-1.843 2.706-2.296 1.05-.487 2.106-.724 3.22-.724 1.84 0 3.405.48 4.79 1.474 1.558 1.127 2.92 2.694 4.034 4.67 1.2 2.13 2.144 4.698 2.79 7.636.67 3.03 1.014 6.303 1.014 9.738 0 3.394-.288 6.268-.856 8.538-.54 2.11-1.248 3.796-2.102 5-.772 1.06-1.61 1.79-2.585 2.234zm60.42 18.358c-1.305.875-3.022 1.61-5.11 2.176-2.156.59-4.826.89-7.925.89-2.488 0-4.842-.183-7.012-.548-2.104-.35-3.946-.838-5.472-1.44-1.327-.53-2.347-1.144-3.047-1.817-.47-.455-.47-.727-.47-.886 0-.903.45-2.84 3.168-6.15 4.622.553 10.553.895 18.02 1.05 2.81.106 5.14.266 6.936.48 1.942.234 2.99.548 3.543.772.34.14.53.24.526.24.033.083.07.257.07.57 0 .697-.22 1.408-.667 2.162-.527.87-1.386 1.71-2.56 2.5zm-9.775-50.675c.445 1.89.66 3.99.66 6.24 0 3.708-.655 6.427-1.908 7.864-1.166 1.344-2.553 1.966-4.378 1.966-1.12 0-2.046-.248-2.85-.753-.926-.586-1.714-1.414-2.416-2.547-.77-1.225-1.372-2.745-1.786-4.522-.447-1.895-.667-3.994-.667-6.237 0-3.658.693-6.396 2.003-7.923 1.23-1.424 2.586-2.085 4.285-2.085 1.114 0 2.053.256 2.872.782.948.606 1.734 1.447 2.4 2.576.765 1.285 1.364 2.85 1.785 4.64z"/></symbol><symbol id="icon-formula-p-placeholder" viewBox="0 0 256 256"><rect x="60" y="60" width="136" height="136"/></symbol><symbol id="icon-formula-p" viewBox="0 0 256 256"><path d="M24.38 232c-8.022-18.104-14.096-35.747-18.207-52.925C2.055 161.898 0 144.875 0 128.002c0-16.868 2.055-33.896 6.174-51.074C10.284 59.75 16.358 42.108 24.38 24h21.91c-8.64 18.518-15.174 36.26-19.593 53.237-4.43 16.974-6.64 33.896-6.64 50.765 0 16.873 2.21 33.79 6.64 50.764C31.117 195.74 37.65 213.482 46.29 232H24.38zM209.71 232c8.64-18.518 15.17-36.26 19.598-53.234 4.42-16.973 6.634-33.89 6.634-50.764 0-16.868-2.214-33.79-6.634-50.765-4.43-16.976-10.96-34.72-19.598-53.237h21.912c8.024 18.107 14.09 35.75 18.208 52.928 4.11 17.18 6.17 34.206 6.17 51.074 0 16.873-2.06 33.896-6.17 51.073-4.12 17.178-10.184 34.82-18.208 52.925H209.71z"/></symbol><symbol id="icon-formula-per-placeholder-1" viewBox="0 0 256 256"><g><rect x="83.7" y="5.5" width="88.7" height="88.7"/></g></symbol><symbol id="icon-formula-per-placeholder-2" viewBox="0 0 256 256"><g><polygon points="76,251.5 128,161.5 180,251.5"/></g></symbol><symbol id="icon-formula-per" viewBox="0 0 256 256"><path d="M195.8,138.4H60.2c-5,0-9.1-4.1-9.1-9.1c0-5.1,4.1-9.1,9.1-9.1h135.7c5.1,0,9.1,4.1,9.1,9.1 C205,134.4,200.9,138.4,195.8,138.4L195.8,138.4z"/></symbol><symbol id="icon-formula-root-placeholder-1" viewBox="0 0 256 256"><polygon points="36.142,98.799 0,98.799 18.071,67.499 36.142,36.198 54.213,67.499 72.284,98.799 "/></symbol><symbol id="icon-formula-root-placeholder-2" viewBox="0 0 256 256"><g><rect x="135.9" y="86.5" width="87" height="87"/></g></symbol><symbol id="icon-formula-root" viewBox="0 0 256 256"><path d="M86.974 227.69c-3.25 0-6.292-1.814-7.815-4.778l-41.862-81.66h-17.22c-4.85 0-8.784-3.926-8.784-8.783 0-4.854 3.933-8.786 8.785-8.786h22.587c3.295 0 6.32 1.844 7.82 4.776l31.205 60.876 18.46-153.292c.532-4.412 4.276-7.733 8.72-7.733h138.344c4.857 0 8.784 3.934 8.784 8.786V60.94c0 4.856-3.927 8.784-8.784 8.784-4.854 0-8.784-3.928-8.784-8.785V45.88h-121.77L95.697 219.953c-.462 3.836-3.373 6.92-7.17 7.598-.52.095-1.04.14-1.552.14z"/></symbol><symbol id="icon-learn-cup-basic" viewBox="0 0 256 256"><g><path d="M132,14.2v227.6H71.1c0-15.7,12.7-28.5,28.5-28.5h14.2v-29.8c-23-4.7-42-20.4-51.3-41.4c-2.9-6.6-4.9-13.8-5.6-21.3 c-0.3-2.4-0.4-4.9-0.4-7.5s0.1-5,0.4-7.5V28.4c0-7.8,6.4-14.2,14.2-14.2H132z"/><path style="fill:#FF9F28 !important" d="M199.5,113.5c0,2.5-0.1,5-0.4,7.5c-0.8,7.5-2.7,14.6-5.6,21.3c-9.2,21-28.2,36.7-51.3,41.4v29.8h14.2 c15.7,0,28.4,12.7,28.4,28.5H128V14.2h56.9c7.8,0,14.2,6.4,14.2,14.2V106C199.4,108.5,199.5,111,199.5,113.5z"/></g></symbol><symbol id="icon-learn-cup-default-detailed" viewBox="0 0 256 256"><g><path style="fill:#FFD700 !important;" d="M212.7,64.1c0,1.6,0,3.1-0.1,4.7c0,1.5-0.1,2.9-0.1,4.3c0,0.4,0,0.7-0.1,1.1c0,1-0.1,2.1-0.2,3.1 c0,0.3,0,0.6-0.1,1c-0.1,1.3-0.2,2.7-0.3,4c-0.4,4.2-0.9,8.2-1.6,12c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,1-0.4,2.1-0.6,3.1 c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.9-0.4,1.7-0.6,2.5c0,0.2-0.1,0.3-0.1,0.4c-0.2,0.8-0.4,1.6-0.6,2.3c-0.3,1.1-0.6,2.1-0.9,3.2 c-0.3,1-0.6,2-0.9,3c-0.2,0.7-0.5,1.4-0.7,2.1c-0.2,0.5-0.3,1-0.6,1.6c-0.3,1-0.7,1.9-1.1,2.9c-2.9,7.6-8.9,19.2-17.5,29.2 c-8.1,9.4-17.9,16-28.1,20.3c-1.1,0.5-1.8,1.5-1.8,2.7V191c0,1.2,0.8,2.3,2,2.8c11.2,3.9,16.2,9.1,16.6,9.4c0.5,0.5,0.8,1.2,0.8,2 v12.3c0,1.3,0.8,2.4,2,2.8c10.8,3.5,15.8,7.1,16.2,7.4c0.7,0.5,1.1,1.4,1.1,2.3v14.4c0,2.6-1.6,4.7-3.9,5.5 c-0.6,0.2-1.2,0.3-1.9,0.3h-122c-0.5,0-0.9-0.1-1.3-0.3c-0.9-0.4-1.6-1.4-1.6-2.6l-0.1-17.5c0-0.9,0.4-1.8,1.2-2.3 c0.4-0.3,5.3-3.8,15.9-7.2c1.2-0.4,2-1.5,2-2.8l-0.1-11.7c0-0.7,0.3-1.4,0.8-2c0.3-0.4,5.7-6.1,17.8-10.3c1.2-0.4,2-1.5,2-2.8 v-17.4c0-1.2-0.8-2.3-1.9-2.7c-11.6-4.3-24.5-14.1-31.6-22.1c-2.9-3.2-12.1-15.7-17.3-29.4c-0.4-0.9-0.7-1.9-1.1-2.9 c-0.4-1.1-0.8-2.3-1.2-3.4c-0.4-1.2-0.7-2.3-1-3.5c-0.3-1.1-0.6-2.2-0.9-3.3c-0.1-0.4-0.2-0.9-0.3-1.4c-0.1-0.4-0.2-0.9-0.3-1.4 c-0.2-0.7-0.3-1.4-0.5-2.2c0-0.1,0-0.1,0-0.2c-0.2-0.9-0.3-1.7-0.5-2.6c0-0.1-0.1-0.3-0.1-0.4c-0.2-1-0.4-2.1-0.6-3.2 c-0.1-0.2-0.1-0.4-0.1-0.7c-0.2-1-0.4-2-0.5-3c-0.1-0.2-0.1-0.4-0.1-0.7c-0.1-0.6-0.2-1.2-0.2-1.8c-0.1-0.6-0.2-1.2-0.3-1.8 c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3 c-0.1-0.8-0.1-1.6-0.2-2.3c0-0.7-0.1-1.3-0.1-2l-0.1-1.4c-0.1-1.1-0.1-2.2-0.2-3.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-1.4-0.1-2.7-0.1-4.1c0-1.6-0.1-3.1-0.1-4.7v-52c0-3.2,2.6-5.8,5.8-5.8h160.6c1.6,0,2.9,1.3,2.9,2.9l0,17.4 l0,23.2v0.1L212.7,64.1z"/><path style="fill:#ff9f28 !important;" d="M212.7,49.5L212.7,49.5l0-23.3l0-17.4c0-1.6-1.3-2.9-2.9-2.9H128V7c0.4,0.5,0.6,1.1,0.6,1.7 c0,1.6,1.3,2.9,2.9,2.9H181v46.2L141.5,58l-13.4-38.2L128,20v88.5l0.1,0l40.4,19.2l-13.3-44.6L181,58.8v5.4 c0,5.4-0.1,10.6-0.4,15.8c-0.2,3-0.4,5.9-0.7,8.8c-0.5,5.7-1.3,11.2-2.3,16.4c-0.1,0.6-0.2,1.2-0.3,1.7c-0.2,0.9-0.4,1.9-0.6,2.8 c-0.3,1.6-0.7,3.3-1.1,4.9c-0.2,0.8-0.4,1.6-0.6,2.4c-0.6,2.3-1.3,4.5-2,6.7c-0.3,0.8-0.5,1.6-0.8,2.4c-0.3,0.8-0.5,1.6-0.9,2.4 c-0.3,0.9-0.7,1.8-1,2.6c-0.4,0.9-0.8,1.8-1.1,2.7c-0.3,0.6-0.5,1.1-0.8,1.7c-0.2,0.4-0.3,0.8-0.5,1.1c-0.3,0.6-0.6,1.2-0.9,1.8 c-0.2,0.5-0.5,1-0.8,1.5c-0.3,0.6-0.7,1.2-1,1.8c-0.2,0.3-0.4,0.7-0.6,1c-1.3,2.2-2.7,4.2-4.1,6.1c-0.5,0.6-0.9,1.2-1.4,1.8 c-2,2.4-4.1,4.7-6.4,6.6c-0.7,0.6-1.4,1.2-2.2,1.8c-0.4,0.3-0.8,0.7-1.3,1c-0.6,0.5-1.3,0.9-2,1.4c-0.2,0.1-0.3,0.2-0.4,0.3 c-0.6,0.4-1.2,0.8-1.8,1.1c-0.7,0.4-1.5,0.8-2.2,1.2c-0.3,0.2-0.6,0.3-0.9,0.4c0,0-0.1,0-0.2,0.1c-0.7,0.3-1.4,0.7-2.2,1 c-0.6,0.3-1.2,0.5-1.9,0.8c-0.3,0.1-0.7,0.3-1.1,0.4c-0.8,0.3-1.7,0.6-2.5,0.8c-0.9,0.3-1.9,0.5-2.9,0.8c0,0,0,0,0,0 c-0.7,0.2-1.5,0.3-2.2,0.5c-0.8-0.1-1.5-0.3-2.2-0.4c1.3,0.3,2.2,1.5,2.2,2.8v3.6c0.1,0,0.2,0,0.3-0.1c1.9-0.2,6.1-0.6,10.4-1 c0.5-0.1,1.1-0.1,1.7-0.2c1.1-0.1,2.1-0.2,3.1-0.3c0.9-0.1,1.8-0.2,2.5-0.3c1.8-0.2,3.3,1.1,3.3,2.9v12.6c0,1.6-1.3,2.9-2.9,2.9 c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9-0.1c-0.5,0-1-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.4,0-0.9-0.1-1.3-0.1c-0.6,0-1.2-0.1-1.8-0.1 c-0.8-0.1-1.6-0.1-2.4-0.1c-2.5-0.1-5-0.3-7-0.4h-0.2c-1.6,0-2.9,1.3-2.9,2.9v0.2c0,0,0,0,0,0c0,1.5-1,2.7-2.5,2.9 c-0.2,0-0.4,0.1-0.6,0.1c1-0.2,2-0.3,3-0.4c0.8,0.1,1.7,0.2,2.5,0.3h0c0.8,0.1,1.6,0.2,2.5,0.3c2.2,0.4,4.5,0.8,6.7,1.2 c1.6,0.3,3.1,0.6,4.6,1c0.9,0.2,1.9,0.4,2.8,0.6c0.8,0.2,1.6,0.4,2.3,0.6c0.1,0,0.2,0.1,0.3,0.1c0.9,0.2,1.7,0.4,2.5,0.7 c0.1,0,0.2,0,0.3,0.1c2,0.5,3.8,1,5.5,1.6h0c0.7,0.2,1.4,0.4,2,0.6c1,0.3,1.9,0.6,2.8,0.9c0.5,0.2,1,0.3,1.4,0.5 c0.7,0.3,1.4,0.5,2,0.8c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.4,0.2c0.8,0.5,1.3,1.5,1.3,2.4v6.4 c0,1.8-1.6,3.2-3.4,2.8c-2.7-0.4-6-0.9-9.7-1.2c-1.9-0.2-3.9-0.4-6-0.6c-0.4,0-0.8-0.1-1.3-0.1c-2.4-0.2-4.8-0.4-7.2-0.6 c-0.2,0-0.4,0-0.5,0c-0.6,0-1.2-0.1-1.8-0.1l-1-0.1c-1.1-0.1-2.2-0.2-3.3-0.2c-2.3-0.1-4.6-0.3-6.5-0.4v0c-0.9,0.1-2,0.1-3.1,0.2 c1.7-0.1,3.1,1.2,3.1,2.9c0,1.5,1.1,2.7,2.6,2.9c0,0,0,0,0,0c0,0,0.1,0,0.1,0c1.7,0.1,3.4,0.3,5.1,0.4c2.6,0.2,5.2,0.5,7.8,0.8 c1.5,0.2,3,0.4,4.5,0.6c1.6,0.2,3.1,0.4,4.7,0.7c2.3,0.4,4.5,0.8,6.6,1.2c0.7,0.1,1.4,0.3,2.1,0.4c2.8,0.5,5.4,1.1,7.9,1.7 c0.6,0.1,1.2,0.3,1.8,0.4c1.2,0.3,2.3,0.6,3.4,0.8c0.9,0.2,1.8,0.5,2.6,0.7c3.1,0.9,5.8,1.7,7.7,2.4c0.5,0.2,1,0.4,1.5,0.6 c0.1,0,0.1,0.1,0.2,0.1c0.4,0.2,0.8,0.3,1.1,0.5c0.2,0.1,0.3,0.2,0.4,0.3v9.9c0,1.6-1.3,2.9-2.9,2.9h-54.6c-1.6,0-2.8,1.2-2.9,2.8 l0,0.2c0,1.1-0.7,2-1.6,2.5c-0.4,0.2-0.8,0.3-1.2,0.3h63.3c0.7,0,1.3-0.1,1.9-0.3c2.3-0.8,3.9-2.9,3.9-5.5v-14.4 c0-0.9-0.4-1.8-1.1-2.3c-0.4-0.3-5.4-3.9-16.2-7.4c-1.2-0.4-2-1.5-2-2.8v-12.3c0-0.8-0.3-1.5-0.8-2c-0.3-0.3-5.4-5.5-16.6-9.4 c-1.2-0.4-2-1.5-2-2.8v-18.8c0-1.2,0.7-2.2,1.8-2.7c10.3-4.3,20-11,28.1-20.3c8.7-9.9,14.7-21.6,17.5-29.2c0.4-0.9,0.7-1.9,1.1-2.9 c0.2-0.5,0.4-1,0.6-1.6c0.3-0.7,0.5-1.4,0.7-2.1c0.3-1,0.6-2,0.9-3c0.3-1,0.6-2.1,0.9-3.2c0.2-0.8,0.4-1.6,0.6-2.3 c0-0.1,0.1-0.3,0.1-0.4c0.2-0.8,0.4-1.7,0.6-2.5c0.2-1.1,0.5-2.2,0.7-3.2c0.2-1,0.4-2,0.6-3.1c0.1-0.4,0.2-0.8,0.3-1.3 c0.7-3.9,1.2-7.9,1.6-12c0.1-1.3,0.3-2.6,0.3-4c0.1-0.3,0.1-0.6,0.1-1c0.1-1,0.1-2,0.2-3.1c0.1-0.3,0.1-0.7,0.1-1.1 c0.1-1.4,0.1-2.9,0.1-4.3c0-1.6,0.1-3.1,0.1-4.7L212.7,49.5z"/><path style="fill:#FFFB00 !important;" d="M128.2,247.3l0-0.2c0.1-1.6,1.4-2.8,2.9-2.8H72.5c-1.6,0-2.8-1.3-2.9-2.8v-0.1l0-8.2v-0.1 c0-1.2,0.8-2.2,1.9-2.6c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.2,1.1-0.4,1.7-0.6c1-0.3,2.1-0.7,3.3-1c0.4-0.1,0.8-0.3,1.3-0.4 c0.4-0.1,0.9-0.3,1.4-0.4c0.5-0.2,1-0.3,1.6-0.4c0.4-0.1,0.9-0.2,1.3-0.3c0.2-0.1,0.4-0.1,0.5-0.2c0.8-0.2,1.7-0.4,2.6-0.6 c1.1-0.3,2.2-0.5,3.4-0.8c0.1,0,0.3-0.1,0.4-0.1c0.7-0.2,1.3-0.3,2-0.4c1-0.2,2.1-0.4,3.2-0.7c0.3-0.1,0.7-0.1,1.1-0.2 c0.9-0.2,1.9-0.4,2.9-0.5c5.4-1,11.4-1.9,17.6-2.6c0.8-0.1,1.6-0.2,2.4-0.3c1.4-0.2,2.8-0.3,4.2-0.4c0.9-0.1,1.8-0.2,2.7-0.2 c0.9-0.1,1.8-0.1,2.7-0.2v-0.1c0.1,0,0.2,0,0.2,0c0.9,0,1.7,0.1,2.6,0.2c-1.5-0.2-2.6-1.4-2.6-2.9c0-1.7-1.4-3-3.1-2.9 c-0.9,0.1-1.9,0.1-2.9,0.2c-0.9,0.1-1.8,0.1-2.7,0.2c-0.5,0-0.9,0.1-1.4,0.1c-0.6,0-1.2,0.1-1.7,0.1c-3.2,0.2-6.5,0.5-9.7,0.8 c-1.9,0.2-3.8,0.3-5.6,0.5c-0.9,0.1-1.8,0.2-2.6,0.3c-3,0.3-5.8,0.7-7.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.6,0.1-1.1,0.2-1.6,0.3 l-0.1-9.4v-0.1c0-1.1,0.7-2.1,1.6-2.5c0.2-0.1,0.4-0.2,0.6-0.3c1.9-0.9,4.7-1.9,8.3-3.1c3.8-1.2,8.3-2.5,13.1-3.7 c0.1,0,0.2,0,0.3-0.1c0.9-0.2,1.8-0.4,2.7-0.6c3.4-0.8,6.9-1.5,10.4-2c0.2,0,0.4-0.1,0.6-0.1c1.4-0.2,2.5-1.4,2.5-2.9c0,0,0,0,0,0 v-0.2c0-1.6,1.3-2.9,2.9-2.9c-1.2-0.1-2.2-0.2-2.9-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.7,0.1c-0.4,0-0.9,0.1-1.4,0.1 c-0.3,0-0.5,0-0.8,0c-0.3,0-0.6,0-0.9,0.1c-0.6,0-1.2,0.1-1.9,0.1c-0.3,0-0.7,0-1,0.1c-0.3,0-0.7,0-1.1,0.1h0 c-0.6,0-1.2,0.1-1.8,0.1c-2.1,0.1-4.2,0.2-5.9,0.3c-0.4,0-0.8,0.1-1.2,0.1c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0 c-0.7,0.1-1.3,0.1-1.6,0.2v-15c0-1.7,1.4-3,3.1-2.9h0.1c0.4,0,0.8,0.1,1.3,0.1c0.7,0,1.4,0.1,2.2,0.2c0.4,0,0.9,0.1,1.4,0.1 c0.1,0,0.2,0,0.3,0c0.5,0,0.9,0,1.4,0.1c0.6,0,1.2,0.1,1.8,0.1c0.6,0,1.2,0.1,1.7,0.1c0.1,0,0.2,0,0.3,0c1,0.1,1.9,0.1,2.7,0.2 c0,0,0,0,0.1,0c1.4,0.1,2.5,0.2,3.1,0.3V171c0-1.3-1-2.5-2.2-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.8-0.2-1.7-0.4-2.5-0.6 c-0.2-0.1-0.4-0.1-0.7-0.2c-0.9-0.3-1.7-0.5-2.5-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.6-0.6-2.3-0.9c-0.9-0.4-1.8-0.8-2.7-1.2 c-2.5-1.2-4.8-2.5-7-4.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.8-0.5-1.5-1.1-2.3-1.7c-0.8-0.6-1.5-1.2-2.2-1.9c-0.7-0.6-1.5-1.3-2.2-2 c-2.1-2.1-4.1-4.3-5.9-6.7c-0.6-0.8-1.2-1.6-1.8-2.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.7-1-1.5-1.5-2.2c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.4-0.7-0.9-1.4-1.3-2.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.5-0.8-0.9-1.6-1.3-2.4c-0.2-0.4-0.4-0.7-0.6-1.1c-0.4-0.7-0.7-1.4-1.1-2.1 c-0.5-1-1-2-1.4-3.1c-1-2.3-1.9-4.6-2.8-7.1c-0.4-1-0.7-2.1-1-3.1c-0.3-1-0.7-2.1-1-3.2c-0.7-2.4-1.3-4.8-1.9-7.3 c-0.3-1.2-0.6-2.4-0.8-3.6c-0.3-1.4-0.6-2.8-0.8-4.2c-0.1-0.8-0.3-1.5-0.4-2.2c-0.1-0.8-0.3-1.5-0.4-2.3c-0.2-1.1-0.3-2.3-0.5-3.5 c-0.1-0.9-0.2-1.9-0.3-2.9c-0.1-0.7-0.2-1.4-0.2-2c-0.1-1.3-0.3-2.5-0.4-3.8c-0.1-0.9-0.1-1.8-0.2-2.8c-0.1-1-0.2-2.1-0.2-3.2 c0-0.1,0-0.1,0-0.1c-0.1-1.7-0.2-3.4-0.3-5.2c0-0.1,0-0.3,0-0.4c0-1.6-0.1-3.3-0.1-4.9c0-1.8-0.1-3.6-0.1-5.4v-49 c0-1.6,1.3-2.9,2.9-2.9H128h3.5c-1.6,0-2.9-1.3-2.9-2.9c0-0.7-0.2-1.3-0.6-1.7V5.9H49.1c-3.2,0-5.8,2.6-5.8,5.8v52 c0,1.6,0,3.1,0.1,4.7c0,1.4,0.1,2.8,0.1,4.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0,0.4c0.1,1.1,0.1,2.2,0.2,3.2 l0.1,1.4c0,0.7,0.1,1.4,0.1,2c0.1,0.8,0.1,1.6,0.2,2.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.4,0.1,0.6 c0,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.6,0.2,1.2,0.3,1.8c0.1,0.6,0.1,1.2,0.2,1.8c0,0.2,0.1,0.4,0.1,0.7 c0.1,1,0.3,2.1,0.5,3c0,0.2,0.1,0.4,0.1,0.7c0.2,1.1,0.4,2.1,0.6,3.2c0,0.1,0,0.3,0.1,0.4c0.2,0.9,0.3,1.7,0.5,2.6 c0,0.1,0,0.1,0,0.2c0.2,0.7,0.3,1.4,0.5,2.2c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.5,0.2,0.9,0.3,1.4c0.3,1.1,0.6,2.2,0.9,3.3 c0.3,1.2,0.7,2.3,1,3.5c0.4,1.2,0.8,2.3,1.2,3.4c0.4,1,0.7,2,1.1,2.9c5.3,13.7,14.4,26.2,17.3,29.4c7.1,8,20,17.8,31.6,22.1 c1.1,0.4,1.9,1.5,1.9,2.7v17.4c0,1.3-0.8,2.4-2,2.8c-12.1,4.1-17.5,9.9-17.8,10.3c-0.5,0.5-0.8,1.2-0.8,2l0.1,11.7 c0,1.3-0.8,2.4-2,2.8c-10.6,3.4-15.5,6.9-15.9,7.2c-0.7,0.5-1.2,1.4-1.2,2.3l0.1,17.5c0,1.1,0.6,2.1,1.6,2.6 c0.4,0.2,0.9,0.3,1.3,0.3h58.7c0.4,0,0.9-0.1,1.2-0.3C127.6,249.4,128.2,248.4,128.2,247.3z"/><polygon style="fill:#FFFB00 !important;" points="74.1,57.8 101.1,83.3 87.4,127.7 128,108.5 128,20 114.2,57.8 "/></g></symbol><symbol id="icon-learn-cup-detailed" viewBox="0 0 256 256"><g><path style="fill:#FFD700 !important;" d="M212.1,64.1c0,1.6,0,3.1-0.1,4.7c0,1.5-0.1,2.9-0.1,4.3c0,0.4,0,0.7-0.1,1.1c0,1-0.1,2.1-0.2,3.1 c0,0.3,0,0.6-0.1,1c-0.1,1.3-0.2,2.7-0.3,4c-0.4,4.2-0.9,8.2-1.6,12c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,1-0.4,2.1-0.6,3.1 c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.9-0.4,1.7-0.6,2.5c0,0.2-0.1,0.3-0.1,0.4c-0.2,0.8-0.4,1.6-0.6,2.3c-0.3,1.1-0.6,2.1-0.9,3.2 c-0.3,1-0.6,2-0.9,3c-0.2,0.7-0.5,1.4-0.7,2.1c-0.2,0.5-0.3,1-0.6,1.6c-0.3,1-0.7,1.9-1.1,2.9c-2.9,7.6-8.9,19.2-17.5,29.2 c-8.1,9.4-17.9,16-28.1,20.3c-1.1,0.5-1.8,1.5-1.8,2.7v18.8c0,1.2,0.8,2.3,2,2.8c11.2,3.9,16.2,9.1,16.6,9.4c0.5,0.5,0.8,1.2,0.8,2 v12.3c0,1.3,0.8,2.4,2,2.8c10.8,3.5,15.8,7.1,16.2,7.4c0.7,0.5,1.1,1.4,1.1,2.3v14.4c0,2.6-1.6,4.7-3.9,5.5 c-0.6,0.2-1.2,0.3-1.9,0.3H66.1c-0.5,0-0.9-0.1-1.3-0.3c-0.9-0.4-1.6-1.4-1.6-2.6l-0.1-17.5c0-0.9,0.4-1.8,1.2-2.3 c0.4-0.3,5.3-3.8,15.9-7.2c1.2-0.4,2-1.5,2-2.8l-0.1-11.7c0-0.7,0.3-1.4,0.8-2c0.3-0.4,5.7-6.1,17.8-10.3c1.2-0.4,2-1.5,2-2.8 v-17.4c0-1.2-0.8-2.3-1.9-2.7c-11.6-4.3-24.5-14.1-31.6-22.1c-2.9-3.2-12.1-15.7-17.3-29.4c-0.4-0.9-0.7-1.9-1.1-2.9 c-0.4-1.1-0.8-2.3-1.2-3.4c-0.4-1.2-0.7-2.3-1-3.5c-0.3-1.1-0.6-2.2-0.9-3.3c-0.1-0.4-0.2-0.9-0.3-1.4c-0.1-0.4-0.2-0.9-0.3-1.4 c-0.2-0.7-0.3-1.4-0.5-2.2c0-0.1,0-0.1,0-0.2c-0.2-0.9-0.3-1.7-0.5-2.6c0-0.1-0.1-0.3-0.1-0.4c-0.2-1-0.4-2.1-0.6-3.2 c-0.1-0.2-0.1-0.4-0.1-0.7c-0.2-1-0.4-2-0.5-3c-0.1-0.2-0.1-0.4-0.1-0.7c-0.1-0.6-0.2-1.2-0.2-1.8c-0.1-0.6-0.2-1.2-0.3-1.8 c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3 c-0.1-0.8-0.1-1.6-0.2-2.3c0-0.7-0.1-1.3-0.1-2l-0.1-1.4c-0.1-1.1-0.1-2.2-0.2-3.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3 s0-0.2,0-0.3c0-1.4-0.1-2.7-0.1-4.1c0-1.6-0.1-3.1-0.1-4.7V11.7c0-3.2,2.6-5.8,5.8-5.8h160.6c1.6,0,2.9,1.3,2.9,2.9l0,17.4l0,23.2 v0.1L212.1,64.1z"/><path style="fill:#FFFB00 !important;" d="M127.6,247.3l0-0.2c0.1-1.6,1.3-2.8,2.9-2.8H71.8c-1.6,0-2.8-1.3-2.9-2.8v-0.1l0-8.2v-0.1 c0-1.2,0.8-2.2,1.9-2.6c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.2,1.1-0.4,1.7-0.6c1-0.3,2.1-0.7,3.3-1c0.4-0.1,0.8-0.3,1.3-0.4 c0.4-0.1,0.9-0.3,1.4-0.4c0.5-0.2,1-0.3,1.6-0.4c0.4-0.1,0.9-0.2,1.3-0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.8-0.2,1.7-0.4,2.6-0.6 c1.1-0.3,2.2-0.5,3.4-0.8c0.1,0,0.3-0.1,0.4-0.1c0.7-0.2,1.3-0.3,2-0.4c1-0.2,2.1-0.4,3.2-0.7c0.3-0.1,0.7-0.1,1.1-0.2 c0.9-0.2,1.9-0.4,2.9-0.5c5.4-1,11.4-1.9,17.6-2.6c0.8-0.1,1.6-0.2,2.3-0.3c1.4-0.2,2.8-0.3,4.2-0.4c0.9-0.1,1.8-0.2,2.7-0.2 c0.9-0.1,1.8-0.1,2.7-0.2v-0.1c0.1,0,0.2,0,0.2,0c0.9,0,1.7,0.1,2.6,0.2c-1.5-0.2-2.6-1.4-2.6-2.9c0-1.7-1.4-3-3.1-2.9 c-0.9,0.1-1.9,0.1-2.9,0.2c-0.9,0.1-1.8,0.1-2.7,0.2c-0.4,0-0.9,0.1-1.4,0.1c-0.6,0-1.2,0.1-1.7,0.1c-3.2,0.2-6.5,0.5-9.7,0.8 c-1.9,0.2-3.8,0.3-5.6,0.5c-0.9,0.1-1.8,0.2-2.6,0.3c-3,0.3-5.8,0.7-7.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.6,0.1-1.1,0.2-1.6,0.3 l0-9.4v-0.1c0-1.1,0.7-2.1,1.6-2.5c0.2-0.1,0.4-0.2,0.6-0.3c1.9-0.9,4.8-1.9,8.3-3.1c3.8-1.2,8.3-2.5,13.1-3.7c0.1,0,0.2,0,0.3-0.1 c0.9-0.2,1.8-0.4,2.7-0.6c3.4-0.8,7-1.5,10.4-2c0.2,0,0.4-0.1,0.5-0.1c1.4-0.2,2.5-1.4,2.5-2.9v-0.2c0-1.6,1.3-2.9,2.9-2.9 c-1.2-0.1-2.2-0.2-2.9-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.7,0.1c-0.4,0-0.9,0.1-1.4,0.1c-0.3,0-0.5,0-0.8,0 c-0.3,0-0.6,0-0.9,0.1c-0.6,0-1.2,0.1-1.9,0.1c-0.3,0-0.7,0-1,0.1c-0.3,0-0.7,0-1.1,0.1h0c-0.6,0-1.2,0.1-1.8,0.1 c-2.1,0.1-4.2,0.2-5.9,0.3c-0.4,0-0.8,0.1-1.2,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.7,0.1-1.3,0.1-1.6,0.2v-15 c0-1.7,1.4-3,3.1-2.9h0.1c0.4,0,0.8,0.1,1.2,0.1c0.7,0,1.4,0.1,2.2,0.2c0.4,0,0.9,0.1,1.4,0.1c0.1,0,0.2,0,0.3,0 c0.5,0,0.9,0,1.4,0.1c0.6,0,1.2,0.1,1.8,0.1c0.6,0,1.1,0.1,1.7,0.1c0.1,0,0.2,0,0.3,0c1,0.1,1.9,0.1,2.7,0.2c0,0,0,0,0,0 c1.4,0.1,2.5,0.2,3.1,0.3V171c0-1.3-1-2.5-2.3-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.8-0.2-1.6-0.4-2.5-0.6c-0.2-0.1-0.5-0.1-0.7-0.2 c-0.9-0.3-1.7-0.5-2.5-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.6-0.6-2.3-0.9c-0.9-0.4-1.8-0.8-2.7-1.2c-2.5-1.2-4.8-2.5-7.1-4.1 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2l21.9-10.4V95.2l-8.4,23.1l-24.5,0l16.5,15.5l-7.5,24.3 c-0.7-0.6-1.5-1.2-2.2-1.8c-0.7-0.6-1.5-1.3-2.2-2c-2.1-2.1-4.1-4.3-5.9-6.7c-0.6-0.8-1.2-1.6-1.8-2.5c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.5-0.7-1-1.5-1.5-2.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.7-0.9-1.4-1.3-2.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.4-0.8-0.9-1.6-1.3-2.4 c-0.2-0.4-0.4-0.7-0.6-1.1c-0.4-0.7-0.7-1.4-1.1-2.1c-0.5-1-1-2-1.4-3.1c-1-2.3-1.9-4.6-2.8-7.1c-0.4-1-0.7-2.1-1-3.1 c-0.3-1-0.7-2.1-1-3.2c-0.7-2.4-1.3-4.8-1.9-7.3c-0.3-1.2-0.6-2.4-0.8-3.6c-0.3-1.4-0.6-2.8-0.8-4.2c-0.1-0.8-0.3-1.5-0.4-2.2 c-0.1-0.8-0.3-1.5-0.4-2.3c-0.2-1.1-0.3-2.3-0.5-3.5c-0.1-0.9-0.3-1.9-0.3-2.9c-0.1-0.7-0.2-1.4-0.2-2c-0.1-1.3-0.3-2.5-0.4-3.8 c-0.1-0.9-0.2-1.8-0.2-2.8c-0.1-1-0.2-2.1-0.2-3.2c0-0.1,0-0.1,0-0.1c-0.1-1.7-0.2-3.4-0.3-5.2c0-0.1,0-0.3,0-0.4 c-0.1-1.6-0.1-3.3-0.1-4.9c0-1.8-0.1-3.6-0.1-5.4v-49c0-1.6,1.3-2.9,2.9-2.9H112v67.5l15.5,15.5h0.4V8.8c0-1.6-1.3-2.9-2.9-2.9 H48.5c-3.2,0-5.8,2.6-5.8,5.8v14.5c0,1.6-1.3,2.9-2.9,2.9H11.6C5.2,29.2,0,34.4,0,40.8v22.9C0,117,28.5,139,67.7,147.6 c0.6,0.1,1.1,0.4,1.6,0.9c9.1,10.5,20,17.8,31.6,22.1c1.1,0.4,1.9,1.5,1.9,2.7v17.4c0,1.3-0.8,2.4-2,2.8 c-12.1,4.1-17.5,9.9-17.8,10.3c-0.5,0.5-0.8,1.2-0.8,2l0,11.7c0,1.3-0.8,2.4-2,2.8c-10.6,3.4-15.5,6.9-15.9,7.2 c-0.7,0.5-1.2,1.4-1.2,2.3l0.1,17.5c0,1.1,0.7,2.1,1.6,2.6c0.4,0.2,0.8,0.3,1.3,0.3h58.7c0.4,0,0.9-0.1,1.2-0.3 C126.9,249.4,127.5,248.4,127.6,247.3z M48.2,122.8c-0.1-0.1-0.2-0.1-0.3-0.2c-1.3-0.7-2.6-1.4-3.8-2.2c-1.2-0.8-2.4-1.5-3.5-2.4 c-0.6-0.4-1.1-0.8-1.6-1.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.2-0.3-0.3-0.5-0.5c-0.4-0.3-0.7-0.6-1.1-0.9 c-0.6-0.5-1.2-1.1-1.7-1.6c-0.2-0.2-0.5-0.5-0.7-0.7c-0.3-0.3-0.6-0.7-0.9-1c-0.5-0.5-1-1.1-1.4-1.6c-0.4-0.5-0.9-1.1-1.3-1.6 c-0.2-0.3-0.4-0.5-0.6-0.8c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4-0.6-0.8-1.2-1.2-1.7c-0.4-0.6-0.8-1.2-1.1-1.8c-0.3-0.5-0.6-1-0.9-1.6 c-0.3-0.6-0.6-1.2-0.9-1.8c-0.3-0.5-0.5-1-0.8-1.6v0c-0.3-0.5-0.5-1.1-0.7-1.6c-0.2-0.5-0.4-1-0.6-1.6c-0.3-0.9-0.6-1.7-0.9-2.6 c-0.3-0.9-0.6-1.8-0.8-2.7c-0.2-0.8-0.4-1.6-0.6-2.5c-0.2-0.7-0.3-1.3-0.4-2c-0.1-0.5-0.2-1-0.3-1.5c-0.1-0.6-0.2-1.2-0.3-1.8 c-0.1-0.7-0.3-1.5-0.3-2.3c-0.1-0.6-0.2-1.2-0.3-1.9c0-0.1,0-0.2,0-0.2c-0.1-0.7-0.2-1.5-0.2-2.2c-0.1-0.6-0.1-1.1-0.2-1.7 c-0.1-1-0.1-2-0.2-3c0-0.6-0.1-1.3-0.1-1.9v-0.3c0-0.5,0-1.1-0.1-1.7c0-0.8,0-1.6,0-2.3V49.5c0-1.6,1.3-2.9,2.9-2.9h19.4 c1.6,0,2.9,1.3,2.9,2.9v14.1c0,1.6,0,3.1,0.1,4.7c0,1.4,0.1,2.8,0.1,4.1c0,0.1,0,0.2,0,0.3s0,0.2,0,0.3c0,0.1,0,0.3,0,0.4 c0,1.1,0.1,2.2,0.2,3.2l0.1,1.4c0,0.7,0.1,1.4,0.2,2c0.1,0.8,0.1,1.6,0.2,2.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2 c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.6,0.2,1.2,0.2,1.8c0.1,0.6,0.2,1.2,0.3,1.8 c0,0.2,0.1,0.4,0.1,0.7c0.2,1,0.3,2.1,0.5,3c0,0.2,0.1,0.4,0.1,0.7c0.2,1.1,0.4,2.1,0.6,3.2c0,0.1,0,0.3,0.1,0.4 c0.2,0.9,0.3,1.7,0.5,2.6c0,0.1,0,0.1,0,0.2c0.2,0.7,0.3,1.4,0.5,2.2c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.5,0.2,0.9,0.3,1.4 c0.3,1.1,0.6,2.2,0.9,3.3c0.3,1.2,0.7,2.3,1.1,3.5c0.4,1.2,0.8,2.3,1.2,3.4c0.3,1,0.7,2,1.1,2.9C52.8,121.4,50.4,123.7,48.2,122.8z "/><path style="fill:#ff9f28 !important;" d="M255.9,37.9c0-4.8-3.9-8.7-8.7-8.7h-32.3c-1.6,0-2.9-1.3-2.9-2.9l0-17.4c0-1.6-1.3-2.9-2.9-2.9h-81.1v2.9v85.8 h0.4l15.5-15.5V11.7h36.5v52.4c0,5.3-0.1,10.6-0.4,15.8c-0.2,3-0.4,5.9-0.7,8.8c-0.5,5.7-1.3,11.2-2.3,16.4 c-0.1,0.6-0.2,1.2-0.3,1.7c-0.2,0.9-0.4,1.9-0.6,2.8c-0.3,1.6-0.7,3.3-1.1,4.9c-0.2,0.8-0.4,1.6-0.6,2.4c-0.6,2.3-1.3,4.5-2,6.7 c-0.3,0.8-0.5,1.6-0.8,2.4c-0.3,0.8-0.6,1.6-0.9,2.4c-0.3,0.9-0.7,1.8-1,2.6c-0.4,0.9-0.8,1.8-1.2,2.7c-0.2,0.6-0.5,1.1-0.8,1.7 c-0.2,0.4-0.3,0.8-0.5,1.1c-0.3,0.6-0.6,1.2-0.9,1.8c-0.2,0.5-0.5,1-0.8,1.5c-0.3,0.6-0.7,1.2-1,1.8c-0.2,0.3-0.4,0.7-0.6,1 c-1.3,2.2-2.7,4.2-4.2,6.1c-0.4,0.6-0.9,1.2-1.4,1.8c-2,2.4-4.1,4.7-6.4,6.6c0,0-0.1,0.1-0.1,0.1l-7-23.5l16.3-15.4l-24.7,0 L128,95.1l0,0.1v54.1l0,0l21.1,10c-0.3,0.2-0.5,0.4-0.8,0.6c-0.6,0.5-1.3,0.9-2,1.4c-0.1,0.1-0.3,0.2-0.4,0.3 c-0.6,0.4-1.2,0.8-1.9,1.1c-0.7,0.4-1.5,0.8-2.2,1.2c-0.3,0.2-0.6,0.3-0.9,0.4c0,0-0.1,0-0.2,0.1c-0.7,0.3-1.4,0.7-2.2,1 c-0.6,0.3-1.2,0.5-1.9,0.8c-0.3,0.1-0.7,0.3-1,0.4c-0.8,0.3-1.7,0.6-2.5,0.8c-0.9,0.3-1.9,0.5-2.9,0.8c0,0,0,0,0,0 c-0.7,0.2-1.5,0.3-2.2,0.5v2.3v3.6c0.1,0,0.2,0,0.3-0.1c1.9-0.2,6.1-0.6,10.4-1c0.6-0.1,1.1-0.1,1.7-0.2c1.1-0.1,2.1-0.2,3.1-0.3 c0.9-0.1,1.8-0.2,2.5-0.3c1.7-0.2,3.3,1.1,3.3,2.9v12.6c0,1.6-1.3,2.9-2.9,2.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9-0.1 c-0.5,0-0.9-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.4,0-0.9-0.1-1.4-0.1c-0.6,0-1.2-0.1-1.8-0.1c-0.8-0.1-1.6-0.1-2.4-0.1 c-2.5-0.1-5-0.3-7-0.4h-0.2c-1.6,0-2.9,1.3-2.9,2.9v0.2v2.5c0.8,0.1,1.7,0.2,2.5,0.3h0c0.8,0.1,1.6,0.2,2.4,0.3 c2.2,0.4,4.5,0.8,6.7,1.2c1.6,0.3,3.1,0.6,4.6,1c0.9,0.2,1.9,0.4,2.8,0.6c0.8,0.2,1.6,0.4,2.3,0.6c0.1,0,0.2,0.1,0.3,0.1 c0.9,0.2,1.7,0.4,2.5,0.7c0.1,0,0.2,0,0.3,0.1c2,0.5,3.8,1,5.5,1.6h0c0.7,0.2,1.4,0.4,2,0.6c1,0.3,1.9,0.6,2.8,0.9 c0.5,0.2,1,0.3,1.4,0.5c0.8,0.3,1.4,0.5,2,0.8c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0.2 c0.8,0.5,1.3,1.5,1.3,2.4v6.4c0,1.8-1.6,3.2-3.4,2.8c-2.7-0.4-6-0.9-9.7-1.2c-1.9-0.2-3.9-0.4-6-0.6c-0.4,0-0.8-0.1-1.3-0.1 c-2.4-0.2-4.8-0.4-7.2-0.6c-0.2,0-0.3,0-0.5,0c-0.6,0-1.2-0.1-1.8-0.1l-1-0.1c-1.1-0.1-2.2-0.2-3.3-0.2c-2.3-0.1-4.6-0.3-6.5-0.4v0 v3.1c0,1.5,1.1,2.7,2.6,2.9c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c1.7,0.1,3.4,0.3,5.1,0.4c2.6,0.2,5.3,0.5,7.8,0.8c1.5,0.2,3,0.4,4.5,0.6 c1.6,0.2,3.1,0.4,4.7,0.7c2.3,0.4,4.5,0.8,6.6,1.2c0.7,0.1,1.4,0.3,2.1,0.4c2.8,0.5,5.4,1.1,7.9,1.7c0.6,0.1,1.2,0.3,1.8,0.4 c1.2,0.3,2.3,0.6,3.4,0.8c0.9,0.2,1.8,0.5,2.6,0.7c3.1,0.9,5.7,1.7,7.7,2.4c0.5,0.2,1,0.4,1.5,0.6c0.1,0,0.1,0.1,0.2,0.1 c0.4,0.2,0.8,0.3,1.1,0.5c0.2,0.1,0.3,0.2,0.4,0.3v9.9c0,1.6-1.3,2.9-2.9,2.9h-54.6c-1.6,0-2.8,1.2-2.9,2.8l0,0.2 c0,1.1-0.7,2-1.6,2.5c-0.4,0.2-0.8,0.3-1.2,0.3H188c0.7,0,1.3-0.1,1.9-0.3c2.3-0.8,3.9-2.9,3.9-5.5v-14.4c0-0.9-0.4-1.8-1.2-2.3 c-0.4-0.3-5.4-3.9-16.2-7.4c-1.2-0.4-2-1.5-2-2.8v-12.3c0-0.8-0.3-1.5-0.8-2c-0.3-0.3-5.3-5.5-16.6-9.4c-1.2-0.4-2-1.5-2-2.8v-18.8 c0-1.2,0.7-2.2,1.8-2.7c10.3-4.3,19.9-11,28.1-20.3c0.4-0.5,1-0.8,1.6-0.9c10.7-2.1,20.8-5.3,29.7-9.8c26.8-13.7,39.8-37.9,39.8-74 c0,0,0,0,0,0L255.9,37.9z M238.4,70.1c0,0.7-0.1,1.5-0.1,2.2l-0.1,0.8c0,0.6-0.1,1.2-0.2,1.8c-0.1,1.3-0.3,2.5-0.4,3.7 c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.7-0.2,1.3-0.4,1.9c-0.1,0.5-0.2,1.1-0.4,1.6c-0.3,1.2-0.6,2.4-0.9,3.5 c-0.5,1.6-1,3.2-1.6,4.7c-0.2,0.5-0.3,0.9-0.6,1.4c-0.5,1.2-1,2.4-1.5,3.5c-0.3,0.6-0.6,1.2-0.9,1.8c-0.3,0.5-0.5,1-0.8,1.5 c-0.2,0.3-0.4,0.7-0.6,1c-0.7,1.2-1.5,2.3-2.2,3.4c-0.3,0.4-0.6,0.9-1,1.3c-0.7,0.9-1.4,1.8-2.2,2.7c-0.6,0.7-1.2,1.4-1.9,2 c-0.9,0.9-1.8,1.7-2.7,2.5c-0.3,0.3-0.7,0.6-1.1,0.9c-0.4,0.3-0.8,0.7-1.3,1c-0.5,0.4-1,0.8-1.5,1.1c-0.5,0.4-1.1,0.8-1.7,1.1 c-2.3,1.5-4.8,2.9-7.4,4.2c0,0-0.1,0-0.1,0c-2.3,1-4.8-1.3-3.9-3.7c0.4-0.9,0.7-1.9,1.1-2.9c0.2-0.5,0.4-1,0.5-1.6 c0.3-0.7,0.5-1.4,0.7-2.1c0.3-1,0.6-2,0.9-3c0.3-1,0.6-2.1,0.9-3.2c0.2-0.8,0.4-1.6,0.6-2.3c0-0.1,0.1-0.3,0.1-0.4 c0.2-0.8,0.4-1.7,0.6-2.5c0.2-1.1,0.5-2.2,0.7-3.2c0.2-1,0.4-2,0.6-3.1c0.1-0.4,0.2-0.8,0.3-1.3c0.7-3.9,1.2-7.9,1.6-12 c0.1-1.3,0.3-2.6,0.3-4c0-0.3,0.1-0.6,0.1-1c0.1-1,0.1-2,0.2-3.1c0-0.3,0.1-0.7,0.1-1.1c0.1-1.4,0.1-2.9,0.2-4.3 c0-1.6,0.1-3.1,0.1-4.7l0-14.6v-0.1c0-1.6,1.3-2.8,2.9-2.8h20.7c1.6,0,2.8,1.3,2.9,2.8v0.1l0.1,14.9 C238.6,66.3,238.5,68.2,238.4,70.1z"/></g></symbol><symbol id="icon-learn-cup-empty-default" viewBox="0 0 256 256"><g><path class="st0" d="M142.4,183.4c22.9-4.7,41.8-20.3,50.9-41.2h0.3c3.1-7,5-14.6,5.7-22.6l0-12.1l0-15.1l-0.1-49.7V28.4 c0-7.9-6.4-14.2-14.2-14.2H71.1c-7.9,0-14.2,6.4-14.2,14.2v92.8c0.8,7.4,2.7,14.4,5.5,21h0.5c9.1,20.9,28,36.6,50.9,41.2v0.4v29.5 H99.6c-15.7,0-28.4,12.7-28.4,28.4H185c0-15.7-12.7-28.4-28.4-28.4h-14.2v-29.6V183.4z M128,156.5c-17,0-32.3-10.1-39.1-25.6 l-3.6-8.2v-80h34h17.5h33.8l0,13.5l0.1,66.5l-3.6,8.2C160.3,146.5,145,156.5,128,156.5z"/></g></symbol><symbol id="icon-learn-cup-empty" viewBox="0 0 256 256"><path d="M241.8,42.7h-42.7V28.4c0-7.9-6.4-14.2-14.2-14.2H71.1c-7.9,0-14.2,6.4-14.2,14.2v14.2H14.2C6.4,42.7,0,49,0,56.9v28.4 c0,22.9,15.2,56.9,56.9,56.9h6c9.1,20.9,28,36.6,50.9,41.2v29.9H99.6c-15.7,0-28.4,12.7-28.4,28.4h113.8c0-15.7-12.7-28.4-28.4-28.4 h-14.2v-29.9c22.9-4.7,41.8-20.3,50.9-41.2h6c41.7,0,56.9-34,56.9-56.9V56.9C256,49,249.6,42.7,241.8,42.7z M56.9,113.8 c-26,0-28.3-21.8-28.4-28.4V71.1h28.4V113.8z M170.7,122.7l-3.6,8.2c-6.8,15.6-22.1,25.6-39.1,25.6s-32.3-10.1-39.1-25.6l-3.6-8.2 v-80h85.3L170.7,122.7L170.7,122.7z M227.6,85.3c0,4.8-1.4,28.4-28.4,28.4V71.1h28.4V85.3z"/></symbol><symbol id="icon-learn-cup" viewBox="0 0 256 256"><path d="M71.1,14.2c-7.8,0-14.2,6.4-14.2,14.2v14.2H14.2C6.4,42.7,0,49,0,56.9v28.4c0,22.9,15.2,56.9,56.9,56.9h6 c9.1,20.9,28,36.6,50.9,41.2v29.9H99.6c-15.7,0-28.5,12.7-28.5,28.5H135V14.2H71.1z M56.9,113.8c-26,0-28.3-21.9-28.5-28.5V71.1 h28.5V113.8z"/><path class="st0" style="fill:#FF9F28 !important" d="M241.8,42.7h-42.7V28.4c0-7.8-6.4-14.2-14.2-14.2H128v227.6h56.9c0-15.7-12.7-28.5-28.4-28.5h-14.2v-29.9 c22.9-4.7,41.8-20.3,50.9-41.2h6c41.7,0,56.9-34,56.9-56.9V56.9C256,49,249.6,42.7,241.8,42.7z M227.6,85.3 c0,4.8-1.4,28.5-28.5,28.5V71.1h28.5V85.3z"/></symbol><symbol id="icon-learn-medal" viewBox="0 0 256 256"><polygon points="184.5,182.88 142.12,182.96 128.05,143 113.56,182.8 71.5,182.82 99.83,209.47 85.5,256 128.05,235.85 170.38,256 156.5,209.26 "/><polygon points="128.71,142.25 139.37,131.59 139.37,0 116.94,0 116.94,131.9 127.29,142.25 "/><polygon points="113.83,0 100.75,0 100.75,115.71 113.83,128.79 "/><polygon points="155.25,0 142.17,0 142.17,128.79 155.25,115.71 "/></symbol><symbol id="icon-logo-android" viewBox="0 0 256 256"><path d="M224 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM32 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm24 104c0 13.255 10.745 24 24 24h8v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h8c13.255 0 24-10.745 24-24V96H56v88zM157.65 22.374l10.125-19.452c.508-.975.125-2.19-.85-2.697s-2.19-.125-2.698.85l-10.28 19.747C145.898 17.71 137.15 16 128 16c-9.15 0-17.898 1.71-25.95 4.82L91.773 1.077c-.508-.976-1.72-1.358-2.697-.85s-1.358 1.72-.85 2.697l10.124 19.452C75.69 32.63 59.29 54.27 56.443 80h143.11c-2.844-25.73-19.246-47.372-41.905-57.626zM96 67.6c-6.406 0-11.6-5.194-11.6-11.6 0-6.407 5.194-11.6 11.6-11.6 6.407 0 11.6 5.193 11.6 11.6 0 6.406-5.193 11.6-11.6 11.6zm64 0c-6.406 0-11.6-5.194-11.6-11.6 0-6.407 5.193-11.6 11.6-11.6 6.405 0 11.6 5.193 11.6 11.6 0 6.406-5.194 11.6-11.6 11.6z"/></symbol><symbol id="icon-logo-apple" viewBox="0 0 256 256"><path d="M197.875 136.022c-.324-32.42 26.44-47.97 27.635-48.74-15.037-22.006-38.462-25.02-46.81-25.37-19.936-2.018-38.9 11.738-49.017 11.738-10.093 0-25.706-11.438-42.24-11.138-21.728.323-41.763 12.634-52.95 32.095-22.577 39.175-5.782 97.21 16.222 128.982 10.752 15.55 23.573 33.02 40.406 32.395 16.212-.647 22.342-10.49 41.94-10.49 19.6 0 25.107 10.49 42.263 10.168 17.444-.324 28.496-15.85 39.174-31.45 12.347-18.04 17.43-35.508 17.73-36.405-.387-.178-34.015-13.06-34.352-51.786zM165.64 40.88c8.936-10.84 14.966-25.878 13.32-40.88-12.87.524-28.47 8.573-37.702 19.388-8.285 9.594-15.538 24.906-13.593 39.61 14.366 1.12 29.03-7.303 37.976-18.118z"/></symbol><symbol id="icon-logo-cc" viewBox="0 0 256 256"><path d="M129.662 162.677c-8.634 0-15.18-3.155-19.615-9.467-4.457-6.31-6.652-14.71-6.652-25.222 0-23.114 8.762-34.67 26.268-34.67 3.498 0 7.292 1.172 11.387 3.497 4.07 2.347 7.527 6.44 10.34 12.262L177.64 95.41c-10.49-18.913-27.91-28.38-52.196-28.38-16.588 0-30.28 5.48-41.15 16.46C73.435 94.47 68 109.31 68 127.987c0 19.146 5.372 34.117 16.12 44.86 10.725 10.746 24.884 16.122 42.388 16.122 10.96 0 21.002-2.752 30.105-8.252 9.106-5.497 16.248-13.025 21.387-22.62l-24.18-12.265c-4.668 11.218-12.73 16.844-24.158 16.844zM255.988 126.28C255.042 55.603 196.95-.928 126.288.02 55.595.964-.936 59.03.01 129.705.96 200.384 59.022 256.93 129.714 255.98c70.677-.932 127.222-59.01 126.274-129.7zM129.34 229.036c-55.81.76-101.65-43.88-102.396-99.688-.747-55.812 43.89-101.65 99.702-102.397 55.797-.746 101.637 43.893 102.383 99.69s-43.88 101.635-99.69 102.396z"/></symbol><symbol id="icon-logo-facebook" viewBox="0 0 256 256"><path d="M148.148 256H100.18V128h-32V83.888l32-.015-.052-25.988c0-35.988 9.76-57.885 52.15-57.885h35.294v44.12h-22.06c-16.507 0-17.3 6.165-17.3 17.672l-.066 22.08h39.674l-4.677 44.113-34.963.015-.032 128z"/></symbol><symbol id="icon-logo-github" viewBox="0 0 256 256"><path d="M128 0C57.308 0 0 57.308 0 128s57.308 128 128 128 128-57.308 128-128S198.692 0 128 0zm76.014 204.014c-9.88 9.88-21.377 17.633-34.177 23.047-3.25 1.376-6.554 2.583-9.9 3.624V211.5c0-10.084-3.458-17.5-10.374-22.25 4.333-.416 8.313-1 11.938-1.75s7.46-1.834 11.5-3.25c4.042-1.416 7.667-3.104 10.876-5.063 3.208-1.96 6.29-4.5 9.25-7.625 2.958-3.125 5.438-6.666 7.438-10.625s3.583-8.71 4.75-14.25c1.166-5.54 1.75-11.646 1.75-18.313 0-12.917-4.21-23.917-12.625-33 3.832-10 3.415-20.875-1.25-32.625l-3.126-.376c-2.167-.25-6.063.667-11.688 2.75s-11.938 5.5-18.938 10.25c-9.917-2.75-20.21-4.125-30.875-4.125-10.75 0-21 1.374-30.75 4.124-4.417-3-8.604-5.48-12.563-7.438s-7.125-3.292-9.5-4-4.583-1.146-6.625-1.313-3.354-.208-3.938-.125-1 .167-1.25.25c-4.667 11.833-5.083 22.708-1.25 32.625-8.417 9.083-12.625 20.083-12.625 33 0 6.666.583 12.77 1.75 18.313s2.75 10.29 4.75 14.25 4.48 7.5 7.438 10.625 6.042 5.667 9.25 7.626 6.833 3.646 10.875 5.063 7.875 2.5 11.5 3.25 7.604 1.333 11.938 1.75c-6.833 4.665-10.25 12.083-10.25 22.25v19.557c-3.774-1.124-7.495-2.45-11.15-3.997-12.8-5.414-24.297-13.168-34.177-23.047-9.88-9.88-17.633-21.378-23.046-34.177-5.6-13.238-8.44-27.315-8.44-41.836s2.84-28.598 8.44-41.837c5.413-12.798 13.166-24.297 23.046-34.176 9.88-9.88 21.378-17.634 34.176-23.047 13.24-5.6 27.317-8.44 41.838-8.44s28.598 2.84 41.838 8.44c12.8 5.413 24.297 13.166 34.177 23.046 9.88 9.88 17.633 21.378 23.046 34.176 5.6 13.24 8.44 27.316 8.44 41.837s-2.84 28.597-8.44 41.837c-5.414 12.8-13.167 24.298-23.046 34.177z"/></symbol><symbol id="icon-logo-instagram" viewBox="0 0 256 256"><path d="M127.95 23.086c34.183 0 38.196.152 51.707.762 12.495.56 19.25 2.64 23.77 4.42 5.994 2.335 10.262 5.08 14.73 9.548 4.47 4.47 7.264 8.736 9.55 14.73 1.728 4.52 3.86 11.276 4.42 23.77.608 13.512.76 17.525.76 51.71 0 34.183-.15 38.196-.76 51.707-.56 12.495-2.642 19.25-4.42 23.77-2.337 5.994-5.08 10.262-9.55 14.73-4.47 4.47-8.736 7.264-14.73 9.55-4.52 1.728-11.275 3.86-23.77 4.42-13.51.608-17.524.76-51.708.76-34.185 0-38.198-.15-51.71-.76-12.494-.56-19.25-2.642-23.77-4.42-5.994-2.337-10.26-5.08-14.73-9.55-4.47-4.47-7.264-8.736-9.55-14.73-1.726-4.52-3.86-11.275-4.418-23.77-.61-13.51-.762-17.524-.762-51.708s.152-38.197.762-51.708c.56-12.495 2.64-19.25 4.42-23.77 2.335-5.995 5.08-10.26 9.548-14.73s8.736-7.265 14.73-9.55c4.52-1.727 11.276-3.86 23.77-4.42 13.512-.66 17.525-.76 51.71-.76m0-23.062c-34.744 0-39.112.152-52.775.762-13.613.61-22.908 2.794-31.035 5.943-8.432 3.25-15.543 7.67-22.654 14.78-7.11 7.112-11.48 14.274-14.78 22.655C3.555 52.292 1.37 61.587.76 75.25.152 88.864 0 93.233 0 127.976c0 34.742.152 39.11.762 52.774.61 13.61 2.794 22.907 5.943 31.085 3.25 8.432 7.67 15.543 14.78 22.653 7.112 7.11 14.274 11.48 22.655 14.78 8.127 3.15 17.422 5.335 31.086 5.944 13.663.61 17.98.762 52.774.762 34.793 0 39.11-.152 52.774-.762 13.612-.61 22.908-2.794 31.086-5.943 8.432-3.25 15.543-7.67 22.653-14.782 7.11-7.11 11.48-14.272 14.78-22.653 3.15-8.127 5.335-17.423 5.944-31.086s.763-17.982.763-52.775-.152-39.11-.762-52.774c-.61-13.612-2.794-22.907-5.943-31.085-3.25-8.432-7.67-15.543-14.78-22.654-7.11-7.11-14.273-11.478-22.654-14.78-8.126-3.15-17.422-5.333-31.085-5.943C167.06.177 162.69.025 127.95.025zM127.95 62.248c-36.268 0-65.728 29.41-65.728 65.727s29.46 65.727 65.727 65.727 65.726-29.46 65.726-65.727-29.46-65.727-65.727-65.727zm0 108.393c-23.57 0-42.668-19.097-42.668-42.665s19.098-42.667 42.667-42.667 42.665 19.098 42.665 42.667-19.097 42.666-42.666 42.666z"/><circle cx="196.267" cy="59.657" r="15.34"/></symbol><symbol id="icon-logo-twitter" viewBox="0 0 256 256"><path d="M256 48.605c-9.42 4.177-19.54 7-30.165 8.27 10.844-6.5 19.172-16.792 23.094-29.058-10.15 6.02-21.39 10.39-33.354 12.745-9.58-10.207-23.23-16.585-38.337-16.585-29.007 0-52.522 23.515-52.522 52.52 0 4.116.464 8.125 1.36 11.97-43.65-2.19-82.35-23.1-108.254-54.876-4.52 7.758-7.11 16.78-7.11 26.405 0 18.222 9.27 34.298 23.364 43.716-8.61-.27-16.708-2.635-23.788-6.568-.005.22-.005.44-.005.66 0 25.447 18.104 46.675 42.13 51.5-4.406 1.2-9.046 1.844-13.836 1.844-3.385 0-6.675-.33-9.883-.943 6.684 20.865 26.08 36.052 49.063 36.475-17.975 14.086-40.622 22.482-65.23 22.482-4.238 0-8.42-.248-12.528-.735 23.243 14.903 50.85 23.6 80.51 23.6 96.605 0 149.433-80.03 149.433-149.437 0-2.276-.05-4.542-.152-6.795C240.056 68.387 248.96 59.138 256 48.605z"/></symbol><symbol id="icon-logo-windows" viewBox="0 0 256 256"><path d="M.093 119.467L0 36.247l102.4-13.905v97.125H.093zm119.374-99.605L255.967 0v119.467h-136.5V19.862zM256 136.532L255.967 256l-136.5-19.204V136.533H256zm-153.6 98.09L.083 220.6l-.005-84.064H102.4v98.09z"/></symbol><symbol id="icon-logo-youtube" viewBox="0 0 256 256"><path d="M208 32H48C21.6 32 0 53.6 0 80v96c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48V80c0-26.4-21.6-48-48-48zM96 192V64l80 64-80 64z"/></symbol><symbol id="icon-logout" viewBox="0 0 256 256"><path d="M247.25,132.53c0,65.75-53.5,119.25-119.25,119.25S8.75,198.28,8.75,132.53C8.75,71.86,54.3,21.62,113,14.22V29.36 C62.6,36.65,23.75,80.14,23.75,132.53c0,57.48,46.77,104.25,104.25,104.25c57.48,0,104.25-46.77,104.25-104.25 c0-52.391-38.85-95.88-89.25-103.17V14.22C201.7,21.62,247.25,71.86,247.25,132.53z"/><path d="M128,142.53c-5.523,0-10-4.478-10-10V14.22c0-5.522,4.477-10,10-10c5.522,0,10,4.478,10,10V132.53 C138,138.053,133.522,142.53,128,142.53z"/></symbol><symbol id="icon-menu-academy" viewBox="0 0 256 256"><g><g><path d="M24,208v5c0,8.9,6,16.8,14.6,19.1l73.5,23.1c1.7,0.5,3.5,0.7,5.2,0.7c4.3,0,8.5-1.4,12-4.1c4.9-3.8,7.8-12.7,7.8-19v-2.2 h75c10.9,0,19.8-8.9,19.8-19.8V44.7c0-11-8.9-19.9-19.8-19.9h-74.8v-2.2c0-6.2-2.8-14.7-7.7-18.5c-4.9-3.8-11.1-5-17.1-3.5 L38.8,22.7C30.1,25,24,32.9,24,42v5.6 M24.2,179.5V190 M24.2,151v10.5 M24.2,122.5V133 M24.2,94v10.5 M24.2,65.6V76 M119.3,232.9 c0,0.7-0.4,1.2-0.7,1.4c-0.3,0.3-0.9,0.5-1.6,0.3l-14.6-3.9l-58.9-15.8c-0.8-0.2-1.3-0.9-1.3-1.8V42c0-0.8,0.6-1.5,1.3-1.8 L102,24.9l15-3.9c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.8,0.2,1.1,0.4c0.3,0.3,0.7,0.7,0.7,1.4V232.9z M137.3,190v-10.4h31.4c5,0,9-4,9-9 s-4-9-9-9h-31.4v-10.5h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4v-10.4h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V94.1h56.4c5,0,9-4,9-9s-4-9-9-9 h-56.4V65.6 M137.3,47.6V43h74.9c1,0,1.8,0.8,1.8,1.8V211c0,1-0.8,1.8-1.8,1.8h-74.8v-4.6"/></g><path d="M59.1,103c-4.3,0-8.1-3.1-8.9-7.5c-0.8-4.9,2.4-9.6,7.3-10.4l40.5-7c4.9-0.8,9.6,2.4,10.4,7.3c0.8,4.9-2.4,9.6-7.3,10.4 l-40.5,7C60.2,103,59.6,103,59.1,103z"/><path d="M59.1,127c-4.5,0-8.4-3.4-8.9-7.9c-0.6-4.9,3-9.4,7.9-10l25.5-3c4.9-0.6,9.4,3,10,7.9c0.6,4.9-3,9.4-7.9,10l-25.5,3 C59.8,127,59.5,127,59.1,127z"/></g></symbol><symbol id="icon-menu-collection" viewBox="0 0 256 256"><path d="M229.705 38.5h-18.977l-1.875-9.362c-1.734-8.38-9.104-14.375-17.346-14.534-.12-.01-.234-.085-.355-.085-1.2 0-2.42.083-3.647.335l-22.37 4.622-3.957-8.832c-2.99-6.685-9.62-10.665-16.53-10.665-2.456 0-4.95.504-7.33 1.564L19.49 54.348c-9.057 4.06-13.154 14.804-9.085 23.862l72.55 162.436c1.323 8.673 8.814 15.854 17.852 15.854h128.898c9.977 0 17.795-9.17 17.795-19.146V55.95c0-9.975-7.818-17.45-17.795-17.45zM25.8 71.308c-.243-.553.038-1.313.6-1.556l20.393-9.142c.057.58.15 1.172.272 1.753L68.807 167.27 25.8 71.308zM82.5 55.95v95.418L63.47 58.94c-.065-.3.063-.59.25-.88.188-.282.462-.45.763-.517l18.268-3.806c-.094.723-.25 1.463-.25 2.213zm108.605-24.602c.084-.02.402-.027.402-.027s.873.632.994 1.242l1.164 5.94h-20.27l-1.183-2.938 18.895-4.216zm-46.888-14.4c.14-.067.28-.096.432-.096.28 0 .88.142 1.133.685l2.43 5.42-32.385 6.713 28.39-12.723zM230.5 237.353c0 .646-.138 2.146-.795 2.146H100.807c-.656 0-1.307-1.5-1.307-2.146V55.95c0-.646.65-.45 1.307-.45h129.02c.647 0 .673-.196.673.45v181.404zM215.5 82c0 4.142-3.357 7.5-7.5 7.5h-86c-4.142 0-7.5-3.358-7.5-7.5v-2c0-4.142 3.358-7.5 7.5-7.5h86c4.143 0 7.5 3.358 7.5 7.5v2zM215.5 113c0 4.142-3.357 7.5-7.5 7.5h-86c-4.142 0-7.5-3.358-7.5-7.5v-2c0-4.142 3.358-7.5 7.5-7.5h86c4.143 0 7.5 3.358 7.5 7.5v2zM215.5 145c0 4.143-3.357 7.5-7.5 7.5h-86c-4.142 0-7.5-3.357-7.5-7.5v-2c0-4.143 3.358-7.5 7.5-7.5h86c4.143 0 7.5 3.357 7.5 7.5v2zM187.5 177c0 4.143-3.358 7.5-7.5 7.5h-58c-4.142 0-7.5-3.357-7.5-7.5v-2c0-4.143 3.358-7.5 7.5-7.5h58c4.142 0 7.5 3.357 7.5 7.5v2z"/></symbol><symbol id="icon-menu-exam" viewBox="0 0 256 256"><g><path class="st0" d="M202.7,256H53.3c-12.9,0-23.5-10.5-23.5-23.5V23.5C29.8,10.5,40.3,0,53.3,0h149.5c12.9,0,23.5,10.5,23.5,23.5 v209.1C226.2,245.5,215.7,256,202.7,256z M53.3,17.6c-3.2,0-5.9,2.6-5.9,5.9v209.1c0,3.2,2.6,5.9,5.9,5.9h149.5 c3.2,0,5.9-2.6,5.9-5.9V23.5c0-3.2-2.6-5.9-5.9-5.9H53.3z"/><g><path class="st0" d="M192.5,46.4H63.5c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8S197.3,46.4,192.5,46.4 z"/><path class="st0" d="M192.5,74.2H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8 C201.3,70.3,197.3,74.2,192.5,74.2z"/><path class="st0" d="M192.5,102H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8 C201.3,98.1,197.3,102,192.5,102z"/><path class="st0" d="M192.5,129.8H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8 C201.3,125.9,197.3,129.8,192.5,129.8z"/><path class="st0" d="M192.5,157.7H63.5c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8 S197.3,157.7,192.5,157.7z"/><path class="st0" d="M108.5,185.5H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h44.9c4.9,0,8.8,3.9,8.8,8.8 C117.2,181.5,113.3,185.5,108.5,185.5z"/></g><path class="st0" d="M163.2,228.1c-2.6,0-5-1.1-6.7-3.1L143,209.1c-3.1-3.7-2.7-9.2,1-12.4c3.7-3.1,9.2-2.7,12.4,1l6.6,7.8 l21.2-26.3c3-3.8,8.6-4.4,12.4-1.3c3.8,3,4.4,8.6,1.3,12.4l-27.8,34.5c-1.6,2-4.1,3.2-6.7,3.3C163.3,228.1,163.3,228.1,163.2,228.1 z"/></g></symbol><symbol id="icon-menu-exercisebook" viewBox="0 0 256 256"><g><path class="st0" d="M218.5,0.3H56c-12.3,0-22.3,10-22.3,22.3v3.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9 h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5 c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9 h9.5v3.3c0,12.3,10,22.3,22.3,22.3h162.5c12.3,0,22.3-10,22.3-22.3v-211C240.7,10.3,230.8,0.3,218.5,0.3z M222.7,233.4 c0,2.3-1.9,4.3-4.3,4.3H56c-2.3,0-4.3-1.9-4.3-4.3v-3.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3 h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5V137h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9 s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-3.3 c0-2.3,1.9-4.3,4.3-4.3h162.5c2.3,0,4.3,1.9,4.3,4.3v210.9H222.7z"/><path class="st0" d="M197.5,62.1H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,62.1,197.5,62.1z"/><path class="st0" d="M197.5,119H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,119,197.5,119z"/><path class="st0" d="M197.5,175.9H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,175.9,197.5,175.9z"/><path class="st0" d="M197.5,33.7H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,33.7,197.5,33.7z"/><path class="st0" d="M197.5,90.6H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,90.6,197.5,90.6z"/><path class="st0" d="M197.5,147.4H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,147.4,197.5,147.4z"/><path class="st0" d="M158.3,204.3H85c-5,0-9,4-9,9s4,9,9,9h73.3c5,0,9-4,9-9S163.2,204.3,158.3,204.3z"/></g></symbol><symbol id="icon-menu-group" viewBox="0 0 256 256"><g><path class="st0" d="M216.1,165.9c-4.9,0-9.6,0.9-13.9,2.5l-28.8-39.7c13.8-12.4,22.6-30.5,22.6-50.5c0-37.5-30.5-67.9-67.9-67.9 S60.1,40.8,60.1,78.2c0,19.3,8.1,36.8,21.2,49.2L53,168.2c-4.1-1.4-8.5-2.2-13.1-2.2c-22,0-39.9,17.9-39.9,39.9 s17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9c0-10.8-4.3-20.6-11.3-27.8l27.7-39.9c7,3.7,14.6,6.3,22.8,7.4V167 c-17.6,4.2-30.7,20-30.7,38.8c0,22,17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9c0-18.8-13.1-34.7-30.7-38.8v-21.5 c7.5-1,14.6-3.2,21.1-6.5l28.8,39.6c-6.7,7.1-10.7,16.7-10.7,27.2c0,22,17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9 S238.1,165.9,216.1,165.9z M39.9,227.4c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6c11.9,0,21.6,9.7,21.6,21.6 C61.4,217.7,51.8,227.4,39.9,227.4z M78.4,78.2c0-27.4,22.3-49.6,49.6-49.6c27.4,0,49.6,22.3,49.6,49.6c0,27.4-22.3,49.6-49.6,49.6 C100.6,127.8,78.4,105.6,78.4,78.2z M149.6,205.8c0,11.9-9.7,21.6-21.6,21.6s-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6 S149.6,193.9,149.6,205.8z M216.1,227.4c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6c11.9,0,21.6,9.7,21.6,21.6 C237.7,217.7,228,227.4,216.1,227.4z"/></g></symbol><symbol id="icon-menu-how-to" viewBox="0 0 256 256"><path d="M126.09 17.457c9.648 0 18.46 1.36 26.173 4.036 7.423 2.58 13.842 6.212 19.075 10.785 5.117 4.477 9 9.704 11.863 15.968 2.855 6.254 4.24 13.204 4.24 21.25 0 10.204-3.13 18.882-9.567 26.528-7.02 8.337-18.854 15.386-35.17 20.952-7.105 2.424-11.96 9.003-12.18 16.508l-.056 1.85h-24.33V113.94c5.78-1.685 10.767-3.114 15.138-4.34 6.987-1.952 12.782-4.14 17.703-6.675 6.52-3.353 11.63-7.753 15.2-13.1 3.836-5.76 5.78-12.83 5.78-21.02 0-9.22-3.8-17.673-10.7-23.806-6.667-5.928-16.222-8.688-30.07-8.688-11.12 0-21.727 2.105-31.534 6.263-3.536 1.503-6.867 2.886-9.975 4.142l-6.26-17.45c2.27-1.11 4.928-2.162 7.953-3.143 6.057-1.965 12.29-3.6 18.53-4.855 6.378-1.287 12.337-2.262 17.692-2.897 7.05-.826 9.687-.916 10.494-.916m-6.556 176.647c3.03 0 5.686.52 8.112 1.584 2.672 1.175 5 2.77 7.097 4.866 2.11 2.113 3.708 4.44 4.878 7.104 1.07 2.437 1.59 5.093 1.59 8.122 0 3.03-.52 5.686-1.588 8.12-1.172 2.67-2.765 4.992-4.862 7.09-2.113 2.11-4.44 3.707-7.104 4.878-2.436 1.068-5.093 1.588-8.122 1.588-3.086 0-5.846-.54-8.435-1.648-2.64-1.13-4.85-2.64-6.77-4.62-2.162-2.228-3.865-4.718-5.215-7.637-1.08-2.32-1.603-4.862-1.603-7.77 0-2.904.525-5.45 1.61-7.785 1.343-2.9 3.05-5.396 5.22-7.634 1.91-1.97 4.12-3.478 6.754-4.606 2.592-1.11 5.352-1.65 8.438-1.65M126.09-.543c-2.535 0-6.73.352-12.594 1.04-5.865.696-12.248 1.737-19.148 3.128S80.6 6.805 73.82 9.005c-6.787 2.2-12.367 4.804-16.733 7.812-2.533 1.854-4.372 3.3-5.52 4.34-1.154 1.045-1.154 3.066 0 6.075l13.8 38.47c.984 2.363 2.137 3.55 3.46 3.55.223 0 .45-.034.68-.1 1.607-.46 3.45-1.15 5.52-2.07 5.52-2.07 12.076-4.712 19.667-7.937 7.59-3.218 15.752-4.83 24.496-4.83 8.97 0 15.01 1.38 18.113 4.14s4.657 6.212 4.657 10.352c0 4.604-.922 8.28-2.76 11.04-1.844 2.76-4.657 5.12-8.453 7.073-3.795 1.956-8.57 3.74-14.317 5.348-5.752 1.61-12.54 3.568-20.356 5.864-3.224 1.154-5.348 2.13-6.383 2.934-1.034.81-1.55 2.475-1.55 5.002v39.678c0 3.223.397 5.293 1.206 6.21.803.92 2.814 1.38 6.038 1.38h45.542c2.986 0 4.885-.46 5.693-1.38.802-.917 1.32-2.987 1.552-6.21l.345-11.73c19.548-6.67 33.925-15.467 43.127-26.395 9.196-10.92 13.8-23.632 13.8-38.123 0-10.582-1.956-20.156-5.865-28.722-3.914-8.56-9.376-15.908-16.39-22.043-7.018-6.135-15.352-10.88-25.013-14.238C148.515 1.14 137.82-.543 126.09-.543zm-6.556 176.647c-5.52 0-10.696 1.035-15.526 3.104-4.83 2.07-9.03 4.95-12.593 8.626-3.57 3.682-6.442 7.882-8.625 12.593-2.188 4.718-3.277 9.833-3.277 15.354s1.09 10.642 3.277 15.354c2.183 4.718 5.057 8.916 8.625 12.593 3.563 3.677 7.763 6.556 12.593 8.626 4.83 2.07 10.006 3.104 15.526 3.104s10.636-1.035 15.353-3.104c4.712-2.07 8.91-4.95 12.593-8.626 3.677-3.677 6.556-7.875 8.626-12.593 2.07-4.712 3.104-9.832 3.104-15.353s-1.035-10.635-3.104-15.353c-2.07-4.71-4.95-8.91-8.626-12.593-3.682-3.677-7.88-6.556-12.593-8.626-4.717-2.068-9.833-3.104-15.353-3.104z"/></symbol><symbol id="icon-menu-invitation" viewBox="-871 873 256 256"><path d="M-625.4 975.4l-26.5-23.3v-29.5c0-12.1-9.8-21.9-21.9-21.9h-36.5l-30.5-26.8c-1.3-1.1-3.2-1.1-4.5 0l-30.5 26.8h-36.5c-12.1 0-21.9 9.8-21.9 21.9V952l-26.5 23.3c-.7.7-1.2 1.6-1.2 2.6v129.2c0 12 9.8 21.8 21.9 21.8h193.7c12.1 0 21.9-9.8 21.9-21.8V977.9c.2-1-.3-1.9-1-2.5zm-126.3-74.7l8.7-7.7 8.7 7.7h-17.4zm111.4 94v112.4c0 .5-.1 1-.2 1.5l-65-56.7 65.2-57.2zm-11.6-12.1v-9.3l5.2 4.6-5.2 4.7zM-683 1009c.1 0 .1 0 .2 0l-13 11.6h-95.1l-13.4-11.9c.4.2.9.3 1.3.3h120zm15-13.2l-11.6 10.4c0-.2 0-.4 0-.6v-9.2c0-1.9-1.5-3.4-3.4-3.4h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 .6.2 1.2.5 1.7l-12.1-10.6v-74.1c0-3.3 2.5-5.8 5.8-5.8h138.4c3.2 0 5.8 2.6 5.8 5.9v73.1zm-45.8 40.9l-13 11.6h-12.6c-.2-.1-.5-.1-.7-.1l-19.6-.1-12.9-11.4h58.8zm-55.6 27.7h52.8l56.6 48.5h-166l56.6-48.5zm-11.1-12.5l-65 56.7c-.1-.5-.2-1-.2-1.5V994.7l65.2 57.2zm-58.8-74l5.2-4.6v9.3l-5.2-4.7zM-683 965.3h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 1.9 1.5 3.4 3.4 3.4h120c1.9 0 3.4-1.5 3.4-3.4v-9.2c0-1.9-1.5-3.4-3.4-3.4zM-683 937.6h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 1.9 1.5 3.4 3.4 3.4h120c1.9 0 3.4-1.5 3.4-3.4V941c0-1.9-1.5-3.4-3.4-3.4z"/></symbol><symbol id="icon-menu-new-problem" viewBox="0 0 256 256"><g><path class="st0" d="M111.7,129.1h-11v-11c0-5-4-9-9-9s-9,4-9,9v11h-11c-5,0-9,4-9,9s4,9,9,9h11v11c0,5,4,9,9,9s9-4,9-9v-11h11 c5,0,9-4,9-9S116.6,129.1,111.7,129.1z"/><path class="st0" d="M112.9,181.1c-3.5-3.5-9.2-3.5-12.7,0l-0.3,0.3c0,0,0,0,0,0l-8.2,8.2l-8.5-8.5c-3.5-3.5-9.2-3.5-12.7,0 c0,0-0.1,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.2,0.1c-3.5,3.5-3.5,9.2,0,12.7l8.5,8.5l-8.5,8.5c-3.5,3.5-3.5,9.2,0,12.7 c1.8,1.8,4.1,2.6,6.4,2.6s4.6-0.9,6.4-2.6l8.5-8.5l8.5,8.5c1.8,1.8,4.1,2.6,6.4,2.6c2.3,0,4.6-0.9,6.4-2.6c0,0,0.1-0.1,0.1-0.2 c0.1,0,0.1-0.1,0.2-0.1c3.5-3.5,3.5-9.2,0-12.7l-8.5-8.5l8.5-8.5C116.5,190.3,116.5,184.6,112.9,181.1z"/><path class="st0" d="M183.3,129.1h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,129.1,183.3,129.1z"/><path class="st0" d="M209.2,0.3H46.8c-12.3,0-22.3,10-22.3,22.3v210.8c0,12.3,10,22.3,22.3,22.3h162.5c12.3,0,22.3-10,22.3-22.3 V22.6C231.5,10.3,221.5,0.3,209.2,0.3z M213.5,233.4c0,2.3-1.9,4.3-4.3,4.3H46.8c-2.3,0-4.3-1.9-4.3-4.3V22.6 c0-2.3,1.9-4.3,4.3-4.3h162.5c2.3,0,4.3,1.9,4.3,4.3V233.4z"/><path class="st0" d="M182.3,30.1H73.8c-12.3,0-22.3,10-22.3,22.3v27.5c0,12.3,10,22.3,22.3,22.3h108.5c12.3,0,22.3-10,22.3-22.3 V52.3C204.5,40.1,194.5,30.1,182.3,30.1z M186.5,79.8c0,2.3-1.9,4.3-4.3,4.3H73.8c-2.3,0-4.3-1.9-4.3-4.3V52.3 c0-2.3,1.9-4.3,4.3-4.3h108.5c2.3,0,4.3,1.9,4.3,4.3V79.8z"/><path class="st0" d="M183.3,182h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,182,183.3,182z"/><path class="st0" d="M183.3,204.2h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,204.2,183.3,204.2z"/></g></symbol><symbol id="icon-menu-notification-full" viewBox="0 0 256 256"><path d="M157.53,236.26v2.891c0,9.29-7.561,16.85-16.851,16.85h-25.36c-9.29,0-16.85-7.56-16.85-16.85v-2.891 c0-9.29,7.56-16.85,16.85-16.85h25.36C149.97,219.41,157.53,226.97,157.53,236.26z"/><path d="M244.57,208.44c0,4.119-3.34,7.47-7.46,7.47H18.89c-4.12,0-7.46-3.351-7.46-7.47c0-4.12,3.34-7.46,7.46-7.46 c15.56,0,28.21-12.66,28.21-28.211V102.9c0-34.81,22.11-64.56,53.02-75.94c-1.05-2.2-1.65-4.64-1.65-7.22v-2.89 C98.47,7.56,106.03,0,115.32,0h25.36c9.29,0,16.851,7.56,16.851,16.85v2.89c0,2.58-0.601,5.02-1.641,7.22 c30.9,11.38,53.011,41.13,53.011,75.94v69.87c0,15.551,12.649,28.211,28.21,28.211C241.23,200.98,244.57,204.32,244.57,208.44z"/></symbol><symbol id="icon-menu-notification" viewBox="0 0 256 256"><path d="M140.68,219.41h-25.358c-9.293,0-16.854,7.561-16.854,16.854v2.882c0,9.293,7.562,16.854,16.854,16.854h25.358 c9.293,0,16.854-7.561,16.854-16.854v-2.882C157.533,226.971,149.973,219.41,140.68,219.41z M142.606,239.146 c0,1.063-0.865,1.927-1.927,1.927h-25.358c-1.063,0-1.927-0.864-1.927-1.927v-2.882c0-1.063,0.864-1.927,1.927-1.927h25.358 c1.062,0,1.927,0.864,1.927,1.927V239.146z"/><path d="M237.111,200.978c-15.558,0-28.213-12.655-28.213-28.212v-69.867c0-34.812-22.104-64.557-53.013-75.942 c1.045-2.192,1.647-4.635,1.647-7.221v-2.881C157.533,7.561,149.973,0,140.68,0h-25.358c-9.293,0-16.854,7.561-16.854,16.854v2.881 c0,2.586,0.603,5.028,1.648,7.221c-30.909,11.386-53.013,41.13-53.013,75.942v69.867c0,15.557-12.656,28.212-28.213,28.212 c-4.122,0-7.464,3.342-7.464,7.464s3.342,7.464,7.464,7.464h218.222c4.122,0,7.463-3.342,7.463-7.464 S241.233,200.978,237.111,200.978z M113.395,16.854c0-1.063,0.864-1.928,1.927-1.928h25.358c1.062,0,1.927,0.865,1.927,1.928v2.881 c0,1.063-0.865,1.928-1.927,1.928h-25.358c-1.063,0-1.927-0.864-1.927-1.928V16.854z M51.501,200.978 c6.557-7.569,10.528-17.435,10.528-28.212v-69.867c0-36.376,29.595-65.971,65.971-65.971s65.971,29.595,65.971,65.971v69.867 c0,10.777,3.972,20.643,10.53,28.212H51.501z"/></symbol><symbol id="icon-menu-premium" viewBox="-15 17 256 256"><path d="M234.5 86.7l-43.3-41.1c-3.6-3.4-8.3-5.3-13.3-5.3H48c-4.9 0-9.7 1.9-13.3 5.3L-8.5 86.7c-7.4 7-8 18.5-1.5 26.3L98.2 242.8c3.7 4.4 9.1 6.9 14.8 6.9s11.1-2.5 14.8-6.9L236 112.9c6.5-7.8 5.9-19.3-1.5-26.2zm-15.8 11.5h-39.8L159.8 80l19.8-18.8-1.7-1.7 40.8 38.7zm-121.3 0L113 83.4l15.6 14.8H97.4zm34.4 4.8L113 215.9 94.2 103h37.6zm-15.3-23l18.2-17.3L152.8 80l-18.2 17.3L116.5 80zm21.6-20.5h36.3l-18.2 17.3-18.1-17.3zM113 76.7L94.8 59.5h36.3L113 76.7zM91.3 62.8L109.5 80 91.3 97.3 73.2 80l18.1-17.2zM69.7 76.7L51.5 59.5h36.3L69.7 76.7zm15.6 21.5H54.1l15.6-14.8 15.6 14.8zm4 4.8L108 215.1 51.9 103h37.4zm47.4 0h37.4L118 215.1 136.7 103zm4-4.8l15.6-14.8 15.6 14.8h-31.2zM48 59.5l-1.7 1.7L66.2 80 47.1 98.2H7.3L48 59.5zM6.8 103h39.8l59.7 119.4L6.8 103zm112.9 119.5L179.4 103h39.8l-99.5 119.5z"/></symbol><symbol id="icon-menu-tv" viewBox="0 0 256 256"><g><path class="st0" d="M215.2,56.8H136L157.6,22c0.2,0,0.3,0,0.5,0c6,0,10.9-4.9,10.9-10.9s-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9 c0,1.8,0.5,3.5,1.2,5l-25.3,40.6h-2.4L104.9,38c-0.2-0.2-0.4-0.4-0.7-0.6c0.4-1.2,0.7-2.5,0.7-3.8c0-6-4.9-10.9-10.9-10.9 s-10.9,4.9-10.9,10.9S88,44.6,94,44.6c0.7,0,1.4-0.1,2.1-0.2c0.2,0.3,0.3,0.5,0.5,0.8l9.9,11.6H40.8C18.3,56.8,0,75,0,97.5v117.4 c0,22.5,18.3,40.8,40.8,40.8h174.4c22.5,0,40.8-18.3,40.8-40.8V97.5C256,75,237.7,56.8,215.2,56.8z M237,216.4 c0,10.7-8.7,19.5-19.5,19.5h-179c-10.7,0-19.5-8.7-19.5-19.5V96c0-10.7,8.7-19.5,19.5-19.5h179c10.7,0,19.5,8.7,19.5,19.5V216.4z"/><g><path d="M149,200.9h-9.4v-61.8c0-12.3-5.1-14.5-15.2-14.5H107c-11.9,0-14.4,6.1-14.4,11.3c0,4.2,1.9,11.3,14.4,11.3h10.1v53.8H107 c-11.9,0-14.4,6.1-14.4,11.3c0,4.2,1.9,11.3,14.4,11.3h42c12.5,0,14.4-7.1,14.4-11.3C163.4,207.1,160.9,200.9,149,200.9z"/><path d="M118.6,117.9h9.5c6.8,0,10.8-3.9,10.8-10.8v-7.9c0-6.8-3.9-10.8-10.8-10.8h-9.5c-6.8,0-10.8,3.9-10.8,10.8v7.9 C107.8,114,111.8,117.9,118.6,117.9z"/></g></g></symbol><symbol id="icon-pro" viewBox="0 0 256 256"><path d="M244,35H12C5.37,35,0,40.37,0,47v162c0,6.63,5.37,12,12,12h232c6.63,0,12-5.37,12-12V47C256,40.37,250.63,35,244,35z M84.95,133.23c0,7.34-3.59,11-10.77,11H45.63v42.71H28V69.06h46.18c7.18,0,10.77,3.61,10.77,10.84V133.23z M139.41,186.94 l-19.43-54.761v-10.62h17.32V84.2h-22.22v102.74H97.45V69.06h46.78c7.079,0,10.63,3.61,10.63,10.84v42.87 c0,4.97-1.69,8.18-5.051,9.64c-1.81,0.75-5.63,1.13-11.449,1.13l19.43,53.4H139.41z M228,176.17c0,7.19-3.57,10.78-10.7,10.78 h-38.26c-6.98,0-10.48-3.59-10.48-10.78V79.9c0-7.23,3.49-10.84,10.48-10.84h38.26c7.13,0,10.7,3.61,10.7,10.84V176.17z"/><rect x="45.63" y="84.2" width="21.54" height="44.89"/><rect x="186.19" y="84.2" width="24.18" height="87.6"/></symbol><symbol id="icon-shape-a-x" viewBox="0 0 1000 1000"><path d="M0 0v1000h1000V0H0zm575.62 812.47c0 6.092-4.942 11.03-11.036 11.03h-125.85c-6.092 0-11.03-4.938-11.03-11.03V686.617c0-6.093 4.938-11.03 11.03-11.03h125.85c6.094 0 11.035 4.937 11.035 11.03V812.47zm107.24-369.078c-22.706 26.964-58.183 48.67-106.415 65.127l-.852 101.26c-.57 7.953-1.85 13.06-3.832 15.323-1.993 2.272-6.675 3.403-14.044 3.403H445.34c-7.955 0-12.917-1.13-14.898-3.403-1.997-2.263-2.98-7.37-2.98-15.324V439.56c0-6.24 1.278-10.35 3.83-12.346 2.555-1.98 7.796-4.39 15.75-7.235 19.288-5.666 36.035-10.495 50.23-14.47 14.18-3.966 25.964-8.37 35.328-13.2 9.365-4.813 16.31-10.64 20.857-17.45 4.537-6.812 6.813-15.884 6.813-27.242 0-10.216-3.83-18.73-11.494-25.54-7.662-6.812-22.56-10.217-44.694-10.217-21.576 0-41.717 3.98-60.444 11.92-18.73 7.955-34.904 14.474-48.526 19.58-5.106 2.274-9.657 3.977-13.62 5.107-3.98 1.146-7.383-1.702-10.217-8.512l-34.052-94.924c-2.848-7.42-2.848-12.41 0-14.99 2.832-2.566 7.368-6.132 13.62-10.708 10.774-7.423 24.543-13.847 41.29-19.274 16.733-5.426 33.627-9.843 50.653-13.275 17.026-3.43 32.777-6 47.25-7.715 14.473-1.703 24.82-2.567 31.072-2.567 28.945 0 55.338 4.15 79.172 12.426 23.84 8.285 44.402 19.992 61.723 35.13 17.307 15.137 30.78 33.27 40.44 54.393 9.644 21.134 14.472 44.76 14.472 70.87 0 35.755-11.362 67.122-34.056 94.072z"/></symbol><symbol id="icon-shape-a" viewBox="0 0 256 256"><path d="M0 0h256v256H0z"/></symbol><symbol id="icon-shape-a2" viewBox="-871 873 256 256"><path d="M-665 923v156h-156V923h156m50-50h-256v256h256V873z"/></symbol><symbol id="icon-shape-arrow" viewBox="0 0 256 256"><path d="M159.216 232.36l91.43-91.43c7.14-7.142 7.14-18.72 0-25.86l-91.43-91.43c-7.142-7.14-18.72-7.14-25.86 0-7.14 7.142-7.14 18.72 0 25.86l60.214 60.214H18.286C8.186 109.714 0 117.9 0 128c0 10.1 8.187 18.286 18.286 18.286H193.57L133.356 206.5c-3.57 3.57-5.355 8.25-5.355 12.93s1.786 9.358 5.356 12.93c7.14 7.14 18.718 7.14 25.86 0z"/></symbol><symbol id="icon-shape-b-x" viewBox="0 0 1000 1000"><path d="M500 66.99L0 933.01h1000L500 66.99zm52.47 774.805c0 4.73-3.838 8.566-8.57 8.566H446.16c-4.732 0-8.568-3.835-8.568-8.565v-97.74c0-4.73 3.836-8.566 8.568-8.566H543.9c4.732 0 8.57 3.834 8.57 8.565v97.74zm.64-236.056l-.66 78.64c-.443 6.178-1.44 10.144-2.978 11.9-1.548 1.766-5.185 2.645-10.908 2.645H451.29c-6.178 0-10.032-.88-11.57-2.644-1.55-1.757-2.314-5.723-2.314-11.9V552.186c0-4.845.992-8.038 2.975-9.588 1.984-1.538 6.055-3.41 12.232-5.62 14.98-4.4 27.985-8.15 39.01-11.238 11.01-3.08 20.164-6.5 27.437-10.25 7.272-3.738 12.665-8.264 16.198-13.552 3.523-5.29 5.29-12.337 5.29-21.157 0-7.934-2.975-14.547-8.927-19.835-5.95-5.29-17.52-7.934-34.71-7.934-16.756 0-32.398 3.09-46.942 9.257-14.545 6.178-27.108 11.24-37.687 15.207-3.965 1.766-7.5 3.087-10.577 3.966-3.09.89-5.734-1.322-7.935-6.61l-26.445-73.72c-2.212-5.764-2.212-9.64 0-11.644 2.2-1.993 5.722-4.762 10.577-8.315 8.368-5.764 19.06-10.753 32.066-14.968 12.996-4.214 26.116-7.644 39.34-10.31 13.222-2.665 25.455-4.66 36.694-5.99 11.24-1.323 19.276-1.995 24.132-1.995 22.48 0 42.978 3.223 61.486 9.648 18.515 6.435 34.484 15.527 47.936 27.283 13.44 11.756 23.905 25.837 31.406 42.243 7.49 16.415 11.24 34.764 11.24 55.042 0 27.77-8.823 52.13-26.448 73.06-17.632 20.94-45.183 37.798-82.64 50.577z"/></symbol><symbol id="icon-shape-b" viewBox="0 0 256 256"><path d="M0 238.852L128 17.15l128 221.7z"/></symbol><symbol id="icon-shape-b2" viewBox="-871 873 256 256"><path d="M-743 990.1l41.4 71.7h-82.8l41.4-71.7m0-99.9l-128 221.7h256l-128-221.7z"/></symbol><symbol id="icon-shape-c-x" viewBox="0 0 1000 1000"><path d="M500 0C223.83 0 0 223.83 0 500s223.83 500 500 500 500-223.83 500-500S776.17 0 500 0zm75.62 812.47c0 6.092-4.942 11.03-11.036 11.03h-125.85c-6.092 0-11.03-4.938-11.03-11.03V686.617c0-6.093 4.938-11.03 11.03-11.03h125.85c6.094 0 11.035 4.937 11.035 11.03V812.47zm107.24-369.078c-22.706 26.964-58.183 48.67-106.415 65.127l-.852 101.26c-.57 7.953-1.85 13.06-3.832 15.323-1.993 2.272-6.675 3.403-14.044 3.403H445.34c-7.955 0-12.917-1.13-14.898-3.403-1.997-2.263-2.98-7.37-2.98-15.324V439.56c0-6.24 1.278-10.35 3.83-12.346 2.555-1.98 7.796-4.39 15.75-7.235 19.288-5.666 36.035-10.495 50.23-14.47 14.18-3.966 25.964-8.37 35.328-13.2 9.365-4.813 16.31-10.64 20.857-17.45 4.537-6.812 6.813-15.884 6.813-27.242 0-10.216-3.83-18.73-11.494-25.54-7.662-6.812-22.56-10.217-44.694-10.217-21.576 0-41.717 3.98-60.444 11.92-18.73 7.955-34.904 14.474-48.526 19.58-5.106 2.274-9.657 3.977-13.62 5.107-3.98 1.146-7.383-1.702-10.217-8.512l-34.052-94.924c-2.848-7.42-2.848-12.41 0-14.99 2.832-2.566 7.368-6.132 13.62-10.708 10.774-7.423 24.543-13.847 41.29-19.274 16.733-5.426 33.627-9.843 50.653-13.275 17.026-3.43 32.777-6 47.25-7.715 14.473-1.703 24.82-2.567 31.072-2.567 28.945 0 55.338 4.15 79.172 12.426 23.84 8.285 44.402 19.992 61.723 35.13 17.307 15.137 30.78 33.27 40.44 54.393 9.644 21.134 14.472 44.76 14.472 70.87 0 35.755-11.362 67.122-34.056 94.072z"/></symbol><symbol id="icon-shape-c" viewBox="0 0 256 256"><circle cx="128" cy="128" r="128"/></symbol><symbol id="icon-shape-c2" viewBox="-871 873 256 256"><path d="M-743 923c43 0 78 35 78 78s-35 78-78 78-78-35-78-78 35-78 78-78m0-50c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128z"/></symbol><symbol id="icon-shape-d" viewBox="0 0 256 256"><path d="M128 256L0 128.003l128-128 128 128z"/></symbol><symbol id="icon-shape-d2" viewBox="-871 873 256 256"><path d="M-743 943.7l57.3 57.3-57.3 57.3-57.3-57.3 57.3-57.3m0-70.7l-128 128 128 128 128-128-128-128z"/></symbol><symbol id="icon-shape-e" viewBox="0 0 256 256"><path d="M256 17.148L128 238.852 0 17.148z"/></symbol><symbol id="icon-shape-e2" viewBox="-871 873 256 256"><path d="M-701.6 940.2l-41.4 71.7-41.4-71.7h82.8m86.6-50h-256l128 221.7 128-221.7z"/></symbol><symbol id="icon-shape-f" viewBox="0 0 256 256"><path d="M48.892 249.736L0 99.262 128 6.264l128 92.998-48.89 150.474z"/></symbol><symbol id="icon-shape-f2" viewBox="-871 873 256 256"><path d="M-743 941.1l69.2 50.3-26.4 81.4h-85.6l-26.4-81.4 69.2-50.3m0-61.8l-128 93 48.9 150.5h158.2l48.9-150.5-128-93z"/></symbol><symbol id="icon-shape-placeholder" viewBox="0 0 256 256"><path d="M126.6,157.8h-5.1c0-7.5,0.4-13.4,1.2-17.8c0.8-4.3,1.8-7.8,3.1-10.3c1.2-2.5,4.4-7.1,9.5-13.8c4-5.2,6.8-10.1,8.5-14.8 c1.6-4.6,2.4-9.7,2.4-15.2c0-7.5-2.1-13.6-6.3-18.1c-4.2-4.6-9.4-6.9-15.5-6.9c-5.3,0-9.7,1.3-13.2,3.9c-3.5,2.6-5.3,5.3-5.3,8 c0,1.5,1.2,3.2,3.7,5.2c3.8,2.9,5.6,6.1,5.6,9.5c0,3.1-1,5.6-3,7.6c-2,2-4.5,3.1-7.5,3.1c-3.6,0-6.6-1.4-9.1-4.3 c-2.5-2.9-3.7-6.6-3.7-11.3c0-7.3,3.4-13.9,10.1-19.7c6.8-5.8,15.3-8.7,25.5-8.7c10.5,0,19.2,3.3,26.1,9.8 c6.9,6.5,10.3,14.4,10.3,23.8c0,6-1.2,11.4-3.5,16.3c-1.8,3.6-6.3,8.7-13.5,15.3c-9.4,8.4-15.1,14.6-17.1,18.6 C127.9,142,126.8,148.6,126.6,157.8z M124.3,178.5c3.2,0,5.9,1.1,8.1,3.3c2.2,2.2,3.3,4.9,3.3,8c0,3.3-1.1,6.1-3.3,8.5 c-2.2,2.3-4.9,3.5-8.1,3.5c-3.2,0-5.9-1.1-8.1-3.4c-2.2-2.3-3.3-5.1-3.3-8.5c0-3.2,1.1-5.9,3.3-8.1 C118.4,179.6,121.1,178.5,124.3,178.5z"/><path style="opacity:0.2" d="M209.5,228h-163c-10.2,0-18.5-8.3-18.5-18.5v-163C28,36.3,36.3,28,46.5,28h163c10.2,0,18.5,8.3,18.5,18.5v163 C228,219.7,219.7,228,209.5,228z"/></symbol><symbol id="icon-shape-x" viewBox="0 0 1000 1000"><path d="M576.608 788.15v194.318c0 9.403-7.628 17.03-17.046 17.03H365.26c-9.42 0-17.047-7.627-17.047-17.03V788.15c0-9.42 7.627-17.03 17.046-17.03H559.56c9.418 0 17.046 7.61 17.046 17.03zM794.782 267.343c-.016 55.215-17.556 103.636-52.59 145.25-35.064 41.64-89.834 75.147-164.302 100.562l-1.33 156.353c-.88 12.274-2.854 20.164-5.913 23.653-3.073 3.522-10.313 5.267-21.68 5.267h-173.52c-12.29 0-19.948-1.745-23.005-5.266-3.073-3.488-4.602-11.378-4.602-23.652v-262.83c0-9.636 1.977-15.98 5.914-19.053 3.953-3.058 12.043-6.78 24.318-11.18 29.785-8.754 55.647-16.212 77.558-22.342 21.894-6.13 40.1-12.923 54.55-20.38 14.453-7.428 25.185-16.43 32.21-26.944 6.994-10.516 10.515-24.52 10.515-42.06 0-15.78-5.913-28.92-17.74-39.436-11.843-10.515-34.835-15.78-69.02-15.78-33.306 0-64.402 6.146-93.322 18.405-28.92 12.274-53.903 22.34-74.934 30.23-7.876 3.506-14.9 6.146-21.03 7.892-6.146 1.76-11.396-2.625-15.765-13.14l-52.59-146.578c-4.386-11.457-4.386-19.16 0-23.145 4.37-3.97 11.38-9.465 21.03-16.538 16.645-11.457 37.906-21.385 63.753-29.754 25.847-8.384 51.926-15.21 78.22-20.505 26.28-5.296 50.6-9.264 72.957-11.904C466.81 1.842 482.775.5 492.443.5c44.684 0 85.447 6.407 122.24 19.193 36.812 12.784 68.556 30.865 95.3 54.242 26.727 23.36 47.526 51.37 62.44 83.98 14.9 32.627 22.36 69.112 22.36 109.428z"/></symbol><symbol id="icon-star" viewBox="0 0 256 256"><path d="M64.189,150.59L0.005,90.21l95.297-0.05L128.128,0l31.874,90.54l96.004-0.19l-63.436,59.77L224.024,256l-95.896-45.641 L31.728,256L64.189,150.59z"/></symbol><symbol id="icon-symbol-az" viewBox="0 0 256 256"><g><path d="M124.7,168c-2.5-2.2-5.7-3.3-9.6-3.4L79.7,70.9c-1.4-3.7-4.9-6.2-8.9-6.2H31.9c-4.2,0-7.7,1.2-10.3,3.4 c-2.8,2.5-4.4,6-4.4,9.9c0,3.9,1.6,7.4,4.4,9.9c2.6,2.3,6,3.5,10.3,3.5h9.1L14,164.5c-3.9,0.1-7.2,1.3-9.6,3.4 c-2.8,2.5-4.4,6-4.4,9.9c0,3.8,1.5,7.2,4.3,9.8c2.6,2.4,6.1,3.6,10.4,3.6h28.9c4.3,0,7.8-1.2,10.4-3.6c2.7-2.5,4.2-6,4.2-9.7 c0-3.9-1.6-7.4-4.4-9.9c-2.6-2.3-6-3.4-10.3-3.4h-1.2l3.4-9.2h37.5l3.4,9.2h-1c-4.3,0-7.8,1.2-10.4,3.4c-2.8,2.5-4.4,6-4.4,9.9 c0,3.8,1.5,7.2,4.2,9.7c2.6,2.4,6.1,3.6,10.5,3.6h28.8c4.3,0,7.8-1.2,10.4-3.6c2.7-2.5,4.2-6,4.2-9.7 C129.2,174,127.6,170.5,124.7,168z M64.3,105.3l8.8,23.3H55.7L64.3,105.3z"/><path d="M153.1,113.5h-32.4c-5.3,0-9.5,4.3-9.5,9.5v11c0,5.3,4.3,9.5,9.5,9.5h32.4c5.3,0,9.5-4.3,9.5-9.5v-11 C162.6,117.8,158.4,113.5,153.1,113.5z"/><path d="M252.4,153c-2.5-2.7-6-4.2-9.8-4.2c-3.9,0-7.4,1.6-9.9,4.4c-2.3,2.6-3.4,6-3.4,10.3v1.1h-21.5l43.7-49.1 c1.6-1.7,2.4-4,2.4-6.3v-6.9c0-5.3-4.3-9.5-9.5-9.5h-66.7c-5.3,0-9.5,4.3-9.5,9.5v18.3c0,4.3,1.2,7.8,3.6,10.4 c2.5,2.7,6,4.3,9.8,4.3c3.8,0,7.2-1.5,9.7-4.2c2.4-2.6,3.6-6.1,3.6-10.4v-1h17.3l-43.5,49.1c-1.5,1.7-2.4,4-2.4,6.3v6.9 c0,5.3,4.3,9.5,9.5,9.5h70.6c5.2,0,9.5-4.2,9.5-9.5l0.1-18.4C256,159.1,254.8,155.6,252.4,153z"/></g></symbol><symbol id="icon-symbol-back" viewBox="0 0 256 256"><path d="M216 0c4.416 0 8.188 1.563 11.313 4.688S232 11.583 232 16c0 4.5-1.54 8.292-4.625 11.375L126.625 128l100.75 100.75c3.084 3.084 4.625 6.875 4.625 11.375 0 4.416-1.563 8.166-4.688 11.25S220.416 256 216 256c-4.5 0-8.29-1.54-11.375-4.625l-112-112C89.542 136.125 88 132.333 88 128c0-4.25 1.542-8 4.625-11.25l112-112C207.79 1.583 211.585 0 216 0zM40 0c4.417 0 8.188 1.563 11.313 4.688S56 11.583 56 16v224c0 4.416-1.563 8.188-4.688 11.313S44.417 256 40 256s-8.188-1.563-11.313-4.688S24 244.416 24 240V16c0-4.417 1.563-8.188 4.688-11.313S35.583 0 40 0z"/></symbol><symbol id="icon-symbol-backspace" viewBox="0 0 256 256"><path d="M85.333 32H224c8.833 0 16.375 3.125 22.625 9.375S256 55.167 256 64v128c0 8.833-3.125 16.375-9.375 22.625S232.833 224 224 224H85.333L0 128l85.333-96zM224 53.333H94.917L28.583 128l66.333 74.667H224c2.944 0 5.458-1.042 7.542-3.125 2.083-2.084 3.125-4.598 3.125-7.542V64c0-2.944-1.042-5.458-3.125-7.542-2.084-2.083-4.598-3.125-7.542-3.125zM202.667 96c0 3-1.028 5.528-3.084 7.583L175.083 128l24.5 24.417c2.056 2.056 3.084 4.583 3.084 7.583 0 3.056-1.015 5.598-3.042 7.625s-4.57 3.042-7.625 3.042c-3 0-5.527-1.028-7.583-3.084L160 143.083l-24.417 24.5c-2.056 2.056-4.583 3.084-7.583 3.084-2.944 0-5.458-1.042-7.542-3.125-2.083-2.084-3.125-4.598-3.125-7.542 0-2.89 1.027-5.417 3.083-7.583l24.5-24.417-24.5-24.417c-2.056-2.167-3.083-4.695-3.083-7.583 0-2.944 1.042-5.458 3.125-7.542 2.083-2.083 4.597-3.125 7.542-3.125 3 0 5.527 1.028 7.583 3.083l24.417 24.5 24.417-24.5c2.056-2.055 4.583-3.083 7.583-3.083 3.056 0 5.598 1.014 7.625 3.042s3.042 4.57 3.042 7.625z"/></symbol><symbol id="icon-symbol-calculator" viewBox="0 0 256 256"><path d="M204.5,256h-153c-12.131,0-22-9.869-22-22V22c0-12.131,9.869-22,22-22h153c12.131,0,22,9.869,22,22v212 C226.5,246.131,216.631,256,204.5,256z M51.5,20c-1.103,0-2,0.897-2,2v212c0,1.103,0.897,2,2,2h153c1.103,0,2-0.897,2-2V22 c0-1.103-0.897-2-2-2H51.5z"/><g><path d="M190.104,76.727H65.898c-5.127,0-9.298-4.171-9.298-9.297V37.3c0-5.127,4.171-9.298,9.298-9.298h124.206 c5.126,0,9.297,4.171,9.297,9.298v30.129C199.4,72.556,195.229,76.727,190.104,76.727z M65.898,33.002 c-2.37,0-4.298,1.928-4.298,4.298v30.129c0,2.37,1.928,4.297,4.298,4.297h124.206c2.369,0,4.297-1.928,4.297-4.297V37.3 c0-2.37-1.928-4.298-4.297-4.298H65.898z"/><path d="M90.79,127.298H65.898c-5.127,0-9.298-4.171-9.298-9.298V92.288c0-5.126,4.171-9.297,9.298-9.297H90.79 c5.127,0,9.298,4.171,9.298,9.297V118C100.087,123.127,95.917,127.298,90.79,127.298z M65.898,87.99 c-2.37,0-4.298,1.928-4.298,4.297V118c0,2.37,1.928,4.298,4.298,4.298H90.79c2.37,0,4.298-1.928,4.298-4.298V92.288 c0-2.37-1.928-4.297-4.298-4.297H65.898z"/><path d="M140.447,127.298h-24.893c-5.127,0-9.298-4.171-9.298-9.298V92.288c0-5.126,4.171-9.297,9.298-9.297h24.893 c5.126,0,9.297,4.171,9.297,9.297V118C149.744,123.127,145.573,127.298,140.447,127.298z M115.555,87.99 c-2.37,0-4.298,1.928-4.298,4.297V118c0,2.37,1.928,4.298,4.298,4.298h24.893c2.369,0,4.297-1.928,4.297-4.298V92.288 c0-2.37-1.928-4.297-4.297-4.297H115.555z"/><path d="M190.104,127.298h-24.893c-5.127,0-9.299-4.171-9.299-9.298V92.287c0-5.126,4.172-9.296,9.299-9.296h24.893 c5.126,0,9.297,4.17,9.297,9.296V118C199.4,123.127,195.229,127.298,190.104,127.298z M165.211,87.99 c-2.37,0-4.299,1.927-4.299,4.296V118c0,2.37,1.929,4.298,4.299,4.298h24.893c2.369,0,4.297-1.928,4.297-4.298V92.287 c0-2.369-1.928-4.296-4.297-4.296H165.211z"/><path d="M90.79,177.647H65.898c-5.127,0-9.298-4.171-9.298-9.298v-25.713c0-5.126,4.171-9.297,9.298-9.297H90.79 c5.127,0,9.298,4.171,9.298,9.297v25.713C100.087,173.477,95.917,177.647,90.79,177.647z M65.898,138.34 c-2.37,0-4.298,1.928-4.298,4.297v25.713c0,2.37,1.928,4.298,4.298,4.298H90.79c2.37,0,4.298-1.928,4.298-4.298v-25.713 c0-2.369-1.928-4.297-4.298-4.297H65.898z"/><path d="M140.447,177.647h-24.893c-5.127,0-9.298-4.171-9.298-9.298v-25.713c0-5.126,4.171-9.297,9.298-9.297h24.893 c5.126,0,9.297,4.171,9.297,9.297v25.713C149.744,173.477,145.573,177.647,140.447,177.647z M115.555,138.34 c-2.37,0-4.298,1.928-4.298,4.297v25.713c0,2.37,1.928,4.298,4.298,4.298h24.893c2.369,0,4.297-1.928,4.297-4.298v-25.713 c0-2.369-1.928-4.297-4.297-4.297H115.555z"/><path d="M90.79,227.998H65.898c-5.127,0-9.298-4.171-9.298-9.298v-25.713c0-5.127,4.171-9.298,9.298-9.298H90.79 c5.127,0,9.298,4.171,9.298,9.298V218.7C100.087,223.827,95.917,227.998,90.79,227.998z M65.898,188.689 c-2.37,0-4.298,1.928-4.298,4.298V218.7c0,2.37,1.928,4.298,4.298,4.298H90.79c2.37,0,4.298-1.928,4.298-4.298v-25.713 c0-2.37-1.928-4.298-4.298-4.298H65.898z"/><path d="M140.447,227.998h-24.893c-5.127,0-9.298-4.171-9.298-9.298v-25.713c0-5.127,4.171-9.298,9.298-9.298h24.893 c5.126,0,9.297,4.171,9.297,9.298V218.7C149.744,223.827,145.573,227.998,140.447,227.998z M115.555,188.689 c-2.37,0-4.298,1.928-4.298,4.298V218.7c0,2.37,1.928,4.298,4.298,4.298h24.893c2.369,0,4.297-1.928,4.297-4.298v-25.713 c0-2.37-1.928-4.298-4.297-4.298H115.555z"/><path d="M190.104,227.998h-24.893c-5.127,0-9.299-4.171-9.299-9.298v-76.063c0-5.126,4.172-9.297,9.299-9.297h24.893 c4.331,0,8.052,2.94,9.048,7.149c0.165,0.701,0.249,1.423,0.249,2.147V218.7C199.4,223.827,195.229,227.998,190.104,227.998z M165.211,138.34c-2.37,0-4.299,1.928-4.299,4.297V218.7c0,2.37,1.929,4.298,4.299,4.298h24.893c2.369,0,4.297-1.928,4.297-4.298 v-76.063c0-0.339-0.039-0.674-0.115-0.997c-0.459-1.942-2.18-3.3-4.182-3.3H165.211z"/></g></symbol><symbol id="icon-symbol-camera" viewBox="0 0 256 256"><path d="M85.333 21.333h85.333l21.333 32h32c8.832 0 16.374 3.18 22.624 9.542S256 76.833 256 85.665v117.168c0 8.834-3.125 16.348-9.375 22.542s-13.792 9.292-22.625 9.292H32c-8.833 0-16.375-3.125-22.625-9.375S0 211.5 0 202.667V85.5c0-8.834 3.125-16.403 9.375-22.71 6.25-6.304 13.792-9.457 22.625-9.457h32l21.333-32zm42.667 64c7.223 0 14.125 1.417 20.708 4.25 6.584 2.833 12.25 6.625 17 11.375s8.542 10.417 11.375 17c2.834 6.583 4.25 13.486 4.25 20.71 0 7.22-1.416 14.124-4.25 20.707-2.833 6.583-6.625 12.25-11.375 17s-10.416 8.542-17 11.375C142.125 190.583 135.223 192 128 192c-7.222 0-14.125-1.417-20.708-4.25-6.583-2.833-12.25-6.625-17-11.375s-8.542-10.417-11.375-17-4.25-13.486-4.25-20.708c0-7.223 1.417-14.126 4.25-20.71 2.833-6.582 6.625-12.25 11.375-17s10.417-8.54 17-11.374c6.583-2.833 13.486-4.25 20.708-4.25zm0 21.333c-8.833 0-16.375 3.125-22.625 9.375S96 129.834 96 138.668c0 8.833 3.125 16.375 9.375 22.625s13.792 9.375 22.625 9.375 16.375-3.125 22.625-9.375S160 147.5 160 138.667c0-8.834-3.125-16.376-9.375-22.626s-13.792-9.374-22.625-9.374zm52.583-32l-20.916-32H96.75l-21.333 32H32c-2.944 0-5.458 1.056-7.542 3.167-2.083 2.11-3.125 4.667-3.125 7.667v117.167c0 2.944 1.042 5.458 3.125 7.54 2.083 2.085 4.597 3.126 7.542 3.126h192c3 0 5.527-1.014 7.583-3.04 2.056-2.03 3.084-4.516 3.084-7.46V85.666c0-3-1.056-5.583-3.167-7.75-2.11-2.166-4.61-3.25-7.5-3.25h-43.417z"/></symbol><symbol id="icon-symbol-chart" viewBox="0 0 256 256"><g><path d="M50.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-41c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v41C60,243.7,55.7,248,50.5,248z "/><path d="M148.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-101c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v101 C158,243.7,153.7,248,148.5,248z"/><path d="M246.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-221c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v221 C256,243.7,251.7,248,246.5,248z"/></g></symbol><symbol id="icon-symbol-clipboard-copy" viewBox="0 0 256 256"><path d="M76.8,76.8V25.6C76.8,11.5,88.3,0,102.4,0h128C244.5,0,256,11.5,256,25.6l0,0v128c0,14.1-11.5,25.6-25.6,25.6l0,0h-51.2 v51.2c0,14.1-11.5,25.6-25.6,25.6l0,0h-128C11.5,256,0,244.5,0,230.4l0,0v-128c0-14.1,11.5-25.6,25.6-25.6 C25.6,76.8,76.8,76.8,76.8,76.8z M102.4,76.8h51.2c14.1,0,25.6,11.5,25.6,25.6l0,0v51.2h51.2v-128h-128 C102.4,25.6,102.4,76.8,102.4,76.8z M25.6,102.4v128h128v-128C153.6,102.4,25.6,102.4,25.6,102.4z"/></symbol><symbol id="icon-symbol-clipboard-cut" viewBox="0 0 256 256"><path d="M125.1,147.2l68.3,50c5.6,4.2,15.9,7.5,22.9,7.5H256L88.3,81.7c0.9-3.4,1.5-7.3,1.5-11.3c0-24.7-20-44.8-44.8-44.8 S0.2,45.7,0.2,70.4s20,44.8,44.8,44.8c9.6,0,18.4-3,25.7-8.1l-0.1,0.1L99,128.1l-28.5,20.9c-7.2-5.1-16.1-8.1-25.7-8.1 C20,140.8,0,160.9,0,185.6s20,44.8,44.8,44.8s44.8-20,44.8-44.8c0-4-0.5-7.8-1.5-11.5l0.1,0.3l37.1-27.1L125.1,147.2z M44.9,89.7 c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2l0,0c10.6,0,19.2,8.6,19.2,19.2S55.5,89.7,44.9,89.7C44.9,89.7,44.9,89.7,44.9,89.7z M44.9,204.8c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2l0,0c10.6,0,19.2,8.6,19.2,19.2S55.5,204.8,44.9,204.8L44.9,204.8z M193.3,58.8c6.5-4.4,14.4-7.1,22.9-7.5l0.1,0H256l-96,70.4l-26.2-19.2C133.8,102.5,193.3,58.8,193.3,58.8z"/></symbol><symbol id="icon-symbol-clipboard-paste" viewBox="0 0 256 256"><g transform="scale(0.01953125 0.01953125)"><path d="M6881.4,13099.8H1310.7C586.8,13099.8,0,12512.9,0,11789l0,0V3924.6c0-720.9,589.8-1310.7,1310.7-1310.7h655.4v-655.4 l1330.4-262.1C3437.2,736.4,4254.9,7.6,5242.9,7.6s1805.8,728.8,1945.2,1678.1l1.3,10.7l1330.4,262.1v655.4h655.4 c723.9,0,1310.7,586.8,1310.7,1310.7l0,0V4580H9175.2v-655.4h-655.4V4580H1966.1v-655.4h-655.4V11789h3276.8v1310.7 C4587.6,13099.8,6881.4,13099.8,6881.4,13099.8z M5242.9,2613.9c362,0,655.4-293.4,655.4-655.4s-293.4-655.4-655.4-655.4l0,0 c-362,0-655.4,293.4-655.4,655.4S4881,2613.9,5242.9,2613.9L5242.9,2613.9z M6553.7,5235.3h5242.9 c723.9,0,1310.7,586.8,1310.7,1310.7l0,0V11789c0,723.9-586.8,1310.7-1310.7,1310.7l0,0H6553.7 c-723.9,0-1310.7-586.8-1310.7-1310.7l0,0V6546.1C5242.9,5825.2,5832.8,5235.3,6553.7,5235.3z M6553.7,6546.1V11789h5242.9V6546.1 C11796.6,6546.1,6553.7,6546.1,6553.7,6546.1z"/></g></symbol><symbol id="icon-symbol-clock" viewBox="0 0 256 256"><g><path fill="none" d="M128,44.511c-52.971,0-96.065,43.095-96.065,96.065S75.029,236.642,128,236.642s96.065-43.095,96.065-96.065 S180.971,44.511,128,44.511z M131.499,143.902c-0.028,0.03-0.048,0.066-0.077,0.096c-0.072,0.072-0.155,0.121-0.229,0.188 c-0.134,0.119-0.267,0.234-0.413,0.338c-0.124,0.087-0.253,0.161-0.383,0.235c-0.142,0.08-0.281,0.16-0.432,0.227 c-0.146,0.065-0.295,0.116-0.445,0.166c-0.146,0.048-0.291,0.097-0.443,0.131c-0.169,0.038-0.337,0.059-0.508,0.079 c-0.104,0.012-0.202,0.042-0.308,0.048c-0.087,0.005-0.173,0.007-0.259,0.007c0,0-0.001,0-0.001,0s0,0-0.001,0 c-0.001,0-0.002,0-0.003,0c-0.1,0-0.193-0.022-0.292-0.028c-0.212-0.014-0.424-0.021-0.633-0.062 c-0.307-0.06-0.605-0.148-0.89-0.264c-0.035-0.015-0.066-0.038-0.101-0.053c-0.25-0.108-0.491-0.231-0.717-0.378 c-0.079-0.052-0.148-0.12-0.225-0.176c-0.177-0.131-0.353-0.264-0.51-0.417c-0.016-0.016-0.035-0.026-0.05-0.041L82.079,101.5 c-1.89-1.89-1.89-4.954,0-6.843c1.89-1.891,4.954-1.891,6.844,0l33.563,33.562l-1.712-31.709c-0.145-2.668,1.902-4.949,4.571-5.094 c2.672-0.146,4.95,1.903,5.093,4.572l2.395,44.328c0.003,0.043-0.008,0.085-0.006,0.129c0.005,0.173-0.011,0.343-0.024,0.514 c-0.012,0.148-0.017,0.298-0.043,0.442c-0.026,0.154-0.072,0.304-0.114,0.456c-0.042,0.151-0.077,0.304-0.133,0.449 c-0.054,0.141-0.127,0.272-0.194,0.408c-0.072,0.146-0.141,0.295-0.228,0.433c-0.074,0.118-0.166,0.228-0.252,0.341 C131.729,143.63,131.623,143.773,131.499,143.902z M128,62.516c-43.228,0-78.397,35.169-78.397,78.397 c0,2.673-2.167,4.839-4.839,4.839s-4.839-2.166-4.839-4.839c0-48.566,39.51-88.077,88.076-88.077c2.673,0,4.84,2.167,4.84,4.839 C132.84,60.349,130.673,62.516,128,62.516z"/><path d="M213.771,63.425l15.687-15.686c3.78-3.78,3.78-9.909,0-13.689c-3.781-3.779-9.908-3.779-13.688,0L199.66,50.159 c-19.7-15.646-44.605-25.006-71.66-25.006c-63.645,0-115.424,51.779-115.424,115.424C12.576,204.222,64.355,256,128,256 c63.646,0,115.424-51.778,115.424-115.424C243.424,110.942,232.194,83.884,213.771,63.425z M128,236.642 c-52.971,0-96.065-43.095-96.065-96.065S75.029,44.511,128,44.511s96.065,43.095,96.065,96.065S180.971,236.642,128,236.642z"/><path d="M132.318,142.714c0.067-0.136,0.141-0.268,0.194-0.408c0.056-0.146,0.091-0.298,0.133-0.449 c0.042-0.152,0.088-0.302,0.114-0.456c0.026-0.145,0.031-0.294,0.043-0.442c0.014-0.171,0.029-0.341,0.024-0.514 c-0.002-0.044,0.009-0.086,0.006-0.129l-2.395-44.328c-0.144-2.669-2.421-4.718-5.093-4.572c-2.669,0.145-4.716,2.425-4.571,5.094 l1.712,31.709L88.923,94.657c-1.891-1.891-4.954-1.891-6.844,0c-1.89,1.889-1.89,4.954,0,6.843l42.499,42.498 c0.016,0.015,0.035,0.025,0.05,0.041c0.158,0.153,0.333,0.286,0.51,0.417c0.077,0.056,0.146,0.124,0.225,0.176 c0.226,0.146,0.468,0.27,0.717,0.378c0.035,0.015,0.066,0.038,0.101,0.053c0.285,0.115,0.583,0.204,0.89,0.264 c0.209,0.04,0.421,0.048,0.633,0.062c0.098,0.006,0.192,0.028,0.292,0.028c0.001,0,0.002,0,0.003,0c0,0,0,0,0.001,0 s0.001,0,0.001,0c0.086,0,0.172-0.002,0.259-0.007c0.106-0.006,0.203-0.036,0.308-0.048c0.171-0.021,0.339-0.041,0.508-0.079 c0.152-0.034,0.297-0.083,0.443-0.131c0.15-0.05,0.299-0.101,0.445-0.166c0.15-0.066,0.29-0.146,0.432-0.227 c0.13-0.074,0.259-0.148,0.383-0.235c0.146-0.104,0.279-0.219,0.413-0.338c0.074-0.066,0.157-0.115,0.229-0.188 c0.029-0.029,0.049-0.065,0.077-0.096c0.124-0.129,0.23-0.272,0.34-0.415c0.086-0.113,0.178-0.223,0.252-0.341 C132.178,143.009,132.246,142.86,132.318,142.714z"/><path d="M104.528,19.358h46.943c5.346,0,9.68-4.334,9.68-9.679S156.817,0,151.472,0h-46.943c-5.346,0-9.679,4.334-9.679,9.679 S99.182,19.358,104.528,19.358z"/><path d="M128,52.836c-48.565,0-88.076,39.511-88.076,88.077c0,2.673,2.167,4.839,4.839,4.839s4.839-2.166,4.839-4.839 c0-43.229,35.169-78.397,78.397-78.397c2.673,0,4.84-2.167,4.84-4.84C132.84,55.003,130.673,52.836,128,52.836z"/></g></symbol><symbol id="icon-symbol-code" viewBox="0 0 256 256"><path d="M32 128l64-64H64L0 128l64 64h32l-64-64zm160-64h-32l64 64-64 64h32l64-64-64-64zm-56-32L96 224h24l40-192h-24z"/></symbol><symbol id="icon-symbol-cookie" viewBox="0 0 256 256"><path d="M255.979,93.884l-0.069-3.417l-3.404-0.294c-8.643-0.747-15.708-7.237-17.182-15.784l-0.715-4.146l-4.055,1.131 c-2.121,0.592-4.305,0.892-6.49,0.892c-13.285,0-24.093-10.809-24.093-24.093c0-1.596,0.158-3.199,0.473-4.765l0.73-3.647 l-3.63-0.811c-8.663-1.934-14.95-9.786-14.95-18.672c0-1.628,0.205-3.245,0.609-4.807l1.1-4.255l-4.368-0.477 c-3.121-0.34-6.271-0.513-9.363-0.513c-39.966,0-73.604,27.588-82.884,64.72c-0.751-0.02-1.503-0.029-2.259-0.029 C38.323,74.915,0,113.238,0,160.345c0,47.104,38.323,85.429,85.429,85.429c39.966,0,73.604-27.589,82.885-64.721 c0.75,0.021,1.503,0.03,2.258,0.03c47.106,0,85.429-38.323,85.429-85.429C256,95.063,255.99,94.473,255.979,93.884z M85.429,238.169 c-42.913,0-77.825-34.912-77.825-77.824c0-42.913,34.912-77.825,77.825-77.825s77.824,34.912,77.824,77.825 C163.253,203.257,128.341,238.169,85.429,238.169z M170.571,173.479c-0.241,0-0.481-0.007-0.723-0.01 c0.663-4.279,1.009-8.662,1.009-13.125c0-43.733-33.034-79.891-75.458-84.845c8.901-33.173,39.229-57.67,75.172-57.67 c1.495,0,3.006,0.044,4.52,0.132c-0.066,0.77-0.1,1.541-0.1,2.315c0,11.223,7.18,21.267,17.5,25.09 c-0.083,0.934-0.124,1.87-0.124,2.805c0,17.479,14.219,31.697,31.697,31.697c1.58,0,3.158-0.119,4.723-0.355 c2.941,8.917,10.403,15.674,19.595,17.704C247.547,139.414,212.964,173.479,170.571,173.479z"/><path d="M171.731,49.998c0-6.331-5.151-11.481-11.481-11.481c-6.331,0-11.481,5.15-11.481,11.481s5.15,11.481,11.481,11.481 S171.731,56.329,171.731,49.998z M156.372,49.998c0-2.138,1.739-3.877,3.878-3.877c2.138,0,3.877,1.739,3.877,3.877 c0,2.139-1.74,3.878-3.877,3.878C158.112,53.876,156.372,52.137,156.372,49.998z"/><path d="M111.187,59.644l6.479,3.98c1.034-1.683,2.16-3.337,3.345-4.915l-6.081-4.566C113.604,55.909,112.344,57.761,111.187,59.644 z"/><path d="M119.452,48.701l5.601,5.143c6.547-7.13,14.748-12.757,23.714-16.271l-2.773-7.08 C135.955,34.427,126.778,40.723,119.452,48.701z"/><path d="M220.873,132.097l6.109,4.527c3.581-4.832,6.539-10.1,8.79-15.656l-7.047-2.856 C226.714,123.074,224.073,127.779,220.873,132.097z"/><path d="M194.054,122.944c-6.331,0-11.481,5.15-11.481,11.481s5.15,11.481,11.481,11.481s11.481-5.151,11.481-11.481 C205.535,128.095,200.385,122.944,194.054,122.944z M194.054,138.304c-2.138,0-3.878-1.74-3.878-3.878s1.74-3.877,3.878-3.877 s3.877,1.739,3.877,3.877C197.931,136.564,196.192,138.304,194.054,138.304z"/><path d="M170.571,73.668c-6.331,0-11.481,5.151-11.481,11.482s5.15,11.481,11.481,11.481c6.332,0,11.482-5.15,11.482-11.481 C182.053,78.819,176.903,73.668,170.571,73.668z M170.571,89.028c-2.138,0-3.877-1.74-3.877-3.878s1.739-3.877,3.877-3.877 c2.139,0,3.878,1.739,3.878,3.877S172.71,89.028,170.571,89.028z"/><path d="M227.068,103.881c0-7.847-6.384-14.23-14.23-14.23s-14.23,6.384-14.23,14.23c0,7.848,6.384,14.231,14.23,14.231 C220.686,118.112,227.068,111.728,227.068,103.881z M212.838,110.508c-3.654,0-6.627-2.973-6.627-6.627s2.973-6.627,6.627-6.627 s6.627,2.973,6.627,6.627S216.492,110.508,212.838,110.508z"/><path d="M90.439,116.103c6.331,0,11.481-5.15,11.481-11.481S96.77,93.14,90.439,93.14s-11.481,5.151-11.481,11.481 S84.108,116.103,90.439,116.103z M90.439,100.743c2.138,0,3.878,1.74,3.878,3.878s-1.74,3.877-3.878,3.877 c-2.138,0-3.877-1.739-3.877-3.877S88.301,100.743,90.439,100.743z"/><path d="M34.435,123.083l-6.081-4.565c-1.329,1.77-2.588,3.621-3.743,5.502l6.479,3.979 C32.123,126.318,33.248,124.665,34.435,123.083z"/><path d="M62.193,101.949l-2.774-7.08c-10.038,3.933-19.216,10.229-26.542,18.208l5.601,5.143 C45.026,111.089,53.226,105.463,62.193,101.949z"/><path d="M136.001,197.365l6.109,4.527c3.582-4.834,6.539-10.102,8.79-15.656l-7.047-2.856 C141.842,188.342,139.201,193.047,136.001,197.365z"/><path d="M25.042,193.682c3.35,6.061,7.562,11.598,12.518,16.46l5.325-5.429c-4.431-4.347-8.194-9.295-11.188-14.71L25.042,193.682z"/><path d="M26.283,177.004l-7.329,2.027c0.761,2.75,1.697,5.479,2.784,8.114l7.029-2.898 C27.798,181.896,26.962,179.459,26.283,177.004z"/><path d="M108.911,187.634c-6.331,0-11.481,5.15-11.481,11.481s5.151,11.481,11.481,11.481c6.331,0,11.481-5.15,11.481-11.481 S115.241,187.634,108.911,187.634z M108.911,202.993c-2.138,0-3.877-1.74-3.877-3.878s1.74-3.877,3.877-3.877 s3.877,1.739,3.877,3.877S111.048,202.993,108.911,202.993z"/><path d="M32.934,141.183c-6.331,0-11.481,5.151-11.481,11.482s5.151,11.481,11.481,11.481s11.481-5.151,11.481-11.481 C44.415,146.334,39.265,141.183,32.934,141.183z M32.934,156.543c-2.138,0-3.877-1.741-3.877-3.878c0-2.138,1.74-3.878,3.877-3.878 c2.138,0,3.877,1.74,3.877,3.878S35.072,156.543,32.934,156.543z"/><path d="M85.429,138.358c-6.331,0-11.481,5.15-11.481,11.481c0,6.33,5.151,11.481,11.481,11.481c6.331,0,11.481-5.15,11.481-11.481 S91.76,138.358,85.429,138.358z M85.429,153.718c-2.138,0-3.877-1.74-3.877-3.878s1.74-3.878,3.877-3.878 c2.138,0,3.877,1.74,3.877,3.878S87.566,153.718,85.429,153.718z"/><path d="M123.893,158.142c0,7.847,6.384,14.23,14.23,14.23s14.231-6.384,14.231-14.23s-6.385-14.23-14.231-14.23 S123.893,150.295,123.893,158.142z M144.75,158.142c0,3.654-2.973,6.627-6.627,6.627c-3.653,0-6.626-2.973-6.626-6.627 s2.973-6.627,6.626-6.627C141.777,151.516,144.75,154.487,144.75,158.142z"/><path d="M64.677,198.559c-7.847,0-14.23,6.384-14.23,14.23s6.384,14.23,14.23,14.23s14.231-6.384,14.231-14.23 C78.909,204.941,72.524,198.559,64.677,198.559z M64.677,219.416c-3.654,0-6.626-2.974-6.626-6.627c0-3.654,2.973-6.628,6.626-6.628 c3.654,0,6.627,2.974,6.627,6.628C71.305,216.442,68.331,219.416,64.677,219.416z"/></symbol><symbol id="icon-symbol-copy" viewBox="0 0 256 256"><g><path d="M128.2,214.4c-50.4,0-91.5-41-91.5-91.5s41-91.5,91.5-91.5s91.5,41,91.5,91.5c0,14.8-3.5,28.8-9.8,41.2 c2.3,5,4.1,10.3,5.3,15.8c10.7-16.4,17-35.9,17-57C232.1,65.5,185.6,19,128.2,19C70.7,19,24.2,65.5,24.2,122.9 s46.5,103.9,103.9,103.9c6.4,0,12.6-0.6,18.7-1.7l-11-11.1C133.3,214.3,130.7,214.4,128.2,214.4z"/><g><path d="M214.3,180L164,231l-50.3-51h15.1h18l-0.5-18c-0.5-21.9-3.4-45.5-15.8-67.5c11.5,5.3,21.8,13,30.1,22.9 c1.7,2,3.3,4.1,4.8,6.2c1.5,2.1,2.9,4.4,4.2,6.6c6.1,10.5,9.9,22,11.2,34.1l1.7,15.6h15.7H214.3 M240,174.1c0-3-1.1-6-3.4-8.3 c-2.3-2.3-5.3-3.4-8.3-3.4h-29.9c-1.6-14.8-6.3-28.7-13.5-41c-1.6-2.7-3.3-5.4-5.1-8c-1.8-2.6-3.7-5.1-5.8-7.4 C154.8,83.3,126,68.9,93.8,68.9H82.1c40,26.3,45.8,61.4,46.6,93.6H99.7c-0.4,0-0.7,0-1.1,0.1c-1.1,0.1-2.2,0.4-3.3,0.8 c-1.4,0.6-2.7,1.4-3.9,2.6c-2.3,2.3-3.4,5.3-3.4,8.3c0,0.7,0.1,1.5,0.2,2.2c0.3,1.5,0.9,2.9,1.7,4.2c0.4,0.6,0.9,1.3,1.5,1.8 L164,256l72.6-73.6c0.6-0.6,1.1-1.2,1.5-1.8c0.9-1.3,1.4-2.7,1.7-4.2C239.9,175.6,240,174.9,240,174.1L240,174.1z"/></g></g></symbol><symbol id="icon-symbol-eye" viewBox="0 0 256 256"><path d="M255.72 126.233c-.08-.336-.032-.697-.16-1.025-.05-.136-.17-.208-.217-.336-.08-.192-.064-.41-.168-.593-23.233-44.473-73.81-76.335-127.167-76.335-53.365 0-103.934 31.814-127.183 76.278-.104.184-.088.4-.168.593-.056.128-.168.2-.216.336-.127.33-.08.69-.16 1.025-.144.6-.28 1.178-.28 1.795s.144 1.186.28 1.793c.08.338.032.697.16 1.025.048.137.168.21.216.338.08.19.064.408.168.592 23.242 44.473 73.818 76.334 127.183 76.334 53.356 0 103.934-31.813 127.167-76.277.112-.184.096-.4.168-.592.048-.13.168-.2.217-.338.127-.328.078-.69.16-1.025.135-.61.28-1.186.28-1.794 0-.61-.145-1.194-.28-1.795zM128 192.023c-44.985 0-89.024-25.564-110.968-64.05C39.096 89.436 83.072 63.96 128 63.96c44.97 0 89.016 25.573 110.96 64.052-22.064 38.543-66.03 64.01-110.96 64.01zm0-96.05c2.21 0 3.99 1.788 3.99 4.007 0 2.203-1.787 3.998-3.99 3.998v.008c-13.25 0-24.027 10.775-24.027 24.01 0 2.212-1.794 4.007-3.998 4.007-2.21 0-4.006-1.795-4.006-4.006 0-17.666 14.315-31.982 31.98-32.014.018 0 .034-.01.05-.01zm-.185-24.026c-30.98 0-56.08 25.108-56.08 56.08s25.107 56.083 56.08 56.083c30.965 0 56.08-25.117 56.08-56.082 0-30.98-25.115-56.08-56.08-56.08zm0 104.15c-26.51 0-48.07-21.56-48.07-48.07s21.56-48.068 48.07-48.068 48.07 21.558 48.07 48.068c0 26.51-21.56 48.07-48.07 48.07z"/></symbol><symbol id="icon-symbol-feed" viewBox="0 0 256 256"><path d="M128 0C57.308 0 0 57.308 0 128s57.308 128 128 128 128-57.308 128-128S198.692 0 128 0zM80 192c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zm44 0c0-33.084-26.916-60-60-60v-24c46.318 0 84 37.682 84 84h-24zm48 0c0-28.848-11.234-55.97-31.633-76.367C119.97 95.233 92.847 84 64 84V60c35.26 0 68.406 13.73 93.338 38.662S196 156.742 196 192h-24z"/></symbol><symbol id="icon-symbol-fire" viewBox="0 0 256 256"><path d="M175.97 72c-.496 21.4-16.56 39.472-16.56 39.472C159.41 71.664 127.97 40 127.97 40s-.424 23.696-16.344 47.584C95.706 31.848 47.93 0 47.93 0c23.888 87.584-7.96 119.44-7.96 183.136 0 37.368 31.632 72.864 80 72.864 71.656 0 85.512-26.304 92.92-55.944 10.208-40.808-5.08-88.248-36.92-128.056zm21.408 124.168C192.233 216.72 186.426 240 119.97 240c-40.064 0-64-28.912-64-56.864 0-21.407 3.904-38.983 8.032-57.592 5.248-23.592 10.624-47.744 8.296-79.688 24.672 34.152 33.456 79.4 33.456 79.4s22.968-32.248 29.144-47.224C139.625 87.656 143.97 120 143.97 152c0 0 21.248-17.504 37.184-43.824 16.784 30.095 22.83 61.56 16.224 87.992zm-17.952-61.808l1.488 8.28c3.327 18.543 1.464 40.463-4.736 55.855-.624 1.56-2.128 2.504-3.704 2.504-.504 0-1.016-.097-1.504-.29-2.048-.823-3.048-3.15-2.216-5.2 4.672-11.59 6.64-27.91 5.392-42.823-8.032 8.977-18.152 18.328-39.776 28.6l-4.048 1.913-1.456-4.224c-2.896-8.4-5.815-16.89-7.08-28.72-4.328 6.823-8.28 12.903-14.92 21.943l-4.064 5.535-2.816-6.272c-6.888-15.4-12.136-27.424-16.296-38-3.848 12.36-6.72 26.656-6.72 55.528 0 2.21-1.8 4-4 4-2.216 0-4-1.79-4-4 0-37.67 5-52.183 10.28-67.55l4.16-12.08 3.832 10.8c4.12 11.606 9.544 24.4 17.216 41.694 5.056-7.144 8.448-12.52 12.544-19.008l12.144-19.023v13.672c0 15.392 2.768 25.448 5.815 34.584 21.273-10.705 29.24-20.017 37.666-29.84l6.8-7.88z"/></symbol><symbol id="icon-symbol-folder" viewBox="0 0 256 256"><path d="M238.835 141.276c0-3.13-2.37-4.693-7.107-4.693H85.825c-3.576 0-7.398.96-11.466 2.883s-7.265 4.27-9.59 7.04l-39.425 48.68c-1.61 2.145-2.414 3.934-2.414 5.363 0 3.13 2.37 4.692 7.108 4.692H175.94c3.577 0 7.42-.983 11.534-2.95 4.112-1.966 7.285-4.336 9.52-7.107l39.428-48.68c1.608-1.965 2.413-3.71 2.413-5.23zm-153.01-21.858h102.99V97.96c0-3.574-1.252-6.614-3.755-9.117-2.504-2.504-5.543-3.755-9.12-3.755H98.7c-3.577 0-6.617-1.252-9.12-3.755-2.503-2.504-3.755-5.543-3.755-9.12v-8.582c0-3.574-1.252-6.614-3.755-9.117-2.503-2.504-5.543-3.755-9.12-3.755H30.04c-3.577 0-6.617 1.25-9.12 3.755-2.503 2.503-3.755 5.543-3.755 9.118v114.39l34.33-42.24c3.934-4.74 9.12-8.65 15.556-11.735 6.438-3.085 12.696-4.627 18.775-4.627zM256 141.276c0 5.543-2.056 10.907-6.17 16.092l-39.56 48.68c-3.844 4.738-9.028 8.65-15.556 11.733-6.525 3.085-12.783 4.627-18.773 4.627H30.04c-8.226 0-15.29-2.95-21.19-8.85S0 200.593 0 192.368V63.63c0-8.224 2.95-15.286 8.85-21.187s12.964-8.85 21.19-8.85H72.95c8.225 0 15.288 2.95 21.188 8.85 5.9 5.9 8.85 12.963 8.85 21.188v4.293h72.952c8.225 0 15.287 2.95 21.188 8.85s8.852 12.964 8.852 21.19v21.456h25.747c4.826 0 9.252 1.094 13.275 3.284 4.022 2.19 7.018 5.342 8.984 9.454 1.34 2.86 2.01 5.9 2.01 9.118z"/></symbol><symbol id="icon-symbol-forward" viewBox="0 0 256 256"><path d="M40 0c4.417 0 8.208 1.583 11.375 4.75l112 112C166.46 119.833 168 123.583 168 128c0 4.5-1.54 8.292-4.625 11.375l-112 112C48.292 254.46 44.5 256 40 256c-4.417 0-8.188-1.54-11.313-4.625S24 244.54 24 240.125c0-4.334 1.542-8.125 4.625-11.375L129.375 128 28.625 27.375C25.542 24.125 24 20.333 24 16c0-4.417 1.563-8.188 4.688-11.313S35.583 0 40 0zm176 0c4.416 0 8.188 1.563 11.313 4.688S232 11.583 232 16v224c0 4.416-1.563 8.188-4.688 11.313S220.416 256 216 256s-8.188-1.563-11.313-4.688S200 244.416 200 240V16c0-4.417 1.563-8.188 4.688-11.313S211.584 0 216 0z"/></symbol><symbol id="icon-symbol-heart-full" viewBox="0 0 256 256"><path d="M233.54,38.1C204.5,9.33,158.07,8.73,128,35.8C97.91,8.73,51.5,9.33,22.45,38.1c-29.93,29.64-29.93,77.68,0,107.34 c8.55,8.47,88.43,87.529,88.43,87.529c9.47,9.38,24.771,9.38,34.23,0c0,0,87.47-86.58,88.439-87.529 C263.48,115.78,263.48,67.73,233.54,38.1z M73.97,56c0.01,0,0.01-0.01,0.03-0.01c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4h-0.01 c-14.35,0-25.99,11.64-25.99,26c0,1.11-0.45,2.11-1.18,2.83c-0.72,0.72-1.72,1.17-2.82,1.17c-2.21,0-4-1.79-4-4 C40,71.22,55.21,56.01,73.97,56z"/></symbol><symbol id="icon-symbol-heart" viewBox="0 0 256 256"><path d="M233.538 38.1c-29.035-28.77-75.465-29.37-105.54-2.303C97.914 8.73 51.5 9.33 22.448 38.1c-29.93 29.637-29.93 77.683 0 107.335 8.554 8.473 88.436 87.538 88.436 87.538 9.465 9.377 24.77 9.377 34.228 0 0 0 87.467-86.586 88.435-87.538 29.938-29.653 29.938-77.7-.01-107.334zm-11.4 96.037l-88.436 87.54c-3.145 3.127-8.272 3.127-11.4 0l-88.436-87.54c-23.603-23.363-23.603-61.376 0-84.74 22.755-22.52 59.335-23.314 83.282-1.775l10.85 9.76 10.84-9.76c23.956-21.54 60.536-20.755 83.29 1.776 23.603 23.355 23.603 61.368.01 84.74zM73.997 55.99c2.217 0 4 1.793 4 4 0 2.21-1.79 4-4 4h-.007c-14.353 0-25.994 11.643-25.994 25.996v.008c0 2.208-1.792 4-4 4-2.21 0-4-1.792-4-4 0-18.77 15.21-33.98 33.97-33.996.017 0 .017-.007.033-.007z"/></symbol><symbol id="icon-symbol-hidepass" viewBox="0 0 256 256"><path d="M255.7,126.2c-0.1-0.3,0-0.7-0.2-1c0-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.1-0.4-0.2-0.6C243,101,223.4,81.2,199.7,67.6 l41.4-41.4c1.6-1.6,2.3-3.6,2.3-5.6c0-2.1-0.8-4.1-2.3-5.7c-3.1-3.1-8.2-3.1-11.3,0L184.7,60c-17.7-7.7-37-12-56.7-12 c-53.4,0-103.9,31.8-127.2,76.3c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3-0.1,0.7-0.2,1C0.1,126.8,0,127.3,0,128 c0,0.6,0.1,1.2,0.3,1.8c0.1,0.3,0,0.7,0.2,1c0,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.2,0.6C13,155,32.7,174.8,56.3,188.4 l-41.4,41.4c-1.6,1.6-2.3,3.6-2.3,5.6c0,2.1,0.8,4.1,2.3,5.7c3.1,3.1,8.2,3.1,11.3,0L71.3,196c17.7,7.7,37,12,56.7,12 c53.3,0,103.9-31.8,127.2-76.3c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.2-0.2,0.2-0.3c0.1-0.3,0.1-0.7,0.2-1c0.1-0.6,0.3-1.2,0.3-1.8 C256,127.4,255.8,126.8,255.7,126.2z M68,176.7c-21.1-11.2-39.2-28.1-51-48.7c22.1-38.5,66-64,111-64c15.2,0,30.3,2.9,44.5,8.3 l-11,11c-9.4-7.1-21-11.2-33.7-11.2C96.8,72,71.7,97,71.7,128c0,12.6,4.2,24.3,11.2,33.7L68,176.7z M128,192 c-15.2,0-30.3-2.9-44.4-8.3L94.3,173c9.3,7,21,11.1,33.5,11.1c31,0,56.1-25.1,56.1-56.1c0-12.6-4.1-24.2-11.1-33.5L188,79.3 c21.1,11.3,39.2,28.1,50.9,48.7C216.9,166.5,172.9,192,128,192z"/></symbol><symbol id="icon-symbol-idea" viewBox="0 0 256 256"><path d="M128 0C79.392 0 40 39.392 40 88c0 32.248 29.504 66.424 40.248 96.44C96.272 229.2 94.496 256 128 256c34 0 31.72-26.672 47.752-71.376C186.528 154.544 216 120 216 88c0-48.608-39.407-88-88-88zm20.735 217.408l-39.664 4.952c-1.415-4.097-2.935-8.888-4.783-15.144-.024-.08-.056-.168-.072-.25l49.503-6.183c-.704 2.36-1.456 4.84-2.11 7.063-1.048 3.594-1.984 6.714-2.873 9.562zm-46.847-18.144c-1.457-4.815-3.096-9.888-4.92-15.264h62.127c-.983 2.872-1.968 5.752-2.815 8.472l-54.392 6.792zM128 240c-8.104 0-11.832-.936-15.976-10l33.904-4.248C141.018 238.982 137.438 240 128 240zm37.376-72H90.712c-3.984-8.64-8.768-17.28-13.488-25.736C66.784 123.584 56 104.264 56 88c0-39.704 32.296-72 72-72s72 32.296 72 72c0 16.144-10.8 35.568-21.248 54.36-4.672 8.424-9.424 17.048-13.376 25.64zM128 40c2.2 0 4 1.792 4 4s-1.792 4-4 4c-22.056 0-40 17.944-40 40 0 2.208-1.792 4-4 4s-4-1.792-4-4c0-26.472 21.528-48 48-48z"/></symbol><symbol id="icon-symbol-info" viewBox="0 0 256 256"><path d="M128 256C57.42 256 0 198.58 0 128S57.42 0 128 0s128 57.42 128 128-57.42 128-128 128zm0-237.45C67.65 18.55 18.55 67.65 18.55 128S67.65 237.45 128 237.45 237.45 188.35 237.45 128 188.35 18.55 128 18.55zM151.68 219.77c0 1.824-.17 2.817-.497 2.98-.336.17-1.41.25-3.23.25h-37.748c-1.492 0-2.486-.123-2.983-.372-.494-.25-.744-1.2-.744-2.857v-84.195H93.064c-1.487 0-2.44-.204-2.854-.62-.416-.41-.623-1.282-.623-2.61v-28.313c0-1.65.207-2.688.623-3.104.413-.41 1.367-.62 2.854-.62h55.138c1.65 0 2.645.21 2.98.62.327.417.497 1.453.497 3.104v115.74zm2.732-160.443c0 3.476-.662 6.83-1.988 10.06-1.326 3.227-3.19 6.082-5.587 8.567-2.4 2.483-5.26 4.47-8.57 5.96-3.314 1.49-6.872 2.235-10.68 2.235-3.81 0-7.37-.747-10.68-2.236-3.315-1.49-6.128-3.477-8.44-5.96-2.32-2.485-4.145-5.34-5.467-8.568-1.325-3.23-1.988-6.583-1.988-10.06 0-3.476.663-6.83 1.988-10.06 1.322-3.227 3.186-6.04 5.587-8.44 2.402-2.4 5.255-4.306 8.57-5.715 3.307-1.403 6.868-2.11 10.68-2.11 3.81 0 7.325.707 10.557 2.11 3.23 1.41 6.043 3.355 8.443 5.84 2.397 2.483 4.26 5.3 5.587 8.443 1.326 3.146 1.988 6.457 1.988 9.934z"/></symbol><symbol id="icon-symbol-key" viewBox="0 0 256 256"><path d="M610.52 521.752c-6.432-4.256-123.136-80.8-296.735-118.368 63.68-80.672 104.576-189.184 121.952-261.408 24.127-100.096 14.75-295.936-81.377-417.984C298.168-347.336 219.544-385 127-385s-171.168 37.696-227.328 108.992C-196.456-153.992-205.8 41.848-181.704 141.944c17.376 72.224 58.24 180.735 121.952 261.408-173.6 37.567-290.304 114.11-296.704 118.367-23.456 15.615-33.952 44.8-25.76 71.743C-374.088 620.503-349.16 639-321 639h896c28.192 0 53.057-18.496 61.248-45.504 8.225-26.944-2.27-56.128-25.728-71.744zM263.544 363.736l-10.432 13.248c-76.32 87.68-175.84 87.68-252.128 0L-9.48 363.736c-89.12-112.93-133.344-262.305-114.304-404.8C-106.344-177.992-27.88-321 127-321S360.376-177.96 377.816-41.032c18.976 142.56-25.088 291.776-114.272 404.768zM-321 575c4.416-2.944 112.832-74.048 274.752-109.056L33.24 448.76C61.624 467.384 92.76 479 127 479c34.27 0 65.376-11.616 93.76-30.24l79.488 17.185C460.888 500.695 568.92 571 575 575h-896z"/></symbol><symbol id="icon-symbol-lab" viewBox="0 0 256 256"><path d="M165.457 29.857c-3.784-3.776-8.8-5.856-14.144-5.856s-10.36 2.08-14.16 5.865l-11.28 11.295c-3.783 3.776-5.87 8.8-5.87 14.152 0 3.768 1.03 7.376 2.967 10.504L14.355 109.328C7.092 112.52 1.885 119.072.42 126.84c-1.48 7.816 1 15.832 6.672 21.496l101.758 100.64c4.384 4.383 10.208 6.87 16.36 7.015.144.01.48.01.624.01 1.616 0 3.256-.17 4.88-.497 7.952-1.648 14.464-7.144 17.416-14.624l42.735-107.007c3.216 2.12 7 3.256 10.936 3.256 5.36 0 10.377-2.09 14.145-5.865L227.2 120c3.816-3.792 5.904-8.824 5.904-14.184s-2.097-10.4-5.856-14.144l-61.79-61.815zm-32.184 205.078c-.99 2.504-3.176 4.352-5.815 4.896-.608.13-1.224.177-1.832.17-2.032-.05-3.992-.865-5.456-2.337L18.348 136.96c-1.872-1.864-2.696-4.536-2.2-7.145.488-2.59 2.232-4.783 4.656-5.84l49.735-19.918c33.51 11.144 67.03.408 100.557 36.175l-37.824 94.703zm82.664-126.295l-11.312 11.304c-1.56 1.568-4.097 1.568-5.656 0l-14.145-14.136-11.456 28.71.95-2.423c-24.08-24.04-48.55-27.07-70.63-29.783-7.096-.872-13.976-1.784-20.736-3.24l67.927-27.208-13.72-13.72c-1.56-1.56-1.56-4.096 0-5.656l11.313-11.32c1.56-1.56 4.096-1.56 5.655 0l61.8 61.815c1.585 1.56 1.585 4.098.01 5.657zM132.002 168c11.023 0 20-8.97 20-20 0-11.032-8.97-20-20-20-11.032 0-20 8.968-20 20 0 11.03 8.976 20 20 20zm0-32c6.624 0 12 5.376 12 12s-5.376 12-12 12c-6.632 0-12-5.376-12-12s5.368-12 12-12zM236 .002c-11.03 0-20 8.968-20 20s8.97 20 20 20c11.032 0 20-8.968 20-20s-8.968-20-20-20zm0 32c-6.624 0-12-5.377-12-12 0-6.625 5.376-12 12-12s12 5.375 12 12c0 6.623-5.376 12-12 12zM64.003 136c0 8.823 7.176 16 16 16s16-7.177 16-16c0-8.824-7.176-16-16-16s-16 7.176-16 16zm16-8c4.415 0 8 3.576 8 8s-3.585 8-8 8-8-3.576-8-8 3.583-8 8-8zm16 56c0-4.42 3.58-8 8-8 4.417 0 8 3.58 8 8s-3.583 8-8 8c-4.42 0-8-3.583-8-8zM224 64c0-4.417 3.582-8 8-8s8 3.583 8 8-3.582 8-8 8-8-3.58-8-8z"/></symbol><symbol id="icon-symbol-lock" viewBox="0 0 256 256"><path d="M200 104V72c0-39.768-32.232-72-72-72S56 32.232 56 72v32c-13.256 0-24 10.744-24 24v56c0 39.768 32.232 72 72 72h48c39.768 0 72-32.232 72-72v-56c0-13.264-10.752-24-24-24zM72 72c0-30.928 25.072-56 56-56s56 25.072 56 56v32h-16V72.016c0-22.096-17.904-40-40-40s-40 17.904-40 40V104H72V72zm88 0v32H96V72c0-17.672 14.328-32 32-32s32 14.328 32 32zm48 80v32c0 30.872-25.128 56-56 56h-48c-30.872 0-56-25.128-56-56v-56c0-4.416 3.584-8 8-8 5.336 0 10.664 0 16 0h112c5.328 0 10.656 0 16 0 4.408 0 8 3.584 8 8v24zm-80 0c8.832 0 16 7.16 16 16 0 4.872-2.624 14.145-5.328 21.456-2.184 5.904-4.416 10.528-10.672 10.528-5.752 0-8.488-4.672-10.664-10.608C114.664 182.08 112 172.856 112 168c0-8.84 7.168-16 16-16z"/></symbol><symbol id="icon-symbol-lowercase" viewBox="0 0 256 256"><path d="M254.97,124.1L130.38,2.43c-1.32-1.29-3.44-1.29-4.76,0L1.03,124.1c-0.99,0.97-1.3,2.44-0.78,3.72 c0.52,1.291,1.77,2.13,3.16,2.13H62.3v121.18c0,1.88,1.52,3.41,3.4,3.41h124.6c1.88,0,3.4-1.53,3.4-3.41V129.95h58.89 c1.391,0,2.641-0.84,3.16-2.13C256.27,126.54,255.96,125.07,254.97,124.1z"/></symbol><symbol id="icon-symbol-money" viewBox="0 0 256 256"><path d="M251.316 84.685l-80-79.998C167.35.72 161.597-.873 156.15.47c-2.872.705-5.44 2.185-7.473 4.217-1.815 1.816-3.184 4.064-3.968 6.576-3.625 11.75-9.89 21.967-19.16 31.23-12.383 12.377-28.51 21.753-45.573 31.664-18.112 10.496-36.824 21.376-52.16 36.703C14.785 123.908 5.914 138.42.714 155.267c-1.752 5.688-.224 11.84 3.968 16.048l79.998 79.998c3.968 3.968 9.72 5.56 15.167 4.216 2.872-.72 5.44-2.185 7.472-4.217 1.815-1.815 3.183-4.063 3.967-6.592 3.632-11.75 9.896-21.967 19.175-31.23 12.376-12.375 28.495-21.735 45.575-31.64 18.095-10.51 36.814-21.39 52.143-36.72 13.03-13.03 21.903-27.56 27.11-44.406 1.746-5.68.21-11.855-3.974-16.04zM96 239.995c-26.496-26.497-53.503-53.512-79.998-80C38.737 86.39 137.278 89.606 159.998 16c26.495 26.486 53.51 53.502 80.015 79.997C217.27 169.587 118.728 166.387 96 239.994zm60.494-120.8c-2.608-2.183-5.232-3.67-7.872-4.407-2.624-.736-5.248-1.032-7.903-.84-2.625.2-5.314.8-8 1.832-2.69 1.048-5.393 2.184-8.113 3.504-4.295-4.936-8.59-9.816-12.887-14.344 1.936-1.752 3.815-2.64 5.624-2.704 1.816-.08 3.56.112 5.216.528 1.688.424 3.23.784 4.656 1.064 1.44.28 2.687-.032 3.784-.952 1.16-1 1.8-2.296 1.888-3.856.08-1.576-.512-3.112-1.832-4.608-1.688-1.936-3.72-3.112-6.16-3.544-2.408-.424-4.872-.392-7.44.168-2.527.576-4.935 1.528-7.215 2.872-2.28 1.344-4.11 2.72-5.47 4.064-.52-.496-1.04-.984-1.56-1.472-.577-.528-1.296-.816-2.16-.8-.873 0-1.593.376-2.185 1.064-.576.672-.84 1.456-.736 2.28.08.856.423 1.512 1.015 2.016.52.44 1.04.872 1.56 1.328-2.048 2.472-3.736 5.2-5.064 8.08-1.343 2.888-2.143 5.752-2.44 8.528-.31 2.8-.015 5.36.84 7.736.857 2.392 2.44 4.424 4.753 6.344 3.768 3.128 8.2 4.456 13.344 4.16 5.127-.313 10.656-1.84 16.6-5.032 4.72 5.456 9.455 10.872 14.183 15.904-2 1.688-3.752 2.655-5.296 2.968-1.544.328-2.92.296-4.167-.08-1.248-.393-2.408-.952-3.473-1.672-1.063-.736-2.11-1.36-3.16-1.872-1.03-.512-2.095-.8-3.183-.816-1.087-.016-2.247.513-3.527 1.608-1.312 1.144-1.968 2.472-1.968 3.968 0 1.488.688 3 2.032 4.528 1.36 1.527 3.128 2.815 5.264 3.83 2.137 1.018 4.552 1.657 7.21 1.833 2.655.185 5.455-.216 8.407-1.312 2.968-1.08 5.903-3.03 8.8-5.936 1.392 1.36 2.8 2.656 4.2 3.904.592.512 1.312.77 2.184.704.84-.032 1.576-.424 2.16-1.128.593-.72.84-1.512.753-2.344-.08-.84-.425-1.488-1-1.952-1.408-1.128-2.816-2.312-4.216-3.56 2.392-2.937 4.312-6.032 5.735-9.096 1.424-3.08 2.264-6.048 2.544-8.8.28-2.77-.048-5.265-.952-7.53-.898-2.292-2.49-4.26-4.77-6.156zm-44.726 5.425c-2.264.096-4.24-.656-5.968-2.328-.736-.704-1.248-1.56-1.56-2.576-.328-1.016-.44-2.128-.312-3.344.112-1.2.472-2.456 1.096-3.72.592-1.264 1.472-2.528 2.592-3.752 4.056 4.032 8.104 8.456 12.16 13.032-3.072 1.688-5.745 2.592-8.008 2.688zm37.734 16.016c-.72 1.328-1.544 2.513-2.512 3.544-4.488-4.527-8.968-9.504-13.44-14.607 1.145-.512 2.345-1.048 3.64-1.592 1.297-.543 2.593-.903 3.89-1.127 1.327-.2 2.64-.144 3.95.168 1.297.33 2.53 1.033 3.673 2.145 1.128 1.128 1.84 2.297 2.128 3.56.314 1.28.33 2.576.113 3.904-.233 1.334-.705 2.662-1.44 4.006zm-31.767 36.8c1.576-1.272 3.896-1.208 5.344.264 1.566 1.56 1.566 4.112 0 5.672-.13.128-.265.216-.41.328l.017.016c-5.064 3.85-9.224 7.313-13.712 11.8-4.056 4.048-7.72 8.313-10.888 12.64l-5.112 7c-.16.288-.352.552-.592.8-1.568 1.56-4.12 1.56-5.68 0-1.36-1.36-1.528-3.455-.528-5.016l-.016-.016 5.47-7.472c3.417-4.673 7.345-9.248 11.69-13.592 4.52-4.536 9.4-8.584 14.398-12.424h.017zm29.287-115.72c4.048-4.047 7.704-8.295 10.88-12.646l5.312-7.28c.192-.344.408-.688.704-.984 1.576-1.576 4.128-1.576 5.704 0 1.496 1.504 1.56 3.88.2 5.472l.016.016-5.472 7.504c-3.424 4.672-7.345 9.23-11.688 13.576-4.52 4.52-9.392 8.583-14.392 12.423l-.03-.016c-1.594 1.465-4.065 1.433-5.593-.11-1.576-1.577-1.576-4.145 0-5.72.28-.297.607-.505.936-.69 4.703-3.59 9.24-7.36 13.422-11.543z"/></symbol><symbol id="icon-symbol-more" viewBox="0 0 256 256"><circle cx="128" cy="128" r="27.5"/><circle cx="228.5" cy="128" r="27.5"/><circle cx="27.5" cy="128" r="27.5"/></symbol><symbol id="icon-symbol-new-tab" viewBox="0 0 256 256"><path d="M36.57 0v219.43H256V0H36.57zm201.144 201.143H54.857V18.286h182.857v182.857zM18.286 237.715v-192L0 27.43V256h228.57l-18.284-18.285h-192zM82.286 54.857L128 100.57 73.143 155.43l27.43 27.43L155.428 128l45.713 45.715V54.857H82.286z"/></symbol><symbol id="icon-symbol-paperplane" viewBox="0 0 256 256"><path d="M252.34 1.28C251.015.424 249.5 0 247.998 0c-1.544 0-3.096.44-4.44 1.344L3.566 161.34c-2.472 1.64-3.832 4.527-3.512 7.487.304 2.952 2.224 5.504 4.984 6.592l62.59 25.046 29.43 51.503c1.41 2.47 4.025 4 6.857 4.03.032 0 .056 0 .088 0 2.808 0 5.416-1.487 6.855-3.888l16.616-27.703 77.557 31.015c.952.384 1.952.567 2.968.567 1.36 0 2.704-.344 3.92-1.03 2.112-1.186 3.56-3.266 3.968-5.657l40-239.993c.52-3.144-.873-6.295-3.545-8.032zM25.093 166.21L210.486 42.608 75.69 186.897c-.71-.423-1.344-.982-2.128-1.295l-48.47-19.39zm56.423 26.312c-.016-.032-.04-.048-.056-.08L233 30.247l-129.19 201.29-22.295-39.015zm120.22 44.343l-68.326-27.327c-1.625-.64-3.314-.856-4.985-.952l105.213-163.1-31.904 191.38z"/></symbol><symbol id="icon-symbol-parent-folder" viewBox="0 0 256 256"><path d="M253.988 132.157c-1.967-4.112-4.962-7.264-8.984-9.454-4.023-2.19-8.45-3.285-13.276-3.285H205.98V97.96c0-8.224-2.95-15.286-8.852-21.187s-12.963-8.85-21.188-8.85h-72.95V63.63c0-8.225-2.95-15.287-8.852-21.188-5.9-5.9-12.963-8.85-21.188-8.85H30.04c-8.226 0-15.29 2.95-21.19 8.85S0 55.406 0 63.632v128.737c0 8.224 2.95 15.286 8.85 21.187s12.965 8.85 21.19 8.85h145.9c5.99 0 12.25-1.54 18.774-4.625 6.527-3.084 11.712-6.995 15.557-11.734l39.56-48.68c4.114-5.184 6.17-10.548 6.17-16.09 0-3.22-.67-6.26-2.012-9.12zM17.165 63.63c0-3.574 1.25-6.614 3.755-9.117 2.503-2.504 5.543-3.755 9.12-3.755h42.91c3.577 0 6.616 1.25 9.12 3.755 2.503 2.503 3.755 5.543 3.755 9.118v8.584c0 3.576 1.25 6.615 3.755 9.12 2.503 2.502 5.543 3.754 9.12 3.754h77.24c3.577 0 6.616 1.25 9.12 3.755 2.503 2.503 3.754 5.543 3.754 9.118v21.458H85.824c-6.078 0-12.336 1.542-18.773 4.626-1.497.718-2.92 1.485-4.284 2.293V102.3h20.586L53.617 72.593 23.882 102.3h20.585v41.387c0 .234.018.464.036.694l-27.338 33.64V63.63zm219.257 82.876l-39.427 48.68c-2.235 2.77-5.408 5.14-9.52 7.106-4.114 1.967-7.958 2.95-11.534 2.95H30.04c-4.74 0-7.108-1.563-7.108-4.693 0-1.43.805-3.22 2.414-5.365l39.426-48.68c2.324-2.77 5.52-5.116 9.588-7.04s7.89-2.882 11.466-2.882h145.902c4.738 0 7.107 1.563 7.107 4.693 0 1.52-.805 3.264-2.413 5.23z"/></symbol><symbol id="icon-symbol-pen" viewBox="0 0 256 256"><path d="M235.163 20.64C222.003 7.496 204.676 0 187.596 0c-14.408 0-27.672 5.344-37.36 15.016L111.3 54.248c-.12.112-.256.184-.376.304-.064.064-.104.152-.168.208l.016.016-82.632 83.272c-3.808 3.784-6.568 8.496-8.104 13.64L1.244 219.752c-.016.184-1.24 5.528-1.24 8.248 0 15.456 12.552 28 28.032 28 3.08 0 9.04-1.472 9.256-1.504l67.824-17.832c5.152-1.528 9.832-4.313 13.64-8.128L240.86 105.472C263.067 83.248 260.563 46 235.163 20.64zM128.116 190.36c-.656-7.216-2.696-14.296-5.752-21.017l75.64-75.632c4.624 14.61 2.248 29.89-7.89 40.033-.062.063-.143.104-.198.168l.11.105-61.823 62.32c0-1.99.096-3.942-.087-5.975zm-9.768-28.312c-2.984-4.903-6.376-9.64-10.576-13.832-4.888-4.888-10.496-8.72-16.352-11.936l76.256-76.256c5.983 2.656 11.72 6.44 16.784 11.504 4.327 4.312 7.672 9.144 10.248 14.168l-76.36 76.352zm-34.456-29.552c-7.408-2.984-15.168-4.688-22.944-4.792l61.624-62.096c9.43-9.2 23.167-11.848 36.696-8.496l-75.376 75.384zM33.34 238.984c-.873.2-3.585.888-5.425 1.016-6.576-.08-11.912-5.424-11.912-12 .096-1.344.632-3.656.816-4.496l8.423-30.512c9.144-.248 18.984 3.312 26.72 11.063 7.856 7.84 11.552 17.872 11.152 27.128l-29.776 7.8zm37.656-9.888c-.192-10.735-4.56-21.904-13.376-30.703-8.336-8.345-19.248-13.16-30.128-13.593l7.968-28.855c.576-1.92 1.72-3.816 3.128-5.473 16.048-11.487 40.728-8.096 57.872 9.064 18.136 18.128 20.936 44.688 6.968 60.544-.928.488-1.864.952-2.872 1.248l-29.56 7.768zM229.53 94.176l-13.47 13.576c0-1.808.215-3.544.047-5.392-1.408-15.48-8.624-30.448-20.344-42.152-13.032-13.04-30.313-20.52-47.424-20.568l13.247-13.36c6.633-6.616 15.89-10.28 26.01-10.28 12.87 0 26.095 5.824 36.263 15.96 9.544 9.528 15.232 21.368 16.048 33.344.75 11.176-2.936 21.424-10.377 28.872z"/></symbol><symbol id="icon-symbol-pipe" viewBox="0 0 256 256"><path d="M93.134,239.762c-7.846,0-15.285-3.508-20.277-9.57L5.992,148.998c-9.223-11.198-7.621-27.754,3.579-36.977 c11.199-9.223,27.754-7.621,36.977,3.579l46.277,56.195L209.207,26.112c9.056-11.334,25.584-13.183,36.919-4.127 c11.335,9.056,13.183,25.584,4.128,36.919L113.658,229.889c-4.942,6.187-12.411,9.813-20.328,9.872 C93.265,239.762,93.199,239.762,93.134,239.762z"/></symbol><symbol id="icon-symbol-planet" viewBox="0 0 256 256"><path d="M128 0C57.303 0 0 57.303 0 128s57.303 128 128 128 128-57.303 128-128S198.697 0 128 0zm111.277 123.87H189.76c-.453-18.29-3.707-35.765-9.478-51.76 11.148-4.65 21.454-10.835 30.852-18.144 16.706 18.755 27.152 43.108 28.143 69.905zM123.433 239.254c-13.725-11.43-25.236-26.27-33.66-43.504 10.81-3.378 22.264-5.23 34.098-5.608v49.128c-.148 0-.288-.01-.437-.017zm9.117-222.505c15.575 12.965 28.284 30.332 36.88 50.59-11.775 4.02-24.286 6.357-37.31 6.77V16.723c.157.008.29.016.43.025zm13.76 1.403c22.79 3.792 43.238 14.436 59.16 29.845-8.647 6.63-18.094 12.247-28.31 16.5-7.514-17.812-18.06-33.56-30.85-46.344zm-22.44-1.427v57.385c-13.022-.42-25.54-2.75-37.31-6.77 8.598-20.258 21.307-37.625 36.88-50.59.15-.01.282-.017.43-.025zm-45.038 47.78c-10.2-4.252-19.654-9.868-28.3-16.5C66.444 32.596 86.9 21.95 109.692 18.16c-12.8 12.775-23.338 28.523-30.86 46.344zm4.616 10.447c12.734 4.418 26.302 6.995 40.423 7.424v41.497H74.497c.446-17.29 3.51-33.816 8.952-48.92zm40.423 57.18v49.754c-13.022.396-25.616 2.527-37.482 6.35-7.15-17.027-11.372-35.996-11.892-56.104h49.375zm-14.178 105.72c-20.422-3.395-38.97-12.29-54.05-25.204 8.135-5.64 16.93-10.414 26.328-14.04 7.2 14.93 16.623 28.185 27.722 39.243zm22.437 1.427V190.15c11.825.38 23.287 2.23 34.097 5.606-8.432 17.235-19.935 32.075-33.66 43.504-.14 0-.29.01-.438.017zm41.9-40.67c9.39 3.624 18.176 8.405 26.327 14.038-15.08 12.907-33.627 21.81-54.05 25.203 11.1-11.057 20.514-24.31 27.723-39.242zm-4.418-10.373c-11.875-3.823-24.47-5.954-37.483-6.35v-49.756h49.374c-.52 20.11-4.748 39.078-11.892 56.106zM132.13 123.87V82.375c14.112-.43 27.68-2.998 40.422-7.416 5.435 15.104 8.498 31.628 8.952 48.92H132.13v-.007zM44.874 53.967C54.272 61.276 64.58 67.46 75.72 72.11c-5.773 15.995-9.027 33.47-9.48 51.76H16.722c.99-26.796 11.437-51.15 28.152-69.904zM16.723 132.13h49.515c.512 21.1 4.922 41.025 12.412 58.937-10.463 4.08-20.216 9.514-29.217 15.946-19.39-19.3-31.63-45.683-32.71-74.884zm189.844 74.875c-9-6.425-18.754-11.867-29.226-15.946 7.5-17.913 11.9-37.84 12.42-58.94h49.517c-1.082 29.21-13.328 55.594-32.71 74.885z"/></symbol><symbol id="icon-symbol-play" viewBox="0 0 256 256"><path d="M128,0C57.4,0,0,57.4,0,128c0,70.6,57.4,128,128,128c70.6,0,128-57.4,128-128C256,57.4,198.6,0,128,0z M128,242.9 c-63.3,0-114.9-51.5-114.9-114.9C13.1,64.7,64.7,13.1,128,13.1c63.3,0,114.9,51.5,114.9,114.9C242.9,191.3,191.3,242.9,128,242.9z"/><path d="M189,122.9L98.2,74.6c-1.8-0.9-3.9-0.9-5.6,0.1c-1.7,1-2.8,2.9-2.8,4.9v96.7c0,2,1,3.8,2.8,4.9c0.9,0.5,1.9,0.8,2.9,0.8 c0.9,0,1.8-0.2,2.7-0.7l90.8-48.3c1.9-1,3-2.9,3-5C192,125.8,190.9,123.9,189,122.9z"/></symbol><symbol id="icon-symbol-prim-table" viewBox="0 0 256 256"><g><g><g><circle cx="62.4" cy="61.5" r="17.3"/><circle cx="62.4" cy="124.8" r="17.3"/><circle cx="62.4" cy="188.1" r="17.3"/></g><g><circle cx="193.6" cy="61.5" r="17.3"/><circle cx="193.6" cy="124.8" r="17.3"/></g></g><path d="M128,221c-4.7,0-8.4-3.8-8.4-8.4V43.4c0-4.7,3.8-8.4,8.4-8.4c4.7,0,8.4,3.8,8.4,8.4v169.1C136.4,217.2,132.7,221,128,221z"/></g></symbol><symbol id="icon-symbol-question-mark" viewBox="0 0 256 256"><path d="M186.168 17.55C169.94 5.845 149.588 0 125.07 0c-18.66 0-34.39 4.124-47.175 12.345C57.6 25.23 46.82 47.105 45.512 77.965H92.53c0-8.988 2.617-17.65 7.865-25.983 5.248-8.334 14.15-12.5 26.71-12.5 12.756 0 21.56 3.384 26.367 10.14 4.82 6.783 7.225 14.278 7.225 22.5 0 7.153-3.584 13.695-7.907 19.654-2.375 3.47-5.52 6.656-9.4 9.585 0 0-25.5 16.356-36.708 29.497-6.5 7.624-7.083 19.03-7.652 35.4-.042 1.165.398 3.568 4.48 3.568 4.082 0 32.953 0 36.58 0s4.38-2.688 4.437-3.868c.257-5.96.925-9.002 2.02-12.444 2.063-6.5 7.638-12.174 13.924-17.052l12.943-8.93c11.677-9.103 21.006-16.57 25.116-22.43 7.024-9.64 11.96-21.502 11.96-35.568-.002-22.97-8.123-40.29-24.322-51.982zM124.316 198.028c-16.213-.484-29.582 10.724-30.094 28.302-.512 17.564 12.203 29.17 28.416 29.653 16.925.497 29.938-10.354 30.45-27.918.498-17.58-11.848-29.54-28.772-30.037z"/></symbol><symbol id="icon-symbol-quote" viewBox="0 0 256 256"><g><path d="M86.7,128.2h-3.1c-8.8,0-16.8-3.4-24-10.3c-7.2-6.8-10.7-15.4-10.7-25.6c0-9.9,3.6-18.3,10.7-25c7.2-6.8,16-10.1,26.6-10.1 c11.6,0,21.2,4.7,28.8,14.2c7.6,9.4,11.3,22.6,11.3,39.4c0,12.1-2,23.5-5.9,34.2c-3.9,10.7-9,20-15.2,28 c-6.2,7.9-12.9,14.2-20.1,18.9c-7.2,4.6-13.6,7-19.2,7c-5.2,0-9.2-1.5-11.9-4.4c-2.8-2.9-4.1-6.8-4.1-11.7c0-7.1,3.1-12.2,9.2-15.3 c8.7-4.9,15.2-10.3,19.6-16.2C83,145.3,85.7,137.7,86.7,128.2z"/><path d="M167.9,127.8h-3.3c-9,0-17-3.4-24.2-10.3c-7.2-6.8-10.7-15.4-10.7-25.6c0-10.1,3.6-18.4,10.7-24.9c7.2-6.5,16-9.8,26.6-9.8 c11.5,0,21,4.6,28.7,13.8c7.6,9.2,11.4,22.3,11.4,39.3c0,15.6-3.3,30.2-10,43.8c-6.7,13.6-14.9,24.4-24.5,32.3 c-9.7,7.9-18.3,11.9-25.8,11.9c-5,0-9-1.5-11.8-4.5c-2.8-3-4.2-6.8-4.2-11.6c0-6.9,3.1-12,9.2-15.3c8.3-4.6,15-9.9,19.8-16.1 C164.5,144.8,167.3,137,167.9,127.8z"/></g></symbol><symbol id="icon-symbol-redo" viewBox="0 0 256 256"><path d="M144 20c-4.096 0-8.19 1.552-11.313 4.672C129.567 27.808 128 31.904 128 36v40.944C56 84.912 0 145.888 0 220v16c35.92-54.77 84-62.72 128-63.823V212c0 4.08 1.568 8.192 4.688 11.312 3.12 3.12 7.216 4.688 11.312 4.688s8.19-1.567 11.313-4.688L256 124 155.313 24.672C152.19 21.552 148.096 20 144 20z"/></symbol><symbol id="icon-symbol-refresh" viewBox="0 0 256 256"><path d="M218.67,217.405c23.036-23.065,36.261-53.493,37.324-86.22c0.201-6.046-4.536-11.097-10.573-11.298 c-6.073-0.222-11.11,4.535-11.307,10.582c-1.25,38.292-22.751,71.253-53.869,88.912c-0.254,0.131-0.508,0.28-0.762,0.409 c-1.077,0.615-2.186,1.191-3.283,1.751c-1.005,0.51-2.012,1.018-3.027,1.497c-0.363,0.173-0.71,0.338-1.075,0.485 c-1.351,0.63-2.708,1.225-4.099,1.777c-0.006,0.002-0.011,0.005-0.017,0.007c-27.062,10.956-57.768,10.313-84.402-1.936 c-0.333-0.159-0.662-0.327-0.982-0.469c-0.949-0.451-1.88-0.922-2.82-1.399c-0.869-0.45-1.733-0.895-2.579-1.357 c-0.39-0.213-0.774-0.432-1.156-0.649c-18.349-10.342-33.288-25.986-42.789-44.76c-0.219-0.435-0.423-0.85-0.636-1.287 c-0.453-0.925-0.883-1.855-1.308-2.771c-0.521-1.156-1.029-2.294-1.501-3.464c-0.085-0.218-0.172-0.438-0.261-0.655 c-10.774-26.897-10.097-57.36,2.023-83.832c0.202-0.449,0.417-0.883,0.629-1.33c0.388-0.809,0.789-1.622,1.194-2.423 c0.511-1.004,1.038-2.003,1.583-2.989c0.13-0.24,0.264-0.478,0.396-0.717c10.364-18.48,26.083-33.511,44.967-43.05 c0.359-0.183,0.708-0.354,1.069-0.536c0.981-0.479,1.97-0.941,2.966-1.397c1.137-0.51,2.275-1.015,3.425-1.487 c0.219-0.087,0.44-0.169,0.66-0.26c38.207-15.287,83.58-7.521,114.518,23.319l-37.961,37.941h90.819V-0.999l-37.38,37.382 c-23.573-23.512-54.121-35.913-85.022-37.207c-0.408-0.053-0.819-0.098-1.219-0.113C130.792-0.979,129.393-1,127.977-1 c-15.875,0-31.122,2.923-45.218,8.273c-0.013,0.005-0.026,0.01-0.039,0.015c-0.603,0.229-1.202,0.466-1.801,0.704 c-0.517,0.198-1.035,0.406-1.55,0.62c-0.04,0.018-0.089,0.034-0.129,0.051c-15.198,6.238-29.42,15.507-41.743,27.828 c-11.19,11.181-19.863,23.942-26.032,37.568c-0.114,0.249-0.225,0.498-0.338,0.747c-0.247,0.56-0.493,1.109-0.731,1.67 c-0.292,0.682-0.582,1.378-0.869,2.065c-0.048,0.127-0.105,0.254-0.154,0.382c-5.527,13.604-8.797,28.38-9.304,43.9 c-0.568,17.341,2.366,33.982,8.154,49.275c0.03,0.102,0.059,0.182,0.097,0.283c0.201,0.535,0.416,1.068,0.629,1.602 c0.231,0.586,0.463,1.191,0.707,1.775c0.012,0.025,0.026,0.052,0.041,0.077c6.235,15.171,15.502,29.377,27.802,41.671 c11.758,11.756,25.253,20.741,39.662,26.962c14.364,6.237,30.11,9.93,46.69,10.468c1.429,0.042,2.86,0.063,4.283,0.063 c29.607,0,57.811-10.046,80.641-28.664c0.277-0.22,0.552-0.452,0.829-0.685c0.518-0.428,1.031-0.854,1.536-1.269 c0.412-0.374,0.837-0.734,1.265-1.114c0.354-0.313,0.721-0.623,1.08-0.962c0.427-0.366,0.828-0.761,1.251-1.132 c0.271-0.252,0.547-0.499,0.816-0.752c0.108-0.103,0.191-0.187,0.278-0.268c0.399-0.38,0.773-0.743,1.17-1.127 c0.429-0.395,0.836-0.811,1.26-1.231c0.096-0.09,0.205-0.185,0.296-0.29C218.589,217.475,218.63,217.438,218.67,217.405z"/></symbol><symbol id="icon-symbol-rotate-device" viewBox="0 0 256 256"><g><path d="M131.541,0H12.648C5.674,0,0,5.674,0,12.648v230.703C0,250.326,5.674,256,12.648,256h118.893 c6.975,0,12.648-5.674,12.648-12.648V12.648C144.189,5.674,138.516,0,131.541,0z M137.106,243.352c0,3.068-2.497,5.565-5.565,5.565 H12.648c-3.069,0-5.565-2.497-5.565-5.565V12.648c0-3.069,2.497-5.565,5.565-5.565h118.893c3.068,0,5.565,2.497,5.565,5.565 V243.352z"/><path d="M72.095,223.62c-6.137,0-11.13,4.993-11.13,11.131s4.993,11.131,11.13,11.131c6.138,0,11.13-4.993,11.13-11.131 S78.232,223.62,72.095,223.62z M72.095,238.799c-2.231,0-4.047-1.815-4.047-4.048s1.816-4.048,4.047-4.048 c2.232,0,4.047,1.815,4.047,4.048S74.327,238.799,72.095,238.799z"/><path d="M82.213,12.648H61.976c-1.956,0-3.542,1.585-3.542,3.542c0,1.956,1.585,3.542,3.542,3.542h20.237 c1.956,0,3.542-1.586,3.542-3.542C85.755,14.234,84.169,12.648,82.213,12.648z"/><path d="M243.352,111.81h-93.091c-1.955,0-3.541,1.585-3.541,3.542s1.586,3.542,3.541,3.542h93.091 c3.069,0,5.565,2.497,5.565,5.565v118.893c0,3.069-2.496,5.565-5.565,5.565h-95.114c-1.956,0-3.542,1.586-3.542,3.542 c0,1.955,1.586,3.541,3.542,3.541h95.114c6.975,0,12.648-5.674,12.648-12.648V124.458C256,117.484,250.326,111.81,243.352,111.81z"/><path d="M243.352,194.023v-20.237c0-1.955-1.586-3.541-3.541-3.541c-1.956,0-3.542,1.586-3.542,3.541v20.237 c0,1.956,1.586,3.542,3.542,3.542C241.766,197.565,243.352,195.979,243.352,194.023z"/><path d="M172.016,45.534c0,0.017,0.005,0.033,0.005,0.05c0.001,0.063,0.014,0.125,0.019,0.188c0.007,0.11,0.013,0.219,0.031,0.33 c0.007,0.042,0.007,0.084,0.015,0.125c0.02,0.095,0.055,0.182,0.081,0.274c0.019,0.066,0.024,0.134,0.048,0.2 c0.01,0.029,0.026,0.055,0.037,0.083c0.013,0.035,0.021,0.07,0.035,0.104c0.022,0.055,0.054,0.104,0.079,0.157 c0.055,0.115,0.113,0.226,0.179,0.333c0.024,0.04,0.041,0.082,0.067,0.121c0.02,0.03,0.045,0.056,0.065,0.085 c0.094,0.131,0.196,0.253,0.305,0.369c0.026,0.028,0.047,0.062,0.074,0.089l0.053,0.053c0.001,0,0.001,0,0.001,0l10.315,10.316 c0.691,0.691,1.598,1.037,2.504,1.037s1.813-0.346,2.504-1.037c1.384-1.383,1.384-3.625,0-5.009l-2.376-2.376 c11.008,4.234,18.845,14.913,18.845,27.395c0,1.956,1.586,3.542,3.541,3.542c1.956,0,3.542-1.585,3.542-3.542 c0-15.327-9.52-28.464-22.954-33.833l2.047-0.714c1.847-0.644,2.822-2.663,2.178-4.51c-0.644-1.847-2.662-2.823-4.51-2.178 l-14.354,5.006c-0.026,0.009-0.048,0.024-0.073,0.034c-0.038,0.014-0.076,0.023-0.114,0.039c-0.093,0.039-0.177,0.092-0.266,0.138 c-0.088,0.045-0.178,0.086-0.26,0.139c-0.028,0.017-0.057,0.03-0.084,0.048c-0.077,0.051-0.143,0.116-0.215,0.172 c-0.089,0.07-0.179,0.137-0.261,0.215c-0.082,0.078-0.153,0.165-0.228,0.25s-0.149,0.168-0.215,0.26 c-0.021,0.029-0.046,0.056-0.065,0.085c-0.048,0.071-0.08,0.149-0.121,0.223c-0.053,0.091-0.106,0.18-0.15,0.276 c-0.017,0.038-0.038,0.072-0.054,0.111c-0.033,0.079-0.05,0.163-0.077,0.244c-0.033,0.099-0.067,0.197-0.091,0.298 c-0.01,0.041-0.024,0.078-0.033,0.119c-0.016,0.079-0.016,0.159-0.025,0.239c-0.015,0.113-0.029,0.226-0.033,0.341 c-0.001,0.021-0.006,0.041-0.006,0.062C172.021,45.501,172.016,45.517,172.016,45.534z"/></g></symbol><symbol id="icon-symbol-search" viewBox="-15 17 256 256"><path d="M145 17c-53 0-96 43-96 96 0 16.2 4.1 31.5 11.2 44.9l-66.8 66.7h.1c-5.2 5.1-8.5 12.2-8.5 20.1 0 15.6 12.6 28.2 28.2 28.2 7.9 0 15-3.2 20.1-8.5l66.7-66.7c13.4 7.1 28.7 11.2 44.9 11.2 53 0 96-43 96-96C241 60 198 17 145 17zM23.4 254.5c-2.6 2.7-6.1 4.3-10.1 4.3-7.8 0-14.1-6.3-14.1-14.1 0-4 1.7-7.5 4.3-10.1l-.1-.1L67.9 170c5.6 7.6 12.4 14.3 20 20l-64.5 64.5zM145 193c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zm0-136c2.2 0 4 1.8 4 4s-1.8 4-4 4c-26.5 0-48 21.5-48 48 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-30.9 25.1-56 56-56z"/></symbol><symbol id="icon-symbol-settings" viewBox="0 0 256 256"><path d="M243.128 101.428l-24.512-4.91c-1.232-3.545-2.688-6.985-4.296-10.314l13.888-20.832c4.23-6.344 3.392-14.8-2-20.184l-15.392-15.393c-3.097-3.096-7.185-4.688-11.328-4.688-3.064 0-6.16.88-8.856 2.688L169.8 41.675c-3.344-1.614-6.784-3.055-10.328-4.286l-4.91-24.522C153.07 5.38 146.496.004 138.87.004h-21.76c-7.623 0-14.19 5.385-15.687 12.864l-4.912 24.52C92.97 38.62 89.53 40.07 86.2 41.677l-20.823-13.88c-2.712-1.808-5.8-2.688-8.872-2.688-4.136 0-8.224 1.592-11.32 4.688L29.8 45.188c-5.392 5.392-6.232 13.84-2 20.184l13.88 20.832c-1.616 3.336-3.056 6.776-4.288 10.32l-24.528 4.903C5.384 102.924 0 109.492 0 117.117v21.76c0 7.623 5.384 14.2 12.864 15.687l24.52 4.92c1.232 3.544 2.68 6.984 4.288 10.313L27.8 190.627c-4.232 6.346-3.392 14.802 2 20.186l15.392 15.392c3.096 3.097 7.184 4.688 11.32 4.688 3.072 0 6.168-.888 8.864-2.688l20.832-13.888c3.336 1.624 6.776 3.064 10.32 4.296l4.903 24.512c1.497 7.488 8.065 12.872 15.69 12.872h21.76c7.623 0 14.2-5.392 15.687-12.872l4.92-24.512c3.544-1.23 6.983-2.688 10.312-4.296l20.83 13.888c2.705 1.8 5.8 2.688 8.857 2.688 4.144 0 8.23-1.592 11.328-4.688l15.392-15.392c5.392-5.393 6.23-13.84 2-20.185l-13.888-20.83c1.623-3.346 3.062-6.785 4.295-10.33l24.512-4.903c7.48-1.48 12.872-8.064 12.872-15.688v-21.76c0-7.625-5.393-14.193-12.872-15.69zm-27.656 42.36c-5.56 1.112-10.11 5.08-11.968 10.44-1.032 2.952-2.232 5.815-3.576 8.592-2.488 5.112-2.063 11.145 1.08 15.856l13.89 20.832-15.394 15.392-20.832-13.888c-2.672-1.784-5.768-2.688-8.872-2.688-2.376 0-4.768.528-6.968 1.592-2.784 1.345-5.64 2.56-8.607 3.593-5.345 1.854-9.313 6.406-10.425 11.967l-4.92 24.527h-21.76l-4.904-24.527c-1.112-5.56-5.08-10.112-10.432-11.968-2.952-1.033-5.824-2.233-8.6-3.577-2.208-1.08-4.592-1.608-6.976-1.608-3.112 0-6.2.904-8.872 2.688L56.504 214.9l-15.392-15.392 13.88-20.832c3.144-4.72 3.552-10.752 1.096-15.84-1.344-2.784-2.552-5.64-3.584-8.608-1.856-5.344-6.416-9.313-11.968-10.424l-24.52-4.92L16 117.116l24.528-4.904c5.552-1.11 10.112-5.08 11.968-10.432 1.032-2.952 2.224-5.824 3.576-8.6 2.48-5.104 2.063-11.137-1.088-15.85L41.112 56.5l15.384-15.392 20.832 13.88c2.672 1.784 5.768 2.688 8.872 2.688 2.376 0 4.76-.527 6.968-1.592 2.776-1.344 5.64-2.552 8.6-3.584 5.352-1.855 9.32-6.416 10.432-11.968l4.912-24.52 21.76-.01 4.904 24.53c1.11 5.55 5.08 10.11 10.44 11.967 2.95 1.03 5.815 2.224 8.592 3.575 2.215 1.072 4.592 1.6 6.983 1.6 3.113 0 6.2-.903 8.873-2.688l20.832-13.88L214.888 56.5 201 77.332c-3.145 4.72-3.544 10.744-1.096 15.84 1.344 2.776 2.56 5.64 3.592 8.6 1.855 5.353 6.408 9.32 11.968 10.433l24.513 4.912.023 21.76-24.528 4.91zM128 71.996c-30.92 0-56 25.08-56 56 0 30.93 25.08 56 56 56s56-25.08 56-56-25.08-56-56-56zm0 105.01c-27.056 0-49-21.953-49-49.002 0-27.056 21.944-49 49-49 27.048 0 49 21.944 49 49 0 27.05-21.952 49-49 49zm0-81.01c-17.68 0-32 14.32-32 32 0 17.672 14.32 32 32 32 17.672 0 32-14.328 32-32s-14.328-32-32-32zm0 56.01c-13.248 0-24-10.754-24-24.002s10.752-24 24-24 24 10.752 24 24-10.752 24-24 24z"/></symbol><symbol id="icon-symbol-showpass" viewBox="0 0 256 256"><path d="M255.7,126.2c-0.1-0.3,0-0.7-0.2-1c0-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.1-0.4-0.2-0.6C231.9,79.8,181.4,47.9,128,47.9 c-53.4,0-103.9,31.8-127.2,76.3c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3-0.1,0.7-0.2,1C0.1,126.8,0,127.3,0,128 c0,0.6,0.1,1.2,0.3,1.8c0.1,0.3,0,0.7,0.2,1c0,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.2,0.6C24.1,176.2,74.6,208,128,208 c53.3,0,103.9-31.8,127.2-76.3c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.2-0.2,0.2-0.3c0.1-0.3,0.1-0.7,0.2-1c0.1-0.6,0.3-1.2,0.3-1.8 C256,127.4,255.8,126.8,255.7,126.2z M128,192c-45,0-89-25.6-111-64.1c22.1-38.5,66-64,111-64c45,0,89,25.6,111,64 C216.9,166.5,172.9,192,128,192z"/><ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -19.0313 233.6914)" cx="127.8" cy="128" rx="56.1" ry="56.1"/></symbol><symbol id="icon-symbol-speach-bubble" viewBox="0 0 256 256"><path d="M128 56c2.208 0 4 1.792 4 4s-1.8 4-4 4c-42.616 0-80 22.432-80 48 0 2.208-1.792 4-4 4s-4-1.792-4-4c0-30.352 40.296-56 88-56zm0-40C57.304 16 0 58.984 0 112c0 33.016 22.232 62.128 56.064 79.408 0 .216-.064.36-.064.592 0 14.344-10.712 29.784-15.424 37.888.008 0 .016 0 .016 0-.376.88-.592 1.85-.592 2.864 0 4 3.24 7.248 7.248 7.248.752 0 2.072-.2 2.04-.112 25-4.096 48.552-27.063 54.024-33.72C111.304 207.344 119.544 208 128 208c70.68 0 128-42.984 128-96s-57.312-96-128-96zm0 176c-7.336 0-14.864-.56-22.368-1.656-.776-.128-1.552-.168-2.32-.168-4.752 0-9.304 2.112-12.368 5.84-3.424 4.168-13.168 13.473-24.68 20.313 3.12-7.16 5.56-15.185 5.728-23.457.048-.512.072-1.032.072-1.472 0-6.016-3.368-11.512-8.72-14.247C33.696 162.016 16 137.656 16 112c0-44.112 50.24-80 112-80 61.744 0 112 35.888 112 80s-50.248 80-112 80z"/></symbol><symbol id="icon-symbol-study" viewBox="0 0 256 256"><g><g><path d="M24,209v5c0,8.9,6,16.8,14.6,19.1l73.5,23.1c1.7,0.5,3.5,0.7,5.2,0.7c4.3,0,8.5-1.4,12-4.1c4.9-3.8,7.8-12.7,7.8-19v-2.2 h75c10.9,0,19.8-8.9,19.8-19.8V45.7c0-11-8.9-19.9-19.8-19.9h-74.8v-2.2c0-6.2-2.8-14.7-7.7-18.5c-4.9-3.8-11.1-5-17.1-3.5 L38.8,23.7C30.1,26,24,33.9,24,43v5.6 M24.2,180.5V191 M24.2,152v10.5 M24.2,123.5V134 M24.2,95v10.5 M24.2,66.6V77 M119.3,233.9 c0,0.7-0.4,1.2-0.7,1.4c-0.3,0.3-0.9,0.5-1.6,0.3l-14.6-3.9l-58.9-15.8c-0.8-0.2-1.3-0.9-1.3-1.8V43c0-0.8,0.6-1.5,1.3-1.8 L102,25.9l15-3.9c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.8,0.2,1.1,0.4c0.3,0.3,0.7,0.7,0.7,1.4V233.9z M137.3,191v-10.4h31.4c5,0,9-4,9-9 s-4-9-9-9h-31.4v-10.5h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4v-10.4h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V95.1h56.4c5,0,9-4,9-9s-4-9-9-9 h-56.4V66.6 M137.3,48.6V44h74.9c1,0,1.8,0.8,1.8,1.8V212c0,1-0.8,1.8-1.8,1.8h-74.8v-4.6"/></g><path d="M59.1,104c-4.3,0-8.1-3.1-8.9-7.5c-0.8-4.9,2.4-9.6,7.3-10.4l40.5-7c4.9-0.8,9.6,2.4,10.4,7.3c0.8,4.9-2.4,9.6-7.3,10.4 l-40.5,7C60.2,104,59.6,104,59.1,104z"/><path d="M59.1,128c-4.5,0-8.4-3.4-8.9-7.9c-0.6-4.9,3-9.4,7.9-10l25.5-3c4.9-0.6,9.4,3,10,7.9c0.6,4.9-3,9.4-7.9,10l-25.5,3 C59.8,128,59.5,128,59.1,128z"/></g></symbol><symbol id="icon-symbol-test" viewBox="0 0 256 256"><g id="Layer_3"><g><path d="M199.6,0H56.4C44.5,0,34.9,9.7,34.9,21.6v212.9c0,11.9,9.7,21.6,21.6,21.6h143.1c11.9,0,21.6-9.7,21.6-21.6V21.6 C221.1,9.7,211.5,0,199.6,0z M203.1,234.4c0,2-1.6,3.6-3.6,3.6H56.4c-2,0-3.6-1.6-3.6-3.6V21.6c0-2,1.6-3.6,3.6-3.6h143.1 c2,0,3.6,1.6,3.6,3.6V234.4z"/><path d="M180.7,33.7H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,33.7,180.7,33.7z"/><path d="M180.7,62.1H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,62.1,180.7,62.1z"/><path d="M180.7,119H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,119,180.7,119z"/><path d="M111.7,147.4H75.3c-5,0-9,4-9,9s4,9,9,9h36.3c5,0,9-4,9-9S116.6,147.4,111.7,147.4z"/><path d="M180.7,90.6H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,90.6,180.7,90.6z"/><path d="M173.9,175.2l-28,28.1l-7.4-7.2c-3.6-3.5-9.3-3.4-12.7,0.2c-3.5,3.6-3.4,9.3,0.2,12.7l13.8,13.4c1.7,1.7,4,2.5,6.3,2.5 c2.3,0,4.6-0.9,6.4-2.7l34.3-34.4c3.5-3.5,3.5-9.2,0-12.7C183.1,171.7,177.4,171.7,173.9,175.2z"/></g></g></symbol><symbol id="icon-symbol-trash" viewBox="0 0 256 256"><path d="M103.62 0h48.76c10.097 0 18.716 3.57 25.858 10.714 7.143 7.143 10.714 15.762 10.714 25.857v12.19h48.762c3.365 0 6.238 1.19 8.62 3.573 2.38 2.38 3.57 5.254 3.57 8.62 0 3.364-1.19 6.237-3.57 8.618s-5.255 3.573-8.62 3.573h-12.19V219.43c0 10.094-3.57 18.713-10.714 25.856C207.667 252.43 199.048 256 188.952 256H67.048c-10.096 0-18.714-3.57-25.857-10.714-7.142-7.144-10.713-15.763-10.713-25.857V73.142h-12.19c-3.365 0-6.238-1.19-8.62-3.572s-3.57-5.253-3.57-8.618 1.19-6.238 3.57-8.62c2.382-2.38 5.255-3.57 8.62-3.57H67.05V36.57c0-10.096 3.57-18.715 10.713-25.858C84.905 3.57 93.523 0 103.62 0zm97.523 219.43V73.142H54.857V219.43c0 3.364 1.19 6.237 3.57 8.618s5.255 3.57 8.62 3.57H188.95c3.366 0 6.24-1.19 8.62-3.57s3.573-5.254 3.573-8.62zM152.38 24.38h-48.76c-3.366 0-6.24 1.19-8.62 3.572-2.38 2.38-3.57 5.254-3.57 8.62v12.19h73.142V36.57c0-3.366-1.19-6.24-3.57-8.62-2.383-2.38-5.256-3.57-8.62-3.57z"/></symbol><symbol id="icon-symbol-undo" viewBox="0 0 256 256"><path d="M128 76.944V36c0-4.096-1.568-8.192-4.688-11.328C120.192 21.552 116.096 20 112 20s-8.192 1.552-11.312 4.672L0 124l100.688 99.313c3.12 3.12 7.216 4.688 11.312 4.688s8.192-1.567 11.312-4.687C126.432 220.19 128 216.08 128 212v-39.824c44 1.088 92.08 9.057 128 63.824v-16c0-74.128-56-135.088-128-143.056z"/></symbol><symbol id="icon-symbol-uppercase" viewBox="0 0 256 256"><g><path fill="none" d="M32.049,117.333h36.589c5.123,0,9.275,4.152,9.275,9.275v109.449h100.173V126.609 c0-5.123,4.152-9.275,9.275-9.275h36.588L128,23.632L32.049,117.333z"/><path d="M253.204,119.973L134.48,4.031c-3.603-3.519-9.356-3.52-12.961,0L2.795,119.973c-2.698,2.635-3.532,6.642-2.11,10.134 c1.423,3.493,4.818,5.776,8.59,5.776h50.087v109.449c0,5.122,4.152,9.275,9.275,9.275h118.724c5.122,0,9.275-4.153,9.275-9.275 V135.884h50.087c3.771,0,7.167-2.283,8.59-5.776C256.736,126.615,255.902,122.608,253.204,119.973z M187.362,117.333 c-5.123,0-9.275,4.152-9.275,9.275v109.449H77.914V126.609c0-5.123-4.153-9.275-9.275-9.275H32.049L128,23.632l95.95,93.702 H187.362z"/></g></symbol><symbol id="icon-symbol-user" viewBox="0 0 256 256"><path d="M248.873 226.688c-1.607-1.063-30.784-20.2-74.184-29.592 15.92-20.168 26.143-47.296 30.487-65.352 6.03-25.024 3.688-73.984-20.345-104.496C170.785 9.416 151.13 0 127.994 0c-23.136 0-42.792 9.424-56.832 27.248-24.032 30.504-26.368 79.464-20.344 104.488 4.344 18.056 14.56 45.184 30.488 65.352-43.4 9.392-72.576 28.528-74.176 29.592-5.864 3.904-8.488 11.2-6.44 17.937C2.722 251.377 8.954 256 15.994 256h224c7.048 0 13.265-4.624 15.313-11.376 2.054-6.736-.57-14.032-6.434-17.936zm-86.744-39.504l-2.608 3.313c-19.08 21.92-43.96 21.92-63.032 0l-2.616-3.313c-22.28-28.23-33.336-65.576-28.576-101.2C69.658 51.752 89.274 16 127.994 16s58.343 35.76 62.704 69.992c4.743 35.64-6.273 72.944-28.57 101.192zM15.993 240c1.104-.736 28.208-18.512 68.688-27.264l19.872-4.297c7.096 4.655 14.88 7.56 23.44 7.56 8.568 0 16.343-2.904 23.44-7.56l19.872 4.296c40.16 8.688 67.168 26.264 68.687 27.264h-224z"/></symbol><symbol id="icon-symbol-x" viewBox="0 0 256 256"><path d="M235.056 205.613l-67.896-77.598 67.896-77.597c11.546-11.546 11.546-30.256 0-41.777s-30.256-11.52-41.776 0l-65.288 74.62L62.728 8.665C51.182-2.88 32.472-2.88 20.95 8.666c-11.52 11.546-11.52 30.256 0 41.777l67.873 77.573-67.897 77.598c-11.52 11.546-11.52 30.206 0 41.728 11.546 11.546 30.256 11.546 41.777 0l65.288-74.57 65.264 74.57c11.546 11.546 30.256 11.546 41.777 0s11.547-30.183.026-41.73z"/></symbol><symbol id="icon-symbor-camera" viewBox="0 0 256 256"><path d="M85.333 21.333h85.333l21.333 32h32c8.832 0 16.374 3.18 22.624 9.542S256 76.833 256 85.665v117.168c0 8.834-3.125 16.348-9.375 22.542s-13.792 9.292-22.625 9.292H32c-8.833 0-16.375-3.125-22.625-9.375S0 211.5 0 202.667V85.5c0-8.834 3.125-16.403 9.375-22.71 6.25-6.304 13.792-9.457 22.625-9.457h32l21.333-32zm42.667 64c7.223 0 14.125 1.417 20.708 4.25 6.584 2.833 12.25 6.625 17 11.375s8.542 10.417 11.375 17c2.834 6.583 4.25 13.486 4.25 20.71 0 7.22-1.416 14.124-4.25 20.707-2.833 6.583-6.625 12.25-11.375 17s-10.416 8.542-17 11.375C142.125 190.583 135.223 192 128 192c-7.222 0-14.125-1.417-20.708-4.25-6.583-2.833-12.25-6.625-17-11.375s-8.542-10.417-11.375-17-4.25-13.486-4.25-20.708c0-7.223 1.417-14.126 4.25-20.71 2.833-6.582 6.625-12.25 11.375-17s10.417-8.54 17-11.374c6.583-2.833 13.486-4.25 20.708-4.25zm0 21.333c-8.833 0-16.375 3.125-22.625 9.375S96 129.834 96 138.668c0 8.833 3.125 16.375 9.375 22.625s13.792 9.375 22.625 9.375 16.375-3.125 22.625-9.375S160 147.5 160 138.667c0-8.834-3.125-16.376-9.375-22.626s-13.792-9.374-22.625-9.374zm52.583-32l-20.916-32H96.75l-21.333 32H32c-2.944 0-5.458 1.056-7.542 3.167-2.083 2.11-3.125 4.667-3.125 7.667v117.167c0 2.944 1.042 5.458 3.125 7.54 2.083 2.085 4.597 3.126 7.542 3.126h192c3 0 5.527-1.014 7.583-3.04 2.056-2.03 3.084-4.516 3.084-7.46V85.666c0-3-1.056-5.583-3.167-7.75-2.11-2.166-4.61-3.25-7.5-3.25h-43.417z"/></symbol></svg>';
APP.$store.templates = {"add-users-list":"{{#if this.length > 0}}<ul class=\"list\">{{#each this}}<li class=\"list--item\">{{this.name}} ({{this.email}}) <a style=\"float: right\" data-add-user-to-filter=\"{{this._id}}\" class=\"button button--small\">Add</a></li>{{/each}}</ul>{{#else}}No match. Enter the full name or email address.{{/if}}{{!JSON.stringify(this)}}","basic-calculator":"<div class=\"basic-calculator\">    <div  class=\"basic-calculator__result\" data-basic-calculator-result>404</div>    <div class=\"basic-calculator__rows\">        <div class=\"basic-calculator__row basic-calculator__row--first\">            <button data-basic-calculator-delete class=\"basic-calculator__button basic-calculator__button--del\">C</button>            <button data-basic-calculator-input=\"%\" class=\"basic-calculator__button basic-calculator__button--op\">%</button>            <button data-basic-calculator-input=\"+\" class=\"basic-calculator__button basic-calculator__button--op\">+</button>        </div>        <div class=\"basic-calculator__row\">            <button data-basic-calculator-input=\"7\" class=\"basic-calculator__button\">7</button>            <button data-basic-calculator-input=\"8\" class=\"basic-calculator__button\">8</button>            <button data-basic-calculator-input=\"9\" class=\"basic-calculator__button\">9</button>            <button data-basic-calculator-input=\"-\" class=\"basic-calculator__button basic-calculator__button--op\">-</button>        </div>        <div class=\"basic-calculator__row\">            <button data-basic-calculator-input=\"4\" class=\"basic-calculator__button\">4</button>            <button data-basic-calculator-input=\"5\" class=\"basic-calculator__button\">5</button>            <button data-basic-calculator-input=\"6\" class=\"basic-calculator__button\">6</button>            <button data-basic-calculator-input=\"*\" class=\"basic-calculator__button basic-calculator__button--op\">*</button>        </div>        <div class=\"basic-calculator__row\">            <button data-basic-calculator-input=\"1\" class=\"basic-calculator__button\">1</button>            <button data-basic-calculator-input=\"2\" class=\"basic-calculator__button\">2</button>            <button data-basic-calculator-input=\"3\" class=\"basic-calculator__button\">3</button>            <button data-basic-calculator-input=\"/\" class=\"basic-calculator__button basic-calculator__button--op\">/</button>        </div>        <div class=\"basic-calculator__row\">            <button data-basic-calculator-input=\"0\" class=\"basic-calculator__button basic-calculator__button--zero\">0</button>            <button data-basic-calculator-input=\".\" class=\"basic-calculator__button\">.</button>            <button data-basic-calculator-eq class=\"basic-calculator__button basic-calculator__button--eq\">=</button>        </div>    </div></div>","calculator/abs":"<div data-formula=\"abs\">\t<div class=\"gutter\">\t\t<div data-formula-before><span></span></div>\t\t<div\t\t\t\tdata-fit-box\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div data-formula-after><span></span></div>\t</div></div>","calculator/error":"<h3 data-formula-content>{0}</h3>","calculator/exp":"<div data-formula=\"exp\">\t<div class=\"gutter\">\t\t<div class=\"inline-block\">\t\t\t<div data-formula=\"p\"\t\t\t\t data-formula-ghost-p=\"{ghost-phase}\"\t\t\t\t data-parenthesis\t\t\t\t data-parenthesis-type=\"1\">\t\t\t\t<div class=\"gutter\">\t\t\t\t\t<div data-formula-before><span></span></div>\t\t\t\t\t<div\t\t\t\t\t\t\tdata-fit-box\t\t\t\t\t\t\tdata-argument=\"1\"\t\t\t\t\t\t\tdata-formula-content\t\t\t\t\t\t\tdata-input-placeholder\t\t\t\t\t\t\tdata-formula-level>{0}\t\t\t\t\t</div>\t\t\t\t\t<div data-formula-after><span></span></div>\t\t\t\t</div>\t\t\t</div>\t\t</div>\t\t<div\t\t\t\tclass=\"half-size exp-sup\"\t\t\t\tdata-sup-sub=\"not-set\"\t\t\t\tdata-argument=\"2\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{1}\t\t</div>\t</div></div>","calculator/lit":"lit({0})","calculator/literal":"<span data-formula=\"literal\">{0}</span>","calculator/log":"<div data-formula=\"log\">\t<div class=\"gutter\">\t\t<div class=\"inline-block\" data-formula-part=\"fnsub\">\t\t\t<span data-formula-part=\"fn\" class=\"log\">log</span>\t\t\t<div\t\t\t\tdata-formula-part=\"sub\"\t\t\t\tclass=\"half-size log-sub\"\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t\t</div>\t\t</div>\t\t<div class=\"inline-block log-body\">\t\t\t<div data-formula=\"p\"\t\t\t\t data-formula-ghost-p=\"{ghost-phase}\"\t\t\t\t data-parenthesis\t\t\t\t data-parenthesis-type=\"1\">\t\t\t\t<div class=\"gutter\">\t\t\t\t\t<div data-formula-before><span></span></div>\t\t\t\t\t<div\t\t\t\t\t\tdata-fit-box\t\t\t\t\t\tdata-argument=\"1\"\t\t\t\t\t\tdata-formula-content\t\t\t\t\t\tdata-input-placeholder\t\t\t\t\t\tdata-formula-level>{1}\t\t\t\t\t</div>\t\t\t\t\t<div data-formula-after><span></span></div>\t\t\t\t</div>\t\t\t</div>\t\t</div>\t</div></div>","calculator/mark":"<span data-formula=\"mark\" data-mark=\"{1}\">{0}</span>","calculator/p":"<div data-formula=\"p\" data-parenthesis data-parenthesis-type=\"1\">\t<div class=\"gutter\">\t\t<div data-formula-before><span></span></div>\t\t<div\t\t\t\tdata-fit-box\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div data-formula-after><span></span></div>\t</div></div>","calculator/per":"<div data-formula=\"per\">        <div class=\"gutter\">            <div data-formula-content-top>                <div data-argument=\"1\" data-formula-level data-input-placeholder>{0}</div>            </div>            <div data-fit-box style=\"width:100%;height:1px;top:4px;position:relative;\"></div>            <div data-formula-content-bottom>                <div data-argument=\"2\" data-formula-level data-input-placeholder>{1}</div>            </div>        </div>    </div>","calculator/placeholder":"<div class=\"calculator--placeholder\"></div>","calculator/root":"<div data-formula=\"root\">\t<div\t\t\tclass=\"half-size root-sup\"\t\t\tdata-argument=\"2\"\t\t\tdata-formula-content\t\t\tdata-input-placeholder\t\t\tdata-input-default=\"2\"\t\t\tdata-formula-level>{0}\t</div>\t<div class=\"gutter inline-block\">\t\t<div class=\"root-start\">\t\t</div>\t\t<div class=\"root-body\">\t\t\t<div\t\t\t\t\tdata-fit-box\t\t\t\t\tdata-argument=\"1\"\t\t\t\t\tdata-formula-content\t\t\t\t\tdata-input-placeholder\t\t\t\t\tdata-formula-level>{1}\t\t\t</div>\t\t\t<div class=\"root-end\"></div>\t\t</div>\t</div></div>","calculator/row-arrow-flag":"","calculator/shape":"<div data-formula=\"shape\" class=\"formula--shape-{0}\">\t<i class=\"icon-wrapper\">\t\t<svg viewBox=\"0 0 256 256\">\t\t\t<use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{0}\"></use>\t\t</svg>\t</i></div>","calculator/sub":"<div data-formula=\"sub\">\t<div class=\"gutter\">\t\t<div\t\t\t\tdata-fit-box\t\t\t\tclass=\"inline-block\"\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div\t\t\t\tclass=\"half-size sub-sub\"\t\t\t\tdata-sup-sub=\"not-set\"\t\t\t\tdata-argument=\"2\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{1}\t\t</div>\t</div></div>","calculator/unmark":"<span data-unmark>{0}</span>","calculator/wrapper":"<div\t\tclass=\"calculator--element\"\t\tdata-calculator-element\t\tdata-calculator-element-type=\"{type}\"\t\tdata-calculator-element-id=\"{id}\"><span data-calculator-element-before></span>{content}<span data-calculator-element-after></span></div>","challenge-users-list":"{{#if Object.keys(this).length > 0}}    <div class=\"pro__table__wrapper\">        <table class=\"pro__table\">            <thead>                <tr>                    <td>                        <label>                            <input type=\"checkbox\" checked=\"checked\" data-toggle-list=\"members\">                            <span>All</span>                        </label>                    </td>                    <td>                        Members                    </td>                </tr>            </thead>            <tbody>                {{#each this}}                    {{#each this}}                        {{#if this._id}}                        <tr>                            <td>                                <input data-toggle-item=\"members\" id=\"member_list_{{this._id}}\" type=\"checkbox\" value=\"{{this._id}}\" checked=\"checked\" name=\"challenge-target\" />                            </td>                            <td>                                <label for=\"member_list_{{this._id}}\" style=\"display: block\">{{this.name}}</label>                            </td>                        </tr>                        {{/if}}                    {{/each}}                {{/each}}            </tbody>        </table>    </div>{{/if}}","cookie-notification":"<div class=\"cookie-notification cookie-notification--show\" data-cookie-notification>    <span class=\"cookie-notification__icon\">{{>icon 'symbol-cookie'}}</span>    <div style=\"float: left; max-width: calc(100% - 80px);\">        <span>Akriel uses cookies to provide you the best user experience.</span>        <br><br>        <a class=\"button button--small button--dark\" target=\"_blank\" href=\"/en-US/akriel/privacy\">What’s a cookie?</a>    </div>    <a class=\"cookie-notification__close\">{{>icon 'symbol-x'}}</a></div><div class=\"no-cookie-notification\" data-no-cookie-notification>    <span class=\"no-cookie-notification__icon\">{{>icon 'symbol-cookie'}}</span>    <div style=\"float: left; max-width: calc(100% - 80px);\">        <span>            At the moment, <b style=\"display: inline\">the use of cookies</b> are disabled in your browser. Cookies are essential for Akriel to work properly. Please enable them to get the full customer experience.        </span>    </div>    <a class=\"no-cookie-notification__close\">{{>icon 'symbol-x'}}</a></div>","currents":"<div class=\"list collection__list\">{{#each this.problems}}    <a class=\"list--item collection__list__item\" href=\"/en-US/problem/direct/{{btoa(this.formula)}}/?source=currents\">        <div data-f=\"{{this.formula}}\">            <div data-f-content></div>        </div>    </a>{{/each}}</div>","error-notification":"<div class=\"error-notification\" data-error-notification>    <span class=\"error-notification__icon\">{{>icon 'symbol-lab'}}</span>    <b>We apologize, an error has occurred on the page.</b>    <b>If you experience anything strange, just refresh the page.</b>    <a data-close-error-notification class=\"error-notification__close\">{{>icon 'symbol-x'}}</a>    <p>        We at Akriel are committed to providing the best user experience we can. We investigate every bug report - including this one. We’ll make sure this won’t happen again! Thank you for your understanding.    </p>    <a class=\"button button--small button--red\" onclick=\"document.location.reload()\">Reload page</a>    <!--a class=\"button button--small  button--secondary\">Megjegyzést írok a hibához.</a--></div><div class=\"offline-notification\" data-offline-notification>    <b>No internet</b></div>","exam-live":"<table class=\"learn-period__table\">    {{#each this}}    {{#if this.startTime}}    <tr>        <td class=\"learn-period__table__row-name\" style=\"vertical-align:middle;\">            <a target=\"_blank\" href=\"/en-US/exam/view/{{this.examId}}/{{this.examSecretId}}\" title=\"{{this.name}}\" class=\"learn-period__secondary-title\">{{this.name}}</a>        </td>        <td>            <div class=\"learn-period__chart{{#if this.done}} learn-period__chart--purple{{/if}}\">                {{#if this.percentage > 0}}                <div class=\"learn-period__chart__i2 learn-period__chart__done\"                     style=\"width: {{this.percentage}}%\">                     {{#if this.percentage === 100}}                        {{this.points}}                    {{/if}}                </div>                {{/if}}                {{#if this.percentage < 100}}                <div class=\"learn-period__chart__i3\" style=\"width: {{100 - this.percentage}}%\">                    {{this.points}}                </div>                {{/if}}            </div>        </td>        <td class=\"learn-period__table__row-name\">            {{#if this.done}}            <span class=\"exam__mark grade-mark grade-mark__small\" style=\"position: relative;left: 0;top: 0;margin-left: 15px;\">{{this.percentage}}%</span>            {{/if}}        </td>    </tr>    {{#else}}    <tr class=\"exam--waiting\">    <td class=\"learn-period__table__row-name\" style=\"vertical-align:middle;\">        <span class=\"learn-period__secondary-title\">{{this.name}}</span>    </td>    <td>        <div class=\"learn-period__chart\">            <div class=\"learn-period__chart__i3\" style=\"width: 100%;background-color: #eaeaec;\">                0            </div>        </div>    </td>    <td class=\"learn-period__table__row-name\">        {{#if this.done}}        <span class=\"exam__mark grade-mark\" style=\"position: relative;left: 0;top: 0;margin-left: 15px;\">{{this.percentage}}%</span>        {{/if}}    </td>    </tr>    {{/if}}    {{/each}}</table>","exam-solution":"{{#if this.type === 'comment-text'}}<div data-exam-answer=\"{{this.index}}\">    {{>icon \"symbol-speach-bubble\"}}<p class=\"formula-flack\">{{this.display}}</p><div class=\"formula-actions\"><a data-switch-type=\"comment-text\" data-exam-text-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div></div>{{#elseif this.type === 'comment-formula'}}<div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'>    {{>icon \"symbol-speach-bubble\"}}<div class=\"formula-flack\" data-f=\"{{this.display}}\">    <div data-f-content></div></div><div class=\"formula-actions\"><a data-switch-type=\"comment-formula\" data-exam-answer-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div></div>{{#elseif this.type === 'comment-doodle'}}<div data-exam-answer=\"{{this.index}}\">    {{>icon \"symbol-speach-bubble\"}}<p class=\"formula-flack\">    <img class=\"doodle-image\" data-editable=\"1\"  data-doodle-id=\"{{this.display}}\" src=\"/doodle/{{this.display}}.svg\" /></p><div class=\"formula-actions\" style=\"width: 50px\"><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div></div>{{#elseif this.type === 'cta'}}<div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'>    <div class=\"formula-flack\" data-f=\"{{this.display}}\">        <div data-f-content></div>    </div><div class=\"formula-actions\"><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div></div>{{#else}}<div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'>    <div class=\"formula-flack\" data-f=\"{{this.display}}\">        <div data-f-content></div>    </div><div class=\"formula-actions\"><a data-switch-type=\"solution\" data-exam-answer-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div></div>{{/if}}","formula/abs":"<div data-formula=\"abs\">\t<div class=\"gutter\">\t\t<div data-formula-before>\t\t\t<span></span>\t\t</div>\t\t<div\t\t\t\tdata-fit-box\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div data-formula-after>\t\t\t<span></span>\t\t</div>\t</div></div>","formula/brakets":"<div  data-formula=\"brakets\" class=\"problem--brakets\">    <div class=\"problem--braket-top\"></div>    <div class=\"problem--braket-bottom\"></div>    <div class=\"problem--row problem--group-row\">        <span class=\"problem--prefix\">{2}</span>        <div class=\"problem--prefixed-formula\">{0}</div>    </div>    <div class=\"problem--row problem--group-row\">        <span class=\"problem--prefix\">{3}</span>        <div class=\"problem--prefixed-formula\">{1}</div>    </div></div>","formula/error":"<h3 data-formula-content>{0}</h3>","formula/exp":"<div data-formula=\"exp\">\t<div class=\"gutter\">\t\t<div\t\t\t\tdata-fit-box\t\t\t\tclass=\"inline-block\"\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div\t\t\t\tclass=\"half-size exp-sup\"\t\t\t\tdata-sup-sub=\"not-set\"\t\t\t\tdata-argument=\"2\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{1}\t\t</div>\t</div></div>","formula/lit":"lit({0})","formula/literal":"<span data-formula=\"literal\" data-literal-content=\"{0}\">{1}</span>","formula/log":"<div data-formula=\"log\">\t<div class=\"gutter\">\t\t<div class=\"inline-block\" data-formula-part=\"fnsub\">\t\t\t<span data-formula-part=\"fn\" class=\"log\">log</span>\t\t\t<div\t\t\t\t\tdata-formula-part=\"sub\"\t\t\t\t\tclass=\"half-size log-sub\"\t\t\t\t\tdata-argument=\"1\"\t\t\t\t\tdata-formula-content\t\t\t\t\tdata-input-placeholder\t\t\t\t\tdata-formula-level>{0}\t\t\t</div>\t\t</div>\t\t<div class=\"inline-block log-body\">\t\t\t<div\t\t\t\t\tdata-fit-box\t\t\t\t\tdata-argument=\"2\"\t\t\t\t\tdata-formula-content\t\t\t\t\tdata-input-placeholder\t\t\t\t\tdata-formula-level>{1}\t\t\t</div>\t\t</div>\t</div></div>","formula/mark":"<span data-formula=\"mark\" data-mark=\"{1}\">{0}</span>","formula/p":"<div data-formula=\"p\" data-parenthesis data-parenthesis-type=\"1\" data-parenthesis-force-type=\"{1}\">\t<div class=\"gutter\">\t\t<div data-formula-before>\t\t\t<span></span>\t\t</div>\t\t<div\t\t\t\tdata-fit-box\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div data-formula-after>\t\t\t<span></span>\t\t</div>\t</div></div>","formula/per":"<div data-formula=\"per\">    <div class=\"gutter\">        <div data-formula-content-top>            <div data-argument=\"1\" data-formula-level data-input-placeholder>{0}</div>        </div>        <div data-fit-box style=\"width:100%;height:1px;top:-1px;position:relative;\"></div>        <div data-formula-content-bottom>            <div data-argument=\"2\" data-formula-level data-input-placeholder>{1}</div>        </div>    </div></div>","formula/root":"<div data-formula=\"root\">    <div        class=\"half-size root-sup\"        data-argument=\"2\"        data-formula-content        data-input-placeholder        data-input-default=\"2\"        data-formula-level>        {1}    </div>    <div class=\"gutter inline-block\">        <div class=\"root-start\">        </div>        <div class=\"root-body\">            <div                data-fit-box                data-argument=\"1\"                data-formula-content                data-input-placeholder                data-formula-level>                {0}            </div>            <div class=\"root-end\"></div>        </div>    </div></div>","formula/row-arrow-flag":"","formula/shape":"<div data-formula=\"shape\" class=\"formula--shape-{0}\">\t<i class=\"icon-wrapper\">\t\t<svg viewBox=\"0 0 256 256\">\t\t\t<use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{0}\"></use>\t\t</svg>\t</i></div>","formula/sub":"<div data-formula=\"sub\">\t<div class=\"gutter\">\t\t<div\t\t\t\tdata-fit-box\t\t\t\tclass=\"inline-block\"\t\t\t\tdata-argument=\"1\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{0}\t\t</div>\t\t<div\t\t\t\tclass=\"half-size sub-sub\"\t\t\t\tdata-sup-sub=\"not-set\"\t\t\t\tdata-argument=\"2\"\t\t\t\tdata-formula-content\t\t\t\tdata-input-placeholder\t\t\t\tdata-formula-level>{1}\t\t</div>\t</div></div>","formula/unmark":"<span data-unmark>{0}</span>","formula/wrapper":"<div\t\tclass=\"calculator--element\"\t\tdata-calculator-element\t\tdata-calculator-element-type=\"{type}\"\t\tdata-calculator-element-id=\"{id}\"><span data-calculator-element-before></span>{content}<span data-calculator-element-after></span></div>","formula":"<div class=\"formula-flack\" data-f=\"{{this}}\">    <div data-f-content></div></div>","fromto":"<div class=\"problem--formula problem--formula-wrapper\"{{#if this.vertical}} data-problem-vertical{{/if}}>\t<div class=\"problem--formula-left\" data-formula style=\"{{#if !this.vertical}}padding: 10px 0;{{/if}} padding-right: 20px;\">\t\t<div class=\"formula\" data-formula>\t\t{{#compute this.from /}}\t\t</div>\t\t{{#if this.vertical}}\t\t\t<div class=\"problem--formula-action\" {{#if !this.action}}style=\"visibility:hidden\"{{/if}} data-formula>\t\t\t\t<div class=\"formula\" data-fit-box>\t\t\t\t\t<span data-formula=\"literal\" class=\"problem--formula-action__per\">/</span>\t\t\t\t\t{{#compute this.action /}}\t\t\t\t</div>\t\t\t</div>\t\t{{#else}}\t\t<div class=\"problem--formula-arrow{{#if this.action}} problem--formula-arrow-no-action{{/if}}\" data-formula>\t\t\t{{>icon \"arrow-right\"}}\t\t</div>\t\t{{/if}}\t</div>\t<div class=\"problem--formula-right\" data-formula style=\"{{#if !this.vertical}}padding: 10px 0;{{/if}}}\">\t\t<div class=\"problem--formula-arrow{{#if this.action}} problem--formula-arrow-no-action{{/if}}\" data-formula>\t\t\t{{>icon \"arrow-right\"}}\t\t</div>\t\t<div class=\"formula\" data-formula>{{#compute this.to /}}</div>\t</div></div>","group-unapproveds":"{{#if this.users}}<div class=\"learn-period newsfeed__item\"><span class=\"newsfeed__item__bold\">Join requests</span>{{#each this.users}}<div class=\"user-list__item\" style=\"border-top: 1px solid #fff; border-bottom: 1px solid #d6dbde;\">    <a class=\"user-list__name\" href=\"/en-US/user/{{this._id}}\">{{this.name}}</a>    <div class=\"user-list__actions\" data-group-join-approve-action>        <a class=\"button button--iconed button--small\" data-user-action=\"approve-user:{{this._id}}\">            {{>icon \"symbol-pipe\"}}        </a>        <a class=\"button button--iconed button--small button--gray\" data-user-action=\"un-approve-user:{{this._id}}\">            {{>icon \"symbol-x\"}}        </a>    </div></div>{{/each}}</div>{{/if}}","hcflcm":"{{#if this.cards}}{{#each this.cards}}<div class=\"card\">    {{#each this.parts}}        {{!JSON.stringify(this)}}        {{#if this.message}}            {{#if this.message.link}}            <a class=\"card__message-link\" target=\"_blank\" href=\"{{#getLink this.message.link /}}&source=hcflcm\">{{#compute this.message.text /}}</a>            {{#else}}            <div class=\"card__p\">{{#compute this.message.text /}}</div>            {{/if}}        {{/if}}        {{#if this.formula}}            {{#each this.formula}}                {{!JSON.stringify(this)}}                {{#if this.link}}                <div class=\"academy-item card__formula{{#if this.highlighted}} card__formula--highlighted{{/if}}\">                    <a class=\"card__formula__link\" target=\"_blank\" href=\"/en-US/problem/direct/{{#base64 this.from/}}/?cmd={{this.link.cmd.replace(/#/g, '')}}&source=hcflcm\">                        {{#if this.to}}                        <div data-fromto                             data-from=\"{{this.from}}\"                             data-to=\"{{this.to}}\"                             data-vertical=\"false\"></div>                        {{#else}}                        <div data-f=\"{{this.from}}\"><div data-f-content></div></div>                        {{/if}}                    </a>                </div>                {{#else}}                <div style=\"display: block; max-width: 100%;text-align: left\" class=\"academy-item card__formula{{#if this.highlighted}} card__formula--highlighted{{/if}}\">                    {{#if this.to}}                    <div data-fromto                         style=\"display: block; margin:0\"                         data-from=\"{{this.from}}\"                         data-to=\"{{this.to}}\"                         data-vertical=\"false\"></div>                    {{#else}}                    <div data-f=\"{{this.from}}\"><div data-f-content></div></div>                    {{/if}}                </div>                {{/if}}            {{/each}}        {{/if}}    {{/each}}</div>{{/each}}{{/if}}{{#if this.final_message}}<div class=\"card\">    <strong>{{#compute this.final_message /}}</strong></div>{{/if}}","icon":"<i class=\"icon-wrapper\">    <svg viewBox=\"0 0 256 256\">        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-{{this}}\"></use>    </svg></i>","keyboard/5th-device":"<div class=\"pillar-box\" data-keyboard-var=\"5th\">\t<div class=\"keyboard--section keyboard--section-characters\" style=\"width:50% !important;\">\t\t<div class=\"keyboard--section-row\" style=\"padding-right:0;\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel - Gyorsbillentyű:&nbsp;&nbsp;(\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"per:inverse\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\" title=\"Visszatörlés - Gyorsbillentyű: Backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '01234'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '56789'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\" style=\"width:50% !important;\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/5th":"<div class=\"pillar-box\" data-keyboard-var=\"5th\">\t<div class=\"keyboard--section keyboard--section-characters\">\t\t<div class=\"keyboard--section-row\" style=\"font-size: 24px;padding-right:0;\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel - Gyorsbillentyű:&nbsp;&nbsp;(\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\" data-keyboard-action=\"per:inverse\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\" title=\"Visszatörlés - Gyorsbillentyű: Backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '0123456789'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\" style=\"width:25%\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/desktop":"<div class=\"pillar-box\" data-keyboard-var=\"default\">\t<div class=\"keyboard--section keyboard--section-characters\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel - Gyorsbillentyű:&nbsp;&nbsp;(\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\" data-keyboard-action=\"per:inverse\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\" title=\"Hatvány bevitel - Gyorsbillentyű: Alt Gr\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"\t\t\t\t\ttitle=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-action=\"root:inverse\">\t\t\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-1\"}}</span>\t\t\t\t\t</span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-action=\"root\">\t\t\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t\t\t</span>\t\t\t\t</span>\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"\t\t\t\t\ttitle=\"Logaritmus bevitel - Gyorsbillentyű: Ctrl+Space\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\" data-keyboard-action=\"log:inverse\" data-ga-event=\"keyboard-soon:log-inverse\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<!--\t\t\t<button class=\"keyboard--button\" data-keyboard-action-soon=\"abs\" data-ga-event=\"keyboard-soon:abs\" data-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-abs\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-abs-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-open-all=\"action\">\t\t\t\t<span>{{>icon \"symbol-more\"}}</span>\t\t\t</button>\t\t\t-->\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\" title=\"Visszatörlés - Gyorsbillentyű: Backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '1234567890'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button\" data-keyboard-qwerty title=\"Qwerty billentyűzet megjelenítése\">\t\t\t\t<span>a-z</span>\t\t\t</button>\t\t\t{{#each 'xyabcdef'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-start\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-green\" data-keyboard-calculate>\t\t\t\t<span class=\"text\">start</span>\t\t\t\t<span class=\"icon\">{{>icon \"akriel-symbol\"}}</span>\t\t\t</button>\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/device":"<div class=\"pillar-box\" data-keyboard-var=\"default\">\t<div class=\"keyboard--section\">\t\t<div class=\"keyboard--section-row\" style=\"padding-right:20px;\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"per:inverse\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"exp:inverse\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"\t\t\t\ttitle=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"root:inverse\" title=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"\t\t\t\tdata-ga-event=\"keyboard-soon:log\" data-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"log:inverse\" data-ga-event=\"keyboard-soon:log-inverse\"\t\t\t\tdata-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\">\t\t\t\t<span>{{>icon \"symbol-backspace\"}}</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '1234567890'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button\" data-keyboard-qwerty>\t\t\t\t<span>a-z</span>\t\t\t</button>\t\t\t{{#each 'xyabcd'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--show-on-question\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\"\t\t\t\t\tdata-keyboard-alert=\"Available soon.\"\t\t\t\t\ttitle=\"Available soon.\"><span>,</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\" style=\"margin-right:-10vw;\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"=\"><span>=</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--hide-on-question\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\"\t\t\t\t\tdata-keyboard-alert=\"Available soon.\"\t\t\t\t\ttitle=\"Available soon.\"><span>,</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-start\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-green\" data-keyboard-calculate>\t\t\t\t<span class=\"text\">start</span>\t\t\t\t<span class=\"icon\">{{>icon \"akriel-symbol\"}}</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/extra-buttons":"{{#each this}}<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>{{/each}}","keyboard/original_desktop":"<div class=\"pillar-box\">\t<div class=\"keyboard--section keyboard--section-characters\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel - Gyorsbillentyű:&nbsp;&nbsp;(\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\" data-keyboard-action=\"per:inverse\"  title=\"Tört bevitel - Gyorsbillentyű:&nbsp;&nbsp;/\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\" title=\"Hatvány bevitel - Gyorsbillentyű: Alt Gr\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"\t\t\t\t\ttitle=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-action=\"root:inverse\">\t\t\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-1\"}}</span>\t\t\t\t\t</span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-action=\"root\">\t\t\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t\t\t</span>\t\t\t\t</span>\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"\t\t\t\t\ttitle=\"Logaritmus bevitel - Gyorsbillentyű: Ctrl+Space\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\" data-keyboard-action=\"log:inverse\" data-ga-event=\"keyboard-soon:log-inverse\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<!--\t\t\t<button class=\"keyboard--button\" data-keyboard-action-soon=\"abs\" data-ga-event=\"keyboard-soon:abs\" data-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-abs\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-abs-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-open-all=\"action\">\t\t\t\t<span>{{>icon \"symbol-more\"}}</span>\t\t\t</button>\t\t\t-->\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\" title=\"Visszatörlés - Gyorsbillentyű: Backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '1234567890'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button\" data-keyboard-qwerty title=\"Qwerty billentyűzet megjelenítése\">\t\t\t\t<span>a-z</span>\t\t\t</button>\t\t\t{{#each 'xyabcdef'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-start\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-green\" data-keyboard-calculate>\t\t\t\t<span class=\"text\">start</span>\t\t\t\t<span class=\"icon\">{{>icon \"akriel-symbol\"}}</span>\t\t\t</button>\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/qwerty-uppercase":"<div class=\"pillar-box\">\t<div class=\"keyboard--section keyboard--section-allcharacters\">\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each 'QWERTYUIOP'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each 'ASDFGHJKL'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-normal>\t\t\t\t<span>{{>icon \"symbol-more\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-qwerty>\t\t\t\t<span>{{>icon \"symbol-lowercase\"}}</span>\t\t\t</button>\t\t\t{{#each 'ZXCVBNM'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/qwerty":"<div class=\"pillar-box\">\t<div class=\"keyboard--section keyboard--section-allcharacters\">\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each 'qwertyuiop'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each 'asdfghjkl'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-normal>\t\t\t\t<span>{{>icon \"symbol-more\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-qwerty-uppercase>\t\t\t\t<span>{{>icon \"symbol-uppercase\"}}</span>\t\t\t</button>\t\t\t{{#each 'zxcvbnm'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"symbol-backspace\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/symbol-device":"<div class=\"pillar-box\" data-keyboard-var=\"symbol\">\t<div class=\"keyboard--section keyboard--section-characters\" style=\"width:50% !important;\">\t\t<div class=\"keyboard--section-row\" style=\"padding-right:0;\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"per:inverse\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"exp:inverse\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"\t\t\t\ttitle=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"root:inverse\" title=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"\t\t\t\tdata-ga-event=\"keyboard-soon:log\" data-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"log:inverse\" data-ga-event=\"keyboard-soon:log-inverse\"\t\t\t\tdata-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\">\t\t\t\t<span>{{>icon \"symbol-backspace\"}}</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '012xy'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each 'ABCDEF'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\">                    <span data-formula=\"shape\" class=\"formula--shape-{{#lowercase this /}}\" style=\"display:inline\">                      <i class=\"icon-wrapper\"><svg viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{{#lowercase this /}}\"></use></svg></i>                    </span>                </button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\" style=\"width:50% !important;\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","keyboard/symbol":"<div class=\"pillar-box\" data-keyboard-var=\"symbol\">\t<div class=\"keyboard--section keyboard--section-characters\">\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\">\t\t\t\t<span>{{>icon \"formula-p\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"per:inverse\">\t\t\t\t<span>{{>icon \"formula-per\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"exp:inverse\">\t\t\t\t<span>{{>icon \"formula-exp\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"\t\t\t\ttitle=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"root:inverse\" title=\"Gyök bevitel - Gyorsbillentyű: Space\">\t\t\t\t<span>{{>icon \"formula-root\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-root-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"\t\t\t\tdata-ga-event=\"keyboard-soon:log\" data-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--large keyboard--visible-on-selection-phase\"\t\t\t\tdata-keyboard-action=\"log:inverse\" data-ga-event=\"keyboard-soon:log-inverse\"\t\t\t\tdata-keyboard-alert=\"Hamarosan használható lesz.\">\t\t\t\t<span>{{>icon \"formula-log\"}}</span>\t\t\t\t<span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-1\"}}</span>\t\t\t\t<span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-2\"}}</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\">\t\t\t\t<span>{{>icon \"symbol-backspace\"}}</span>\t\t\t</button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t{{#each '012xy'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t\t{{#each 'ABCDEF'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\">                    <span data-formula=\"shape\" class=\"formula--shape-{{#lowercase this /}}\" style=\"display:inline\">                      <i class=\"icon-wrapper\"><svg viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{{#lowercase this /}}\"></use></svg></i>                    </span>                </button>\t\t\t{{/each}}\t\t</div>\t</div>\t<div class=\"keyboard--section keyboard--section-actions\" style=\"width:25%\">\t\t<div class=\"keyboard--section-row\">\t\t\t<div data-keyboard=\"extra-buttons\"></div>\t\t\t{{#each '+-*:'.split('')}}\t\t\t\t<button class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>\t\t\t{{/each}}\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button--default\" data-keyboard-character=\"=\">\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button--extended\" data-keyboard-character=\"=\">\t\t\t\t<span class=\"keyboard--button--hover\">\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ne;\"><span>&ne;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\">\"><span>&gt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"<\"><span>&lt;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&ge;\"><span>&ge;</span></span>\t\t\t\t\t<span class=\"keyboard--button\" data-keyboard-character=\"&le;\"><span>&le;</span></span>\t\t\t\t</span>\t\t\t\t<span>=</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"up\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-up\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-ga-event=\"keyboard-soon:,\" data-keyboard-alert=\"Available soon.\" title=\"Available soon.\"><span>,</span></button>\t\t</div>\t\t<div class=\"keyboard--section-row\">\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"left\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-left\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"down\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-down\"}}\t\t\t\t</span>\t\t\t</button>\t\t\t<button class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"right\">\t\t\t\t<span>\t\t\t\t\t{{>icon \"arrow-key-right\"}}\t\t\t\t</span>\t\t\t</button>\t\t</div>\t</div></div>","learn/emocard":"<div class=\"emocard emocard--{{this.type}}\">\t{{#if this.type === 'show-star'}}\t\t<div class=\"emocard__layer emocard__shine emocard__shine--white\">\t\t\t<svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t\t<svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t</div>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star\"></use></svg>\t{{#elseif this.type === 'show-medal'}}\t\t<div class=\"emocard__layer emocard__shine emocard__shine--white\">\t\t\t<svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t\t<svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t</div>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-medal\"></use></svg>\t{{#elseif this.type === 'show-cup'}}\t\t<div class=\"emocard__layer emocard__shine emocard__shine--white\">\t\t\t<svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t\t<svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t</div>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup\"></use></svg>\t{{#elseif this.type === 'show-cup-default'}}\t\t<div class=\"emocard__layer emocard__shine emocard__shine--white\">\t\t\t<svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t\t<svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg>\t\t</div>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup-default\"></use></svg>\t{{#elseif this.type === 'hide-star'}}\t\t<svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star-shadow\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t{{#elseif this.type === 'hide-medal'}}\t\t<svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-medal-shadow\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t{{#elseif this.type === 'hide-cup'}}\t\t<svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup-shadow\"></use></svg>\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t{{#elseif this.type === 'okay'}}\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t<svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-arrow\"></use></svg>\t{{#elseif this.type === 'okay-gold'}}\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t<svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-checkmark-gold\"></use></svg>\t{{#elseif this.type === 'fail'}}\t\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg>\t\t<svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-x\"></use></svg>\t{{#elseif this.type === 'half-star'}}\t<svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star-shadow\"></use></svg>\t<svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg-gold\"></use></svg>\t{{/if}}</div>","learn-competition":"<table class=\"learn-period__table\" style=\"margin-bottom: .6em;\">    <tr>        <td colspan=\"2\">            <span style=\"display:block;margin:0 0 .6em 0;font-weight:bold;font-size:1.2em;\">{{this.title}}</span>        </td>    </tr>    {{#each this.competition.data}}    <tr>        <td class=\"learn-period__table__row-name\" style=\"vertical-align: middle\">            <span class=\"{{#if this.isMe}}learn-period__table__row-name--me{{/if}}\">{{this.name}}</span>        </td>        <td style=\"width: 100%\">            {{!JSON.stringify(this)}}            {{!((this.before || 0) + this.actual + this.counting)}}            <div class=\"learn-period__chart\">                {{#if this.actual}}                <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.actual)}}%\">                    {{#if this.actual > 0 && !(this.counting && this.counting > 0)}}                    {{this.actual}}                    {{/if}}                </div>                {{/if}}                {{#if this.counting && this.counting > 0}}                    <div class=\"learn-period__chart__i3\" style=\"width: {{100 / ((this.actual + this.counting) / this.counting)}}%\">{{this.actual}}</div>                {{/if}}            </div>        </td>    </tr>    {{/each}}</table>","learn-error":"{{!JSON.stringify(this)}}{{#if this.error && this.error.message}}{{#compute this.error.message /}}{{#else}}An error has occurred.{{/if}}","learn-period":"{{#if this.allStars && this.allStars.sortedStars.length > 0}}<table class=\"learn-period__table\">{{!JSON.stringify(this.allStars)}}    <tr>        <td colspan=\"3\">            <span style=\"margin: 30px 0 15px 0\" class=\"learn-period__primary-title newsfeed__item__bold\">                <span style=\"color: #FFD700\">{{>icon \"star\"}}</span>                Stars            </span>        </td>    </tr>    {{#each this.allStars.sortedStars}}    <tr>        <td class=\"learn-period__table__row-name\">            <a href=\"?filterUser={{this.user.id}}&fromView=cup\" title=\"{{this.user.name}}\" class=\"learn-period__secondary-title\">{{this.user.name}}</a>        </td>        <td>            <div class=\"learn-period__chart\">                {{#if this.preCount}}                <div class=\"learn-period__chart__i1\"                     style=\"width: {{100 / (((this.preCount || 0) + this.postCount + (meta.parent.context.allStars.max - this.count)) / this.preCount)}}%\">{{this.preCount}}</div>                {{/if}}                {{#if this.postCount}}                <div class=\"learn-period__chart__i2{{#if this.count === 0}} learn-period__chart__done{{/if}}\"                     style=\"width: {{100 / (((this.preCount || 0) + this.postCount + (meta.parent.context.allStars.max - this.count)) / this.postCount)}}%\">                    {{#if this.postCount > 0}}                    {{this.postCount}}                    {{/if}}                </div>                {{/if}}                <div class=\"learn-period__chart__i3\" style=\"width: {{100 - (this.count / meta.parent.context.allStars.max  * 100)}}%\"></div>            </div>        </td>    </tr>    {{/each}}    <tr>        <td colspan=\"3\">            <div style=\"display: flex; text-align: center;border-top: 3px solid rgba(49,55,68,0.23); margin-top: 15px\">                <div style=\"width:100%\">                    <span style=\"margin: 15px 0;\" class=\"learn-period__primary-title newsfeed__item__bold\">                        {{this.allStars.allStars}}                    </span>                    Number of all stars                </div>                <div style=\"width:100%\">                    <span style=\"margin: 15px 0;\" class=\"learn-period__primary-title newsfeed__item__bold\">                        {{this.allStars.averageStars}}                    </span>                    Number of average stars                </div>            </div>        </td>    </tr></table>{{/if}}<table class=\"learn-period__table{{#if this.sortedCups}} learn-period__table--gold{{/if}}\">    {{#each this.sortedUsers}}    <tr>        <td colspan=\"3\">            <a href=\"?filterUser={{this.id}}&fromView=user\" class=\"learn-period__primary-title newsfeed__item__bold\">                {{>icon \"symbol-user\"}}                {{this.name}}                {{#if this.lasActivity}}                <span style=\"opacity: .5; font-size: 13px\">                    - (<span style=\"text-transform: lowercase\">                        Last activity <span data-ago-moment=\"{{this.lastActivity}}\"></span>.</span>)                </span>                {{/if}}            </a>        </td>    </tr>    {{#each this.sortedTopics}}    {{#if this.department}}        <tr>            <td colspan=\"3\">                <span class=\"learn-period__subtitle\">                {{#compute this.department /}}                </span>            </td>        </tr>    {{/if}}    <tr>        <td class=\"learn-period__table__row-name\" style=\"vertical-align: middle\">            {{#if this.cup}}            <a href=\"?view=cup\" class=\"learn-period__cup\">                {{>icon \"learn-cup\"}}            </a>            {{#elseif this.defaultCup}}            <a href=\"?view=cup\" class=\"learn-period__cup\">                {{>icon \"learn-cup-basic\"}}            </a>            {{/if}}            <a href=\"?filterTopic={{this.id}}\" title='{{#computeSilence this.title /}}' class=\"learn-period__secondary-title\">{{#compute this.title /}}</a>        </td>        <td style=\"width: 100%\">            {{!JSON.stringify(this)}}            {{!this.before + this.actual + this.counting}}            <div class=\"learn-period__chart\">                {{#if this.before}}                <div class=\"learn-period__chart__i1\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.before)}}%\">{{this.before}}</div>                {{/if}}                {{#if this.actual}}                <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.actual)}}%\">                    {{#if this.actual > 0 && !(this.counting && this.counting > 0)}}                    {{this.actual}}                    {{/if}}                </div>                {{/if}}                {{#if this.counting && this.counting > 0}}                <div class=\"learn-period__chart__i3\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.counting)}}%\">{{this.actual}}</div>                {{/if}}            </div>        </td>        <td style=\"width: 0\">            {{#if this.bestExam}}<a class=\"grade-mark\" href=\"/en-US/exam/{{this.bestExam.examId}}\" target=\"_blank\"><span title=\"Test\" style=\"{{#if this.bestExam.grade === 100}}font-weight:bold;color:#e06476{{#else}}color:#5e626a{{/if}}\">{{this.bestExam.grade}}%</span></a>{{/if}}        </td>    </tr>    {{/each}}    {{/each}}    {{#each this.sortedTopics}}    {{#if this.department}}        <tr>            <td colspan=\"3\">                <span class=\"learn-period__primary-title newsfeed__item__bold\" style=\"font-size: 28px; margin-top: 45px; text-align: center;\">                {{#compute this.department /}}                                </span>            </td>        </tr>    {{/if}}    <tr>        <td colspan=\"2\">            <table width=\"100%\">            <tr>                <td width=\"100%\">                    <a href=\"?filterTopic={{this.id}}\" class=\"learn-period__primary-title newsfeed__item__bold\">                        {{>icon \"menu-academy\"}}                        {{#compute this.title /}}                    </a>                </td>                <td style=\"text-align:right; white-space:nowrap\">                    {{#if this.summary}}                        <div class=\"newsfeed__item__bold\" style=\"margin-top: 30px; margin-bottom: 5px;\">                            {{#if this.summary.stars}}                                {{this.summary.stars}}                                <span style=\"color:#ff9f28; top: -2px; position: relative;\">{{>icon 'star'}}</span>                            {{/if}}                            {{#if this.summary.cups}}                                {{this.summary.cups}}                                <span class=\"learn-period__cup\" style=\"float:none; display:inline-block\">                                    {{>icon \"learn-cup\"}}                                </span>                            {{/if}}                        </div>                    {{/if}}                </td>            </tr>            </table>        </td>        <td></td>    </tr>    {{#each this.sortedUsers}}    <tr>        <td class=\"learn-period__table__row-name\" style=\"vertical-align: middle\">            {{#if this.cup}}            <a href=\"?view=cup\" class=\"learn-period__cup\">                {{>icon \"learn-cup\"}}            </a>            {{#elseif this.defaultCup}}            <a href=\"?view=cup\" class=\"learn-period__cup\">                {{>icon \"learn-cup-basic\"}}            </a>            {{/if}}            <a href=\"?filterUser={{this.id}}&fromView=topic\" title=\"{{this.name}}\" class=\"learn-period__secondary-title\">{{this.name}}</a>        </td>        <td style=\"width: 100%\">            {{!JSON.stringify(this)}}            {{!((this.before || 0) + this.actual + this.counting)}}            <div class=\"learn-period__chart\">                {{#if this.before}}                <div class=\"learn-period__chart__i1\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.before)}}%\">{{this.before}}</div>                {{/if}}                {{#if this.actual}}                <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.actual)}}%\">                    {{#if this.actual > 0 && !(this.counting && this.counting > 0)}}                    {{this.actual}}                    {{/if}}                </div>                {{/if}}                {{#if this.counting && this.counting > 0}}                <div class=\"learn-period__chart__i3\"                     style=\"width: {{100 / (((this.before || 0) + this.actual + this.counting) / this.counting)}}%\">{{this.actual}}</div>                {{/if}}            </div>        </td>        <td style=\"width: 0\">            {{#if this.bestExam}}<a class=\"grade-mark\" href=\"/en-US/exam/{{this.bestExam.examId}}\" target=\"_blank\"><span title=\"Test\" style=\"{{#if this.bestExam.grade === 100}}font-weight:bold;color:#e06476{{#else}}color:#5e626a{{/if}}\">{{this.bestExam.grade}}%</span></a>{{/if}}        </td>    </tr>    {{/each}}    {{/each}}    {{#if this.sortedCups && this.sortedCups.length > 0}}    <tr>        <td colspan=\"3\">            <span style=\"margin: 15px 0; color: #fff\" class=\"learn-period__primary-title newsfeed__item__bold\">                <span style=\"color: #FFD700\">{{>icon \"learn-cup\"}}</span>                Cups            </span>        </td>    </tr>    {{#each this.sortedCups}}    <tr>        <td class=\"learn-period__table__row-name\">            <a href=\"?filterUser={{this.user.id}}&fromView=cup\" title=\"{{this.user.name}}\" class=\"learn-period__secondary-title\">{{this.user.name}}</a>        </td>        <td>            <div class=\"learn-period__chart\">                {{#if this.count}}                    <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\"                         style=\"width: {{this.count / meta.parent.context.max  * 100}}%;\">                        {{#if this.count > 0}}                        {{this.count}}                        {{/if}}                    </div>                    <div class=\"learn-period__chart__i3\"                         style=\"width: {{100 - (this.count / meta.parent.context.max  * 100)}}%\"></div>                {{#else}}                    <div class=\"learn-period__chart__i3\" style=\"width:100%\"></div>                {{/if}}            </div>        </td>    </tr>    {{/each}}    <tr>        <td colspan=\"3\">            <div style=\"display: flex; color: #fff; text-align: center;border-top: 3px solid rgba(49,55,68,0.23); margin-top: 15px\">                <div style=\"width:100%\">                    <span style=\"margin: 15px 0; color: #ffd700\" class=\"learn-period__primary-title newsfeed__item__bold\">                        {{this.allCups}}                    </span>                    Number of all cups                </div>                <div style=\"width:100%\">                    <span style=\"margin: 15px 0; color: #ffd700\" class=\"learn-period__primary-title newsfeed__item__bold\">                        {{this.averageCups}}                    </span>                    Number of average cups                </div>            </div>        </td>    </tr>    {{/if}}    {{#if Object.keys(this.topics || {}).length + Object.keys(this.users || {}).length === 0 && (this.sortedCups || {}).length === 0}}    <tr>        <td colspan=\"3\">            {{#if this.sortedCups}}            <span class=\"learn-period__primary-title newsfeed__item__bold\" style=\"color: #FFFFFF; margin: 0\">                Nobody has earned a cup in this study group.            </span>            {{#else}}            <span class=\"learn-period__primary-title newsfeed__item__bold\">            No activity in this study cycle yet.            </span>            {{/if}}        </td>    </tr>    {{/if}}</table>","learn-solutions":"{{#each this.items}}<div class=\"newsfeed__item\" data-newsfeed-story=\"{{this._id}}\">    <div class=\"newsfeed__item__details\">        <div style=\"font-size: 23px\" data-f=\"{{this.data.details.problem.clone}}\"><div data-f-content></div></div>        <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap; float: right; padding: 10px 0\"></a>        <div data-nf-input-details></div>    </div>    <div data-nf-card-actions>        <div class=\"newsfeed__item__actions\">        {{#if this.data.details && this.data.details.events}}        <a class=\"button button--small\" data-group-show-details='{{#base64 JSON.stringify(this.data) /}}'>            Your own solution ({{this.data.details.events.length}})        </a>        <a class=\"button button--small button--purple\" target=\"_blank\" href=\"{{this.data.details.problem.solutionLink}}\">            Akriel’s solution        </a>        {{/if}}        </div>    </div></div>{{/each}}","live-client":"<div class=\"newsfeed__item newsfeed__item--lecture-history\">    <div class=\"newsfeed__item__details\">        <p class=\"newsfeed__item__text--global\">            <div data-live-client-block=\"0\" data-live-client-stamp=\"{{this.closed}}@{{this.userId}}@{{this.url}}\">                <div class=\"newsfeed__item__bold\" style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100%\">                    <a href=\"/hu-HU/user/{{this.userId}}\" style=\"font-weight:normal;\">{{this.userName}}</a>                </div>                {{#if !this.closed && this.url}}                    <div class=\"newsfeed__item__bold\" style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100%\">                        <a target=\"_blank\" href=\"{{this.url}}\">{{this.title}} <span style=\"font-size:.66em\" title=\"{{this.url}}\">[<span style=\"opacity:.5;\">{{this.url}}</span>]</span></a>                    </div>                    <a href=\"/hu-HU/user/{{this.userId}}\">{{this.userName}}</a> has been on the <a href=\"{{this.url}}\" title=\"{{this.url}}\">{{this.title}}</a> page <span data-ago-moment=\"{{this.timeStamp}}\"></span>.                {{#else}}                    <a href=\"/hu-HU/user/{{this.userId}}\">{{this.userName}}</a> is inactive.                {{/if}}            </div>            <div data-live-client-block=\"1\" data-live-client-stamp=\"{{this.focus}}@{{this.url}}\">                {{#if this.url && !this.closed  && !this.focus}}                    Currently inactive.                {{/if}}            </div>            <div data-live-client-block=\"2\" data-live-client-stamp=\"{{this.problemInstruction}}@{{this.problemClone}}\">                {{#if !this.closed && this.problemClone}}                {{#if this.problemSolutionLink}}                    Currently working on the following exercise:                {{/if}}                <div style=\"display:block;\" data-f=\"{{this.problemInstruction}}\">                    <div data-f-content style=\"white-space: normal\"></div>                </div>                <div class=\"formula-flack\" data-f=\"{{this.problemClone}}\">                    <div data-f-content></div>                </div>                {{/if}}            </div>            <div data-live-client-block=\"3\" data-live-client-block-type=\"single\" data-live-client-stamp=\"{{btoa(JSON.stringify(this.history || {}))}}\">                {{#if this.history && this.history.data && this.history.data.details && this.history.data.details.events  && this.history.data.details.events.length}}                    {{!JSON.stringify(this.history.data.details.events)}}                    <p>Activity so far:</p>                    {{#each this.history.data.details.events}}                    <div style=\"padding: 15px;\">                        <div style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\" data-f=\"{{this.formula}}\"><div data-f-content></div></div>                        {{#if this.type === 'fail'}}                        <span style=\"float: right; color: #e06476\" title='The value is incorrect'>{{>icon 'symbol-x'}}</span>                        {{#elseif this.type === 'ok'}}                        <span style=\"float: right\" title='The formula evaluates correct, but this isn't the final solution yet.'>{{>icon 'symbol-pipe'}}</span>                        {{#elseif this.type === 'perfect'}}                        <span style=\"float: right; color: #38d090\" title='Correct solution'>{{>icon 'symbol-pipe'}}</span>                        {{/if}}                    </div>                    {{/each}}                {{/if}}            </div>            <div data-live-client-block=\"4\" data-live-client-block-type=\"list\" data-live-client-stamp=\"{{btoa(JSON.stringify(this.lastStep || {}))}}\">                {{#if this.lastStep}}                    Last step:                    {{#if this.historyId}}                        {{#with this.lastStep}}                            <div style=\"padding: 15px;\">                                {{#if this.formula}}                                    <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\">                                        {{#compute this.formula /}}                                    </div>                                {{#else}}                                    {{#if this.type === 'text'}}                                        <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                                        <p style=\"margin-bottom: 15px\">{{this.content}}</p>                                    {{#elseif this.type === 'formula'}}                                        <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                                        <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\">                                            {{#compute this.content /}}                                        </div>                                    {{#elseif this.type === 'comment-doodle'}}                                        <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                                        <p class=\"formula-flack\">                                            <img data-doodle-id=\"{{this.content}}\" class=\"doodle-image\" src=\"/doodle/{{this.content}}.svg\" />                                        </p>                                    {{#elseif this.type === 'prime-table'}}                                        <span style=\"float: right;\" title='Prime factorization chart'>{{>icon 'symbol-prim-table'}}</span>                                        <div class=\"prime-table\">                                            <div class=\"prime-table__left\">                                                {{#each this.content}}                                                <div class=\"prime-table__cell\">{{this[0] > 0 ? this[0] : '&nbsp;'}}</div>                                                {{/each}}                                            </div>                                            <div class=\"prime-table__right\">                                                {{#each this.content}}                                                <div class=\"prime-table__cell\">{{this[1] > 0 ?  this[1] : '&nbsp;'}}</div>                                                {{/each}}                                            </div>                                        </div>                                    {{/if}}                                {{/if}}                                {{#if this.type === 'fail'}}                                    <span style=\"float: right; color: #e06476\" title='The value is incorrect'>{{>icon 'symbol-x'}}</span>                                {{#elseif this.type === 'ok'}}                                    <span style=\"float: right\" title='The formula evaluates correct, but this isn't the final solution yet.'>{{>icon 'symbol-pipe'}}</span>                                {{#elseif this.type === 'perfect'}}                                    <span style=\"float: right; color: #38d090\" title='Correct solution'>{{>icon 'symbol-pipe'}}</span>                                {{/if}}                            </div>                        {{/with}}                    {{#else}}                        {{#with this.lastStep}}                        <div class=\"exam__problem__solution\">                            {{#if this.type === 'comment-doodle'}}                                {{>icon 'symbol-speach-bubble'}}                                <p class=\"formula-flack\">                                    <img data-doodle-id=\"{{this.display}}\" class=\"doodle-image\" src=\"/doodle/{{this.display}}.svg\" />                                </p>                            {{#elseif this.type === 'comment-text'}}                                {{>icon 'symbol-speach-bubble'}}                                <p class=\"formula-flack\">{{this.display}}</p>                            {{#elseif this.type ===  'comment-formula'}}                                {{>icon 'symbol-speach-bubble'}}                                <div class=\"formula-flack\" data-f=\"{{this.display}}\">                                    <div data-f-content></div>                                </div>                            {{#elseif this.type ===  'solution'}}                                {{#if this.result === 0}}                                    <span style=\"float: right; color: #e06476\" title='The value is incorrect'>{{>icon 'symbol-x'}}</span>                                {{#elseif this.result === 1}}                                    <span style=\"float: right\" title='The formula evaluates correct, but this isn't the final solution yet.'>{{>icon 'symbol-pipe'}}</span>                                {{#elseif this.result === 2}}                                    <span style=\"float: right; color: #38d090\" title='Correct solution'>{{>icon 'symbol-pipe'}}</span>                                {{/if}}                                <div class=\"formula-flack\" data-f=\"{{this.display}}\">                                    <div data-f-content></div>                                </div>                            {{/if}}                        </div>                        {{/with}}                    {{/if}}                {{/if}}            </div>            <div data-live-client-block=\"5\" data-live-client-stamp=\"{{(this.input || {}).value}}@{{#if this.input && this.input.type === 'doodle'}}{{Math.random()}}{{/if}}\">                {{#if !this.closed && this.input && this.input.value}}                    Actual step:                    <div style=\"padding: 15px; overflow: auto;\">                    {{#if this.input.type === 'formula'}}                        <div data-formula style=\"font-size: 22px; margin-bottom: 15px; color: #313744;\">                            {{#compute this.input.value /}}                        </div>                    {{#elseif this.input.type === 'doodle'}}                        <p class=\"formula-flack\">                            <img data-doodle-id=\"{{this.input.value}}\" class=\"doodle-image\" src=\"/doodle/{{this.input.value}}.svg?{{Math.random()}}\" />                        </p>                    {{/if}}                    </div>                {{/if}}            </div>        </p>    </div>    <div class=\"newsfeed__item__actions\" data-live-client-block=\"6\" data-live-client-stamp=\"{{this.winId}}@{{this.problemSolutionLink}}\">        {{#if !this.closed && this.winId}}            <a class=\"button button--small\" href=\"/en-US/mirror/{{this.winId}}\" target=\"_blank\">                Live view            </a>        {{/if}}        {{#if !this.closed && this.problemSolutionLink}}        <a class=\"button button--small button--purple\" target=\"_blank\" href=\"{{this.problemSolutionLink}}\">            Akriel’s solution        </a>        {{/if}}        {{!JSON.stringify(this)}}    </div></div>","mail-to":"{{#if this.support}}<a href=\"mailto:{{base64Decode('c3VwcG9ydEBha3JpZWwuaW8=')}}\" class=\"strong\">{{base64Decode('c3VwcG9ydEBha3JpZWwuaW8=')}}</a>{{#else}}<a href=\"mailto:{{base64Decode('aW5mb0Bha3JpZWwuaW8=')}}\" class=\"strong\">{{base64Decode('aW5mb0Bha3JpZWwuaW8=')}}</a>{{/if}}","newsfeed-card-actions":"{{!JSON.stringify(this)}}<div class=\"newsfeed__item__actions\">    {{#if this.category === 'exam' && this.data.examId}}        {{#if this.data.type === 'exam-started'}}        <a class=\"button button--green button--small\" href=\"/en-US/group/exam/{{this.data.examId}}/live\">            Go to test        </a>        {{#else}}        <a class=\"button button--green button--small\" href=\"/en-US/exam/{{this.data.examId}}\">            Go to test        </a>        {{/if}}    {{#elseif this.data.type === 'exam-collected'}}        <a class=\"button button--green button--small\" href=\"/en-US/group/exam/{{this.data.groupExamId}}/live\">            Go to test        </a>    {{/if}}    {{#if this.data.type === 'group-topic' && this.data.topic}}    <a class=\"button button--small\" href=\"/en-US/learn/topic/{{this.data.topic.id}}\">        Go to the lesson    </a>    {{/if}}    {{#if this.data.details && this.data.details.events && this.data.details.events.length}}    {{!JSON.stringify(this.data.details)}}    <a class=\"button button--small\" data-group-show-details='{{#base64 JSON.stringify(this.data) /}}'>        Your own solution ({{this.data.details.events.length}})    </a>    <a class=\"button button--small button--purple\" target=\"_blank\" href=\"/en-US{{this.data.details.problem.solutionLink}}\">        Akriel’s solution    </a>    {{#elseif this.data.details && this.data.details.problem}}    <a class=\"button button--small button--purple\" target=\"_blank\" href=\"/en-US/problem/{{this.data.details.problem}}\">        Akriel’s solution    </a>    {{/if}}    {{#if this.data.type === 'group-connect-request'}}    <a class=\"button button--gray button--small\" data-group-join-approve-action data-show-unapproved-users=\"{{this.data.groupId}}\">        Manage requests    </a>    {{/if}}    {{#if this.data.type !== 'user-like'}}        {{#if this.liked}}        <a data-unlike-story=\"{{this._id}}\" class=\"button button--secondary button--small button--heart\" style=\"color:#e06476\">            {{>icon 'symbol-heart'}}            <span data-count>{{#if this.like && this.like.length > 0}}{{this.like.length}}{{/if}}</span>        </a>        {{#else}}        <a data-like-story=\"{{this._id}}\" class=\"button button--gray button--small button--heart\">            {{>icon 'symbol-heart-full'}}            <span data-count>{{#if this.like && this.like.length > 0}}{{this.like.length}}{{/if}}</span>        </a>        {{/if}}    {{/if}}    {{#if this.reply && this.reply.length === 0}}    <a href=\"/en-US/story/{{this._id}}\" class=\"button button--secondary button--small newsfeed__item__actions__reply\">answer</a>    {{#elseif this.reply && this.reply.length > 0}}    <a href=\"/en-US/story/{{this._id}}\" class=\"button button--small newsfeed__item__actions__reply\">{{this.reply.length}} answer</a>    {{/if}}</div>","newsfeed-card":"{{!JSON.stringify(this)}}<div data-newsfeed-story=\"{{this._id}}\">    <div class=\"newsfeed__item newsfeed__item--{{this.data.type}} {{#if this.data.highlighted}}newsfeed__item--highlighted{{/if}}\">        {{#if this.archived}}        <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">This entry is not available.</div>        {{#else}}        {{#if this.data.type === 'user-like' && this.user}}        <div class=\"newsfeed__item__details\">            <span style=\"color:#e06476\">{{>icon 'symbol-heart-full'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> liked <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>        </div>        {{/if}}        {{#if this.data.reply}}        <div class=\"newsfeed__item__reply-wrapper\">            {{>newsFeedCard this.data.reply}}        </div>        {{/if}}        {{#if this.data.type == 'connect-to-group' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> joined the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>        </div>        {{#elseif this.data.type == 'group-connect-request'}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{this.data.executiveUser ? this.data.executiveUser.name : 'Unnamed user'}}</a> has been requesting to join the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.            {{#if this.data.message}}            <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div>            {{/if}}        </div>        {{#elseif this.data.type == 'disconnect-from-group' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> left the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'approve-user' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Unnamed user'}).name}}</a> accepted the join request of <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> to study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'un-approve-user' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Unnamed user'}).name}}</a> denied the join request of <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> to study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'remove-user' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Unnamed user'}).name}}</a> removed <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> from study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'add-owner-role' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Unnamed user'}).name}}</a> promoted <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> leader of study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'remove-owner-role' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-user'}}</span>            <a href=\"/en-US/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Unnamed user'}).name}}</a> revoked the group leader role of <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> in study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'create-group' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-pen'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> created the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.            {{#if this.data.message}}            <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div>            {{/if}}        </div>        {{#elseif this.data.type == 'delete-group' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-trash'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> archived the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'group-name-modified' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-pen'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> renamed the study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group && this.data.group.name}}</a> to \"<b style=\"font-weight: bold\">{{this.data.newName}}</b>\" <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.        </div>        {{#elseif this.data.type == 'group-description-modified' && this.user}}        <div class=\"newsfeed__item__details\">            <span>{{>icon 'symbol-pen'}}</span>            <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> changed the description of the study group named <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.            <div class=\"newsfeed__item__message\">{{#postReplacer this.data.newDescription /}}</div>        </div>        {{#elseif this.data.type === 'earn-default-cup' && this.data.topic && this.user}}        <div class=\"newsfeed__item__system-message\">            {{>icon 'learn-cup-basic'}}            <div class=\"newsfeed__item__bold\">                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> has earned a cup            </div>            <p>                for solving one of each exercise categories in the lesson <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>            </p>            <p style=\"margin: 30px 0 0; opacity: .5\"><a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a></p>        </div>        {{#elseif this.data.type === 'earn-cup' && this.data.topic && this.user}}        <div class=\"newsfeed__item__system-message\">            {{>icon 'learn-cup'}}            <div class=\"newsfeed__item__bold\">                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> has earned a grand cup            </div>            <p>                for solving all exercises of lesson <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>            </p>            <p style=\"margin: 30px 0 0; opacity: .5\"><a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a></p>        </div>        {{#elseif this.data.type == 'group-get-new-cup' && this.data.topic}}        <div class=\"newsfeed__item__system-message\">            {{>icon 'learn-cup'}}            <div class=\"newsfeed__item__bold\">Congratulations, you’ve earned a group cup</div>            <p>                for solving all exercises of lesson <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>            </p>            <p style=\"margin: 30px 0 0; opacity: .5\">                <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>, in group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a>.            </p>        </div>        {{#elseif this.data.type == 'lecture-history' && this.data.question && this.user}}        <div class=\"newsfeed__item__details\">            <p class=\"newsfeed__item__text--global\">                {{#if this.data.details.success}}                    <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> successfully solved the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#elseif this.data.details.events.length === 0}}                    <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> viewed the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#else}}                    <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> could not solve the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{/if}}            </p>            <p class=\"newsfeed__item__text--personal\">                {{#if this.data.details.success}}                    <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}}</span>                    You successfully solved the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#elseif this.data.details.length === 0}}                    <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}}</span>                    You viewed the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#else}}                    <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}}</span>                    You could not solve the exercise named <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{/if}}            </p>            <br>            <div style=\"font-size: 23px\" data-f=\"{{this.data.details.problem.clone}}\"><div data-f-content></div></div>            <div data-nf-input-details></div>        </div>        {{#elseif this.data.type !== 'user-like' && (this.user || true)}}        <div class=\"newsfeed__item__details\">            {{#if this.data.type === 'group-message'}}                {{#if this.data.reply || this.data.replyTo }}                    <span>{{>icon 'symbol-redo'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> replied <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> in study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a>.                {{#else}}                    <span>{{>icon 'symbol-speach-bubble'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> messaged <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> in study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a>.                {{/if}}                <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div>            {{#elseif this.data.type === 'group-topic' && this.data.topic}}                <span>{{>icon 'menu-academy'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> shared a lesson <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> in study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a>.                <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\" class=\"newsfeed__item__message\" style=\"display: block\">{{this.data.topic.title}}</a>                {{#if this.data.message}}                <p style=\"margin-top: 10px;\">{{this.data.message}}</p>                {{/if}}            {{#elseif this.data.type === 'earn-star' && this.data.question}}                <span style=\"color:#ff9f28; top: -2px; position: relative;\">{{>icon 'star'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> earned {{this.data.quantity || 'a'}} star(s) <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, for practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.            {{#elseif this.data.type === 'earn-medal' && this.data.question}}                <span style=\"color:#ff9f28; top: -1px; position: relative;\">{{>icon 'learn-medal'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> earned {{this.data.quantity || 'a'}} medal(s) <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> for practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.            {{#elseif this.data.type === 'loose-star' && this.data.question}}                <span style=\"top: -2px; position: relative;\">{{>icon 'star'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> lost {{this.data.quantity || 'a'}} star(s) <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.            {{#elseif this.data.type === 'ok-answer' && this.data.question}}                <span style=\"top: -2px; position: relative\">{{>icon 'symbol-pipe'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> entered a correct intermediate solution <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.                <br><br>                <p>The question:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div>                <p>Entered solution:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div>            {{#elseif this.data.type === 'perfect-answer' && this.data.question}}                <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> entered the correct solution <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.                <br><br>                <p>The question:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div>                <p>Entered solution:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div>            {{#elseif this.data.type === 'ok-go-on-answer' && this.data.question}}                <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-pipe'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> entered a correct intermediate solution <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.                <br><br>                <p>The question:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div>                <p>Entered solution:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div>            {{#elseif this.data.type === 'ok-but-was-answer' && this.data.question}}                <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-pipe'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> entered an already entered correct solution <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.                <br><br>                <p>The question:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div>                <p>Entered solution:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div>            {{#elseif this.data.type === 'view-answer' && this.data.question}}                <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> viewed the derivation of exercise <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#if this.data.details}}                <br><br><div style=\"font-size: 23px\" data-f=\"{{this.data.details.formula}}\"><div data-f-content></div></div>                {{/if}}            {{#elseif this.data.type === 'fail-answer' && this.data.question}}                <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> entered an incorrect solution <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, while practicing <a href=\"/en-US/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> in lesson <a href=\"/en-US/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a>.                <br><br>                <p>The question:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div>                <p>Entered solution:</p>                <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div>            {{#elseif this.category === 'problem-history'}}                <span style=\"top: -2px; position: relative;\">{{>icon 'menu-new-problem'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unnamed user'}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> viewed the derivation of the following exercise:                <br><br><div style=\"font-size: 23px\" data-f=\"{{this.data.details.formula}}\"><div data-f-content></div></div>            {{#elseif this.category === 'error'}}                <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-lab'}}</span>                <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unregistered user'}}</a> encountered error type <strong style=\"font-weight: bold\">{{this.data.type}}</strong> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>.                {{#if this.data.details.error && this.data.details.error.final_message}}                <p style=\"margin-top: 15px\">{{#compute this.data.details.error.final_message /}}</p>                {{/if}}                <pre style=\"white-space: pre-line; margin-top: 15px; word-break: break-all;\">                    {{JSON.stringify(this.data.details.error)}}                </pre>            {{#elseif this.category === 'exam'}}                {{#if this.data.type === 'exam-finished'}}                    <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unregistered user'}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> took a test with the result of <strong style=\"font-weight: bold\">{{this.data.details.percentage}}</strong>% in lesson <a style=\"font-weight: bold\" href=\"/en-US/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>, taking <strong style=\"font-weight: bold\">{{Math.round(this.data.details.length / 1000 / 60)}}</strong> minutes.                {{#elseif this.data.type === 'exam-started'}}                    <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unregistered user'}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> started a test on the following lesson: <a href=\"/en-US/learn/topic/{{this.data.topic.id}}\" style=\"font-weight: bold\">{{this.data.topic.title}}</a> in study group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a>.                {{#elseif this.data.type === 'exam-collected' && this.data.group}}                    <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}}</span>                    <a href=\"/en-US/user/{{this.userId}}\">{{this.user ? this.user.name : 'Unregistered user'}}</a> <a href=\"/en-US/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> has collected the tests in group <a href=\"/en-US/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> on the following lesson: <strong style=\"font-weight: bold\">{{this.data.topic.title}}</strong>.                {{/if}}                {{!JSON.stringify(this)}}            {{#else}}                <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">This entry is not available.</div>            {{/if}}            <div data-nf-input-details></div>        </div>        {{#elseif this.data.type !== 'user-like'}}            <div class=\"newsfeed__item__details\">                <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">This entry is not available.</div>            </div>        {{/if}}        {{#if this.data && this.data.details && this.data.details.responseTime}}        <span style=\"font-weight: bold\" class=\"debug-info\">            Response time: {{this.data.details.responseTime / 1000}} seconds            <br><br>        </span>        {{/if}}        <div data-nf-card-actions>            {{>newsFeedCardActions this}}        </div>        {{/if}}    </div></div>","newsfeed-input-details":"{{!JSON.stringify(this)}}<div class=\"newsfeed__item__actions\" style=\"margin-top: 15px\">    <div style=\"font-weight: bold; color: #313744; padding-bottom: 15px\">{{#compute this.details.problem.instruction /}}</div>    {{#if this.details.events.length > 0}}        {{#each this.details.events}}        <div style=\"width: 100%; border-top: 2px solid #d6dbde; padding-top: 15px;\">            {{#if this.formula}}                <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\">                    {{#compute this.formula /}}                </div>            {{#else}}            {{#if this.type === 'text'}}                <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                <p style=\"margin-bottom: 15px\">{{this.content}}</p>            {{#elseif this.type === 'formula'}}                <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\">                    {{#compute this.content /}}                </div>            {{#elseif this.type === 'comment-doodle'}}                <span style=\"float: right;\" title='Commentary'>{{>icon 'symbol-speach-bubble'}}</span>                <p class=\"formula-flack\">                    <img data-doodle-id=\"{{this.content}}\" class=\"doodle-image\" src=\"/doodle/{{this.content}}.svg\" />                </p>            {{#elseif this.type === 'prime-table'}}                <span style=\"float: right;\" title='Prime factorization chart'>{{>icon 'symbol-prim-table'}}</span>                <div class=\"prime-table\">                    <div class=\"prime-table__left\">                        {{#each this.content}}                        <div class=\"prime-table__cell\">{{this[0] > 0 ? this[0] : '&nbsp;'}}</div>                        {{/each}}                    </div>                    <div class=\"prime-table__right\">                        {{#each this.content}}                        <div class=\"prime-table__cell\">{{this[1] > 0 ?  this[1] : '&nbsp;'}}</div>                        {{/each}}                    </div>                </div>            {{/if}}            {{/if}}        {{#if this.type === 'fail'}}            <span style=\"float: right; color: #e06476\" title='The value is incorrect'>{{>icon 'symbol-x'}}</span>        {{#elseif this.type === 'ok'}}            <span style=\"float: right\" title='The formula evaluates correct, but this isn't the final solution yet.'>{{>icon 'symbol-pipe'}}</span>        {{#elseif this.type === 'perfect'}}            <span style=\"float: right; color: #38d090\" title='Correct solution'>{{>icon 'symbol-pipe'}}</span>        {{/if}}        </div>        {{/each}}        <p>            {{#if Math.floor((new Date(this.details.events[this.details.events.length - 1].date) - new Date(this.details.date)) / 60000) > 0}}                {{#if Math.round((new Date(this.details.events[this.details.events.length - 1].date) - new Date(this.details.date)) % 60000 / 1000) > 0}}                    in {{Math.floor((new Date(nth(this.details.events,this.details.events.length - 1).date) - new Date(this.details.date)) / 60000)}} minute(s) and {{Math.round((new Date(nth(this.details.events, this.details.events.length - 1).date) - new Date(this.details.date)) % 60000 / 1000)}} second(s).                {{#else}}                    in {{Math.floor((new Date(nth(this.details.events,this.details.events.length - 1).date) - new Date(this.details.date)) / 60000)}} minute(s).                {{/if}}            {{#else}}                in {{Math.round((new Date(nth(this.details.events, this.details.events.length - 1).date) - new Date(this.details.date)) % 60000 / 1000)}} second(s).            {{/if}}        </p>    {{#else}}        No solution has been entered for this exercise.    {{/if}}</div>","newsfeed":"{{#if this.items.length > 0}}{{#each this.items}}{{>newsFeedCard this}}{{/each}}{{#if this.remaining > 0}}<div data-newsfeed-content>    <a class=\"button button--full button--gray\" data-newsfeed-load-more=\"{{this.lastDate}}\">        load {{this.remaining}} more news    </a></div>{{/if}}{{#else}}<div class=\"newsfeed__item newsfeed__item--no-result\" data-hide-when-loaded>    <span class=\"newsfeed__item__message\">Nothing has happened here so far.</span>    <small>Or you don’t have permission to view.</small></div>{{/if}}","notification-overlay":"<p>{{this.text}}</p>{{#if this.msg}}<p>{{this.msg}}</p>{{/if}}<div class=\"text-center\">    <a class=\"button button--secondary\" data-close-overlay>Close</a>    {{#if this.cta}}    <a href=\"{{this.link}}\" class=\"button\">{{this.cta}}</a>    {{/if}}</div>","notification":"{{#if this.length > 0}}{{#each this}}<div data-notification-href=\"{{this.link}}\" data-notification-id=\"{{this.id}}\"    class=\"notification__item notification__item--{{this.key}} {{#if this.pro}} notification__item--pro{{/if}}{{#if this.seen}} notification__item--seen{{/if}}\">    <div class=\"notification__item__text\">        {{#if this.key === 'someone-liked-my-story'}}        <span class=\"notification__item__icon\" style=\"color:#e06476\">{{>icon 'symbol-heart-full'}}</span>        {{#elseif this.key === 'someone-replied-my-story' || this.key === 'new-message-in-a-group'}}        <span class=\"notification__item__icon\">{{>icon 'symbol-speach-bubble'}}</span>        {{#elseif ['group-connect-request','connect-to-group','you-connect-to-group','accept-connection-request','denied-connection-request'].indexOf(this.key) > -1}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-group'}}</span>        {{#elseif ['pro-activated','pro-success-payment','dpro-success-payment','pro-de-activated','pro-subscription-joined'].indexOf(this.key) > -1}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-premium'}}</span>        {{#elseif this.key === 'new-group-challenge'}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'symbol-paperplane'}}</span>        {{#elseif this.key === 'new-group-topic'}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-academy'}}</span>        {{#elseif this.key === 'win-group-cup'}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'learn-cup'}}</span>        {{#elseif this.key === 'resolved-group-challenge'}}        <span class=\"notification__item__icon\" style=\"color: #38d090;position: relative;top: -1px;\">{{>icon 'symbol-pipe'}}</span>        {{#elseif this.key === 'group-exam-start' || this.key === 'group-exam-finished'}}        <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-exam'}}</span>        {{/if}}        {{this.text}}    </div>    <span class=\"notification__item__msg\">{{#if this.msg}}{{this.msg}}{{/if}}</span>    <span class=\"notification__item__time\" data-ago-moment=\"{{this.date}}\"></span>    {{#if this.cta}}    <span class=\"notification__item__cta\">{{this.cta}}</a>    {{/if}}    <div class=\"notification__item__seen\" data-notification-seen-toggle>        <span class=\"notification__item__seen__decor\"></span>    </div></div>{{/each}}<div class=\"notification__inner-text\">    <span>{{>icon \"menu-notification\"}}</span></div>{{/if}}","onboard":"<div class=\"onboard hide\" data-onboard>\t<div class=\"onboard__message\" data-onboard-content>\t\t<div class=\"onboard__message__text\" data-onboard-text></div>\t</div>\t<div class=\"onboard__blocker\" data-onboard-blocker></div>\t<div class=\"onboard__pointer\" data-onboard-pointer>\t\t<span class=\"onboard__pointer__decor\"></span>\t</div>\t<svg data-onboard-line class=\"onboard__line\" x=\"0px\" y=\"0px\" xml:space=\"preserve\">\t\t<path data-onboard-line-path class=\"onboard__line__path\" />\t</svg></div><div class=\"overlay\" data-overlay=\"failed-input\">\t<div class=\"overlay--background\" data-close-overlay>\t\t<span class=\"overlay--close-icon\">\t\t\t<i class=\"icon-wrapper\">\t\t\t\t<svg viewBox=\"0 0 256 256\">\t\t\t\t\t<use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-symbol-x\"></use>\t\t\t\t</svg>\t\t\t</i>\t\t</span>\t</div>\t<div class=\"overlay--content-wrapper\">\t\t<div class=\"overlay--content content-wrapper center-box\">\t\t\tThis is not an example. Please try again or watch the intro video:<br><br>\t\t\t<div style=\"position: relative; padding-bottom: 56.2%\">\t\t\t\t<iframe style=\"width:100%; height:100%; position:absolute; left:0;\" src=\"https://www.youtube.com/embed/_YWxEpk8y1A?rel=0\" frameborder=\"0\" allowfullscreen></iframe>\t\t\t</div>\t\t\t<br>\t\t\t<div class=\"text-center\">\t\t\t\t<button class=\"button\" data-close-overlay>Close</button>\t\t\t</div>\t\t</div>\t</div></div>","overlays":"<div class=\"overlay\" data-overlay=\"alert\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <p style=\"white-space: pre-line\" data-alert-content></p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"users-list\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <div data-users-list></div>            <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\">                <button class=\"button button--secondary\" data-refresh-user-list>Refresh list</button>                <button class=\"button\" data-close-overlay>OK</button>                <br><br>                <button class=\"button button--gray\" data-open-overlay=\"group-registration\">Add new name</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"group-registration\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <form class=\"overlay--content content-wrapper center-box\"              method=\"post\"              action=\"/en-US/service/group/sign-up\"              data-callback=\"APP.Group.successGroupRegistration\">            <p>If you want to register multiple names, enter each name on a separate line.</p>            <textarea name=\"names\" placeholder=\"Enter the name you want to register.\"></textarea>            <span data-form-error=\"names\"></span>            <input type=\"hidden\" name=\"groupId\" />            <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\">                <button class=\"button\">Registration</button>                <a class=\"button button--secondary\" data-close-last-overlay>Cancel</a>            </div>        </form>    </div></div><div class=\"overlay\" data-overlay=\"edit-user-name\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <form class=\"overlay--content content-wrapper center-box\"              method=\"post\"              action=\"/en-US/service/group/user-edit\"              data-callback=\"APP.Group.successAction\">            <p>Edit username</p>            <input type=\"hidden\" name=\"method\" value=\"edit-user-name\" />            <input type=\"text\" name=\"name\" placeholder=\"Username\" />            <span data-form-error=\"name\"></span>            <input type=\"hidden\" name=\"userId\" />            <input type=\"hidden\" name=\"groupId\" />            <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\">                <button class=\"button\">Save</button>                <a class=\"button button--secondary\" data-close-last-overlay>Cancel</a>            </div>        </form>    </div></div><div class=\"overlay\" data-overlay=\"edit-user-email\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <form class=\"overlay--content content-wrapper center-box\"              method=\"post\"              action=\"/en-US/service/group/user-edit\"              data-callback=\"APP.Group.successAction\">            <p>Edit email address</p>            <input type=\"hidden\" name=\"method\" value=\"edit-user-email\" />            <input type=\"text\" name=\"email\" placeholder=\"Email address\" />            <span data-form-error=\"email\"></span>            <input type=\"hidden\" name=\"userId\" />            <input type=\"hidden\" name=\"groupId\" />            <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\">                <button class=\"button\">Save</button>                <a class=\"button button--secondary\" data-close-last-overlay>Cancel</a>            </div>        </form>    </div></div><div class=\"overlay\" data-overlay=\"success-action\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <p>Operation successful.</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"fail-action\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <p>An error has occurred during the operation; please accept our apologies. We’ll fix this issue as soon as we can.</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"pro-activated\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content overlay--content--pro content-wrapper center-box\">            <h1>Your Akriel subscription has been activated!</h1>            <p>From now on, you can enjoy all the benefits of Akriel.<br>Have fun using Akriel!</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"pro-deactivated\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <h1>Your Akriel subscription has expired.</h1>            <p>You can renew your subscription in the \"Subscription\" menu.</p>            <div class=\"text-center\">                <a class=\"button\" href=\"/en-US/pro\">Subscription</a>                <button class=\"button button--secondary\" data-close-overlay>Cancel</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"user-account-logged-in\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\">            <h1 class=\"text-center\">You have logged in</h1>            <p>Apparently you logged in to Akriel in the meantime.</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"user-account-logged-in-other-user\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\">            <h1 class=\"text-center\">Account warning</h1>            <p>Apparently you’ve logged in to Akriel in the meantime with a different user account.</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"user-account-logged-out\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\">            <h1 class=\"text-center\">You have logged out</h1>            <p>Apparently you’ve been idle for too long or you may have already logged out from Akriel on a different browser tab.</p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay>OK</button>            </div>        </div>    </div></div><div class=\"overlay\" data-overlay=\"youtube-video-overlay\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\" data-youtube-video-wrapper>    </div></div><div class=\"overlay\" data-overlay=\"live-access\">    <div class=\"overlay--background\" data-close-overlay>        <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span>    </div>    <div class=\"overlay--content-wrapper\">        <div class=\"overlay--content content-wrapper center-box\">            <p>                <span data-access-name></span> would like to get access to Akriel’s browser window in order to work with you.            </p>            <div class=\"text-center\">                <button class=\"button\" data-close-overlay data-allow-live>OK</button>                <button class=\"button button--secondary\" data-close-overlay>Cancel</button>            </div>        </div>    </div></div>","placeholder":"<div data-row-placeholder=\"{{this.id}}\" class=\"problem-row-placeholder\">    <div data-row-placeholder-content class=\"problem-row-placeholder__content\"></div></div>","prime-table":"<div class=\"prime-table\">    <div class=\"prime-table__left\">        {{#each this}}        <div class=\"prime-table__cell\">{{this[0] || '&nbsp;'}}</div>        {{/each}}    </div>    <div class=\"prime-table__right\">        {{#each this}}        <div class=\"prime-table__cell\">{{this[1] || '&nbsp;'}}</div>        {{/each}}    </div></div>","problem/academy":"<div class=\"problem--toggler-button--wrapper\">    <span class=\"button button--small button--iconed problem--toggler-button button--purple\">        <i class=\"button__icon\">            {{>icon \"akriel-symbol-p1\"}}        </i>        <i class=\"button__icon\">            {{>icon \"akriel-symbol-p2\"}}        </i>        <span>More info</span>    </span>    <span class=\"problem--row__close\">        {{>icon \"symbol-x\"}}    </span></div><div data-href=\"/en-US/academy/{{this.pictogram.id}}\" data-academy-overlay-trigger class=\"problem--child\"     data-problem-gate data-problem-child data-problem-accordion data-traceid=\"{{this.traceid}}\">    <div class=\"problem--border\" data-academy-content=\"{{this.pictogram.id}}/{{this.pictogram.index}}\"         style=\"border-color:transparent;padding-bottom:0;\">    </div></div>","problem/child":"{{#if this.child}}    {{#if !this.multiple_show}}        <div class=\"problem--child\"        {{#if this.link && this.link.method}} data-open-overlay=\"soon-{{this.link.method.type}}\" data-prevent{{/if}}>        <span class=\"problem--title problem--title--primary\">        {{#if this.message && this.message.method}}            <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\">            {{#compute this.message.method /}}                </span>            {{/if}}            </span>            {{#if this.extended_pictogram}}                <div class=\"problem--title problem--title--secondary\">                <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\">                {{#compute this.extended_pictogram.message/}}                    </span>                    </div>                {{/if}}                </div>            {{/if}}            <div class=\"problem--toggler-button--wrapper\" {{#if this.fullymarked}}data-not-shown{{/if}}><span class=\"button button--small button--iconed problem--toggler-button\"      {{#if this.extended_pictogram}}data-open-primary-child{{/if}}>    <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>    <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>    <span>More info</span></span>                {{#if this.extended_pictogram && this.extended_pictogram.pictogram}}                    <span class=\"button button--small button--iconed button--purple problem--toggler-button\" data-open-secondary-child                          data-href=\"/en-US/academy/{{this.extended_pictogram.pictogram.id}}\"                          data-academy-index=\"{{this.extended_pictogram.pictogram.index}}\"                          data-academy-trigger='[data-academy-content=\"{{this.extended_pictogram.pictogram.id}}/{{this.extended_pictogram.pictogram.index}}\"]'>    <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>    <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>    <span>More info</span></span>                {{/if}}            </div>            <div class=\"problem--child{{#if this.child && this.child.length === 1}} problem--child--single{{/if}}{{#if this.extended_pictogram}} problem--primary-child{{/if}}\"                 data-problem-gate data-problem-child data-problem-accordion>                {{#each this.child}}{{>problemRow this}}{{/each}}            </div>        {{/if}}","problem/index":"{{>tree this}}","problem/row":"<div\t{{#if this.link && this.link.pictogram && this.link.pictogram.embed}}    data-href=\"/en-US/academy/{{this.link.pictogram.id}}\"    data-academy-index=\"{{this.link.pictogram.index}}\"    data-academy-trigger='[data-academy-content=\"{{this.link.pictogram.id}}/{{this.link.pictogram.index}}\"]'    data-enable-href    {{/if}}    class=\"problem--row{{#if !this.child && !this.link}} problem--row-no-child{{/if}} problem--row-hide    {{#if this.singlewhenclosed}} problem--hide-mark{{/if}}    {{#if this.multiple_show}} problem--multiple-main-row{{/if}}    {{#if this.show_mark_immediately}} problem--row--show-mark-immediately{{/if}}\"    {{#if this.fullymarked}}data-row-fullymarked=\"true\"{{/if}}    data-problem-action-type=\"{{this.actioncolor}}\" data-traceid=\"{{this.traceid}}\"    data-problem-row    data-row-index=\"{{this.index}}\"    {{#if this.mainRow}}data-problem-main-row=\"0\"{{/if}}    ><div class=\"problem--border problem--border-color-{{this.actioncolor}}\">    {{#if !(this.mainRow && (this.fullymarked || this.multiple_show))}}    <span class=\"problem--row__close\">        {{>icon \"symbol-x\"}}    </span>    {{/if}}    {{#if this.message && this.message.action}}    <div class=\"problem--title{{#if this.headerindex && this.headerindex.action}} problem--title__indexed{{/if}}        {{#if this.singlewhenclosed}} problem--title__hide{{/if}}\"        {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}>        <span class=\"problem--method-name\">            <span>                {{#if this.headerindex && this.headerindex.action}}                    <span class=\"problem--index problem--index--active\">{{this.headerindex.action}}</span>                {{/if}}                {{#compute this.message.action /}}            </span>        </span>    </div>    {{/if}}    {{#if !this.multiple_show && this.message}}    <div class=\"problem--title{{#if this.headerindex && this.headerindex.row}} problem--title__indexed{{/if}}        {{#if this.singlewhenclosed}} problem--title__hide{{/if}}\"        {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}>        {{#if this.knowledgebase}}        <span class=\"problem--academy-indicator\">            {{>icon \"symbol-study\"}}        </span>        {{/if}}        {{#if this.link && this.link.row && this.link.row.type === \"problem\"}}        <span class=\"problem--formula-wrapper\"              data-blank-href=\"/en-US/problem/direct/{{#base64 this.link.row.value.formula/}}/?cmd={{this.link.row.value.cmd.replace(/#/g, '')}}&source=message\">\t\t        <span style=\"position:relative\">\t\t\t\t{{#if this.headerindex && this.headerindex.row}}                    <span class=\"problem--index problem--index--active\" style=\"left:-20px\">{{this.headerindex.row}}</span>                {{/if}}                {{#if this.message}}                    {{#compute this.message.row /}}                {{/if}}\t\t\t\t</span>\t\t        {{#if this.message && this.message.trace}}                    <span class=\"debug-info\">[{{this.message.trace}}]</span>                {{/if}}            </span>        {{#else}}        <span class=\"problem--formula-wrapper\"           {{#if this.link && this.link.row}}          data-blank-href=\"{{JSON.stringify(this.link)}}\"          data-prevent          {{/if}}>            <span style=\"position:relative\">                {{#if this.headerindex && this.headerindex.row}}                    <span class=\"problem--index problem--index--active\" style=\"left:-20px\">{{this.headerindex.row}}</span>                {{/if}}                {{#if this.message && this.message.row}}                    {{#compute this.message.row /}}                {{/if}}            </span>            {{#if this.message && this.message.trace}}                <span class=\"debug-info\">[{{this.message.trace}}]</span>            {{/if}}        </span>        {{/if}}    </div>    {{/if}}    <div class=\"problem--wrapper{{#if this.multiple_show}} problem--formula-multiple-main-row__wrapper{{/if}}\">        {{#if this.formula}}            <div class=\"problem--details\">                <div class=\"problem--formula problem--formula-wrapper\"                    {{#if this.formula && this.formula.direction === \"vertical\"}}data-problem-vertical{{/if}}>                <div class=\"problem--formula-left\" data-formula>                    <div class=\"formula\" data-formula>{{#compute this.formula.from /}}</div>\t\t\t\t\t{{#if this.formula && this.formula.direction !== \"vertical\"}}\t\t\t\t\t\t<div class=\"{{#if this.exception || (!this.multiple_show && this.formula && this.formula.to) && this.fullymarked}} problem--formula-hide-on-open{{/if}}                        {{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}}\t\t\t\t\t\tproblem--formula-arrow{{#if !(this.formula && this.formula.action)}} problem--formula-arrow-no-action{{/if}}\" data-formula>\t\t\t\t\t\t\t{{>icon \"arrow-right\"}}\t\t\t\t\t\t</div>\t\t\t\t\t{{/if}}                    {{#if this.formula.action}}                        <div class=\"problem--formula-action\" data-formula                         {{#if this.link && this.link.action}}                         data-blank-href=\"{{JSON.stringify(this.link)}}\"                         data-prevent                         {{/if}}>                            <div class=\"formula\" data-fit-box>                                <span data-formula=\"literal\" class=\"problem--formula-action__per\">/</span>                                {{#compute this.formula.action /}}                            </div>                        </div>                    {{/if}}            </div>            {{#if this.exception}}            <div class=\"problem--formula-right{{#if this.fullymarked}} problem--formula-hide-on-open{{/if}}{{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}}\" data-formula>                <div class=\"problem--formula-arrow{{#if !(this.formula && this.formula.action)}} problem--formula-arrow-no-action{{/if}}\" data-formula>                    {{>icon \"arrow-right\"}}                </div>                <div class=\"formula\" data-formula>{{#compute this.exception /}}</div>            </div>            {{#elseif !this.multiple_show && this.formula && this.formula.to}}            <div class=\"problem--formula-right {{#if this.fullymarked}} problem--formula-hide-on-open{{/if}}{{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}}\" data-formula>                <div class=\"problem--formula-arrow{{#if !this.formula.action}} problem--formula-arrow-no-action{{/if}}\"                     data-formula>                    {{>icon \"arrow-right\"}}                </div>                <div class=\"formula\" data-formula>{{#compute this.formula.to /}}</div>            </div>            {{/if}}            {{#if this.mainRow}}            <span class=\"problem--row-arrow-flag\">                <i class=\"icon-wrapper\">{{>icon \"arrow-small-down\"}}</i>            </span><span class=\"problem--row-arrow-flag problem--row-arrow-flag--close\" data-main-row-close>                <i class=\"icon-wrapper\">{{>icon \"arrow-small-down\"}}</i>            </span>            {{/if}}        </div>        {{/if}}        {{#if this.primefactory}}        <div class=\"prime-table\">            <div class=\"prime-table__left\">                {{#each this.primefactory}}                <div class=\"prime-table__cell\">{{this.left || '&nbsp;'}}</div>                {{/each}}            </div>            <div class=\"prime-table__right\">                {{#each this.primefactory}}                <div class=\"prime-table__cell\">{{this.right || '&nbsp;'}}</div>                {{/each}}            </div>        </div>        {{/if}}        {{#if this.animation}}            <div data-operation='{{JSON.stringify(this.animation)}}'></div>        {{/if}}    </div>{{#if this.child}}{{#if !this.multiple_show}}<div class=\"problem--child\"    {{#if this.link && this.link.method}}     data-blank-href='{{#getLink this.link.method.value /}}' data-prevent     {{/if}}>    <span class=\"problem--title problem--title--primary\"        {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}>        {{#if this.message && this.message.method}}        <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\">            {{#compute this.message.method /}}        </span>        {{/if}}    </span>    {{#if this.extended_pictogram}}        <div class=\"problem--title problem--title--secondary\"            {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}>            <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\">                {{#compute this.extended_pictogram.message/}}            </span>        </div>    {{/if}}</div>{{/if}}{{#if !(this.mainRow && this.multiple_show) && !this.singlewhenclosed}}<div class=\"problem--toggler-button--wrapper\" {{#if this.fullymarked}}data-not-shown{{/if}}>    <span class=\"button button--small button--iconed problem--toggler-button\"        {{#if this.extended_pictogram}}data-open-primary-child{{/if}}>        <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>        <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>        <span>More info</span>    </span>    {{#if this.extended_pictogram && this.extended_pictogram.pictogram}}    <span class=\"button button--small button--iconed button--purple problem--toggler-button\" data-open-secondary-child          data-href=\"/en-US/academy/{{this.extended_pictogram.pictogram.id}}\"          data-academy-index=\"{{this.extended_pictogram.pictogram.index}}\"          data-academy-trigger='[data-academy-content=\"{{this.extended_pictogram.pictogram.id}}/{{this.extended_pictogram.pictogram.index}}\"]'>        <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>        <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>        <span>More info</span>    </span>    {{/if}}</div>{{/if}}<div class=\"problem--child{{#if this.child && this.child.length === 1}} problem--child--single{{/if}}{{#if this.extended_pictogram}} problem--primary-child{{/if}}    problem--child-no-gutter problem--child-hide\"     data-problem-gate data-problem-child data-problem-accordion>    {{#each this.child}}{{#problemRow [this, {}] /}}{{/each}}</div>{{/if}}{{#if this.extended_pictogram}}<div class=\"problem--child problem--secondary-child\" data-problem-gate data-secondary-child data-problem-accordion>\t{{>problemAcademy this.extended_pictogram}}</div>{{/if}}{{#if this.link && this.link.pictogram}}    {{#if !this.multiple_show}}    <div class=\"problem--child\" {{#if this.link.method}} data-open-overlay=\"soon-{{this.link.row.type}}\" data-prevent{{/if}}>        <span class=\"problem--title\" style=\"margin-bottom: -20px;display: block;            {{#if this.link.pictogram && this.link.pictogram.embed}}margin-top:8px;{{/if}}\"            {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}>            {{#if this.message.method}}            <span class=\"problem--formula-wrapper\">                {{#compute this.message.method /}}            </span>            {{/if}}        </span>    </div>    {{/if}}    {{#if this.link.pictogram.embed}}        {{>problemAcademy this.link}}    {{#elseif !(this.mainRow && this.multiple_show) || !this.singlewhenclosed}}    <div class=\"problem--toggler-button--wrapper\"         data-href=\"/en-US/academy/{{this.link.pictogram.id}}\" data-academy-overlay-trigger>        <span class=\"button button--small button--purple button--iconed problem--toggler-button\">            <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>            <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>            <span>More info</span>        </span>        {{#if !(this.mainRow && (this.fullymarked || this.multiple_show))}}            <span class=\"problem--row__close\">                {{>icon \"symbol-x\"}}            </span>        {{/if}}    </div>    {{/if}}{{/if}}{{#if this.link && this.link.sf && !(this.mainRow && this.multiple_show)}}{{!JSON.stringify(this.link)}}<div class=\"problem--toggler-button--wrapper\">    <span class=\"button button--small button--iconed problem--toggler-button\" data-open-overlay=\"soon-SF\">        <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i>        <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i>        <span>More info</span>    </span></div>{{/if}}</div></div></div>","problem/tree":"{{!JSON.stringify(this)}}{{#if this.tree}}{{#each this.tree}}{{#if this.header}}<div class=\"problem--text\">{{#compute this.header /}}</div>{{/if}}<div class=\"problem__leaf\" data-formulas-root data-main-problem-section>    {{#each this.result}}{{#problemRow [this, {mainRow:true}] /}}{{/each}}    {{#if this.tree}}{{>tree this}}{{/if}}</div>{{/each}}{{#else}}{{#each this.group}}    {{#if this.title}}        {{! JSON.stringify(this)}}        {{#if this.command}}        <div class=\"problem--text\" data-blank-href=\"{{#getLink this.command /}}\">{{#compute this.title /}}</div>        {{#else}}        <div class=\"problem--text\">{{#compute this.title /}}</div>        {{/if}}    {{/if}}    {{#if this.showbrakets}}        <div class=\"problem--brakets\">            <div class=\"problem--braket-top\"></div>            <div class=\"problem--braket-bottom\"></div>            {{#each this.child}}                <div class=\"problem--row problem--group-row\">                    <span class=\"problem--prefix\">{{#if this.prefix}}{{#compute this.prefix/}}{{/if}}</span>                    <div class=\"problem--prefixed-formula\">{{#compute this.formula/}}</div>                </div>            {{/each}}        </div>    {{#else}}        {{#each this.tree}}            {{#if this.prefix && this.prefix.indexOf(\"\\'I.\\'\") === -1 && this.prefix.indexOf(\"\\'II.\\'\") === -1}}            <strong class=\"problem--text problem--prefix\" style=\"padding: .2rem; margin: 1em 3em 1.5em\">{{#compute this.prefix /}}</strong>            {{/if}}            {{#if this.header}}                <strong class=\"problem--text\">{{#compute this.header /}}</strong>            {{/if}}            <div class=\"problem__leaf\" data-formulas-root data-main-problem-section>                {{#each this.result}}{{#problemRow [this, {mainRow:true}] /}}{{/each}}                {{#if this.tree}}{{>tree this}}{{/if}}            </div>        {{/each}}    {{/if}}{{/each}}{{/if}}<div data-cosmetic-formulas>    {{#if this.extension}}    <div class=\"problem--text\" data-blank-href=\"{{#getLink this.extension.command /}}\">        <span>{{#compute this.extension.message /}}</span>    </div>    {{/if}}    {{#if this.final_message}}    <div class=\"problem--text\">        <span>{{#compute this.final_message /}}</span>    </div>    {{/if}}    {{#if this.solutions}}        {{#if this.solutions.dropdoubles}}        <div class=\"problem--text\">            <span>{{#compute this.solutions.dropdoubles /}}</span>        </div>        {{/if}}        {{#if this.solutions.fakes}}            <strong class=\"problem--text\">{{#compute this.solutions.fakes.message /}}</strong>            {{#each this.solutions.fakes.checks}}            <span class=\"standalone-formula\">{{#compute this.solution /}}</span>            {{#if this.message}}            <div {{#if this.formula}} data-blank-href=\"/en-US/problem/direct/{{#base64 this.formula /}}/?source=solution-fake&cmd={{this.cmd}}\"{{/if}}                class=\"problem--text\"            >                <span>{{#compute this.message /}}</span>            </div>            {{/if}}            {{/each}}        {{/if}}        {{#if this.solutions.valids}}            <strong class=\"problem--text\">{{#compute this.solutions.valids.message /}}</strong>            {{#each this.solutions.valids.checks}}                {{#if this.solution}}                <span class=\"standalone-formula\">{{#compute this.solution /}}</span>                {{/if}}                {{#if this.message}}                <div {{#if this.formula}} data-blank-href=\"/en-US/problem/direct/{{#base64 this.formula /}}/?source=solution-fake&cmd={{this.cmd}}\"{{/if}} class=\"problem--text\">                    <span>{{#compute this.message /}}</span>                </div>                {{/if}}            {{/each}}        {{/if}}    {{/if}}</div>","users-list":"{{#if Object.keys(this).length > 0}}    {{#each this}}        {{#if meta.key === 'group-director' && this.length > 0}}            <strong>Group leader(s)</strong>            <div class=\"user-list\">            {{#each this}}                {{#if this._id}}                <div class=\"user-list__item\">                    <a class=\"user-list__name\" href=\"/en-US/user/{{this._id}}\">{{this.name}}</a>                    <div class=\"user-list__actions\">                        <a class=\"button button--iconed button--small button--gray\" data-user-action=\"remove-owner-role:{{this._id}}\">                            {{>icon \"symbol-x\"}}                        </a>                    </div>                </div>                {{/if}}            {{/each}}            </div>        {{#elseif meta.key === 'group-member' && this.length > 0}}            <strong>Group members</strong>            <div class=\"user-list\">                {{#each this}}                {{#if this._id}}                <div class=\"user-list__item\">                    <span style=\"vertical-align:middle\">{{parseInt(meta.index, 10) > 99 ? (parseInt(meta.index, 10) + 1) : ('0' + (parseInt(meta.index, 10) + 1)).substr(-2,2)}}</span>                    <a class=\"user-list__name\" style=\"vertical-align:middle;margin-left:10px;padding-top:0\" href=\"?filterUser={{this._id}}\">{{this.name}}{{#if this.email}}<br>{{this.email}}{{/if}}</a>                    <div class=\"user-list__actions\">                        <a class=\"button button--small button--gray\" data-user-action=\"add-owner-role:{{this._id}}\">Mark as group leader</a>                        <a class=\"button button--iconed button--small button--gray\" data-user-edit=\"{{this._id}}::{{this.email}}::{{this.name}}\">{{>icon \"symbol-pen\"}}</a>                        <a class=\"button button--iconed button--small button--gray\" data-user-action=\"remove-user:{{this._id}}\">                            {{>icon \"symbol-x\"}}                        </a>                    </div>                </div>                {{/if}}                {{/each}}            </div>        {{#elseif meta.key === 'unapproved-group-member' && this.length > 0}}            <strong>Join requests</strong>            <div class=\"user-list\">                {{#each this}}                {{#if this._id}}                <div class=\"user-list__item\">                    <a class=\"user-list__name\" href=\"/en-US/user/{{this._id}}\">{{this.name}}</a>                    <div class=\"user-list__actions\" data-group-join-approve-action>                        <a class=\"button button--iconed button--small\" data-user-action=\"approve-user:{{this._id}}\">                            {{>icon \"symbol-pipe\"}}                        </a>                        <a class=\"button button--iconed button--small button--gray\" data-user-action=\"un-approve-user:{{this._id}}\">                            {{>icon \"symbol-x\"}}                        </a>                    </div>                </div>                {{/if}}                {{/each}}            </div>        {{#elseif meta.key === 'liker' && this.length > 0}}            <strong>Liked by</strong>            <div class=\"user-list\">                {{#each this}}                {{#if this._id}}                <div class=\"user-list__item\">                    <a class=\"user-list__name\" href=\"/en-US/user/{{this._id}}\">{{this.name}}</a>                </div>                {{/if}}                {{/each}}            </div>        {{/if}}    {{/each}}{{#else}}<strong style=\"margin-bottom: 30px;\">No such user.</strong>{{/if}}","youtube-video":"<div style=\"background-color:#fff;padding-bottom: calc(315 / 560 * 100%);position:absolute;width: 100%;top: 50%;transform: translateY(-50%);\"><iframe src=\"https://www.youtube.com/embed/{{this.id}}?autoplay=1&theme=light&showinfo=0&rel=0&hd=1&controls=1&autohide=1&modestbranding=1&cc_load_policy=1&cc_lang_pref={{this.language.split('-')[0]}}\"       style=\"position:absolute;width: 100%; height: 100%;left:0;top:0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>"};